!function(e) {
  if ("object" == typeof exports && "undefined" != typeof module) module.exports = e();
  else if ("function" == typeof define && define.amd) define([], e);
  else {
    ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).Uppy = e();
  }
}(function() {
  var e, t, n, r = function(e2) {
    var t2;
    return function(n2) {
      return t2 || e2(t2 = { exports: {}, parent: n2 }, t2.exports), t2.exports;
    };
  }, o = r(function(e2, t2) {
    var n2 = vp("socket.io-client");
    e2.exports = t2 = o2;
    var r2 = t2.managers = {};
    function o2(e3, t3) {
      "object" == typeof e3 && (t3 = e3, e3 = void 0), t3 = t3 || {};
      var o3, i2 = yp(e3), a2 = i2.source, s2 = i2.id, l2 = i2.path, u2 = r2[s2] && l2 in r2[s2].nsps;
      return t3.forceNew || t3["force new connection"] || false === t3.multiplex || u2 ? (n2("ignoring socket cache for %s", a2), o3 = ph(a2, t3)) : (r2[s2] || (n2("new io instance for %s", a2), r2[s2] = ph(a2, t3)), o3 = r2[s2]), i2.query && !t3.query && (t3.query = i2.query), o3.socket(i2.path, t3);
    }
    t2.protocol = Op.protocol, t2.connect = o2, t2.Manager = ph, t2.Socket = oh;
  }), i = r(function(e2, t2) {
  }), a = r(function(e2, t2) {
    (function(e3) {
      (function() {
        "use strict";
        t2.Buffer = n2, t2.INSPECT_MAX_BYTES = 50;
        function e4(e5) {
          if (e5 > 2147483647) throw new RangeError('The value "' + e5 + '" is invalid for option "size"');
          var t3 = new Uint8Array(e5);
          return t3.__proto__ = n2.prototype, t3;
        }
        function n2(e5, t3, n3) {
          if ("number" == typeof e5) {
            if ("string" == typeof t3) throw new TypeError('The "string" argument must be of type string. Received type number');
            return i2(e5);
          }
          return r2(e5, t3, n3);
        }
        function r2(t3, r3, o3) {
          if ("string" == typeof t3) return function(t4, r4) {
            if ("string" == typeof r4 && "" !== r4 || (r4 = "utf8"), !n2.isEncoding(r4)) throw new TypeError("Unknown encoding: " + r4);
            var o4 = 0 | l2(t4, r4), i4 = e4(o4), a3 = i4.write(t4, r4);
            return a3 !== o4 && (i4 = i4.slice(0, a3)), i4;
          }(t3, r3);
          if (ArrayBuffer.isView(t3)) return a2(t3);
          if (null == t3) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t3);
          if (F2(t3, ArrayBuffer) || t3 && F2(t3.buffer, ArrayBuffer)) return function(e5, t4, r4) {
            if (t4 < 0 || e5.byteLength < t4) throw new RangeError('"offset" is outside of buffer bounds');
            if (e5.byteLength < t4 + (r4 || 0)) throw new RangeError('"length" is outside of buffer bounds');
            var o4;
            return (o4 = void 0 === t4 && void 0 === r4 ? new Uint8Array(e5) : void 0 === r4 ? new Uint8Array(e5, t4) : new Uint8Array(e5, t4, r4)).__proto__ = n2.prototype, o4;
          }(t3, r3, o3);
          if ("number" == typeof t3) throw new TypeError('The "value" argument must not be of type number. Received type number');
          var i3 = t3.valueOf && t3.valueOf();
          if (null != i3 && i3 !== t3) return n2.from(i3, r3, o3);
          var u3 = function(t4) {
            if (n2.isBuffer(t4)) {
              var r4 = 0 | s2(t4.length), o4 = e4(r4);
              return 0 === o4.length || t4.copy(o4, 0, 0, r4), o4;
            }
            return void 0 !== t4.length ? "number" != typeof t4.length || D2(t4.length) ? e4(0) : a2(t4) : "Buffer" === t4.type && Array.isArray(t4.data) ? a2(t4.data) : void 0;
          }(t3);
          if (u3) return u3;
          if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof t3[Symbol.toPrimitive]) return n2.from(t3[Symbol.toPrimitive]("string"), r3, o3);
          throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t3);
        }
        function o2(e5) {
          if ("number" != typeof e5) throw new TypeError('"size" argument must be of type number');
          if (e5 < 0) throw new RangeError('The value "' + e5 + '" is invalid for option "size"');
        }
        function i2(t3) {
          return o2(t3), e4(t3 < 0 ? 0 : 0 | s2(t3));
        }
        function a2(t3) {
          for (var n3 = t3.length < 0 ? 0 : 0 | s2(t3.length), r3 = e4(n3), o3 = 0; o3 < n3; o3 += 1) r3[o3] = 255 & t3[o3];
          return r3;
        }
        function s2(e5) {
          if (e5 >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647 .toString(16) + " bytes");
          return 0 | e5;
        }
        function l2(e5, t3) {
          if (n2.isBuffer(e5)) return e5.length;
          if (ArrayBuffer.isView(e5) || F2(e5, ArrayBuffer)) return e5.byteLength;
          if ("string" != typeof e5) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e5);
          var r3 = e5.length, o3 = arguments.length > 2 && true === arguments[2];
          if (!o3 && 0 === r3) return 0;
          for (var i3 = false; ; ) switch (t3) {
            case "ascii":
            case "latin1":
            case "binary":
              return r3;
            case "utf8":
            case "utf-8":
              return N2(e5).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r3;
            case "hex":
              return r3 >>> 1;
            case "base64":
              return T2(e5).length;
            default:
              if (i3) return o3 ? -1 : N2(e5).length;
              t3 = ("" + t3).toLowerCase(), i3 = true;
          }
        }
        function u2(e5, t3, n3) {
          var r3 = e5[t3];
          e5[t3] = e5[n3], e5[n3] = r3;
        }
        function c2(e5, t3, r3, o3, i3) {
          if (0 === e5.length) return -1;
          if ("string" == typeof r3 ? (o3 = r3, r3 = 0) : r3 > 2147483647 ? r3 = 2147483647 : r3 < -2147483648 && (r3 = -2147483648), D2(r3 = +r3) && (r3 = i3 ? 0 : e5.length - 1), r3 < 0 && (r3 = e5.length + r3), r3 >= e5.length) {
            if (i3) return -1;
            r3 = e5.length - 1;
          } else if (r3 < 0) {
            if (!i3) return -1;
            r3 = 0;
          }
          if ("string" == typeof t3 && (t3 = n2.from(t3, o3)), n2.isBuffer(t3)) return 0 === t3.length ? -1 : p2(e5, t3, r3, o3, i3);
          if ("number" == typeof t3) return t3 &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i3 ? Uint8Array.prototype.indexOf.call(e5, t3, r3) : Uint8Array.prototype.lastIndexOf.call(e5, t3, r3) : p2(e5, [t3], r3, o3, i3);
          throw new TypeError("val must be string, number or Buffer");
        }
        function p2(e5, t3, n3, r3, o3) {
          var i3, a3 = 1, s3 = e5.length, l3 = t3.length;
          if (void 0 !== r3 && ("ucs2" === (r3 = String(r3).toLowerCase()) || "ucs-2" === r3 || "utf16le" === r3 || "utf-16le" === r3)) {
            if (e5.length < 2 || t3.length < 2) return -1;
            a3 = 2, s3 /= 2, l3 /= 2, n3 /= 2;
          }
          function u3(e6, t4) {
            return 1 === a3 ? e6[t4] : e6.readUInt16BE(t4 * a3);
          }
          if (o3) {
            var c3 = -1;
            for (i3 = n3; i3 < s3; i3++) if (u3(e5, i3) === u3(t3, -1 === c3 ? 0 : i3 - c3)) {
              if (-1 === c3 && (c3 = i3), i3 - c3 + 1 === l3) return c3 * a3;
            } else -1 !== c3 && (i3 -= i3 - c3), c3 = -1;
          } else for (n3 + l3 > s3 && (n3 = s3 - l3), i3 = n3; i3 >= 0; i3--) {
            for (var p3 = true, d3 = 0; d3 < l3; d3++) if (u3(e5, i3 + d3) !== u3(t3, d3)) {
              p3 = false;
              break;
            }
            if (p3) return i3;
          }
          return -1;
        }
        function d2(e5, t3, n3, r3) {
          n3 = Number(n3) || 0;
          var o3 = e5.length - n3;
          r3 ? (r3 = Number(r3)) > o3 && (r3 = o3) : r3 = o3;
          var i3 = t3.length;
          r3 > i3 / 2 && (r3 = i3 / 2);
          for (var a3 = 0; a3 < r3; ++a3) {
            var s3 = parseInt(t3.substr(2 * a3, 2), 16);
            if (D2(s3)) return a3;
            e5[n3 + a3] = s3;
          }
          return a3;
        }
        function h2(e5, t3, n3, r3) {
          return R2(N2(t3, e5.length - n3), e5, n3, r3);
        }
        function f2(e5, t3, n3, r3) {
          return R2(function(e6) {
            for (var t4 = [], n4 = 0; n4 < e6.length; ++n4) t4.push(255 & e6.charCodeAt(n4));
            return t4;
          }(t3), e5, n3, r3);
        }
        function m2(e5, t3, n3, r3) {
          return f2(e5, t3, n3, r3);
        }
        function v2(e5, t3, n3, r3) {
          return R2(T2(t3), e5, n3, r3);
        }
        function g2(e5, t3, n3, r3) {
          return R2(function(e6, t4) {
            for (var n4, r4, o3, i3 = [], a3 = 0; a3 < e6.length && !((t4 -= 2) < 0); ++a3) r4 = (n4 = e6.charCodeAt(a3)) >> 8, o3 = n4 % 256, i3.push(o3), i3.push(r4);
            return i3;
          }(t3, e5.length - n3), e5, n3, r3);
        }
        function y2(e5, t3, n3) {
          return 0 === t3 && n3 === e5.length ? oo.fromByteArray(e5) : oo.fromByteArray(e5.slice(t3, n3));
        }
        function b2(e5, t3, n3) {
          n3 = Math.min(e5.length, n3);
          for (var r3 = [], o3 = t3; o3 < n3; ) {
            var i3, a3, s3, l3, u3 = e5[o3], c3 = null, p3 = u3 > 239 ? 4 : u3 > 223 ? 3 : u3 > 191 ? 2 : 1;
            if (o3 + p3 <= n3) switch (p3) {
              case 1:
                u3 < 128 && (c3 = u3);
                break;
              case 2:
                128 == (192 & (i3 = e5[o3 + 1])) && (l3 = (31 & u3) << 6 | 63 & i3) > 127 && (c3 = l3);
                break;
              case 3:
                i3 = e5[o3 + 1], a3 = e5[o3 + 2], 128 == (192 & i3) && 128 == (192 & a3) && (l3 = (15 & u3) << 12 | (63 & i3) << 6 | 63 & a3) > 2047 && (l3 < 55296 || l3 > 57343) && (c3 = l3);
                break;
              case 4:
                i3 = e5[o3 + 1], a3 = e5[o3 + 2], s3 = e5[o3 + 3], 128 == (192 & i3) && 128 == (192 & a3) && 128 == (192 & s3) && (l3 = (15 & u3) << 18 | (63 & i3) << 12 | (63 & a3) << 6 | 63 & s3) > 65535 && l3 < 1114112 && (c3 = l3);
            }
            null === c3 ? (c3 = 65533, p3 = 1) : c3 > 65535 && (c3 -= 65536, r3.push(c3 >>> 10 & 1023 | 55296), c3 = 56320 | 1023 & c3), r3.push(c3), o3 += p3;
          }
          return function(e6) {
            var t4 = e6.length;
            if (t4 <= _2) return String.fromCharCode.apply(String, e6);
            for (var n4 = "", r4 = 0; r4 < t4; ) n4 += String.fromCharCode.apply(String, e6.slice(r4, r4 += _2));
            return n4;
          }(r3);
        }
        n2.TYPED_ARRAY_SUPPORT = function() {
          try {
            var e5 = new Uint8Array(1);
            return e5.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
              return 42;
            } }, 42 === e5.foo();
          } catch (t3) {
            return false;
          }
        }(), n2.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(n2.prototype, "parent", { enumerable: true, get: function() {
          if (n2.isBuffer(this)) return this.buffer;
        } }), Object.defineProperty(n2.prototype, "offset", { enumerable: true, get: function() {
          if (n2.isBuffer(this)) return this.byteOffset;
        } }), "undefined" != typeof Symbol && null != Symbol.species && n2[Symbol.species] === n2 && Object.defineProperty(n2, Symbol.species, { value: null, configurable: true, enumerable: false, writable: false }), n2.poolSize = 8192, n2.from = function(e5, t3, n3) {
          return r2(e5, t3, n3);
        }, n2.prototype.__proto__ = Uint8Array.prototype, n2.__proto__ = Uint8Array, n2.alloc = function(t3, n3, r3) {
          return function(t4, n4, r4) {
            return o2(t4), t4 <= 0 ? e4(t4) : void 0 !== n4 ? "string" == typeof r4 ? e4(t4).fill(n4, r4) : e4(t4).fill(n4) : e4(t4);
          }(t3, n3, r3);
        }, n2.allocUnsafe = function(e5) {
          return i2(e5);
        }, n2.allocUnsafeSlow = function(e5) {
          return i2(e5);
        }, n2.isBuffer = function(e5) {
          return null != e5 && true === e5._isBuffer && e5 !== n2.prototype;
        }, n2.compare = function(e5, t3) {
          if (F2(e5, Uint8Array) && (e5 = n2.from(e5, e5.offset, e5.byteLength)), F2(t3, Uint8Array) && (t3 = n2.from(t3, t3.offset, t3.byteLength)), !n2.isBuffer(e5) || !n2.isBuffer(t3)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
          if (e5 === t3) return 0;
          for (var r3 = e5.length, o3 = t3.length, i3 = 0, a3 = Math.min(r3, o3); i3 < a3; ++i3) if (e5[i3] !== t3[i3]) {
            r3 = e5[i3], o3 = t3[i3];
            break;
          }
          return r3 < o3 ? -1 : o3 < r3 ? 1 : 0;
        }, n2.isEncoding = function(e5) {
          switch (String(e5).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return true;
            default:
              return false;
          }
        }, n2.concat = function(e5, t3) {
          if (!Array.isArray(e5)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === e5.length) return n2.alloc(0);
          var r3;
          if (void 0 === t3) for (t3 = 0, r3 = 0; r3 < e5.length; ++r3) t3 += e5[r3].length;
          var o3 = n2.allocUnsafe(t3), i3 = 0;
          for (r3 = 0; r3 < e5.length; ++r3) {
            var a3 = e5[r3];
            if (F2(a3, Uint8Array) && (a3 = n2.from(a3)), !n2.isBuffer(a3)) throw new TypeError('"list" argument must be an Array of Buffers');
            a3.copy(o3, i3), i3 += a3.length;
          }
          return o3;
        }, n2.byteLength = l2, n2.prototype._isBuffer = true, n2.prototype.swap16 = function() {
          var e5 = this.length;
          if (e5 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
          for (var t3 = 0; t3 < e5; t3 += 2) u2(this, t3, t3 + 1);
          return this;
        }, n2.prototype.swap32 = function() {
          var e5 = this.length;
          if (e5 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
          for (var t3 = 0; t3 < e5; t3 += 4) u2(this, t3, t3 + 3), u2(this, t3 + 1, t3 + 2);
          return this;
        }, n2.prototype.swap64 = function() {
          var e5 = this.length;
          if (e5 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
          for (var t3 = 0; t3 < e5; t3 += 8) u2(this, t3, t3 + 7), u2(this, t3 + 1, t3 + 6), u2(this, t3 + 2, t3 + 5), u2(this, t3 + 3, t3 + 4);
          return this;
        }, n2.prototype.toString = function() {
          var e5 = this.length;
          return 0 === e5 ? "" : 0 === arguments.length ? b2(this, 0, e5) : function(e6, t3, n3) {
            var r3 = false;
            if ((void 0 === t3 || t3 < 0) && (t3 = 0), t3 > this.length) return "";
            if ((void 0 === n3 || n3 > this.length) && (n3 = this.length), n3 <= 0) return "";
            if ((n3 >>>= 0) <= (t3 >>>= 0)) return "";
            for (e6 || (e6 = "utf8"); ; ) switch (e6) {
              case "hex":
                return S2(this, t3, n3);
              case "utf8":
              case "utf-8":
                return b2(this, t3, n3);
              case "ascii":
                return w2(this, t3, n3);
              case "latin1":
              case "binary":
                return C2(this, t3, n3);
              case "base64":
                return y2(this, t3, n3);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return k2(this, t3, n3);
              default:
                if (r3) throw new TypeError("Unknown encoding: " + e6);
                e6 = (e6 + "").toLowerCase(), r3 = true;
            }
          }.apply(this, arguments);
        }, n2.prototype.toLocaleString = n2.prototype.toString, n2.prototype.equals = function(e5) {
          if (!n2.isBuffer(e5)) throw new TypeError("Argument must be a Buffer");
          return this === e5 || 0 === n2.compare(this, e5);
        }, n2.prototype.inspect = function() {
          var e5 = "", n3 = t2.INSPECT_MAX_BYTES;
          return e5 = this.toString("hex", 0, n3).replace(/(.{2})/g, "$1 ").trim(), this.length > n3 && (e5 += " ... "), "<Buffer " + e5 + ">";
        }, n2.prototype.compare = function(e5, t3, r3, o3, i3) {
          if (F2(e5, Uint8Array) && (e5 = n2.from(e5, e5.offset, e5.byteLength)), !n2.isBuffer(e5)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e5);
          if (void 0 === t3 && (t3 = 0), void 0 === r3 && (r3 = e5 ? e5.length : 0), void 0 === o3 && (o3 = 0), void 0 === i3 && (i3 = this.length), t3 < 0 || r3 > e5.length || o3 < 0 || i3 > this.length) throw new RangeError("out of range index");
          if (o3 >= i3 && t3 >= r3) return 0;
          if (o3 >= i3) return -1;
          if (t3 >= r3) return 1;
          if (this === e5) return 0;
          for (var a3 = (i3 >>>= 0) - (o3 >>>= 0), s3 = (r3 >>>= 0) - (t3 >>>= 0), l3 = Math.min(a3, s3), u3 = this.slice(o3, i3), c3 = e5.slice(t3, r3), p3 = 0; p3 < l3; ++p3) if (u3[p3] !== c3[p3]) {
            a3 = u3[p3], s3 = c3[p3];
            break;
          }
          return a3 < s3 ? -1 : s3 < a3 ? 1 : 0;
        }, n2.prototype.includes = function(e5, t3, n3) {
          return -1 !== this.indexOf(e5, t3, n3);
        }, n2.prototype.indexOf = function(e5, t3, n3) {
          return c2(this, e5, t3, n3, true);
        }, n2.prototype.lastIndexOf = function(e5, t3, n3) {
          return c2(this, e5, t3, n3, false);
        }, n2.prototype.write = function(e5, t3, n3, r3) {
          if (void 0 === t3) r3 = "utf8", n3 = this.length, t3 = 0;
          else if (void 0 === n3 && "string" == typeof t3) r3 = t3, n3 = this.length, t3 = 0;
          else {
            if (!isFinite(t3)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            t3 >>>= 0, isFinite(n3) ? (n3 >>>= 0, void 0 === r3 && (r3 = "utf8")) : (r3 = n3, n3 = void 0);
          }
          var o3 = this.length - t3;
          if ((void 0 === n3 || n3 > o3) && (n3 = o3), e5.length > 0 && (n3 < 0 || t3 < 0) || t3 > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          r3 || (r3 = "utf8");
          for (var i3 = false; ; ) switch (r3) {
            case "hex":
              return d2(this, e5, t3, n3);
            case "utf8":
            case "utf-8":
              return h2(this, e5, t3, n3);
            case "ascii":
              return f2(this, e5, t3, n3);
            case "latin1":
            case "binary":
              return m2(this, e5, t3, n3);
            case "base64":
              return v2(this, e5, t3, n3);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return g2(this, e5, t3, n3);
            default:
              if (i3) throw new TypeError("Unknown encoding: " + r3);
              r3 = ("" + r3).toLowerCase(), i3 = true;
          }
        }, n2.prototype.toJSON = function() {
          return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
        };
        var _2 = 4096;
        function w2(e5, t3, n3) {
          var r3 = "";
          n3 = Math.min(e5.length, n3);
          for (var o3 = t3; o3 < n3; ++o3) r3 += String.fromCharCode(127 & e5[o3]);
          return r3;
        }
        function C2(e5, t3, n3) {
          var r3 = "";
          n3 = Math.min(e5.length, n3);
          for (var o3 = t3; o3 < n3; ++o3) r3 += String.fromCharCode(e5[o3]);
          return r3;
        }
        function S2(e5, t3, n3) {
          var r3, o3 = e5.length;
          (!t3 || t3 < 0) && (t3 = 0), (!n3 || n3 < 0 || n3 > o3) && (n3 = o3);
          for (var i3 = "", a3 = t3; a3 < n3; ++a3) i3 += (r3 = e5[a3]) < 16 ? "0" + r3.toString(16) : r3.toString(16);
          return i3;
        }
        function k2(e5, t3, n3) {
          for (var r3 = e5.slice(t3, n3), o3 = "", i3 = 0; i3 < r3.length; i3 += 2) o3 += String.fromCharCode(r3[i3] + 256 * r3[i3 + 1]);
          return o3;
        }
        function x2(e5, t3, n3) {
          if (e5 % 1 != 0 || e5 < 0) throw new RangeError("offset is not uint");
          if (e5 + t3 > n3) throw new RangeError("Trying to access beyond buffer length");
        }
        function P2(e5, t3, r3, o3, i3, a3) {
          if (!n2.isBuffer(e5)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (t3 > i3 || t3 < a3) throw new RangeError('"value" argument is out of bounds');
          if (r3 + o3 > e5.length) throw new RangeError("Index out of range");
        }
        function E2(e5, t3, n3, r3, o3, i3) {
          if (n3 + r3 > e5.length) throw new RangeError("Index out of range");
          if (n3 < 0) throw new RangeError("Index out of range");
        }
        function O2(e5, t3, n3, r3, o3) {
          return t3 = +t3, n3 >>>= 0, o3 || E2(e5, 0, n3, 4), fo.write(e5, t3, n3, r3, 23, 4), n3 + 4;
        }
        function A2(e5, t3, n3, r3, o3) {
          return t3 = +t3, n3 >>>= 0, o3 || E2(e5, 0, n3, 8), fo.write(e5, t3, n3, r3, 52, 8), n3 + 8;
        }
        n2.prototype.slice = function(e5, t3) {
          var r3 = this.length;
          (e5 = ~~e5) < 0 ? (e5 += r3) < 0 && (e5 = 0) : e5 > r3 && (e5 = r3), (t3 = void 0 === t3 ? r3 : ~~t3) < 0 ? (t3 += r3) < 0 && (t3 = 0) : t3 > r3 && (t3 = r3), t3 < e5 && (t3 = e5);
          var o3 = this.subarray(e5, t3);
          return o3.__proto__ = n2.prototype, o3;
        }, n2.prototype.readUIntLE = function(e5, t3, n3) {
          e5 >>>= 0, t3 >>>= 0, n3 || x2(e5, t3, this.length);
          for (var r3 = this[e5], o3 = 1, i3 = 0; ++i3 < t3 && (o3 *= 256); ) r3 += this[e5 + i3] * o3;
          return r3;
        }, n2.prototype.readUIntBE = function(e5, t3, n3) {
          e5 >>>= 0, t3 >>>= 0, n3 || x2(e5, t3, this.length);
          for (var r3 = this[e5 + --t3], o3 = 1; t3 > 0 && (o3 *= 256); ) r3 += this[e5 + --t3] * o3;
          return r3;
        }, n2.prototype.readUInt8 = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 1, this.length), this[e5];
        }, n2.prototype.readUInt16LE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 2, this.length), this[e5] | this[e5 + 1] << 8;
        }, n2.prototype.readUInt16BE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 2, this.length), this[e5] << 8 | this[e5 + 1];
        }, n2.prototype.readUInt32LE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 4, this.length), (this[e5] | this[e5 + 1] << 8 | this[e5 + 2] << 16) + 16777216 * this[e5 + 3];
        }, n2.prototype.readUInt32BE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 4, this.length), 16777216 * this[e5] + (this[e5 + 1] << 16 | this[e5 + 2] << 8 | this[e5 + 3]);
        }, n2.prototype.readIntLE = function(e5, t3, n3) {
          e5 >>>= 0, t3 >>>= 0, n3 || x2(e5, t3, this.length);
          for (var r3 = this[e5], o3 = 1, i3 = 0; ++i3 < t3 && (o3 *= 256); ) r3 += this[e5 + i3] * o3;
          return r3 >= (o3 *= 128) && (r3 -= Math.pow(2, 8 * t3)), r3;
        }, n2.prototype.readIntBE = function(e5, t3, n3) {
          e5 >>>= 0, t3 >>>= 0, n3 || x2(e5, t3, this.length);
          for (var r3 = t3, o3 = 1, i3 = this[e5 + --r3]; r3 > 0 && (o3 *= 256); ) i3 += this[e5 + --r3] * o3;
          return i3 >= (o3 *= 128) && (i3 -= Math.pow(2, 8 * t3)), i3;
        }, n2.prototype.readInt8 = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 1, this.length), 128 & this[e5] ? -1 * (255 - this[e5] + 1) : this[e5];
        }, n2.prototype.readInt16LE = function(e5, t3) {
          e5 >>>= 0, t3 || x2(e5, 2, this.length);
          var n3 = this[e5] | this[e5 + 1] << 8;
          return 32768 & n3 ? 4294901760 | n3 : n3;
        }, n2.prototype.readInt16BE = function(e5, t3) {
          e5 >>>= 0, t3 || x2(e5, 2, this.length);
          var n3 = this[e5 + 1] | this[e5] << 8;
          return 32768 & n3 ? 4294901760 | n3 : n3;
        }, n2.prototype.readInt32LE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 4, this.length), this[e5] | this[e5 + 1] << 8 | this[e5 + 2] << 16 | this[e5 + 3] << 24;
        }, n2.prototype.readInt32BE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 4, this.length), this[e5] << 24 | this[e5 + 1] << 16 | this[e5 + 2] << 8 | this[e5 + 3];
        }, n2.prototype.readFloatLE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 4, this.length), fo.read(this, e5, true, 23, 4);
        }, n2.prototype.readFloatBE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 4, this.length), fo.read(this, e5, false, 23, 4);
        }, n2.prototype.readDoubleLE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 8, this.length), fo.read(this, e5, true, 52, 8);
        }, n2.prototype.readDoubleBE = function(e5, t3) {
          return e5 >>>= 0, t3 || x2(e5, 8, this.length), fo.read(this, e5, false, 52, 8);
        }, n2.prototype.writeUIntLE = function(e5, t3, n3, r3) {
          e5 = +e5, t3 >>>= 0, n3 >>>= 0, r3 || P2(this, e5, t3, n3, Math.pow(2, 8 * n3) - 1, 0);
          var o3 = 1, i3 = 0;
          for (this[t3] = 255 & e5; ++i3 < n3 && (o3 *= 256); ) this[t3 + i3] = e5 / o3 & 255;
          return t3 + n3;
        }, n2.prototype.writeUIntBE = function(e5, t3, n3, r3) {
          e5 = +e5, t3 >>>= 0, n3 >>>= 0, r3 || P2(this, e5, t3, n3, Math.pow(2, 8 * n3) - 1, 0);
          var o3 = n3 - 1, i3 = 1;
          for (this[t3 + o3] = 255 & e5; --o3 >= 0 && (i3 *= 256); ) this[t3 + o3] = e5 / i3 & 255;
          return t3 + n3;
        }, n2.prototype.writeUInt8 = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 1, 255, 0), this[t3] = 255 & e5, t3 + 1;
        }, n2.prototype.writeUInt16LE = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 2, 65535, 0), this[t3] = 255 & e5, this[t3 + 1] = e5 >>> 8, t3 + 2;
        }, n2.prototype.writeUInt16BE = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 2, 65535, 0), this[t3] = e5 >>> 8, this[t3 + 1] = 255 & e5, t3 + 2;
        }, n2.prototype.writeUInt32LE = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 4, 4294967295, 0), this[t3 + 3] = e5 >>> 24, this[t3 + 2] = e5 >>> 16, this[t3 + 1] = e5 >>> 8, this[t3] = 255 & e5, t3 + 4;
        }, n2.prototype.writeUInt32BE = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 4, 4294967295, 0), this[t3] = e5 >>> 24, this[t3 + 1] = e5 >>> 16, this[t3 + 2] = e5 >>> 8, this[t3 + 3] = 255 & e5, t3 + 4;
        }, n2.prototype.writeIntLE = function(e5, t3, n3, r3) {
          if (e5 = +e5, t3 >>>= 0, !r3) {
            var o3 = Math.pow(2, 8 * n3 - 1);
            P2(this, e5, t3, n3, o3 - 1, -o3);
          }
          var i3 = 0, a3 = 1, s3 = 0;
          for (this[t3] = 255 & e5; ++i3 < n3 && (a3 *= 256); ) e5 < 0 && 0 === s3 && 0 !== this[t3 + i3 - 1] && (s3 = 1), this[t3 + i3] = (e5 / a3 >> 0) - s3 & 255;
          return t3 + n3;
        }, n2.prototype.writeIntBE = function(e5, t3, n3, r3) {
          if (e5 = +e5, t3 >>>= 0, !r3) {
            var o3 = Math.pow(2, 8 * n3 - 1);
            P2(this, e5, t3, n3, o3 - 1, -o3);
          }
          var i3 = n3 - 1, a3 = 1, s3 = 0;
          for (this[t3 + i3] = 255 & e5; --i3 >= 0 && (a3 *= 256); ) e5 < 0 && 0 === s3 && 0 !== this[t3 + i3 + 1] && (s3 = 1), this[t3 + i3] = (e5 / a3 >> 0) - s3 & 255;
          return t3 + n3;
        }, n2.prototype.writeInt8 = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 1, 127, -128), e5 < 0 && (e5 = 255 + e5 + 1), this[t3] = 255 & e5, t3 + 1;
        }, n2.prototype.writeInt16LE = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 2, 32767, -32768), this[t3] = 255 & e5, this[t3 + 1] = e5 >>> 8, t3 + 2;
        }, n2.prototype.writeInt16BE = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 2, 32767, -32768), this[t3] = e5 >>> 8, this[t3 + 1] = 255 & e5, t3 + 2;
        }, n2.prototype.writeInt32LE = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 4, 2147483647, -2147483648), this[t3] = 255 & e5, this[t3 + 1] = e5 >>> 8, this[t3 + 2] = e5 >>> 16, this[t3 + 3] = e5 >>> 24, t3 + 4;
        }, n2.prototype.writeInt32BE = function(e5, t3, n3) {
          return e5 = +e5, t3 >>>= 0, n3 || P2(this, e5, t3, 4, 2147483647, -2147483648), e5 < 0 && (e5 = 4294967295 + e5 + 1), this[t3] = e5 >>> 24, this[t3 + 1] = e5 >>> 16, this[t3 + 2] = e5 >>> 8, this[t3 + 3] = 255 & e5, t3 + 4;
        }, n2.prototype.writeFloatLE = function(e5, t3, n3) {
          return O2(this, e5, t3, true, n3);
        }, n2.prototype.writeFloatBE = function(e5, t3, n3) {
          return O2(this, e5, t3, false, n3);
        }, n2.prototype.writeDoubleLE = function(e5, t3, n3) {
          return A2(this, e5, t3, true, n3);
        }, n2.prototype.writeDoubleBE = function(e5, t3, n3) {
          return A2(this, e5, t3, false, n3);
        }, n2.prototype.copy = function(e5, t3, r3, o3) {
          if (!n2.isBuffer(e5)) throw new TypeError("argument should be a Buffer");
          if (r3 || (r3 = 0), o3 || 0 === o3 || (o3 = this.length), t3 >= e5.length && (t3 = e5.length), t3 || (t3 = 0), o3 > 0 && o3 < r3 && (o3 = r3), o3 === r3) return 0;
          if (0 === e5.length || 0 === this.length) return 0;
          if (t3 < 0) throw new RangeError("targetStart out of bounds");
          if (r3 < 0 || r3 >= this.length) throw new RangeError("Index out of range");
          if (o3 < 0) throw new RangeError("sourceEnd out of bounds");
          o3 > this.length && (o3 = this.length), e5.length - t3 < o3 - r3 && (o3 = e5.length - t3 + r3);
          var i3 = o3 - r3;
          if (this === e5 && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t3, r3, o3);
          else if (this === e5 && r3 < t3 && t3 < o3) for (var a3 = i3 - 1; a3 >= 0; --a3) e5[a3 + t3] = this[a3 + r3];
          else Uint8Array.prototype.set.call(e5, this.subarray(r3, o3), t3);
          return i3;
        }, n2.prototype.fill = function(e5, t3, r3, o3) {
          if ("string" == typeof e5) {
            if ("string" == typeof t3 ? (o3 = t3, t3 = 0, r3 = this.length) : "string" == typeof r3 && (o3 = r3, r3 = this.length), void 0 !== o3 && "string" != typeof o3) throw new TypeError("encoding must be a string");
            if ("string" == typeof o3 && !n2.isEncoding(o3)) throw new TypeError("Unknown encoding: " + o3);
            if (1 === e5.length) {
              var i3 = e5.charCodeAt(0);
              ("utf8" === o3 && i3 < 128 || "latin1" === o3) && (e5 = i3);
            }
          } else "number" == typeof e5 && (e5 &= 255);
          if (t3 < 0 || this.length < t3 || this.length < r3) throw new RangeError("Out of range index");
          if (r3 <= t3) return this;
          var a3;
          if (t3 >>>= 0, r3 = void 0 === r3 ? this.length : r3 >>> 0, e5 || (e5 = 0), "number" == typeof e5) for (a3 = t3; a3 < r3; ++a3) this[a3] = e5;
          else {
            var s3 = n2.isBuffer(e5) ? e5 : n2.from(e5, o3), l3 = s3.length;
            if (0 === l3) throw new TypeError('The value "' + e5 + '" is invalid for argument "value"');
            for (a3 = 0; a3 < r3 - t3; ++a3) this[a3 + t3] = s3[a3 % l3];
          }
          return this;
        };
        var U2 = /[^+/0-9A-Za-z-_]/g;
        function N2(e5, t3) {
          var n3;
          t3 = t3 || 1 / 0;
          for (var r3 = e5.length, o3 = null, i3 = [], a3 = 0; a3 < r3; ++a3) {
            if ((n3 = e5.charCodeAt(a3)) > 55295 && n3 < 57344) {
              if (!o3) {
                if (n3 > 56319) {
                  (t3 -= 3) > -1 && i3.push(239, 191, 189);
                  continue;
                }
                if (a3 + 1 === r3) {
                  (t3 -= 3) > -1 && i3.push(239, 191, 189);
                  continue;
                }
                o3 = n3;
                continue;
              }
              if (n3 < 56320) {
                (t3 -= 3) > -1 && i3.push(239, 191, 189), o3 = n3;
                continue;
              }
              n3 = 65536 + (o3 - 55296 << 10 | n3 - 56320);
            } else o3 && (t3 -= 3) > -1 && i3.push(239, 191, 189);
            if (o3 = null, n3 < 128) {
              if ((t3 -= 1) < 0) break;
              i3.push(n3);
            } else if (n3 < 2048) {
              if ((t3 -= 2) < 0) break;
              i3.push(n3 >> 6 | 192, 63 & n3 | 128);
            } else if (n3 < 65536) {
              if ((t3 -= 3) < 0) break;
              i3.push(n3 >> 12 | 224, n3 >> 6 & 63 | 128, 63 & n3 | 128);
            } else {
              if (!(n3 < 1114112)) throw new Error("Invalid code point");
              if ((t3 -= 4) < 0) break;
              i3.push(n3 >> 18 | 240, n3 >> 12 & 63 | 128, n3 >> 6 & 63 | 128, 63 & n3 | 128);
            }
          }
          return i3;
        }
        function T2(e5) {
          return oo.toByteArray(function(e6) {
            if ((e6 = (e6 = e6.split("=")[0]).trim().replace(U2, "")).length < 2) return "";
            for (; e6.length % 4 != 0; ) e6 += "=";
            return e6;
          }(e5));
        }
        function R2(e5, t3, n3, r3) {
          for (var o3 = 0; o3 < r3 && !(o3 + n3 >= t3.length || o3 >= e5.length); ++o3) t3[o3 + n3] = e5[o3];
          return o3;
        }
        function F2(e5, t3) {
          return e5 instanceof t3 || null != e5 && null != e5.constructor && null != e5.constructor.name && e5.constructor.name === t3.name;
        }
        function D2(e5) {
          return e5 != e5;
        }
      }).call(this);
    }).call(this, a({}).Buffer);
  }), s = e = {};
  function l() {
    throw new Error("setTimeout has not been defined");
  }
  function u() {
    throw new Error("clearTimeout has not been defined");
  }
  function c(e2) {
    if (t === setTimeout) return setTimeout(e2, 0);
    if ((t === l || !t) && setTimeout) return t = setTimeout, setTimeout(e2, 0);
    try {
      return t(e2, 0);
    } catch (n2) {
      try {
        return t.call(null, e2, 0);
      } catch (n3) {
        return t.call(this, e2, 0);
      }
    }
  }
  !function() {
    try {
      t = "function" == typeof setTimeout ? setTimeout : l;
    } catch (e2) {
      t = l;
    }
    try {
      n = "function" == typeof clearTimeout ? clearTimeout : u;
    } catch (e2) {
      n = u;
    }
  }();
  var p, d = [], h = false, f = -1;
  function m() {
    h && p && (h = false, p.length ? d = p.concat(d) : f = -1, d.length && v());
  }
  function v() {
    if (!h) {
      var e2 = c(m);
      h = true;
      for (var t2 = d.length; t2; ) {
        for (p = d, d = []; ++f < t2; ) p && p[f].run();
        f = -1, t2 = d.length;
      }
      p = null, h = false, function(e3) {
        if (n === clearTimeout) return clearTimeout(e3);
        if ((n === u || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e3);
        try {
          n(e3);
        } catch (t3) {
          try {
            return n.call(null, e3);
          } catch (t4) {
            return n.call(this, e3);
          }
        }
      }(e2);
    }
  }
  function g(e2, t2) {
    this.fun = e2, this.array = t2;
  }
  function y() {
  }
  s.nextTick = function(e2) {
    var t2 = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n2 = 1; n2 < arguments.length; n2++) t2[n2 - 1] = arguments[n2];
    d.push(new g(e2, t2)), 1 !== d.length || h || c(v);
  }, g.prototype.run = function() {
    this.fun.apply(null, this.array);
  }, s.title = "browser", s.browser = true, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = y, s.addListener = y, s.once = y, s.off = y, s.removeListener = y, s.removeAllListeners = y, s.emit = y, s.prependListener = y, s.prependOnceListener = y, s.listeners = function(e2) {
    return [];
  }, s.binding = function(e2) {
    throw new Error("process.binding is not supported");
  }, s.cwd = function() {
    return "/";
  }, s.chdir = function(e2) {
    throw new Error("process.chdir is not supported");
  }, s.umask = function() {
    return 0;
  };
  var b = { exports: {} };
  (function(e2, t2) {
    (function() {
      !function(e3, t3) {
        "object" == typeof b.exports ? b.exports = t3() : e3.ES6Promise = t3();
      }(this, function() {
        "use strict";
        function n2(e3) {
          return "function" == typeof e3;
        }
        var r2 = Array.isArray ? Array.isArray : function(e3) {
          return "[object Array]" === Object.prototype.toString.call(e3);
        }, o2 = 0, i2 = void 0, a2 = void 0, s2 = function(e3, t3) {
          f2[o2] = e3, f2[o2 + 1] = t3, 2 === (o2 += 2) && (a2 ? a2(m2) : _2());
        }, l2 = "undefined" != typeof window ? window : void 0, u2 = l2 || {}, c2 = u2.MutationObserver || u2.WebKitMutationObserver, p2 = "undefined" == typeof self && void 0 !== e2 && "[object process]" === {}.toString.call(e2), d2 = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
        function h2() {
          var e3 = setTimeout;
          return function() {
            return e3(m2, 1);
          };
        }
        var f2 = new Array(1e3);
        function m2() {
          for (var e3 = 0; e3 < o2; e3 += 2) (0, f2[e3])(f2[e3 + 1]), f2[e3] = void 0, f2[e3 + 1] = void 0;
          o2 = 0;
        }
        var v2, g2, y2, b2, _2 = void 0;
        function w2(e3, t3) {
          var n3 = this, r3 = new this.constructor(k2);
          void 0 === r3[S2] && F2(r3);
          var o3 = n3._state;
          if (o3) {
            var i3 = arguments[o3 - 1];
            s2(function() {
              return T2(o3, r3, i3, n3._result);
            });
          } else U2(n3, r3, e3, t3);
          return r3;
        }
        function C2(e3) {
          if (e3 && "object" == typeof e3 && e3.constructor === this) return e3;
          var t3 = new this(k2);
          return P2(t3, e3), t3;
        }
        p2 ? _2 = function() {
          return e2.nextTick(m2);
        } : c2 ? (g2 = 0, y2 = new c2(m2), b2 = document.createTextNode(""), y2.observe(b2, { characterData: true }), _2 = function() {
          b2.data = g2 = ++g2 % 2;
        }) : d2 ? ((v2 = new MessageChannel()).port1.onmessage = m2, _2 = function() {
          return v2.port2.postMessage(0);
        }) : _2 = void 0 === l2 ? function() {
          try {
            var e3 = Function("return this")().require("vertx");
            return void 0 !== (i2 = e3.runOnLoop || e3.runOnContext) ? function() {
              i2(m2);
            } : h2();
          } catch (t3) {
            return h2();
          }
        }() : h2();
        var S2 = Math.random().toString(36).substring(2);
        function k2() {
        }
        function x2(e3, t3, r3) {
          t3.constructor === e3.constructor && r3 === w2 && t3.constructor.resolve === C2 ? function(e4, t4) {
            1 === t4._state ? O2(e4, t4._result) : 2 === t4._state ? A2(e4, t4._result) : U2(t4, void 0, function(t5) {
              return P2(e4, t5);
            }, function(t5) {
              return A2(e4, t5);
            });
          }(e3, t3) : void 0 === r3 ? O2(e3, t3) : n2(r3) ? function(e4, t4, n3) {
            s2(function(e5) {
              var r4 = false, o3 = function(n4, o4, i3, a3) {
                try {
                  n4.call(o4, function(n5) {
                    r4 || (r4 = true, t4 !== n5 ? P2(e5, n5) : O2(e5, n5));
                  }, function(t5) {
                    r4 || (r4 = true, A2(e5, t5));
                  });
                } catch (s3) {
                  return s3;
                }
              }(n3, t4, 0, 0, e5._label);
              !r4 && o3 && (r4 = true, A2(e5, o3));
            }, e4);
          }(e3, t3, r3) : O2(e3, t3);
        }
        function P2(e3, t3) {
          if (e3 === t3) A2(e3, new TypeError("You cannot resolve a promise with itself"));
          else if (o3 = typeof (r3 = t3), null === r3 || "object" !== o3 && "function" !== o3) O2(e3, t3);
          else {
            var n3 = void 0;
            try {
              n3 = t3.then;
            } catch (Dp2) {
              return void A2(e3, Dp2);
            }
            x2(e3, t3, n3);
          }
          var r3, o3;
        }
        function E2(e3) {
          e3._onerror && e3._onerror(e3._result), N2(e3);
        }
        function O2(e3, t3) {
          void 0 === e3._state && (e3._result = t3, e3._state = 1, 0 !== e3._subscribers.length && s2(N2, e3));
        }
        function A2(e3, t3) {
          void 0 === e3._state && (e3._state = 2, e3._result = t3, s2(E2, e3));
        }
        function U2(e3, t3, n3, r3) {
          var o3 = e3._subscribers, i3 = o3.length;
          e3._onerror = null, o3[i3] = t3, o3[i3 + 1] = n3, o3[i3 + 2] = r3, 0 === i3 && e3._state && s2(N2, e3);
        }
        function N2(e3) {
          var t3 = e3._subscribers, n3 = e3._state;
          if (0 !== t3.length) {
            for (var r3 = void 0, o3 = void 0, i3 = e3._result, a3 = 0; a3 < t3.length; a3 += 3) r3 = t3[a3], o3 = t3[a3 + n3], r3 ? T2(n3, r3, o3, i3) : o3(i3);
            e3._subscribers.length = 0;
          }
        }
        function T2(e3, t3, r3, o3) {
          var i3 = n2(r3), a3 = void 0, s3 = void 0, l3 = true;
          if (i3) {
            try {
              a3 = r3(o3);
            } catch (u3) {
              l3 = false, s3 = u3;
            }
            if (t3 === a3) return void A2(t3, new TypeError("A promises callback cannot return that same promise."));
          } else a3 = o3;
          void 0 !== t3._state || (i3 && l3 ? P2(t3, a3) : false === l3 ? A2(t3, s3) : 1 === e3 ? O2(t3, a3) : 2 === e3 && A2(t3, a3));
        }
        var R2 = 0;
        function F2(e3) {
          e3[S2] = R2++, e3._state = void 0, e3._result = void 0, e3._subscribers = [];
        }
        var D2 = function() {
          function e3(e4, t3) {
            this._instanceConstructor = e4, this.promise = new e4(k2), this.promise[S2] || F2(this.promise), r2(t3) ? (this.length = t3.length, this._remaining = t3.length, this._result = new Array(this.length), 0 === this.length ? O2(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(t3), 0 === this._remaining && O2(this.promise, this._result))) : A2(this.promise, new Error("Array Methods must be provided an Array"));
          }
          return e3.prototype._enumerate = function(e4) {
            for (var t3 = 0; void 0 === this._state && t3 < e4.length; t3++) this._eachEntry(e4[t3], t3);
          }, e3.prototype._eachEntry = function(e4, t3) {
            var n3 = this._instanceConstructor, r3 = n3.resolve;
            if (r3 === C2) {
              var o3 = void 0, i3 = void 0, a3 = false;
              try {
                o3 = e4.then;
              } catch (l3) {
                a3 = true, i3 = l3;
              }
              if (o3 === w2 && void 0 !== e4._state) this._settledAt(e4._state, t3, e4._result);
              else if ("function" != typeof o3) this._remaining--, this._result[t3] = e4;
              else if (n3 === M2) {
                var s3 = new n3(k2);
                a3 ? A2(s3, i3) : x2(s3, e4, o3), this._willSettleAt(s3, t3);
              } else this._willSettleAt(new n3(function(t4) {
                return t4(e4);
              }), t3);
            } else this._willSettleAt(r3(e4), t3);
          }, e3.prototype._settledAt = function(e4, t3, n3) {
            var r3 = this.promise;
            void 0 === r3._state && (this._remaining--, 2 === e4 ? A2(r3, n3) : this._result[t3] = n3), 0 === this._remaining && O2(r3, this._result);
          }, e3.prototype._willSettleAt = function(e4, t3) {
            var n3 = this;
            U2(e4, void 0, function(e5) {
              return n3._settledAt(1, t3, e5);
            }, function(e5) {
              return n3._settledAt(2, t3, e5);
            });
          }, e3;
        }(), M2 = function() {
          function e3(t3) {
            this[S2] = R2++, this._result = this._state = void 0, this._subscribers = [], k2 !== t3 && ("function" != typeof t3 && function() {
              throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
            }(), this instanceof e3 ? function(e4, t4) {
              try {
                t4(function(t5) {
                  P2(e4, t5);
                }, function(t5) {
                  A2(e4, t5);
                });
              } catch (n3) {
                A2(e4, n3);
              }
            }(this, t3) : function() {
              throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
            }());
          }
          return e3.prototype.catch = function(e4) {
            return this.then(null, e4);
          }, e3.prototype.finally = function(e4) {
            var t3 = this.constructor;
            return n2(e4) ? this.then(function(n3) {
              return t3.resolve(e4()).then(function() {
                return n3;
              });
            }, function(n3) {
              return t3.resolve(e4()).then(function() {
                throw n3;
              });
            }) : this.then(e4, e4);
          }, e3;
        }();
        return M2.prototype.then = w2, M2.all = function(e3) {
          return new D2(this, e3).promise;
        }, M2.race = function(e3) {
          var t3 = this;
          return r2(e3) ? new t3(function(n3, r3) {
            for (var o3 = e3.length, i3 = 0; i3 < o3; i3++) t3.resolve(e3[i3]).then(n3, r3);
          }) : new t3(function(e4, t4) {
            return t4(new TypeError("You must pass an array to race."));
          });
        }, M2.resolve = C2, M2.reject = function(e3) {
          var t3 = new this(k2);
          return A2(t3, e3), t3;
        }, M2._setScheduler = function(e3) {
          a2 = e3;
        }, M2._setAsap = function(e3) {
          s2 = e3;
        }, M2._asap = s2, M2.polyfill = function() {
          var e3 = void 0;
          if (void 0 !== t2) e3 = t2;
          else if ("undefined" != typeof self) e3 = self;
          else try {
            e3 = Function("return this")();
          } catch (o3) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
          }
          var n3 = e3.Promise;
          if (n3) {
            var r3 = null;
            try {
              r3 = Object.prototype.toString.call(n3.resolve());
            } catch (o3) {
            }
            if ("[object Promise]" === r3 && !n3.cast) return;
          }
          e3.Promise = M2;
        }, M2.Promise = M2, M2;
      });
    }).call(this);
  }).call(this, e, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
  (b = b.exports).polyfill();
  var _, w = { exports: {} };
  _ = function(e2) {
    "use strict";
    var t2 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== t2 && t2, n2 = "URLSearchParams" in t2, r2 = "Symbol" in t2 && "iterator" in Symbol, o2 = "FileReader" in t2 && "Blob" in t2 && function() {
      try {
        return new Blob(), true;
      } catch (e3) {
        return false;
      }
    }(), i2 = "FormData" in t2, a2 = "ArrayBuffer" in t2;
    if (a2) var s2 = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"], l2 = ArrayBuffer.isView || function(e3) {
      return e3 && s2.indexOf(Object.prototype.toString.call(e3)) > -1;
    };
    function u2(e3) {
      if ("string" != typeof e3 && (e3 = String(e3)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e3) || "" === e3) throw new TypeError('Invalid character in header field name: "' + e3 + '"');
      return e3.toLowerCase();
    }
    function c2(e3) {
      return "string" != typeof e3 && (e3 = String(e3)), e3;
    }
    function p2(e3) {
      var t3 = { next: function() {
        var t4 = e3.shift();
        return { done: void 0 === t4, value: t4 };
      } };
      return r2 && (t3[Symbol.iterator] = function() {
        return t3;
      }), t3;
    }
    function d2(e3) {
      this.map = {}, e3 instanceof d2 ? e3.forEach(function(e4, t3) {
        this.append(t3, e4);
      }, this) : Array.isArray(e3) ? e3.forEach(function(e4) {
        this.append(e4[0], e4[1]);
      }, this) : e3 && Object.getOwnPropertyNames(e3).forEach(function(t3) {
        this.append(t3, e3[t3]);
      }, this);
    }
    function h2(e3) {
      if (e3.bodyUsed) return Promise.reject(new TypeError("Already read"));
      e3.bodyUsed = true;
    }
    function f2(e3) {
      return new Promise(function(t3, n3) {
        e3.onload = function() {
          t3(e3.result);
        }, e3.onerror = function() {
          n3(e3.error);
        };
      });
    }
    function m2(e3) {
      var t3 = new FileReader(), n3 = f2(t3);
      return t3.readAsArrayBuffer(e3), n3;
    }
    function v2(e3) {
      if (e3.slice) return e3.slice(0);
      var t3 = new Uint8Array(e3.byteLength);
      return t3.set(new Uint8Array(e3)), t3.buffer;
    }
    function g2() {
      return this.bodyUsed = false, this._initBody = function(e3) {
        var t3;
        this.bodyUsed = this.bodyUsed, this._bodyInit = e3, e3 ? "string" == typeof e3 ? this._bodyText = e3 : o2 && Blob.prototype.isPrototypeOf(e3) ? this._bodyBlob = e3 : i2 && FormData.prototype.isPrototypeOf(e3) ? this._bodyFormData = e3 : n2 && URLSearchParams.prototype.isPrototypeOf(e3) ? this._bodyText = e3.toString() : a2 && o2 && (t3 = e3) && DataView.prototype.isPrototypeOf(t3) ? (this._bodyArrayBuffer = v2(e3.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a2 && (ArrayBuffer.prototype.isPrototypeOf(e3) || l2(e3)) ? this._bodyArrayBuffer = v2(e3) : this._bodyText = e3 = Object.prototype.toString.call(e3) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e3 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n2 && URLSearchParams.prototype.isPrototypeOf(e3) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
      }, o2 && (this.blob = function() {
        var e3 = h2(this);
        if (e3) return e3;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        return Promise.resolve(new Blob([this._bodyText]));
      }, this.arrayBuffer = function() {
        return this._bodyArrayBuffer ? h2(this) || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer)) : this.blob().then(m2);
      }), this.text = function() {
        var e3, t3, n3, r3 = h2(this);
        if (r3) return r3;
        if (this._bodyBlob) return e3 = this._bodyBlob, n3 = f2(t3 = new FileReader()), t3.readAsText(e3), n3;
        if (this._bodyArrayBuffer) return Promise.resolve(function(e4) {
          for (var t4 = new Uint8Array(e4), n4 = new Array(t4.length), r4 = 0; r4 < t4.length; r4++) n4[r4] = String.fromCharCode(t4[r4]);
          return n4.join("");
        }(this._bodyArrayBuffer));
        if (this._bodyFormData) throw new Error("could not read FormData body as text");
        return Promise.resolve(this._bodyText);
      }, i2 && (this.formData = function() {
        return this.text().then(_2);
      }), this.json = function() {
        return this.text().then(JSON.parse);
      }, this;
    }
    d2.prototype.append = function(e3, t3) {
      e3 = u2(e3), t3 = c2(t3);
      var n3 = this.map[e3];
      this.map[e3] = n3 ? n3 + ", " + t3 : t3;
    }, d2.prototype.delete = function(e3) {
      delete this.map[u2(e3)];
    }, d2.prototype.get = function(e3) {
      return e3 = u2(e3), this.has(e3) ? this.map[e3] : null;
    }, d2.prototype.has = function(e3) {
      return this.map.hasOwnProperty(u2(e3));
    }, d2.prototype.set = function(e3, t3) {
      this.map[u2(e3)] = c2(t3);
    }, d2.prototype.forEach = function(e3, t3) {
      for (var n3 in this.map) this.map.hasOwnProperty(n3) && e3.call(t3, this.map[n3], n3, this);
    }, d2.prototype.keys = function() {
      var e3 = [];
      return this.forEach(function(t3, n3) {
        e3.push(n3);
      }), p2(e3);
    }, d2.prototype.values = function() {
      var e3 = [];
      return this.forEach(function(t3) {
        e3.push(t3);
      }), p2(e3);
    }, d2.prototype.entries = function() {
      var e3 = [];
      return this.forEach(function(t3, n3) {
        e3.push([n3, t3]);
      }), p2(e3);
    }, r2 && (d2.prototype[Symbol.iterator] = d2.prototype.entries);
    var y2 = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
    function b2(e3, t3) {
      if (!(this instanceof b2)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
      var n3, r3, o3 = (t3 = t3 || {}).body;
      if (e3 instanceof b2) {
        if (e3.bodyUsed) throw new TypeError("Already read");
        this.url = e3.url, this.credentials = e3.credentials, t3.headers || (this.headers = new d2(e3.headers)), this.method = e3.method, this.mode = e3.mode, this.signal = e3.signal, o3 || null == e3._bodyInit || (o3 = e3._bodyInit, e3.bodyUsed = true);
      } else this.url = String(e3);
      if (this.credentials = t3.credentials || this.credentials || "same-origin", !t3.headers && this.headers || (this.headers = new d2(t3.headers)), this.method = (r3 = (n3 = t3.method || this.method || "GET").toUpperCase(), y2.indexOf(r3) > -1 ? r3 : n3), this.mode = t3.mode || this.mode || null, this.signal = t3.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o3) throw new TypeError("Body not allowed for GET or HEAD requests");
      if (this._initBody(o3), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t3.cache && "no-cache" !== t3.cache)) {
        var i3 = /([?&])_=[^&]*/;
        i3.test(this.url) ? this.url = this.url.replace(i3, "$1_=" + (/* @__PURE__ */ new Date()).getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
      }
    }
    function _2(e3) {
      var t3 = new FormData();
      return e3.trim().split("&").forEach(function(e4) {
        if (e4) {
          var n3 = e4.split("="), r3 = n3.shift().replace(/\+/g, " "), o3 = n3.join("=").replace(/\+/g, " ");
          t3.append(decodeURIComponent(r3), decodeURIComponent(o3));
        }
      }), t3;
    }
    function w2(e3, t3) {
      if (!(this instanceof w2)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
      t3 || (t3 = {}), this.type = "default", this.status = void 0 === t3.status ? 200 : t3.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t3.statusText ? "" : "" + t3.statusText, this.headers = new d2(t3.headers), this.url = t3.url || "", this._initBody(e3);
    }
    b2.prototype.clone = function() {
      return new b2(this, { body: this._bodyInit });
    }, g2.call(b2.prototype), g2.call(w2.prototype), w2.prototype.clone = function() {
      return new w2(this._bodyInit, { status: this.status, statusText: this.statusText, headers: new d2(this.headers), url: this.url });
    }, w2.error = function() {
      var e3 = new w2(null, { status: 0, statusText: "" });
      return e3.type = "error", e3;
    };
    var C2 = [301, 302, 303, 307, 308];
    w2.redirect = function(e3, t3) {
      if (-1 === C2.indexOf(t3)) throw new RangeError("Invalid status code");
      return new w2(null, { status: t3, headers: { location: e3 } });
    }, e2.DOMException = t2.DOMException;
    try {
      new e2.DOMException();
    } catch (wd2) {
      e2.DOMException = function(e3, t3) {
        this.message = e3, this.name = t3;
        var n3 = Error(e3);
        this.stack = n3.stack;
      }, e2.DOMException.prototype = Object.create(Error.prototype), e2.DOMException.prototype.constructor = e2.DOMException;
    }
    function S2(n3, r3) {
      return new Promise(function(i3, s3) {
        var l3 = new b2(n3, r3);
        if (l3.signal && l3.signal.aborted) return s3(new e2.DOMException("Aborted", "AbortError"));
        var u3 = new XMLHttpRequest();
        function p3() {
          u3.abort();
        }
        u3.onload = function() {
          var e3, t3, n4 = { status: u3.status, statusText: u3.statusText, headers: (e3 = u3.getAllResponseHeaders() || "", t3 = new d2(), e3.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(e4) {
            return 0 === e4.indexOf("\n") ? e4.substr(1, e4.length) : e4;
          }).forEach(function(e4) {
            var n5 = e4.split(":"), r5 = n5.shift().trim();
            if (r5) {
              var o3 = n5.join(":").trim();
              t3.append(r5, o3);
            }
          }), t3) };
          n4.url = "responseURL" in u3 ? u3.responseURL : n4.headers.get("X-Request-URL");
          var r4 = "response" in u3 ? u3.response : u3.responseText;
          setTimeout(function() {
            i3(new w2(r4, n4));
          }, 0);
        }, u3.onerror = function() {
          setTimeout(function() {
            s3(new TypeError("Network request failed"));
          }, 0);
        }, u3.ontimeout = function() {
          setTimeout(function() {
            s3(new TypeError("Network request failed"));
          }, 0);
        }, u3.onabort = function() {
          setTimeout(function() {
            s3(new e2.DOMException("Aborted", "AbortError"));
          }, 0);
        }, u3.open(l3.method, function(e3) {
          try {
            return "" === e3 && t2.location.href ? t2.location.href : e3;
          } catch (n4) {
            return e3;
          }
        }(l3.url), true), "include" === l3.credentials ? u3.withCredentials = true : "omit" === l3.credentials && (u3.withCredentials = false), "responseType" in u3 && (o2 ? u3.responseType = "blob" : a2 && l3.headers.get("Content-Type") && -1 !== l3.headers.get("Content-Type").indexOf("application/octet-stream") && (u3.responseType = "arraybuffer")), !r3 || "object" != typeof r3.headers || r3.headers instanceof d2 ? l3.headers.forEach(function(e3, t3) {
          u3.setRequestHeader(t3, e3);
        }) : Object.getOwnPropertyNames(r3.headers).forEach(function(e3) {
          u3.setRequestHeader(e3, c2(r3.headers[e3]));
        }), l3.signal && (l3.signal.addEventListener("abort", p3), u3.onreadystatechange = function() {
          4 === u3.readyState && l3.signal.removeEventListener("abort", p3);
        }), u3.send(void 0 === l3._bodyInit ? null : l3._bodyInit);
      });
    }
    S2.polyfill = true, t2.fetch || (t2.fetch = S2, t2.Headers = d2, t2.Request = b2, t2.Response = w2), e2.Headers = d2, e2.Request = b2, e2.Response = w2, e2.fetch = S2, Object.defineProperty(e2, "__esModule", { value: true });
  }, "object" == typeof w.exports ? _(w.exports) : _(this.WHATWGFetch = {}), w = w.exports;
  var C = function(e2, t2) {
    return Object.prototype.hasOwnProperty.call(e2, t2);
  };
  function S() {
    return (S = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var k, x = function() {
    function e2(e3) {
      var t3 = this;
      this.locale = { strings: {}, pluralize: function(e4) {
        return 1 === e4 ? 0 : 1;
      } }, Array.isArray(e3) ? e3.forEach(function(e4) {
        return t3._apply(e4);
      }) : this._apply(e3);
    }
    var t2 = e2.prototype;
    return t2._apply = function(e3) {
      if (e3 && e3.strings) {
        var t3 = this.locale;
        this.locale = S({}, t3, { strings: S({}, t3.strings, e3.strings) }), this.locale.pluralize = e3.pluralize || t3.pluralize;
      }
    }, t2.interpolate = function(e3, t3) {
      var n2 = String.prototype, r2 = n2.split, o2 = n2.replace, i2 = /\$/g, a2 = [e3];
      for (var s2 in t3) if ("_" !== s2 && C(t3, s2)) {
        var l2 = t3[s2];
        "string" == typeof l2 && (l2 = o2.call(t3[s2], i2, "$$$$")), a2 = u2(a2, new RegExp("%\\{" + s2 + "\\}", "g"), l2);
      }
      return a2;
      function u2(e4, t4, n3) {
        var o3 = [];
        return e4.forEach(function(e5) {
          if ("string" != typeof e5) return o3.push(e5);
          r2.call(e5, t4).forEach(function(e6, t5, r3) {
            "" !== e6 && o3.push(e6), t5 < r3.length - 1 && o3.push(n3);
          });
        }), o3;
      }
    }, t2.translate = function(e3, t3) {
      return this.translateArray(e3, t3).join("");
    }, t2.translateArray = function(e3, t3) {
      if (!C(this.locale.strings, e3)) throw new Error("missing string: " + e3);
      var n2 = this.locale.strings[e3];
      if ("object" == typeof n2) {
        if (t3 && void 0 !== t3.smart_count) {
          var r2 = this.locale.pluralize(t3.smart_count);
          return this.interpolate(n2[r2], t3);
        }
        throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
      }
      return this.interpolate(n2, t3);
    }, e2;
  }(), P = function() {
    var e2 = {}, t2 = e2._fns = {};
    return e2.emit = function(e3, n2, r2, o2, i2, a2, s2) {
      var l2 = function(e4) {
        for (var n3 = t2[e4] ? t2[e4] : [], r3 = e4.indexOf(":"), o3 = -1 === r3 ? [e4] : [e4.substring(0, r3), e4.substring(r3 + 1)], i3 = Object.keys(t2), a3 = 0, s3 = i3.length; a3 < s3; a3++) {
          var l3 = i3[a3];
          if ("*" === l3 && (n3 = n3.concat(t2[l3])), 2 === o3.length && o3[0] === l3) {
            n3 = n3.concat(t2[l3]);
            break;
          }
        }
        return n3;
      }(e3);
      l2.length && function(e4, t3, n3) {
        for (var r3 = 0, o3 = t3.length; r3 < o3 && t3[r3]; r3++) t3[r3].event = e4, t3[r3].apply(t3[r3], n3);
      }(e3, l2, [n2, r2, o2, i2, a2, s2]);
    }, e2.on = function(e3, n2) {
      t2[e3] || (t2[e3] = []), t2[e3].push(n2);
    }, e2.once = function(t3, n2) {
      this.on(t3, function r2() {
        n2.apply(this, arguments), e2.off(t3, r2);
      });
    }, e2.off = function(e3, t3) {
      var n2 = [];
      if (e3 && t3) for (var r2 = this._fns[e3], o2 = 0, i2 = r2 ? r2.length : 0; o2 < i2; o2++) r2[o2] !== t3 && n2.push(r2[o2]);
      n2.length ? this._fns[e3] = n2 : delete this._fns[e3];
    }, e2;
  }, E = function(e2, t2) {
    var n2 = "000000000" + e2;
    return n2.substr(n2.length - t2);
  }, O = "object" == typeof window ? window : self, A = Object.keys(O).length, U = E(((navigator.mimeTypes ? navigator.mimeTypes.length : 0) + navigator.userAgent.length).toString(36) + A.toString(36), 4), N = function() {
    return U;
  }, T = "undefined" != typeof window && (window.crypto || window.msCrypto) || "undefined" != typeof self && self.crypto;
  if (T) {
    var R = Math.pow(2, 32) - 1;
    k = function() {
      return Math.abs(T.getRandomValues(new Uint32Array(1))[0] / R);
    };
  } else k = Math.random;
  var F = k, D = {}, M = 0, B = Math.pow(36, 4);
  function I() {
    return E((F() * B << 0).toString(36), 4);
  }
  function L() {
    return M = M < B ? M : 0, ++M - 1;
  }
  function j() {
    return "c" + (/* @__PURE__ */ new Date()).getTime().toString(36) + E(L().toString(36), 4) + N() + (I() + I());
  }
  j.slug = function() {
    var e2 = (/* @__PURE__ */ new Date()).getTime().toString(36), t2 = L().toString(36).slice(-4), n2 = N().slice(0, 1) + N().slice(-1), r2 = I().slice(-2);
    return e2.slice(-2) + t2 + n2 + r2;
  }, j.isCuid = function(e2) {
    return "string" == typeof e2 && !!e2.startsWith("c");
  }, j.isSlug = function(e2) {
    if ("string" != typeof e2) return false;
    var t2 = e2.length;
    return t2 >= 7 && t2 <= 10;
  }, j.fingerprint = N, D = j;
  var z = {};
  (function(e2) {
    (function() {
      var t2 = /^\s+|\s+$/g, n2 = /^[-+]0x[0-9a-f]+$/i, r2 = /^0b[01]+$/i, o2 = /^0o[0-7]+$/i, i2 = parseInt, a2 = "object" == typeof e2 && e2 && e2.Object === Object && e2, s2 = "object" == typeof self && self && self.Object === Object && self, l2 = a2 || s2 || Function("return this")(), u2 = Object.prototype.toString, c2 = Math.max, p2 = Math.min, d2 = function() {
        return l2.Date.now();
      };
      function h2(e3) {
        var t3 = typeof e3;
        return !!e3 && ("object" == t3 || "function" == t3);
      }
      function f2(e3) {
        if ("number" == typeof e3) return e3;
        if (function(e4) {
          return "symbol" == typeof e4 || /* @__PURE__ */ function(e5) {
            return !!e5 && "object" == typeof e5;
          }(e4) && "[object Symbol]" == u2.call(e4);
        }(e3)) return NaN;
        if (h2(e3)) {
          var a3 = "function" == typeof e3.valueOf ? e3.valueOf() : e3;
          e3 = h2(a3) ? a3 + "" : a3;
        }
        if ("string" != typeof e3) return 0 === e3 ? e3 : +e3;
        e3 = e3.replace(t2, "");
        var s3 = r2.test(e3);
        return s3 || o2.test(e3) ? i2(e3.slice(2), s3 ? 2 : 8) : n2.test(e3) ? NaN : +e3;
      }
      z = function(e3, t3, n3) {
        var r3 = true, o3 = true;
        if ("function" != typeof e3) throw new TypeError("Expected a function");
        return h2(n3) && (r3 = "leading" in n3 ? !!n3.leading : r3, o3 = "trailing" in n3 ? !!n3.trailing : o3), function(e4, t4, n4) {
          var r4, o4, i3, a3, s3, l3, u3 = 0, m2 = false, v2 = false, g2 = true;
          if ("function" != typeof e4) throw new TypeError("Expected a function");
          function y2(t5) {
            var n5 = r4, i4 = o4;
            return r4 = o4 = void 0, u3 = t5, a3 = e4.apply(i4, n5);
          }
          function b2(e5) {
            var n5 = e5 - l3;
            return void 0 === l3 || n5 >= t4 || n5 < 0 || v2 && e5 - u3 >= i3;
          }
          function _2() {
            var e5 = d2();
            if (b2(e5)) return w2(e5);
            s3 = setTimeout(_2, function(e6) {
              var n5 = t4 - (e6 - l3);
              return v2 ? p2(n5, i3 - (e6 - u3)) : n5;
            }(e5));
          }
          function w2(e5) {
            return s3 = void 0, g2 && r4 ? y2(e5) : (r4 = o4 = void 0, a3);
          }
          function C2() {
            var e5 = d2(), n5 = b2(e5);
            if (r4 = arguments, o4 = this, l3 = e5, n5) {
              if (void 0 === s3) return function(e6) {
                return u3 = e6, s3 = setTimeout(_2, t4), m2 ? y2(e6) : a3;
              }(l3);
              if (v2) return s3 = setTimeout(_2, t4), y2(l3);
            }
            return void 0 === s3 && (s3 = setTimeout(_2, t4)), a3;
          }
          return t4 = f2(t4) || 0, h2(n4) && (m2 = !!n4.leading, i3 = (v2 = "maxWait" in n4) ? c2(f2(n4.maxWait) || 0, t4) : i3, g2 = "trailing" in n4 ? !!n4.trailing : g2), C2.cancel = function() {
            void 0 !== s3 && clearTimeout(s3), u3 = 0, r4 = l3 = o4 = s3 = void 0;
          }, C2.flush = function() {
            return void 0 === s3 ? a3 : w2(d2());
          }, C2;
        }(e3, t3, { leading: r3, maxWait: t3, trailing: o3 });
      };
    }).call(this);
  }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
  var H, W = function(e2) {
    if ("number" != typeof e2 || isNaN(e2)) throw new TypeError("Expected a number, got " + typeof e2);
    var t2 = e2 < 0, n2 = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    if (t2 && (e2 = -e2), e2 < 1) return (t2 ? "-" : "") + e2 + " B";
    var r2 = Math.min(Math.floor(Math.log(e2) / Math.log(1024)), n2.length - 1);
    e2 = Number(e2 / Math.pow(1024, r2));
    var o2 = n2[r2];
    return e2 >= 10 || e2 % 1 == 0 ? (t2 ? "-" : "") + e2.toFixed(0) + " " + o2 : (t2 ? "-" : "") + e2.toFixed(1) + " " + o2;
  };
  function V(e2, t2) {
    this.text = e2 = e2 || "", this.hasWild = ~e2.indexOf("*"), this.separator = t2, this.parts = e2.split(t2);
  }
  V.prototype.match = function(e2) {
    var t2, n2, r2 = true, o2 = this.parts, i2 = o2.length;
    if ("string" == typeof e2 || e2 instanceof String) if (this.hasWild || this.text == e2) {
      for (n2 = (e2 || "").split(this.separator), t2 = 0; r2 && t2 < i2; t2++) "*" !== o2[t2] && (r2 = t2 < n2.length && o2[t2] === n2[t2]);
      r2 = r2 && n2;
    } else r2 = false;
    else if ("function" == typeof e2.splice) for (r2 = [], t2 = e2.length; t2--; ) this.match(e2[t2]) && (r2[r2.length] = e2[t2]);
    else if ("object" == typeof e2) for (var a2 in r2 = {}, e2) this.match(a2) && (r2[a2] = e2[a2]);
    return r2;
  }, H = function(e2, t2, n2) {
    var r2 = new V(e2, n2 || /[\/\.]/);
    return void 0 !== t2 ? r2.match(t2) : r2;
  };
  var q, X = /[\/\+\.]/;
  function G() {
    return (G = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var Y = function() {
    function e2() {
      this.state = {}, this.callbacks = [];
    }
    var t2 = e2.prototype;
    return t2.getState = function() {
      return this.state;
    }, t2.setState = function(e3) {
      var t3 = G({}, this.state), n2 = G({}, this.state, e3);
      this.state = n2, this._publish(t3, n2, e3);
    }, t2.subscribe = function(e3) {
      var t3 = this;
      return this.callbacks.push(e3), function() {
        t3.callbacks.splice(t3.callbacks.indexOf(e3), 1);
      };
    }, t2._publish = function() {
      for (var e3 = arguments.length, t3 = new Array(e3), n2 = 0; n2 < e3; n2++) t3[n2] = arguments[n2];
      this.callbacks.forEach(function(e4) {
        e4.apply(void 0, t3);
      });
    }, e2;
  }();
  Y.VERSION = "1.2.7", q = function() {
    return new Y();
  };
  var $ = function(e2) {
    var t2 = e2.lastIndexOf(".");
    return -1 === t2 || t2 === e2.length - 1 ? { name: e2, extension: void 0 } : { name: e2.slice(0, t2), extension: e2.slice(t2 + 1) };
  }, K = { md: "text/markdown", markdown: "text/markdown", mp4: "video/mp4", mp3: "audio/mp3", svg: "image/svg+xml", jpg: "image/jpeg", png: "image/png", gif: "image/gif", heic: "image/heic", heif: "image/heif", yaml: "text/yaml", yml: "text/yaml", csv: "text/csv", tsv: "text/tab-separated-values", tab: "text/tab-separated-values", avi: "video/x-msvideo", mks: "video/x-matroska", mkv: "video/x-matroska", mov: "video/quicktime", doc: "application/msword", docm: "application/vnd.ms-word.document.macroenabled.12", docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", dot: "application/msword", dotm: "application/vnd.ms-word.template.macroenabled.12", dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template", xla: "application/vnd.ms-excel", xlam: "application/vnd.ms-excel.addin.macroenabled.12", xlc: "application/vnd.ms-excel", xlf: "application/x-xliff+xml", xlm: "application/vnd.ms-excel", xls: "application/vnd.ms-excel", xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12", xlsm: "application/vnd.ms-excel.sheet.macroenabled.12", xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", xlt: "application/vnd.ms-excel", xltm: "application/vnd.ms-excel.template.macroenabled.12", xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template", xlw: "application/vnd.ms-excel", txt: "text/plain", text: "text/plain", conf: "text/plain", log: "text/plain", pdf: "application/pdf", zip: "application/zip", "7z": "application/x-7z-compressed", rar: "application/x-rar-compressed", tar: "application/x-tar", gz: "application/gzip", dmg: "application/x-apple-diskimage" }, J = function(e2) {
    var t2 = e2.name ? $(e2.name).extension : null;
    return t2 = t2 ? t2.toLowerCase() : null, e2.type ? e2.type : t2 && K[t2] ? K[t2] : "application/octet-stream";
  };
  function Q(e2) {
    var t2 = "";
    return e2.replace(/[^A-Z0-9]/gi, function(e3) {
      return t2 += "-" + function(e4) {
        return e4.charCodeAt(0).toString(32);
      }(e3), "/";
    }) + t2;
  }
  var Z = function(e2) {
    var t2 = "uppy";
    return "string" == typeof e2.name && (t2 += "-" + Q(e2.name.toLowerCase())), void 0 !== e2.type && (t2 += "-" + e2.type), e2.meta && "string" == typeof e2.meta.relativePath && (t2 += "-" + Q(e2.meta.relativePath.toLowerCase())), void 0 !== e2.data.size && (t2 += "-" + e2.data.size), void 0 !== e2.data.lastModified && (t2 += "-" + e2.data.lastModified), t2;
  }, ee = function(e2, t2) {
    for (var n2 = 0; n2 < e2.length; n2++) if (t2(e2[n2])) return n2;
    return -1;
  }, te = function(e2) {
    if (null == e2 && (e2 = "undefined" != typeof navigator ? navigator.userAgent : null), !e2) return true;
    var t2 = /Edge\/(\d+\.\d+)/.exec(e2);
    if (!t2) return true;
    var n2 = t2[1].split("."), r2 = n2[0], o2 = n2[1];
    return r2 = parseInt(r2, 10), o2 = parseInt(o2, 10), r2 < 15 || 15 === r2 && o2 < 15063 || r2 > 18 || 18 === r2 && o2 >= 18218;
  };
  function ne(e2) {
    return 2 !== e2.length ? 0 + e2 : e2;
  }
  var re = function() {
    var e2 = /* @__PURE__ */ new Date();
    return ne(e2.getHours().toString()) + ":" + ne(e2.getMinutes().toString()) + ":" + ne(e2.getSeconds().toString());
  }, oe = { justErrorsLogger: { debug: function() {
  }, warn: function() {
  }, error: function() {
    for (var e2, t2 = arguments.length, n2 = new Array(t2), r2 = 0; r2 < t2; r2++) n2[r2] = arguments[r2];
    return (e2 = console).error.apply(e2, ["[Uppy] [" + re() + "]"].concat(n2));
  } }, debugLogger: { debug: function() {
    for (var e2 = console.debug || console.log, t2 = arguments.length, n2 = new Array(t2), r2 = 0; r2 < t2; r2++) n2[r2] = arguments[r2];
    e2.call.apply(e2, [console, "[Uppy] [" + re() + "]"].concat(n2));
  }, warn: function() {
    for (var e2, t2 = arguments.length, n2 = new Array(t2), r2 = 0; r2 < t2; r2++) n2[r2] = arguments[r2];
    return (e2 = console).warn.apply(e2, ["[Uppy] [" + re() + "]"].concat(n2));
  }, error: function() {
    for (var e2, t2 = arguments.length, n2 = new Array(t2), r2 = 0; r2 < t2; r2++) n2[r2] = arguments[r2];
    return (e2 = console).error.apply(e2, ["[Uppy] [" + re() + "]"].concat(n2));
  } } }, ie = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    ie.exports = N2;
  }(), ie = ie.exports;
  var ae = function(e2) {
    return e2 && "object" == typeof e2 && e2.nodeType === Node.ELEMENT_NODE;
  }, se = function(e2, t2) {
    return void 0 === t2 && (t2 = document), "string" == typeof e2 ? t2.querySelector(e2) : ae(e2) ? e2 : void 0;
  };
  function le() {
    return (le = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var ue, ce = function() {
    function e2(e3, t3) {
      this.uppy = e3, this.opts = t3 || {}, this.update = this.update.bind(this), this.mount = this.mount.bind(this), this.install = this.install.bind(this), this.uninstall = this.uninstall.bind(this);
    }
    var t2 = e2.prototype;
    return t2.getPluginState = function() {
      return this.uppy.getState().plugins[this.id] || {};
    }, t2.setPluginState = function(e3) {
      var t3, n2 = this.uppy.getState().plugins;
      this.uppy.setState({ plugins: le({}, n2, (t3 = {}, t3[this.id] = le({}, n2[this.id], e3), t3)) });
    }, t2.setOptions = function(e3) {
      this.opts = le({}, this.opts, e3), this.setPluginState();
    }, t2.update = function(e3) {
      void 0 !== this.el && this._updateUI && this._updateUI(e3);
    }, t2.afterUpdate = function() {
    }, t2.onMount = function() {
    }, t2.mount = function(t3, n2) {
      var r2, o2, i2, a2, s2 = this, l2 = n2.id, u2 = se(t3);
      if (u2) return this.isTargetDOMEl = true, this.rerender = function(e3) {
        s2.uppy.getPlugin(s2.id) && (s2.el = ie.render(s2.render(e3), u2, s2.el), s2.afterUpdate());
      }, this._updateUI = (r2 = this.rerender, o2 = null, i2 = null, function() {
        for (var e3 = arguments.length, t4 = new Array(e3), n3 = 0; n3 < e3; n3++) t4[n3] = arguments[n3];
        return i2 = t4, o2 || (o2 = Promise.resolve().then(function() {
          return o2 = null, r2.apply(void 0, i2);
        })), o2;
      }), this.uppy.log("Installing " + l2 + " to a DOM element '" + t3 + "'"), this.opts.replaceTargetContent && (u2.innerHTML = ""), this.el = ie.render(this.render(this.uppy.getState()), u2), this.onMount(), this.el;
      if ("object" == typeof t3 && t3 instanceof e2) a2 = t3;
      else if ("function" == typeof t3) {
        var c2 = t3;
        this.uppy.iteratePlugins(function(e3) {
          if (e3 instanceof c2) return a2 = e3, false;
        });
      }
      if (a2) return this.uppy.log("Installing " + l2 + " to " + a2.id), this.parent = a2, this.el = a2.addTarget(n2), this.onMount(), this.el;
      this.uppy.log("Not installing " + l2);
      var p2 = "Invalid target option given to " + l2 + ".";
      throw new Error(p2 += "function" == typeof t3 ? " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly." : "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.");
    }, t2.render = function(e3) {
      throw new Error("Extend the render method to add your plugin to a DOM element");
    }, t2.addTarget = function(e3) {
      throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }, t2.unmount = function() {
      this.isTargetDOMEl && this.el && this.el.parentNode && this.el.parentNode.removeChild(this.el);
    }, t2.install = function() {
    }, t2.uninstall = function() {
      this.unmount();
    }, e2;
  }();
  function pe() {
    return (pe = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function de(e2, t2) {
    for (var n2 = 0; n2 < t2.length; n2++) {
      var r2 = t2[n2];
      r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
    }
  }
  function he(e2) {
    var t2 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
    return (he = function(e3) {
      if (null === e3 || (n2 = e3, -1 === Function.toString.call(n2).indexOf("[native code]"))) return e3;
      var n2;
      if ("function" != typeof e3) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t2) {
        if (t2.has(e3)) return t2.get(e3);
        t2.set(e3, r2);
      }
      function r2() {
        return fe(e3, arguments, ve(this).constructor);
      }
      return r2.prototype = Object.create(e3.prototype, { constructor: { value: r2, enumerable: false, writable: true, configurable: true } }), me(r2, e3);
    })(e2);
  }
  function fe(e2, t2, n2) {
    return (fe = function() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if ("function" == typeof Proxy) return true;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), true;
      } catch (e3) {
        return false;
      }
    }() ? Reflect.construct : function(e3, t3, n3) {
      var r2 = [null];
      r2.push.apply(r2, t3);
      var o2 = new (Function.bind.apply(e3, r2))();
      return n3 && me(o2, n3.prototype), o2;
    }).apply(null, arguments);
  }
  function me(e2, t2) {
    return (me = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function ve(e2) {
    return (ve = Object.setPrototypeOf ? Object.getPrototypeOf : function(e3) {
      return e3.__proto__ || Object.getPrototypeOf(e3);
    })(e2);
  }
  var ge = oe.justErrorsLogger, ye = oe.debugLogger, be = function(e2) {
    var t2, n2;
    function r2() {
      for (var t3, n3 = arguments.length, r3 = new Array(n3), o2 = 0; o2 < n3; o2++) r3[o2] = arguments[o2];
      return (t3 = e2.call.apply(e2, [this].concat(r3)) || this).isRestriction = true, t3;
    }
    return n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, me(t2, n2), r2;
  }(he(Error)), _e = function() {
    function e2(e3) {
      var t3 = this;
      this.defaultLocale = { strings: { addBulkFilesFailed: { 0: "Failed to add %{smart_count} file due to an internal error", 1: "Failed to add %{smart_count} files due to internal errors" }, youCanOnlyUploadX: { 0: "You can only upload %{smart_count} file", 1: "You can only upload %{smart_count} files" }, youHaveToAtLeastSelectX: { 0: "You have to select at least %{smart_count} file", 1: "You have to select at least %{smart_count} files" }, exceedsSize2: "%{backwardsCompat} %{size}", exceedsSize: "%{file} exceeds maximum allowed size of", inferiorSize: "This file is smaller than the allowed size of %{size}", youCanOnlyUploadFileTypes: "You can only upload: %{types}", noNewAlreadyUploading: "Cannot add new files: already uploading", noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists", companionError: "Connection with Companion failed", companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}", failedToUpload: "Failed to upload %{file}", noInternetConnection: "No Internet connection", connectedToInternet: "Connected to the Internet", noFilesFound: "You have no files or folders here", selectX: { 0: "Select %{smart_count}", 1: "Select %{smart_count}" }, selectAllFilesFromFolderNamed: "Select all files from folder %{name}", unselectAllFilesFromFolderNamed: "Unselect all files from folder %{name}", selectFileNamed: "Select file %{name}", unselectFileNamed: "Unselect file %{name}", openFolderNamed: "Open folder %{name}", cancel: "Cancel", logOut: "Log out", filter: "Filter", resetFilter: "Reset filter", loading: "Loading...", authenticateWithTitle: "Please authenticate with %{pluginName} to select files", authenticateWith: "Connect to %{pluginName}", searchImages: "Search for images", enterTextToSearch: "Enter text to search for images", backToSearch: "Back to Search", emptyFolderAdded: "No files were added from empty folder", folderAdded: { 0: "Added %{smart_count} file from %{folder}", 1: "Added %{smart_count} files from %{folder}" } } };
      var n3 = { id: "uppy", autoProceed: false, allowMultipleUploads: true, debug: false, restrictions: { maxFileSize: null, minFileSize: null, maxTotalFileSize: null, maxNumberOfFiles: null, minNumberOfFiles: null, allowedFileTypes: null }, meta: {}, onBeforeFileAdded: function(e4) {
        return e4;
      }, onBeforeUpload: function(e4) {
        return e4;
      }, store: q(), logger: ge, infoTimeout: 5e3 };
      if (this.opts = pe({}, n3, e3, { restrictions: pe({}, n3.restrictions, e3 && e3.restrictions) }), e3 && e3.logger && e3.debug ? this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning") : e3 && e3.debug && (this.opts.logger = ye), this.log("Using Core v" + this.constructor.VERSION), this.opts.restrictions.allowedFileTypes && null !== this.opts.restrictions.allowedFileTypes && !Array.isArray(this.opts.restrictions.allowedFileTypes)) throw new TypeError("`restrictions.allowedFileTypes` must be an array");
      this.i18nInit(), this.plugins = {}, this.getState = this.getState.bind(this), this.getPlugin = this.getPlugin.bind(this), this.setFileMeta = this.setFileMeta.bind(this), this.setFileState = this.setFileState.bind(this), this.log = this.log.bind(this), this.info = this.info.bind(this), this.hideInfo = this.hideInfo.bind(this), this.addFile = this.addFile.bind(this), this.removeFile = this.removeFile.bind(this), this.pauseResume = this.pauseResume.bind(this), this.validateRestrictions = this.validateRestrictions.bind(this), this.calculateProgress = z(this.calculateProgress.bind(this), 500, { leading: true, trailing: true }), this.updateOnlineStatus = this.updateOnlineStatus.bind(this), this.resetProgress = this.resetProgress.bind(this), this.pauseAll = this.pauseAll.bind(this), this.resumeAll = this.resumeAll.bind(this), this.retryAll = this.retryAll.bind(this), this.cancelAll = this.cancelAll.bind(this), this.retryUpload = this.retryUpload.bind(this), this.upload = this.upload.bind(this), this.emitter = P(), this.on = this.on.bind(this), this.off = this.off.bind(this), this.once = this.emitter.once.bind(this.emitter), this.emit = this.emitter.emit.bind(this.emitter), this.preProcessors = [], this.uploaders = [], this.postProcessors = [], this.store = this.opts.store, this.setState({ plugins: {}, files: {}, currentUploads: {}, allowNewUpload: true, capabilities: { uploadProgress: te(), individualCancellation: true, resumableUploads: false }, totalProgress: 0, meta: pe({}, this.opts.meta), info: { isHidden: true, type: "info", message: "" }, recoveredState: null }), this.storeUnsubscribe = this.store.subscribe(function(e4, n4, r3) {
        t3.emit("state-update", e4, n4, r3), t3.updateAll(n4);
      }), this.opts.debug && "undefined" != typeof window && (window[this.opts.id] = this), this.addListeners();
    }
    var t2, n2, r2 = e2.prototype;
    return r2.on = function(e3, t3) {
      return this.emitter.on(e3, t3), this;
    }, r2.off = function(e3, t3) {
      return this.emitter.off(e3, t3), this;
    }, r2.updateAll = function(e3) {
      this.iteratePlugins(function(t3) {
        t3.update(e3);
      });
    }, r2.setState = function(e3) {
      this.store.setState(e3);
    }, r2.getState = function() {
      return this.store.getState();
    }, r2.setFileState = function(e3, t3) {
      var n3;
      if (!this.getState().files[e3]) throw new Error("Can\u2019t set state for " + e3 + " (the file could have been removed)");
      this.setState({ files: pe({}, this.getState().files, (n3 = {}, n3[e3] = pe({}, this.getState().files[e3], t3), n3)) });
    }, r2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.opts.locale]), this.locale = this.translator.locale, this.i18n = this.translator.translate.bind(this.translator), this.i18nArray = this.translator.translateArray.bind(this.translator);
    }, r2.setOptions = function(e3) {
      this.opts = pe({}, this.opts, e3, { restrictions: pe({}, this.opts.restrictions, e3 && e3.restrictions) }), e3.meta && this.setMeta(e3.meta), this.i18nInit(), e3.locale && this.iteratePlugins(function(e4) {
        e4.setOptions();
      }), this.setState();
    }, r2.resetProgress = function() {
      var e3 = { percentage: 0, bytesUploaded: 0, uploadComplete: false, uploadStarted: null }, t3 = pe({}, this.getState().files), n3 = {};
      Object.keys(t3).forEach(function(r3) {
        var o2 = pe({}, t3[r3]);
        o2.progress = pe({}, o2.progress, e3), n3[r3] = o2;
      }), this.setState({ files: n3, totalProgress: 0 }), this.emit("reset-progress");
    }, r2.addPreProcessor = function(e3) {
      this.preProcessors.push(e3);
    }, r2.removePreProcessor = function(e3) {
      var t3 = this.preProcessors.indexOf(e3);
      -1 !== t3 && this.preProcessors.splice(t3, 1);
    }, r2.addPostProcessor = function(e3) {
      this.postProcessors.push(e3);
    }, r2.removePostProcessor = function(e3) {
      var t3 = this.postProcessors.indexOf(e3);
      -1 !== t3 && this.postProcessors.splice(t3, 1);
    }, r2.addUploader = function(e3) {
      this.uploaders.push(e3);
    }, r2.removeUploader = function(e3) {
      var t3 = this.uploaders.indexOf(e3);
      -1 !== t3 && this.uploaders.splice(t3, 1);
    }, r2.setMeta = function(e3) {
      var t3 = pe({}, this.getState().meta, e3), n3 = pe({}, this.getState().files);
      Object.keys(n3).forEach(function(t4) {
        n3[t4] = pe({}, n3[t4], { meta: pe({}, n3[t4].meta, e3) });
      }), this.log("Adding metadata:"), this.log(e3), this.setState({ meta: t3, files: n3 });
    }, r2.setFileMeta = function(e3, t3) {
      var n3 = pe({}, this.getState().files);
      if (n3[e3]) {
        var r3 = pe({}, n3[e3].meta, t3);
        n3[e3] = pe({}, n3[e3], { meta: r3 }), this.setState({ files: n3 });
      } else this.log("Was trying to set metadata for a file that has been removed: ", e3);
    }, r2.getFile = function(e3) {
      return this.getState().files[e3];
    }, r2.getFiles = function() {
      var e3 = this.getState().files;
      return Object.keys(e3).map(function(t3) {
        return e3[t3];
      });
    }, r2.validateRestrictions = function(e3, t3) {
      try {
        return this.checkRestrictions(e3, t3), { result: true };
      } catch (wd2) {
        return { result: false, reason: wd2.message };
      }
    }, r2.checkRestrictions = function(e3, t3) {
      void 0 === t3 && (t3 = this.getFiles());
      var n3 = this.opts.restrictions, r3 = n3.maxFileSize, o2 = n3.minFileSize, i2 = n3.maxTotalFileSize, a2 = n3.maxNumberOfFiles, s2 = n3.allowedFileTypes;
      if (a2 && t3.length + 1 > a2) throw new be("" + this.i18n("youCanOnlyUploadX", { smart_count: a2 }));
      if (s2 && !s2.some(function(t4) {
        return t4.indexOf("/") > -1 ? !!e3.type && function(e4, t5) {
          function n4(t6) {
            var n5 = H(t6, e4, X);
            return n5 && n5.length >= 2;
          }
          return t5 ? n4(t5.split(";")[0]) : n4;
        }(e3.type.replace(/;.*?$/, ""), t4) : !("." !== t4[0] || !e3.extension) && e3.extension.toLowerCase() === t4.substr(1).toLowerCase();
      })) {
        var l2 = s2.join(", ");
        throw new be(this.i18n("youCanOnlyUploadFileTypes", { types: l2 }));
      }
      if (i2 && null != e3.size) {
        var u2 = 0;
        if (u2 += e3.size, t3.forEach(function(e4) {
          u2 += e4.size;
        }), u2 > i2) throw new be(this.i18n("exceedsSize2", { backwardsCompat: this.i18n("exceedsSize"), size: W(i2), file: e3.name }));
      }
      if (r3 && null != e3.size && e3.size > r3) throw new be(this.i18n("exceedsSize2", { backwardsCompat: this.i18n("exceedsSize"), size: W(r3), file: e3.name }));
      if (o2 && null != e3.size && e3.size < o2) throw new be(this.i18n("inferiorSize", { size: W(o2) }));
    }, r2.checkMinNumberOfFiles = function(e3) {
      var t3 = this.opts.restrictions.minNumberOfFiles;
      if (Object.keys(e3).length < t3) throw new be("" + this.i18n("youHaveToAtLeastSelectX", { smart_count: t3 }));
    }, r2.showOrLogErrorAndThrow = function(e3, t3) {
      var n3 = void 0 === t3 ? {} : t3, r3 = n3.showInformer, o2 = void 0 === r3 || r3, i2 = n3.file, a2 = void 0 === i2 ? null : i2, s2 = n3.throwErr, l2 = void 0 === s2 || s2, u2 = "object" == typeof e3 ? e3.message : e3, c2 = "object" == typeof e3 && e3.details ? e3.details : "", p2 = u2;
      if (c2 && (p2 += " " + c2), e3.isRestriction ? (this.log(p2), this.emit("restriction-failed", a2, e3)) : this.log(p2, "error"), o2 && this.info({ message: u2, details: c2 }, "error", this.opts.infoTimeout), l2) throw "object" == typeof e3 ? e3 : new Error(e3);
    }, r2.assertNewUploadAllowed = function(e3) {
      false === this.getState().allowNewUpload && this.showOrLogErrorAndThrow(new be(this.i18n("noNewAlreadyUploading")), { file: e3 });
    }, r2.checkAndCreateFileStateObject = function(e3, t3) {
      var n3 = J(t3), r3 = t3;
      r3.type = n3;
      var o2, i2 = this.opts.onBeforeFileAdded(r3, e3);
      false === i2 && this.showOrLogErrorAndThrow(new be("Cannot add the file because onBeforeFileAdded returned false."), { showInformer: false, file: r3 }), "object" == typeof i2 && i2 && (r3 = i2), o2 = r3.name ? r3.name : "image" === n3.split("/")[0] ? n3.split("/")[0] + "." + n3.split("/")[1] : "noname";
      var a2 = $(o2).extension, s2 = r3.isRemote || false, l2 = Z(r3);
      e3[l2] && !e3[l2].isGhost && this.showOrLogErrorAndThrow(new be(this.i18n("noDuplicates", { fileName: o2 })), { file: r3 });
      var u2 = r3.meta || {};
      u2.name = o2, u2.type = n3;
      var c2 = Number.isFinite(r3.data.size) ? r3.data.size : null, p2 = { source: r3.source || "", id: l2, name: o2, extension: a2 || "", meta: pe({}, this.getState().meta, u2), type: n3, data: r3.data, progress: { percentage: 0, bytesUploaded: 0, bytesTotal: c2, uploadComplete: false, uploadStarted: null }, size: c2, isRemote: s2, remote: r3.remote || "", preview: r3.preview };
      try {
        var d2 = Object.keys(e3).map(function(t4) {
          return e3[t4];
        });
        this.checkRestrictions(p2, d2);
      } catch (wd2) {
        this.showOrLogErrorAndThrow(wd2, { file: p2 });
      }
      return p2;
    }, r2.startIfAutoProceed = function() {
      var e3 = this;
      this.opts.autoProceed && !this.scheduledAutoProceed && (this.scheduledAutoProceed = setTimeout(function() {
        e3.scheduledAutoProceed = null, e3.upload().catch(function(t3) {
          t3.isRestriction || e3.log(t3.stack || t3.message || t3);
        });
      }, 4));
    }, r2.addFile = function(e3) {
      var t3;
      this.assertNewUploadAllowed(e3);
      var n3 = this.getState().files, r3 = this.checkAndCreateFileStateObject(n3, e3);
      return n3[r3.id] && n3[r3.id].isGhost && (r3 = pe({}, n3[r3.id], { data: e3.data, isGhost: false }), this.log("Replaced the blob in the restored ghost file: " + r3.name + ", " + r3.id)), this.setState({ files: pe({}, n3, (t3 = {}, t3[r3.id] = r3, t3)) }), this.emit("file-added", r3), this.emit("files-added", [r3]), this.log("Added file: " + r3.name + ", " + r3.id + ", mime type: " + r3.type), this.startIfAutoProceed(), r3.id;
    }, r2.addFiles = function(e3) {
      var t3 = this;
      this.assertNewUploadAllowed();
      for (var n3 = pe({}, this.getState().files), r3 = [], o2 = [], i2 = 0; i2 < e3.length; i2++) try {
        var a2 = this.checkAndCreateFileStateObject(n3, e3[i2]);
        n3[a2.id] && n3[a2.id].isGhost && (a2 = pe({}, n3[a2.id], { data: e3[i2].data, isGhost: false }), this.log("Replaced blob in a ghost file: " + a2.name + ", " + a2.id)), n3[a2.id] = a2, r3.push(a2);
      } catch (l3) {
        l3.isRestriction || o2.push(l3);
      }
      if (this.setState({ files: n3 }), r3.forEach(function(e4) {
        t3.emit("file-added", e4);
      }), this.emit("files-added", r3), r3.length > 5 ? this.log("Added batch of " + r3.length + " files") : Object.keys(r3).forEach(function(e4) {
        t3.log("Added file: " + r3[e4].name + "\n id: " + r3[e4].id + "\n type: " + r3[e4].type);
      }), r3.length > 0 && this.startIfAutoProceed(), o2.length > 0) {
        var s2 = "Multiple errors occurred while adding files:\n";
        if (o2.forEach(function(e4) {
          s2 += "\n * " + e4.message;
        }), this.info({ message: this.i18n("addBulkFilesFailed", { smart_count: o2.length }), details: s2 }, "error", this.opts.infoTimeout), "function" == typeof AggregateError) throw new AggregateError(o2, s2);
        var l2 = new Error(s2);
        throw l2.errors = o2, l2;
      }
    }, r2.removeFiles = function(e3, t3) {
      var n3 = this, r3 = this.getState(), o2 = r3.files, i2 = r3.currentUploads, a2 = pe({}, o2), s2 = pe({}, i2), l2 = /* @__PURE__ */ Object.create(null);
      function u2(e4) {
        return void 0 === l2[e4];
      }
      e3.forEach(function(e4) {
        o2[e4] && (l2[e4] = o2[e4], delete a2[e4]);
      }), Object.keys(s2).forEach(function(e4) {
        var t4 = i2[e4].fileIDs.filter(u2);
        0 !== t4.length ? s2[e4] = pe({}, i2[e4], { fileIDs: t4 }) : delete s2[e4];
      });
      var c2 = { currentUploads: s2, files: a2 };
      0 === Object.keys(a2).length && (c2.allowNewUpload = true, c2.error = null, c2.recoveredState = null), this.setState(c2), this.calculateTotalProgress();
      var p2 = Object.keys(l2);
      p2.forEach(function(e4) {
        n3.emit("file-removed", l2[e4], t3);
      }), p2.length > 5 ? this.log("Removed " + p2.length + " files") : this.log("Removed files: " + p2.join(", "));
    }, r2.removeFile = function(e3, t3) {
      void 0 === t3 && (t3 = null), this.removeFiles([e3], t3);
    }, r2.pauseResume = function(e3) {
      if (this.getState().capabilities.resumableUploads && !this.getFile(e3).uploadComplete) {
        var t3 = !this.getFile(e3).isPaused;
        return this.setFileState(e3, { isPaused: t3 }), this.emit("upload-pause", e3, t3), t3;
      }
    }, r2.pauseAll = function() {
      var e3 = pe({}, this.getState().files);
      Object.keys(e3).filter(function(t3) {
        return !e3[t3].progress.uploadComplete && e3[t3].progress.uploadStarted;
      }).forEach(function(t3) {
        var n3 = pe({}, e3[t3], { isPaused: true });
        e3[t3] = n3;
      }), this.setState({ files: e3 }), this.emit("pause-all");
    }, r2.resumeAll = function() {
      var e3 = pe({}, this.getState().files);
      Object.keys(e3).filter(function(t3) {
        return !e3[t3].progress.uploadComplete && e3[t3].progress.uploadStarted;
      }).forEach(function(t3) {
        var n3 = pe({}, e3[t3], { isPaused: false, error: null });
        e3[t3] = n3;
      }), this.setState({ files: e3 }), this.emit("resume-all");
    }, r2.retryAll = function() {
      var e3 = pe({}, this.getState().files), t3 = Object.keys(e3).filter(function(t4) {
        return e3[t4].error;
      });
      if (t3.forEach(function(t4) {
        var n4 = pe({}, e3[t4], { isPaused: false, error: null });
        e3[t4] = n4;
      }), this.setState({ files: e3, error: null }), this.emit("retry-all", t3), 0 === t3.length) return Promise.resolve({ successful: [], failed: [] });
      var n3 = this.createUpload(t3, { forceAllowNewUpload: true });
      return this.runUpload(n3);
    }, r2.cancelAll = function() {
      this.emit("cancel-all");
      var e3 = this.getState().files, t3 = Object.keys(e3);
      t3.length && this.removeFiles(t3, "cancel-all"), this.setState({ totalProgress: 0, error: null, recoveredState: null });
    }, r2.retryUpload = function(e3) {
      this.setFileState(e3, { error: null, isPaused: false }), this.emit("upload-retry", e3);
      var t3 = this.createUpload([e3], { forceAllowNewUpload: true });
      return this.runUpload(t3);
    }, r2.reset = function() {
      this.cancelAll();
    }, r2.logout = function() {
      this.iteratePlugins(function(e3) {
        e3.provider && e3.provider.logout && e3.provider.logout();
      });
    }, r2.calculateProgress = function(e3, t3) {
      if (this.getFile(e3.id)) {
        var n3 = Number.isFinite(t3.bytesTotal) && t3.bytesTotal > 0;
        this.setFileState(e3.id, { progress: pe({}, this.getFile(e3.id).progress, { bytesUploaded: t3.bytesUploaded, bytesTotal: t3.bytesTotal, percentage: n3 ? Math.round(t3.bytesUploaded / t3.bytesTotal * 100) : 0 }) }), this.calculateTotalProgress();
      } else this.log("Not setting progress for a file that has been removed: " + e3.id);
    }, r2.calculateTotalProgress = function() {
      var e3 = this.getFiles().filter(function(e4) {
        return e4.progress.uploadStarted || e4.progress.preprocess || e4.progress.postprocess;
      });
      if (0 === e3.length) return this.emit("progress", 0), void this.setState({ totalProgress: 0 });
      var t3 = e3.filter(function(e4) {
        return null != e4.progress.bytesTotal;
      }), n3 = e3.filter(function(e4) {
        return null == e4.progress.bytesTotal;
      });
      if (0 !== t3.length) {
        var r3 = t3.reduce(function(e4, t4) {
          return e4 + t4.progress.bytesTotal;
        }, 0), o2 = r3 / t3.length;
        r3 += o2 * n3.length;
        var i2 = 0;
        t3.forEach(function(e4) {
          i2 += e4.progress.bytesUploaded;
        }), n3.forEach(function(e4) {
          i2 += o2 * (e4.progress.percentage || 0) / 100;
        });
        var a2 = 0 === r3 ? 0 : Math.round(i2 / r3 * 100);
        a2 > 100 && (a2 = 100), this.setState({ totalProgress: a2 }), this.emit("progress", a2);
      } else {
        var s2 = 100 * e3.length, l2 = n3.reduce(function(e4, t4) {
          return e4 + t4.progress.percentage;
        }, 0), u2 = Math.round(l2 / s2 * 100);
        this.setState({ totalProgress: u2 });
      }
    }, r2.addListeners = function() {
      var e3 = this, t3 = function(t4, n3, r3) {
        var o2 = t4.message || "Unknown error";
        t4.details && (o2 += " " + t4.details), e3.setState({ error: o2 }), null != n3 && e3.setFileState(n3.id, { error: o2, response: r3 });
      };
      this.on("error", t3), this.on("upload-error", function(n3, r3, o2) {
        if (t3(r3, n3, o2), "object" == typeof r3 && r3.message) {
          var i2 = new Error(r3.message);
          i2.details = r3.message, r3.details && (i2.details += " " + r3.details), i2.message = e3.i18n("failedToUpload", { file: n3.name }), e3.showOrLogErrorAndThrow(i2, { throwErr: false });
        } else e3.showOrLogErrorAndThrow(r3, { throwErr: false });
      }), this.on("upload", function() {
        e3.setState({ error: null });
      }), this.on("upload-started", function(t4) {
        e3.getFile(t4.id) ? e3.setFileState(t4.id, { progress: { uploadStarted: Date.now(), uploadComplete: false, percentage: 0, bytesUploaded: 0, bytesTotal: t4.size } }) : e3.log("Not setting progress for a file that has been removed: " + t4.id);
      }), this.on("upload-progress", this.calculateProgress), this.on("upload-success", function(t4, n3) {
        if (e3.getFile(t4.id)) {
          var r3 = e3.getFile(t4.id).progress;
          e3.setFileState(t4.id, { progress: pe({}, r3, { postprocess: e3.postProcessors.length > 0 ? { mode: "indeterminate" } : null, uploadComplete: true, percentage: 100, bytesUploaded: r3.bytesTotal }), response: n3, uploadURL: n3.uploadURL, isPaused: false }), e3.calculateTotalProgress();
        } else e3.log("Not setting progress for a file that has been removed: " + t4.id);
      }), this.on("preprocess-progress", function(t4, n3) {
        e3.getFile(t4.id) ? e3.setFileState(t4.id, { progress: pe({}, e3.getFile(t4.id).progress, { preprocess: n3 }) }) : e3.log("Not setting progress for a file that has been removed: " + t4.id);
      }), this.on("preprocess-complete", function(t4) {
        if (e3.getFile(t4.id)) {
          var n3 = pe({}, e3.getState().files);
          n3[t4.id] = pe({}, n3[t4.id], { progress: pe({}, n3[t4.id].progress) }), delete n3[t4.id].progress.preprocess, e3.setState({ files: n3 });
        } else e3.log("Not setting progress for a file that has been removed: " + t4.id);
      }), this.on("postprocess-progress", function(t4, n3) {
        e3.getFile(t4.id) ? e3.setFileState(t4.id, { progress: pe({}, e3.getState().files[t4.id].progress, { postprocess: n3 }) }) : e3.log("Not setting progress for a file that has been removed: " + t4.id);
      }), this.on("postprocess-complete", function(t4) {
        if (e3.getFile(t4.id)) {
          var n3 = pe({}, e3.getState().files);
          n3[t4.id] = pe({}, n3[t4.id], { progress: pe({}, n3[t4.id].progress) }), delete n3[t4.id].progress.postprocess, e3.setState({ files: n3 });
        } else e3.log("Not setting progress for a file that has been removed: " + t4.id);
      }), this.on("restored", function() {
        e3.calculateTotalProgress();
      }), "undefined" != typeof window && window.addEventListener && (window.addEventListener("online", function() {
        return e3.updateOnlineStatus();
      }), window.addEventListener("offline", function() {
        return e3.updateOnlineStatus();
      }), setTimeout(function() {
        return e3.updateOnlineStatus();
      }, 3e3));
    }, r2.updateOnlineStatus = function() {
      void 0 === window.navigator.onLine || window.navigator.onLine ? (this.emit("is-online"), this.wasOffline && (this.emit("back-online"), this.info(this.i18n("connectedToInternet"), "success", 3e3), this.wasOffline = false)) : (this.emit("is-offline"), this.info(this.i18n("noInternetConnection"), "error", 0), this.wasOffline = true);
    }, r2.getID = function() {
      return this.opts.id;
    }, r2.use = function(e3, t3) {
      if ("function" != typeof e3) throw new TypeError("Expected a plugin class, but got " + (null === e3 ? "null" : typeof e3) + ". Please verify that the plugin was imported and spelled correctly.");
      var n3 = new e3(this, t3), r3 = n3.id;
      if (this.plugins[n3.type] = this.plugins[n3.type] || [], !r3) throw new Error("Your plugin must have an id");
      if (!n3.type) throw new Error("Your plugin must have a type");
      var o2 = this.getPlugin(r3);
      if (o2) {
        var i2 = "Already found a plugin named '" + o2.id + "'. Tried to use: '" + r3 + "'.\nUppy plugins must have unique `id` options. See https://uppy.io/docs/plugins/#id.";
        throw new Error(i2);
      }
      return e3.VERSION && this.log("Using " + r3 + " v" + e3.VERSION), this.plugins[n3.type].push(n3), n3.install(), this;
    }, r2.getPlugin = function(e3) {
      var t3 = null;
      return this.iteratePlugins(function(n3) {
        if (n3.id === e3) return t3 = n3, false;
      }), t3;
    }, r2.iteratePlugins = function(e3) {
      var t3 = this;
      Object.keys(this.plugins).forEach(function(n3) {
        t3.plugins[n3].forEach(e3);
      });
    }, r2.removePlugin = function(e3) {
      var t3;
      this.log("Removing plugin " + e3.id), this.emit("plugin-remove", e3), e3.uninstall && e3.uninstall();
      var n3 = this.plugins[e3.type].slice(), r3 = ee(n3, function(t4) {
        return t4.id === e3.id;
      });
      -1 !== r3 && (n3.splice(r3, 1), this.plugins[e3.type] = n3);
      var o2 = { plugins: pe({}, this.getState().plugins, (t3 = {}, t3[e3.id] = void 0, t3)) };
      this.setState(o2);
    }, r2.close = function() {
      var e3 = this;
      this.log("Closing Uppy instance " + this.opts.id + ": removing all files and uninstalling plugins"), this.reset(), this.storeUnsubscribe(), this.iteratePlugins(function(t3) {
        e3.removePlugin(t3);
      });
    }, r2.info = function(e3, t3, n3) {
      void 0 === t3 && (t3 = "info"), void 0 === n3 && (n3 = 3e3);
      var r3 = "object" == typeof e3;
      this.setState({ info: { isHidden: false, type: t3, message: r3 ? e3.message : e3, details: r3 ? e3.details : null } }), this.emit("info-visible"), clearTimeout(this.infoTimeoutID), this.infoTimeoutID = 0 !== n3 ? setTimeout(this.hideInfo, n3) : void 0;
    }, r2.hideInfo = function() {
      var e3 = pe({}, this.getState().info, { isHidden: true });
      this.setState({ info: e3 }), this.emit("info-hidden");
    }, r2.log = function(e3, t3) {
      var n3 = this.opts.logger;
      switch (t3) {
        case "error":
          n3.error(e3);
          break;
        case "warning":
          n3.warn(e3);
          break;
        default:
          n3.debug(e3);
      }
    }, r2.run = function() {
      return this.log("Calling run() is no longer necessary.", "warning"), this;
    }, r2.restore = function(e3) {
      return this.log('Core: attempting to restore upload "' + e3 + '"'), this.getState().currentUploads[e3] ? this.runUpload(e3) : (this.removeUpload(e3), Promise.reject(new Error("Nonexistent upload")));
    }, r2.createUpload = function(e3, t3) {
      var n3;
      void 0 === t3 && (t3 = {});
      var r3 = t3.forceAllowNewUpload, o2 = void 0 !== r3 && r3, i2 = this.getState(), a2 = i2.allowNewUpload, s2 = i2.currentUploads;
      if (!a2 && !o2) throw new Error("Cannot create a new upload: already uploading.");
      var l2 = D();
      return this.emit("upload", { id: l2, fileIDs: e3 }), this.setState({ allowNewUpload: false !== this.opts.allowMultipleUploads, currentUploads: pe({}, s2, (n3 = {}, n3[l2] = { fileIDs: e3, step: 0, result: {} }, n3)) }), l2;
    }, r2.getUpload = function(e3) {
      return this.getState().currentUploads[e3];
    }, r2.addResultData = function(e3, t3) {
      var n3;
      if (this.getUpload(e3)) {
        var r3 = this.getState().currentUploads, o2 = pe({}, r3[e3], { result: pe({}, r3[e3].result, t3) });
        this.setState({ currentUploads: pe({}, r3, (n3 = {}, n3[e3] = o2, n3)) });
      } else this.log("Not setting result for an upload that has been removed: " + e3);
    }, r2.removeUpload = function(e3) {
      var t3 = pe({}, this.getState().currentUploads);
      delete t3[e3], this.setState({ currentUploads: t3 });
    }, r2.runUpload = function(e3) {
      var t3 = this, n3 = this.getState().currentUploads[e3].step, r3 = [].concat(this.preProcessors, this.uploaders, this.postProcessors), o2 = Promise.resolve();
      return r3.forEach(function(r4, i2) {
        i2 < n3 || (o2 = o2.then(function() {
          var n4, o3 = t3.getState().currentUploads, a2 = o3[e3];
          if (a2) {
            var s2 = pe({}, a2, { step: i2 });
            return t3.setState({ currentUploads: pe({}, o3, (n4 = {}, n4[e3] = s2, n4)) }), r4(s2.fileIDs, e3);
          }
        }).then(function() {
          return null;
        }));
      }), o2.catch(function(n4) {
        t3.emit("error", n4, e3), t3.removeUpload(e3);
      }), o2.then(function() {
        var n4 = t3.getState().currentUploads[e3];
        if (n4) {
          n4.fileIDs.forEach(function(e4) {
            var n5 = t3.getFile(e4);
            n5 && n5.progress.postprocess && t3.emit("postprocess-complete", n5);
          });
          var r4 = n4.fileIDs.map(function(e4) {
            return t3.getFile(e4);
          }), o3 = r4.filter(function(e4) {
            return !e4.error;
          }), i2 = r4.filter(function(e4) {
            return e4.error;
          });
          t3.addResultData(e3, { successful: o3, failed: i2, uploadID: e3 });
        }
      }).then(function() {
        var n4 = t3.getState().currentUploads;
        if (n4[e3]) {
          var r4 = n4[e3].result;
          return t3.emit("complete", r4), t3.removeUpload(e3), r4;
        }
      }).then(function(n4) {
        return null == n4 && t3.log("Not setting result for an upload that has been removed: " + e3), n4;
      });
    }, r2.upload = function() {
      var e3 = this;
      this.plugins.uploader || this.log("No uploader type plugins are used", "warning");
      var t3 = this.getState().files, n3 = this.opts.onBeforeUpload(t3);
      return false === n3 ? Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false")) : (n3 && "object" == typeof n3 && (t3 = n3, this.setState({ files: t3 })), Promise.resolve().then(function() {
        return e3.checkMinNumberOfFiles(t3);
      }).catch(function(t4) {
        e3.showOrLogErrorAndThrow(t4);
      }).then(function() {
        var n4 = e3.getState().currentUploads, r3 = Object.keys(n4).reduce(function(e4, t4) {
          return e4.concat(n4[t4].fileIDs);
        }, []), o2 = [];
        Object.keys(t3).forEach(function(t4) {
          var n5 = e3.getFile(t4);
          n5.progress.uploadStarted || -1 !== r3.indexOf(t4) || o2.push(n5.id);
        });
        var i2 = e3.createUpload(o2);
        return e3.runUpload(i2);
      }).catch(function(t4) {
        e3.showOrLogErrorAndThrow(t4, { showInformer: false });
      }));
    }, t2 = e2, (n2 = [{ key: "state", get: function() {
      return this.getState();
    } }]) && de(t2.prototype, n2), e2;
  }();
  function we(e2) {
    var t2 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
    return (we = function(e3) {
      if (null === e3 || (n2 = e3, -1 === Function.toString.call(n2).indexOf("[native code]"))) return e3;
      var n2;
      if ("function" != typeof e3) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t2) {
        if (t2.has(e3)) return t2.get(e3);
        t2.set(e3, r2);
      }
      function r2() {
        return Ce(e3, arguments, ke(this).constructor);
      }
      return r2.prototype = Object.create(e3.prototype, { constructor: { value: r2, enumerable: false, writable: true, configurable: true } }), Se(r2, e3);
    })(e2);
  }
  function Ce(e2, t2, n2) {
    return (Ce = function() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if ("function" == typeof Proxy) return true;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), true;
      } catch (e3) {
        return false;
      }
    }() ? Reflect.construct : function(e3, t3, n3) {
      var r2 = [null];
      r2.push.apply(r2, t3);
      var o2 = new (Function.bind.apply(e3, r2))();
      return n3 && Se(o2, n3.prototype), o2;
    }).apply(null, arguments);
  }
  function Se(e2, t2) {
    return (Se = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function ke(e2) {
    return (ke = Object.setPrototypeOf ? Object.getPrototypeOf : function(e3) {
      return e3.__proto__ || Object.getPrototypeOf(e3);
    })(e2);
  }
  _e.VERSION = "1.19.2", (ue = function(e2) {
    return new _e(e2);
  }).Uppy = _e, ue.Plugin = ce, ue.debugLogger = ye;
  var xe = function(e2) {
    var t2, n2;
    function r2() {
      var t3;
      return (t3 = e2.call(this, "Authorization required") || this).name = "AuthError", t3.isAuthError = true, t3;
    }
    return n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Se(t2, n2), r2;
  }(we(Error));
  function Pe(e2) {
    var t2 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
    return (Pe = function(e3) {
      if (null === e3 || (n2 = e3, -1 === Function.toString.call(n2).indexOf("[native code]"))) return e3;
      var n2;
      if ("function" != typeof e3) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t2) {
        if (t2.has(e3)) return t2.get(e3);
        t2.set(e3, r2);
      }
      function r2() {
        return Ee(e3, arguments, Ae(this).constructor);
      }
      return r2.prototype = Object.create(e3.prototype, { constructor: { value: r2, enumerable: false, writable: true, configurable: true } }), Oe(r2, e3);
    })(e2);
  }
  function Ee(e2, t2, n2) {
    return (Ee = function() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if ("function" == typeof Proxy) return true;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), true;
      } catch (e3) {
        return false;
      }
    }() ? Reflect.construct : function(e3, t3, n3) {
      var r2 = [null];
      r2.push.apply(r2, t3);
      var o2 = new (Function.bind.apply(e3, r2))();
      return n3 && Oe(o2, n3.prototype), o2;
    }).apply(null, arguments);
  }
  function Oe(e2, t2) {
    return (Oe = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function Ae(e2) {
    return (Ae = Object.setPrototypeOf ? Object.getPrototypeOf : function(e3) {
      return e3.__proto__ || Object.getPrototypeOf(e3);
    })(e2);
  }
  var Ue, Ne, Te = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return void 0 === n3 && (n3 = null), (r3 = e2.call(this, "This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.\n\nSource error: [" + t3 + "]") || this).isNetworkError = true, r3.request = n3, r3;
    }
    return n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Oe(t2, n2), r2;
  }(Pe(Error)), Re = function() {
    return fetch.apply(void 0, arguments).catch(function(e2) {
      throw "AbortError" === e2.name ? e2 : new Te(e2);
    });
  };
  function Fe() {
    return (Fe = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function De(e2, t2) {
    for (var n2 = 0; n2 < t2.length; n2++) {
      var r2 = t2[n2];
      r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
    }
  }
  var Me = (Ne = Ue = function() {
    function e2(e3, t3) {
      this.uppy = e3, this.opts = t3, this.onReceiveResponse = this.onReceiveResponse.bind(this), this.allowedHeaders = ["accept", "content-type", "uppy-auth-token"], this.preflightDone = false;
    }
    var t2, n2, r2 = e2.prototype;
    return r2.headers = function() {
      var e3 = this.opts.companionHeaders || this.opts.serverHeaders || {};
      return Promise.resolve(Fe({}, this.defaultHeaders, e3));
    }, r2._getPostResponseFunc = function(e3) {
      var t3 = this;
      return function(n3) {
        return e3 ? n3 : t3.onReceiveResponse(n3);
      };
    }, r2.onReceiveResponse = function(e3) {
      var t3, n3 = this.uppy.getState().companion || {}, r3 = this.opts.companionUrl, o2 = e3.headers;
      return o2.has("i-am") && o2.get("i-am") !== n3[r3] && this.uppy.setState({ companion: Fe({}, n3, (t3 = {}, t3[r3] = o2.get("i-am"), t3)) }), e3;
    }, r2._getUrl = function(e3) {
      return /^(https?:|)\/\//.test(e3) ? e3 : this.hostname + "/" + e3;
    }, r2._json = function(e3) {
      if (401 === e3.status) throw new xe();
      if (e3.status < 200 || e3.status > 300) {
        var t3 = "Failed request with status: " + e3.status + ". " + e3.statusText;
        return e3.json().then(function(e4) {
          throw t3 = e4.message ? t3 + " message: " + e4.message : t3, t3 = e4.requestId ? t3 + " request-Id: " + e4.requestId : t3, new Error(t3);
        }).catch(function() {
          throw new Error(t3);
        });
      }
      return e3.json();
    }, r2.preflight = function(e3) {
      var t3 = this;
      return this.preflightDone ? Promise.resolve(this.allowedHeaders.slice()) : fetch(this._getUrl(e3), { method: "OPTIONS" }).then(function(e4) {
        return e4.headers.has("access-control-allow-headers") && (t3.allowedHeaders = e4.headers.get("access-control-allow-headers").split(",").map(function(e5) {
          return e5.trim().toLowerCase();
        })), t3.preflightDone = true, t3.allowedHeaders.slice();
      }).catch(function(e4) {
        return t3.uppy.log("[CompanionClient] unable to make preflight request " + e4, "warning"), t3.preflightDone = true, t3.allowedHeaders.slice();
      });
    }, r2.preflightAndHeaders = function(e3) {
      var t3 = this;
      return Promise.all([this.preflight(e3), this.headers()]).then(function(e4) {
        var n3 = e4[0], r3 = e4[1];
        return Object.keys(r3).forEach(function(e5) {
          -1 === n3.indexOf(e5.toLowerCase()) && (t3.uppy.log("[CompanionClient] excluding unallowed header " + e5), delete r3[e5]);
        }), r3;
      });
    }, r2.get = function(e3, t3) {
      var n3 = this;
      return this.preflightAndHeaders(e3).then(function(t4) {
        return Re(n3._getUrl(e3), { method: "get", headers: t4, credentials: n3.opts.companionCookiesRule || "same-origin" });
      }).then(this._getPostResponseFunc(t3)).then(function(e4) {
        return n3._json(e4);
      }).catch(function(t4) {
        return t4.isAuthError || (t4.message = "Could not get " + n3._getUrl(e3) + ". " + t4.message), Promise.reject(t4);
      });
    }, r2.post = function(e3, t3, n3) {
      var r3 = this;
      return this.preflightAndHeaders(e3).then(function(n4) {
        return Re(r3._getUrl(e3), { method: "post", headers: n4, credentials: r3.opts.companionCookiesRule || "same-origin", body: JSON.stringify(t3) });
      }).then(this._getPostResponseFunc(n3)).then(function(e4) {
        return r3._json(e4);
      }).catch(function(t4) {
        return t4.isAuthError || (t4.message = "Could not post " + r3._getUrl(e3) + ". " + t4.message), Promise.reject(t4);
      });
    }, r2.delete = function(e3, t3, n3) {
      var r3 = this;
      return this.preflightAndHeaders(e3).then(function(n4) {
        return Re(r3.hostname + "/" + e3, { method: "delete", headers: n4, credentials: r3.opts.companionCookiesRule || "same-origin", body: t3 ? JSON.stringify(t3) : null });
      }).then(this._getPostResponseFunc(n3)).then(function(e4) {
        return r3._json(e4);
      }).catch(function(t4) {
        return t4.isAuthError || (t4.message = "Could not delete " + r3._getUrl(e3) + ". " + t4.message), Promise.reject(t4);
      });
    }, t2 = e2, (n2 = [{ key: "hostname", get: function() {
      var e3 = this.uppy.getState().companion, t3 = this.opts.companionUrl;
      return (e3 && e3[t3] ? e3[t3] : t3).replace(/\/$/, "");
    } }, { key: "defaultHeaders", get: function() {
      return { Accept: "application/json", "Content-Type": "application/json", "Uppy-Versions": "@uppy/companion-client=" + e2.VERSION };
    } }]) && De(t2.prototype, n2), e2;
  }(), Ue.VERSION = "1.10.2", Ne), Be = Object.prototype.hasOwnProperty, Ie = function e2(t2, n2) {
    var r2 = [];
    for (var o2 in t2) if (Be.call(t2, o2)) {
      var i2, a2 = t2[o2], s2 = encodeURIComponent(o2);
      i2 = "object" == typeof a2 ? e2(a2, n2 ? n2 + "[" + s2 + "]" : s2) : (n2 ? n2 + "[" + s2 + "]" : s2) + "=" + encodeURIComponent(a2), r2.push(i2);
    }
    return r2.join("&");
  }, Le = function(e2, t2) {
    if (t2 = t2.split(":")[0], !(e2 = +e2)) return false;
    switch (t2) {
      case "http":
      case "ws":
        return 80 !== e2;
      case "https":
      case "wss":
        return 443 !== e2;
      case "ftp":
        return 21 !== e2;
      case "gopher":
        return 70 !== e2;
      case "file":
        return false;
    }
    return 0 !== e2;
  }, je = {}, ze = Object.prototype.hasOwnProperty;
  function He(e2) {
    try {
      return decodeURIComponent(e2.replace(/\+/g, " "));
    } catch (t2) {
      return null;
    }
  }
  function We(e2) {
    try {
      return encodeURIComponent(e2);
    } catch (t2) {
      return null;
    }
  }
  je.stringify = function(e2, t2) {
    t2 = t2 || "";
    var n2, r2, o2 = [];
    for (r2 in "string" != typeof t2 && (t2 = "?"), e2) if (ze.call(e2, r2)) {
      if ((n2 = e2[r2]) || null != n2 && !isNaN(n2) || (n2 = ""), r2 = We(r2), n2 = We(n2), null === r2 || null === n2) continue;
      o2.push(r2 + "=" + n2);
    }
    return o2.length ? t2 + o2.join("&") : "";
  }, je.parse = function(e2) {
    for (var t2, n2 = /([^=?#&]+)=?([^&]*)/g, r2 = {}; t2 = n2.exec(e2); ) {
      var o2 = He(t2[1]), i2 = He(t2[2]);
      null === o2 || null === i2 || o2 in r2 || (r2[o2] = i2);
    }
    return r2;
  };
  var Ve = {};
  (function(e2) {
    (function() {
      "use strict";
      var t2 = /^[A-Za-z][A-Za-z0-9+-.]*:[\\/]+/, n2 = /^([a-z][a-z0-9.+-]*:)?([\\/]{1,})?([\S\s]*)/i, r2 = new RegExp("^[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]+");
      function o2(e3) {
        return (e3 || "").toString().replace(r2, "");
      }
      var i2 = [["#", "hash"], ["?", "query"], function(e3) {
        return e3.replace("\\", "/");
      }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d+)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]], a2 = { hash: 1, query: 1 };
      function s2(n3) {
        var r3, o3 = ("undefined" != typeof window ? window : void 0 !== e2 ? e2 : "undefined" != typeof self ? self : {}).location || {}, i3 = {}, s3 = typeof (n3 = n3 || o3);
        if ("blob:" === n3.protocol) i3 = new u2(unescape(n3.pathname), {});
        else if ("string" === s3) for (r3 in i3 = new u2(n3, {}), a2) delete i3[r3];
        else if ("object" === s3) {
          for (r3 in n3) r3 in a2 || (i3[r3] = n3[r3]);
          void 0 === i3.slashes && (i3.slashes = t2.test(n3.href));
        }
        return i3;
      }
      function l2(e3) {
        e3 = o2(e3);
        var t3 = n2.exec(e3);
        return { protocol: t3[1] ? t3[1].toLowerCase() : "", slashes: !!(t3[2] && t3[2].length >= 2), rest: t3[2] && 1 === t3[2].length ? "/" + t3[3] : t3[3] };
      }
      function u2(e3, t3, n3) {
        if (e3 = o2(e3), !(this instanceof u2)) return new u2(e3, t3, n3);
        var r3, a3, c2, p2, d2, h2, f2 = i2.slice(), m2 = typeof t3, v2 = this, g2 = 0;
        for ("object" !== m2 && "string" !== m2 && (n3 = t3, t3 = null), n3 && "function" != typeof n3 && (n3 = je.parse), t3 = s2(t3), r3 = !(a3 = l2(e3 || "")).protocol && !a3.slashes, v2.slashes = a3.slashes || r3 && t3.slashes, v2.protocol = a3.protocol || t3.protocol || "", e3 = a3.rest, a3.slashes || (f2[3] = [/(.*)/, "pathname"]); g2 < f2.length; g2++) "function" != typeof (p2 = f2[g2]) ? (c2 = p2[0], h2 = p2[1], c2 != c2 ? v2[h2] = e3 : "string" == typeof c2 ? ~(d2 = e3.indexOf(c2)) && ("number" == typeof p2[2] ? (v2[h2] = e3.slice(0, d2), e3 = e3.slice(d2 + p2[2])) : (v2[h2] = e3.slice(d2), e3 = e3.slice(0, d2))) : (d2 = c2.exec(e3)) && (v2[h2] = d2[1], e3 = e3.slice(0, d2.index)), v2[h2] = v2[h2] || r3 && p2[3] && t3[h2] || "", p2[4] && (v2[h2] = v2[h2].toLowerCase())) : e3 = p2(e3);
        n3 && (v2.query = n3(v2.query)), r3 && t3.slashes && "/" !== v2.pathname.charAt(0) && ("" !== v2.pathname || "" !== t3.pathname) && (v2.pathname = function(e4, t4) {
          if ("" === e4) return t4;
          for (var n4 = (t4 || "/").split("/").slice(0, -1).concat(e4.split("/")), r4 = n4.length, o3 = n4[r4 - 1], i3 = false, a4 = 0; r4--; ) "." === n4[r4] ? n4.splice(r4, 1) : ".." === n4[r4] ? (n4.splice(r4, 1), a4++) : a4 && (0 === r4 && (i3 = true), n4.splice(r4, 1), a4--);
          return i3 && n4.unshift(""), "." !== o3 && ".." !== o3 || n4.push(""), n4.join("/");
        }(v2.pathname, t3.pathname)), "/" !== v2.pathname.charAt(0) && v2.hostname && (v2.pathname = "/" + v2.pathname), Le(v2.port, v2.protocol) || (v2.host = v2.hostname, v2.port = ""), v2.username = v2.password = "", v2.auth && (p2 = v2.auth.split(":"), v2.username = p2[0] || "", v2.password = p2[1] || ""), v2.origin = v2.protocol && v2.host && "file:" !== v2.protocol ? v2.protocol + "//" + v2.host : "null", v2.href = v2.toString();
      }
      u2.prototype = { set: function(e3, t3, n3) {
        var r3 = this;
        switch (e3) {
          case "query":
            "string" == typeof t3 && t3.length && (t3 = (n3 || je.parse)(t3)), r3[e3] = t3;
            break;
          case "port":
            r3[e3] = t3, Le(t3, r3.protocol) ? t3 && (r3.host = r3.hostname + ":" + t3) : (r3.host = r3.hostname, r3[e3] = "");
            break;
          case "hostname":
            r3[e3] = t3, r3.port && (t3 += ":" + r3.port), r3.host = t3;
            break;
          case "host":
            r3[e3] = t3, /:\d+$/.test(t3) ? (t3 = t3.split(":"), r3.port = t3.pop(), r3.hostname = t3.join(":")) : (r3.hostname = t3, r3.port = "");
            break;
          case "protocol":
            r3.protocol = t3.toLowerCase(), r3.slashes = !n3;
            break;
          case "pathname":
          case "hash":
            if (t3) {
              var o3 = "pathname" === e3 ? "/" : "#";
              r3[e3] = t3.charAt(0) !== o3 ? o3 + t3 : t3;
            } else r3[e3] = t3;
            break;
          default:
            r3[e3] = t3;
        }
        for (var a3 = 0; a3 < i2.length; a3++) {
          var s3 = i2[a3];
          s3[4] && (r3[s3[1]] = r3[s3[1]].toLowerCase());
        }
        return r3.origin = r3.protocol && r3.host && "file:" !== r3.protocol ? r3.protocol + "//" + r3.host : "null", r3.href = r3.toString(), r3;
      }, toString: function(e3) {
        e3 && "function" == typeof e3 || (e3 = je.stringify);
        var t3, n3 = this, r3 = n3.protocol;
        r3 && ":" !== r3.charAt(r3.length - 1) && (r3 += ":");
        var o3 = r3 + (n3.slashes ? "//" : "");
        return n3.username && (o3 += n3.username, n3.password && (o3 += ":" + n3.password), o3 += "@"), o3 += n3.host + n3.pathname, (t3 = "object" == typeof n3.query ? e3(n3.query) : n3.query) && (o3 += "?" !== t3.charAt(0) ? "?" + t3 : t3), n3.hash && (o3 += n3.hash), o3;
      } }, u2.extractProtocol = l2, u2.location = s2, u2.trimLeft = o2, u2.qs = je, Ve = u2;
    }).call(this);
  }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
  var qe = {};
  function Xe() {
    return (Xe = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Ge(e2, t2) {
    return (Ge = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  qe.setItem = function(e2, t2) {
    return new Promise(function(n2) {
      localStorage.setItem(e2, t2), n2();
    });
  }, qe.getItem = function(e2) {
    return Promise.resolve(localStorage.getItem(e2));
  }, qe.removeItem = function(e2) {
    return new Promise(function(t2) {
      localStorage.removeItem(e2), t2();
    });
  };
  var Ye = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).provider = n3.provider, r3.id = r3.provider, r3.name = r3.opts.name || r3.id.split("-").map(function(e3) {
        return e3.charAt(0).toUpperCase() + e3.slice(1);
      }).join(" "), r3.pluginId = r3.opts.pluginId, r3.tokenKey = "companion-" + r3.pluginId + "-auth-token", r3.companionKeysParams = r3.opts.companionKeysParams, r3.preAuthToken = null, r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Ge(t2, n2);
    var o2 = r2.prototype;
    return o2.headers = function() {
      var t3 = this;
      return Promise.all([e2.prototype.headers.call(this), this.getAuthToken()]).then(function(e3) {
        var n3 = e3[0], r3 = e3[1], o3 = {};
        return r3 && (o3["uppy-auth-token"] = r3), t3.companionKeysParams && (o3["uppy-credentials-params"] = btoa(JSON.stringify({ params: t3.companionKeysParams }))), Xe({}, n3, o3);
      });
    }, o2.onReceiveResponse = function(t3) {
      t3 = e2.prototype.onReceiveResponse.call(this, t3);
      var n3 = this.uppy.getPlugin(this.pluginId), r3 = n3.getPluginState().authenticated ? 401 !== t3.status : t3.status < 400;
      return n3.setPluginState({ authenticated: r3 }), t3;
    }, o2.setAuthToken = function(e3) {
      return this.uppy.getPlugin(this.pluginId).storage.setItem(this.tokenKey, e3);
    }, o2.getAuthToken = function() {
      return this.uppy.getPlugin(this.pluginId).storage.getItem(this.tokenKey);
    }, o2.authUrl = function(e3) {
      void 0 === e3 && (e3 = {}), this.preAuthToken && (e3.uppyPreAuthToken = this.preAuthToken);
      var t3 = Ie(e3);
      return t3 = t3 ? "?" + t3 : t3, this.hostname + "/" + this.id + "/connect" + t3;
    }, o2.fileUrl = function(e3) {
      return this.hostname + "/" + this.id + "/get/" + e3;
    }, o2.fetchPreAuthToken = function() {
      var e3 = this;
      return this.companionKeysParams ? this.post(this.id + "/preauth/", { params: this.companionKeysParams }).then(function(t3) {
        e3.preAuthToken = t3.token;
      }).catch(function(t3) {
        e3.uppy.log("[CompanionClient] unable to fetch preAuthToken " + t3, "warning");
      }) : Promise.resolve();
    }, o2.list = function(e3) {
      return this.get(this.id + "/list/" + (e3 || ""));
    }, o2.logout = function() {
      var e3 = this;
      return this.get(this.id + "/logout").then(function(t3) {
        return Promise.all([t3, e3.uppy.getPlugin(e3.pluginId).storage.removeItem(e3.tokenKey)]);
      }).then(function(e4) {
        return e4[0];
      });
    }, r2.initPlugin = function(e3, t3, n3) {
      if (e3.type = "acquirer", e3.files = [], n3 && (e3.opts = Xe({}, n3, t3)), t3.serverUrl || t3.serverPattern) throw new Error("`serverUrl` and `serverPattern` have been renamed to `companionUrl` and `companionAllowedHosts` respectively in the 0.30.5 release. Please consult the docs (for example, https://uppy.io/docs/instagram/ for the Instagram plugin) and use the updated options.`");
      if (t3.companionAllowedHosts) {
        var r3 = t3.companionAllowedHosts;
        if (!("string" == typeof r3 || Array.isArray(r3) || r3 instanceof RegExp)) throw new TypeError(e3.id + ': the option "companionAllowedHosts" must be one of string, Array, RegExp');
        e3.opts.companionAllowedHosts = r3;
      } else /^(?!https?:\/\/).*$/i.test(t3.companionUrl) ? e3.opts.companionAllowedHosts = "https://" + t3.companionUrl.replace(/^\/\//, "") : e3.opts.companionAllowedHosts = new Ve(t3.companionUrl).origin;
      e3.storage = e3.opts.storage || qe;
    }, r2;
  }(Me);
  function $e(e2, t2) {
    return ($e = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Ke = { RequestClient: Me, Provider: Ye, SearchProvider: function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).provider = n3.provider, r3.id = r3.provider, r3.name = r3.opts.name || r3.id.split("-").map(function(e3) {
        return e3.charAt(0).toUpperCase() + e3.slice(1);
      }).join(" "), r3.pluginId = r3.opts.pluginId, r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, $e(t2, n2);
    var o2 = r2.prototype;
    return o2.fileUrl = function(e3) {
      return this.hostname + "/search/" + this.id + "/get/" + e3;
    }, o2.search = function(e3, t3) {
      return t3 = t3 ? "&" + t3 : "", this.get("search/" + this.id + "/list?q=" + encodeURIComponent(e3) + t3);
    }, r2;
  }(Me), Socket: function() {
    function e2(e3) {
      this.opts = e3, this._queued = [], this.isOpen = false, this.emitter = P(), this._handleMessage = this._handleMessage.bind(this), this.close = this.close.bind(this), this.emit = this.emit.bind(this), this.on = this.on.bind(this), this.once = this.once.bind(this), this.send = this.send.bind(this), e3 && false === e3.autoOpen || this.open();
    }
    var t2 = e2.prototype;
    return t2.open = function() {
      var e3 = this;
      this.socket = new WebSocket(this.opts.target), this.socket.onopen = function(t3) {
        for (e3.isOpen = true; e3._queued.length > 0 && e3.isOpen; ) {
          var n2 = e3._queued[0];
          e3.send(n2.action, n2.payload), e3._queued = e3._queued.slice(1);
        }
      }, this.socket.onclose = function(t3) {
        e3.isOpen = false;
      }, this.socket.onmessage = this._handleMessage;
    }, t2.close = function() {
      this.socket && this.socket.close();
    }, t2.send = function(e3, t3) {
      this.isOpen ? this.socket.send(JSON.stringify({ action: e3, payload: t3 })) : this._queued.push({ action: e3, payload: t3 });
    }, t2.on = function(e3, t3) {
      this.emitter.on(e3, t3);
    }, t2.emit = function(e3, t3) {
      this.emitter.emit(e3, t3);
    }, t2.once = function(e3, t3) {
      this.emitter.once(e3, t3);
    }, t2._handleMessage = function(e3) {
      try {
        var t3 = JSON.parse(e3.data);
        this.emit(t3.action, t3.payload);
      } catch (wd2) {
        console.log(wd2);
      }
    }, e2;
  }() }, Je = { exports: {} };
  function Qe(e2, t2) {
    return (Qe = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    Je.exports = N2;
  }();
  var Ze = (Je = Je.exports).h, et = function(e2) {
    var t2, n2;
    function r2() {
      return e2.apply(this, arguments) || this;
    }
    return n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Qe(t2, n2), r2.prototype.render = function() {
      var e3 = Ze("span", { className: "uppy-Provider-authTitleName" }, this.props.pluginName, Ze("br", null));
      return Ze("div", { className: "uppy-Provider-auth" }, Ze("div", { className: "uppy-Provider-authIcon" }, this.props.pluginIcon()), Ze("div", { className: "uppy-Provider-authTitle" }, this.props.i18nArray("authenticateWithTitle", { pluginName: e3 })), Ze("button", { type: "button", className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn", onClick: this.props.handleAuth, "data-uppy-super-focusable": true }, this.props.i18nArray("authenticateWith", { pluginName: this.props.pluginName })));
    }, r2;
  }(Je.Component), tt = Je.h, nt = Je.h, rt = function(e2) {
    return nt("span", null, nt("button", { type: "button", className: "uppy-u-reset", onClick: e2.getFolder }, e2.title), e2.isLast ? "" : " / ");
  }, ot = function(e2) {
    var t2 = [];
    return e2.showBreadcrumbs && t2.push(function(e3) {
      return nt("div", { className: "uppy-Provider-breadcrumbs" }, nt("div", { className: "uppy-Provider-breadcrumbsIcon" }, e3.breadcrumbsIcon), e3.directories.map(function(t3, n2) {
        return nt(rt, { key: t3.id, getFolder: function() {
          return e3.getFolder(t3.id);
        }, title: 0 === n2 ? e3.title : t3.title, isLast: n2 + 1 === e3.directories.length });
      }));
    }({ getFolder: e2.getFolder, directories: e2.directories, breadcrumbsIcon: e2.pluginIcon && e2.pluginIcon(), title: e2.title })), t2.push(function(e3) {
      return [tt("span", { className: "uppy-ProviderBrowser-user", key: "username" }, e3.username), tt("button", { type: "button", onClick: e3.logout, className: "uppy-u-reset uppy-ProviderBrowser-userLogout", key: "logout" }, e3.i18n("logOut"))];
    }({ logout: e2.logout, username: e2.username, i18n: e2.i18n })), t2;
  }, it = { exports: {} };
  function at(e2, t2) {
    return (at = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  !function() {
    "use strict";
    var e2 = {}.hasOwnProperty;
    function t2() {
      for (var n2 = [], r2 = 0; r2 < arguments.length; r2++) {
        var o2 = arguments[r2];
        if (o2) {
          var i2 = typeof o2;
          if ("string" === i2 || "number" === i2) n2.push(o2);
          else if (Array.isArray(o2)) {
            if (o2.length) {
              var a2 = t2.apply(null, o2);
              a2 && n2.push(a2);
            }
          } else if ("object" === i2) if (o2.toString === Object.prototype.toString) for (var s2 in o2) e2.call(o2, s2) && o2[s2] && n2.push(s2);
          else n2.push(o2.toString());
        }
      }
      return n2.join(" ");
    }
    it.exports ? (t2.default = t2, it.exports = t2) : window.classNames = t2;
  }(), it = it.exports;
  var st = Je.h, lt = function(e2) {
    var t2, n2;
    function r2(t3) {
      var n3;
      return (n3 = e2.call(this, t3) || this).preventEnterPress = n3.preventEnterPress.bind(function(e3) {
        if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e3;
      }(n3)), n3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, at(t2, n2);
    var o2 = r2.prototype;
    return o2.preventEnterPress = function(e3) {
      13 === e3.keyCode && (e3.stopPropagation(), e3.preventDefault());
    }, o2.render = function() {
      var e3 = this;
      return st("div", { className: "uppy-ProviderBrowser-search" }, st("input", { className: "uppy-u-reset uppy-ProviderBrowser-searchInput", type: "text", placeholder: this.props.i18n("filter"), "aria-label": this.props.i18n("filter"), onKeyUp: this.preventEnterPress, onKeyDown: this.preventEnterPress, onKeyPress: this.preventEnterPress, onInput: function(t3) {
        return e3.props.filterQuery(t3);
      }, value: this.props.filterInput }), st("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon uppy-ProviderBrowser-searchIcon", width: "12", height: "12", viewBox: "0 0 12 12" }, st("path", { d: "M8.638 7.99l3.172 3.172a.492.492 0 1 1-.697.697L7.91 8.656a4.977 4.977 0 0 1-2.983.983C2.206 9.639 0 7.481 0 4.819 0 2.158 2.206 0 4.927 0c2.721 0 4.927 2.158 4.927 4.82a4.74 4.74 0 0 1-1.216 3.17zm-3.71.685c2.176 0 3.94-1.726 3.94-3.856 0-2.129-1.764-3.855-3.94-3.855C2.75.964.984 2.69.984 4.819c0 2.13 1.765 3.856 3.942 3.856z" })), this.props.filterInput && st("button", { className: "uppy-u-reset uppy-ProviderBrowser-searchClose", type: "button", "aria-label": this.props.i18n("resetFilter"), title: this.props.i18n("resetFilter"), onClick: this.props.filterQuery }, st("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", viewBox: "0 0 19 19" }, st("path", { d: "M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z" }))));
    }, r2;
  }(Je.Component);
  function ut() {
    return (ut = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var ct = function(e2) {
    return ut({}, e2, { type: e2.mimeType, extension: e2.name ? $(e2.name).extension : null });
  }, pt = Je.h;
  function dt() {
    return pt("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: 11, height: 14.5, viewBox: "0 0 44 58" }, pt("path", { d: "M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z" }));
  }
  function ht() {
    return pt("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", style: { minWidth: 16, marginRight: 3 }, viewBox: "0 0 276.157 276.157" }, pt("path", { d: "M273.08 101.378c-3.3-4.65-8.86-7.32-15.254-7.32h-24.34V67.59c0-10.2-8.3-18.5-18.5-18.5h-85.322c-3.63 0-9.295-2.875-11.436-5.805l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.73c-9.292 0-18.638 6.608-21.737 15.372l-2.033 5.752c-.958 2.71-4.72 5.37-7.596 5.37H18.5C8.3 49.09 0 57.39 0 67.59v167.07c0 .886.16 1.73.443 2.52.152 3.306 1.18 6.424 3.053 9.064 3.3 4.652 8.86 7.32 15.255 7.32h188.487c11.395 0 23.27-8.425 27.035-19.18l40.677-116.188c2.11-6.035 1.43-12.164-1.87-16.816zM18.5 64.088h8.864c9.295 0 18.64-6.607 21.738-15.37l2.032-5.75c.96-2.712 4.722-5.373 7.597-5.373h29.565c3.63 0 9.295 2.876 11.437 5.806l6.386 8.735c4.982 6.815 15.104 11.954 23.546 11.954h85.322c1.898 0 3.5 1.602 3.5 3.5v26.47H69.34c-11.395 0-23.27 8.423-27.035 19.178L15 191.23V67.59c0-1.898 1.603-3.5 3.5-3.5zm242.29 49.15l-40.676 116.188c-1.674 4.78-7.812 9.135-12.877 9.135H18.75c-1.447 0-2.576-.372-3.02-.997-.442-.625-.422-1.814.057-3.18l40.677-116.19c1.674-4.78 7.812-9.134 12.877-9.134h188.487c1.448 0 2.577.372 3.02.997.443.625.423 1.814-.056 3.18z" }));
  }
  function ft() {
    return pt("svg", { "aria-hidden": "true", focusable: "false", style: { width: 16, marginRight: 4 }, viewBox: "0 0 58 58" }, pt("path", { d: "M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z" }), pt("path", { d: "M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z" }));
  }
  var mt = function(e2) {
    if (null !== e2.itemIconString) switch (e2.itemIconString) {
      case "file":
        return pt(dt, null);
      case "folder":
        return pt(ht, null);
      case "video":
        return pt(ft, null);
      default:
        return pt("img", { src: e2.itemIconString });
    }
  }, vt = Je.h, gt = function(e2) {
    return vt("li", { className: e2.className, title: e2.isDisabled ? e2.restrictionReason : null }, vt("div", { "aria-hidden": true, className: "uppy-ProviderBrowserItem-fakeCheckbox " + (e2.isChecked ? "uppy-ProviderBrowserItem-fakeCheckbox--is-checked" : "") }), vt("button", { type: "button", className: "uppy-u-reset uppy-ProviderBrowserItem-inner", onClick: e2.toggleCheckbox, role: "option", "aria-label": e2.isChecked ? e2.i18n("unselectFileNamed", { name: e2.title }) : e2.i18n("selectFileNamed", { name: e2.title }), "aria-selected": e2.isChecked, "aria-disabled": e2.isDisabled, disabled: e2.isDisabled, "data-uppy-super-focusable": true }, e2.itemIconEl, e2.showTitles && e2.title));
  }, yt = Je.h, bt = function(e2) {
    return "folder" === e2.type ? e2.isChecked ? e2.i18n("unselectAllFilesFromFolderNamed", { name: e2.title }) : e2.i18n("selectAllFilesFromFolderNamed", { name: e2.title }) : e2.isChecked ? e2.i18n("unselectFileNamed", { name: e2.title }) : e2.i18n("selectFileNamed", { name: e2.title });
  }, _t = function(e2) {
    return yt("li", { className: e2.className, title: e2.isDisabled ? e2.restrictionReason : null }, e2.isCheckboxDisabled ? null : yt("button", { type: "button", className: "uppy-u-reset uppy-ProviderBrowserItem-fakeCheckbox " + (e2.isChecked ? "uppy-ProviderBrowserItem-fakeCheckbox--is-checked" : ""), onClick: e2.toggleCheckbox, id: e2.id, role: "option", "aria-label": bt(e2), "aria-selected": e2.isChecked, "aria-disabled": e2.isDisabled, disabled: e2.isDisabled, "data-uppy-super-focusable": true }), "file" === e2.type ? yt("label", { htmlFor: e2.id, className: "uppy-u-reset uppy-ProviderBrowserItem-inner" }, yt("div", { className: "uppy-ProviderBrowserItem-iconWrap" }, e2.itemIconEl), e2.showTitles && e2.title) : yt("button", { type: "button", className: "uppy-u-reset uppy-ProviderBrowserItem-inner", onClick: e2.handleFolderClick, "aria-label": e2.i18n("openFolderNamed", { name: e2.title }) }, yt("div", { className: "uppy-ProviderBrowserItem-iconWrap" }, e2.itemIconEl), e2.showTitles && yt("span", null, e2.title)));
  };
  function wt() {
    return (wt = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var Ct = Je.h, St = function(e2) {
    var t2 = e2.getItemIcon(), n2 = it("uppy-ProviderBrowserItem", { "uppy-ProviderBrowserItem--selected": e2.isChecked }, { "uppy-ProviderBrowserItem--disabled": e2.isDisabled }, { "uppy-ProviderBrowserItem--noPreview": "video" === t2 }), r2 = Ct(mt, { itemIconString: t2 });
    switch (e2.viewType) {
      case "grid":
        return Ct(gt, wt({}, e2, { className: n2, itemIconEl: r2 }));
      case "list":
        return Ct(_t, wt({}, e2, { className: n2, itemIconEl: r2 }));
      default:
        throw new Error("There is no such type " + e2.viewType);
    }
  };
  function kt() {
    return (kt = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var xt = Je.h, Pt = function(e2, t2) {
    return { id: e2.id, title: e2.name, getItemIcon: function() {
      return e2.icon;
    }, isChecked: t2.isChecked(e2), toggleCheckbox: function(n2) {
      return t2.toggleCheckbox(n2, e2);
    }, columns: t2.columns, showTitles: t2.showTitles, viewType: t2.viewType, i18n: t2.i18n };
  }, Et = function(e2) {
    var t2 = e2.folders, n2 = e2.files, r2 = e2.handleScroll, o2 = e2.isChecked;
    return t2.length || n2.length ? xt("div", { className: "uppy-ProviderBrowser-body" }, xt("ul", { className: "uppy-ProviderBrowser-list", onScroll: r2, role: "listbox", tabIndex: "-1" }, t2.map(function(t3) {
      return St(kt({}, Pt(t3, e2), { type: "folder", isDisabled: !!o2(t3) && o2(t3).loading, isCheckboxDisabled: "shared-with-me" === t3.id, handleFolderClick: function() {
        return e2.handleFolderClick(t3);
      } }));
    }), n2.map(function(t3) {
      var n3 = e2.validateRestrictions(ct(t3), [].concat(e2.uppyFiles, e2.currentSelection)), r3 = Pt(t3, e2), o3 = n3.reason;
      return St(kt({}, r3, { type: "file", isDisabled: !n3.result && !r3.isChecked, restrictionReason: o3 }));
    }))) : xt("div", { className: "uppy-Provider-empty" }, e2.i18n("noFilesFound"));
  }, Ot = Je.h, At = function(e2) {
    return Ot("div", { className: "uppy-ProviderBrowser-footer" }, Ot("button", { className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary", onClick: e2.done }, e2.i18n("selectX", { smart_count: e2.selected })), Ot("button", { className: "uppy-u-reset uppy-c-btn uppy-c-btn-link", onClick: e2.cancel }, e2.i18n("cancel")));
  };
  function Ut() {
    return (Ut = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var Nt = Je.h, Tt = function(e2) {
    var t2 = e2.currentSelection, n2 = e2.folders, r2 = e2.files, o2 = e2.uppyFiles, i2 = e2.filterItems, a2 = n2, s2 = r2;
    "" !== e2.filterInput && (a2 = i2(n2), s2 = i2(r2));
    var l2 = t2.length;
    return Nt("div", { className: it("uppy-ProviderBrowser", "uppy-ProviderBrowser-viewType--" + e2.viewType) }, Nt("div", { className: "uppy-ProviderBrowser-header" }, Nt("div", { className: it("uppy-ProviderBrowser-headerBar", !e2.showBreadcrumbs && "uppy-ProviderBrowser-headerBar--simple") }, e2.headerComponent)), e2.showFilter && Nt(lt, e2), Nt(Et, { columns: [{ name: "Name", key: "title" }], folders: a2, files: s2, sortByTitle: e2.sortByTitle, sortByDate: e2.sortByDate, isChecked: e2.isChecked, handleFolderClick: e2.getNextFolder, toggleCheckbox: e2.toggleCheckbox, handleScroll: e2.handleScroll, title: e2.title, showTitles: e2.showTitles, i18n: e2.i18n, viewType: e2.viewType, validateRestrictions: e2.validateRestrictions, uppyFiles: o2, currentSelection: t2 }), l2 > 0 && Nt(At, Ut({ selected: l2 }, e2)));
  }, Rt = Je.h, Ft = function(e2) {
    return Rt("div", { className: "uppy-Provider-loading" }, Rt("span", null, e2.i18n("loading")));
  }, Dt = function(e2) {
    if (!e2) return false;
    var t2 = e2.split("/")[1];
    return !!/^(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(t2);
  }, Mt = function() {
    function e2(e3) {
      this.plugin = e3, this.filterItems = this.filterItems.bind(this), this.toggleCheckbox = this.toggleCheckbox.bind(this), this.isChecked = this.isChecked.bind(this), this.loaderWrapper = this.loaderWrapper.bind(this);
    }
    var t2 = e2.prototype;
    return t2.filterItems = function(e3) {
      var t3 = this.plugin.getPluginState();
      return t3.filterInput && "" !== t3.filterInput ? e3.filter(function(e4) {
        return -1 !== e4.name.toLowerCase().indexOf(t3.filterInput.toLowerCase());
      }) : e3;
    }, t2.toggleCheckbox = function(e3, t3) {
      var n2 = this;
      e3.stopPropagation(), e3.preventDefault(), e3.currentTarget.focus();
      var r2 = this.plugin.getPluginState(), o2 = r2.folders, i2 = r2.files, a2 = this.filterItems(o2.concat(i2));
      if (this.lastCheckbox && e3.shiftKey) {
        var s2, l2 = a2.indexOf(this.lastCheckbox), u2 = a2.indexOf(t3);
        return s2 = (s2 = l2 < u2 ? a2.slice(l2, u2 + 1) : a2.slice(u2, l2 + 1)).reduce(function(e4, t4) {
          var r3 = n2.plugin.uppy, o3 = r3.validateRestrictions(ct(t4), [].concat(r3.getFiles(), e4));
          return o3.result ? [].concat(e4, [t4]) : (r3.info({ message: o3.reason }, "error", r3.opts.infoTimeout), e4);
        }), void this.plugin.setPluginState({ currentSelection: s2 });
      }
      this.lastCheckbox = t3;
      var c2 = this.plugin.getPluginState().currentSelection;
      this.isChecked(t3) ? this.plugin.setPluginState({ currentSelection: c2.filter(function(e4) {
        return e4.id !== t3.id;
      }) }) : this.plugin.setPluginState({ currentSelection: c2.concat([t3]) });
    }, t2.isChecked = function(e3) {
      return this.plugin.getPluginState().currentSelection.some(function(t3) {
        return t3.id === e3.id;
      });
    }, t2.loaderWrapper = function(e3, t3, n2) {
      var r2 = this;
      e3.then(function(e4) {
        r2.plugin.setPluginState({ loading: false }), t3(e4);
      }).catch(function(e4) {
        r2.plugin.setPluginState({ loading: false }), n2(e4);
      }), this.plugin.setPluginState({ loading: true });
    }, e2;
  }();
  function Bt(e2, t2) {
    return (Bt = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var It, Lt, jt = function(e2) {
    var t2, n2;
    function r2() {
      return e2.apply(this, arguments) || this;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Bt(t2, n2);
    var o2 = r2.prototype;
    return o2.componentWillUnmount = function() {
      this.props.onUnmount();
    }, o2.render = function() {
      return this.props.children[0];
    }, r2;
  }(Je.Component), zt = "1.12.3";
  function Ht() {
    return (Ht = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var Wt, Vt, qt = Je.h, Xt = (Lt = It = function() {
    function e2(e3, t3) {
      this.plugin = e3, this.provider = t3.provider, this._sharedHandler = new Mt(e3), this.opts = Ht({}, { viewType: "list", showTitles: true, showFilter: true, showBreadcrumbs: true }, t3), this.addFile = this.addFile.bind(this), this.filterQuery = this.filterQuery.bind(this), this.getFolder = this.getFolder.bind(this), this.getNextFolder = this.getNextFolder.bind(this), this.logout = this.logout.bind(this), this.preFirstRender = this.preFirstRender.bind(this), this.handleAuth = this.handleAuth.bind(this), this.sortByTitle = this.sortByTitle.bind(this), this.sortByDate = this.sortByDate.bind(this), this.handleError = this.handleError.bind(this), this.handleScroll = this.handleScroll.bind(this), this.listAllFiles = this.listAllFiles.bind(this), this.donePicking = this.donePicking.bind(this), this.cancelPicking = this.cancelPicking.bind(this), this.clearSelection = this.clearSelection.bind(this), this.render = this.render.bind(this), this.clearSelection(), this.plugin.setPluginState({ authenticated: false, files: [], folders: [], directories: [], filterInput: "", isSearchVisible: false });
    }
    var t2 = e2.prototype;
    return t2.tearDown = function() {
    }, t2._updateFilesAndFolders = function(e3, t3, n2) {
      this.nextPagePath = e3.nextPagePath, e3.items.forEach(function(e4) {
        e4.isFolder ? n2.push(e4) : t3.push(e4);
      }), this.plugin.setPluginState({ folders: n2, files: t3 });
    }, t2.preFirstRender = function() {
      this.plugin.setPluginState({ didFirstRender: true }), this.plugin.onFirstRender();
    }, t2.getFolder = function(e3, t3) {
      var n2 = this;
      return this._sharedHandler.loaderWrapper(this.provider.list(e3), function(r2) {
        var o2, i2 = n2.plugin.getPluginState(), a2 = ee(i2.directories, function(t4) {
          return e3 === t4.id;
        });
        o2 = -1 !== a2 ? i2.directories.slice(0, a2 + 1) : i2.directories.concat([{ id: e3, title: t3 }]), n2.username = r2.username || n2.username, n2._updateFilesAndFolders(r2, [], []), n2.plugin.setPluginState({ directories: o2 });
      }, this.handleError);
    }, t2.getNextFolder = function(e3) {
      this.getFolder(e3.requestPath, e3.name), this.lastCheckbox = void 0;
    }, t2.addFile = function(e3) {
      var t3 = { id: this.providerFileToId(e3), source: this.plugin.id, data: e3, name: e3.name || e3.id, type: e3.mimeType, isRemote: true, body: { fileId: e3.id }, remote: { companionUrl: this.plugin.opts.companionUrl, url: "" + this.provider.fileUrl(e3.requestPath), body: { fileId: e3.id }, providerOptions: this.provider.opts } }, n2 = J(t3);
      n2 && Dt(n2) && (t3.preview = e3.thumbnail), this.plugin.uppy.log("Adding remote file");
      try {
        return this.plugin.uppy.addFile(t3), true;
      } catch (wd2) {
        return wd2.isRestriction || this.plugin.uppy.log(wd2), false;
      }
    }, t2.logout = function() {
      var e3 = this;
      this.provider.logout().then(function(t3) {
        if (t3.ok) {
          if (!t3.revoked) {
            var n2 = e3.plugin.uppy.i18n("companionUnauthorizeHint", { provider: e3.plugin.title, url: t3.manual_revoke_url });
            e3.plugin.uppy.info(n2, "info", 7e3);
          }
          e3.plugin.setPluginState({ authenticated: false, files: [], folders: [], directories: [] });
        }
      }).catch(this.handleError);
    }, t2.filterQuery = function(e3) {
      var t3 = this.plugin.getPluginState();
      this.plugin.setPluginState(Ht({}, t3, { filterInput: e3 ? e3.target.value : "" }));
    }, t2.sortByTitle = function() {
      var e3 = Ht({}, this.plugin.getPluginState()), t3 = e3.files, n2 = e3.folders, r2 = e3.sorting, o2 = t3.sort(function(e4, t4) {
        return "titleDescending" === r2 ? t4.name.localeCompare(e4.name) : e4.name.localeCompare(t4.name);
      }), i2 = n2.sort(function(e4, t4) {
        return "titleDescending" === r2 ? t4.name.localeCompare(e4.name) : e4.name.localeCompare(t4.name);
      });
      this.plugin.setPluginState(Ht({}, e3, { files: o2, folders: i2, sorting: "titleDescending" === r2 ? "titleAscending" : "titleDescending" }));
    }, t2.sortByDate = function() {
      var e3 = Ht({}, this.plugin.getPluginState()), t3 = e3.files, n2 = e3.folders, r2 = e3.sorting, o2 = t3.sort(function(e4, t4) {
        var n3 = new Date(e4.modifiedDate), o3 = new Date(t4.modifiedDate);
        return "dateDescending" === r2 ? n3 > o3 ? -1 : n3 < o3 ? 1 : 0 : n3 > o3 ? 1 : n3 < o3 ? -1 : 0;
      }), i2 = n2.sort(function(e4, t4) {
        var n3 = new Date(e4.modifiedDate), o3 = new Date(t4.modifiedDate);
        return "dateDescending" === r2 ? n3 > o3 ? -1 : n3 < o3 ? 1 : 0 : n3 > o3 ? 1 : n3 < o3 ? -1 : 0;
      });
      this.plugin.setPluginState(Ht({}, e3, { files: o2, folders: i2, sorting: "dateDescending" === r2 ? "dateAscending" : "dateDescending" }));
    }, t2.sortBySize = function() {
      var e3 = Ht({}, this.plugin.getPluginState()), t3 = e3.files, n2 = e3.sorting;
      if (t3.length && this.plugin.getItemData(t3[0]).size) {
        var r2 = t3.sort(function(e4, t4) {
          var r3 = e4.size, o2 = t4.size;
          return "sizeDescending" === n2 ? r3 > o2 ? -1 : r3 < o2 ? 1 : 0 : r3 > o2 ? 1 : r3 < o2 ? -1 : 0;
        });
        this.plugin.setPluginState(Ht({}, e3, { files: r2, sorting: "sizeDescending" === n2 ? "sizeAscending" : "sizeDescending" }));
      }
    }, t2.addFolder = function(e3) {
      var t3 = this, n2 = this.providerFileToId(e3), r2 = Ht({}, this.plugin.getPluginState().selectedFolders);
      if (!(n2 in r2) || !r2[n2].loading) return r2[n2] = { loading: true, files: [] }, this.plugin.setPluginState({ selectedFolders: Ht({}, r2) }), this.listAllFiles(e3.requestPath).then(function(o2) {
        var i2 = 0;
        o2.forEach(function(e4) {
          t3.addFile(e4) && i2++;
        });
        var a2, s2 = o2.map(t3.providerFileToId);
        r2[n2] = { loading: false, files: s2 }, t3.plugin.setPluginState({ selectedFolders: r2 }), a2 = o2.length ? t3.plugin.uppy.i18n("folderAdded", { smart_count: i2, folder: e3.name }) : t3.plugin.uppy.i18n("emptyFolderAdded"), t3.plugin.uppy.info(a2);
      }).catch(function(e4) {
        var r3 = Ht({}, t3.plugin.getPluginState().selectedFolders);
        delete r3[n2], t3.plugin.setPluginState({ selectedFolders: r3 }), t3.handleError(e4);
      });
    }, t2.providerFileToId = function(e3) {
      return Z({ data: e3, name: e3.name || e3.id, type: e3.mimeType });
    }, t2.handleAuth = function() {
      var t3 = this, n2 = btoa(JSON.stringify({ origin: "origin" in location ? location.origin : location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") })), r2 = "@uppy/provider-views=" + e2.VERSION, o2 = this.provider.authUrl({ state: n2, uppyVersions: r2 }), i2 = window.open(o2, "_blank");
      window.addEventListener("message", function e3(n3) {
        if (t3._isOriginAllowed(n3.origin, t3.plugin.opts.companionAllowedHosts) && n3.source === i2) {
          var r3 = "string" == typeof n3.data ? JSON.parse(n3.data) : n3.data;
          r3.token ? (i2.close(), window.removeEventListener("message", e3), t3.provider.setAuthToken(r3.token), t3.preFirstRender()) : t3.plugin.uppy.log("did not receive token from auth window");
        } else t3.plugin.uppy.log("rejecting event from " + n3.origin + " vs allowed pattern " + t3.plugin.opts.companionAllowedHosts);
      });
    }, t2._isOriginAllowed = function(e3, t3) {
      var n2 = function(e4) {
        return "string" == typeof e4 ? new RegExp("^" + e4 + "$") : e4 instanceof RegExp ? e4 : void 0;
      };
      return (Array.isArray(t3) ? t3.map(n2) : [n2(t3)]).filter(function(e4) {
        return null != e4;
      }).some(function(t4) {
        return t4.test(e3) || t4.test(e3 + "/");
      });
    }, t2.handleError = function(e3) {
      var t3 = this.plugin.uppy;
      if (t3.log(e3.toString()), !e3.isAuthError) {
        var n2 = t3.i18n("companionError");
        t3.info({ message: n2, details: e3.toString() }, "error", 5e3);
      }
    }, t2.handleScroll = function(e3) {
      var t3 = this, n2 = e3.target.scrollHeight - (e3.target.scrollTop + e3.target.offsetHeight), r2 = this.nextPagePath || null;
      n2 < 50 && r2 && !this._isHandlingScroll && (this.provider.list(r2).then(function(e4) {
        var n3 = t3.plugin.getPluginState(), r3 = n3.files, o2 = n3.folders;
        t3._updateFilesAndFolders(e4, r3, o2);
      }).catch(this.handleError).then(function() {
        t3._isHandlingScroll = false;
      }), this._isHandlingScroll = true);
    }, t2.listAllFiles = function(e3, t3) {
      var n2 = this;
      return void 0 === t3 && (t3 = null), t3 = t3 || [], new Promise(function(r2, o2) {
        n2.provider.list(e3).then(function(e4) {
          e4.items.forEach(function(e5) {
            e5.isFolder ? n2.addFolder(e5) : t3.push(e5);
          });
          var i2 = e4.nextPagePath || null;
          return i2 ? n2.listAllFiles(i2, t3).then(function(e5) {
            return r2(e5);
          }).catch(function(e5) {
            return o2(e5);
          }) : r2(t3);
        }).catch(function(e4) {
          return o2(e4);
        });
      });
    }, t2.donePicking = function() {
      var e3 = this, t3 = this.plugin.getPluginState().currentSelection.map(function(t4) {
        return t4.isFolder ? e3.addFolder(t4) : e3.addFile(t4);
      });
      this._sharedHandler.loaderWrapper(Promise.all(t3), function() {
        e3.clearSelection();
      }, function() {
      });
    }, t2.cancelPicking = function() {
      this.clearSelection();
      var e3 = this.plugin.uppy.getPlugin("Dashboard");
      e3 && e3.hideAllPanels();
    }, t2.clearSelection = function() {
      this.plugin.setPluginState({ currentSelection: [] });
    }, t2.render = function(e3, t3) {
      void 0 === t3 && (t3 = {});
      var n2 = this.plugin.getPluginState(), r2 = n2.authenticated;
      if (n2.didFirstRender || this.preFirstRender(), this.plugin.getPluginState().loading) return qt(jt, { onUnmount: this.clearSelection }, qt(Ft, { i18n: this.plugin.uppy.i18n }));
      if (!r2) return qt(jt, { onUnmount: this.clearSelection }, qt(et, { pluginName: this.plugin.title, pluginIcon: this.plugin.icon, handleAuth: this.handleAuth, i18n: this.plugin.uppy.i18n, i18nArray: this.plugin.uppy.i18nArray }));
      var o2 = Ht({}, this.opts, t3), i2 = { showBreadcrumbs: o2.showBreadcrumbs, getFolder: this.getFolder, directories: this.plugin.getPluginState().directories, pluginIcon: this.plugin.icon, title: this.plugin.title, logout: this.logout, username: this.username, i18n: this.plugin.uppy.i18n }, a2 = Ht({}, this.plugin.getPluginState(), { username: this.username, getNextFolder: this.getNextFolder, getFolder: this.getFolder, filterItems: this._sharedHandler.filterItems, filterQuery: this.filterQuery, sortByTitle: this.sortByTitle, sortByDate: this.sortByDate, logout: this.logout, isChecked: this._sharedHandler.isChecked, toggleCheckbox: this._sharedHandler.toggleCheckbox, handleScroll: this.handleScroll, listAllFiles: this.listAllFiles, done: this.donePicking, cancel: this.cancelPicking, headerComponent: ot(i2), title: this.plugin.title, viewType: o2.viewType, showTitles: o2.showTitles, showFilter: o2.showFilter, showBreadcrumbs: o2.showBreadcrumbs, pluginIcon: this.plugin.icon, i18n: this.plugin.uppy.i18n, uppyFiles: this.plugin.uppy.getFiles(), validateRestrictions: this.plugin.uppy.validateRestrictions });
      return qt(jt, { onUnmount: this.clearSelection }, qt(Tt, a2));
    }, e2;
  }(), It.VERSION = zt, Lt), Gt = Je.h, Yt = function(e2) {
    var t2, n2 = function() {
      t2.value && e2.search(t2.value);
    };
    return Gt("div", { className: "uppy-SearchProvider" }, Gt("input", { className: "uppy-u-reset uppy-c-textInput uppy-SearchProvider-input", type: "text", "aria-label": e2.i18n("enterTextToSearch"), placeholder: e2.i18n("enterTextToSearch"), onKeyUp: function(e3) {
      13 === e3.keyCode && n2();
    }, ref: function(e3) {
      t2 = e3;
    }, "data-uppy-super-focusable": true }), Gt("button", { className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-SearchProvider-searchButton", type: "button", onClick: n2 }, e2.i18n("searchImages")));
  }, $t = Je.h;
  function Kt() {
    return (Kt = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var Jt, Qt = Je.h, Zt = { ProviderViews: Xt, SearchProviderViews: (Vt = Wt = function() {
    function e2(e3, t3) {
      this.plugin = e3, this.provider = t3.provider, this._sharedHandler = new Mt(e3), this.opts = Kt({}, { viewType: "grid", showTitles: false, showFilter: false, showBreadcrumbs: false }, t3), this.search = this.search.bind(this), this.triggerSearchInput = this.triggerSearchInput.bind(this), this.addFile = this.addFile.bind(this), this.preFirstRender = this.preFirstRender.bind(this), this.handleError = this.handleError.bind(this), this.handleScroll = this.handleScroll.bind(this), this.donePicking = this.donePicking.bind(this), this.cancelPicking = this.cancelPicking.bind(this), this.clearSelection = this.clearSelection.bind(this), this.render = this.render.bind(this), this.clearSelection(), this.plugin.setPluginState({ isInputMode: true, files: [], folders: [], directories: [], filterInput: "", isSearchVisible: false });
    }
    var t2 = e2.prototype;
    return t2.tearDown = function() {
    }, t2._updateFilesAndInputMode = function(e3, t3) {
      this.nextPageQuery = e3.nextPageQuery, this._searchTerm = e3.searchedFor, e3.items.forEach(function(e4) {
        t3.push(e4);
      }), this.plugin.setPluginState({ isInputMode: false, files: t3 });
    }, t2.preFirstRender = function() {
      this.plugin.setPluginState({ didFirstRender: true }), this.plugin.onFirstRender();
    }, t2.search = function(e3) {
      var t3 = this;
      if (!e3 || e3 !== this._searchTerm) return this._sharedHandler.loaderWrapper(this.provider.search(e3), function(e4) {
        t3._updateFilesAndInputMode(e4, []);
      }, this.handleError);
      this.plugin.setPluginState({ isInputMode: false });
    }, t2.triggerSearchInput = function() {
      this.plugin.setPluginState({ isInputMode: true });
    }, t2.addFile = function(e3) {
      var t3 = { id: this.providerFileToId(e3), source: this.plugin.id, data: e3, name: e3.name || e3.id, type: e3.mimeType, isRemote: true, body: { fileId: e3.id }, remote: { companionUrl: this.plugin.opts.companionUrl, url: "" + this.provider.fileUrl(e3.requestPath), body: { fileId: e3.id }, providerOptions: Kt({}, this.provider.opts, { provider: null }) } }, n2 = J(t3);
      n2 && Dt(n2) && (t3.preview = e3.thumbnail), this.plugin.uppy.log("Adding remote file");
      try {
        this.plugin.uppy.addFile(t3);
      } catch (wd2) {
        wd2.isRestriction || this.plugin.uppy.log(wd2);
      }
    }, t2.providerFileToId = function(e3) {
      return Z({ data: e3, name: e3.name || e3.id, type: e3.mimeType });
    }, t2.handleError = function(e3) {
      var t3 = this.plugin.uppy;
      t3.log(e3.toString());
      var n2 = t3.i18n("companionError");
      t3.info({ message: n2, details: e3.toString() }, "error", 5e3);
    }, t2.handleScroll = function(e3) {
      var t3 = this, n2 = e3.target.scrollHeight - (e3.target.scrollTop + e3.target.offsetHeight), r2 = this.nextPageQuery || null;
      n2 < 50 && r2 && !this._isHandlingScroll && (this.provider.search(this._searchTerm, r2).then(function(e4) {
        var n3 = t3.plugin.getPluginState().files;
        t3._updateFilesAndInputMode(e4, n3);
      }).catch(this.handleError).then(function() {
        t3._isHandlingScroll = false;
      }), this._isHandlingScroll = true);
    }, t2.donePicking = function() {
      var e3 = this, t3 = this.plugin.getPluginState().currentSelection.map(function(t4) {
        return e3.addFile(t4);
      });
      this._sharedHandler.loaderWrapper(Promise.all(t3), function() {
        e3.clearSelection();
      }, function() {
      });
    }, t2.cancelPicking = function() {
      this.clearSelection();
      var e3 = this.plugin.uppy.getPlugin("Dashboard");
      e3 && e3.hideAllPanels();
    }, t2.clearSelection = function() {
      this.plugin.setPluginState({ currentSelection: [] });
    }, t2.render = function(e3, t3) {
      void 0 === t3 && (t3 = {});
      var n2 = this.plugin.getPluginState(), r2 = n2.didFirstRender, o2 = n2.isInputMode;
      if (r2 || this.preFirstRender(), this.plugin.getPluginState().loading) return Qt(jt, { onUnmount: this.clearSelection }, Qt(Ft, { i18n: this.plugin.uppy.i18n }));
      if (o2) return Qt(jt, { onUnmount: this.clearSelection }, Qt(Yt, { search: this.search, i18n: this.plugin.uppy.i18n }));
      var i2, a2 = Kt({}, this.opts, t3), s2 = Kt({}, this.plugin.getPluginState(), { isChecked: this._sharedHandler.isChecked, toggleCheckbox: this._sharedHandler.toggleCheckbox, handleScroll: this.handleScroll, done: this.donePicking, cancel: this.cancelPicking, headerComponent: (i2 = { triggerSearchInput: this.triggerSearchInput, i18n: this.plugin.uppy.i18n }, $t("button", { type: "button", onClick: i2.triggerSearchInput, className: "uppy-u-reset uppy-ProviderBrowser-userLogout" }, i2.i18n("backToSearch"))), title: this.plugin.title, viewType: a2.viewType, showTitles: a2.showTitles, showFilter: a2.showFilter, showBreadcrumbs: a2.showBreadcrumbs, pluginIcon: this.plugin.icon, i18n: this.plugin.uppy.i18n, uppyFiles: this.plugin.uppy.getFiles(), validateRestrictions: this.plugin.uppy.validateRestrictions });
      return Qt(jt, { onUnmount: this.clearSelection }, Qt(Tt, s2));
    }, e2;
  }(), Wt.VERSION = zt, Vt) };
  function en() {
    return (en = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var tn = function() {
    function e2(e3) {
      var t3;
      this._store = e3.store, this._id = e3.id || D(), this._selector = e3.selector || (t3 = this._id, function(e4) {
        return e4.uppy[t3];
      }), this.setState({});
    }
    var t2 = e2.prototype;
    return t2.setState = function(e3) {
      this._store.dispatch({ type: "uppy/STATE_UPDATE", id: this._id, payload: e3 });
    }, t2.getState = function() {
      return this._selector(this._store.getState());
    }, t2.subscribe = function(e3) {
      var t3 = this, n2 = this.getState();
      return this._store.subscribe(function() {
        var r2 = t3.getState();
        if (n2 !== r2) {
          var o2 = function(e4, t4) {
            var n3 = Object.keys(t4), r3 = {};
            return n3.forEach(function(n4) {
              e4[n4] !== t4[n4] && (r3[n4] = t4[n4]);
            }), r3;
          }(n2, r2);
          e3(n2, r2, o2), n2 = r2;
        }
      });
    }, e2;
  }();
  tn.VERSION = "1.2.8", (Jt = function(e2) {
    return new tn(e2);
  }).STATE_UPDATE = "uppy/STATE_UPDATE", Jt.reducer = function(e2, t2) {
    if (void 0 === e2 && (e2 = {}), "uppy/STATE_UPDATE" === t2.type) {
      var n2, r2 = en({}, e2[t2.id], t2.payload);
      return en({}, e2, ((n2 = {})[t2.id] = r2, n2));
    }
    return e2;
  }, Jt.middleware = function() {
    return function() {
      return function(e2) {
        return function(t2) {
          e2(t2);
        };
      };
    };
  };
  var nn = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    nn.exports = N2;
  }(), nn = nn.exports;
  var rn = nn.h, on = function(e2) {
    var t2 = { color: "#838999", icon: rn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "25", height: "25", viewBox: "0 0 25 25" }, rn("g", { fill: "#A7AFB7", fillRule: "nonzero" }, rn("path", { d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z" }), rn("path", { d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z" }))) };
    if (!e2) return t2;
    var n2 = e2.split("/")[0], r2 = e2.split("/")[1];
    return "text" === n2 ? { color: "#5a5e69", icon: rn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "25", height: "25", viewBox: "0 0 25 25" }, rn("path", { d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z", fill: "#5A5E69", fillRule: "nonzero" })) } : "image" === n2 ? { color: "#686de0", icon: rn("svg", { "aria-hidden": "true", focusable: "false", width: "25", height: "25", viewBox: "0 0 25 25" }, rn("g", { fill: "#686DE0", fillRule: "evenodd" }, rn("path", { d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z", fillRule: "nonzero" }), rn("path", { d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z", fillRule: "nonzero" }), rn("circle", { cx: "7.5", cy: "9.5", r: "1.5" }))) } : "audio" === n2 ? { color: "#068dbb", icon: rn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "25", height: "25", viewBox: "0 0 25 25" }, rn("path", { d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z", fill: "#049BCF", fillRule: "nonzero" })) } : "video" === n2 ? { color: "#19af67", icon: rn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "25", height: "25", viewBox: "0 0 25 25" }, rn("path", { d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z", fill: "#19AF67", fillRule: "nonzero" })) } : "application" === n2 && "pdf" === r2 ? { color: "#e25149", icon: rn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "25", height: "25", viewBox: "0 0 25 25" }, rn("path", { d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z", fill: "#E2514A", fillRule: "nonzero" })) } : "application" === n2 && -1 !== ["zip", "x-7z-compressed", "x-rar-compressed", "x-tar", "x-gzip", "x-apple-diskimage"].indexOf(r2) ? { color: "#00C469", icon: rn("svg", { "aria-hidden": "true", focusable: "false", width: "25", height: "25", viewBox: "0 0 25 25" }, rn("path", { d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z", fill: "#00C469", fillRule: "nonzero" })) } : t2;
  }, an = nn.h, sn = function(e2) {
    var t2 = e2.file;
    if (t2.preview) return an("img", { className: "uppy-Dashboard-Item-previewImg", alt: t2.name, src: t2.preview });
    var n2 = on(t2.type), r2 = n2.color, o2 = n2.icon;
    return an("div", { className: "uppy-Dashboard-Item-previewIconWrap" }, an("span", { className: "uppy-Dashboard-Item-previewIcon", style: { color: r2 } }, o2), an("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-Dashboard-Item-previewIconBg", width: "58", height: "76", viewBox: "0 0 58 76" }, an("rect", { fill: "#FFF", width: "58", height: "76", rx: "3", fillRule: "evenodd" })));
  }, ln = nn.h, un = function(e2) {
    return ln("div", { className: "uppy-Dashboard-Item-previewInnerWrap", style: { backgroundColor: on(e2.file.type).color } }, e2.showLinkToFileUploadResult && e2.file.uploadURL && ln("a", { className: "uppy-Dashboard-Item-previewLink", href: e2.file.uploadURL, rel: "noreferrer noopener", target: "_blank", "aria-label": e2.file.meta.name }), ln(sn, { file: e2.file }));
  }, cn = nn.h;
  function pn(e2) {
    return e2.isUploaded ? e2.i18n("uploadComplete") : e2.error ? e2.i18n("retryUpload") : e2.resumableUploads ? e2.file.isPaused ? e2.i18n("resumeUpload") : e2.i18n("pauseUpload") : e2.individualCancellation ? e2.i18n("cancelUpload") : "";
  }
  function dn(e2) {
    return cn("div", { className: "uppy-Dashboard-Item-progress" }, cn("button", { className: "uppy-u-reset uppy-Dashboard-Item-progressIndicator", type: "button", "aria-label": pn(e2), title: pn(e2), onClick: function() {
      return function(e3) {
        e3.isUploaded || (!e3.error || e3.hideRetryButton ? e3.resumableUploads && !e3.hidePauseResumeButton ? e3.pauseUpload(e3.file.id) : e3.individualCancellation && !e3.hideCancelButton && e3.cancelUpload(e3.file.id) : e3.retryUpload(e3.file.id));
      }(e2);
    } }, e2.children));
  }
  function hn(e2) {
    var t2 = e2.children;
    return cn("svg", { "aria-hidden": "true", focusable: "false", width: "70", height: "70", viewBox: "0 0 36 36", className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle" }, t2);
  }
  function fn(e2) {
    var t2 = e2.progress, n2 = 2 * Math.PI * 15;
    return cn("g", null, cn("circle", { className: "uppy-Dashboard-Item-progressIcon--bg", r: "15", cx: "18", cy: "18", "stroke-width": "2", fill: "none" }), cn("circle", { className: "uppy-Dashboard-Item-progressIcon--progress", r: "15", cx: "18", cy: "18", transform: "rotate(-90, 18, 18)", fill: "none", "stroke-width": "2", "stroke-dasharray": n2, "stroke-dashoffset": n2 - n2 / 100 * t2 }));
  }
  var mn = function(e2) {
    return e2.file.progress.uploadStarted ? e2.isUploaded ? cn("div", { className: "uppy-Dashboard-Item-progress" }, cn("div", { className: "uppy-Dashboard-Item-progressIndicator" }, cn(hn, null, cn("circle", { r: "15", cx: "18", cy: "18", fill: "#1bb240" }), cn("polygon", { className: "uppy-Dashboard-Item-progressIcon--check", transform: "translate(2, 3)", points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634" })))) : e2.recoveredState ? void 0 : e2.error && !e2.hideRetryButton ? cn(dn, e2, cn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry", width: "28", height: "31", viewBox: "0 0 16 19" }, cn("path", { d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z" }), cn("path", { d: "M7.9 3H10v2H7.9z" }), cn("path", { d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z" }), cn("path", { d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z" }))) : e2.resumableUploads && !e2.hidePauseResumeButton ? cn(dn, e2, cn(hn, null, cn(fn, { progress: e2.file.progress.percentage }), e2.file.isPaused ? cn("polygon", { className: "uppy-Dashboard-Item-progressIcon--play", transform: "translate(3, 3)", points: "12 20 12 10 20 15" }) : cn("g", { className: "uppy-Dashboard-Item-progressIcon--pause", transform: "translate(14.5, 13)" }, cn("rect", { x: "0", y: "0", width: "2", height: "10", rx: "0" }), cn("rect", { x: "5", y: "0", width: "2", height: "10", rx: "0" })))) : e2.resumableUploads || !e2.individualCancellation || e2.hideCancelButton ? cn("div", { className: "uppy-Dashboard-Item-progress" }, cn("div", { className: "uppy-Dashboard-Item-progressIndicator" }, cn(hn, null, cn(fn, { progress: e2.file.progress.percentage })))) : cn(dn, e2, cn(hn, null, cn(fn, { progress: e2.file.progress.percentage }), cn("polygon", { className: "cancel", transform: "translate(2, 2)", points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12" }))) : null;
  }, vn = nn.h, gn = function(e2) {
    var t2 = e2.file, n2 = e2.onClick;
    return t2.error ? vn("span", { className: "uppy-Dashboard-Item-errorDetails", "aria-label": t2.error, "data-microtip-position": "bottom", "data-microtip-size": "medium", role: "tooltip", onClick: n2 }, "?") : null;
  }, yn = function(e2) {
    return vn("div", { className: "uppy-Dashboard-Item-fileInfo", "data-uppy-file-source": e2.file.source }, function(e3) {
      var t2;
      return t2 = e3.containerWidth <= 352 ? 35 : e3.containerWidth <= 576 ? 60 : 30, vn("div", { className: "uppy-Dashboard-Item-name", title: e3.file.meta.name }, function(e4, t3) {
        if (e4.length <= t3) return e4;
        if (t3 <= "...".length) return e4.substr(0, t3);
        var n2 = t3 - "...".length, r2 = Math.ceil(n2 / 2), o2 = Math.floor(n2 / 2);
        return e4.substr(0, r2) + "..." + e4.substr(e4.length - o2);
      }(e3.file.meta.name, t2));
    }(e2), vn("div", { className: "uppy-Dashboard-Item-status" }, function(e3) {
      return e3.file.size && vn("div", { className: "uppy-Dashboard-Item-statusSize" }, W(e3.file.size));
    }(e2), function(e3) {
      return e3.file.isGhost && vn("span", null, " \u2022 ", vn("button", { className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect", type: "button", onClick: e3.toggleAddFilesPanel }, e3.i18n("reSelect")));
    }(e2), vn(gn, { file: e2.file, onClick: function() {
      alert(e2.file.error);
    } })));
  }, bn = nn.h;
  function _n(e2) {
    var t2 = e2.file, n2 = e2.uploadInProgressOrComplete, r2 = e2.metaFields, o2 = e2.canEditFile, i2 = e2.i18n, a2 = e2.onClick;
    return !n2 && r2 && r2.length > 0 || !n2 && o2(t2) ? bn("button", { className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit", type: "button", "aria-label": i2("editFile") + " " + t2.meta.name, title: i2("editFile"), onClick: function() {
      return a2();
    } }, bn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "14", height: "14", viewBox: "0 0 14 14" }, bn("g", { fillRule: "evenodd" }, bn("path", { d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z", fillRule: "nonzero" }), bn("rect", { x: "1", y: "12.293", width: "11", height: "1", rx: ".5" }), bn("path", { fillRule: "nonzero", d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z" })))) : null;
  }
  function wn(e2) {
    var t2 = e2.i18n, n2 = e2.onClick;
    return bn("button", { className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove", type: "button", "aria-label": t2("removeFile"), title: t2("removeFile"), onClick: function() {
      return n2();
    } }, bn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "18", height: "18", viewBox: "0 0 18 18" }, bn("path", { d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z" }), bn("path", { fill: "#FFF", d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z" })));
  }
  var Cn = function(e2, t2) {
    var n2, r2;
    (n2 = t2.file.uploadURL, r2 = t2.i18n("copyLinkToClipboardFallback"), r2 = r2 || "Copy the URL below", new Promise(function(e3) {
      var t3 = document.createElement("textarea");
      t3.setAttribute("style", { position: "fixed", top: 0, left: 0, width: "2em", height: "2em", padding: 0, border: "none", outline: "none", boxShadow: "none", background: "transparent" }), t3.value = n2, document.body.appendChild(t3), t3.select();
      var o2 = function() {
        document.body.removeChild(t3), window.prompt(r2, n2), e3();
      };
      try {
        return document.execCommand("copy") ? (document.body.removeChild(t3), e3()) : o2();
      } catch (wd2) {
        return document.body.removeChild(t3), o2();
      }
    })).then(function() {
      t2.log("Link copied to clipboard."), t2.info(t2.i18n("copyLinkToClipboardSuccess"), "info", 3e3);
    }).catch(t2.log).then(function() {
      return e2.target.focus({ preventScroll: true });
    });
  };
  function Sn(e2) {
    return bn("button", { className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink", type: "button", "aria-label": e2.i18n("copyLink"), title: e2.i18n("copyLink"), onClick: function(t2) {
      return Cn(t2, e2);
    } }, bn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "14", height: "14", viewBox: "0 0 14 12" }, bn("path", { d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z" })));
  }
  var kn = function(e2) {
    var t2 = e2.file, n2 = e2.uploadInProgressOrComplete, r2 = e2.canEditFile, o2 = e2.metaFields, i2 = e2.showLinkToFileUploadResult, a2 = e2.showRemoveButton, s2 = e2.i18n, l2 = e2.removeFile, u2 = e2.toggleFileCard, c2 = e2.openFileEditor, p2 = e2.log, d2 = e2.info;
    return bn("div", { className: "uppy-Dashboard-Item-actionWrapper" }, bn(_n, { i18n: s2, file: t2, uploadInProgressOrComplete: n2, canEditFile: r2, metaFields: o2, onClick: function() {
      o2 && o2.length > 0 ? u2(true, t2.id) : c2(t2);
    } }), i2 && t2.uploadURL ? bn(Sn, { file: t2, i18n: s2, info: d2, log: p2 }) : null, a2 ? bn(wn, { i18n: s2, info: e2.info, log: e2.log, onClick: function() {
      return l2(t2.id, "removed-by-user");
    } }) : null);
  };
  function xn(e2, t2) {
    return (xn = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Pn = nn.h, En = function(e2) {
    var t2, n2;
    function r2() {
      return e2.apply(this, arguments) || this;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, xn(t2, n2);
    var o2 = r2.prototype;
    return o2.shouldComponentUpdate = function(e3) {
      return !function(e4, t3) {
        if (e4 === t3) return true;
        for (var n3 in e4) if (!(n3 in t3)) return false;
        for (var n3 in t3) if (e4[n3] !== t3[n3]) return false;
        return true;
      }(this.props, e3);
    }, o2.componentDidMount = function() {
      var e3 = this.props.file;
      e3.preview || this.props.handleRequestThumbnail(e3);
    }, o2.componentDidUpdate = function() {
      var e3 = this.props.file;
      e3.preview || this.props.handleRequestThumbnail(e3);
    }, o2.componentWillUnmount = function() {
      var e3 = this.props.file;
      e3.preview || this.props.handleCancelThumbnail(e3);
    }, o2.render = function() {
      var e3 = this.props.file, t3 = e3.progress.preprocess || e3.progress.postprocess, n3 = e3.progress.uploadComplete && !t3 && !e3.error, r3 = e3.progress.uploadStarted || t3, o3 = e3.progress.uploadStarted && !e3.progress.uploadComplete || t3, i2 = e3.error || false, a2 = e3.isGhost, s2 = (this.props.individualCancellation || !o3) && !n3;
      n3 && this.props.showRemoveButtonAfterComplete && (s2 = true);
      var l2 = it({ "uppy-Dashboard-Item": true, "is-inprogress": o3 && !this.props.recoveredState, "is-processing": t3, "is-complete": n3, "is-error": !!i2, "is-resumable": this.props.resumableUploads, "is-noIndividualCancellation": !this.props.individualCancellation, "is-ghost": a2 });
      return Pn("div", { className: l2, id: "uppy_" + e3.id, role: this.props.role }, Pn("div", { className: "uppy-Dashboard-Item-preview" }, Pn(un, { file: e3, showLinkToFileUploadResult: this.props.showLinkToFileUploadResult }), Pn(mn, { file: e3, error: i2, isUploaded: n3, hideRetryButton: this.props.hideRetryButton, hideCancelButton: this.props.hideCancelButton, hidePauseResumeButton: this.props.hidePauseResumeButton, recoveredState: this.props.recoveredState, showRemoveButtonAfterComplete: this.props.showRemoveButtonAfterComplete, resumableUploads: this.props.resumableUploads, individualCancellation: this.props.individualCancellation, pauseUpload: this.props.pauseUpload, cancelUpload: this.props.cancelUpload, retryUpload: this.props.retryUpload, i18n: this.props.i18n })), Pn("div", { className: "uppy-Dashboard-Item-fileInfoAndButtons" }, Pn(yn, { file: e3, id: this.props.id, acquirers: this.props.acquirers, containerWidth: this.props.containerWidth, i18n: this.props.i18n, toggleAddFilesPanel: this.props.toggleAddFilesPanel }), Pn(kn, { file: e3, metaFields: this.props.metaFields, showLinkToFileUploadResult: this.props.showLinkToFileUploadResult, showRemoveButton: s2, canEditFile: this.props.canEditFile, uploadInProgressOrComplete: r3, removeFile: this.props.removeFile, toggleFileCard: this.props.toggleFileCard, openFileEditor: this.props.openFileEditor, i18n: this.props.i18n, log: this.props.log, info: this.props.info })));
    }, r2;
  }(nn.Component), On = ["data", "rowHeight", "renderRow", "overscanCount", "sync"];
  function An() {
    return (An = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Un(e2, t2) {
    return (Un = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Nn = nn.h, Tn = nn.Component, Rn = { position: "relative", width: "100%", minHeight: "100%" }, Fn = { position: "absolute", top: 0, left: 0, width: "100%", overflow: "visible" }, Dn = function(e2) {
    var t2, n2;
    function r2(t3) {
      var n3;
      return (n3 = e2.call(this, t3) || this).handleResize = function() {
        n3.resize();
      }, n3.handleScroll = function() {
        n3.setState({ offset: n3.base.scrollTop }), n3.props.sync && n3.forceUpdate();
      }, n3.focusElement = null, n3.state = { offset: 0, height: 0 }, n3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Un(t2, n2);
    var o2 = r2.prototype;
    return o2.resize = function() {
      this.state.height !== this.base.offsetHeight && this.setState({ height: this.base.offsetHeight });
    }, o2.componentWillUpdate = function() {
      this.base.contains(document.activeElement) && (this.focusElement = document.activeElement);
    }, o2.componentDidUpdate = function() {
      this.focusElement && this.focusElement.parentNode && document.activeElement !== this.focusElement && this.focusElement.focus(), this.focusElement = null, this.resize();
    }, o2.componentDidMount = function() {
      this.resize(), window.addEventListener("resize", this.handleResize);
    }, o2.componentWillUnmount = function() {
      window.removeEventListener("resize", this.handleResize);
    }, o2.render = function(e3) {
      var t3 = e3.data, n3 = e3.rowHeight, r3 = e3.renderRow, o3 = e3.overscanCount, i2 = void 0 === o3 ? 10 : o3, a2 = (e3.sync, function(e4, t4) {
        if (null == e4) return {};
        var n4, r4, o4 = {}, i3 = Object.keys(e4);
        for (r4 = 0; r4 < i3.length; r4++) n4 = i3[r4], t4.indexOf(n4) >= 0 || (o4[n4] = e4[n4]);
        return o4;
      }(e3, On)), s2 = this.state, l2 = s2.offset, u2 = s2.height, c2 = Math.floor(l2 / n3), p2 = Math.floor(u2 / n3);
      i2 && (c2 = Math.max(0, c2 - c2 % i2), p2 += i2);
      var d2 = c2 + p2 + 4, h2 = t3.slice(c2, d2), f2 = An({}, Rn, { height: t3.length * n3 }), m2 = An({}, Fn, { top: c2 * n3 });
      return Nn("div", An({ onScroll: this.handleScroll }, a2), Nn("div", { role: "presentation", style: f2 }, Nn("div", { role: "presentation", style: m2 }, h2.map(r3))));
    }, r2;
  }(Tn);
  function Mn() {
    return (Mn = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var Bn = nn.h, In = function(e2) {
    var t2 = 0 === e2.totalFileCount, n2 = it("uppy-Dashboard-files", { "uppy-Dashboard-files--noFiles": t2 }), r2 = 1 === e2.itemsPerRow ? 71 : 200, o2 = { id: e2.id, error: e2.error, i18n: e2.i18n, log: e2.log, info: e2.info, acquirers: e2.acquirers, resumableUploads: e2.resumableUploads, individualCancellation: e2.individualCancellation, hideRetryButton: e2.hideRetryButton, hidePauseResumeButton: e2.hidePauseResumeButton, hideCancelButton: e2.hideCancelButton, showLinkToFileUploadResult: e2.showLinkToFileUploadResult, showRemoveButtonAfterComplete: e2.showRemoveButtonAfterComplete, isWide: e2.isWide, metaFields: e2.metaFields, recoveredState: e2.recoveredState, retryUpload: e2.retryUpload, pauseUpload: e2.pauseUpload, cancelUpload: e2.cancelUpload, toggleFileCard: e2.toggleFileCard, removeFile: e2.removeFile, handleRequestThumbnail: e2.handleRequestThumbnail, handleCancelThumbnail: e2.handleCancelThumbnail }, i2 = Object.keys(e2.files);
    e2.recoveredState && i2.sort(function(t3, n3) {
      return e2.files[n3].isGhost - e2.files[t3].isGhost;
    });
    var a2, s2, l2, u2, c2 = (a2 = i2, s2 = e2.itemsPerRow, l2 = [], u2 = [], a2.forEach(function(e3, t3) {
      u2.length < s2 ? u2.push(e3) : (l2.push(u2), u2 = [e3]);
    }), u2.length && l2.push(u2), l2);
    return Bn(Dn, { class: n2, role: "list", data: c2, renderRow: function(t3) {
      return Bn("div", { role: "presentation", key: t3[0] }, t3.map(function(t4) {
        return Bn(En, Mn({ key: t4 }, o2, { role: "listitem", openFileEditor: e2.openFileEditor, canEditFile: e2.canEditFile, toggleAddFilesPanel: e2.toggleAddFilesPanel, file: e2.files[t4] }));
      }));
    }, rowHeight: r2 });
  };
  function Ln(e2, t2) {
    return (Ln = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var jn = nn.h, zn = function(e2) {
    var t2, n2;
    function r2() {
      for (var t3, n3 = arguments.length, r3 = new Array(n3), o3 = 0; o3 < n3; o3++) r3[o3] = arguments[o3];
      return (t3 = e2.call.apply(e2, [this].concat(r3)) || this).triggerFileInputClick = function() {
        t3.fileInput.click();
      }, t3.triggerFolderInputClick = function() {
        t3.folderInput.click();
      }, t3.onFileInputChange = function(e3) {
        t3.props.handleInputChange(e3), e3.target.value = null;
      }, t3.renderHiddenInput = function(e3, n4) {
        return jn("input", { className: "uppy-Dashboard-input", hidden: true, "aria-hidden": "true", tabIndex: -1, webkitdirectory: e3, type: "file", name: "files[]", multiple: 1 !== t3.props.maxNumberOfFiles, onChange: t3.onFileInputChange, accept: t3.props.allowedFileTypes, ref: n4 });
      }, t3.renderMyDeviceAcquirer = function() {
        return jn("div", { className: "uppy-DashboardTab", role: "presentation", "data-uppy-acquirer-id": "MyDevice" }, jn("button", { type: "button", className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn", role: "tab", tabIndex: 0, "data-uppy-super-focusable": true, onClick: t3.triggerFileInputClick }, jn("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, jn("g", { fill: "none", fillRule: "evenodd" }, jn("rect", { className: "uppy-ProviderIconBg", width: "32", height: "32", rx: "16", fill: "#2275D7" }), jn("path", { d: "M21.973 21.152H9.863l-1.108-5.087h14.464l-1.246 5.087zM9.935 11.37h3.958l.886 1.444a.673.673 0 0 0 .585.316h6.506v1.37H9.935v-3.13zm14.898 3.44a.793.793 0 0 0-.616-.31h-.978v-2.126c0-.379-.275-.613-.653-.613H15.75l-.886-1.445a.673.673 0 0 0-.585-.316H9.232c-.378 0-.667.209-.667.587V14.5h-.782a.793.793 0 0 0-.61.303.795.795 0 0 0-.155.663l1.45 6.633c.078.36.396.618.764.618h13.354c.36 0 .674-.246.76-.595l1.631-6.636a.795.795 0 0 0-.144-.675z", fill: "#FFF" }))), jn("div", { className: "uppy-DashboardTab-name" }, t3.props.i18n("myDevice"))));
      }, t3.renderBrowseButton = function(e3, n4) {
        var r4 = t3.props.acquirers.length;
        return jn("button", { type: "button", className: "uppy-u-reset uppy-Dashboard-browse", onClick: n4, "data-uppy-super-focusable": 0 === r4 }, e3);
      }, t3.renderDropPasteBrowseTagline = function() {
        var e3 = t3.props.acquirers.length, n4 = t3.props.fileManagerSelectionType, r4 = n4.charAt(0).toUpperCase() + n4.slice(1), o4 = "browse", i2 = "browse", a2 = "browse";
        if ("files" === n4) try {
          o4 = t3.props.i18n("browse"), i2 = t3.props.i18n("browse"), a2 = t3.props.i18n("browse");
        } catch (p2) {
        }
        try {
          i2 = t3.props.i18n("browseFiles"), a2 = t3.props.i18n("browseFolders");
        } catch (d2) {
        }
        var s2, l2 = t3.renderBrowseButton(o4, t3.triggerFileInputClick), u2 = t3.renderBrowseButton(i2, t3.triggerFileInputClick), c2 = t3.renderBrowseButton(a2, t3.triggerFolderInputClick);
        if (s2 = e3 > 0 ? t3.props.i18nArray("dropPasteImport" + r4, { browseFiles: u2, browseFolders: c2, browse: l2 }) : t3.props.i18nArray("dropPaste" + r4, { browseFiles: u2, browseFolders: c2, browse: l2 }), "files" === n4) try {
          s2 = e3 > 0 ? t3.props.i18nArray("dropPasteImport", { browse: l2 }) : t3.props.i18nArray("dropPaste", { browse: l2 });
        } catch (h2) {
        }
        return t3.props.disableLocalFiles && (s2 = t3.props.i18n("importFiles")), jn("div", { className: "uppy-Dashboard-AddFiles-title" }, s2);
      }, t3.renderAcquirer = function(e3) {
        return jn("div", { className: "uppy-DashboardTab", role: "presentation", "data-uppy-acquirer-id": e3.id }, jn("button", { type: "button", className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn", role: "tab", tabIndex: 0, "aria-controls": "uppy-DashboardContent-panel--" + e3.id, "aria-selected": t3.props.activePickerPanel.id === e3.id, "data-uppy-super-focusable": true, onClick: function() {
          return t3.props.showPanel(e3.id);
        } }, e3.icon(), jn("div", { className: "uppy-DashboardTab-name" }, e3.name)));
      }, t3.renderAcquirers = function(e3, n4) {
        var r4 = [].concat(e3), o4 = r4.splice(e3.length - 2, e3.length);
        return jn("div", { className: "uppy-Dashboard-AddFiles-list", role: "tablist" }, !n4 && t3.renderMyDeviceAcquirer(), r4.map(function(e4) {
          return t3.renderAcquirer(e4);
        }), jn("span", { role: "presentation", style: "white-space: nowrap;" }, o4.map(function(e4) {
          return t3.renderAcquirer(e4);
        })));
      }, t3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Ln(t2, n2);
    var o2 = r2.prototype;
    return o2.renderPoweredByUppy = function() {
      var e3 = jn("span", null, jn("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon uppy-Dashboard-poweredByIcon", width: "11", height: "11", viewBox: "0 0 11 11" }, jn("path", { d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z", fillRule: "evenodd" })), jn("span", { className: "uppy-Dashboard-poweredByUppy" }, "Uppy")), t3 = this.props.i18nArray("poweredBy2", { backwardsCompat: this.props.i18n("poweredBy"), uppy: e3 });
      return jn("a", { tabIndex: "-1", href: "https://uppy.io", rel: "noreferrer noopener", target: "_blank", className: "uppy-Dashboard-poweredBy" }, t3);
    }, o2.render = function() {
      var e3 = this;
      return jn("div", { className: "uppy-Dashboard-AddFiles" }, this.renderHiddenInput(false, function(t3) {
        e3.fileInput = t3;
      }), this.renderHiddenInput(true, function(t3) {
        e3.folderInput = t3;
      }), this.renderDropPasteBrowseTagline(), this.props.acquirers.length > 0 && this.renderAcquirers(this.props.acquirers, this.props.disableLocalFiles), jn("div", { className: "uppy-Dashboard-AddFiles-info" }, this.props.note && jn("div", { className: "uppy-Dashboard-note" }, this.props.note), this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy(this.props)));
    }, r2;
  }(nn.Component), Hn = nn.h, Wn = function(e2) {
    return Hn("div", { className: it("uppy-Dashboard-AddFilesPanel", e2.className), "data-uppy-panelType": "AddFiles", "aria-hidden": e2.showAddFilesPanel }, Hn("div", { className: "uppy-DashboardContent-bar" }, Hn("div", { className: "uppy-DashboardContent-title", role: "heading", "aria-level": "1" }, e2.i18n("addingMoreFiles")), Hn("button", { className: "uppy-DashboardContent-back", type: "button", onClick: function(t2) {
      return e2.toggleAddFilesPanel(false);
    } }, e2.i18n("back"))), Hn(zn, e2));
  }, Vn = function(e2) {
    var t2 = e2.target.tagName;
    "INPUT" !== t2 && "TEXTAREA" !== t2 ? (e2.preventDefault(), e2.stopPropagation()) : e2.stopPropagation();
  }, qn = nn.h, Xn = function(e2) {
    return qn("div", { className: it("uppy-DashboardContent-panel", e2.className), role: "tabpanel", "data-uppy-panelType": "PickerPanel", id: "uppy-DashboardContent-panel--" + e2.activePickerPanel.id, onDragOver: Vn, onDragLeave: Vn, onDrop: Vn, onPaste: Vn }, qn("div", { className: "uppy-DashboardContent-bar" }, qn("div", { className: "uppy-DashboardContent-title", role: "heading", "aria-level": "1" }, e2.i18n("importFrom", { name: e2.activePickerPanel.name })), qn("button", { className: "uppy-DashboardContent-back", type: "button", onClick: e2.hideAllPanels }, e2.i18n("done"))), qn("div", { className: "uppy-DashboardContent-panelBody" }, e2.getPlugin(e2.activePickerPanel.id).render(e2.state)));
  }, Gn = nn.h, Yn = function(e2) {
    var t2 = this.props.files[this.props.fileCardFor];
    return Gn("div", { className: it("uppy-DashboardContent-panel", e2.className), role: "tabpanel", "data-uppy-panelType": "FileEditor", id: "uppy-DashboardContent-panel--editor" }, Gn("div", { className: "uppy-DashboardContent-bar" }, Gn("div", { className: "uppy-DashboardContent-title", role: "heading", "aria-level": "1" }, e2.i18nArray("editing", { file: Gn("span", { className: "uppy-DashboardContent-titleFile" }, t2.meta ? t2.meta.name : t2.name) })), Gn("button", { className: "uppy-DashboardContent-back", type: "button", onClick: e2.hideAllPanels }, e2.i18n("done"))), Gn("div", { className: "uppy-DashboardContent-panelBody" }, e2.editors.map(function(t3) {
      return e2.getPlugin(t3.id).render(e2.state);
    })));
  }, $n = nn.h, Kn = "error", Jn = "waiting", Qn = "preprocessing", Zn = "uploading", er = "postprocessing", tr = "complete", nr = "paused";
  function rr(e2) {
    switch (function(e3, t2, n2, r2) {
      if (void 0 === r2 && (r2 = {}), e3) return Kn;
      if (t2) return tr;
      if (n2) return nr;
      for (var o2 = Jn, i2 = Object.keys(r2), a2 = 0; a2 < i2.length; a2++) {
        var s2 = r2[i2[a2]].progress;
        if (s2.uploadStarted && !s2.uploadComplete) return Zn;
        s2.preprocess && o2 !== Zn && (o2 = Qn), s2.postprocess && o2 !== Zn && o2 !== Qn && (o2 = er);
      }
      return o2;
    }(e2.isAllErrored, e2.isAllComplete, e2.isAllPaused, e2.files)) {
      case "uploading":
        return e2.i18n("uploadingXFiles", { smart_count: e2.inProgressNotPausedFiles.length });
      case "preprocessing":
      case "postprocessing":
        return e2.i18n("processingXFiles", { smart_count: e2.processingFiles.length });
      case "paused":
        return e2.i18n("uploadPaused");
      case "waiting":
        return e2.i18n("xFilesSelected", { smart_count: e2.newFiles.length });
      case "complete":
        return e2.i18n("uploadComplete");
    }
  }
  var or = function(e2) {
    var t2 = e2.allowNewUpload;
    return t2 && e2.maxNumberOfFiles && (t2 = e2.totalFileCount < e2.maxNumberOfFiles), $n("div", { className: "uppy-DashboardContent-bar" }, e2.isAllComplete || e2.hideCancelButton ? $n("div", null) : $n("button", { className: "uppy-DashboardContent-back", type: "button", onClick: e2.cancelAll }, e2.i18n("cancel")), $n("div", { className: "uppy-DashboardContent-title", role: "heading", "aria-level": "1" }, $n(rr, e2)), t2 ? $n("button", { className: "uppy-DashboardContent-addMore", type: "button", "aria-label": e2.i18n("addMoreFiles"), title: e2.i18n("addMoreFiles"), onClick: function() {
      return e2.toggleAddFilesPanel(true);
    } }, $n("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "15", height: "15", viewBox: "0 0 15 15" }, $n("path", { d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z" })), $n("span", { className: "uppy-DashboardContent-addMoreCaption" }, e2.i18n("addMore"))) : $n("div", null));
  };
  function ir() {
    return (ir = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function ar(e2, t2) {
    return (ar = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var sr = nn.h, lr = function(e2) {
    var t2, n2;
    function r2(t3) {
      var n3;
      (n3 = e2.call(this, t3) || this).saveOnEnter = function(e3) {
        if (13 === e3.keyCode) {
          e3.stopPropagation(), e3.preventDefault();
          var t4 = n3.props.files[n3.props.fileCardFor];
          n3.props.saveFileCard(n3.state.formState, t4.id);
        }
      }, n3.updateMeta = function(e3, t4) {
        var r4;
        n3.setState({ formState: ir({}, n3.state.formState, (r4 = {}, r4[t4] = e3, r4)) });
      }, n3.handleSave = function() {
        var e3 = n3.props.fileCardFor;
        n3.props.saveFileCard(n3.state.formState, e3);
      }, n3.handleCancel = function() {
        n3.props.toggleFileCard(false);
      }, n3.renderMetaFields = function() {
        var e3 = n3.getMetaFields() || [], t4 = { text: "uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input" };
        return e3.map(function(e4) {
          var r4 = "uppy-Dashboard-FileCard-input-" + e4.id;
          return sr("fieldset", { key: e4.id, className: "uppy-Dashboard-FileCard-fieldset" }, sr("label", { className: "uppy-Dashboard-FileCard-label", htmlFor: r4 }, e4.name), void 0 !== e4.render ? e4.render({ value: n3.state.formState[e4.id], onChange: function(t5) {
            return n3.updateMeta(t5, e4.id);
          }, fieldCSSClasses: t4 }, sr) : sr("input", { className: t4.text, id: r4, type: e4.type || "text", value: n3.state.formState[e4.id], placeholder: e4.placeholder, onKeyUp: n3.saveOnEnter, onKeyDown: n3.saveOnEnter, onKeyPress: n3.saveOnEnter, onInput: function(t5) {
            return n3.updateMeta(t5.target.value, e4.id);
          }, "data-uppy-super-focusable": true }));
        });
      };
      var r3 = n3.props.files[n3.props.fileCardFor], o3 = n3.getMetaFields() || [], i2 = {};
      return o3.forEach(function(e3) {
        i2[e3.id] = r3.meta[e3.id] || "";
      }), n3.state = { formState: i2 }, n3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, ar(t2, n2);
    var o2 = r2.prototype;
    return o2.getMetaFields = function() {
      return "function" == typeof this.props.metaFields ? this.props.metaFields(this.props.files[this.props.fileCardFor]) : this.props.metaFields;
    }, o2.render = function() {
      var e3 = this, t3 = this.props.files[this.props.fileCardFor], n3 = this.props.canEditFile(t3);
      return sr("div", { className: it("uppy-Dashboard-FileCard", this.props.className), "data-uppy-panelType": "FileCard", onDragOver: Vn, onDragLeave: Vn, onDrop: Vn, onPaste: Vn }, sr("div", { className: "uppy-DashboardContent-bar" }, sr("div", { className: "uppy-DashboardContent-title", role: "heading", "aria-level": "1" }, this.props.i18nArray("editing", { file: sr("span", { className: "uppy-DashboardContent-titleFile" }, t3.meta ? t3.meta.name : t3.name) })), sr("button", { className: "uppy-DashboardContent-back", type: "button", title: this.props.i18n("finishEditingFile"), onClick: this.handleSave }, this.props.i18n("done"))), sr("div", { className: "uppy-Dashboard-FileCard-inner" }, sr("div", { className: "uppy-Dashboard-FileCard-preview", style: { backgroundColor: on(t3.type).color } }, sr(sn, { file: t3 }), n3 && sr("button", { type: "button", className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit", onClick: function() {
        return e3.props.openFileEditor(t3);
      } }, this.props.i18n("editFile"))), sr("div", { className: "uppy-Dashboard-FileCard-info" }, this.renderMetaFields()), sr("div", { className: "uppy-Dashboard-FileCard-actions" }, sr("button", { className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn", type: "button", onClick: this.handleSave }, this.props.i18n("saveChanges")), sr("button", { className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn", type: "button", onClick: this.handleCancel }, this.props.i18n("cancel")))));
    }, r2;
  }(nn.Component);
  function ur(e2, t2) {
    return (ur = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var cr = nn.cloneElement, pr = nn.Component, dr = "uppy-transition-slideDownUp", hr = function(e2) {
    var t2, n2;
    function r2(t3) {
      var n3;
      return (n3 = e2.call(this, t3) || this).state = { cachedChildren: null, className: "" }, n3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, ur(t2, n2);
    var o2 = r2.prototype;
    return o2.componentWillUpdate = function(e3) {
      var t3 = this, n3 = this.state.cachedChildren, r3 = e3.children[0];
      if (n3 !== r3) {
        var o3 = { cachedChildren: r3 };
        r3 && !n3 && (o3.className = dr + "-enter", cancelAnimationFrame(this.animationFrame), clearTimeout(this.leaveTimeout), this.leaveTimeout = void 0, this.animationFrame = requestAnimationFrame(function() {
          t3.base.getBoundingClientRect(), t3.setState({ className: dr + "-enter " + dr + "-enter-active" }), t3.enterTimeout = setTimeout(function() {
            t3.setState({ className: "" });
          }, 250);
        })), n3 && !r3 && void 0 === this.leaveTimeout && (o3.cachedChildren = n3, o3.className = dr + "-leave", cancelAnimationFrame(this.animationFrame), clearTimeout(this.enterTimeout), this.enterTimeout = void 0, this.animationFrame = requestAnimationFrame(function() {
          t3.setState({ className: dr + "-leave " + dr + "-leave-active" }), t3.leaveTimeout = setTimeout(function() {
            t3.setState({ cachedChildren: null, className: "" });
          }, 250);
        })), this.setState(o3);
      }
    }, o2.render = function() {
      var e3 = this.state, t3 = e3.cachedChildren, n3 = e3.className;
      return t3 ? cr(t3, { className: it(n3, t3.attributes.className) }) : null;
    }, r2;
  }(pr), fr = function() {
    var e2 = document.createElement("div");
    return "draggable" in e2 && "ondragstart" in e2 && "ondrop" in e2 && "FormData" in window && "FileReader" in window;
  };
  function mr() {
    return (mr = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var vr = nn.h, gr = "error", yr = "waiting", br = "preprocessing", _r = "uploading", wr = "postprocessing", Cr = "complete", Sr = function(e2) {
    var t2, n2 = (t2 = e2, { hours: Math.floor(t2 / 3600) % 24, minutes: Math.floor(t2 / 60) % 60, seconds: Math.floor(t2 % 60) }), r2 = n2.hours ? n2.hours + "h " : "", o2 = n2.hours ? ("0" + n2.minutes).substr(-2) : n2.minutes, i2 = o2 ? o2 + "m" : "", a2 = o2 ? ("0" + n2.seconds).substr(-2) : n2.seconds;
    return "" + r2 + i2 + (n2.hours ? "" : o2 ? " " + a2 + "s" : a2 + "s");
  }, kr = { exports: {} };
  function xr() {
    return (xr = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    kr.exports = N2;
  }();
  var Pr, Er, Or = (kr = kr.exports).h, Ar = function(e2) {
    var t2 = it("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--upload", { "uppy-c-btn-primary": e2.uploadState === yr }, { "uppy-StatusBar-actionBtn--disabled": e2.isSomeGhost }), n2 = e2.newFiles && e2.isUploadStarted && !e2.recoveredState ? e2.i18n("uploadXNewFiles", { smart_count: e2.newFiles }) : e2.i18n("uploadXFiles", { smart_count: e2.newFiles });
    return Or("button", { type: "button", className: t2, "aria-label": e2.i18n("uploadXFiles", { smart_count: e2.newFiles }), onClick: e2.startUpload, disabled: e2.isSomeGhost, "data-uppy-super-focusable": true }, n2);
  }, Ur = function(e2) {
    return Or("button", { type: "button", className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry", "aria-label": e2.i18n("retryUpload"), onClick: e2.retryAll, "data-uppy-super-focusable": true }, Or("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "8", height: "10", viewBox: "0 0 8 10" }, Or("path", { d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z" })), e2.i18n("retry"));
  }, Nr = function(e2) {
    return Or("button", { type: "button", className: "uppy-u-reset uppy-StatusBar-actionCircleBtn", title: e2.i18n("cancel"), "aria-label": e2.i18n("cancel"), onClick: e2.cancelAll, "data-uppy-super-focusable": true }, Or("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "16", height: "16", viewBox: "0 0 16 16" }, Or("g", { fill: "none", fillRule: "evenodd" }, Or("circle", { fill: "#888", cx: "8", cy: "8", r: "8" }), Or("path", { fill: "#FFF", d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z" }))));
  }, Tr = function(e2) {
    var t2 = e2.isAllPaused, n2 = (0, e2.i18n)(t2 ? "resume" : "pause");
    return Or("button", { title: n2, "aria-label": n2, className: "uppy-u-reset uppy-StatusBar-actionCircleBtn", type: "button", onClick: function() {
      return function(e3) {
        if (!e3.isAllComplete) return e3.resumableUploads ? e3.isAllPaused ? e3.resumeAll() : e3.pauseAll() : e3.cancelAll();
      }(e2);
    }, "data-uppy-super-focusable": true }, Or("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "16", height: "16", viewBox: "0 0 16 16" }, Or("g", { fill: "none", fillRule: "evenodd" }, Or("circle", { fill: "#888", cx: "8", cy: "8", r: "8" }), Or("path", t2 ? { fill: "#FFF", d: "M6 4.25L11.5 8 6 11.75z" } : { d: "M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z", fill: "#FFF" }))));
  }, Rr = function(e2) {
    var t2 = e2.i18n;
    return Or("button", { type: "button", className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done", onClick: e2.doneButtonHandler, "data-uppy-super-focusable": true }, t2("done"));
  }, Fr = function() {
    return Or("svg", { className: "uppy-StatusBar-spinner", "aria-hidden": "true", focusable: "false", width: "14", height: "14" }, Or("path", { d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0", fillRule: "evenodd" }));
  }, Dr = function(e2) {
    var t2 = Math.round(100 * e2.value);
    return Or("div", { className: "uppy-StatusBar-content" }, Or(Fr, null), "determinate" === e2.mode ? t2 + "% \xB7 " : "", e2.message);
  }, Mr = function(e2) {
    return Or("div", { className: "uppy-StatusBar-statusSecondary" }, e2.i18n("filesUploadedOfTotal", { complete: e2.complete, smart_count: e2.numUploads }));
  }, Br = function(e2) {
    var t2 = it("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--uploadNewlyAdded");
    return Or("div", { className: "uppy-StatusBar-statusSecondary" }, Or("div", { className: "uppy-StatusBar-statusSecondaryHint" }, e2.i18n("xMoreFilesAdded", { smart_count: e2.newFiles })), Or("button", { type: "button", className: t2, "aria-label": e2.i18n("uploadXFiles", { smart_count: e2.newFiles }), onClick: e2.startUpload }, e2.i18n("upload")));
  }, Ir = z(function(e2) {
    var t2 = e2.numUploads > 1;
    return Or("div", { className: "uppy-StatusBar-statusSecondary" }, t2 && e2.i18n("filesUploadedOfTotal", { complete: e2.complete, smart_count: e2.numUploads }), Or("span", { className: "uppy-StatusBar-additionalInfo" }, t2 && " \xB7 ", e2.i18n("dataUploadedOfTotal", { complete: W(e2.totalUploadedSize), total: W(e2.totalSize) }), " \xB7 ", e2.i18n("xTimeLeft", { time: Sr(e2.totalETA) })));
  }, 500, { leading: true, trailing: true }), Lr = function(e2) {
    if (!e2.isUploadStarted || e2.isAllComplete) return null;
    var t2 = e2.isAllPaused ? e2.i18n("paused") : e2.i18n("uploading"), n2 = e2.newFiles && e2.isUploadStarted;
    return Or("div", { className: "uppy-StatusBar-content", "aria-label": t2, title: t2 }, e2.isAllPaused ? null : Or(Fr, null), Or("div", { className: "uppy-StatusBar-status" }, Or("div", { className: "uppy-StatusBar-statusPrimary" }, e2.supportsUploadProgress ? t2 + ": " + e2.totalProgress + "%" : t2), e2.isAllPaused || n2 || !e2.showProgressDetails ? null : e2.supportsUploadProgress ? Or(Ir, e2) : Or(Mr, e2), n2 ? Or(Br, e2) : null));
  }, jr = function(e2) {
    e2.totalProgress;
    var t2 = e2.i18n;
    return Or("div", { className: "uppy-StatusBar-content", role: "status", title: t2("complete") }, Or("div", { className: "uppy-StatusBar-status" }, Or("div", { className: "uppy-StatusBar-statusPrimary" }, Or("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-StatusBar-statusIndicator uppy-c-icon", width: "15", height: "11", viewBox: "0 0 15 11" }, Or("path", { d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z" })), t2("complete"))));
  }, zr = function(e2) {
    var t2 = e2.error, n2 = (e2.retryAll, e2.hideRetryButton, e2.i18n);
    return Or("div", { className: "uppy-StatusBar-content", role: "alert", title: n2("uploadFailed") }, Or("div", { className: "uppy-StatusBar-status" }, Or("div", { className: "uppy-StatusBar-statusPrimary" }, Or("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-StatusBar-statusIndicator uppy-c-icon", width: "11", height: "11", viewBox: "0 0 11 11" }, Or("path", { d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z" })), n2("uploadFailed"))), Or("span", { className: "uppy-StatusBar-details", "aria-label": t2, "data-microtip-position": "top-right", "data-microtip-size": "medium", role: "tooltip", onClick: function() {
      var e3 = n2("uploadFailed") + " \n\n " + t2;
      alert(e3);
    } }, "?"));
  }, Hr = function(e2) {
    for (; e2 && !e2.dir; ) e2 = e2.parentNode;
    return e2 ? e2.dir : void 0;
  };
  function Wr() {
    return (Wr = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Vr(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function qr(e2, t2) {
    return (qr = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Xr = (Er = Pr = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).startUpload = function() {
        if (!r3.uppy.getState().recoveredState) return r3.uppy.upload().catch(function() {
        });
        r3.uppy.emit("restore-confirmed");
      }, r3.id = r3.opts.id || "StatusBar", r3.title = "StatusBar", r3.type = "progressindicator", r3.defaultLocale = { strings: { uploading: "Uploading", upload: "Upload", complete: "Complete", uploadFailed: "Upload failed", paused: "Paused", retry: "Retry", retryUpload: "Retry upload", cancel: "Cancel", pause: "Pause", resume: "Resume", done: "Done", filesUploadedOfTotal: { 0: "%{complete} of %{smart_count} file uploaded", 1: "%{complete} of %{smart_count} files uploaded" }, dataUploadedOfTotal: "%{complete} of %{total}", xTimeLeft: "%{time} left", uploadXFiles: { 0: "Upload %{smart_count} file", 1: "Upload %{smart_count} files" }, uploadXNewFiles: { 0: "Upload +%{smart_count} file", 1: "Upload +%{smart_count} files" }, xMoreFilesAdded: { 0: "%{smart_count} more file added", 1: "%{smart_count} more files added" } } }, r3.opts = Wr({}, { target: "body", hideUploadButton: false, hideRetryButton: false, hidePauseResumeButton: false, hideCancelButton: false, showProgressDetails: false, hideAfterFinish: true, doneButtonHandler: null }, n3), r3.i18nInit(), r3.render = r3.render.bind(Vr(r3)), r3.install = r3.install.bind(Vr(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, qr(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, t3), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.setPluginState();
    }, o2.getTotalSpeed = function(e3) {
      var t3 = 0;
      return e3.forEach(function(e4) {
        t3 += function(e5) {
          if (!e5.bytesUploaded) return 0;
          var t4 = /* @__PURE__ */ new Date() - e5.uploadStarted;
          return e5.bytesUploaded / (t4 / 1e3);
        }(e4.progress);
      }), t3;
    }, o2.getTotalETA = function(e3) {
      var t3 = this.getTotalSpeed(e3);
      if (0 === t3) return 0;
      var n3 = e3.reduce(function(e4, t4) {
        return e4 + ((n4 = t4.progress).bytesTotal - n4.bytesUploaded);
        var n4;
      }, 0);
      return Math.round(n3 / t3 * 10) / 10;
    }, o2.getUploadingState = function(e3, t3, n3, r3) {
      if (e3) return gr;
      if (t3) return Cr;
      if (n3) return yr;
      for (var o3 = yr, i2 = Object.keys(r3), a2 = 0; a2 < i2.length; a2++) {
        var s2 = r3[i2[a2]].progress;
        if (s2.uploadStarted && !s2.uploadComplete) return _r;
        s2.preprocess && o3 !== _r && (o3 = br), s2.postprocess && o3 !== _r && o3 !== br && (o3 = wr);
      }
      return o3;
    }, o2.render = function(e3) {
      var t3 = e3.capabilities, n3 = e3.files, r3 = e3.allowNewUpload, o3 = e3.totalProgress, i2 = e3.error, a2 = e3.recoveredState, s2 = Object.keys(n3).map(function(e4) {
        return n3[e4];
      }), l2 = s2.filter(function(e4) {
        return !e4.progress.uploadStarted && !e4.progress.preprocess && !e4.progress.postprocess;
      });
      a2 && (l2 = s2);
      var u2 = s2.filter(function(e4) {
        return e4.progress.uploadStarted;
      }).filter(function(e4) {
        return e4.isPaused;
      }), c2 = s2.filter(function(e4) {
        return e4.progress.uploadComplete;
      }), p2 = s2.filter(function(e4) {
        return e4.error;
      }), d2 = s2.filter(function(e4) {
        return !e4.progress.uploadComplete && e4.progress.uploadStarted;
      }), h2 = d2.filter(function(e4) {
        return !e4.isPaused;
      }), f2 = s2.filter(function(e4) {
        return e4.progress.uploadStarted || e4.progress.preprocess || e4.progress.postprocess;
      }), m2 = s2.filter(function(e4) {
        return e4.progress.preprocess || e4.progress.postprocess;
      }), v2 = this.getTotalETA(h2), g2 = 0, y2 = 0;
      f2.forEach(function(e4) {
        g2 += e4.progress.bytesTotal || 0, y2 += e4.progress.bytesUploaded || 0;
      });
      var b2 = f2.length > 0, _2 = 100 === o3 && c2.length === Object.keys(n3).length && 0 === m2.length, w2 = i2 && p2.length === s2.length, C2 = 0 !== d2.length && u2.length === d2.length, S2 = d2.length > 0, k2 = t3.resumableUploads || false, x2 = false !== t3.uploadProgress, P2 = s2.some(function(e4) {
        return e4.isGhost;
      });
      return function(e4) {
        var t4, n4, r4 = e4 = e4 || {}, o4 = r4.newFiles, i3 = r4.allowNewUpload, a3 = r4.isUploadInProgress, s3 = r4.isAllPaused, l3 = r4.resumableUploads, u3 = r4.error, c3 = r4.hideUploadButton, p3 = r4.hidePauseResumeButton, d3 = r4.hideCancelButton, h3 = r4.hideRetryButton, f3 = r4.recoveredState, m3 = e4.uploadState, v3 = e4.totalProgress;
        if (m3 === br || m3 === wr) {
          var g3 = function(e5) {
            var t5 = [];
            Object.keys(e5).forEach(function(n6) {
              var r5 = e5[n6].progress;
              r5.preprocess && t5.push(r5.preprocess), r5.postprocess && t5.push(r5.postprocess);
            });
            var n5 = t5[0];
            return { mode: n5.mode, message: n5.message, value: t5.filter(function(e6) {
              return "determinate" === e6.mode;
            }).reduce(function(e6, t6, n6, r5) {
              return e6 + t6.value / r5.length;
            }, 0) };
          }(e4.files);
          "determinate" === (t4 = g3.mode) && (v3 = 100 * g3.value), n4 = Dr(g3);
        } else m3 === Cr ? n4 = jr(e4) : m3 === _r ? (e4.supportsUploadProgress || (t4 = "indeterminate", v3 = null), n4 = Lr(e4)) : m3 === gr && (v3 = void 0, n4 = zr(e4));
        var y3 = "number" == typeof v3 ? v3 : 100, b3 = m3 === yr && e4.hideUploadButton || m3 === yr && !e4.newFiles > 0 || m3 === Cr && e4.hideAfterFinish, _3 = !u3 && o4 && !a3 && !s3 && i3 && !c3;
        f3 && (b3 = false, _3 = true);
        var w3 = !d3 && m3 !== yr && m3 !== Cr, C3 = l3 && !p3 && m3 === _r, S3 = u3 && !h3, k3 = e4.doneButtonHandler && m3 === Cr, x3 = "uppy-StatusBar-progress\n                           " + (t4 ? "is-" + t4 : ""), P3 = it({ "uppy-Root": e4.isTargetDOMEl }, "uppy-StatusBar", "is-" + m3, { "has-ghosts": e4.isSomeGhost });
        return Or("div", { className: P3, "aria-hidden": b3 }, Or("div", { className: x3, style: { width: y3 + "%" }, role: "progressbar", "aria-valuemin": "0", "aria-valuemax": "100", "aria-valuenow": v3 }), n4, Or("div", { className: "uppy-StatusBar-actions" }, _3 ? Or(Ar, xr({}, e4, { uploadState: m3 })) : null, S3 ? Or(Ur, e4) : null, C3 ? Or(Tr, e4) : null, w3 ? Or(Nr, e4) : null, k3 ? Or(Rr, e4) : null));
      }({ error: i2, uploadState: this.getUploadingState(w2, _2, a2, e3.files || {}), allowNewUpload: r3, totalProgress: o3, totalSize: g2, totalUploadedSize: y2, isAllComplete: _2, isAllPaused: C2, isAllErrored: w2, isUploadStarted: b2, isUploadInProgress: S2, isSomeGhost: P2, recoveredState: a2, complete: c2.length, newFiles: l2.length, numUploads: f2.length, totalETA: v2, files: n3, i18n: this.i18n, pauseAll: this.uppy.pauseAll, resumeAll: this.uppy.resumeAll, retryAll: this.uppy.retryAll, cancelAll: this.uppy.cancelAll, startUpload: this.startUpload, doneButtonHandler: this.opts.doneButtonHandler, resumableUploads: k2, supportsUploadProgress: x2, showProgressDetails: this.opts.showProgressDetails, hideUploadButton: this.opts.hideUploadButton, hideRetryButton: this.opts.hideRetryButton, hidePauseResumeButton: this.opts.hidePauseResumeButton, hideCancelButton: this.opts.hideCancelButton, hideAfterFinish: this.opts.hideAfterFinish, isTargetDOMEl: this.isTargetDOMEl });
    }, o2.onMount = function() {
      var e3 = this.el;
      Hr(e3) || (e3.dir = "ltr");
    }, o2.install = function() {
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.unmount();
    }, r2;
  }(ue.Plugin), Pr.VERSION = "1.9.6", Er), Gr = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    Gr.exports = N2;
  }(), Gr = Gr.exports;
  var Yr, $r;
  function Kr() {
    return (Kr = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Jr(e2, t2) {
    return (Jr = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  for (var Qr = ue.Plugin, Zr = Gr.h, eo = ($r = Yr = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).render = function(e3) {
        var t4 = e3.info, n4 = t4.isHidden, o2 = t4.message, i2 = t4.details;
        return Zr("div", { className: "uppy uppy-Informer", "aria-hidden": n4 }, Zr("p", { role: "alert" }, o2, " ", i2 && Zr("span", { "aria-label": i2, "data-microtip-position": "top-left", "data-microtip-size": "medium", role: "tooltip", onClick: function() {
          alert(o2 + " \n\n " + i2);
        }, onMouseOver: function() {
          clearTimeout(r3.uppy.infoTimeoutID);
        }, onMouseLeave: function() {
          r3.uppy.infoTimeoutID = setTimeout(r3.uppy.hideInfo, 2e3);
        } }, "?")));
      }, r3.type = "progressindicator", r3.id = r3.opts.id || "Informer", r3.title = "Informer", r3.opts = Kr({}, {}, n3), r3;
    }
    return n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Jr(t2, n2), r2.prototype.install = function() {
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, r2;
  }(Qr), Yr.VERSION = "1.6.6", $r), to = function(e2, t2, n2) {
    var r2 = e2.split(",")[1], o2 = t2.mimeType || e2.split(",")[0].split(":")[1].split(";")[0];
    null == o2 && (o2 = "plain/text");
    for (var i2, a2 = atob(r2), s2 = [], l2 = 0; l2 < a2.length; l2++) s2.push(a2.charCodeAt(l2));
    try {
      i2 = new Uint8Array(s2);
    } catch (wd2) {
      return null;
    }
    return n2 ? new File([i2], t2.name || "", { type: o2 }) : new Blob([i2], { type: o2 });
  }, no = function(e2) {
    return 0 === e2.indexOf("blob:");
  }, ro = Math.log2 || function(e2) {
    return Math.log(e2) * Math.LOG2E;
  }, oo = { toByteArray: function(e2) {
    var t2, n2, r2 = po(e2), o2 = r2[0], i2 = r2[1], a2 = new so(function(e3, t3, n3) {
      return 3 * (t3 + n3) / 4 - n3;
    }(0, o2, i2)), s2 = 0, l2 = i2 > 0 ? o2 - 4 : o2;
    for (n2 = 0; n2 < l2; n2 += 4) t2 = ao[e2.charCodeAt(n2)] << 18 | ao[e2.charCodeAt(n2 + 1)] << 12 | ao[e2.charCodeAt(n2 + 2)] << 6 | ao[e2.charCodeAt(n2 + 3)], a2[s2++] = t2 >> 16 & 255, a2[s2++] = t2 >> 8 & 255, a2[s2++] = 255 & t2;
    return 2 === i2 && (t2 = ao[e2.charCodeAt(n2)] << 2 | ao[e2.charCodeAt(n2 + 1)] >> 4, a2[s2++] = 255 & t2), 1 === i2 && (t2 = ao[e2.charCodeAt(n2)] << 10 | ao[e2.charCodeAt(n2 + 1)] << 4 | ao[e2.charCodeAt(n2 + 2)] >> 2, a2[s2++] = t2 >> 8 & 255, a2[s2++] = 255 & t2), a2;
  }, fromByteArray: function(e2) {
    for (var t2, n2 = e2.length, r2 = n2 % 3, o2 = [], i2 = 0, a2 = n2 - r2; i2 < a2; i2 += 16383) o2.push(ho(e2, i2, i2 + 16383 > a2 ? a2 : i2 + 16383));
    return 1 === r2 ? (t2 = e2[n2 - 1], o2.push(io[t2 >> 2] + io[t2 << 4 & 63] + "==")) : 2 === r2 && (t2 = (e2[n2 - 2] << 8) + e2[n2 - 1], o2.push(io[t2 >> 10] + io[t2 >> 4 & 63] + io[t2 << 2 & 63] + "=")), o2.join("");
  } }, io = [], ao = [], so = "undefined" != typeof Uint8Array ? Uint8Array : Array, lo = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", uo = 0, co = lo.length; uo < co; ++uo) io[uo] = lo[uo], ao[lo.charCodeAt(uo)] = uo;
  function po(e2) {
    var t2 = e2.length;
    if (t2 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var n2 = e2.indexOf("=");
    return -1 === n2 && (n2 = t2), [n2, n2 === t2 ? 0 : 4 - n2 % 4];
  }
  function ho(e2, t2, n2) {
    for (var r2, o2, i2 = [], a2 = t2; a2 < n2; a2 += 3) r2 = (e2[a2] << 16 & 16711680) + (e2[a2 + 1] << 8 & 65280) + (255 & e2[a2 + 2]), i2.push(io[(o2 = r2) >> 18 & 63] + io[o2 >> 12 & 63] + io[o2 >> 6 & 63] + io[63 & o2]);
    return i2.join("");
  }
  ao["-".charCodeAt(0)] = 62, ao["_".charCodeAt(0)] = 63;
  var fo = { read: function(e2, t2, n2, r2, o2) {
    var i2, a2, s2 = 8 * o2 - r2 - 1, l2 = (1 << s2) - 1, u2 = l2 >> 1, c2 = -7, p2 = n2 ? o2 - 1 : 0, d2 = n2 ? -1 : 1, h2 = e2[t2 + p2];
    for (p2 += d2, i2 = h2 & (1 << -c2) - 1, h2 >>= -c2, c2 += s2; c2 > 0; i2 = 256 * i2 + e2[t2 + p2], p2 += d2, c2 -= 8) ;
    for (a2 = i2 & (1 << -c2) - 1, i2 >>= -c2, c2 += r2; c2 > 0; a2 = 256 * a2 + e2[t2 + p2], p2 += d2, c2 -= 8) ;
    if (0 === i2) i2 = 1 - u2;
    else {
      if (i2 === l2) return a2 ? NaN : 1 / 0 * (h2 ? -1 : 1);
      a2 += Math.pow(2, r2), i2 -= u2;
    }
    return (h2 ? -1 : 1) * a2 * Math.pow(2, i2 - r2);
  }, write: function(e2, t2, n2, r2, o2, i2) {
    var a2, s2, l2, u2 = 8 * i2 - o2 - 1, c2 = (1 << u2) - 1, p2 = c2 >> 1, d2 = 23 === o2 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h2 = r2 ? 0 : i2 - 1, f2 = r2 ? 1 : -1, m2 = t2 < 0 || 0 === t2 && 1 / t2 < 0 ? 1 : 0;
    for (t2 = Math.abs(t2), isNaN(t2) || t2 === 1 / 0 ? (s2 = isNaN(t2) ? 1 : 0, a2 = c2) : (a2 = Math.floor(Math.log(t2) / Math.LN2), t2 * (l2 = Math.pow(2, -a2)) < 1 && (a2--, l2 *= 2), (t2 += a2 + p2 >= 1 ? d2 / l2 : d2 * Math.pow(2, 1 - p2)) * l2 >= 2 && (a2++, l2 /= 2), a2 + p2 >= c2 ? (s2 = 0, a2 = c2) : a2 + p2 >= 1 ? (s2 = (t2 * l2 - 1) * Math.pow(2, o2), a2 += p2) : (s2 = t2 * Math.pow(2, p2 - 1) * Math.pow(2, o2), a2 = 0)); o2 >= 8; e2[n2 + h2] = 255 & s2, h2 += f2, s2 /= 256, o2 -= 8) ;
    for (a2 = a2 << o2 | s2, u2 += o2; u2 > 0; e2[n2 + h2] = 255 & a2, h2 += f2, a2 /= 256, u2 -= 8) ;
    e2[n2 + h2 - f2] |= 128 * m2;
  } }, mo = { exports: {} };
  (function(e2, t2, n2) {
    (function() {
      var r2, o2;
      r2 = this, o2 = function(r3) {
        "use strict";
        function o3(e3, t3) {
          if (!(e3 instanceof t3)) throw new TypeError("Cannot call a class as a function");
        }
        function i2(e3, t3) {
          for (var n3 = 0; n3 < t3.length; n3++) {
            var r4 = t3[n3];
            r4.enumerable = r4.enumerable || false, r4.configurable = true, "value" in r4 && (r4.writable = true), Object.defineProperty(e3, r4.key, r4);
          }
        }
        function a2(e3, t3, n3) {
          return t3 && i2(e3.prototype, t3), n3 && i2(e3, n3), e3;
        }
        function s2(e3, t3, n3) {
          return t3 in e3 ? Object.defineProperty(e3, t3, { value: n3, enumerable: true, configurable: true, writable: true }) : e3[t3] = n3, e3;
        }
        function l2(e3, t3) {
          if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
          e3.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e3, writable: true, configurable: true } });
          var n3 = ["prototype", "__proto__", "caller", "arguments", "length", "name"];
          Object.getOwnPropertyNames(t3).forEach(function(r4) {
            -1 === n3.indexOf(r4) && e3[r4] !== t3[r4] && (e3[r4] = t3[r4]);
          }), t3 && c2(e3, t3);
        }
        function u2(e3) {
          return (u2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(e4) {
            return e4.__proto__ || Object.getPrototypeOf(e4);
          })(e3);
        }
        function c2(e3, t3) {
          return (c2 = Object.setPrototypeOf || function(e4, t4) {
            return e4.__proto__ = t4, e4;
          })(e3, t3);
        }
        function p2() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return false;
          if (Reflect.construct.sham) return false;
          if ("function" == typeof Proxy) return true;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), true;
          } catch (r4) {
            return false;
          }
        }
        function d2(e3, t3, n3) {
          return (d2 = p2() ? Reflect.construct : function(e4, t4, n4) {
            var r4 = [null];
            r4.push.apply(r4, t4);
            var o4 = new (Function.bind.apply(e4, r4))();
            return n4 && c2(o4, n4.prototype), o4;
          }).apply(null, arguments);
        }
        function h2(e3) {
          var t3 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
          return (h2 = function(e4) {
            if (null === e4 || (n3 = e4, -1 === Function.toString.call(n3).indexOf("[native code]"))) return e4;
            var n3;
            if ("function" != typeof e4) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t3) {
              if (t3.has(e4)) return t3.get(e4);
              t3.set(e4, r4);
            }
            function r4() {
              return d2(e4, arguments, u2(this).constructor);
            }
            return r4.prototype = Object.create(e4.prototype, { constructor: { value: r4, enumerable: false, writable: true, configurable: true } }), c2(r4, e4);
          })(e3);
        }
        function f2(e3) {
          if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e3;
        }
        function m2(e3) {
          var t3 = p2();
          return function() {
            var n3, r4 = u2(e3);
            if (t3) {
              var o4 = u2(this).constructor;
              n3 = Reflect.construct(r4, arguments, o4);
            } else n3 = r4.apply(this, arguments);
            return function(e4, t4) {
              return !t4 || "object" != typeof t4 && "function" != typeof t4 ? f2(e4) : t4;
            }(this, n3);
          };
        }
        function v2(e3, t3, n3) {
          return (v2 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e4, t4, n4) {
            var r4 = function(e5, t5) {
              for (; !Object.prototype.hasOwnProperty.call(e5, t5) && null !== (e5 = u2(e5)); ) ;
              return e5;
            }(e4, t4);
            if (r4) {
              var o4 = Object.getOwnPropertyDescriptor(r4, t4);
              return o4.get ? o4.get.call(n4) : o4.value;
            }
          })(e3, t3, n3 || e3);
        }
        var g2 = Object.values || function(e3) {
          var t3 = [];
          for (var n3 in e3) t3.push(e3[n3]);
          return t3;
        }, y2 = Object.entries || function(e3) {
          var t3 = [];
          for (var n3 in e3) t3.push([n3, e3[n3]]);
          return t3;
        }, b2 = Object.assign || function(e3) {
          for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r4 = 1; r4 < t3; r4++) n3[r4 - 1] = arguments[r4];
          return n3.forEach(function(t4) {
            for (var n4 in t4) e3[n4] = t4[n4];
          }), e3;
        }, _2 = Object.fromEntries || function(e3) {
          var t3 = {};
          return w2(e3).forEach(function(e4) {
            var n3 = e4[0], r4 = e4[1];
            t3[n3] = r4;
          }), t3;
        }, w2 = Array.from || function(e3) {
          if (e3 instanceof E2) {
            var t3 = [];
            return e3.forEach(function(e4, n3) {
              return t3.push([n3, e4]);
            }), t3;
          }
          return Array.prototype.slice.call(e3);
        };
        function C2(e3) {
          return -1 !== this.indexOf(e3);
        }
        Array.prototype.includes || (Array.prototype.includes = C2), String.prototype.includes || (String.prototype.includes = C2), String.prototype.startsWith || (String.prototype.startsWith = function(e3) {
          var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          return this.substring(t3, t3 + e3.length) === e3;
        }), String.prototype.endsWith || (String.prototype.endsWith = function(e3) {
          var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length;
          return this.substring(t3 - e3.length, t3) === e3;
        });
        var S2 = "undefined" != typeof self ? self : t2, k2 = S2.fetch || function(e3) {
          var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return new Promise(function(n3, r4) {
            var o4 = new XMLHttpRequest();
            if (o4.open("get", e3, true), o4.responseType = "arraybuffer", o4.onerror = r4, t3.headers) for (var i3 in t3.headers) o4.setRequestHeader(i3, t3.headers[i3]);
            o4.onload = function() {
              n3({ ok: o4.status >= 200 && o4.status < 300, status: o4.status, arrayBuffer: function() {
                return Promise.resolve(o4.response);
              } });
            }, o4.send(null);
          });
        }, x2 = function(e3) {
          var t3 = [];
          if (Object.defineProperties(t3, { size: { get: function() {
            return this.length;
          } }, has: { value: function(e4) {
            return -1 !== this.indexOf(e4);
          } }, add: { value: function(e4) {
            this.has(e4) || this.push(e4);
          } }, delete: { value: function(e4) {
            if (this.has(e4)) {
              var t4 = this.indexOf(e4);
              this.splice(t4, 1);
            }
          } } }), Array.isArray(e3)) for (var n3 = 0; n3 < e3.length; n3++) t3.add(e3[n3]);
          return t3;
        }, P2 = function(e3) {
          return new E2(e3);
        }, E2 = void 0 !== S2.Map && void 0 !== S2.Map.prototype.keys ? S2.Map : function() {
          function e3(t3) {
            if (o3(this, e3), this.clear(), t3) for (var n3 = 0; n3 < t3.length; n3++) this.set(t3[n3][0], t3[n3][1]);
          }
          return a2(e3, [{ key: "clear", value: function() {
            this._map = {}, this._keys = [];
          } }, { key: "size", get: function() {
            return this._keys.length;
          } }, { key: "get", value: function(e4) {
            return this._map["map_" + e4];
          } }, { key: "set", value: function(e4, t3) {
            return this._map["map_" + e4] = t3, this._keys.indexOf(e4) < 0 && this._keys.push(e4), this;
          } }, { key: "has", value: function(e4) {
            return this._keys.indexOf(e4) >= 0;
          } }, { key: "delete", value: function(e4) {
            var t3 = this._keys.indexOf(e4);
            return !(t3 < 0 || (delete this._map["map_" + e4], this._keys.splice(t3, 1), 0));
          } }, { key: "keys", value: function() {
            return this._keys.slice(0);
          } }, { key: "values", value: function() {
            var e4 = this;
            return this._keys.map(function(t3) {
              return e4.get(t3);
            });
          } }, { key: "entries", value: function() {
            var e4 = this;
            return this._keys.map(function(t3) {
              return [t3, e4.get(t3)];
            });
          } }, { key: "forEach", value: function(e4, t3) {
            for (var n3 = 0; n3 < this._keys.length; n3++) e4.call(t3, this._map["map_" + this._keys[n3]], this._keys[n3], this);
          } }]), e3;
        }(), O2 = "undefined" != typeof self ? self : t2, A2 = "undefined" != typeof navigator, U2 = A2 && "undefined" == typeof HTMLImageElement, N2 = !(void 0 === t2 || void 0 === e2 || !e2.versions || !e2.versions.node), T2 = O2.Buffer, R2 = !!T2, F2 = function(e3) {
          return void 0 !== e3;
        };
        function D2(e3) {
          return void 0 === e3 || (e3 instanceof E2 ? 0 === e3.size : 0 === g2(e3).filter(F2).length);
        }
        function M2(e3) {
          var t3 = new Error(e3);
          throw delete t3.stack, t3;
        }
        function B2(e3) {
          var t3 = function(e4) {
            var t4 = 0;
            return e4.ifd0.enabled && (t4 += 1024), e4.exif.enabled && (t4 += 2048), e4.makerNote && (t4 += 2048), e4.userComment && (t4 += 1024), e4.gps.enabled && (t4 += 512), e4.interop.enabled && (t4 += 100), e4.ifd1.enabled && (t4 += 1024), t4 + 2048;
          }(e3);
          return e3.jfif.enabled && (t3 += 50), e3.xmp.enabled && (t3 += 2e4), e3.iptc.enabled && (t3 += 14e3), e3.icc.enabled && (t3 += 6e3), t3;
        }
        var I2 = function(e3) {
          return String.fromCharCode.apply(null, e3);
        }, L2 = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0, j2 = function() {
          function e3(t3) {
            var n3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, r4 = arguments.length > 2 ? arguments[2] : void 0, i3 = arguments.length > 3 ? arguments[3] : void 0;
            if (o3(this, e3), "boolean" == typeof i3 && (this.le = i3), Array.isArray(t3) && (t3 = new Uint8Array(t3)), 0 === t3) this.byteOffset = 0, this.byteLength = 0;
            else if (t3 instanceof ArrayBuffer) {
              void 0 === r4 && (r4 = t3.byteLength - n3);
              var a3 = new DataView(t3, n3, r4);
              this._swapDataView(a3);
            } else if (t3 instanceof Uint8Array || t3 instanceof DataView || t3 instanceof e3) {
              void 0 === r4 && (r4 = t3.byteLength - n3), (n3 += t3.byteOffset) + r4 > t3.byteOffset + t3.byteLength && M2("Creating view outside of available memory in ArrayBuffer");
              var s3 = new DataView(t3.buffer, n3, r4);
              this._swapDataView(s3);
            } else if ("number" == typeof t3) {
              var l3 = new DataView(new ArrayBuffer(t3));
              this._swapDataView(l3);
            } else M2("Invalid input argument for BufferView: " + t3);
          }
          return a2(e3, [{ key: "_swapArrayBuffer", value: function(e4) {
            this._swapDataView(new DataView(e4));
          } }, { key: "_swapBuffer", value: function(e4) {
            this._swapDataView(new DataView(e4.buffer, e4.byteOffset, e4.byteLength));
          } }, { key: "_swapDataView", value: function(e4) {
            this.dataView = e4, this.buffer = e4.buffer, this.byteOffset = e4.byteOffset, this.byteLength = e4.byteLength;
          } }, { key: "_lengthToEnd", value: function(e4) {
            return this.byteLength - e4;
          } }, { key: "set", value: function(t3, n3) {
            var r4 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e3;
            return t3 instanceof DataView || t3 instanceof e3 ? t3 = new Uint8Array(t3.buffer, t3.byteOffset, t3.byteLength) : t3 instanceof ArrayBuffer && (t3 = new Uint8Array(t3)), t3 instanceof Uint8Array || M2("BufferView.set(): Invalid data argument."), this.toUint8().set(t3, n3), new r4(this, n3, t3.byteLength);
          } }, { key: "subarray", value: function(t3, n3) {
            return new e3(this, t3, n3 = n3 || this._lengthToEnd(t3));
          } }, { key: "toUint8", value: function() {
            return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
          } }, { key: "getUint8Array", value: function(e4, t3) {
            return new Uint8Array(this.buffer, this.byteOffset + e4, t3);
          } }, { key: "getString", value: function() {
            var e4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.byteLength;
            return function(e5) {
              return L2 ? L2.decode(e5) : R2 ? n2.from(e5).toString("utf8") : decodeURIComponent(escape(I2(e5)));
            }(this.getUint8Array(e4, t3));
          } }, { key: "getLatin1String", value: function() {
            var e4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.byteLength, n3 = this.getUint8Array(e4, t3);
            return I2(n3);
          } }, { key: "getUnicodeString", value: function() {
            for (var e4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.byteLength, n3 = [], r4 = 0; r4 < t3 && e4 + r4 < this.byteLength; r4 += 2) n3.push(this.getUint16(e4 + r4));
            return I2(n3);
          } }, { key: "getInt8", value: function(e4) {
            return this.dataView.getInt8(e4);
          } }, { key: "getUint8", value: function(e4) {
            return this.dataView.getUint8(e4);
          } }, { key: "getInt16", value: function(e4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.le;
            return this.dataView.getInt16(e4, t3);
          } }, { key: "getInt32", value: function(e4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.le;
            return this.dataView.getInt32(e4, t3);
          } }, { key: "getUint16", value: function(e4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.le;
            return this.dataView.getUint16(e4, t3);
          } }, { key: "getUint32", value: function(e4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.le;
            return this.dataView.getUint32(e4, t3);
          } }, { key: "getFloat32", value: function(e4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.le;
            return this.dataView.getFloat32(e4, t3);
          } }, { key: "getFloat64", value: function(e4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.le;
            return this.dataView.getFloat64(e4, t3);
          } }, { key: "getFloat", value: function(e4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.le;
            return this.dataView.getFloat32(e4, t3);
          } }, { key: "getDouble", value: function(e4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.le;
            return this.dataView.getFloat64(e4, t3);
          } }, { key: "getUintBytes", value: function(e4, t3, n3) {
            switch (t3) {
              case 1:
                return this.getUint8(e4, n3);
              case 2:
                return this.getUint16(e4, n3);
              case 4:
                return this.getUint32(e4, n3);
              case 8:
                return this.getUint64 && this.getUint64(e4, n3);
            }
          } }, { key: "getUint", value: function(e4, t3, n3) {
            switch (t3) {
              case 8:
                return this.getUint8(e4, n3);
              case 16:
                return this.getUint16(e4, n3);
              case 32:
                return this.getUint32(e4, n3);
              case 64:
                return this.getUint64 && this.getUint64(e4, n3);
            }
          } }, { key: "toString", value: function(e4) {
            return this.dataView.toString(e4, this.constructor.name);
          } }, { key: "ensureChunk", value: function() {
          } }], [{ key: "from", value: function(t3, n3) {
            return t3 instanceof this && t3.le === n3 ? t3 : new e3(t3, void 0, void 0, n3);
          } }]), e3;
        }();
        function z2(e3, t3) {
          M2("".concat(e3, " '").concat(t3, "' was not loaded, try using full build of exifr."));
        }
        var H2 = function(e3) {
          l2(n3, h2(E2));
          var t3 = m2(n3);
          function n3(e4) {
            var r4;
            return o3(this, n3), (r4 = t3.call(this)).kind = e4, r4;
          }
          return a2(n3, [{ key: "get", value: function(e4, t4) {
            return this.has(e4) || z2(this.kind, e4), t4 && (e4 in t4 || function(e5, t5) {
              M2("Unknown ".concat(e5, " '").concat(t5, "'."));
            }(this.kind, e4), t4[e4].enabled || z2(this.kind, e4)), v2(u2(n3.prototype), "get", this).call(this, e4);
          } }, { key: "keyList", value: function() {
            return w2(this.keys());
          } }]), n3;
        }(), W2 = new H2("file parser"), V2 = new H2("segment parser"), q2 = new H2("file reader");
        function X2(e3) {
          return function() {
            for (var t3 = [], n3 = 0; n3 < arguments.length; n3++) t3[n3] = arguments[n3];
            try {
              return Promise.resolve(e3.apply(this, t3));
            } catch (e4) {
              return Promise.reject(e4);
            }
          };
        }
        function G2(e3, t3, n3) {
          return n3 ? t3 ? t3(e3) : e3 : (e3 && e3.then || (e3 = Promise.resolve(e3)), t3 ? e3.then(t3) : e3);
        }
        var Y2 = X2(function(e3) {
          return new Promise(function(t3, n3) {
            var r4 = new FileReader();
            r4.onloadend = function() {
              return t3(r4.result || new ArrayBuffer());
            }, r4.onerror = n3, r4.readAsArrayBuffer(e3);
          });
        }), $2 = X2(function(e3) {
          return k2(e3).then(function(e4) {
            return e4.arrayBuffer();
          });
        }), K2 = X2(function(e3, t3) {
          return G2(t3(e3), function(e4) {
            return new j2(e4);
          });
        }), J2 = X2(function(e3, t3, n3) {
          var r4 = new (q2.get(n3))(e3, t3);
          return G2(r4.read(), function() {
            return r4;
          });
        }), Q2 = X2(function(e3, t3, n3, r4) {
          return q2.has(n3) ? J2(e3, t3, n3) : r4 ? K2(e3, r4) : (M2("Parser ".concat(n3, " is not loaded")), G2());
        }), Z2 = "Invalid input argument";
        function ee2(e3, t3) {
          return (n3 = e3).startsWith("data:") || n3.length > 1e4 ? J2(e3, t3, "base64") : A2 ? Q2(e3, t3, "url", $2) : N2 ? J2(e3, t3, "fs") : void M2(Z2);
          var n3;
        }
        var te2 = function(e3) {
          l2(n3, h2(E2));
          var t3 = m2(n3);
          function n3() {
            return o3(this, n3), t3.apply(this, arguments);
          }
          return a2(n3, [{ key: "tagKeys", get: function() {
            return this.allKeys || (this.allKeys = w2(this.keys())), this.allKeys;
          } }, { key: "tagValues", get: function() {
            return this.allValues || (this.allValues = w2(this.values())), this.allValues;
          } }]), n3;
        }();
        function ne2(e3, t3, n3) {
          var r4 = new te2(), o4 = n3;
          Array.isArray(o4) || ("function" == typeof o4.entries && (o4 = o4.entries()), o4 = w2(o4));
          for (var i3 = 0; i3 < o4.length; i3++) {
            var a3 = o4[i3], s3 = a3[0], l3 = a3[1];
            r4.set(s3, l3);
          }
          if (Array.isArray(t3)) {
            var u3 = t3;
            Array.isArray(u3) || ("function" == typeof u3.entries && (u3 = u3.entries()), u3 = w2(u3));
            for (var c3 = 0; c3 < u3.length; c3++) {
              var p3 = u3[c3];
              e3.set(p3, r4);
            }
          } else e3.set(t3, r4);
          return r4;
        }
        function re2(e3, t3, n3) {
          var r4, o4 = e3.get(t3), i3 = n3;
          Array.isArray(i3) || ("function" == typeof i3.entries && (i3 = i3.entries()), i3 = w2(i3));
          for (var a3 = 0; a3 < i3.length; a3++) r4 = i3[a3], o4.set(r4[0], r4[1]);
        }
        var oe2 = P2(), ie2 = P2(), ae2 = P2(), se2 = 37500, le2 = 37510, ue2 = 40965, ce2 = ["chunked", "firstChunkSize", "firstChunkSizeNode", "firstChunkSizeBrowser", "chunkSize", "chunkLimit"], pe2 = ["jfif", "xmp", "icc", "iptc", "ihdr"], de2 = ["tiff"].concat(pe2), he2 = ["ifd0", "ifd1", "exif", "gps", "interop"], fe2 = [].concat(de2, he2), me2 = ["makerNote", "userComment"], ve2 = ["translateKeys", "translateValues", "reviveValues", "multiSegment"], ge2 = [].concat(ve2, ["sanitize", "mergeOutput", "silentErrors"]), ye2 = function() {
          function e3() {
            o3(this, e3);
          }
          return a2(e3, [{ key: "translate", get: function() {
            return this.translateKeys || this.translateValues || this.reviveValues;
          } }]), e3;
        }(), be2 = function(e3) {
          l2(n3, ye2);
          var t3 = m2(n3);
          function n3(e4, r4, i3, a3) {
            var l3;
            if (o3(this, n3), s2(f2(l3 = t3.call(this)), "enabled", false), s2(f2(l3), "skip", x2()), s2(f2(l3), "pick", x2()), s2(f2(l3), "deps", x2()), s2(f2(l3), "translateKeys", false), s2(f2(l3), "translateValues", false), s2(f2(l3), "reviveValues", false), l3.key = e4, l3.enabled = r4, l3.parse = l3.enabled, l3.applyInheritables(a3), l3.canBeFiltered = he2.includes(e4), l3.canBeFiltered && (l3.dict = oe2.get(e4)), void 0 !== i3) if (Array.isArray(i3)) l3.parse = l3.enabled = true, l3.canBeFiltered && i3.length > 0 && l3.translateTagSet(i3, l3.pick);
            else if ("object" == typeof i3) {
              if (l3.enabled = true, l3.parse = false !== i3.parse, l3.canBeFiltered) {
                var u3 = i3.pick, c3 = i3.skip;
                u3 && u3.length > 0 && l3.translateTagSet(u3, l3.pick), c3 && c3.length > 0 && l3.translateTagSet(c3, l3.skip);
              }
              l3.applyInheritables(i3);
            } else true === i3 || false === i3 ? l3.parse = l3.enabled = i3 : M2("Invalid options argument: ".concat(i3));
            return l3;
          }
          return a2(n3, [{ key: "needed", get: function() {
            return this.enabled || this.deps.size > 0;
          } }, { key: "applyInheritables", value: function(e4) {
            var t4, n4, r4 = ve2;
            Array.isArray(r4) || ("function" == typeof r4.entries && (r4 = r4.entries()), r4 = w2(r4));
            for (var o4 = 0; o4 < r4.length; o4++) void 0 !== (n4 = e4[t4 = r4[o4]]) && (this[t4] = n4);
          } }, { key: "translateTagSet", value: function(e4, t4) {
            if (this.dict) {
              var n4, r4, o4 = this.dict, i3 = o4.tagKeys, a3 = o4.tagValues, s3 = e4;
              Array.isArray(s3) || ("function" == typeof s3.entries && (s3 = s3.entries()), s3 = w2(s3));
              for (var l3 = 0; l3 < s3.length; l3++) "string" == typeof (n4 = s3[l3]) ? (-1 === (r4 = a3.indexOf(n4)) && (r4 = i3.indexOf(Number(n4))), -1 !== r4 && t4.add(Number(i3[r4]))) : t4.add(n4);
            } else {
              var u3 = e4;
              Array.isArray(u3) || ("function" == typeof u3.entries && (u3 = u3.entries()), u3 = w2(u3));
              for (var c3 = 0; c3 < u3.length; c3++) {
                var p3 = u3[c3];
                t4.add(p3);
              }
            }
          } }, { key: "finalizeFilters", value: function() {
            !this.enabled && this.deps.size > 0 ? (this.enabled = true, xe2(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && xe2(this.pick, this.deps);
          } }]), n3;
        }(), _e2 = { jfif: false, tiff: true, xmp: false, icc: false, iptc: false, ifd0: true, ifd1: false, exif: true, gps: true, interop: false, ihdr: void 0, makerNote: false, userComment: false, multiSegment: false, skip: [], pick: [], translateKeys: true, translateValues: true, reviveValues: true, sanitize: true, mergeOutput: true, silentErrors: true, chunked: true, firstChunkSize: void 0, firstChunkSizeNode: 512, firstChunkSizeBrowser: 65536, chunkSize: 65536, chunkLimit: 5 }, we2 = P2(), Ce2 = function(e3) {
          l2(n3, ye2);
          var t3 = m2(n3);
          function n3(e4) {
            var r4;
            return o3(this, n3), r4 = t3.call(this), true === e4 ? r4.setupFromTrue() : void 0 === e4 ? r4.setupFromUndefined() : Array.isArray(e4) ? r4.setupFromArray(e4) : "object" == typeof e4 ? r4.setupFromObject(e4) : M2("Invalid options argument ".concat(e4)), void 0 === r4.firstChunkSize && (r4.firstChunkSize = A2 ? r4.firstChunkSizeBrowser : r4.firstChunkSizeNode), r4.mergeOutput && (r4.ifd1.enabled = false), r4.filterNestedSegmentTags(), r4.traverseTiffDependencyTree(), r4.checkLoadedPlugins(), r4;
          }
          return a2(n3, [{ key: "setupFromUndefined", value: function() {
            var e4, t4 = ce2;
            Array.isArray(t4) || ("function" == typeof t4.entries && (t4 = t4.entries()), t4 = w2(t4));
            for (var n4 = 0; n4 < t4.length; n4++) this[e4 = t4[n4]] = _e2[e4];
            var r4 = ge2;
            Array.isArray(r4) || ("function" == typeof r4.entries && (r4 = r4.entries()), r4 = w2(r4));
            for (var o4 = 0; o4 < r4.length; o4++) this[e4 = r4[o4]] = _e2[e4];
            var i3 = me2;
            Array.isArray(i3) || ("function" == typeof i3.entries && (i3 = i3.entries()), i3 = w2(i3));
            for (var a3 = 0; a3 < i3.length; a3++) this[e4 = i3[a3]] = _e2[e4];
            var s3 = fe2;
            Array.isArray(s3) || ("function" == typeof s3.entries && (s3 = s3.entries()), s3 = w2(s3));
            for (var l3 = 0; l3 < s3.length; l3++) this[e4 = s3[l3]] = new be2(e4, _e2[e4], void 0, this);
          } }, { key: "setupFromTrue", value: function() {
            var e4, t4 = ce2;
            Array.isArray(t4) || ("function" == typeof t4.entries && (t4 = t4.entries()), t4 = w2(t4));
            for (var n4 = 0; n4 < t4.length; n4++) this[e4 = t4[n4]] = _e2[e4];
            var r4 = ge2;
            Array.isArray(r4) || ("function" == typeof r4.entries && (r4 = r4.entries()), r4 = w2(r4));
            for (var o4 = 0; o4 < r4.length; o4++) this[e4 = r4[o4]] = _e2[e4];
            var i3 = me2;
            Array.isArray(i3) || ("function" == typeof i3.entries && (i3 = i3.entries()), i3 = w2(i3));
            for (var a3 = 0; a3 < i3.length; a3++) this[e4 = i3[a3]] = true;
            var s3 = fe2;
            Array.isArray(s3) || ("function" == typeof s3.entries && (s3 = s3.entries()), s3 = w2(s3));
            for (var l3 = 0; l3 < s3.length; l3++) this[e4 = s3[l3]] = new be2(e4, true, void 0, this);
          } }, { key: "setupFromArray", value: function(e4) {
            var t4, n4 = ce2;
            Array.isArray(n4) || ("function" == typeof n4.entries && (n4 = n4.entries()), n4 = w2(n4));
            for (var r4 = 0; r4 < n4.length; r4++) this[t4 = n4[r4]] = _e2[t4];
            var o4 = ge2;
            Array.isArray(o4) || ("function" == typeof o4.entries && (o4 = o4.entries()), o4 = w2(o4));
            for (var i3 = 0; i3 < o4.length; i3++) this[t4 = o4[i3]] = _e2[t4];
            var a3 = me2;
            Array.isArray(a3) || ("function" == typeof a3.entries && (a3 = a3.entries()), a3 = w2(a3));
            for (var s3 = 0; s3 < a3.length; s3++) this[t4 = a3[s3]] = _e2[t4];
            var l3 = fe2;
            Array.isArray(l3) || ("function" == typeof l3.entries && (l3 = l3.entries()), l3 = w2(l3));
            for (var u3 = 0; u3 < l3.length; u3++) this[t4 = l3[u3]] = new be2(t4, false, void 0, this);
            this.setupGlobalFilters(e4, void 0, he2);
          } }, { key: "setupFromObject", value: function(e4) {
            var t4;
            he2.ifd0 = he2.ifd0 || he2.image, he2.ifd1 = he2.ifd1 || he2.thumbnail, b2(this, e4);
            var n4 = ce2;
            Array.isArray(n4) || ("function" == typeof n4.entries && (n4 = n4.entries()), n4 = w2(n4));
            for (var r4 = 0; r4 < n4.length; r4++) this[t4 = n4[r4]] = ke2(e4[t4], _e2[t4]);
            var o4 = ge2;
            Array.isArray(o4) || ("function" == typeof o4.entries && (o4 = o4.entries()), o4 = w2(o4));
            for (var i3 = 0; i3 < o4.length; i3++) this[t4 = o4[i3]] = ke2(e4[t4], _e2[t4]);
            var a3 = me2;
            Array.isArray(a3) || ("function" == typeof a3.entries && (a3 = a3.entries()), a3 = w2(a3));
            for (var s3 = 0; s3 < a3.length; s3++) this[t4 = a3[s3]] = ke2(e4[t4], _e2[t4]);
            var l3 = de2;
            Array.isArray(l3) || ("function" == typeof l3.entries && (l3 = l3.entries()), l3 = w2(l3));
            for (var u3 = 0; u3 < l3.length; u3++) this[t4 = l3[u3]] = new be2(t4, _e2[t4], e4[t4], this);
            var c3 = he2;
            Array.isArray(c3) || ("function" == typeof c3.entries && (c3 = c3.entries()), c3 = w2(c3));
            for (var p3 = 0; p3 < c3.length; p3++) this[t4 = c3[p3]] = new be2(t4, _e2[t4], e4[t4], this.tiff);
            this.setupGlobalFilters(e4.pick, e4.skip, he2, fe2), true === e4.tiff ? this.batchEnableWithBool(he2, true) : false === e4.tiff ? this.batchEnableWithUserValue(he2, e4) : Array.isArray(e4.tiff) ? this.setupGlobalFilters(e4.tiff, void 0, he2) : "object" == typeof e4.tiff && this.setupGlobalFilters(e4.tiff.pick, e4.tiff.skip, he2);
          } }, { key: "batchEnableWithBool", value: function(e4, t4) {
            var n4 = e4;
            Array.isArray(n4) || ("function" == typeof n4.entries && (n4 = n4.entries()), n4 = w2(n4));
            for (var r4 = 0; r4 < n4.length; r4++) this[n4[r4]].enabled = t4;
          } }, { key: "batchEnableWithUserValue", value: function(e4, t4) {
            var n4 = e4;
            Array.isArray(n4) || ("function" == typeof n4.entries && (n4 = n4.entries()), n4 = w2(n4));
            for (var r4 = 0; r4 < n4.length; r4++) {
              var o4 = n4[r4], i3 = t4[o4];
              this[o4].enabled = false !== i3 && void 0 !== i3;
            }
          } }, { key: "setupGlobalFilters", value: function(e4, t4, n4) {
            var r4 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : n4;
            if (e4 && e4.length) {
              var o4 = r4;
              Array.isArray(o4) || ("function" == typeof o4.entries && (o4 = o4.entries()), o4 = w2(o4));
              for (var i3 = 0; i3 < o4.length; i3++) this[o4[i3]].enabled = false;
              var a3 = Se2(e4, n4);
              Array.isArray(a3) || ("function" == typeof a3.entries && (a3 = a3.entries()), a3 = w2(a3));
              for (var s3 = 0; s3 < a3.length; s3++) {
                var l3 = a3[s3], u3 = l3[0], c3 = l3[1];
                xe2(this[u3].pick, c3), this[u3].enabled = true;
              }
            } else if (t4 && t4.length) {
              var p3 = Se2(t4, n4);
              Array.isArray(p3) || ("function" == typeof p3.entries && (p3 = p3.entries()), p3 = w2(p3));
              for (var d3 = 0; d3 < p3.length; d3++) {
                var h3 = p3[d3], f3 = h3[0], m3 = h3[1];
                xe2(this[f3].skip, m3);
              }
            }
          } }, { key: "filterNestedSegmentTags", value: function() {
            var e4 = this.ifd0, t4 = this.exif, n4 = this.xmp, r4 = this.iptc, o4 = this.icc;
            this.makerNote ? t4.deps.add(se2) : t4.skip.add(se2), this.userComment ? t4.deps.add(le2) : t4.skip.add(le2), n4.enabled || e4.skip.add(700), r4.enabled || e4.skip.add(33723), o4.enabled || e4.skip.add(34675);
          } }, { key: "traverseTiffDependencyTree", value: function() {
            var e4 = this, t4 = this.ifd0, n4 = this.exif, r4 = this.gps;
            this.interop.needed && (n4.deps.add(ue2), t4.deps.add(ue2)), n4.needed && t4.deps.add(34665), r4.needed && t4.deps.add(34853), this.tiff.enabled = he2.some(function(t5) {
              return true === e4[t5].enabled;
            }) || this.makerNote || this.userComment;
            var o4 = he2;
            Array.isArray(o4) || ("function" == typeof o4.entries && (o4 = o4.entries()), o4 = w2(o4));
            for (var i3 = 0; i3 < o4.length; i3++) this[o4[i3]].finalizeFilters();
          } }, { key: "onlyTiff", get: function() {
            var e4 = this;
            return !pe2.map(function(t4) {
              return e4[t4].enabled;
            }).some(function(e5) {
              return true === e5;
            }) && this.tiff.enabled;
          } }, { key: "checkLoadedPlugins", value: function() {
            var e4 = de2;
            Array.isArray(e4) || ("function" == typeof e4.entries && (e4 = e4.entries()), e4 = w2(e4));
            for (var t4 = 0; t4 < e4.length; t4++) {
              var n4 = e4[t4];
              this[n4].enabled && !V2.has(n4) && z2("segment parser", n4);
            }
          } }], [{ key: "useCached", value: function(e4) {
            var t4 = we2.get(e4);
            return void 0 !== t4 || (t4 = new this(e4), we2.set(e4, t4)), t4;
          } }]), n3;
        }();
        function Se2(e3, t3) {
          var n3, r4, o4, i3 = [], a3 = t3;
          Array.isArray(a3) || ("function" == typeof a3.entries && (a3 = a3.entries()), a3 = w2(a3));
          for (var s3 = 0; s3 < a3.length; s3++) {
            r4 = a3[s3], n3 = [];
            var l3 = oe2.get(r4);
            Array.isArray(l3) || ("function" == typeof l3.entries && (l3 = l3.entries()), l3 = w2(l3));
            for (var u3 = 0; u3 < l3.length; u3++) o4 = l3[u3], (e3.includes(o4[0]) || e3.includes(o4[1])) && n3.push(o4[0]);
            n3.length && i3.push([r4, n3]);
          }
          return i3;
        }
        function ke2(e3, t3) {
          return void 0 !== e3 ? e3 : void 0 !== t3 ? t3 : void 0;
        }
        function xe2(e3, t3) {
          var n3 = t3;
          Array.isArray(n3) || ("function" == typeof n3.entries && (n3 = n3.entries()), n3 = w2(n3));
          for (var r4 = 0; r4 < n3.length; r4++) {
            var o4 = n3[r4];
            e3.add(o4);
          }
        }
        function Pe2(e3, t3, n3) {
          return n3 ? t3 ? t3(e3) : e3 : (e3 && e3.then || (e3 = Promise.resolve(e3)), t3 ? e3.then(t3) : e3);
        }
        function Ee2() {
        }
        function Oe2(e3, t3) {
          if (!t3) return e3 && e3.then ? e3.then(Ee2) : Promise.resolve();
        }
        function Ae2(e3, t3) {
          var n3 = e3();
          return n3 && n3.then ? n3.then(t3) : t3(n3);
        }
        s2(Ce2, "default", _e2);
        var Ue2, Ne2 = function() {
          function e3(t3) {
            o3(this, e3), s2(this, "parsers", {}), this.options = Ce2.useCached(t3);
          }
          return a2(e3, [{ key: "setup", value: function() {
            if (!this.fileParser) {
              var e4 = this.file, t3 = e4.getUint16(0), n3 = W2;
              Array.isArray(n3) || ("function" == typeof n3.entries && (n3 = n3.entries()), n3 = w2(n3));
              for (var r4 = 0; r4 < n3.length; r4++) {
                var o4 = n3[r4], i3 = o4[0], a3 = o4[1];
                if (a3.canHandle(e4, t3)) return this.fileParser = new a3(this.options, this.file, this.parsers), e4[i3] = true;
              }
              M2("Unknown file format");
            }
          } }, { key: "read", value: function(e4) {
            try {
              var t3 = this;
              return Pe2(function(e5, t4) {
                return "string" == typeof e5 ? ee2(e5, t4) : A2 && !U2 && e5 instanceof HTMLImageElement ? ee2(e5.src, t4) : e5 instanceof Uint8Array || e5 instanceof ArrayBuffer || e5 instanceof DataView ? new j2(e5) : A2 && e5 instanceof Blob ? Q2(e5, t4, "blob", Y2) : void M2(Z2);
              }(e4, t3.options), function(e5) {
                t3.file = e5;
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "parse", value: function() {
            try {
              var e4 = this;
              e4.setup();
              var t3 = {}, n3 = [];
              return Ae2(function() {
                return e4.options.silentErrors ? Pe2(e4.doParse(t3, n3).catch(function(e5) {
                  return n3.push(e5);
                }), function() {
                  n3.push.apply(n3, e4.fileParser.errors);
                }) : Oe2(e4.doParse(t3, n3));
              }, function() {
                return e4.file.close && e4.file.close(), e4.options.silentErrors && n3.length > 0 && (t3.errors = n3), D2(r4 = t3) ? void 0 : r4;
                var r4;
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "doParse", value: function(e4, t3) {
            try {
              var n3 = this;
              return Pe2(n3.fileParser.parse(), function() {
                var r4, o4 = g2(n3.parsers).map((r4 = function(t4) {
                  return Pe2(t4.parse(), function(n4) {
                    t4.assignToOutput(e4, n4);
                  });
                }, function() {
                  for (var e5 = [], t4 = 0; t4 < arguments.length; t4++) e5[t4] = arguments[t4];
                  try {
                    return Promise.resolve(r4.apply(this, e5));
                  } catch (e6) {
                    return Promise.reject(e6);
                  }
                }));
                if (n3.options.silentErrors) {
                  var i3 = function(e5) {
                    return t3.push(e5);
                  };
                  o4 = o4.map(function(e5) {
                    return e5.catch(i3);
                  });
                }
                return Oe2(Promise.all(o4));
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "extractThumbnail", value: function() {
            try {
              var e4 = this;
              e4.setup();
              var t3, n3 = e4.options, r4 = e4.file, o4 = V2.get("tiff", n3);
              return Ae2(function() {
                if (!r4.tiff) return function(e5) {
                  var t4 = e5();
                  if (t4 && t4.then) return t4.then(Ee2);
                }(function() {
                  if (r4.jpeg) return Pe2(e4.fileParser.getOrFindSegment("tiff"), function(e5) {
                    t3 = e5;
                  });
                });
                t3 = { start: 0, type: "tiff" };
              }, function() {
                if (void 0 !== t3) return Pe2(e4.fileParser.ensureSegmentChunk(t3), function(t4) {
                  return Pe2((e4.parsers.tiff = new o4(t4, n3, r4)).extractThumbnail(), function(e5) {
                    return r4.close && r4.close(), e5;
                  });
                });
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }]), e3;
        }(), Te2 = (Ue2 = function(e3, t3) {
          var n3, r4, o4 = new Ne2(t3);
          return r4 = function() {
            return o4.parse();
          }, (n3 = o4.read(e3)) && n3.then || (n3 = Promise.resolve(n3)), r4 ? n3.then(r4) : n3;
        }, function() {
          for (var e3 = [], t3 = 0; t3 < arguments.length; t3++) e3[t3] = arguments[t3];
          try {
            return Promise.resolve(Ue2.apply(this, e3));
          } catch (e4) {
            return Promise.reject(e4);
          }
        }), Re2 = Object.freeze({ __proto__: null, parse: Te2, Exifr: Ne2, fileParsers: W2, segmentParsers: V2, fileReaders: q2, tagKeys: oe2, tagValues: ie2, tagRevivers: ae2, createDictionary: ne2, extendDictionary: re2, fetchUrlAsArrayBuffer: $2, readBlobAsArrayBuffer: Y2, chunkedProps: ce2, otherSegments: pe2, segments: de2, tiffBlocks: he2, segmentsAndBlocks: fe2, tiffExtractables: me2, inheritables: ve2, allFormatters: ge2, Options: Ce2 });
        function Fe2() {
        }
        var De2 = function() {
          function e3(t3, n3, r4) {
            var i3 = this;
            o3(this, e3), s2(this, "errors", []), s2(this, "ensureSegmentChunk", function() {
              for (var t4 = [], n4 = 0; n4 < arguments.length; n4++) t4[n4] = arguments[n4];
              try {
                return Promise.resolve(function(e4) {
                  var t5, n5, r5, o4 = e4.start, a3 = e4.size || 65536;
                  return t5 = function() {
                    if (i3.file.chunked) return function(e5) {
                      var t6 = e5();
                      if (t6 && t6.then) return t6.then(Fe2);
                    }(function() {
                      if (!i3.file.available(o4, a3)) return function(e5) {
                        if (e5 && e5.then) return e5.then(Fe2);
                      }(function(e5, t6) {
                        try {
                          var n6 = e5();
                        } catch (e6) {
                          return t6(e6);
                        }
                        return n6 && n6.then ? n6.then(void 0, t6) : n6;
                      }(function() {
                        return n6 = function(t7) {
                          e4.chunk = t7;
                        }, (t6 = i3.file.readChunk(o4, a3)) && t6.then || (t6 = Promise.resolve(t6)), n6 ? t6.then(n6) : t6;
                        var t6, n6;
                      }, function(t6) {
                        M2("Couldn't read segment: ".concat(JSON.stringify(e4), ". ").concat(t6.message));
                      }));
                      e4.chunk = i3.file.subarray(o4, a3);
                    });
                    i3.file.byteLength > o4 + a3 ? e4.chunk = i3.file.subarray(o4, a3) : void 0 === e4.size ? e4.chunk = i3.file.subarray(o4) : M2("Segment unreachable: " + JSON.stringify(e4));
                  }, n5 = function() {
                    return e4.chunk;
                  }, (r5 = t5()) && r5.then ? r5.then(n5) : n5();
                }.apply(this, t4));
              } catch (e4) {
                return Promise.reject(e4);
              }
            }), this.extendOptions && this.extendOptions(t3), this.options = t3, this.file = n3, this.parsers = r4;
          }
          return a2(e3, [{ key: "injectSegment", value: function(e4, t3) {
            this.options[e4].enabled && this.createParser(e4, t3);
          } }, { key: "createParser", value: function(e4, t3) {
            var n3 = new (V2.get(e4))(t3, this.options, this.file);
            return this.parsers[e4] = n3;
          } }, { key: "createParsers", value: function(e4) {
            var t3 = e4;
            Array.isArray(t3) || ("function" == typeof t3.entries && (t3 = t3.entries()), t3 = w2(t3));
            for (var n3 = 0; n3 < t3.length; n3++) {
              var r4 = t3[n3], o4 = r4.type, i3 = r4.chunk, a3 = this.options[o4];
              if (a3 && a3.enabled) {
                var s3 = this.parsers[o4];
                s3 && s3.append || s3 || this.createParser(o4, i3);
              }
            }
          } }, { key: "readSegments", value: function(e4) {
            try {
              var t3 = e4.map(this.ensureSegmentChunk);
              return function(e5, t4) {
                return e5 && e5.then ? e5.then(Fe2) : Promise.resolve();
              }(Promise.all(t3));
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }]), e3;
        }(), Me2 = function() {
          function e3(t3) {
            var n3 = this, r4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i3 = arguments.length > 2 ? arguments[2] : void 0;
            o3(this, e3), s2(this, "errors", []), s2(this, "raw", P2()), s2(this, "handleError", function(e4) {
              if (!n3.options.silentErrors) throw e4;
              n3.errors.push(e4.message);
            }), this.chunk = this.normalizeInput(t3), this.file = i3, this.type = this.constructor.type, this.globalOptions = this.options = r4, this.localOptions = r4[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
          }
          return a2(e3, [{ key: "normalizeInput", value: function(e4) {
            return e4 instanceof j2 ? e4 : new j2(e4);
          } }, { key: "translate", value: function() {
            this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
          } }, { key: "output", get: function() {
            return this.translated ? this.translated : this.raw ? _2(this.raw) : void 0;
          } }, { key: "translateBlock", value: function(e4, t3) {
            var n3 = ae2.get(t3), r4 = ie2.get(t3), o4 = oe2.get(t3), i3 = this.options[t3], a3 = i3.reviveValues && !!n3, s3 = i3.translateValues && !!r4, l3 = i3.translateKeys && !!o4, u3 = {}, c3 = e4;
            Array.isArray(c3) || ("function" == typeof c3.entries && (c3 = c3.entries()), c3 = w2(c3));
            for (var p3 = 0; p3 < c3.length; p3++) {
              var d3 = c3[p3], h3 = d3[0], f3 = d3[1];
              a3 && n3.has(h3) ? f3 = n3.get(h3)(f3) : s3 && r4.has(h3) && (f3 = this.translateValue(f3, r4.get(h3))), l3 && o4.has(h3) && (h3 = o4.get(h3) || h3), u3[h3] = f3;
            }
            return u3;
          } }, { key: "translateValue", value: function(e4, t3) {
            return t3[e4] || t3.DEFAULT || e4;
          } }, { key: "assignToOutput", value: function(e4, t3) {
            this.assignObjectToOutput(e4, this.constructor.type, t3);
          } }, { key: "assignObjectToOutput", value: function(e4, t3, n3) {
            if (this.globalOptions.mergeOutput) return b2(e4, n3);
            e4[t3] ? b2(e4[t3], n3) : e4[t3] = n3;
          } }], [{ key: "findPosition", value: function(e4, t3) {
            var n3 = e4.getUint16(t3 + 2) + 2, r4 = "function" == typeof this.headerLength ? this.headerLength(e4, t3, n3) : this.headerLength, o4 = t3 + r4, i3 = n3 - r4;
            return { offset: t3, length: n3, headerLength: r4, start: o4, size: i3, end: o4 + i3 };
          } }, { key: "parse", value: function(e4) {
            var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return new this(e4, new Ce2(s2({}, this.type, t3))).parse();
          } }]), e3;
        }();
        function Be2(e3, t3, n3) {
          return n3 ? t3 ? t3(e3) : e3 : (e3 && e3.then || (e3 = Promise.resolve(e3)), t3 ? e3.then(t3) : e3);
        }
        function Ie2() {
        }
        function Le2(e3, t3) {
          var n3 = e3();
          return n3 && n3.then ? n3.then(t3) : t3(n3);
        }
        function je2(e3, t3, n3) {
          if (!e3.s) {
            if (n3 instanceof ze2) {
              if (!n3.s) return void (n3.o = je2.bind(null, e3, t3));
              1 & t3 && (t3 = n3.s), n3 = n3.v;
            }
            if (n3 && n3.then) return void n3.then(je2.bind(null, e3, t3), je2.bind(null, e3, 2));
            e3.s = t3, e3.v = n3;
            var r4 = e3.o;
            r4 && r4(e3);
          }
        }
        s2(Me2, "headerLength", 4), s2(Me2, "type", void 0), s2(Me2, "multiSegment", false), s2(Me2, "canHandle", function() {
          return false;
        });
        var ze2 = function() {
          function e3() {
          }
          return e3.prototype.then = function(t3, n3) {
            var r4 = new e3(), o4 = this.s;
            if (o4) {
              var i3 = 1 & o4 ? t3 : n3;
              if (i3) {
                try {
                  je2(r4, 1, i3(this.v));
                } catch (e4) {
                  je2(r4, 2, e4);
                }
                return r4;
              }
              return this;
            }
            return this.o = function(e4) {
              try {
                var o5 = e4.v;
                1 & e4.s ? je2(r4, 1, t3 ? t3(o5) : o5) : n3 ? je2(r4, 1, n3(o5)) : je2(r4, 2, o5);
              } catch (e5) {
                je2(r4, 2, e5);
              }
            }, r4;
          }, e3;
        }();
        function He2(e3) {
          return e3 instanceof ze2 && 1 & e3.s;
        }
        function We2(e3) {
          return 192 === e3 || 194 === e3 || 196 === e3 || 219 === e3 || 221 === e3 || 218 === e3 || 254 === e3;
        }
        function Ve2(e3) {
          return e3 >= 224 && e3 <= 239;
        }
        function qe2(e3, t3, n3) {
          var r4 = V2;
          Array.isArray(r4) || ("function" == typeof r4.entries && (r4 = r4.entries()), r4 = w2(r4));
          for (var o4 = 0; o4 < r4.length; o4++) {
            var i3 = r4[o4], a3 = i3[0];
            if (i3[1].canHandle(e3, t3, n3)) return a3;
          }
        }
        var Xe2 = function(e3) {
          l2(n3, De2);
          var t3 = m2(n3);
          function n3() {
            var e4;
            o3(this, n3);
            for (var r4 = arguments.length, i3 = new Array(r4), a3 = 0; a3 < r4; a3++) i3[a3] = arguments[a3];
            return s2(f2(e4 = t3.call.apply(t3, [this].concat(i3))), "appSegments", []), s2(f2(e4), "jpegSegments", []), s2(f2(e4), "unknownSegments", []), e4;
          }
          return a2(n3, [{ key: "parse", value: function() {
            try {
              var e4 = this;
              return Be2(e4.findAppSegments(), function() {
                return Be2(e4.readSegments(e4.appSegments), function() {
                  e4.mergeMultiSegments(), e4.createParsers(e4.mergedAppSegments || e4.appSegments);
                });
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "setupSegmentFinderArgs", value: function(e4) {
            var t4 = this;
            true === e4 ? (this.findAll = true, this.wanted = x2(V2.keyList())) : (e4 = void 0 === e4 ? V2.keyList().filter(function(e5) {
              return t4.options[e5].enabled;
            }) : e4.filter(function(e5) {
              return t4.options[e5].enabled && V2.has(e5);
            }), this.findAll = false, this.remaining = x2(e4), this.wanted = x2(e4)), this.unfinishedMultiSegment = false;
          } }, { key: "findAppSegments", value: function() {
            var e4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t4 = arguments.length > 1 ? arguments[1] : void 0;
            try {
              var n4 = this;
              n4.setupSegmentFinderArgs(t4);
              var r4 = n4.file, o4 = n4.findAll, i3 = n4.wanted, a3 = n4.remaining;
              return Le2(function() {
                if (!o4 && n4.file.chunked) return o4 = w2(i3).some(function(e5) {
                  var t5 = V2.get(e5), r5 = n4.options[e5];
                  return t5.multiSegment && r5.multiSegment;
                }), function(e5) {
                  var t5 = function() {
                    if (o4) return function(e6, t6) {
                      return e6 && e6.then ? e6.then(Ie2) : Promise.resolve();
                    }(n4.file.readWhole());
                  }();
                  if (t5 && t5.then) return t5.then(Ie2);
                }();
              }, function() {
                var t5 = false;
                if (e4 = n4.findAppSegmentsInRange(e4, r4.byteLength), !n4.options.onlyTiff) return function() {
                  if (r4.chunked) {
                    var o5 = false;
                    return function(e5, t6, n5) {
                      for (var r5; ; ) {
                        var o6 = e5();
                        if (He2(o6) && (o6 = o6.v), !o6) return a4;
                        if (o6.then) {
                          r5 = 0;
                          break;
                        }
                        var i4, a4 = n5();
                        if (a4 && a4.then) {
                          if (!He2(a4)) {
                            r5 = 1;
                            break;
                          }
                          a4 = a4.s;
                        }
                      }
                      var s3 = new ze2(), l3 = je2.bind(null, s3, 2);
                      return (0 === r5 ? o6.then(c3) : 1 === r5 ? a4.then(u3) : i4.then(p3)).then(void 0, l3), s3;
                      function u3(t7) {
                        a4 = t7;
                        do {
                          if (!(o6 = e5()) || He2(o6) && !o6.v) return void je2(s3, 1, a4);
                          if (o6.then) return void o6.then(c3).then(void 0, l3);
                          He2(a4 = n5()) && (a4 = a4.v);
                        } while (!a4 || !a4.then);
                        a4.then(u3).then(void 0, l3);
                      }
                      function c3(e6) {
                        e6 ? (a4 = n5()) && a4.then ? a4.then(u3).then(void 0, l3) : u3(a4) : je2(s3, 1, a4);
                      }
                      function p3() {
                        (o6 = e5()) ? o6.then ? o6.then(c3).then(void 0, l3) : c3(o6) : je2(s3, 1, a4);
                      }
                    }(function() {
                      return !t5 && a3.size > 0 && !o5 && (!!r4.canReadNextChunk || !!n4.unfinishedMultiSegment);
                    }, 0, function() {
                      var i4 = r4.nextChunkOffset, a4 = n4.appSegments.some(function(e5) {
                        return !n4.file.available(e5.offset || e5.start, e5.length || e5.size);
                      });
                      return Le2(function() {
                        return Be2(e4 > i4 && !a4 ? r4.readNextChunk(e4) : r4.readNextChunk(i4), function(e5) {
                          o5 = !e5;
                        });
                      }, function() {
                        void 0 === (e4 = n4.findAppSegmentsInRange(e4, r4.byteLength)) && (t5 = true);
                      });
                    });
                  }
                }();
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "findAppSegmentsInRange", value: function(e4, t4) {
            t4 -= 2;
            for (var n4, r4, o4, i3, a3, s3, l3 = this.file, u3 = this.findAll, c3 = this.wanted, p3 = this.remaining, d3 = this.options; e4 < t4; e4++) if (255 === l3.getUint8(e4)) {
              if (Ve2(n4 = l3.getUint8(e4 + 1))) {
                if (r4 = l3.getUint16(e4 + 2), (o4 = qe2(l3, e4, r4)) && c3.has(o4) && (a3 = (i3 = V2.get(o4)).findPosition(l3, e4), s3 = d3[o4], a3.type = o4, this.appSegments.push(a3), !u3 && (i3.multiSegment && s3.multiSegment ? (this.unfinishedMultiSegment = a3.chunkNumber < a3.chunkCount, this.unfinishedMultiSegment || p3.delete(o4)) : p3.delete(o4), 0 === p3.size))) break;
                d3.recordUnknownSegments && ((a3 = Me2.findPosition(l3, e4)).marker = n4, this.unknownSegments.push(a3)), e4 += r4 + 1;
              } else if (We2(n4)) {
                if (r4 = l3.getUint16(e4 + 2), 218 === n4 && false !== d3.stopAfterSos) return;
                d3.recordJpegSegments && this.jpegSegments.push({ offset: e4, length: r4, marker: n4 }), e4 += r4 + 1;
              }
            }
            return e4;
          } }, { key: "mergeMultiSegments", value: function() {
            var e4 = this;
            if (this.appSegments.some(function(e5) {
              return e5.multiSegment;
            })) {
              var t4 = function(e5, t5) {
                for (var n4, r4, o4, i3 = P2(), a3 = 0; a3 < e5.length; a3++) r4 = (n4 = e5[a3]).type, i3.has(r4) ? o4 = i3.get(r4) : i3.set(r4, o4 = []), o4.push(n4);
                return w2(i3);
              }(this.appSegments);
              this.mergedAppSegments = t4.map(function(t5) {
                var n4 = t5[0], r4 = t5[1], o4 = V2.get(n4, e4.options);
                return o4.handleMultiSegments ? { type: n4, chunk: o4.handleMultiSegments(r4) } : r4[0];
              });
            }
          } }, { key: "getSegment", value: function(e4) {
            return this.appSegments.find(function(t4) {
              return t4.type === e4;
            });
          } }, { key: "getOrFindSegment", value: function(e4) {
            try {
              var t4 = this, n4 = t4.getSegment(e4);
              return Le2(function() {
                if (void 0 === n4) return Be2(t4.findAppSegments(0, [e4]), function() {
                  n4 = t4.getSegment(e4);
                });
              }, function() {
                return n4;
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }], [{ key: "canHandle", value: function(e4, t4) {
            return 65496 === t4;
          } }]), n3;
        }();
        function Ge2() {
        }
        function Ye2(e3, t3) {
          if (!t3) return e3 && e3.then ? e3.then(Ge2) : Promise.resolve();
        }
        function $e2(e3, t3) {
          var n3 = e3();
          return n3 && n3.then ? n3.then(t3) : t3(n3);
        }
        s2(Xe2, "type", "jpeg"), W2.set("jpeg", Xe2);
        var Ke2 = [void 0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8, 4], Je2 = function(e3) {
          l2(n3, e3);
          var t3 = m2(n3);
          function n3() {
            return o3(this, n3), t3.apply(this, arguments);
          }
          return a2(n3, [{ key: "parse", value: function() {
            try {
              var e4 = this;
              e4.parseHeader();
              var t4 = e4.options;
              return $e2(function() {
                if (t4.ifd0.enabled) return Ye2(e4.parseIfd0Block());
              }, function() {
                return $e2(function() {
                  if (t4.exif.enabled) return Ye2(e4.safeParse("parseExifBlock"));
                }, function() {
                  return $e2(function() {
                    if (t4.gps.enabled) return Ye2(e4.safeParse("parseGpsBlock"));
                  }, function() {
                    return $e2(function() {
                      if (t4.interop.enabled) return Ye2(e4.safeParse("parseInteropBlock"));
                    }, function() {
                      return $e2(function() {
                        if (t4.ifd1.enabled) return Ye2(e4.safeParse("parseThumbnailBlock"));
                      }, function() {
                        return e4.createOutput();
                      });
                    });
                  });
                });
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "safeParse", value: function(e4) {
            var t4 = this[e4]();
            return void 0 !== t4.catch && (t4 = t4.catch(this.handleError)), t4;
          } }, { key: "findIfd0Offset", value: function() {
            void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
          } }, { key: "findIfd1Offset", value: function() {
            if (void 0 === this.ifd1Offset) {
              this.findIfd0Offset();
              var e4 = this.chunk.getUint16(this.ifd0Offset), t4 = this.ifd0Offset + 2 + 12 * e4;
              this.ifd1Offset = this.chunk.getUint32(t4);
            }
          } }, { key: "parseBlock", value: function(e4, t4) {
            var n4 = P2();
            return this[t4] = n4, this.parseTags(e4, t4, n4), n4;
          } }, { key: "parseIfd0Block", value: function() {
            try {
              var e4 = this;
              if (e4.ifd0) return;
              var t4 = e4.file;
              return e4.findIfd0Offset(), e4.ifd0Offset < 8 && M2("Malformed EXIF data"), !t4.chunked && e4.ifd0Offset > t4.byteLength && M2("IFD0 offset points to outside of file.\nthis.ifd0Offset: ".concat(e4.ifd0Offset, ", file.byteLength: ").concat(t4.byteLength)), $e2(function() {
                if (t4.tiff) return Ye2(t4.ensureChunk(e4.ifd0Offset, B2(e4.options)));
              }, function() {
                var t5 = e4.parseBlock(e4.ifd0Offset, "ifd0");
                if (0 !== t5.size) return e4.exifOffset = t5.get(34665), e4.interopOffset = t5.get(ue2), e4.gpsOffset = t5.get(34853), e4.xmp = t5.get(700), e4.iptc = t5.get(33723), e4.icc = t5.get(34675), e4.options.sanitize && (t5.delete(34665), t5.delete(ue2), t5.delete(34853), t5.delete(700), t5.delete(33723), t5.delete(34675)), t5;
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "parseExifBlock", value: function() {
            try {
              var e4 = this;
              if (e4.exif) return;
              return $e2(function() {
                if (!e4.ifd0) return Ye2(e4.parseIfd0Block());
              }, function() {
                if (void 0 !== e4.exifOffset) return $e2(function() {
                  if (e4.file.tiff) return Ye2(e4.file.ensureChunk(e4.exifOffset, B2(e4.options)));
                }, function() {
                  var t4 = e4.parseBlock(e4.exifOffset, "exif");
                  return e4.interopOffset || (e4.interopOffset = t4.get(ue2)), e4.makerNote = t4.get(se2), e4.userComment = t4.get(le2), e4.options.sanitize && (t4.delete(ue2), t4.delete(se2), t4.delete(le2)), e4.unpack(t4, 41728), e4.unpack(t4, 41729), t4;
                });
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "unpack", value: function(e4, t4) {
            var n4 = e4.get(t4);
            n4 && 1 === n4.length && e4.set(t4, n4[0]);
          } }, { key: "parseGpsBlock", value: function() {
            try {
              var e4 = this;
              if (e4.gps) return;
              return $e2(function() {
                if (!e4.ifd0) return Ye2(e4.parseIfd0Block());
              }, function() {
                if (void 0 !== e4.gpsOffset) {
                  var t4 = e4.parseBlock(e4.gpsOffset, "gps");
                  return t4 && t4.has(2) && t4.has(4) && (t4.set("latitude", Qe2.apply(void 0, t4.get(2).concat([t4.get(1)]))), t4.set("longitude", Qe2.apply(void 0, t4.get(4).concat([t4.get(3)])))), t4;
                }
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "parseInteropBlock", value: function() {
            try {
              var e4 = this;
              if (e4.interop) return;
              return $e2(function() {
                if (!e4.ifd0) return Ye2(e4.parseIfd0Block());
              }, function() {
                return $e2(function() {
                  if (void 0 === e4.interopOffset && !e4.exif) return Ye2(e4.parseExifBlock());
                }, function() {
                  if (void 0 !== e4.interopOffset) return e4.parseBlock(e4.interopOffset, "interop");
                });
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "parseThumbnailBlock", value: function() {
            var e4 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            try {
              var t4 = this;
              if (t4.ifd1 || t4.ifd1Parsed) return;
              if (t4.options.mergeOutput && !e4) return;
              return t4.findIfd1Offset(), t4.ifd1Offset > 0 && (t4.parseBlock(t4.ifd1Offset, "ifd1"), t4.ifd1Parsed = true), t4.ifd1;
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "extractThumbnail", value: function() {
            try {
              var e4 = this;
              return e4.headerParsed || e4.parseHeader(), $e2(function() {
                if (!e4.ifd1Parsed) return Ye2(e4.parseThumbnailBlock(true));
              }, function() {
                if (void 0 !== e4.ifd1) {
                  var t4 = e4.ifd1.get(513), n4 = e4.ifd1.get(514);
                  return e4.chunk.getUint8Array(t4, n4);
                }
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "image", get: function() {
            return this.ifd0;
          } }, { key: "thumbnail", get: function() {
            return this.ifd1;
          } }, { key: "createOutput", value: function() {
            var e4, t4, n4, r4 = {}, o4 = he2;
            Array.isArray(o4) || ("function" == typeof o4.entries && (o4 = o4.entries()), o4 = w2(o4));
            for (var i3 = 0; i3 < o4.length; i3++) if (!D2(e4 = this[t4 = o4[i3]])) if (n4 = this.canTranslate ? this.translateBlock(e4, t4) : _2(e4), this.options.mergeOutput) {
              if ("ifd1" === t4) continue;
              b2(r4, n4);
            } else r4[t4] = n4;
            return this.makerNote && (r4.makerNote = this.makerNote), this.userComment && (r4.userComment = this.userComment), r4;
          } }, { key: "assignToOutput", value: function(e4, t4) {
            if (this.globalOptions.mergeOutput) b2(e4, t4);
            else {
              var n4 = y2(t4);
              Array.isArray(n4) || ("function" == typeof n4.entries && (n4 = n4.entries()), n4 = w2(n4));
              for (var r4 = 0; r4 < n4.length; r4++) {
                var o4 = n4[r4], i3 = o4[0], a3 = o4[1];
                this.assignObjectToOutput(e4, i3, a3);
              }
            }
          } }], [{ key: "canHandle", value: function(e4, t4) {
            return 225 === e4.getUint8(t4 + 1) && 1165519206 === e4.getUint32(t4 + 4) && 0 === e4.getUint16(t4 + 8);
          } }]), n3;
        }(function(e3) {
          l2(n3, Me2);
          var t3 = m2(n3);
          function n3() {
            return o3(this, n3), t3.apply(this, arguments);
          }
          return a2(n3, [{ key: "parseHeader", value: function() {
            var e4 = this.chunk.getUint16();
            18761 === e4 ? this.le = true : 19789 === e4 && (this.le = false), this.chunk.le = this.le, this.headerParsed = true;
          } }, { key: "parseTags", value: function(e4, t4) {
            var n4 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : P2(), r4 = this.options[t4], o4 = r4.pick, i3 = r4.skip, a3 = (o4 = x2(o4)).size > 0, s3 = 0 === i3.size, l3 = this.chunk.getUint16(e4);
            e4 += 2;
            for (var u3 = 0; u3 < l3; u3++) {
              var c3 = this.chunk.getUint16(e4);
              if (a3) {
                if (o4.has(c3) && (n4.set(c3, this.parseTag(e4, c3, t4)), o4.delete(c3), 0 === o4.size)) break;
              } else !s3 && i3.has(c3) || n4.set(c3, this.parseTag(e4, c3, t4));
              e4 += 12;
            }
            return n4;
          } }, { key: "parseTag", value: function(e4, t4, n4) {
            var r4, o4 = this.chunk, i3 = o4.getUint16(e4 + 2), a3 = o4.getUint32(e4 + 4), s3 = Ke2[i3];
            if (s3 * a3 <= 4 ? e4 += 8 : e4 = o4.getUint32(e4 + 8), (i3 < 1 || i3 > 13) && M2("Invalid TIFF value type. block: ".concat(n4.toUpperCase(), ", tag: ").concat(t4.toString(16), ", type: ").concat(i3, ", offset ").concat(e4)), e4 > o4.byteLength && M2("Invalid TIFF value offset. block: ".concat(n4.toUpperCase(), ", tag: ").concat(t4.toString(16), ", type: ").concat(i3, ", offset ").concat(e4, " is outside of chunk size ").concat(o4.byteLength)), 1 === i3) return o4.getUint8Array(e4, a3);
            if (2 === i3) return "" === (r4 = function(e5) {
              for (; e5.endsWith("\0"); ) e5 = e5.slice(0, -1);
              return e5;
            }(r4 = o4.getString(e4, a3)).trim()) ? void 0 : r4;
            if (7 === i3) return o4.getUint8Array(e4, a3);
            if (1 === a3) return this.parseTagValue(i3, e4);
            for (var l3 = new (function(e5) {
              switch (i3) {
                case 1:
                  return Uint8Array;
                case 3:
                  return Uint16Array;
                case 4:
                  return Uint32Array;
                case 5:
                  return Array;
                case 6:
                  return Int8Array;
                case 8:
                  return Int16Array;
                case 9:
                  return Int32Array;
                case 10:
                  return Array;
                case 11:
                  return Float32Array;
                case 12:
                  return Float64Array;
                default:
                  return Array;
              }
            }())(a3), u3 = s3, c3 = 0; c3 < a3; c3++) l3[c3] = this.parseTagValue(i3, e4), e4 += u3;
            return l3;
          } }, { key: "parseTagValue", value: function(e4, t4) {
            var n4 = this.chunk;
            switch (e4) {
              case 1:
                return n4.getUint8(t4);
              case 3:
                return n4.getUint16(t4);
              case 4:
                return n4.getUint32(t4);
              case 5:
                return n4.getUint32(t4) / n4.getUint32(t4 + 4);
              case 6:
                return n4.getInt8(t4);
              case 8:
                return n4.getInt16(t4);
              case 9:
                return n4.getInt32(t4);
              case 10:
                return n4.getInt32(t4) / n4.getInt32(t4 + 4);
              case 11:
                return n4.getFloat(t4);
              case 12:
                return n4.getDouble(t4);
              case 13:
                return n4.getUint32(t4);
              default:
                M2("Invalid tiff type ".concat(e4));
            }
          } }]), n3;
        }());
        function Qe2(e3, t3, n3, r4) {
          var o4 = e3 + t3 / 60 + n3 / 3600;
          return "S" !== r4 && "W" !== r4 || (o4 *= -1), o4;
        }
        s2(Je2, "type", "tiff"), s2(Je2, "headerLength", 10), V2.set("tiff", Je2);
        var Ze2 = Object.freeze({ __proto__: null, default: Re2, Exifr: Ne2, fileParsers: W2, segmentParsers: V2, fileReaders: q2, tagKeys: oe2, tagValues: ie2, tagRevivers: ae2, createDictionary: ne2, extendDictionary: re2, fetchUrlAsArrayBuffer: $2, readBlobAsArrayBuffer: Y2, chunkedProps: ce2, otherSegments: pe2, segments: de2, tiffBlocks: he2, segmentsAndBlocks: fe2, tiffExtractables: me2, inheritables: ve2, allFormatters: ge2, Options: Ce2, parse: Te2 });
        function et2(e3, t3, n3) {
          return n3 ? t3 ? t3(e3) : e3 : (e3 && e3.then || (e3 = Promise.resolve(e3)), t3 ? e3.then(t3) : e3);
        }
        function tt2(e3) {
          return function() {
            for (var t3 = [], n3 = 0; n3 < arguments.length; n3++) t3[n3] = arguments[n3];
            try {
              return Promise.resolve(e3.apply(this, t3));
            } catch (e4) {
              return Promise.reject(e4);
            }
          };
        }
        var nt2 = tt2(function(e3) {
          var t3 = new Ne2(lt2);
          return et2(t3.read(e3), function() {
            return et2(t3.parse(), function(e4) {
              if (e4 && e4.ifd0) return e4.ifd0[274];
            });
          });
        }), rt2 = tt2(function(e3) {
          var t3 = new Ne2(st2);
          return et2(t3.read(e3), function() {
            return et2(t3.parse(), function(e4) {
              if (e4 && e4.gps) {
                var t4 = e4.gps;
                return { latitude: t4.latitude, longitude: t4.longitude };
              }
            });
          });
        }), ot2 = tt2(function(e3) {
          return et2(this.thumbnail(e3), function(e4) {
            if (void 0 !== e4) {
              var t3 = new Blob([e4]);
              return URL.createObjectURL(t3);
            }
          });
        }), it2 = tt2(function(e3) {
          var t3 = new Ne2(ut2);
          return et2(t3.read(e3), function() {
            return et2(t3.extractThumbnail(), function(e4) {
              return e4 && R2 ? T2.from(e4) : e4;
            });
          });
        }), at2 = { ifd0: false, ifd1: false, exif: false, gps: false, interop: false, sanitize: false, reviveValues: true, translateKeys: false, translateValues: false, mergeOutput: false }, st2 = b2({}, at2, { firstChunkSize: 4e4, gps: [1, 2, 3, 4] }), lt2 = b2({}, at2, { firstChunkSize: 4e4, ifd0: [274] }), ut2 = b2({}, at2, { tiff: false, ifd1: true, mergeOutput: false }), ct2 = Object.freeze({ 1: { dimensionSwapped: false, scaleX: 1, scaleY: 1, deg: 0, rad: 0 }, 2: { dimensionSwapped: false, scaleX: -1, scaleY: 1, deg: 0, rad: 0 }, 3: { dimensionSwapped: false, scaleX: 1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 4: { dimensionSwapped: false, scaleX: -1, scaleY: 1, deg: 180, rad: 180 * Math.PI / 180 }, 5: { dimensionSwapped: true, scaleX: 1, scaleY: -1, deg: 90, rad: 90 * Math.PI / 180 }, 6: { dimensionSwapped: true, scaleX: 1, scaleY: 1, deg: 90, rad: 90 * Math.PI / 180 }, 7: { dimensionSwapped: true, scaleX: 1, scaleY: -1, deg: 270, rad: 270 * Math.PI / 180 }, 8: { dimensionSwapped: true, scaleX: 1, scaleY: 1, deg: 270, rad: 270 * Math.PI / 180 } });
        if (r3.rotateCanvas = true, r3.rotateCss = true, "object" == typeof navigator) {
          var pt2 = navigator.userAgent;
          if (pt2.includes("iPad") || pt2.includes("iPhone")) {
            var dt2 = pt2.match(/OS (\d+)_(\d+)/);
            if (dt2) {
              var ht2 = dt2[1], ft2 = dt2[2], mt2 = Number(ht2) + 0.1 * Number(ft2);
              r3.rotateCanvas = mt2 < 13.4, r3.rotateCss = false;
            }
          } else if (pt2.includes("OS X 10")) {
            var vt2 = pt2.match(/OS X 10[_.](\d+)/)[1];
            r3.rotateCanvas = r3.rotateCss = Number(vt2) < 15;
          }
          if (pt2.includes("Chrome/")) {
            var gt2 = pt2.match(/Chrome\/(\d+)/)[1];
            r3.rotateCanvas = r3.rotateCss = Number(gt2) < 81;
          } else if (pt2.includes("Firefox/")) {
            var yt2 = pt2.match(/Firefox\/(\d+)/)[1];
            r3.rotateCanvas = r3.rotateCss = Number(yt2) < 77;
          }
        }
        function bt2() {
        }
        var _t2 = function(e3) {
          l2(n3, j2);
          var t3 = m2(n3);
          function n3() {
            var e4;
            o3(this, n3);
            for (var r4 = arguments.length, i3 = new Array(r4), a3 = 0; a3 < r4; a3++) i3[a3] = arguments[a3];
            return s2(f2(e4 = t3.call.apply(t3, [this].concat(i3))), "ranges", new wt2()), 0 !== e4.byteLength && e4.ranges.add(0, e4.byteLength), e4;
          }
          return a2(n3, [{ key: "_tryExtend", value: function(e4, t4, n4) {
            if (0 === e4 && 0 === this.byteLength && n4) {
              var r4 = new DataView(n4.buffer || n4, n4.byteOffset, n4.byteLength);
              this._swapDataView(r4);
            } else {
              var o4 = e4 + t4;
              if (o4 > this.byteLength) {
                var i3 = this._extend(o4).dataView;
                this._swapDataView(i3);
              }
            }
          } }, { key: "_extend", value: function(e4) {
            var t4;
            t4 = R2 ? T2.allocUnsafe(e4) : new Uint8Array(e4);
            var n4 = new DataView(t4.buffer, t4.byteOffset, t4.byteLength);
            return t4.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), { uintView: t4, dataView: n4 };
          } }, { key: "subarray", value: function(e4, t4) {
            var r4 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            return t4 = t4 || this._lengthToEnd(e4), r4 && this._tryExtend(e4, t4), this.ranges.add(e4, t4), v2(u2(n3.prototype), "subarray", this).call(this, e4, t4);
          } }, { key: "set", value: function(e4, t4) {
            arguments.length > 2 && void 0 !== arguments[2] && arguments[2] && this._tryExtend(t4, e4.byteLength, e4);
            var r4 = v2(u2(n3.prototype), "set", this).call(this, e4, t4);
            return this.ranges.add(t4, r4.byteLength), r4;
          } }, { key: "ensureChunk", value: function(e4, t4) {
            try {
              var n4 = this;
              if (!n4.chunked) return;
              if (n4.ranges.available(e4, t4)) return;
              return function(e5, t5) {
                return e5 && e5.then ? e5.then(bt2) : Promise.resolve();
              }(n4.readChunk(e4, t4));
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "available", value: function(e4, t4) {
            return this.ranges.available(e4, t4);
          } }]), n3;
        }(), wt2 = function() {
          function e3() {
            o3(this, e3), s2(this, "list", []);
          }
          return a2(e3, [{ key: "length", get: function() {
            return this.list.length;
          } }, { key: "add", value: function(e4, t3) {
            var n3 = e4 + t3, r4 = this.list.filter(function(t4) {
              return Ct2(e4, t4.offset, n3) || Ct2(e4, t4.end, n3);
            });
            if (r4.length > 0) {
              e4 = Math.min.apply(Math, [e4].concat(r4.map(function(e5) {
                return e5.offset;
              }))), t3 = (n3 = Math.max.apply(Math, [n3].concat(r4.map(function(e5) {
                return e5.end;
              })))) - e4;
              var o4 = r4.shift();
              o4.offset = e4, o4.length = t3, o4.end = n3, this.list = this.list.filter(function(e5) {
                return !r4.includes(e5);
              });
            } else this.list.push({ offset: e4, length: t3, end: n3 });
          } }, { key: "available", value: function(e4, t3) {
            var n3 = e4 + t3;
            return this.list.some(function(t4) {
              return t4.offset <= e4 && n3 <= t4.end;
            });
          } }]), e3;
        }();
        function Ct2(e3, t3, n3) {
          return e3 <= t3 && t3 <= n3;
        }
        function St2() {
        }
        function kt2(e3, t3) {
          if (!t3) return e3 && e3.then ? e3.then(St2) : Promise.resolve();
        }
        function xt2(e3, t3, n3) {
          return n3 ? t3 ? t3(e3) : e3 : (e3 && e3.then || (e3 = Promise.resolve(e3)), t3 ? e3.then(t3) : e3);
        }
        var Pt2 = function(e3) {
          l2(n3, e3);
          var t3 = m2(n3);
          function n3() {
            return o3(this, n3), t3.apply(this, arguments);
          }
          return a2(n3, [{ key: "readWhole", value: function() {
            try {
              var e4 = this;
              return e4.chunked = false, xt2(Y2(e4.input), function(t4) {
                e4._swapArrayBuffer(t4);
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "readChunked", value: function() {
            return this.chunked = true, this.size = this.input.size, v2(u2(n3.prototype), "readChunked", this).call(this);
          } }, { key: "_readChunk", value: function(e4, t4) {
            try {
              var n4 = this, r4 = t4 ? e4 + t4 : void 0, o4 = n4.input.slice(e4, r4);
              return xt2(Y2(o4), function(t5) {
                return n4.set(t5, e4, true);
              });
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }]), n3;
        }(function(e3) {
          l2(n3, _t2);
          var t3 = m2(n3);
          function n3(e4, r4) {
            var i3;
            return o3(this, n3), s2(f2(i3 = t3.call(this, 0)), "chunksRead", 0), i3.input = e4, i3.options = r4, i3;
          }
          return a2(n3, [{ key: "readWhole", value: function() {
            try {
              var e4 = this;
              return e4.chunked = false, kt2(e4.readChunk(e4.nextChunkOffset));
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "readChunked", value: function() {
            try {
              var e4 = this;
              return e4.chunked = true, kt2(e4.readChunk(0, e4.options.firstChunkSize));
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "readNextChunk", value: function(e4) {
            try {
              var t4 = this;
              if (void 0 === e4 && (e4 = t4.nextChunkOffset), t4.fullyRead) return t4.chunksRead++, false;
              var n4 = t4.options.chunkSize;
              return r4 = t4.readChunk(e4, n4), o4 = function(e5) {
                return !!e5 && e5.byteLength === n4;
              }, r4 && r4.then || (r4 = Promise.resolve(r4)), o4 ? r4.then(o4) : r4;
            } catch (e5) {
              return Promise.reject(e5);
            }
            var r4, o4;
          } }, { key: "readChunk", value: function(e4, t4) {
            try {
              var n4 = this;
              if (n4.chunksRead++, 0 === (t4 = n4.safeWrapAddress(e4, t4))) return;
              return n4._readChunk(e4, t4);
            } catch (e5) {
              return Promise.reject(e5);
            }
          } }, { key: "safeWrapAddress", value: function(e4, t4) {
            return void 0 !== this.size && e4 + t4 > this.size ? Math.max(0, this.size - e4) : t4;
          } }, { key: "nextChunkOffset", get: function() {
            if (0 !== this.ranges.list.length) return this.ranges.list[0].length;
          } }, { key: "canReadNextChunk", get: function() {
            return this.chunksRead < this.options.chunkLimit;
          } }, { key: "fullyRead", get: function() {
            return void 0 !== this.size && this.nextChunkOffset === this.size;
          } }, { key: "read", value: function() {
            return this.options.chunked ? this.readChunked() : this.readWhole();
          } }, { key: "close", value: function() {
          } }]), n3;
        }());
        q2.set("blob", Pt2), r3.Exifr = Ne2, r3.Options = Ce2, r3.allFormatters = ge2, r3.chunkedProps = ce2, r3.createDictionary = ne2, r3.default = Ze2, r3.disableAllOptions = at2, r3.extendDictionary = re2, r3.fetchUrlAsArrayBuffer = $2, r3.fileParsers = W2, r3.fileReaders = q2, r3.gps = rt2, r3.gpsOnlyOptions = st2, r3.inheritables = ve2, r3.orientation = nt2, r3.orientationOnlyOptions = lt2, r3.otherSegments = pe2, r3.parse = Te2, r3.readBlobAsArrayBuffer = Y2, r3.rotation = function(e3) {
          return et2(nt2(e3), function(e4) {
            return b2({ canvas: r3.rotateCanvas, css: r3.rotateCss }, ct2[e4]);
          });
        }, r3.rotations = ct2, r3.segmentParsers = V2, r3.segments = de2, r3.segmentsAndBlocks = fe2, r3.tagKeys = oe2, r3.tagRevivers = ae2, r3.tagValues = ie2, r3.thumbnail = it2, r3.thumbnailOnlyOptions = ut2, r3.thumbnailUrl = ot2, r3.tiffBlocks = he2, r3.tiffExtractables = me2, Object.defineProperty(r3, "__esModule", { value: true });
      }, "object" == typeof mo.exports ? o2(mo.exports) : o2((r2 = "undefined" != typeof globalThis ? globalThis : r2 || self).exifr = {});
    }).call(this);
  }).call(this, e, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, a({}).Buffer), mo = mo.exports;
  var vo, go;
  function yo() {
    return (yo = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function bo(e2, t2) {
    return (bo = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var _o = (go = vo = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      if ((r3 = e2.call(this, t3, n3) || this).onFileAdded = function(e3) {
        !e3.preview && e3.data && Dt(e3.type) && !e3.isRemote && r3.addToQueue(e3.id);
      }, r3.onCancelRequest = function(e3) {
        var t4 = r3.queue.indexOf(e3.id);
        -1 !== t4 && r3.queue.splice(t4, 1);
      }, r3.onFileRemoved = function(e3) {
        var t4 = r3.queue.indexOf(e3.id);
        -1 !== t4 && r3.queue.splice(t4, 1), e3.preview && no(e3.preview) && URL.revokeObjectURL(e3.preview);
      }, r3.onRestored = function() {
        r3.uppy.getFiles().filter(function(e3) {
          return e3.isRestored;
        }).forEach(function(e3) {
          e3.preview && !no(e3.preview) || r3.addToQueue(e3.id);
        });
      }, r3.waitUntilAllProcessed = function(e3) {
        e3.forEach(function(e4) {
          var t5 = r3.uppy.getFile(e4);
          r3.uppy.emit("preprocess-progress", t5, { mode: "indeterminate", message: r3.i18n("generatingThumbnails") });
        });
        var t4 = function() {
          e3.forEach(function(e4) {
            var t5 = r3.uppy.getFile(e4);
            r3.uppy.emit("preprocess-complete", t5);
          });
        };
        return new Promise(function(e4, n4) {
          r3.queueProcessing ? r3.uppy.once("thumbnail:all-generated", function() {
            t4(), e4();
          }) : (t4(), e4());
        });
      }, r3.type = "modifier", r3.id = r3.opts.id || "ThumbnailGenerator", r3.title = "Thumbnail Generator", r3.queue = [], r3.queueProcessing = false, r3.defaultThumbnailDimension = 200, r3.thumbnailType = r3.opts.thumbnailType || "image/jpeg", r3.defaultLocale = { strings: { generatingThumbnails: "Generating thumbnails..." } }, r3.opts = yo({}, { thumbnailWidth: null, thumbnailHeight: null, waitForThumbnailsBeforeUpload: false, lazy: false }, n3), r3.opts.lazy && r3.opts.waitForThumbnailsBeforeUpload) throw new Error("ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.");
      return r3.i18nInit(), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, bo(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, t3), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.setPluginState();
    }, o2.createThumbnail = function(e3, t3, n3) {
      var r3 = this, o3 = URL.createObjectURL(e3.data), i2 = new Promise(function(e4, t4) {
        var n4 = new Image();
        n4.src = o3, n4.addEventListener("load", function() {
          URL.revokeObjectURL(o3), e4(n4);
        }), n4.addEventListener("error", function(e5) {
          URL.revokeObjectURL(o3), t4(e5.error || new Error("Could not create thumbnail"));
        });
      }), a2 = mo.rotation(e3.data).catch(function(e4) {
        return 1;
      });
      return Promise.all([i2, a2]).then(function(e4) {
        var o4 = e4[0], i3 = e4[1], a3 = r3.getProportionalDimensions(o4, t3, n3, i3.deg), s2 = r3.rotateImage(o4, i3), l2 = r3.resizeImage(s2, a3.width, a3.height);
        return r3.canvasToBlob(l2, r3.thumbnailType, 80);
      }).then(function(e4) {
        return URL.createObjectURL(e4);
      });
    }, o2.getProportionalDimensions = function(e3, t3, n3, r3) {
      var o3 = e3.width / e3.height;
      return 90 !== r3 && 270 !== r3 || (o3 = e3.height / e3.width), null != t3 ? { width: t3, height: Math.round(t3 / o3) } : null != n3 ? { width: Math.round(n3 * o3), height: n3 } : { width: this.defaultThumbnailDimension, height: Math.round(this.defaultThumbnailDimension / o3) };
    }, o2.protect = function(e3) {
      var t3 = e3.width / e3.height, n3 = Math.floor(Math.sqrt(5e6 * t3)), r3 = Math.floor(5e6 / Math.sqrt(5e6 * t3));
      if (n3 > 4096 && (n3 = 4096, r3 = Math.round(n3 / t3)), r3 > 4096 && (r3 = 4096, n3 = Math.round(t3 * r3)), e3.width > n3) {
        var o3 = document.createElement("canvas");
        o3.width = n3, o3.height = r3, o3.getContext("2d").drawImage(e3, 0, 0, n3, r3), e3 = o3;
      }
      return e3;
    }, o2.resizeImage = function(e3, t3, n3) {
      e3 = this.protect(e3);
      var r3 = Math.ceil(ro(e3.width / t3));
      r3 < 1 && (r3 = 1);
      for (var o3 = t3 * Math.pow(2, r3 - 1), i2 = n3 * Math.pow(2, r3 - 1); r3--; ) {
        var a2 = document.createElement("canvas");
        a2.width = o3, a2.height = i2, a2.getContext("2d").drawImage(e3, 0, 0, o3, i2), e3 = a2, o3 = Math.round(o3 / 2), i2 = Math.round(i2 / 2);
      }
      return e3;
    }, o2.rotateImage = function(e3, t3) {
      var n3 = e3.width, r3 = e3.height;
      90 !== t3.deg && 270 !== t3.deg || (n3 = e3.height, r3 = e3.width);
      var o3 = document.createElement("canvas");
      o3.width = n3, o3.height = r3;
      var i2 = o3.getContext("2d");
      return i2.translate(n3 / 2, r3 / 2), t3.canvas && (i2.rotate(t3.rad), i2.scale(t3.scaleX, t3.scaleY)), i2.drawImage(e3, -e3.width / 2, -e3.height / 2, e3.width, e3.height), o3;
    }, o2.canvasToBlob = function(e3, t3, n3) {
      try {
        e3.getContext("2d").getImageData(0, 0, 1, 1);
      } catch (wd2) {
        if (18 === wd2.code) return Promise.reject(new Error("cannot read image, probably an svg with external resources"));
      }
      return e3.toBlob ? new Promise(function(r3) {
        e3.toBlob(r3, t3, n3);
      }).then(function(e4) {
        if (null === e4) throw new Error("cannot read image, probably an svg with external resources");
        return e4;
      }) : Promise.resolve().then(function() {
        return to(e3.toDataURL(t3, n3), {});
      }).then(function(e4) {
        if (null === e4) throw new Error("could not extract blob, probably an old browser");
        return e4;
      });
    }, o2.setPreviewURL = function(e3, t3) {
      this.uppy.setFileState(e3, { preview: t3 });
    }, o2.addToQueue = function(e3) {
      this.queue.push(e3), false === this.queueProcessing && this.processQueue();
    }, o2.processQueue = function() {
      var e3 = this;
      if (this.queueProcessing = true, this.queue.length > 0) {
        var t3 = this.uppy.getFile(this.queue.shift());
        return t3 ? this.requestThumbnail(t3).catch(function(e4) {
        }).then(function() {
          return e3.processQueue();
        }) : void this.uppy.log("[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug", "error");
      }
      this.queueProcessing = false, this.uppy.log("[ThumbnailGenerator] Emptied thumbnail queue"), this.uppy.emit("thumbnail:all-generated");
    }, o2.requestThumbnail = function(e3) {
      var t3 = this;
      return Dt(e3.type) && !e3.isRemote ? this.createThumbnail(e3, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then(function(n3) {
        t3.setPreviewURL(e3.id, n3), t3.uppy.log("[ThumbnailGenerator] Generated thumbnail for " + e3.id), t3.uppy.emit("thumbnail:generated", t3.uppy.getFile(e3.id), n3);
      }).catch(function(n3) {
        t3.uppy.log("[ThumbnailGenerator] Failed thumbnail for " + e3.id + ":", "warning"), t3.uppy.log(n3, "warning"), t3.uppy.emit("thumbnail:error", t3.uppy.getFile(e3.id), n3);
      }) : Promise.resolve();
    }, o2.install = function() {
      this.uppy.on("file-removed", this.onFileRemoved), this.opts.lazy ? (this.uppy.on("thumbnail:request", this.onFileAdded), this.uppy.on("thumbnail:cancel", this.onCancelRequest)) : (this.uppy.on("file-added", this.onFileAdded), this.uppy.on("restored", this.onRestored)), this.opts.waitForThumbnailsBeforeUpload && this.uppy.addPreProcessor(this.waitUntilAllProcessed);
    }, o2.uninstall = function() {
      this.uppy.off("file-removed", this.onFileRemoved), this.opts.lazy ? (this.uppy.off("thumbnail:request", this.onFileAdded), this.uppy.off("thumbnail:cancel", this.onCancelRequest)) : (this.uppy.off("file-added", this.onFileAdded), this.uppy.off("restored", this.onRestored)), this.opts.waitForThumbnailsBeforeUpload && this.uppy.removePreProcessor(this.waitUntilAllProcessed);
    }, r2;
  }(ue.Plugin), vo.VERSION = "1.7.11", go), wo = function(e2) {
    if ("string" == typeof e2) {
      var t2 = [].slice.call(document.querySelectorAll(e2));
      return t2.length > 0 ? t2 : null;
    }
    if ("object" == typeof e2 && ae(e2)) return [e2];
  }, Co = function(e2) {
    return Array.prototype.slice.call(e2 || [], 0);
  }, So = function(e2, t2) {
    var n2 = [], r2 = [];
    return Co(e2.items).forEach(function(e3) {
      var o2 = e3.webkitGetAsEntry();
      o2 && r2.push(function e4(r3) {
        return new Promise(function(o3) {
          if (r3.isFile) r3.file(function(e5) {
            var t3;
            e5.relativePath = (t3 = r3).fullPath && t3.fullPath !== "/" + t3.name ? t3.fullPath : null, n2.push(e5), o3();
          }, function(e5) {
            t2(e5), o3();
          });
          else if (r3.isDirectory) {
            !function e5(t3, n3, r4, o4) {
              var i2 = o4.onSuccess;
              t3.readEntries(function(o5) {
                var a2 = [].concat(n3, o5);
                o5.length ? setTimeout(function() {
                  e5(t3, a2, r4, { onSuccess: i2 });
                }, 0) : i2(a2);
              }, function(e6) {
                r4(e6), i2(n3);
              });
            }(r3.createReader(), [], t2, { onSuccess: function(t3) {
              var n3 = t3.map(function(t4) {
                return e4(t4);
              });
              Promise.all(n3).then(function() {
                return o3();
              });
            } });
          }
        });
      }(o2));
    }), Promise.all(r2).then(function() {
      return n2;
    });
  }, ko = function(e2, t2) {
    var n2 = (void 0 === t2 ? {} : t2).logDropError, r2 = void 0 === n2 ? function() {
    } : n2;
    return e2.items && e2.items[0] && "webkitGetAsEntry" in e2.items[0] ? So(e2, r2) : function(e3) {
      var t3 = Co(e3.files);
      return Promise.resolve(t3);
    }(e2);
  }, xo = function(e2, t2) {
    if (t2) {
      var n2 = e2.querySelector('[data-uppy-paneltype="' + t2 + '"]');
      if (n2) return n2;
    }
    return e2;
  }, Po = ['a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', "input:not([disabled]):not([inert]):not([aria-hidden])", "select:not([disabled]):not([inert]):not([aria-hidden])", "textarea:not([disabled]):not([inert]):not([aria-hidden])", "button:not([disabled]):not([inert]):not([aria-hidden])", 'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])', 'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])', '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])', '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'];
  function Eo(e2, t2) {
    var n2 = t2[0];
    n2 && (n2.focus(), e2.preventDefault());
  }
  function Oo(e2, t2, n2) {
    var r2 = xo(n2, t2), o2 = Co(r2.querySelectorAll(Po)), i2 = o2.indexOf(document.activeElement);
    !function(e3) {
      return e3.contains(document.activeElement);
    }(r2) ? Eo(e2, o2) : e2.shiftKey && 0 === i2 ? function(e3, t3) {
      var n3 = t3[t3.length - 1];
      n3 && (n3.focus(), e3.preventDefault());
    }(e2, o2) : e2.shiftKey || i2 !== o2.length - 1 || Eo(e2, o2);
  }
  var Ao = function(e2, t2, n2) {
    Oo(e2, t2, n2);
  }, Uo = function(e2, t2, n2) {
    null === t2 || Oo(e2, t2, n2);
  }, No = { exports: {} };
  (function(e2) {
    (function() {
      !function(e3, t2) {
        "object" == typeof No.exports ? No.exports = t2() : e3.ResizeObserver = t2();
      }(this, function() {
        "use strict";
        var t2 = function() {
          if ("undefined" != typeof Map) return Map;
          function e3(e4, t3) {
            var n3 = -1;
            return e4.some(function(e5, r3) {
              return e5[0] === t3 && (n3 = r3, true);
            }), n3;
          }
          return function() {
            function t3() {
              this.__entries__ = [];
            }
            return Object.defineProperty(t3.prototype, "size", { get: function() {
              return this.__entries__.length;
            }, enumerable: true, configurable: true }), t3.prototype.get = function(t4) {
              var n3 = e3(this.__entries__, t4), r3 = this.__entries__[n3];
              return r3 && r3[1];
            }, t3.prototype.set = function(t4, n3) {
              var r3 = e3(this.__entries__, t4);
              ~r3 ? this.__entries__[r3][1] = n3 : this.__entries__.push([t4, n3]);
            }, t3.prototype.delete = function(t4) {
              var n3 = this.__entries__, r3 = e3(n3, t4);
              ~r3 && n3.splice(r3, 1);
            }, t3.prototype.has = function(t4) {
              return !!~e3(this.__entries__, t4);
            }, t3.prototype.clear = function() {
              this.__entries__.splice(0);
            }, t3.prototype.forEach = function(e4, t4) {
              void 0 === t4 && (t4 = null);
              for (var n3 = 0, r3 = this.__entries__; n3 < r3.length; n3++) {
                var o3 = r3[n3];
                e4.call(t4, o3[1], o3[0]);
              }
            }, t3;
          }();
        }(), n2 = "undefined" != typeof window && "undefined" != typeof document && window.document === document, r2 = void 0 !== e2 && e2.Math === Math ? e2 : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(), o2 = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(r2) : function(e3) {
          return setTimeout(function() {
            return e3(Date.now());
          }, 1e3 / 60);
        }, i2 = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], a2 = "undefined" != typeof MutationObserver, s2 = function() {
          function e3() {
            this.connected_ = false, this.mutationEventsAdded_ = false, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = /* @__PURE__ */ function(e4, t3) {
              var n3 = false, r3 = false, i3 = 0;
              function a3() {
                n3 && (n3 = false, e4()), r3 && l3();
              }
              function s3() {
                o2(a3);
              }
              function l3() {
                var e5 = Date.now();
                if (n3) {
                  if (e5 - i3 < 2) return;
                  r3 = true;
                } else n3 = true, r3 = false, setTimeout(s3, 20);
                i3 = e5;
              }
              return l3;
            }(this.refresh.bind(this));
          }
          return e3.prototype.addObserver = function(e4) {
            ~this.observers_.indexOf(e4) || this.observers_.push(e4), this.connected_ || this.connect_();
          }, e3.prototype.removeObserver = function(e4) {
            var t3 = this.observers_, n3 = t3.indexOf(e4);
            ~n3 && t3.splice(n3, 1), !t3.length && this.connected_ && this.disconnect_();
          }, e3.prototype.refresh = function() {
            this.updateObservers_() && this.refresh();
          }, e3.prototype.updateObservers_ = function() {
            var e4 = this.observers_.filter(function(e5) {
              return e5.gatherActive(), e5.hasActive();
            });
            return e4.forEach(function(e5) {
              return e5.broadcastActive();
            }), e4.length > 0;
          }, e3.prototype.connect_ = function() {
            n2 && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), a2 ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, { attributes: true, childList: true, characterData: true, subtree: true })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = true), this.connected_ = true);
          }, e3.prototype.disconnect_ = function() {
            n2 && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = false, this.connected_ = false);
          }, e3.prototype.onTransitionEnd_ = function(e4) {
            var t3 = e4.propertyName, n3 = void 0 === t3 ? "" : t3;
            i2.some(function(e5) {
              return !!~n3.indexOf(e5);
            }) && this.refresh();
          }, e3.getInstance = function() {
            return this.instance_ || (this.instance_ = new e3()), this.instance_;
          }, e3.instance_ = null, e3;
        }(), l2 = function(e3, t3) {
          for (var n3 = 0, r3 = Object.keys(t3); n3 < r3.length; n3++) {
            var o3 = r3[n3];
            Object.defineProperty(e3, o3, { value: t3[o3], enumerable: false, writable: false, configurable: true });
          }
          return e3;
        }, u2 = function(e3) {
          return e3 && e3.ownerDocument && e3.ownerDocument.defaultView || r2;
        }, c2 = m2(0, 0, 0, 0);
        function p2(e3) {
          return parseFloat(e3) || 0;
        }
        function d2(e3) {
          for (var t3 = [], n3 = 1; n3 < arguments.length; n3++) t3[n3 - 1] = arguments[n3];
          return t3.reduce(function(t4, n4) {
            return t4 + p2(e3["border-" + n4 + "-width"]);
          }, 0);
        }
        var h2 = "undefined" != typeof SVGGraphicsElement ? function(e3) {
          return e3 instanceof u2(e3).SVGGraphicsElement;
        } : function(e3) {
          return e3 instanceof u2(e3).SVGElement && "function" == typeof e3.getBBox;
        };
        function f2(e3) {
          return n2 ? h2(e3) ? function(e4) {
            var t3 = e4.getBBox();
            return m2(0, 0, t3.width, t3.height);
          }(e3) : function(e4) {
            var t3 = e4.clientWidth, n3 = e4.clientHeight;
            if (!t3 && !n3) return c2;
            var r3 = u2(e4).getComputedStyle(e4), o3 = function(e5) {
              for (var t4 = {}, n4 = 0, r4 = ["top", "right", "bottom", "left"]; n4 < r4.length; n4++) {
                var o4 = r4[n4], i4 = e5["padding-" + o4];
                t4[o4] = p2(i4);
              }
              return t4;
            }(r3), i3 = o3.left + o3.right, a3 = o3.top + o3.bottom, s3 = p2(r3.width), l3 = p2(r3.height);
            if ("border-box" === r3.boxSizing && (Math.round(s3 + i3) !== t3 && (s3 -= d2(r3, "left", "right") + i3), Math.round(l3 + a3) !== n3 && (l3 -= d2(r3, "top", "bottom") + a3)), !function(e5) {
              return e5 === u2(e5).document.documentElement;
            }(e4)) {
              var h3 = Math.round(s3 + i3) - t3, f3 = Math.round(l3 + a3) - n3;
              1 !== Math.abs(h3) && (s3 -= h3), 1 !== Math.abs(f3) && (l3 -= f3);
            }
            return m2(o3.left, o3.top, s3, l3);
          }(e3) : c2;
        }
        function m2(e3, t3, n3, r3) {
          return { x: e3, y: t3, width: n3, height: r3 };
        }
        var v2 = function() {
          function e3(e4) {
            this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = m2(0, 0, 0, 0), this.target = e4;
          }
          return e3.prototype.isActive = function() {
            var e4 = f2(this.target);
            return this.contentRect_ = e4, e4.width !== this.broadcastWidth || e4.height !== this.broadcastHeight;
          }, e3.prototype.broadcastRect = function() {
            var e4 = this.contentRect_;
            return this.broadcastWidth = e4.width, this.broadcastHeight = e4.height, e4;
          }, e3;
        }(), g2 = function(e3, t3) {
          var n3, r3, o3, i3, a3, s3, u3, c3 = (r3 = (n3 = t3).x, o3 = n3.y, i3 = n3.width, a3 = n3.height, s3 = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, u3 = Object.create(s3.prototype), l2(u3, { x: r3, y: o3, width: i3, height: a3, top: o3, right: r3 + i3, bottom: a3 + o3, left: r3 }), u3);
          l2(this, { target: e3, contentRect: c3 });
        }, y2 = function() {
          function e3(e4, n3, r3) {
            if (this.activeObservations_ = [], this.observations_ = new t2(), "function" != typeof e4) throw new TypeError("The callback provided as parameter 1 is not a function.");
            this.callback_ = e4, this.controller_ = n3, this.callbackCtx_ = r3;
          }
          return e3.prototype.observe = function(e4) {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
            if ("undefined" != typeof Element && Element instanceof Object) {
              if (!(e4 instanceof u2(e4).Element)) throw new TypeError('parameter 1 is not of type "Element".');
              var t3 = this.observations_;
              t3.has(e4) || (t3.set(e4, new v2(e4)), this.controller_.addObserver(this), this.controller_.refresh());
            }
          }, e3.prototype.unobserve = function(e4) {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
            if ("undefined" != typeof Element && Element instanceof Object) {
              if (!(e4 instanceof u2(e4).Element)) throw new TypeError('parameter 1 is not of type "Element".');
              var t3 = this.observations_;
              t3.has(e4) && (t3.delete(e4), t3.size || this.controller_.removeObserver(this));
            }
          }, e3.prototype.disconnect = function() {
            this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
          }, e3.prototype.gatherActive = function() {
            var e4 = this;
            this.clearActive(), this.observations_.forEach(function(t3) {
              t3.isActive() && e4.activeObservations_.push(t3);
            });
          }, e3.prototype.broadcastActive = function() {
            if (this.hasActive()) {
              var e4 = this.callbackCtx_, t3 = this.activeObservations_.map(function(e5) {
                return new g2(e5.target, e5.broadcastRect());
              });
              this.callback_.call(e4, t3, e4), this.clearActive();
            }
          }, e3.prototype.clearActive = function() {
            this.activeObservations_.splice(0);
          }, e3.prototype.hasActive = function() {
            return this.activeObservations_.length > 0;
          }, e3;
        }(), b2 = "undefined" != typeof WeakMap ? /* @__PURE__ */ new WeakMap() : new t2(), _2 = function e3(t3) {
          if (!(this instanceof e3)) throw new TypeError("Cannot call a class as a function.");
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
          var n3 = s2.getInstance(), r3 = new y2(t3, n3, this);
          b2.set(this, r3);
        };
        return ["observe", "unobserve", "disconnect"].forEach(function(e3) {
          _2.prototype[e3] = function() {
            var t3;
            return (t3 = b2.get(this))[e3].apply(t3, arguments);
          };
        }), void 0 !== r2.ResizeObserver ? r2.ResizeObserver : _2;
      });
    }).call(this);
  }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}), No = No.exports;
  var To = {};
  (function(e2) {
    (function() {
      var t2 = /^\s+|\s+$/g, n2 = /^[-+]0x[0-9a-f]+$/i, r2 = /^0b[01]+$/i, o2 = /^0o[0-7]+$/i, i2 = parseInt, a2 = "object" == typeof e2 && e2 && e2.Object === Object && e2, s2 = "object" == typeof self && self && self.Object === Object && self, l2 = a2 || s2 || Function("return this")(), u2 = Object.prototype.toString, c2 = Math.max, p2 = Math.min, d2 = function() {
        return l2.Date.now();
      };
      function h2(e3) {
        var t3 = typeof e3;
        return !!e3 && ("object" == t3 || "function" == t3);
      }
      function f2(e3) {
        if ("number" == typeof e3) return e3;
        if (function(e4) {
          return "symbol" == typeof e4 || /* @__PURE__ */ function(e5) {
            return !!e5 && "object" == typeof e5;
          }(e4) && "[object Symbol]" == u2.call(e4);
        }(e3)) return NaN;
        if (h2(e3)) {
          var a3 = "function" == typeof e3.valueOf ? e3.valueOf() : e3;
          e3 = h2(a3) ? a3 + "" : a3;
        }
        if ("string" != typeof e3) return 0 === e3 ? e3 : +e3;
        e3 = e3.replace(t2, "");
        var s3 = r2.test(e3);
        return s3 || o2.test(e3) ? i2(e3.slice(2), s3 ? 2 : 8) : n2.test(e3) ? NaN : +e3;
      }
      To = function(e3, t3, n3) {
        var r3, o3, i3, a3, s3, l3, u3 = 0, m2 = false, v2 = false, g2 = true;
        if ("function" != typeof e3) throw new TypeError("Expected a function");
        function y2(t4) {
          var n4 = r3, i4 = o3;
          return r3 = o3 = void 0, u3 = t4, a3 = e3.apply(i4, n4);
        }
        function b2(e4) {
          var n4 = e4 - l3;
          return void 0 === l3 || n4 >= t3 || n4 < 0 || v2 && e4 - u3 >= i3;
        }
        function _2() {
          var e4 = d2();
          if (b2(e4)) return w2(e4);
          s3 = setTimeout(_2, function(e5) {
            var n4 = t3 - (e5 - l3);
            return v2 ? p2(n4, i3 - (e5 - u3)) : n4;
          }(e4));
        }
        function w2(e4) {
          return s3 = void 0, g2 && r3 ? y2(e4) : (r3 = o3 = void 0, a3);
        }
        function C2() {
          var e4 = d2(), n4 = b2(e4);
          if (r3 = arguments, o3 = this, l3 = e4, n4) {
            if (void 0 === s3) return function(e5) {
              return u3 = e5, s3 = setTimeout(_2, t3), m2 ? y2(e5) : a3;
            }(l3);
            if (v2) return s3 = setTimeout(_2, t3), y2(l3);
          }
          return void 0 === s3 && (s3 = setTimeout(_2, t3)), a3;
        }
        return t3 = f2(t3) || 0, h2(n3) && (m2 = !!n3.leading, i3 = (v2 = "maxWait" in n3) ? c2(f2(n3.maxWait) || 0, t3) : i3, g2 = "trailing" in n3 ? !!n3.trailing : g2), C2.cancel = function() {
          void 0 !== s3 && clearTimeout(s3), u3 = 0, r3 = l3 = o3 = s3 = void 0;
        }, C2.flush = function() {
          return void 0 === s3 ? a3 : w2(d2());
        }, C2;
      };
    }).call(this);
  }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
  function Ro(e2, t2) {
    if (e2.length !== t2.length) return false;
    for (var n2 = 0; n2 < e2.length; n2++) if (e2[n2] !== t2[n2]) return false;
    return true;
  }
  var Fo, Do, Mo = function(e2, t2) {
    var n2;
    void 0 === t2 && (t2 = Ro);
    var r2, o2 = [], i2 = false;
    return function() {
      for (var a2 = [], s2 = 0; s2 < arguments.length; s2++) a2[s2] = arguments[s2];
      return i2 && n2 === this && t2(a2, o2) || (r2 = e2.apply(this, a2), i2 = true, n2 = this, o2 = a2), r2;
    };
  };
  function Bo() {
    return (Bo = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Io(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Lo(e2, t2) {
    return (Lo = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var jo = nn.h, zo = ue.Plugin, Ho = No.default || No, Wo = Mo.default || Mo;
  function Vo() {
    var e2 = {};
    return e2.promise = new Promise(function(t2, n2) {
      e2.resolve = t2, e2.reject = n2;
    }), e2;
  }
  function qo() {
    return jo("svg", { "aria-hidden": "true", focusable: "false", width: "30", height: "30", viewBox: "0 0 30 30" }, jo("path", { d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z" }));
  }
  var Xo = (Do = Fo = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      (r3 = e2.call(this, t3, n3) || this).setOptions = function(t4) {
        e2.prototype.setOptions.call(Io(r3), t4), r3.i18nInit();
      }, r3.i18nInit = function() {
        r3.translator = new x([r3.defaultLocale, r3.uppy.locale, r3.opts.locale]), r3.i18n = r3.translator.translate.bind(r3.translator), r3.i18nArray = r3.translator.translateArray.bind(r3.translator), r3.setPluginState();
      }, r3.removeTarget = function(e3) {
        var t4 = r3.getPluginState().targets.filter(function(t5) {
          return t5.id !== e3.id;
        });
        r3.setPluginState({ targets: t4 });
      }, r3.addTarget = function(e3) {
        var t4 = e3.id || e3.constructor.name, n4 = e3.title || t4, o3 = e3.type;
        if ("acquirer" === o3 || "progressindicator" === o3 || "editor" === o3) {
          var i3 = { id: t4, name: n4, type: o3 }, a2 = r3.getPluginState().targets.slice();
          return a2.push(i3), r3.setPluginState({ targets: a2 }), r3.el;
        }
        r3.uppy.log("Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor", "error");
      }, r3.hideAllPanels = function() {
        var e3 = { activePickerPanel: false, showAddFilesPanel: false, activeOverlayType: null, fileCardFor: null, showFileEditor: false }, t4 = r3.getPluginState();
        t4.activePickerPanel === e3.activePickerPanel && t4.showAddFilesPanel === e3.showAddFilesPanel && t4.showFileEditor === e3.showFileEditor && t4.activeOverlayType === e3.activeOverlayType || r3.setPluginState(e3);
      }, r3.showPanel = function(e3) {
        var t4 = r3.getPluginState().targets.filter(function(t5) {
          return "acquirer" === t5.type && t5.id === e3;
        })[0];
        r3.setPluginState({ activePickerPanel: t4, activeOverlayType: "PickerPanel" });
      }, r3.canEditFile = function(e3) {
        var t4 = r3.getPluginState().targets;
        return r3._getEditors(t4).some(function(t5) {
          return r3.uppy.getPlugin(t5.id).canEditFile(e3);
        });
      }, r3.openFileEditor = function(e3) {
        var t4 = r3.getPluginState().targets, n4 = r3._getEditors(t4);
        r3.setPluginState({ showFileEditor: true, fileCardFor: e3.id || null, activeOverlayType: "FileEditor" }), n4.forEach(function(t5) {
          r3.uppy.getPlugin(t5.id).selectFile(e3);
        });
      }, r3.openModal = function() {
        var e3 = Vo(), t4 = e3.promise, n4 = e3.resolve;
        return r3.savedScrollPosition = window.pageYOffset, r3.savedActiveElement = document.activeElement, r3.opts.disablePageScrollWhenModalOpen && document.body.classList.add("uppy-Dashboard-isFixed"), r3.opts.animateOpenClose && r3.getPluginState().isClosing ? r3.el.addEventListener("animationend", function e4() {
          r3.setPluginState({ isHidden: false }), r3.el.removeEventListener("animationend", e4, false), n4();
        }, false) : (r3.setPluginState({ isHidden: false }), n4()), r3.opts.browserBackButtonClose && r3.updateBrowserHistory(), document.addEventListener("keydown", r3.handleKeyDownInModal), r3.uppy.emit("dashboard:modal-open"), t4;
      }, r3.closeModal = function(e3) {
        void 0 === e3 && (e3 = {});
        var t4 = e3.manualClose, n4 = void 0 === t4 || t4, o3 = r3.getPluginState(), i3 = o3.isHidden, a2 = o3.isClosing;
        if (!i3 && !a2) {
          var s2 = Vo(), l2 = s2.promise, u2 = s2.resolve;
          return r3.opts.disablePageScrollWhenModalOpen && document.body.classList.remove("uppy-Dashboard-isFixed"), r3.opts.animateOpenClose ? (r3.setPluginState({ isClosing: true }), r3.el.addEventListener("animationend", function e4() {
            r3.setPluginState({ isHidden: true, isClosing: false }), r3.superFocus.cancel(), r3.savedActiveElement.focus(), r3.el.removeEventListener("animationend", e4, false), u2();
          }, false)) : (r3.setPluginState({ isHidden: true }), r3.superFocus.cancel(), r3.savedActiveElement.focus(), u2()), document.removeEventListener("keydown", r3.handleKeyDownInModal), n4 && r3.opts.browserBackButtonClose && history.state && history.state[r3.modalName] && history.go(-1), r3.uppy.emit("dashboard:modal-closed"), l2;
        }
      }, r3.isModalOpen = function() {
        return !r3.getPluginState().isHidden || false;
      }, r3.requestCloseModal = function() {
        return r3.opts.onRequestCloseModal ? r3.opts.onRequestCloseModal() : r3.closeModal();
      }, r3.setDarkModeCapability = function(e3) {
        var t4 = r3.uppy.getState().capabilities;
        r3.uppy.setState({ capabilities: Bo({}, t4, { darkMode: e3 }) });
      }, r3.handleSystemDarkModeChange = function(e3) {
        var t4 = e3.matches;
        r3.uppy.log("[Dashboard] Dark mode is " + (t4 ? "on" : "off")), r3.setDarkModeCapability(t4);
      }, r3.toggleFileCard = function(e3, t4) {
        var n4 = r3.uppy.getFile(t4);
        e3 ? r3.uppy.emit("dashboard:file-edit-start", n4) : r3.uppy.emit("dashboard:file-edit-complete", n4), r3.setPluginState({ fileCardFor: e3 ? t4 : null, activeOverlayType: e3 ? "FileCard" : null });
      }, r3.toggleAddFilesPanel = function(e3) {
        r3.setPluginState({ showAddFilesPanel: e3, activeOverlayType: e3 ? "AddFiles" : null });
      }, r3.addFiles = function(e3) {
        var t4 = e3.map(function(e4) {
          return { source: r3.id, name: e4.name, type: e4.type, data: e4, meta: { relativePath: e4.relativePath || null } };
        });
        try {
          r3.uppy.addFiles(t4);
        } catch (wd2) {
          r3.uppy.log(wd2);
        }
      }, r3.startListeningToResize = function() {
        r3.resizeObserver = new Ho(function(e3, t4) {
          var n4 = e3[0].contentRect, o3 = n4.width, i3 = n4.height;
          r3.uppy.log("[Dashboard] resized: " + o3 + " / " + i3, "debug"), r3.setPluginState({ containerWidth: o3, containerHeight: i3, areInsidesReadyToBeVisible: true });
        }), r3.resizeObserver.observe(r3.el.querySelector(".uppy-Dashboard-inner")), r3.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(function() {
          var e3 = r3.getPluginState(), t4 = !r3.opts.inline && e3.isHidden;
          e3.areInsidesReadyToBeVisible || t4 || (r3.uppy.log("[Dashboard] resize event didn't fire on time: defaulted to mobile layout", "debug"), r3.setPluginState({ areInsidesReadyToBeVisible: true }));
        }, 1e3);
      }, r3.stopListeningToResize = function() {
        r3.resizeObserver.disconnect(), clearTimeout(r3.makeDashboardInsidesVisibleAnywayTimeout);
      }, r3.recordIfFocusedOnUppyRecently = function(e3) {
        r3.el.contains(e3.target) ? r3.ifFocusedOnUppyRecently = true : (r3.ifFocusedOnUppyRecently = false, r3.superFocus.cancel());
      }, r3.disableAllFocusableElements = function(e3) {
        var t4 = Co(r3.el.querySelectorAll(Po));
        e3 ? t4.forEach(function(e4) {
          var t5 = e4.getAttribute("tabindex");
          t5 && (e4.dataset.inertTabindex = t5), e4.setAttribute("tabindex", "-1");
        }) : t4.forEach(function(e4) {
          "inertTabindex" in e4.dataset ? e4.setAttribute("tabindex", e4.dataset.inertTabindex) : e4.removeAttribute("tabindex");
        }), r3.dashboardIsDisabled = e3;
      }, r3.updateBrowserHistory = function() {
        var e3;
        history.state && history.state[r3.modalName] || history.pushState(Bo({}, history.state, ((e3 = {})[r3.modalName] = true, e3)), ""), window.addEventListener("popstate", r3.handlePopState, false);
      }, r3.handlePopState = function(e3) {
        !r3.isModalOpen() || e3.state && e3.state[r3.modalName] || r3.closeModal({ manualClose: false }), !r3.isModalOpen() && e3.state && e3.state[r3.modalName] && history.go(-1);
      }, r3.handleKeyDownInModal = function(e3) {
        27 === e3.keyCode && r3.requestCloseModal(e3), 9 === e3.keyCode && Ao(e3, r3.getPluginState().activeOverlayType, r3.el);
      }, r3.handleClickOutside = function() {
        r3.opts.closeModalOnClickOutside && r3.requestCloseModal();
      }, r3.handlePaste = function(e3) {
        r3.uppy.iteratePlugins(function(t5) {
          "acquirer" === t5.type && t5.handleRootPaste && t5.handleRootPaste(e3);
        });
        var t4 = Co(e3.clipboardData.files);
        r3.addFiles(t4);
      }, r3.handleInputChange = function(e3) {
        e3.preventDefault();
        var t4 = Co(e3.target.files);
        r3.addFiles(t4);
      }, r3.handleDragOver = function(e3) {
        e3.preventDefault(), e3.stopPropagation(), r3.opts.disabled || r3.opts.disableLocalFiles || (e3.dataTransfer.dropEffect = "copy", clearTimeout(r3.removeDragOverClassTimeout), r3.setPluginState({ isDraggingOver: true }));
      }, r3.handleDragLeave = function(e3) {
        e3.preventDefault(), e3.stopPropagation(), r3.opts.disabled || r3.opts.disableLocalFiles || (clearTimeout(r3.removeDragOverClassTimeout), r3.removeDragOverClassTimeout = setTimeout(function() {
          r3.setPluginState({ isDraggingOver: false });
        }, 50));
      }, r3.handleDrop = function(e3, t4) {
        if (e3.preventDefault(), e3.stopPropagation(), !r3.opts.disabled && !r3.opts.disableLocalFiles) {
          clearTimeout(r3.removeDragOverClassTimeout), r3.setPluginState({ isDraggingOver: false }), r3.uppy.iteratePlugins(function(t5) {
            "acquirer" === t5.type && t5.handleRootDrop && t5.handleRootDrop(e3);
          });
          var n4 = false;
          ko(e3.dataTransfer, { logDropError: function(e4) {
            r3.uppy.log(e4, "error"), n4 || (r3.uppy.info(e4.message, "error"), n4 = true);
          } }).then(function(e4) {
            e4.length > 0 && (r3.uppy.log("[Dashboard] Files were dropped"), r3.addFiles(e4));
          });
        }
      }, r3.handleRequestThumbnail = function(e3) {
        r3.opts.waitForThumbnailsBeforeUpload || r3.uppy.emit("thumbnail:request", e3);
      }, r3.handleCancelThumbnail = function(e3) {
        r3.opts.waitForThumbnailsBeforeUpload || r3.uppy.emit("thumbnail:cancel", e3);
      }, r3.handleKeyDownInInline = function(e3) {
        9 === e3.keyCode && Uo(e3, r3.getPluginState().activeOverlayType, r3.el);
      }, r3.handlePasteOnBody = function(e3) {
        r3.el.contains(document.activeElement) && r3.handlePaste(e3);
      }, r3.handleComplete = function(e3) {
        var t4 = e3.failed;
        r3.opts.closeAfterFinish && 0 === t4.length && r3.requestCloseModal();
      }, r3.handleCancelRestore = function() {
        r3.uppy.emit("restore-canceled");
      }, r3._openFileEditorWhenFilesAdded = function(e3) {
        var t4 = e3[0];
        r3.canEditFile(t4) && r3.openFileEditor(t4);
      }, r3.initEvents = function() {
        if (r3.opts.trigger && !r3.opts.inline) {
          var e3 = wo(r3.opts.trigger);
          e3 ? e3.forEach(function(e4) {
            return e4.addEventListener("click", r3.openModal);
          }) : r3.uppy.log("Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself", "warning");
        }
        r3.startListeningToResize(), document.addEventListener("paste", r3.handlePasteOnBody), r3.uppy.on("plugin-remove", r3.removeTarget), r3.uppy.on("file-added", r3.hideAllPanels), r3.uppy.on("dashboard:modal-closed", r3.hideAllPanels), r3.uppy.on("file-editor:complete", r3.hideAllPanels), r3.uppy.on("complete", r3.handleComplete), document.addEventListener("focus", r3.recordIfFocusedOnUppyRecently, true), document.addEventListener("click", r3.recordIfFocusedOnUppyRecently, true), r3.opts.inline && r3.el.addEventListener("keydown", r3.handleKeyDownInInline), r3.opts.autoOpenFileEditor && r3.uppy.on("files-added", r3._openFileEditorWhenFilesAdded);
      }, r3.removeEvents = function() {
        var e3 = wo(r3.opts.trigger);
        !r3.opts.inline && e3 && e3.forEach(function(e4) {
          return e4.removeEventListener("click", r3.openModal);
        }), r3.stopListeningToResize(), document.removeEventListener("paste", r3.handlePasteOnBody), window.removeEventListener("popstate", r3.handlePopState, false), r3.uppy.off("plugin-remove", r3.removeTarget), r3.uppy.off("file-added", r3.hideAllPanels), r3.uppy.off("dashboard:modal-closed", r3.hideAllPanels), r3.uppy.off("file-editor:complete", r3.hideAllPanels), r3.uppy.off("complete", r3.handleComplete), document.removeEventListener("focus", r3.recordIfFocusedOnUppyRecently), document.removeEventListener("click", r3.recordIfFocusedOnUppyRecently), r3.opts.inline && r3.el.removeEventListener("keydown", r3.handleKeyDownInInline), r3.opts.autoOpenFileEditor && r3.uppy.off("files-added", r3._openFileEditorWhenFilesAdded);
      }, r3.superFocusOnEachUpdate = function() {
        var e3 = r3.el.contains(document.activeElement), t4 = document.activeElement === document.body || null === document.activeElement, n4 = r3.uppy.getState().info.isHidden, o3 = !r3.opts.inline;
        n4 && (o3 || e3 || t4 && r3.ifFocusedOnUppyRecently) ? r3.superFocus(r3.el, r3.getPluginState().activeOverlayType) : r3.superFocus.cancel();
      }, r3.afterUpdate = function() {
        !r3.opts.disabled || r3.dashboardIsDisabled ? (!r3.opts.disabled && r3.dashboardIsDisabled && r3.disableAllFocusableElements(false), r3.superFocusOnEachUpdate()) : r3.disableAllFocusableElements(true);
      }, r3.cancelUpload = function(e3) {
        r3.uppy.removeFile(e3);
      }, r3.saveFileCard = function(e3, t4) {
        r3.uppy.setFileMeta(t4, e3), r3.toggleFileCard(false, t4);
      }, r3._attachRenderFunctionToTarget = function(e3) {
        var t4 = r3.uppy.getPlugin(e3.id);
        return Bo({}, e3, { icon: t4.icon || r3.opts.defaultPickerIcon, render: t4.render });
      }, r3._isTargetSupported = function(e3) {
        var t4 = r3.uppy.getPlugin(e3.id);
        return "function" != typeof t4.isSupported || t4.isSupported();
      }, r3._getAcquirers = Wo(function(e3) {
        return e3.filter(function(e4) {
          return "acquirer" === e4.type && r3._isTargetSupported(e4);
        }).map(r3._attachRenderFunctionToTarget);
      }), r3._getProgressIndicators = Wo(function(e3) {
        return e3.filter(function(e4) {
          return "progressindicator" === e4.type;
        }).map(r3._attachRenderFunctionToTarget);
      }), r3._getEditors = Wo(function(e3) {
        return e3.filter(function(e4) {
          return "editor" === e4.type;
        }).map(r3._attachRenderFunctionToTarget);
      }), r3.render = function(e3) {
        var t4, n4 = r3.getPluginState(), o3 = e3.files, i3 = e3.capabilities, a2 = e3.allowNewUpload, s2 = Object.keys(o3).filter(function(e4) {
          return !o3[e4].progress.uploadStarted;
        }), l2 = Object.keys(o3).filter(function(e4) {
          return o3[e4].progress.uploadStarted;
        }), u2 = Object.keys(o3).filter(function(e4) {
          return o3[e4].isPaused;
        }), c2 = Object.keys(o3).filter(function(e4) {
          return o3[e4].progress.uploadComplete;
        }), p2 = Object.keys(o3).filter(function(e4) {
          return o3[e4].error;
        }), d2 = Object.keys(o3).filter(function(e4) {
          return !o3[e4].progress.uploadComplete && o3[e4].progress.uploadStarted;
        }), h2 = d2.filter(function(e4) {
          return !o3[e4].isPaused;
        }), f2 = Object.keys(o3).filter(function(e4) {
          return o3[e4].progress.preprocess || o3[e4].progress.postprocess;
        }), m2 = l2.length > 0, v2 = 100 === e3.totalProgress && c2.length === Object.keys(o3).length && 0 === f2.length, g2 = m2 && p2.length === l2.length, y2 = 0 !== d2.length && u2.length === d2.length, b2 = r3._getAcquirers(n4.targets), _2 = r3._getProgressIndicators(n4.targets), w2 = r3._getEditors(n4.targets);
        return t4 = "auto" === r3.opts.theme ? i3.darkMode ? "dark" : "light" : r3.opts.theme, ["files", "folders", "both"].indexOf(r3.opts.fileManagerSelectionType) < 0 && (r3.opts.fileManagerSelectionType = "files", console.error('Unsupported option for "fileManagerSelectionType". Using default of "' + r3.opts.fileManagerSelectionType + '".')), function(e4) {
          var t5 = 0 === e4.totalFileCount, n5 = e4.containerWidth > 576, r4 = it({ "uppy-Root": e4.isTargetDOMEl }), o4 = it({ "uppy-Dashboard": true, "uppy-Dashboard--isDisabled": e4.disabled, "uppy-Dashboard--animateOpenClose": e4.animateOpenClose, "uppy-Dashboard--isClosing": e4.isClosing, "uppy-Dashboard--isDraggingOver": e4.isDraggingOver, "uppy-Dashboard--modal": !e4.inline, "uppy-size--md": e4.containerWidth > 576, "uppy-size--lg": e4.containerWidth > 700, "uppy-size--xl": e4.containerWidth > 900, "uppy-size--height-md": e4.containerHeight > 400, "uppy-Dashboard--isAddFilesPanelVisible": e4.showAddFilesPanel, "uppy-Dashboard--isInnerWrapVisible": e4.areInsidesReadyToBeVisible }), i4 = 1;
          e4.containerWidth > 900 ? i4 = 5 : e4.containerWidth > 700 ? i4 = 4 : e4.containerWidth > 576 && (i4 = 3);
          var a3 = e4.showSelectedFiles && !t5, s3 = e4.recoveredState ? Object.keys(e4.recoveredState.files).length : null, l3 = e4.files ? Object.keys(e4.files).filter(function(t6) {
            return e4.files[t6].isGhost;
          }).length : null, u3 = vr("div", { className: o4, "data-uppy-theme": e4.theme, "data-uppy-num-acquirers": e4.acquirers.length, "data-uppy-drag-drop-supported": !e4.disableLocalFiles && fr(), "aria-hidden": e4.inline ? "false" : e4.isHidden, "aria-disabled": e4.disabled, "aria-label": e4.inline ? e4.i18n("dashboardTitle") : e4.i18n("dashboardWindowTitle"), onPaste: e4.handlePaste, onDragOver: e4.handleDragOver, onDragLeave: e4.handleDragLeave, onDrop: e4.handleDrop }, vr("div", { className: "uppy-Dashboard-overlay", tabIndex: -1, onClick: e4.handleClickOutside }), vr("div", { className: "uppy-Dashboard-inner", "aria-modal": !e4.inline && "true", role: !e4.inline && "dialog", style: { width: e4.inline && e4.width ? e4.width : "", height: e4.inline && e4.height ? e4.height : "" } }, e4.inline ? null : vr("button", { className: "uppy-u-reset uppy-Dashboard-close", type: "button", "aria-label": e4.i18n("closeModal"), title: e4.i18n("closeModal"), onClick: e4.closeModal }, vr("span", { "aria-hidden": "true" }, "\xD7")), vr("div", { className: "uppy-Dashboard-innerWrap" }, vr("div", { className: "uppy-Dashboard-dropFilesHereHint" }, e4.i18n("dropHint")), a3 && vr(or, e4), s3 && vr("div", { className: "uppy-Dashboard-serviceMsg" }, vr("svg", { className: "uppy-Dashboard-serviceMsg-icon", "aria-hidden": "true", focusable: "false", width: "21", height: "16", viewBox: "0 0 24 19" }, vr("g", { transform: "translate(0 -1)", fill: "none", fillRule: "evenodd" }, vr("path", { d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z", fill: "#FFD300" }), vr("path", { fill: "#000", d: "M11 6h2l-.3 8h-1.4z" }), vr("circle", { fill: "#000", cx: "12", cy: "17", r: "1" }))), vr("strong", { className: "uppy-Dashboard-serviceMsg-title" }, e4.i18n("sessionRestored")), vr("div", { class: "uppy-Dashboard-serviceMsg-text" }, l3 > 0 ? e4.i18n("recoveredXFiles", { smart_count: l3 }) : e4.i18n("recoveredAllFiles"))), a3 ? vr(In, mr({}, e4, { itemsPerRow: i4 })) : vr(zn, mr({}, e4, { isSizeMD: n5 })), vr(hr, null, e4.showAddFilesPanel ? vr(Wn, mr({ key: "AddFiles" }, e4, { isSizeMD: n5 })) : null), vr(hr, null, e4.fileCardFor ? vr(lr, mr({ key: "FileCard" }, e4)) : null), vr(hr, null, e4.activePickerPanel ? vr(Xn, mr({ key: "Picker" }, e4)) : null), vr(hr, null, e4.showFileEditor ? vr(Yn, mr({ key: "Editor" }, e4)) : null), vr("div", { className: "uppy-Dashboard-progressindicators" }, e4.progressindicators.map(function(t6) {
            return e4.getPlugin(t6.id).render(e4.state);
          })))));
          return vr("div", { className: r4, dir: e4.direction }, u3);
        }({ state: e3, isHidden: n4.isHidden, files: o3, newFiles: s2, uploadStartedFiles: l2, completeFiles: c2, erroredFiles: p2, inProgressFiles: d2, inProgressNotPausedFiles: h2, processingFiles: f2, isUploadStarted: m2, isAllComplete: v2, isAllErrored: g2, isAllPaused: y2, totalFileCount: Object.keys(o3).length, totalProgress: e3.totalProgress, allowNewUpload: a2, acquirers: b2, theme: t4, disabled: r3.opts.disabled, disableLocalFiles: r3.opts.disableLocalFiles, direction: r3.opts.direction, activePickerPanel: n4.activePickerPanel, showFileEditor: n4.showFileEditor, disableAllFocusableElements: r3.disableAllFocusableElements, animateOpenClose: r3.opts.animateOpenClose, isClosing: n4.isClosing, getPlugin: r3.uppy.getPlugin, progressindicators: _2, editors: w2, autoProceed: r3.uppy.opts.autoProceed, id: r3.id, closeModal: r3.requestCloseModal, handleClickOutside: r3.handleClickOutside, handleInputChange: r3.handleInputChange, handlePaste: r3.handlePaste, inline: r3.opts.inline, showPanel: r3.showPanel, hideAllPanels: r3.hideAllPanels, log: r3.uppy.log, i18n: r3.i18n, i18nArray: r3.i18nArray, removeFile: r3.uppy.removeFile, uppy: r3.uppy, info: r3.uppy.info, note: r3.opts.note, recoveredState: e3.recoveredState, metaFields: n4.metaFields, resumableUploads: i3.resumableUploads || false, individualCancellation: i3.individualCancellation, isMobileDevice: i3.isMobileDevice, pauseUpload: r3.uppy.pauseResume, retryUpload: r3.uppy.retryUpload, cancelUpload: r3.cancelUpload, cancelAll: r3.uppy.cancelAll, fileCardFor: n4.fileCardFor, toggleFileCard: r3.toggleFileCard, toggleAddFilesPanel: r3.toggleAddFilesPanel, showAddFilesPanel: n4.showAddFilesPanel, saveFileCard: r3.saveFileCard, openFileEditor: r3.openFileEditor, canEditFile: r3.canEditFile, width: r3.opts.width, height: r3.opts.height, showLinkToFileUploadResult: r3.opts.showLinkToFileUploadResult, fileManagerSelectionType: r3.opts.fileManagerSelectionType, proudlyDisplayPoweredByUppy: r3.opts.proudlyDisplayPoweredByUppy, hideCancelButton: r3.opts.hideCancelButton, hideRetryButton: r3.opts.hideRetryButton, hidePauseResumeButton: r3.opts.hidePauseResumeButton, showRemoveButtonAfterComplete: r3.opts.showRemoveButtonAfterComplete, containerWidth: n4.containerWidth, containerHeight: n4.containerHeight, areInsidesReadyToBeVisible: n4.areInsidesReadyToBeVisible, isTargetDOMEl: r3.isTargetDOMEl, parentElement: r3.el, allowedFileTypes: r3.uppy.opts.restrictions.allowedFileTypes, maxNumberOfFiles: r3.uppy.opts.restrictions.maxNumberOfFiles, showSelectedFiles: r3.opts.showSelectedFiles, handleCancelRestore: r3.handleCancelRestore, handleRequestThumbnail: r3.handleRequestThumbnail, handleCancelThumbnail: r3.handleCancelThumbnail, isDraggingOver: n4.isDraggingOver, handleDragOver: r3.handleDragOver, handleDragLeave: r3.handleDragLeave, handleDrop: r3.handleDrop });
      }, r3.discoverProviderPlugins = function() {
        r3.uppy.iteratePlugins(function(e3) {
          e3 && !e3.target && e3.opts && e3.opts.target === r3.constructor && r3.addTarget(e3);
        });
      }, r3.install = function() {
        r3.setPluginState({ isHidden: true, fileCardFor: null, activeOverlayType: null, showAddFilesPanel: false, activePickerPanel: false, showFileEditor: false, metaFields: r3.opts.metaFields, targets: [], areInsidesReadyToBeVisible: false, isDraggingOver: false });
        var e3 = r3.opts, t4 = e3.inline, n4 = e3.closeAfterFinish;
        if (t4 && n4) throw new Error("[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.");
        r3.uppy.opts.allowMultipleUploads && n4 && r3.uppy.log("[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploads` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true", "warning");
        var o3 = r3.opts.target;
        o3 && r3.mount(o3, Io(r3)), (r3.opts.plugins || []).forEach(function(e4) {
          var t5 = r3.uppy.getPlugin(e4);
          t5 && t5.mount(Io(r3), t5);
        }), r3.opts.disableStatusBar || r3.uppy.use(Xr, { id: r3.id + ":StatusBar", target: Io(r3), hideUploadButton: r3.opts.hideUploadButton, hideRetryButton: r3.opts.hideRetryButton, hidePauseResumeButton: r3.opts.hidePauseResumeButton, hideCancelButton: r3.opts.hideCancelButton, showProgressDetails: r3.opts.showProgressDetails, hideAfterFinish: r3.opts.hideProgressAfterFinish, locale: r3.opts.locale, doneButtonHandler: r3.opts.doneButtonHandler }), r3.opts.disableInformer || r3.uppy.use(eo, { id: r3.id + ":Informer", target: Io(r3) }), r3.opts.disableThumbnailGenerator || r3.uppy.use(_o, { id: r3.id + ":ThumbnailGenerator", thumbnailWidth: r3.opts.thumbnailWidth, thumbnailType: r3.opts.thumbnailType, waitForThumbnailsBeforeUpload: r3.opts.waitForThumbnailsBeforeUpload, lazy: !r3.opts.waitForThumbnailsBeforeUpload }), r3.darkModeMediaQuery = "undefined" != typeof window && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
        var i3 = !!r3.darkModeMediaQuery && r3.darkModeMediaQuery.matches;
        r3.uppy.log("[Dashboard] Dark mode is " + (i3 ? "on" : "off")), r3.setDarkModeCapability(i3), "auto" === r3.opts.theme && r3.darkModeMediaQuery.addListener(r3.handleSystemDarkModeChange), r3.discoverProviderPlugins(), r3.initEvents();
      }, r3.uninstall = function() {
        if (!r3.opts.disableInformer) {
          var e3 = r3.uppy.getPlugin(r3.id + ":Informer");
          e3 && r3.uppy.removePlugin(e3);
        }
        if (!r3.opts.disableStatusBar) {
          var t4 = r3.uppy.getPlugin(r3.id + ":StatusBar");
          t4 && r3.uppy.removePlugin(t4);
        }
        if (!r3.opts.disableThumbnailGenerator) {
          var n4 = r3.uppy.getPlugin(r3.id + ":ThumbnailGenerator");
          n4 && r3.uppy.removePlugin(n4);
        }
        (r3.opts.plugins || []).forEach(function(e4) {
          var t5 = r3.uppy.getPlugin(e4);
          t5 && t5.unmount();
        }), "auto" === r3.opts.theme && r3.darkModeMediaQuery.removeListener(r3.handleSystemDarkModeChange), r3.unmount(), r3.removeEvents();
      }, r3.id = r3.opts.id || "Dashboard", r3.title = "Dashboard", r3.type = "orchestrator", r3.modalName = "uppy-Dashboard-" + D(), r3.defaultLocale = { strings: { closeModal: "Close Modal", importFrom: "Import from %{name}", addingMoreFiles: "Adding more files", addMoreFiles: "Add more files", dashboardWindowTitle: "File Uploader Window (Press escape to close)", dashboardTitle: "File Uploader", copyLinkToClipboardSuccess: "Link copied to clipboard", copyLinkToClipboardFallback: "Copy the URL below", copyLink: "Copy link", fileSource: "File source: %{name}", done: "Done", back: "Back", addMore: "Add more", removeFile: "Remove file", editFile: "Edit file", editing: "Editing %{file}", finishEditingFile: "Finish editing file", saveChanges: "Save changes", cancel: "Cancel", myDevice: "My Device", dropPasteFiles: "Drop files here or %{browseFiles}", dropPasteFolders: "Drop files here or %{browseFolders}", dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}", dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:", dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:", dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:", importFiles: "Import files from:", dropHint: "Drop your files here", browseFiles: "browse files", browseFolders: "browse folders", uploadComplete: "Upload complete", uploadPaused: "Upload paused", resumeUpload: "Resume upload", pauseUpload: "Pause upload", retryUpload: "Retry upload", cancelUpload: "Cancel upload", xFilesSelected: { 0: "%{smart_count} file selected", 1: "%{smart_count} files selected" }, uploadingXFiles: { 0: "Uploading %{smart_count} file", 1: "Uploading %{smart_count} files" }, processingXFiles: { 0: "Processing %{smart_count} file", 1: "Processing %{smart_count} files" }, recoveredXFiles: { 0: "We could not fully recover 1 file. Please re-select it and resume the upload.", 1: "We could not fully recover %{smart_count} files. Please re-select them and resume the upload." }, recoveredAllFiles: "We restored all files. You can now resume the upload.", sessionRestored: "Session restored", reSelect: "Re-select", poweredBy2: "%{backwardsCompat} %{uppy}", poweredBy: "Powered by" } };
      var o2, i2 = { target: "body", metaFields: [], trigger: "#uppy-select-files", inline: false, width: 750, height: 550, thumbnailWidth: 280, thumbnailType: "image/jpeg", waitForThumbnailsBeforeUpload: false, defaultPickerIcon: qo, showLinkToFileUploadResult: true, showProgressDetails: false, hideUploadButton: false, hideCancelButton: false, hideRetryButton: false, hidePauseResumeButton: false, hideProgressAfterFinish: false, doneButtonHandler: function() {
        r3.uppy.reset(), r3.requestCloseModal();
      }, note: null, closeModalOnClickOutside: false, closeAfterFinish: false, disableStatusBar: false, disableInformer: false, disableThumbnailGenerator: false, disablePageScrollWhenModalOpen: true, animateOpenClose: true, fileManagerSelectionType: "files", proudlyDisplayPoweredByUppy: true, onRequestCloseModal: function() {
        return r3.closeModal();
      }, showSelectedFiles: true, showRemoveButtonAfterComplete: false, browserBackButtonClose: false, theme: "light", autoOpenFileEditor: false, disabled: false, disableLocalFiles: false };
      return r3.opts = Bo({}, i2, n3), r3.i18nInit(), r3.superFocus = (o2 = false, To(function(e3, t4) {
        var n4 = xo(e3, t4), r4 = n4.contains(document.activeElement);
        if (!r4 || !o2) {
          var i3 = n4.querySelector("[data-uppy-super-focusable]");
          if (!r4 || i3) if (i3) i3.focus({ preventScroll: true }), o2 = true;
          else {
            var a2 = n4.querySelector(Po);
            a2 && a2.focus({ preventScroll: true }), o2 = false;
          }
        }
      }, 260)), r3.ifFocusedOnUppyRecently = false, r3.makeDashboardInsidesVisibleAnywayTimeout = null, r3.removeDragOverClassTimeout = null, r3;
    }
    return n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Lo(t2, n2), r2.prototype.onMount = function() {
      var e3 = this.el;
      Hr(e3) || (e3.dir = "ltr");
    }, r2;
  }(zo), Fo.VERSION = "1.20.2", Do), Go = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    Go.exports = N2;
  }(), Go = Go.exports;
  var Yo, $o;
  function Ko() {
    return (Ko = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Jo(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Qo(e2, t2) {
    return (Qo = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Zo, ei, ti = ue.Plugin, ni = Go.h, ri = ($o = Yo = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).type = "acquirer", r3.id = r3.opts.id || "DragDrop", r3.title = "Drag & Drop", r3.defaultLocale = { strings: { dropHereOr: "Drop files here or %{browse}", browse: "browse" } }, r3.opts = Ko({}, { target: null, inputName: "files[]", width: "100%", height: "100%", note: null }, n3), r3.isDragDropSupported = fr(), r3.removeDragOverClassTimeout = null, r3.i18nInit(), r3.onInputChange = r3.onInputChange.bind(Jo(r3)), r3.handleDragOver = r3.handleDragOver.bind(Jo(r3)), r3.handleDragLeave = r3.handleDragLeave.bind(Jo(r3)), r3.handleDrop = r3.handleDrop.bind(Jo(r3)), r3.addFiles = r3.addFiles.bind(Jo(r3)), r3.render = r3.render.bind(Jo(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Qo(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, t3), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.i18nArray = this.translator.translateArray.bind(this.translator), this.setPluginState();
    }, o2.addFiles = function(e3) {
      var t3 = this, n3 = e3.map(function(e4) {
        return { source: t3.id, name: e4.name, type: e4.type, data: e4, meta: { relativePath: e4.relativePath || null } };
      });
      try {
        this.uppy.addFiles(n3);
      } catch (wd2) {
        this.uppy.log(wd2);
      }
    }, o2.onInputChange = function(e3) {
      this.uppy.log("[DragDrop] Files selected through input");
      var t3 = Co(e3.target.files);
      this.addFiles(t3), e3.target.value = null;
    }, o2.handleDrop = function(e3) {
      var t3 = this;
      this.opts.onDrop && this.opts.onDrop(e3), e3.preventDefault(), e3.stopPropagation(), clearTimeout(this.removeDragOverClassTimeout), this.setPluginState({ isDraggingOver: false }), this.uppy.log("[DragDrop] Files were dropped"), ko(e3.dataTransfer, { logDropError: function(e4) {
        t3.uppy.log(e4, "error");
      } }).then(function(e4) {
        return t3.addFiles(e4);
      });
    }, o2.handleDragOver = function(e3) {
      this.opts.onDragOver && this.opts.onDragOver(e3), e3.preventDefault(), e3.stopPropagation(), e3.dataTransfer.dropEffect = "copy", clearTimeout(this.removeDragOverClassTimeout), this.setPluginState({ isDraggingOver: true });
    }, o2.handleDragLeave = function(e3) {
      var t3 = this;
      this.opts.onDragLeave && this.opts.onDragLeave(e3), e3.preventDefault(), e3.stopPropagation(), clearTimeout(this.removeDragOverClassTimeout), this.removeDragOverClassTimeout = setTimeout(function() {
        t3.setPluginState({ isDraggingOver: false });
      }, 50);
    }, o2.renderHiddenFileInput = function() {
      var e3 = this, t3 = this.uppy.opts.restrictions;
      return ni("input", { className: "uppy-DragDrop-input", type: "file", hidden: true, ref: function(t4) {
        e3.fileInputRef = t4;
      }, name: this.opts.inputName, multiple: 1 !== t3.maxNumberOfFiles, accept: t3.allowedFileTypes, onChange: this.onInputChange });
    }, r2.renderArrowSvg = function() {
      return ni("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon uppy-DragDrop-arrow", width: "16", height: "16", viewBox: "0 0 16 16" }, ni("path", { d: "M11 10V0H5v10H2l6 6 6-6h-3zm0 0", fillRule: "evenodd" }));
    }, o2.renderLabel = function() {
      return ni("div", { className: "uppy-DragDrop-label" }, this.i18nArray("dropHereOr", { browse: ni("span", { className: "uppy-DragDrop-browse" }, this.i18n("browse")) }));
    }, o2.renderNote = function() {
      return ni("span", { className: "uppy-DragDrop-note" }, this.opts.note);
    }, o2.render = function() {
      var e3 = this, t3 = "uppy-Root\n      uppy-u-reset\n      uppy-DragDrop-container\n      " + (this.isDragDropSupported ? "uppy-DragDrop--isDragDropSupported" : "") + "\n      " + (this.getPluginState().isDraggingOver ? "uppy-DragDrop--isDraggingOver" : "") + "\n    ", n3 = { width: this.opts.width, height: this.opts.height };
      return ni("button", { type: "button", className: t3, style: n3, onClick: function() {
        return e3.fileInputRef.click();
      }, onDragOver: this.handleDragOver, onDragLeave: this.handleDragLeave, onDrop: this.handleDrop }, this.renderHiddenFileInput(), ni("div", { className: "uppy-DragDrop-inner" }, r2.renderArrowSvg(), this.renderLabel(), this.renderNote()));
    }, o2.install = function() {
      var e3 = this.opts.target;
      this.setPluginState({ isDraggingOver: false }), e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.unmount();
    }, r2;
  }(ti), Yo.VERSION = "1.4.30", $o);
  function oi() {
    return (oi = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function ii(e2, t2) {
    return (ii = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var ai = (ei = Zo = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).addFiles = function(e3) {
        var t4 = e3.map(function(e4) {
          return { source: r3.id, name: e4.name, type: e4.type, data: e4, meta: { relativePath: e4.relativePath || null } };
        });
        try {
          r3.uppy.addFiles(t4);
        } catch (wd2) {
          r3.uppy.log(wd2);
        }
      }, r3.handleDrop = function(e3) {
        e3.preventDefault(), e3.stopPropagation(), clearTimeout(r3.removeDragOverClassTimeout), e3.currentTarget.classList.remove("uppy-is-drag-over"), r3.setPluginState({ isDraggingOver: false }), r3.uppy.log("[DropTarget] Files were dropped"), ko(e3.dataTransfer, { logDropError: function(e4) {
          r3.uppy.log(e4, "error");
        } }).then(function(e4) {
          return r3.addFiles(e4);
        });
      }, r3.handleDragOver = function(e3) {
        e3.preventDefault(), e3.stopPropagation(), e3.dataTransfer.dropEffect = "copy", clearTimeout(r3.removeDragOverClassTimeout), e3.currentTarget.classList.add("uppy-is-drag-over"), r3.setPluginState({ isDraggingOver: true });
      }, r3.handleDragLeave = function(e3) {
        e3.preventDefault(), e3.stopPropagation();
        var t4 = e3.currentTarget;
        clearTimeout(r3.removeDragOverClassTimeout), r3.removeDragOverClassTimeout = setTimeout(function() {
          t4.classList.remove("uppy-is-drag-over"), r3.setPluginState({ isDraggingOver: false });
        }, 50);
      }, r3.addListeners = function() {
        var e3 = r3.opts.target;
        if (e3 instanceof Element ? r3.nodes = [e3] : "string" == typeof e3 && (r3.nodes = Co(document.querySelectorAll(e3))), !r3.nodes && !r3.nodes.length > 0) throw new Error('"' + e3 + '" does not match any HTML elements');
        r3.nodes.forEach(function(e4) {
          e4.addEventListener("dragover", r3.handleDragOver, false), e4.addEventListener("dragleave", r3.handleDragLeave, false), e4.addEventListener("drop", r3.handleDrop, false);
        });
      }, r3.removeListeners = function() {
        r3.nodes && r3.nodes.forEach(function(e3) {
          e3.removeEventListener("dragover", r3.handleDragOver, false), e3.removeEventListener("dragleave", r3.handleDragLeave, false), e3.removeEventListener("drop", r3.handleDrop, false);
        });
      }, r3.type = "acquirer", r3.id = r3.opts.id || "DropTarget", r3.title = "Drop Target", r3.opts = oi({}, { target: null }, n3), r3.removeDragOverClassTimeout = null, r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, ii(t2, n2);
    var o2 = r2.prototype;
    return o2.install = function() {
      this.setPluginState({ isDraggingOver: false }), this.addListeners();
    }, o2.uninstall = function() {
      this.removeListeners();
    }, r2;
  }(ue.Plugin), Zo.VERSION = "0.2.4", ei), si = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    si.exports = N2;
  }(), si = si.exports;
  var li, ui;
  function ci() {
    return (ci = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function pi(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function di(e2, t2) {
    return (di = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var hi = ue.Plugin, fi = si.h, mi = (ui = li = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "FileInput", r3.title = "File Input", r3.type = "acquirer", r3.defaultLocale = { strings: { chooseFiles: "Choose files" } }, r3.opts = ci({}, { target: null, pretty: true, inputName: "files[]" }, n3), r3.i18nInit(), r3.render = r3.render.bind(pi(r3)), r3.handleInputChange = r3.handleInputChange.bind(pi(r3)), r3.handleClick = r3.handleClick.bind(pi(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, di(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, t3), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.i18nArray = this.translator.translateArray.bind(this.translator), this.setPluginState();
    }, o2.addFiles = function(e3) {
      var t3 = this, n3 = e3.map(function(e4) {
        return { source: t3.id, name: e4.name, type: e4.type, data: e4 };
      });
      try {
        this.uppy.addFiles(n3);
      } catch (wd2) {
        this.uppy.log(wd2);
      }
    }, o2.handleInputChange = function(e3) {
      this.uppy.log("[FileInput] Something selected through input...");
      var t3 = Co(e3.target.files);
      this.addFiles(t3), e3.target.value = null;
    }, o2.handleClick = function(e3) {
      this.input.click();
    }, o2.render = function(e3) {
      var t3 = this, n3 = this.uppy.opts.restrictions, r3 = n3.allowedFileTypes ? n3.allowedFileTypes.join(",") : null;
      return fi("div", { className: "uppy-Root uppy-FileInput-container" }, fi("input", { className: "uppy-FileInput-input", style: this.opts.pretty && { width: "0.1px", height: "0.1px", opacity: 0, overflow: "hidden", position: "absolute", zIndex: -1 }, type: "file", name: this.opts.inputName, onChange: this.handleInputChange, multiple: 1 !== n3.maxNumberOfFiles, accept: r3, ref: function(e4) {
        t3.input = e4;
      } }), this.opts.pretty && fi("button", { className: "uppy-FileInput-btn", type: "button", onClick: this.handleClick }, this.i18n("chooseFiles")));
    }, o2.install = function() {
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.unmount();
    }, r2;
  }(hi), li.VERSION = "1.5.2", ui), vi = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    vi.exports = N2;
  }(), vi = vi.exports;
  var gi, yi;
  function bi() {
    return (bi = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function _i(e2, t2) {
    return (_i = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var wi, Ci, Si = ue.Plugin, ki = vi.h, xi = (yi = gi = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "ProgressBar", r3.title = "Progress Bar", r3.type = "progressindicator", r3.opts = bi({}, { target: "body", replaceTargetContent: false, fixed: false, hideAfterFinish: true }, n3), r3.render = r3.render.bind(function(e3) {
        if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e3;
      }(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, _i(t2, n2);
    var o2 = r2.prototype;
    return o2.render = function(e3) {
      var t3 = e3.totalProgress || 0, n3 = (0 === t3 || 100 === t3) && this.opts.hideAfterFinish;
      return ki("div", { className: "uppy uppy-ProgressBar", style: { position: this.opts.fixed ? "fixed" : "initial" }, "aria-hidden": n3 }, ki("div", { className: "uppy-ProgressBar-inner", style: { width: t3 + "%" } }), ki("div", { className: "uppy-ProgressBar-percentage" }, t3));
    }, o2.install = function() {
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.unmount();
    }, r2;
  }(Si), gi.VERSION = "1.3.30", yi), Pi = { exports: {} };
  wi = this, Ci = function() {
    "use strict";
    function e2(t3) {
      return (e2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e3) {
        return typeof e3;
      } : function(e3) {
        return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
      })(t3);
    }
    function t2(e3, t3) {
      for (var n3 = 0; n3 < t3.length; n3++) {
        var r3 = t3[n3];
        r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(e3, r3.key, r3);
      }
    }
    function n2(e3, t3, n3) {
      return t3 in e3 ? Object.defineProperty(e3, t3, { value: n3, enumerable: true, configurable: true, writable: true }) : e3[t3] = n3, e3;
    }
    function r2(e3, t3) {
      var n3 = Object.keys(e3);
      if (Object.getOwnPropertySymbols) {
        var r3 = Object.getOwnPropertySymbols(e3);
        t3 && (r3 = r3.filter(function(t4) {
          return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
        })), n3.push.apply(n3, r3);
      }
      return n3;
    }
    function o2(e3) {
      for (var t3 = 1; t3 < arguments.length; t3++) {
        var o3 = null != arguments[t3] ? arguments[t3] : {};
        t3 % 2 ? r2(Object(o3), true).forEach(function(t4) {
          n2(e3, t4, o3[t4]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(o3)) : r2(Object(o3)).forEach(function(t4) {
          Object.defineProperty(e3, t4, Object.getOwnPropertyDescriptor(o3, t4));
        });
      }
      return e3;
    }
    function i2(e3) {
      return function(e4) {
        if (Array.isArray(e4)) return a2(e4);
      }(e3) || function(e4) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e4)) return Array.from(e4);
      }(e3) || function(e4, t3) {
        if (e4) {
          if ("string" == typeof e4) return a2(e4, void 0);
          var n3 = Object.prototype.toString.call(e4).slice(8, -1);
          return "Object" === n3 && e4.constructor && (n3 = e4.constructor.name), "Map" === n3 || "Set" === n3 ? Array.from(e4) : "Arguments" === n3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3) ? a2(e4, void 0) : void 0;
        }
      }(e3) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function a2(e3, t3) {
      (null == t3 || t3 > e3.length) && (t3 = e3.length);
      for (var n3 = 0, r3 = new Array(t3); n3 < t3; n3++) r3[n3] = e3[n3];
      return r3;
    }
    var s2 = "undefined" != typeof window && void 0 !== window.document, l2 = s2 ? window : {}, u2 = !(!s2 || !l2.document.documentElement) && "ontouchstart" in l2.document.documentElement, c2 = !!s2 && "PointerEvent" in l2, p2 = "".concat("cropper", "-crop"), d2 = "".concat("cropper", "-disabled"), h2 = "".concat("cropper", "-hidden"), f2 = "".concat("cropper", "-hide"), m2 = "".concat("cropper", "-invisible"), v2 = "".concat("cropper", "-modal"), g2 = "".concat("cropper", "-move"), y2 = "".concat("cropper", "Action"), b2 = "".concat("cropper", "Preview"), _2 = c2 ? "pointerdown" : u2 ? "touchstart" : "mousedown", w2 = c2 ? "pointermove" : u2 ? "touchmove" : "mousemove", C2 = c2 ? "pointerup pointercancel" : u2 ? "touchend touchcancel" : "mouseup", S2 = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, k2 = /^data:/, x2 = /^data:image\/jpeg;base64,/, P2 = /^img|canvas$/i, E2 = { viewMode: 0, dragMode: "crop", initialAspectRatio: NaN, aspectRatio: NaN, data: null, preview: "", responsive: true, restore: true, checkCrossOrigin: true, checkOrientation: true, modal: true, guides: true, center: true, highlight: true, background: true, autoCrop: true, autoCropArea: 0.8, movable: true, rotatable: true, scalable: true, zoomable: true, zoomOnTouch: true, zoomOnWheel: true, wheelZoomRatio: 0.1, cropBoxMovable: true, cropBoxResizable: true, toggleDragModeOnDblclick: true, minCanvasWidth: 0, minCanvasHeight: 0, minCropBoxWidth: 0, minCropBoxHeight: 0, minContainerWidth: 200, minContainerHeight: 100, ready: null, cropstart: null, cropmove: null, cropend: null, crop: null, zoom: null }, O2 = Number.isNaN || l2.isNaN;
    function A2(e3) {
      return "number" == typeof e3 && !O2(e3);
    }
    var U2 = function(e3) {
      return e3 > 0 && e3 < 1 / 0;
    };
    function N2(e3) {
      return void 0 === e3;
    }
    function T2(t3) {
      return "object" === e2(t3) && null !== t3;
    }
    var R2 = Object.prototype.hasOwnProperty;
    function F2(e3) {
      if (!T2(e3)) return false;
      try {
        var t3 = e3.constructor, n3 = t3.prototype;
        return t3 && n3 && R2.call(n3, "isPrototypeOf");
      } catch (Dp2) {
        return false;
      }
    }
    function D2(e3) {
      return "function" == typeof e3;
    }
    var M2 = Array.prototype.slice;
    function B2(e3) {
      return Array.from ? Array.from(e3) : M2.call(e3);
    }
    function I2(e3, t3) {
      return e3 && D2(t3) && (Array.isArray(e3) || A2(e3.length) ? B2(e3).forEach(function(n3, r3) {
        t3.call(e3, n3, r3, e3);
      }) : T2(e3) && Object.keys(e3).forEach(function(n3) {
        t3.call(e3, e3[n3], n3, e3);
      })), e3;
    }
    var L2 = Object.assign || function(e3) {
      for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r3 = 1; r3 < t3; r3++) n3[r3 - 1] = arguments[r3];
      return T2(e3) && n3.length > 0 && n3.forEach(function(t4) {
        T2(t4) && Object.keys(t4).forEach(function(n4) {
          e3[n4] = t4[n4];
        });
      }), e3;
    }, j2 = /\.\d*(?:0|9){12}\d*$/;
    function z2(e3) {
      var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e11;
      return j2.test(e3) ? Math.round(e3 * t3) / t3 : e3;
    }
    var H2 = /^width|height|left|top|marginLeft|marginTop$/;
    function W2(e3, t3) {
      var n3 = e3.style;
      I2(t3, function(e4, t4) {
        H2.test(t4) && A2(e4) && (e4 = "".concat(e4, "px")), n3[t4] = e4;
      });
    }
    function V2(e3, t3) {
      if (t3) if (A2(e3.length)) I2(e3, function(e4) {
        V2(e4, t3);
      });
      else if (e3.classList) e3.classList.add(t3);
      else {
        var n3 = e3.className.trim();
        n3 ? n3.indexOf(t3) < 0 && (e3.className = "".concat(n3, " ").concat(t3)) : e3.className = t3;
      }
    }
    function q2(e3, t3) {
      t3 && (A2(e3.length) ? I2(e3, function(e4) {
        q2(e4, t3);
      }) : e3.classList ? e3.classList.remove(t3) : e3.className.indexOf(t3) >= 0 && (e3.className = e3.className.replace(t3, "")));
    }
    function X2(e3, t3, n3) {
      t3 && (A2(e3.length) ? I2(e3, function(e4) {
        X2(e4, t3, n3);
      }) : n3 ? V2(e3, t3) : q2(e3, t3));
    }
    var G2 = /([a-z\d])([A-Z])/g;
    function Y2(e3) {
      return e3.replace(G2, "$1-$2").toLowerCase();
    }
    function $2(e3, t3) {
      return T2(e3[t3]) ? e3[t3] : e3.dataset ? e3.dataset[t3] : e3.getAttribute("data-".concat(Y2(t3)));
    }
    function K2(e3, t3, n3) {
      T2(n3) ? e3[t3] = n3 : e3.dataset ? e3.dataset[t3] = n3 : e3.setAttribute("data-".concat(Y2(t3)), n3);
    }
    var J2 = /\s\s*/, Q2 = function() {
      var e3 = false;
      if (s2) {
        var t3 = false, n3 = function() {
        }, r3 = Object.defineProperty({}, "once", { get: function() {
          return e3 = true, t3;
        }, set: function(e4) {
          t3 = e4;
        } });
        l2.addEventListener("test", n3, r3), l2.removeEventListener("test", n3, r3);
      }
      return e3;
    }();
    function Z2(e3, t3, n3) {
      var r3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, o3 = n3;
      t3.trim().split(J2).forEach(function(t4) {
        if (!Q2) {
          var i3 = e3.listeners;
          i3 && i3[t4] && i3[t4][n3] && (o3 = i3[t4][n3], delete i3[t4][n3], 0 === Object.keys(i3[t4]).length && delete i3[t4], 0 === Object.keys(i3).length && delete e3.listeners);
        }
        e3.removeEventListener(t4, o3, r3);
      });
    }
    function ee2(e3, t3, n3) {
      var r3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, o3 = n3;
      t3.trim().split(J2).forEach(function(t4) {
        if (r3.once && !Q2) {
          var i3 = e3.listeners, a3 = void 0 === i3 ? {} : i3;
          o3 = function() {
            delete a3[t4][n3], e3.removeEventListener(t4, o3, r3);
            for (var i4 = arguments.length, s3 = new Array(i4), l3 = 0; l3 < i4; l3++) s3[l3] = arguments[l3];
            n3.apply(e3, s3);
          }, a3[t4] || (a3[t4] = {}), a3[t4][n3] && e3.removeEventListener(t4, a3[t4][n3], r3), a3[t4][n3] = o3, e3.listeners = a3;
        }
        e3.addEventListener(t4, o3, r3);
      });
    }
    function te2(e3, t3, n3) {
      var r3;
      return D2(Event) && D2(CustomEvent) ? r3 = new CustomEvent(t3, { detail: n3, bubbles: true, cancelable: true }) : (r3 = document.createEvent("CustomEvent")).initCustomEvent(t3, true, true, n3), e3.dispatchEvent(r3);
    }
    function ne2(e3) {
      var t3 = e3.getBoundingClientRect();
      return { left: t3.left + (window.pageXOffset - document.documentElement.clientLeft), top: t3.top + (window.pageYOffset - document.documentElement.clientTop) };
    }
    var re2 = l2.location, oe2 = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
    function ie2(e3) {
      var t3 = e3.match(oe2);
      return null !== t3 && (t3[1] !== re2.protocol || t3[2] !== re2.hostname || t3[3] !== re2.port);
    }
    function ae2(e3) {
      var t3 = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
      return e3 + (-1 === e3.indexOf("?") ? "?" : "&") + t3;
    }
    function se2(e3) {
      var t3 = e3.rotate, n3 = e3.scaleX, r3 = e3.scaleY, o3 = e3.translateX, i3 = e3.translateY, a3 = [];
      A2(o3) && 0 !== o3 && a3.push("translateX(".concat(o3, "px)")), A2(i3) && 0 !== i3 && a3.push("translateY(".concat(i3, "px)")), A2(t3) && 0 !== t3 && a3.push("rotate(".concat(t3, "deg)")), A2(n3) && 1 !== n3 && a3.push("scaleX(".concat(n3, ")")), A2(r3) && 1 !== r3 && a3.push("scaleY(".concat(r3, ")"));
      var s3 = a3.length ? a3.join(" ") : "none";
      return { WebkitTransform: s3, msTransform: s3, transform: s3 };
    }
    function le2(e3, t3) {
      var n3 = e3.pageX, r3 = e3.pageY, i3 = { endX: n3, endY: r3 };
      return t3 ? i3 : o2({ startX: n3, startY: r3 }, i3);
    }
    function ue2(e3) {
      var t3 = e3.aspectRatio, n3 = e3.height, r3 = e3.width, o3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "contain", i3 = U2(r3), a3 = U2(n3);
      if (i3 && a3) {
        var s3 = n3 * t3;
        "contain" === o3 && s3 > r3 || "cover" === o3 && s3 < r3 ? n3 = r3 / t3 : r3 = n3 * t3;
      } else i3 ? n3 = r3 / t3 : a3 && (r3 = n3 * t3);
      return { width: r3, height: n3 };
    }
    var ce2 = String.fromCharCode, pe2 = /^data:.*,/;
    var de2 = { render: function() {
      this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
    }, initContainer: function() {
      var e3 = this.element, t3 = this.options, n3 = this.container, r3 = this.cropper;
      V2(r3, h2), q2(e3, h2);
      var o3 = { width: Math.max(n3.offsetWidth, Number(t3.minContainerWidth) || 200), height: Math.max(n3.offsetHeight, Number(t3.minContainerHeight) || 100) };
      this.containerData = o3, W2(r3, { width: o3.width, height: o3.height }), V2(e3, h2), q2(r3, h2);
    }, initCanvas: function() {
      var e3 = this.containerData, t3 = this.imageData, n3 = this.options.viewMode, r3 = Math.abs(t3.rotate) % 180 == 90, o3 = r3 ? t3.naturalHeight : t3.naturalWidth, i3 = r3 ? t3.naturalWidth : t3.naturalHeight, a3 = o3 / i3, s3 = e3.width, l3 = e3.height;
      e3.height * a3 > e3.width ? 3 === n3 ? s3 = e3.height * a3 : l3 = e3.width / a3 : 3 === n3 ? l3 = e3.width / a3 : s3 = e3.height * a3;
      var u3 = { aspectRatio: a3, naturalWidth: o3, naturalHeight: i3, width: s3, height: l3 };
      u3.left = (e3.width - s3) / 2, u3.top = (e3.height - l3) / 2, u3.oldLeft = u3.left, u3.oldTop = u3.top, this.canvasData = u3, this.limited = 1 === n3 || 2 === n3, this.limitCanvas(true, true), this.initialImageData = L2({}, t3), this.initialCanvasData = L2({}, u3);
    }, limitCanvas: function(e3, t3) {
      var n3 = this.options, r3 = this.containerData, o3 = this.canvasData, i3 = this.cropBoxData, a3 = n3.viewMode, s3 = o3.aspectRatio, l3 = this.cropped && i3;
      if (e3) {
        var u3 = Number(n3.minCanvasWidth) || 0, c3 = Number(n3.minCanvasHeight) || 0;
        a3 > 1 ? (u3 = Math.max(u3, r3.width), c3 = Math.max(c3, r3.height), 3 === a3 && (c3 * s3 > u3 ? u3 = c3 * s3 : c3 = u3 / s3)) : a3 > 0 && (u3 ? u3 = Math.max(u3, l3 ? i3.width : 0) : c3 ? c3 = Math.max(c3, l3 ? i3.height : 0) : l3 && (u3 = i3.width, (c3 = i3.height) * s3 > u3 ? u3 = c3 * s3 : c3 = u3 / s3));
        var p3 = ue2({ aspectRatio: s3, width: u3, height: c3 });
        u3 = p3.width, c3 = p3.height, o3.minWidth = u3, o3.minHeight = c3, o3.maxWidth = 1 / 0, o3.maxHeight = 1 / 0;
      }
      if (t3) if (a3 > (l3 ? 0 : 1)) {
        var d3 = r3.width - o3.width, h3 = r3.height - o3.height;
        o3.minLeft = Math.min(0, d3), o3.minTop = Math.min(0, h3), o3.maxLeft = Math.max(0, d3), o3.maxTop = Math.max(0, h3), l3 && this.limited && (o3.minLeft = Math.min(i3.left, i3.left + (i3.width - o3.width)), o3.minTop = Math.min(i3.top, i3.top + (i3.height - o3.height)), o3.maxLeft = i3.left, o3.maxTop = i3.top, 2 === a3 && (o3.width >= r3.width && (o3.minLeft = Math.min(0, d3), o3.maxLeft = Math.max(0, d3)), o3.height >= r3.height && (o3.minTop = Math.min(0, h3), o3.maxTop = Math.max(0, h3))));
      } else o3.minLeft = -o3.width, o3.minTop = -o3.height, o3.maxLeft = r3.width, o3.maxTop = r3.height;
    }, renderCanvas: function(e3, t3) {
      var n3 = this.canvasData, r3 = this.imageData;
      if (t3) {
        var o3 = function(e4) {
          var t4 = e4.width, n4 = e4.height, r4 = e4.degree;
          if (90 == (r4 = Math.abs(r4) % 180)) return { width: n4, height: t4 };
          var o4 = r4 % 90 * Math.PI / 180, i4 = Math.sin(o4), a4 = Math.cos(o4), s4 = t4 * a4 + n4 * i4, l4 = t4 * i4 + n4 * a4;
          return r4 > 90 ? { width: l4, height: s4 } : { width: s4, height: l4 };
        }({ width: r3.naturalWidth * Math.abs(r3.scaleX || 1), height: r3.naturalHeight * Math.abs(r3.scaleY || 1), degree: r3.rotate || 0 }), i3 = o3.width, a3 = o3.height, s3 = n3.width * (i3 / n3.naturalWidth), l3 = n3.height * (a3 / n3.naturalHeight);
        n3.left -= (s3 - n3.width) / 2, n3.top -= (l3 - n3.height) / 2, n3.width = s3, n3.height = l3, n3.aspectRatio = i3 / a3, n3.naturalWidth = i3, n3.naturalHeight = a3, this.limitCanvas(true, false);
      }
      (n3.width > n3.maxWidth || n3.width < n3.minWidth) && (n3.left = n3.oldLeft), (n3.height > n3.maxHeight || n3.height < n3.minHeight) && (n3.top = n3.oldTop), n3.width = Math.min(Math.max(n3.width, n3.minWidth), n3.maxWidth), n3.height = Math.min(Math.max(n3.height, n3.minHeight), n3.maxHeight), this.limitCanvas(false, true), n3.left = Math.min(Math.max(n3.left, n3.minLeft), n3.maxLeft), n3.top = Math.min(Math.max(n3.top, n3.minTop), n3.maxTop), n3.oldLeft = n3.left, n3.oldTop = n3.top, W2(this.canvas, L2({ width: n3.width, height: n3.height }, se2({ translateX: n3.left, translateY: n3.top }))), this.renderImage(e3), this.cropped && this.limited && this.limitCropBox(true, true);
    }, renderImage: function(e3) {
      var t3 = this.canvasData, n3 = this.imageData, r3 = n3.naturalWidth * (t3.width / t3.naturalWidth), o3 = n3.naturalHeight * (t3.height / t3.naturalHeight);
      L2(n3, { width: r3, height: o3, left: (t3.width - r3) / 2, top: (t3.height - o3) / 2 }), W2(this.image, L2({ width: n3.width, height: n3.height }, se2(L2({ translateX: n3.left, translateY: n3.top }, n3)))), e3 && this.output();
    }, initCropBox: function() {
      var e3 = this.options, t3 = this.canvasData, n3 = e3.aspectRatio || e3.initialAspectRatio, r3 = Number(e3.autoCropArea) || 0.8, o3 = { width: t3.width, height: t3.height };
      n3 && (t3.height * n3 > t3.width ? o3.height = o3.width / n3 : o3.width = o3.height * n3), this.cropBoxData = o3, this.limitCropBox(true, true), o3.width = Math.min(Math.max(o3.width, o3.minWidth), o3.maxWidth), o3.height = Math.min(Math.max(o3.height, o3.minHeight), o3.maxHeight), o3.width = Math.max(o3.minWidth, o3.width * r3), o3.height = Math.max(o3.minHeight, o3.height * r3), o3.left = t3.left + (t3.width - o3.width) / 2, o3.top = t3.top + (t3.height - o3.height) / 2, o3.oldLeft = o3.left, o3.oldTop = o3.top, this.initialCropBoxData = L2({}, o3);
    }, limitCropBox: function(e3, t3) {
      var n3 = this.options, r3 = this.containerData, o3 = this.canvasData, i3 = this.cropBoxData, a3 = this.limited, s3 = n3.aspectRatio;
      if (e3) {
        var l3 = Number(n3.minCropBoxWidth) || 0, u3 = Number(n3.minCropBoxHeight) || 0, c3 = a3 ? Math.min(r3.width, o3.width, o3.width + o3.left, r3.width - o3.left) : r3.width, p3 = a3 ? Math.min(r3.height, o3.height, o3.height + o3.top, r3.height - o3.top) : r3.height;
        l3 = Math.min(l3, r3.width), u3 = Math.min(u3, r3.height), s3 && (l3 && u3 ? u3 * s3 > l3 ? u3 = l3 / s3 : l3 = u3 * s3 : l3 ? u3 = l3 / s3 : u3 && (l3 = u3 * s3), p3 * s3 > c3 ? p3 = c3 / s3 : c3 = p3 * s3), i3.minWidth = Math.min(l3, c3), i3.minHeight = Math.min(u3, p3), i3.maxWidth = c3, i3.maxHeight = p3;
      }
      t3 && (a3 ? (i3.minLeft = Math.max(0, o3.left), i3.minTop = Math.max(0, o3.top), i3.maxLeft = Math.min(r3.width, o3.left + o3.width) - i3.width, i3.maxTop = Math.min(r3.height, o3.top + o3.height) - i3.height) : (i3.minLeft = 0, i3.minTop = 0, i3.maxLeft = r3.width - i3.width, i3.maxTop = r3.height - i3.height));
    }, renderCropBox: function() {
      var e3 = this.options, t3 = this.containerData, n3 = this.cropBoxData;
      (n3.width > n3.maxWidth || n3.width < n3.minWidth) && (n3.left = n3.oldLeft), (n3.height > n3.maxHeight || n3.height < n3.minHeight) && (n3.top = n3.oldTop), n3.width = Math.min(Math.max(n3.width, n3.minWidth), n3.maxWidth), n3.height = Math.min(Math.max(n3.height, n3.minHeight), n3.maxHeight), this.limitCropBox(false, true), n3.left = Math.min(Math.max(n3.left, n3.minLeft), n3.maxLeft), n3.top = Math.min(Math.max(n3.top, n3.minTop), n3.maxTop), n3.oldLeft = n3.left, n3.oldTop = n3.top, e3.movable && e3.cropBoxMovable && K2(this.face, y2, n3.width >= t3.width && n3.height >= t3.height ? "move" : "all"), W2(this.cropBox, L2({ width: n3.width, height: n3.height }, se2({ translateX: n3.left, translateY: n3.top }))), this.cropped && this.limited && this.limitCanvas(true, true), this.disabled || this.output();
    }, output: function() {
      this.preview(), te2(this.element, "crop", this.getData());
    } }, he2 = { initPreview: function() {
      var e3 = this.element, t3 = this.crossOrigin, n3 = this.options.preview, r3 = t3 ? this.crossOriginUrl : this.url, o3 = e3.alt || "The image to preview", i3 = document.createElement("img");
      if (t3 && (i3.crossOrigin = t3), i3.src = r3, i3.alt = o3, this.viewBox.appendChild(i3), this.viewBoxImage = i3, n3) {
        var a3 = n3;
        "string" == typeof n3 ? a3 = e3.ownerDocument.querySelectorAll(n3) : n3.querySelector && (a3 = [n3]), this.previews = a3, I2(a3, function(e4) {
          var n4 = document.createElement("img");
          K2(e4, b2, { width: e4.offsetWidth, height: e4.offsetHeight, html: e4.innerHTML }), t3 && (n4.crossOrigin = t3), n4.src = r3, n4.alt = o3, n4.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', e4.innerHTML = "", e4.appendChild(n4);
        });
      }
    }, resetPreview: function() {
      I2(this.previews, function(e3) {
        var t3 = $2(e3, b2);
        W2(e3, { width: t3.width, height: t3.height }), e3.innerHTML = t3.html, function(e4, t4) {
          if (T2(e4[t4])) try {
            delete e4[t4];
          } catch (Dp2) {
            e4[t4] = void 0;
          }
          else if (e4.dataset) try {
            delete e4.dataset[t4];
          } catch (Dp2) {
            e4.dataset[t4] = void 0;
          }
          else e4.removeAttribute("data-".concat(Y2(t4)));
        }(e3, b2);
      });
    }, preview: function() {
      var e3 = this.imageData, t3 = this.canvasData, n3 = this.cropBoxData, r3 = n3.width, o3 = n3.height, i3 = e3.width, a3 = e3.height, s3 = n3.left - t3.left - e3.left, l3 = n3.top - t3.top - e3.top;
      this.cropped && !this.disabled && (W2(this.viewBoxImage, L2({ width: i3, height: a3 }, se2(L2({ translateX: -s3, translateY: -l3 }, e3)))), I2(this.previews, function(t4) {
        var n4 = $2(t4, b2), u3 = n4.width, c3 = n4.height, p3 = u3, d3 = c3, h3 = 1;
        r3 && (d3 = o3 * (h3 = u3 / r3)), o3 && d3 > c3 && (p3 = r3 * (h3 = c3 / o3), d3 = c3), W2(t4, { width: p3, height: d3 }), W2(t4.getElementsByTagName("img")[0], L2({ width: i3 * h3, height: a3 * h3 }, se2(L2({ translateX: -s3 * h3, translateY: -l3 * h3 }, e3))));
      }));
    } }, fe2 = { bind: function() {
      var e3 = this.element, t3 = this.options, n3 = this.cropper;
      D2(t3.cropstart) && ee2(e3, "cropstart", t3.cropstart), D2(t3.cropmove) && ee2(e3, "cropmove", t3.cropmove), D2(t3.cropend) && ee2(e3, "cropend", t3.cropend), D2(t3.crop) && ee2(e3, "crop", t3.crop), D2(t3.zoom) && ee2(e3, "zoom", t3.zoom), ee2(n3, _2, this.onCropStart = this.cropStart.bind(this)), t3.zoomable && t3.zoomOnWheel && ee2(n3, "wheel", this.onWheel = this.wheel.bind(this), { passive: false, capture: true }), t3.toggleDragModeOnDblclick && ee2(n3, "dblclick", this.onDblclick = this.dblclick.bind(this)), ee2(e3.ownerDocument, w2, this.onCropMove = this.cropMove.bind(this)), ee2(e3.ownerDocument, C2, this.onCropEnd = this.cropEnd.bind(this)), t3.responsive && ee2(window, "resize", this.onResize = this.resize.bind(this));
    }, unbind: function() {
      var e3 = this.element, t3 = this.options, n3 = this.cropper;
      D2(t3.cropstart) && Z2(e3, "cropstart", t3.cropstart), D2(t3.cropmove) && Z2(e3, "cropmove", t3.cropmove), D2(t3.cropend) && Z2(e3, "cropend", t3.cropend), D2(t3.crop) && Z2(e3, "crop", t3.crop), D2(t3.zoom) && Z2(e3, "zoom", t3.zoom), Z2(n3, _2, this.onCropStart), t3.zoomable && t3.zoomOnWheel && Z2(n3, "wheel", this.onWheel, { passive: false, capture: true }), t3.toggleDragModeOnDblclick && Z2(n3, "dblclick", this.onDblclick), Z2(e3.ownerDocument, w2, this.onCropMove), Z2(e3.ownerDocument, C2, this.onCropEnd), t3.responsive && Z2(window, "resize", this.onResize);
    } }, me2 = { resize: function() {
      if (!this.disabled) {
        var e3, t3, n3 = this.options, r3 = this.container, o3 = this.containerData, i3 = r3.offsetWidth / o3.width;
        1 === i3 && r3.offsetHeight === o3.height || (n3.restore && (e3 = this.getCanvasData(), t3 = this.getCropBoxData()), this.render(), n3.restore && (this.setCanvasData(I2(e3, function(t4, n4) {
          e3[n4] = t4 * i3;
        })), this.setCropBoxData(I2(t3, function(e4, n4) {
          t3[n4] = e4 * i3;
        }))));
      }
    }, dblclick: function() {
      var e3, t3;
      this.disabled || "none" === this.options.dragMode || this.setDragMode((e3 = this.dragBox, t3 = p2, (e3.classList ? e3.classList.contains(t3) : e3.className.indexOf(t3) > -1) ? "move" : "crop"));
    }, wheel: function(e3) {
      var t3 = this, n3 = Number(this.options.wheelZoomRatio) || 0.1, r3 = 1;
      this.disabled || (e3.preventDefault(), this.wheeling || (this.wheeling = true, setTimeout(function() {
        t3.wheeling = false;
      }, 50), e3.deltaY ? r3 = e3.deltaY > 0 ? 1 : -1 : e3.wheelDelta ? r3 = -e3.wheelDelta / 120 : e3.detail && (r3 = e3.detail > 0 ? 1 : -1), this.zoom(-r3 * n3, e3)));
    }, cropStart: function(e3) {
      var t3 = e3.buttons, n3 = e3.button;
      if (!(this.disabled || ("mousedown" === e3.type || "pointerdown" === e3.type && "mouse" === e3.pointerType) && (A2(t3) && 1 !== t3 || A2(n3) && 0 !== n3 || e3.ctrlKey))) {
        var r3, o3 = this.options, i3 = this.pointers;
        e3.changedTouches ? I2(e3.changedTouches, function(e4) {
          i3[e4.identifier] = le2(e4);
        }) : i3[e3.pointerId || 0] = le2(e3), r3 = Object.keys(i3).length > 1 && o3.zoomable && o3.zoomOnTouch ? "zoom" : $2(e3.target, y2), S2.test(r3) && false !== te2(this.element, "cropstart", { originalEvent: e3, action: r3 }) && (e3.preventDefault(), this.action = r3, this.cropping = false, "crop" === r3 && (this.cropping = true, V2(this.dragBox, v2)));
      }
    }, cropMove: function(e3) {
      var t3 = this.action;
      if (!this.disabled && t3) {
        var n3 = this.pointers;
        e3.preventDefault(), false !== te2(this.element, "cropmove", { originalEvent: e3, action: t3 }) && (e3.changedTouches ? I2(e3.changedTouches, function(e4) {
          L2(n3[e4.identifier] || {}, le2(e4, true));
        }) : L2(n3[e3.pointerId || 0] || {}, le2(e3, true)), this.change(e3));
      }
    }, cropEnd: function(e3) {
      if (!this.disabled) {
        var t3 = this.action, n3 = this.pointers;
        e3.changedTouches ? I2(e3.changedTouches, function(e4) {
          delete n3[e4.identifier];
        }) : delete n3[e3.pointerId || 0], t3 && (e3.preventDefault(), Object.keys(n3).length || (this.action = ""), this.cropping && (this.cropping = false, X2(this.dragBox, v2, this.cropped && this.options.modal)), te2(this.element, "cropend", { originalEvent: e3, action: t3 }));
      }
    } }, ve2 = { change: function(e3) {
      var t3, n3 = this.options, r3 = this.canvasData, i3 = this.containerData, a3 = this.cropBoxData, s3 = this.pointers, l3 = this.action, u3 = n3.aspectRatio, c3 = a3.left, p3 = a3.top, d3 = a3.width, f3 = a3.height, m3 = c3 + d3, v3 = p3 + f3, g3 = 0, y3 = 0, b3 = i3.width, _3 = i3.height, w3 = true;
      !u3 && e3.shiftKey && (u3 = d3 && f3 ? d3 / f3 : 1), this.limited && (g3 = a3.minLeft, y3 = a3.minTop, b3 = g3 + Math.min(i3.width, r3.width, r3.left + r3.width), _3 = y3 + Math.min(i3.height, r3.height, r3.top + r3.height));
      var C3 = s3[Object.keys(s3)[0]], S3 = { x: C3.endX - C3.startX, y: C3.endY - C3.startY }, k3 = function(e4) {
        switch (e4) {
          case "e":
            m3 + S3.x > b3 && (S3.x = b3 - m3);
            break;
          case "w":
            c3 + S3.x < g3 && (S3.x = g3 - c3);
            break;
          case "n":
            p3 + S3.y < y3 && (S3.y = y3 - p3);
            break;
          case "s":
            v3 + S3.y > _3 && (S3.y = _3 - v3);
        }
      };
      switch (l3) {
        case "all":
          c3 += S3.x, p3 += S3.y;
          break;
        case "e":
          if (S3.x >= 0 && (m3 >= b3 || u3 && (p3 <= y3 || v3 >= _3))) {
            w3 = false;
            break;
          }
          k3("e"), (d3 += S3.x) < 0 && (l3 = "w", c3 -= d3 = -d3), u3 && (f3 = d3 / u3, p3 += (a3.height - f3) / 2);
          break;
        case "n":
          if (S3.y <= 0 && (p3 <= y3 || u3 && (c3 <= g3 || m3 >= b3))) {
            w3 = false;
            break;
          }
          k3("n"), f3 -= S3.y, p3 += S3.y, f3 < 0 && (l3 = "s", p3 -= f3 = -f3), u3 && (d3 = f3 * u3, c3 += (a3.width - d3) / 2);
          break;
        case "w":
          if (S3.x <= 0 && (c3 <= g3 || u3 && (p3 <= y3 || v3 >= _3))) {
            w3 = false;
            break;
          }
          k3("w"), d3 -= S3.x, c3 += S3.x, d3 < 0 && (l3 = "e", c3 -= d3 = -d3), u3 && (f3 = d3 / u3, p3 += (a3.height - f3) / 2);
          break;
        case "s":
          if (S3.y >= 0 && (v3 >= _3 || u3 && (c3 <= g3 || m3 >= b3))) {
            w3 = false;
            break;
          }
          k3("s"), (f3 += S3.y) < 0 && (l3 = "n", p3 -= f3 = -f3), u3 && (d3 = f3 * u3, c3 += (a3.width - d3) / 2);
          break;
        case "ne":
          if (u3) {
            if (S3.y <= 0 && (p3 <= y3 || m3 >= b3)) {
              w3 = false;
              break;
            }
            k3("n"), f3 -= S3.y, p3 += S3.y, d3 = f3 * u3;
          } else k3("n"), k3("e"), S3.x >= 0 ? m3 < b3 ? d3 += S3.x : S3.y <= 0 && p3 <= y3 && (w3 = false) : d3 += S3.x, S3.y <= 0 ? p3 > y3 && (f3 -= S3.y, p3 += S3.y) : (f3 -= S3.y, p3 += S3.y);
          d3 < 0 && f3 < 0 ? (l3 = "sw", p3 -= f3 = -f3, c3 -= d3 = -d3) : d3 < 0 ? (l3 = "nw", c3 -= d3 = -d3) : f3 < 0 && (l3 = "se", p3 -= f3 = -f3);
          break;
        case "nw":
          if (u3) {
            if (S3.y <= 0 && (p3 <= y3 || c3 <= g3)) {
              w3 = false;
              break;
            }
            k3("n"), f3 -= S3.y, p3 += S3.y, d3 = f3 * u3, c3 += a3.width - d3;
          } else k3("n"), k3("w"), S3.x <= 0 ? c3 > g3 ? (d3 -= S3.x, c3 += S3.x) : S3.y <= 0 && p3 <= y3 && (w3 = false) : (d3 -= S3.x, c3 += S3.x), S3.y <= 0 ? p3 > y3 && (f3 -= S3.y, p3 += S3.y) : (f3 -= S3.y, p3 += S3.y);
          d3 < 0 && f3 < 0 ? (l3 = "se", p3 -= f3 = -f3, c3 -= d3 = -d3) : d3 < 0 ? (l3 = "ne", c3 -= d3 = -d3) : f3 < 0 && (l3 = "sw", p3 -= f3 = -f3);
          break;
        case "sw":
          if (u3) {
            if (S3.x <= 0 && (c3 <= g3 || v3 >= _3)) {
              w3 = false;
              break;
            }
            k3("w"), d3 -= S3.x, c3 += S3.x, f3 = d3 / u3;
          } else k3("s"), k3("w"), S3.x <= 0 ? c3 > g3 ? (d3 -= S3.x, c3 += S3.x) : S3.y >= 0 && v3 >= _3 && (w3 = false) : (d3 -= S3.x, c3 += S3.x), S3.y >= 0 ? v3 < _3 && (f3 += S3.y) : f3 += S3.y;
          d3 < 0 && f3 < 0 ? (l3 = "ne", p3 -= f3 = -f3, c3 -= d3 = -d3) : d3 < 0 ? (l3 = "se", c3 -= d3 = -d3) : f3 < 0 && (l3 = "nw", p3 -= f3 = -f3);
          break;
        case "se":
          if (u3) {
            if (S3.x >= 0 && (m3 >= b3 || v3 >= _3)) {
              w3 = false;
              break;
            }
            k3("e"), f3 = (d3 += S3.x) / u3;
          } else k3("s"), k3("e"), S3.x >= 0 ? m3 < b3 ? d3 += S3.x : S3.y >= 0 && v3 >= _3 && (w3 = false) : d3 += S3.x, S3.y >= 0 ? v3 < _3 && (f3 += S3.y) : f3 += S3.y;
          d3 < 0 && f3 < 0 ? (l3 = "nw", p3 -= f3 = -f3, c3 -= d3 = -d3) : d3 < 0 ? (l3 = "sw", c3 -= d3 = -d3) : f3 < 0 && (l3 = "ne", p3 -= f3 = -f3);
          break;
        case "move":
          this.move(S3.x, S3.y), w3 = false;
          break;
        case "zoom":
          this.zoom(function(e4) {
            var t4 = o2({}, e4), n4 = [];
            return I2(e4, function(e5, r4) {
              delete t4[r4], I2(t4, function(t5) {
                var r5 = Math.abs(e5.startX - t5.startX), o3 = Math.abs(e5.startY - t5.startY), i4 = Math.abs(e5.endX - t5.endX), a4 = Math.abs(e5.endY - t5.endY), s4 = Math.sqrt(r5 * r5 + o3 * o3), l4 = (Math.sqrt(i4 * i4 + a4 * a4) - s4) / s4;
                n4.push(l4);
              });
            }), n4.sort(function(e5, t5) {
              return Math.abs(e5) < Math.abs(t5);
            }), n4[0];
          }(s3), e3), w3 = false;
          break;
        case "crop":
          if (!S3.x || !S3.y) {
            w3 = false;
            break;
          }
          t3 = ne2(this.cropper), c3 = C3.startX - t3.left, p3 = C3.startY - t3.top, d3 = a3.minWidth, f3 = a3.minHeight, S3.x > 0 ? l3 = S3.y > 0 ? "se" : "ne" : S3.x < 0 && (c3 -= d3, l3 = S3.y > 0 ? "sw" : "nw"), S3.y < 0 && (p3 -= f3), this.cropped || (q2(this.cropBox, h2), this.cropped = true, this.limited && this.limitCropBox(true, true));
      }
      w3 && (a3.width = d3, a3.height = f3, a3.left = c3, a3.top = p3, this.action = l3, this.renderCropBox()), I2(s3, function(e4) {
        e4.startX = e4.endX, e4.startY = e4.endY;
      });
    } }, ge2 = { crop: function() {
      return !this.ready || this.cropped || this.disabled || (this.cropped = true, this.limitCropBox(true, true), this.options.modal && V2(this.dragBox, v2), q2(this.cropBox, h2), this.setCropBoxData(this.initialCropBoxData)), this;
    }, reset: function() {
      return this.ready && !this.disabled && (this.imageData = L2({}, this.initialImageData), this.canvasData = L2({}, this.initialCanvasData), this.cropBoxData = L2({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
    }, clear: function() {
      return this.cropped && !this.disabled && (L2(this.cropBoxData, { left: 0, top: 0, width: 0, height: 0 }), this.cropped = false, this.renderCropBox(), this.limitCanvas(true, true), this.renderCanvas(), q2(this.dragBox, v2), V2(this.cropBox, h2)), this;
    }, replace: function(e3) {
      var t3 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      return !this.disabled && e3 && (this.isImg && (this.element.src = e3), t3 ? (this.url = e3, this.image.src = e3, this.ready && (this.viewBoxImage.src = e3, I2(this.previews, function(t4) {
        t4.getElementsByTagName("img")[0].src = e3;
      }))) : (this.isImg && (this.replaced = true), this.options.data = null, this.uncreate(), this.load(e3))), this;
    }, enable: function() {
      return this.ready && this.disabled && (this.disabled = false, q2(this.cropper, d2)), this;
    }, disable: function() {
      return this.ready && !this.disabled && (this.disabled = true, V2(this.cropper, d2)), this;
    }, destroy: function() {
      var e3 = this.element;
      return e3.cropper ? (e3.cropper = void 0, this.isImg && this.replaced && (e3.src = this.originalUrl), this.uncreate(), this) : this;
    }, move: function(e3) {
      var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e3, n3 = this.canvasData, r3 = n3.left, o3 = n3.top;
      return this.moveTo(N2(e3) ? e3 : r3 + Number(e3), N2(t3) ? t3 : o3 + Number(t3));
    }, moveTo: function(e3) {
      var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e3, n3 = this.canvasData, r3 = false;
      return e3 = Number(e3), t3 = Number(t3), this.ready && !this.disabled && this.options.movable && (A2(e3) && (n3.left = e3, r3 = true), A2(t3) && (n3.top = t3, r3 = true), r3 && this.renderCanvas(true)), this;
    }, zoom: function(e3, t3) {
      var n3 = this.canvasData;
      return e3 = (e3 = Number(e3)) < 0 ? 1 / (1 - e3) : 1 + e3, this.zoomTo(n3.width * e3 / n3.naturalWidth, null, t3);
    }, zoomTo: function(e3, t3, n3) {
      var r3 = this.options, o3 = this.canvasData, i3 = o3.width, a3 = o3.height, s3 = o3.naturalWidth, l3 = o3.naturalHeight;
      if ((e3 = Number(e3)) >= 0 && this.ready && !this.disabled && r3.zoomable) {
        var u3 = s3 * e3, c3 = l3 * e3;
        if (false === te2(this.element, "zoom", { ratio: e3, oldRatio: i3 / s3, originalEvent: n3 })) return this;
        if (n3) {
          var p3 = this.pointers, d3 = ne2(this.cropper), h3 = p3 && Object.keys(p3).length ? function(e4) {
            var t4 = 0, n4 = 0, r4 = 0;
            return I2(e4, function(e5) {
              var o4 = e5.startX, i4 = e5.startY;
              t4 += o4, n4 += i4, r4 += 1;
            }), { pageX: t4 /= r4, pageY: n4 /= r4 };
          }(p3) : { pageX: n3.pageX, pageY: n3.pageY };
          o3.left -= (u3 - i3) * ((h3.pageX - d3.left - o3.left) / i3), o3.top -= (c3 - a3) * ((h3.pageY - d3.top - o3.top) / a3);
        } else F2(t3) && A2(t3.x) && A2(t3.y) ? (o3.left -= (u3 - i3) * ((t3.x - o3.left) / i3), o3.top -= (c3 - a3) * ((t3.y - o3.top) / a3)) : (o3.left -= (u3 - i3) / 2, o3.top -= (c3 - a3) / 2);
        o3.width = u3, o3.height = c3, this.renderCanvas(true);
      }
      return this;
    }, rotate: function(e3) {
      return this.rotateTo((this.imageData.rotate || 0) + Number(e3));
    }, rotateTo: function(e3) {
      return A2(e3 = Number(e3)) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e3 % 360, this.renderCanvas(true, true)), this;
    }, scaleX: function(e3) {
      var t3 = this.imageData.scaleY;
      return this.scale(e3, A2(t3) ? t3 : 1);
    }, scaleY: function(e3) {
      var t3 = this.imageData.scaleX;
      return this.scale(A2(t3) ? t3 : 1, e3);
    }, scale: function(e3) {
      var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e3, n3 = this.imageData, r3 = false;
      return e3 = Number(e3), t3 = Number(t3), this.ready && !this.disabled && this.options.scalable && (A2(e3) && (n3.scaleX = e3, r3 = true), A2(t3) && (n3.scaleY = t3, r3 = true), r3 && this.renderCanvas(true, true)), this;
    }, getData: function() {
      var e3, t3 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], n3 = this.options, r3 = this.imageData, o3 = this.canvasData, i3 = this.cropBoxData;
      if (this.ready && this.cropped) {
        e3 = { x: i3.left - o3.left, y: i3.top - o3.top, width: i3.width, height: i3.height };
        var a3 = r3.width / r3.naturalWidth;
        if (I2(e3, function(t4, n4) {
          e3[n4] = t4 / a3;
        }), t3) {
          var s3 = Math.round(e3.y + e3.height), l3 = Math.round(e3.x + e3.width);
          e3.x = Math.round(e3.x), e3.y = Math.round(e3.y), e3.width = l3 - e3.x, e3.height = s3 - e3.y;
        }
      } else e3 = { x: 0, y: 0, width: 0, height: 0 };
      return n3.rotatable && (e3.rotate = r3.rotate || 0), n3.scalable && (e3.scaleX = r3.scaleX || 1, e3.scaleY = r3.scaleY || 1), e3;
    }, setData: function(e3) {
      var t3 = this.options, n3 = this.imageData, r3 = this.canvasData, o3 = {};
      if (this.ready && !this.disabled && F2(e3)) {
        var i3 = false;
        t3.rotatable && A2(e3.rotate) && e3.rotate !== n3.rotate && (n3.rotate = e3.rotate, i3 = true), t3.scalable && (A2(e3.scaleX) && e3.scaleX !== n3.scaleX && (n3.scaleX = e3.scaleX, i3 = true), A2(e3.scaleY) && e3.scaleY !== n3.scaleY && (n3.scaleY = e3.scaleY, i3 = true)), i3 && this.renderCanvas(true, true);
        var a3 = n3.width / n3.naturalWidth;
        A2(e3.x) && (o3.left = e3.x * a3 + r3.left), A2(e3.y) && (o3.top = e3.y * a3 + r3.top), A2(e3.width) && (o3.width = e3.width * a3), A2(e3.height) && (o3.height = e3.height * a3), this.setCropBoxData(o3);
      }
      return this;
    }, getContainerData: function() {
      return this.ready ? L2({}, this.containerData) : {};
    }, getImageData: function() {
      return this.sized ? L2({}, this.imageData) : {};
    }, getCanvasData: function() {
      var e3 = this.canvasData, t3 = {};
      return this.ready && I2(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(n3) {
        t3[n3] = e3[n3];
      }), t3;
    }, setCanvasData: function(e3) {
      var t3 = this.canvasData, n3 = t3.aspectRatio;
      return this.ready && !this.disabled && F2(e3) && (A2(e3.left) && (t3.left = e3.left), A2(e3.top) && (t3.top = e3.top), A2(e3.width) ? (t3.width = e3.width, t3.height = e3.width / n3) : A2(e3.height) && (t3.height = e3.height, t3.width = e3.height * n3), this.renderCanvas(true)), this;
    }, getCropBoxData: function() {
      var e3, t3 = this.cropBoxData;
      return this.ready && this.cropped && (e3 = { left: t3.left, top: t3.top, width: t3.width, height: t3.height }), e3 || {};
    }, setCropBoxData: function(e3) {
      var t3, n3, r3 = this.cropBoxData, o3 = this.options.aspectRatio;
      return this.ready && this.cropped && !this.disabled && F2(e3) && (A2(e3.left) && (r3.left = e3.left), A2(e3.top) && (r3.top = e3.top), A2(e3.width) && e3.width !== r3.width && (t3 = true, r3.width = e3.width), A2(e3.height) && e3.height !== r3.height && (n3 = true, r3.height = e3.height), o3 && (t3 ? r3.height = r3.width / o3 : n3 && (r3.width = r3.height * o3)), this.renderCropBox()), this;
    }, getCroppedCanvas: function() {
      var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      if (!this.ready || !window.HTMLCanvasElement) return null;
      var t3 = this.canvasData, n3 = function(e4, t4, n4, r4) {
        var o4 = t4.aspectRatio, a4 = t4.naturalWidth, s4 = t4.naturalHeight, l4 = t4.rotate, u4 = void 0 === l4 ? 0 : l4, c4 = t4.scaleX, p4 = void 0 === c4 ? 1 : c4, d4 = t4.scaleY, h4 = void 0 === d4 ? 1 : d4, f4 = n4.aspectRatio, m4 = n4.naturalWidth, v4 = n4.naturalHeight, g4 = r4.fillColor, y4 = void 0 === g4 ? "transparent" : g4, b4 = r4.imageSmoothingEnabled, _4 = void 0 === b4 || b4, w4 = r4.imageSmoothingQuality, C4 = void 0 === w4 ? "low" : w4, S4 = r4.maxWidth, k4 = void 0 === S4 ? 1 / 0 : S4, x4 = r4.maxHeight, P4 = void 0 === x4 ? 1 / 0 : x4, E4 = r4.minWidth, O4 = void 0 === E4 ? 0 : E4, A4 = r4.minHeight, U4 = void 0 === A4 ? 0 : A4, N4 = document.createElement("canvas"), T4 = N4.getContext("2d"), R3 = ue2({ aspectRatio: f4, width: k4, height: P4 }), F3 = ue2({ aspectRatio: f4, width: O4, height: U4 }, "cover"), D3 = Math.min(R3.width, Math.max(F3.width, m4)), M3 = Math.min(R3.height, Math.max(F3.height, v4)), B3 = ue2({ aspectRatio: o4, width: k4, height: P4 }), I3 = ue2({ aspectRatio: o4, width: O4, height: U4 }, "cover"), L3 = Math.min(B3.width, Math.max(I3.width, a4)), j3 = Math.min(B3.height, Math.max(I3.height, s4)), H3 = [-L3 / 2, -j3 / 2, L3, j3];
        return N4.width = z2(D3), N4.height = z2(M3), T4.fillStyle = y4, T4.fillRect(0, 0, D3, M3), T4.save(), T4.translate(D3 / 2, M3 / 2), T4.rotate(u4 * Math.PI / 180), T4.scale(p4, h4), T4.imageSmoothingEnabled = _4, T4.imageSmoothingQuality = C4, T4.drawImage.apply(T4, [e4].concat(i2(H3.map(function(e5) {
          return Math.floor(z2(e5));
        })))), T4.restore(), N4;
      }(this.image, this.imageData, t3, e3);
      if (!this.cropped) return n3;
      var r3 = this.getData(), o3 = r3.x, a3 = r3.y, s3 = r3.width, l3 = r3.height, u3 = n3.width / Math.floor(t3.naturalWidth);
      1 !== u3 && (o3 *= u3, a3 *= u3, s3 *= u3, l3 *= u3);
      var c3 = s3 / l3, p3 = ue2({ aspectRatio: c3, width: e3.maxWidth || 1 / 0, height: e3.maxHeight || 1 / 0 }), d3 = ue2({ aspectRatio: c3, width: e3.minWidth || 0, height: e3.minHeight || 0 }, "cover"), h3 = ue2({ aspectRatio: c3, width: e3.width || (1 !== u3 ? n3.width : s3), height: e3.height || (1 !== u3 ? n3.height : l3) }), f3 = h3.width, m3 = h3.height;
      f3 = Math.min(p3.width, Math.max(d3.width, f3)), m3 = Math.min(p3.height, Math.max(d3.height, m3));
      var v3 = document.createElement("canvas"), g3 = v3.getContext("2d");
      v3.width = z2(f3), v3.height = z2(m3), g3.fillStyle = e3.fillColor || "transparent", g3.fillRect(0, 0, f3, m3);
      var y3 = e3.imageSmoothingEnabled, b3 = void 0 === y3 || y3, _3 = e3.imageSmoothingQuality;
      g3.imageSmoothingEnabled = b3, _3 && (g3.imageSmoothingQuality = _3);
      var w3, C3, S3, k3, x3, P3, E3 = n3.width, O3 = n3.height, A3 = o3, U3 = a3;
      A3 <= -s3 || A3 > E3 ? (A3 = 0, w3 = 0, S3 = 0, x3 = 0) : A3 <= 0 ? (S3 = -A3, A3 = 0, x3 = w3 = Math.min(E3, s3 + A3)) : A3 <= E3 && (S3 = 0, x3 = w3 = Math.min(s3, E3 - A3)), w3 <= 0 || U3 <= -l3 || U3 > O3 ? (U3 = 0, C3 = 0, k3 = 0, P3 = 0) : U3 <= 0 ? (k3 = -U3, U3 = 0, P3 = C3 = Math.min(O3, l3 + U3)) : U3 <= O3 && (k3 = 0, P3 = C3 = Math.min(l3, O3 - U3));
      var N3 = [A3, U3, w3, C3];
      if (x3 > 0 && P3 > 0) {
        var T3 = f3 / s3;
        N3.push(S3 * T3, k3 * T3, x3 * T3, P3 * T3);
      }
      return g3.drawImage.apply(g3, [n3].concat(i2(N3.map(function(e4) {
        return Math.floor(z2(e4));
      })))), v3;
    }, setAspectRatio: function(e3) {
      var t3 = this.options;
      return this.disabled || N2(e3) || (t3.aspectRatio = Math.max(0, e3) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
    }, setDragMode: function(e3) {
      var t3 = this.options, n3 = this.dragBox, r3 = this.face;
      if (this.ready && !this.disabled) {
        var o3 = "crop" === e3, i3 = t3.movable && "move" === e3;
        e3 = o3 || i3 ? e3 : "none", t3.dragMode = e3, K2(n3, y2, e3), X2(n3, p2, o3), X2(n3, g2, i3), t3.cropBoxMovable || (K2(r3, y2, e3), X2(r3, p2, o3), X2(r3, g2, i3));
      }
      return this;
    } }, ye2 = l2.Cropper, be2 = function() {
      function e3(t3) {
        var n4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (function(e4, t4) {
          if (!(e4 instanceof t4)) throw new TypeError("Cannot call a class as a function");
        }(this, e3), !t3 || !P2.test(t3.tagName)) throw new Error("The first argument is required and must be an <img> or <canvas> element.");
        this.element = t3, this.options = L2({}, E2, F2(n4) && n4), this.cropped = false, this.disabled = false, this.pointers = {}, this.ready = false, this.reloading = false, this.replaced = false, this.sized = false, this.sizing = false, this.init();
      }
      var n3, r3, o3;
      return n3 = e3, o3 = [{ key: "noConflict", value: function() {
        return window.Cropper = ye2, e3;
      } }, { key: "setDefaults", value: function(e4) {
        L2(E2, F2(e4) && e4);
      } }], (r3 = [{ key: "init", value: function() {
        var e4, t3 = this.element, n4 = t3.tagName.toLowerCase();
        if (!t3.cropper) {
          if (t3.cropper = this, "img" === n4) {
            if (this.isImg = true, e4 = t3.getAttribute("src") || "", this.originalUrl = e4, !e4) return;
            e4 = t3.src;
          } else "canvas" === n4 && window.HTMLCanvasElement && (e4 = t3.toDataURL());
          this.load(e4);
        }
      } }, { key: "load", value: function(e4) {
        var t3 = this;
        if (e4) {
          this.url = e4, this.imageData = {};
          var n4 = this.element, r4 = this.options;
          if (r4.rotatable || r4.scalable || (r4.checkOrientation = false), r4.checkOrientation && window.ArrayBuffer) if (k2.test(e4)) x2.test(e4) ? this.read((o4 = e4.replace(pe2, ""), i3 = atob(o4), a3 = new ArrayBuffer(i3.length), I2(s3 = new Uint8Array(a3), function(e5, t4) {
            s3[t4] = i3.charCodeAt(t4);
          }), a3)) : this.clone();
          else {
            var o4, i3, a3, s3, l3 = new XMLHttpRequest(), u3 = this.clone.bind(this);
            this.reloading = true, this.xhr = l3, l3.onabort = u3, l3.onerror = u3, l3.ontimeout = u3, l3.onprogress = function() {
              "image/jpeg" !== l3.getResponseHeader("content-type") && l3.abort();
            }, l3.onload = function() {
              t3.read(l3.response);
            }, l3.onloadend = function() {
              t3.reloading = false, t3.xhr = null;
            }, r4.checkCrossOrigin && ie2(e4) && n4.crossOrigin && (e4 = ae2(e4)), l3.open("GET", e4), l3.responseType = "arraybuffer", l3.withCredentials = "use-credentials" === n4.crossOrigin, l3.send();
          }
          else this.clone();
        }
      } }, { key: "read", value: function(e4) {
        var t3 = this.options, n4 = this.imageData, r4 = function(e5) {
          var t4, n5 = new DataView(e5);
          try {
            var r5, o5, i4;
            if (255 === n5.getUint8(0) && 216 === n5.getUint8(1)) for (var a4 = n5.byteLength, s4 = 2; s4 + 1 < a4; ) {
              if (255 === n5.getUint8(s4) && 225 === n5.getUint8(s4 + 1)) {
                o5 = s4;
                break;
              }
              s4 += 1;
            }
            if (o5) {
              var l3 = o5 + 10;
              if ("Exif" === function(e6, t5, n6) {
                var r6 = "";
                n6 += t5;
                for (var o6 = t5; o6 < n6; o6 += 1) r6 += ce2(e6.getUint8(o6));
                return r6;
              }(n5, o5 + 4, 4)) {
                var u3 = n5.getUint16(l3);
                if (((r5 = 18761 === u3) || 19789 === u3) && 42 === n5.getUint16(l3 + 2, r5)) {
                  var c3 = n5.getUint32(l3 + 4, r5);
                  c3 >= 8 && (i4 = l3 + c3);
                }
              }
            }
            if (i4) {
              var p3, d3, h3 = n5.getUint16(i4, r5);
              for (d3 = 0; d3 < h3; d3 += 1) if (p3 = i4 + 12 * d3 + 2, 274 === n5.getUint16(p3, r5)) {
                p3 += 8, t4 = n5.getUint16(p3, r5), n5.setUint16(p3, 1, r5);
                break;
              }
            }
          } catch (Dp2) {
            t4 = 1;
          }
          return t4;
        }(e4), o4 = 0, i3 = 1, a3 = 1;
        if (r4 > 1) {
          this.url = function(e5, t4) {
            for (var n5 = [], r5 = new Uint8Array(e5); r5.length > 0; ) n5.push(ce2.apply(null, B2(r5.subarray(0, 8192)))), r5 = r5.subarray(8192);
            return "data:".concat("image/jpeg", ";base64,").concat(btoa(n5.join("")));
          }(e4);
          var s3 = function(e5) {
            var t4 = 0, n5 = 1, r5 = 1;
            switch (e5) {
              case 2:
                n5 = -1;
                break;
              case 3:
                t4 = -180;
                break;
              case 4:
                r5 = -1;
                break;
              case 5:
                t4 = 90, r5 = -1;
                break;
              case 6:
                t4 = 90;
                break;
              case 7:
                t4 = 90, n5 = -1;
                break;
              case 8:
                t4 = -90;
            }
            return { rotate: t4, scaleX: n5, scaleY: r5 };
          }(r4);
          o4 = s3.rotate, i3 = s3.scaleX, a3 = s3.scaleY;
        }
        t3.rotatable && (n4.rotate = o4), t3.scalable && (n4.scaleX = i3, n4.scaleY = a3), this.clone();
      } }, { key: "clone", value: function() {
        var e4 = this.element, t3 = this.url, n4 = e4.crossOrigin, r4 = t3;
        this.options.checkCrossOrigin && ie2(t3) && (n4 || (n4 = "anonymous"), r4 = ae2(t3)), this.crossOrigin = n4, this.crossOriginUrl = r4;
        var o4 = document.createElement("img");
        n4 && (o4.crossOrigin = n4), o4.src = r4 || t3, o4.alt = e4.alt || "The image to crop", this.image = o4, o4.onload = this.start.bind(this), o4.onerror = this.stop.bind(this), V2(o4, f2), e4.parentNode.insertBefore(o4, e4.nextSibling);
      } }, { key: "start", value: function() {
        var e4 = this, t3 = this.image;
        t3.onload = null, t3.onerror = null, this.sizing = true;
        var n4 = l2.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(l2.navigator.userAgent), r4 = function(t4, n5) {
          L2(e4.imageData, { naturalWidth: t4, naturalHeight: n5, aspectRatio: t4 / n5 }), e4.sizing = false, e4.sized = true, e4.build();
        };
        if (!t3.naturalWidth || n4) {
          var o4 = document.createElement("img"), i3 = document.body || document.documentElement;
          this.sizingImage = o4, o4.onload = function() {
            r4(o4.width, o4.height), n4 || i3.removeChild(o4);
          }, o4.src = t3.src, n4 || (o4.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", i3.appendChild(o4));
        } else r4(t3.naturalWidth, t3.naturalHeight);
      } }, { key: "stop", value: function() {
        var e4 = this.image;
        e4.onload = null, e4.onerror = null, e4.parentNode.removeChild(e4), this.image = null;
      } }, { key: "build", value: function() {
        if (this.sized && !this.ready) {
          var e4 = this.element, t3 = this.options, n4 = this.image, r4 = e4.parentNode, o4 = document.createElement("div");
          o4.innerHTML = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>';
          var i3 = o4.querySelector(".".concat("cropper", "-container")), a3 = i3.querySelector(".".concat("cropper", "-canvas")), s3 = i3.querySelector(".".concat("cropper", "-drag-box")), l3 = i3.querySelector(".".concat("cropper", "-crop-box")), u3 = l3.querySelector(".".concat("cropper", "-face"));
          this.container = r4, this.cropper = i3, this.canvas = a3, this.dragBox = s3, this.cropBox = l3, this.viewBox = i3.querySelector(".".concat("cropper", "-view-box")), this.face = u3, a3.appendChild(n4), V2(e4, h2), r4.insertBefore(i3, e4.nextSibling), this.isImg || q2(n4, f2), this.initPreview(), this.bind(), t3.initialAspectRatio = Math.max(0, t3.initialAspectRatio) || NaN, t3.aspectRatio = Math.max(0, t3.aspectRatio) || NaN, t3.viewMode = Math.max(0, Math.min(3, Math.round(t3.viewMode))) || 0, V2(l3, h2), t3.guides || V2(l3.getElementsByClassName("".concat("cropper", "-dashed")), h2), t3.center || V2(l3.getElementsByClassName("".concat("cropper", "-center")), h2), t3.background && V2(i3, "".concat("cropper", "-bg")), t3.highlight || V2(u3, m2), t3.cropBoxMovable && (V2(u3, g2), K2(u3, y2, "all")), t3.cropBoxResizable || (V2(l3.getElementsByClassName("".concat("cropper", "-line")), h2), V2(l3.getElementsByClassName("".concat("cropper", "-point")), h2)), this.render(), this.ready = true, this.setDragMode(t3.dragMode), t3.autoCrop && this.crop(), this.setData(t3.data), D2(t3.ready) && ee2(e4, "ready", t3.ready, { once: true }), te2(e4, "ready");
        }
      } }, { key: "unbuild", value: function() {
        this.ready && (this.ready = false, this.unbind(), this.resetPreview(), this.cropper.parentNode.removeChild(this.cropper), q2(this.element, h2));
      } }, { key: "uncreate", value: function() {
        this.ready ? (this.unbuild(), this.ready = false, this.cropped = false) : this.sizing ? (this.sizingImage.onload = null, this.sizing = false, this.sized = false) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
      } }]) && t2(n3.prototype, r3), o3 && t2(n3, o3), e3;
    }();
    return L2(be2.prototype, de2, he2, fe2, me2, ve2, ge2), be2;
  }, "object" == typeof Pi.exports ? Pi.exports = Ci() : (wi = wi || self).Cropper = Ci(), Pi = Pi.exports;
  var Ei = { exports: {} };
  function Oi(e2, t2) {
    return (Oi = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    Ei.exports = N2;
  }();
  var Ai, Ui, Ni = (Ei = Ei.exports).h, Ti = function(e2) {
    var t2, n2;
    function r2(t3) {
      var n3;
      return (n3 = e2.call(this, t3) || this).save = function() {
        n3.cropper.getCroppedCanvas().toBlob(function(e3) {
          return n3.props.save(e3);
        }, n3.props.currentImage.type, n3.props.opts.quality);
      }, n3.granularRotateOnChange = function(e3) {
        var t4 = n3.state, r3 = t4.rotationAngle, o3 = t4.rotationDelta, i2 = Number(e3.target.value) - o3;
        if (cancelAnimationFrame(n3.granularRotateOnInputNextFrame), 0 !== i2) {
          var a2 = r3 + i2;
          n3.granularRotateOnInputNextFrame = requestAnimationFrame(function() {
            n3.cropper.rotateTo(a2);
          });
        }
      }, n3.state = { rotationAngle: 0, rotationDelta: 0 }, n3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Oi(t2, n2);
    var o2 = r2.prototype;
    return o2.componentDidMount = function() {
      var e3 = this;
      this.cropper = new Pi(this.imgElement, this.props.opts.cropperOptions), this.props.opts.actions.granularRotate && this.imgElement.addEventListener("crop", function(t3) {
        var n3 = t3.detail.rotate;
        e3.setState({ rotationAngle: n3, rotationDelta: (n3 + 405) % 90 - 45 });
      });
    }, o2.componentWillUnmount = function() {
      this.cropper.destroy();
    }, o2.renderRevert = function() {
      var e3 = this;
      return Ni("button", { type: "button", className: "uppy-u-reset uppy-c-btn", "aria-label": this.props.i18n("revert"), "data-microtip-position": "top", role: "tooltip", onClick: function() {
        e3.cropper.reset(), e3.cropper.setAspectRatio(0);
      } }, Ni("svg", { "aria-hidden": "true", className: "uppy-c-icon", width: "24", height: "24", viewBox: "0 0 24 24" }, Ni("path", { d: "M0 0h24v24H0z", fill: "none" }), Ni("path", { d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" })));
    }, o2.renderRotate = function() {
      var e3 = this;
      return Ni("button", { type: "button", className: "uppy-u-reset uppy-c-btn", onClick: function() {
        return e3.cropper.rotate(-90);
      }, "aria-label": this.props.i18n("rotate"), "data-microtip-position": "top", role: "tooltip" }, Ni("svg", { "aria-hidden": "true", className: "uppy-c-icon", width: "24", height: "24", viewBox: "0 0 24 24" }, Ni("path", { d: "M0 0h24v24H0V0zm0 0h24v24H0V0z", fill: "none" }), Ni("path", { d: "M14 10a2 2 0 012 2v7a2 2 0 01-2 2H6a2 2 0 01-2-2v-7a2 2 0 012-2h8zm0 1.75H6a.25.25 0 00-.243.193L5.75 12v7a.25.25 0 00.193.243L6 19.25h8a.25.25 0 00.243-.193L14.25 19v-7a.25.25 0 00-.193-.243L14 11.75zM12 .76V4c2.3 0 4.61.88 6.36 2.64a8.95 8.95 0 012.634 6.025L21 13a1 1 0 01-1.993.117L19 13h-.003a6.979 6.979 0 00-2.047-4.95 6.97 6.97 0 00-4.652-2.044L12 6v3.24L7.76 5 12 .76z" })));
    }, o2.renderGranularRotate = function() {
      return Ni("label", { "data-microtip-position": "top", role: "tooltip", "aria-label": this.state.rotationAngle + "\xBA", className: "uppy-ImageCropper-rangeWrapper uppy-u-reset" }, Ni("input", { className: "uppy-ImageCropper-range uppy-u-reset", type: "range", onInput: this.granularRotateOnChange, onChange: this.granularRotateOnChange, value: this.state.rotationDelta, min: "-45", max: "44", "aria-label": this.props.i18n("rotate") }));
    }, o2.renderFlip = function() {
      var e3 = this;
      return Ni("button", { type: "button", className: "uppy-u-reset uppy-c-btn", "aria-label": this.props.i18n("flipHorizontal"), "data-microtip-position": "top", role: "tooltip", onClick: function() {
        return e3.cropper.scaleX(-e3.cropper.getData().scaleX || -1);
      } }, Ni("svg", { "aria-hidden": "true", className: "uppy-c-icon", width: "24", height: "24", viewBox: "0 0 24 24" }, Ni("path", { d: "M0 0h24v24H0z", fill: "none" }), Ni("path", { d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z" })));
    }, o2.renderZoomIn = function() {
      var e3 = this;
      return Ni("button", { type: "button", className: "uppy-u-reset uppy-c-btn", "aria-label": this.props.i18n("zoomIn"), "data-microtip-position": "top", role: "tooltip", onClick: function() {
        return e3.cropper.zoom(0.1);
      } }, Ni("svg", { "aria-hidden": "true", className: "uppy-c-icon", height: "24", viewBox: "0 0 24 24", width: "24" }, Ni("path", { d: "M0 0h24v24H0V0z", fill: "none" }), Ni("path", { d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" }), Ni("path", { d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" })));
    }, o2.renderZoomOut = function() {
      var e3 = this;
      return Ni("button", { type: "button", className: "uppy-u-reset uppy-c-btn", "aria-label": this.props.i18n("zoomOut"), "data-microtip-position": "top", role: "tooltip", onClick: function() {
        return e3.cropper.zoom(-0.1);
      } }, Ni("svg", { "aria-hidden": "true", className: "uppy-c-icon", width: "24", height: "24", viewBox: "0 0 24 24" }, Ni("path", { d: "M0 0h24v24H0V0z", fill: "none" }), Ni("path", { d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z" })));
    }, o2.renderCropSquare = function() {
      var e3 = this;
      return Ni("button", { type: "button", className: "uppy-u-reset uppy-c-btn", "aria-label": this.props.i18n("aspectRatioSquare"), "data-microtip-position": "top", role: "tooltip", onClick: function() {
        return e3.cropper.setAspectRatio(1);
      } }, Ni("svg", { "aria-hidden": "true", className: "uppy-c-icon", width: "24", height: "24", viewBox: "0 0 24 24" }, Ni("path", { d: "M0 0h24v24H0z", fill: "none" }), Ni("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" })));
    }, o2.renderCropWidescreen = function() {
      var e3 = this;
      return Ni("button", { type: "button", className: "uppy-u-reset uppy-c-btn", "aria-label": this.props.i18n("aspectRatioLandscape"), "data-microtip-position": "top", role: "tooltip", onClick: function() {
        return e3.cropper.setAspectRatio(16 / 9);
      } }, Ni("svg", { "aria-hidden": "true", className: "uppy-c-icon", width: "24", height: "24", viewBox: "0 0 24 24" }, Ni("path", { d: "M 19,4.9999992 V 17.000001 H 4.9999998 V 6.9999992 H 19 m 0,-2 H 4.9999998 c -1.0999999,0 -1.9999999,0.9000001 -1.9999999,2 V 17.000001 c 0,1.1 0.9,2 1.9999999,2 H 19 c 1.1,0 2,-0.9 2,-2 V 6.9999992 c 0,-1.0999999 -0.9,-2 -2,-2 z" }), Ni("path", { fill: "none", d: "M0 0h24v24H0z" })));
    }, o2.renderCropWidescreenVertical = function() {
      var e3 = this;
      return Ni("button", { type: "button", className: "uppy-u-reset uppy-c-btn", "aria-label": this.props.i18n("aspectRatioPortrait"), "data-microtip-position": "top", role: "tooltip", onClick: function() {
        return e3.cropper.setAspectRatio(9 / 16);
      } }, Ni("svg", { "aria-hidden": "true", className: "uppy-c-icon", width: "24", height: "24", viewBox: "0 0 24 24" }, Ni("path", { d: "M 19.000001,19 H 6.999999 V 5 h 10.000002 v 14 m 2,0 V 5 c 0,-1.0999999 -0.9,-1.9999999 -2,-1.9999999 H 6.999999 c -1.1,0 -2,0.9 -2,1.9999999 v 14 c 0,1.1 0.9,2 2,2 h 10.000002 c 1.1,0 2,-0.9 2,-2 z" }), Ni("path", { d: "M0 0h24v24H0z", fill: "none" })));
    }, o2.render = function() {
      var e3 = this, t3 = this.props, n3 = t3.currentImage, r3 = t3.i18n, o3 = t3.opts.actions, i2 = URL.createObjectURL(n3.data);
      return Ni("div", { className: "uppy-ImageCropper" }, Ni("div", { className: "uppy-ImageCropper-container" }, Ni("img", { className: "uppy-ImageCropper-image", alt: n3.name, src: i2, ref: function(t4) {
        e3.imgElement = t4;
      } })), Ni("div", { className: "uppy-ImageCropper-controls" }, Ni("button", { type: "button", className: "uppy-u-reset uppy-c-btn", "aria-label": r3("save"), "data-microtip-position": "top", role: "tooltip", onClick: function() {
        return e3.save();
      } }, Ni("svg", { "aria-hidden": "true", className: "uppy-c-icon", width: "24", height: "24", viewBox: "0 0 24 24" }, Ni("path", { d: "M0 0h24v24H0z", fill: "none" }), Ni("path", { d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" }))), o3.revert && this.renderRevert(), o3.rotate && this.renderRotate(), o3.granularRotate && this.renderGranularRotate(), o3.flip && this.renderFlip(), o3.zoomIn && this.renderZoomIn(), o3.zoomOut && this.renderZoomOut(), o3.cropSquare && this.renderCropSquare(), o3.cropWidescreen && this.renderCropWidescreen(), o3.cropWidescreenVertical && this.renderCropWidescreenVertical()));
    }, r2;
  }(Ei.Component);
  function Ri() {
    return (Ri = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Fi(e2, t2) {
    return (Fi = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Di = ue.Plugin, Mi = Ei.h, Bi = (Ui = Ai = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).save = function(e3) {
        var t4 = r3.getPluginState().currentImage;
        r3.uppy.setFileState(t4.id, { data: e3, size: e3.size, preview: null });
        var n4 = r3.uppy.getFile(t4.id);
        r3.uppy.emit("thumbnail:request", n4), r3.setPluginState({ currentImage: n4 }), r3.uppy.emit("file-editor:complete", n4);
      }, r3.selectFile = function(e3) {
        r3.uppy.emit("file-editor:start", e3), r3.setPluginState({ currentImage: e3 });
      }, r3.id = r3.opts.id || "ImageEditor", r3.title = "Image Editor", r3.type = "editor", r3.defaultLocale = { strings: { save: "Save", revert: "Revert", rotate: "Rotate", zoomIn: "Zoom in", zoomOut: "Zoom out", flipHorizontal: "Flip horizontal", aspectRatioSquare: "Crop square", aspectRatioLandscape: "Crop landscape (16:9)", aspectRatioPortrait: "Crop portrait (9:16)" } }, r3.opts = Ri({}, { quality: 0.8 }, n3, { actions: Ri({}, { revert: true, rotate: true, granularRotate: true, flip: true, zoomIn: true, zoomOut: true, cropSquare: true, cropWidescreen: true, cropWidescreenVertical: true }, n3.actions), cropperOptions: Ri({}, { viewMode: 1, background: false, autoCropArea: 1, responsive: true }, n3.cropperOptions) }), r3.i18nInit(), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Fi(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, t3), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.setPluginState();
    }, o2.canEditFile = function(e3) {
      if (!e3.type || e3.isRemote) return false;
      var t3 = e3.type.split("/")[1];
      return !!/^(jpe?g|gif|png|bmp|webp)$/.test(t3);
    }, o2.install = function() {
      this.setPluginState({ currentImage: null });
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.unmount();
    }, o2.render = function() {
      var e3 = this.getPluginState().currentImage;
      if (null !== e3 && !e3.isRemote) return Mi(Ti, { currentImage: e3, save: this.save, opts: this.opts, i18n: this.i18n });
    }, r2;
  }(Di), Ai.VERSION = "0.3.0", Ui), Ii = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    Ii.exports = N2;
  }(), Ii = Ii.exports;
  var Li, ji;
  function zi(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Hi(e2, t2) {
    return (Hi = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Wi = ue.Plugin, Vi = Ke.Provider, qi = Zt.ProviderViews, Xi = Ii.h, Gi = (ji = Li = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "Dropbox", Vi.initPlugin(zi(r3), n3), r3.title = r3.opts.title || "Dropbox", r3.icon = function() {
        return Xi("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, Xi("g", { fill: "none", fillRule: "evenodd" }, Xi("rect", { className: "uppy-ProviderIconBg", fill: "#0D2481", width: "32", height: "32", rx: "16" }), Xi("path", { d: "M11 8l5 3.185-5 3.186-5-3.186L11 8zm10 0l5 3.185-5 3.186-5-3.186L21 8zM6 17.556l5-3.185 5 3.185-5 3.186-5-3.186zm15-3.185l5 3.185-5 3.186-5-3.186 5-3.185zm-10 7.432l5-3.185 5 3.185-5 3.186-5-3.186z", fill: "#FFF", fillRule: "nonzero" })));
      }, r3.provider = new Vi(t3, { companionUrl: r3.opts.companionUrl, companionHeaders: r3.opts.companionHeaders || r3.opts.serverHeaders, companionKeysParams: r3.opts.companionKeysParams, companionCookiesRule: r3.opts.companionCookiesRule, provider: "dropbox", pluginId: r3.id }), r3.onFirstRender = r3.onFirstRender.bind(zi(r3)), r3.render = r3.render.bind(zi(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Hi(t2, n2);
    var o2 = r2.prototype;
    return o2.install = function() {
      this.view = new qi(this, { provider: this.provider });
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.view.tearDown(), this.unmount();
    }, o2.onFirstRender = function() {
      return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder()]);
    }, o2.render = function(e3) {
      return this.view.render(e3);
    }, r2;
  }(Wi), Li.VERSION = "1.5.2", ji);
  function Yi(e2, t2) {
    return (Yi = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var $i = function(e2) {
    var t2, n2;
    function r2() {
      return e2.apply(this, arguments) || this;
    }
    return n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Yi(t2, n2), r2.prototype.toggleCheckbox = function(t3, n3) {
      t3.stopPropagation(), t3.preventDefault(), n3.custom.isTeamDrive || n3.custom.isSharedDrive || e2.prototype.toggleCheckbox.call(this, t3, n3);
    }, r2;
  }(Zt.ProviderViews), Ki = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    Ki.exports = N2;
  }(), Ki = Ki.exports;
  var Ji, Qi;
  function Zi(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function ea(e2, t2) {
    return (ea = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var ta = ue.Plugin, na = Ke.Provider, ra = Ki.h, oa = (Qi = Ji = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "GoogleDrive", r3.title = r3.opts.title || "Google Drive", na.initPlugin(Zi(r3), n3), r3.title = r3.opts.title || "Google Drive", r3.icon = function() {
        return ra("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, ra("g", { fill: "none", fillRule: "evenodd" }, ra("rect", { className: "uppy-ProviderIconBg", fill: "#4285F4", width: "32", height: "32", rx: "16" }), ra("path", { d: "M10.324 23.3l3-5.1H25l-3 5.1H10.324zM13 18.2l-3 5.1-3-5.1 5.839-9.924 2.999 5.1L13 18.2zm11.838-.276h-6L13 8h6l5.84 9.924h-.002z", fill: "#FFF" })));
      }, r3.provider = new na(t3, { companionUrl: r3.opts.companionUrl, companionHeaders: r3.opts.companionHeaders || r3.opts.serverHeaders, companionKeysParams: r3.opts.companionKeysParams, companionCookiesRule: r3.opts.companionCookiesRule, provider: "drive", pluginId: r3.id }), r3.onFirstRender = r3.onFirstRender.bind(Zi(r3)), r3.render = r3.render.bind(Zi(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, ea(t2, n2);
    var o2 = r2.prototype;
    return o2.install = function() {
      this.view = new $i(this, { provider: this.provider });
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.view.tearDown(), this.unmount();
    }, o2.onFirstRender = function() {
      return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder("root", "/")]);
    }, o2.render = function(e3) {
      return this.view.render(e3);
    }, r2;
  }(ta), Ji.VERSION = "1.7.2", Qi), ia = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    ia.exports = N2;
  }(), ia = ia.exports;
  var aa, sa;
  function la(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function ua(e2, t2) {
    return (ua = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var ca = ue.Plugin, pa = Ke.Provider, da = Zt.ProviderViews, ha = ia.h, fa = (sa = aa = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "Instagram", pa.initPlugin(la(r3), n3), r3.title = r3.opts.title || "Instagram", r3.icon = function() {
        return ha("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, ha("g", { fill: "none", fillRule: "evenodd" }, ha("rect", { className: "uppy-ProviderIconBg", fill: "#E1306C", width: "32", height: "32", rx: "16" }), ha("path", { d: "M16 8.622c2.403 0 2.688.009 3.637.052.877.04 1.354.187 1.67.31.392.144.745.374 1.036.673.299.29.529.644.673 1.035.123.317.27.794.31 1.671.043.95.052 1.234.052 3.637s-.009 2.688-.052 3.637c-.04.877-.187 1.354-.31 1.671a2.98 2.98 0 0 1-1.708 1.708c-.317.123-.794.27-1.671.31-.95.043-1.234.053-3.637.053s-2.688-.01-3.637-.053c-.877-.04-1.354-.187-1.671-.31a2.788 2.788 0 0 1-1.035-.673 2.788 2.788 0 0 1-.673-1.035c-.123-.317-.27-.794-.31-1.671-.043-.949-.052-1.234-.052-3.637s.009-2.688.052-3.637c.04-.877.187-1.354.31-1.67.144-.392.374-.745.673-1.036.29-.299.644-.529 1.035-.673.317-.123.794-.27 1.671-.31.95-.043 1.234-.052 3.637-.052zM16 7c-2.444 0-2.75.01-3.71.054-.959.044-1.613.196-2.185.419-.6.225-1.145.58-1.594 1.038-.458.45-.813.993-1.039 1.594-.222.572-.374 1.226-.418 2.184C7.01 13.25 7 13.556 7 16s.01 2.75.054 3.71c.044.959.196 1.613.419 2.185.226.6.58 1.145 1.038 1.594.45.458.993.813 1.594 1.038.572.223 1.227.375 2.184.419.96.044 1.267.054 3.711.054s2.75-.01 3.71-.054c.959-.044 1.613-.196 2.185-.419a4.602 4.602 0 0 0 2.632-2.632c.223-.572.375-1.226.419-2.184.044-.96.054-1.267.054-3.711s-.01-2.75-.054-3.71c-.044-.959-.196-1.613-.419-2.185A4.412 4.412 0 0 0 23.49 8.51a4.412 4.412 0 0 0-1.594-1.039c-.572-.222-1.226-.374-2.184-.418C18.75 7.01 18.444 7 16 7zm0 4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 7.421a2.921 2.921 0 1 1 0-5.842 2.921 2.921 0 0 1 0 5.842zm4.875-6.671a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25z", fill: "#FFF" })));
      }, r3.provider = new pa(t3, { companionUrl: r3.opts.companionUrl, companionHeaders: r3.opts.companionHeaders || r3.opts.serverHeaders, companionKeysParams: r3.opts.companionKeysParams, companionCookiesRule: r3.opts.companionCookiesRule, provider: "instagram", pluginId: r3.id }), r3.onFirstRender = r3.onFirstRender.bind(la(r3)), r3.render = r3.render.bind(la(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, ua(t2, n2);
    var o2 = r2.prototype;
    return o2.install = function() {
      this.view = new da(this, { provider: this.provider, viewType: "grid", showTitles: false, showFilter: false, showBreadcrumbs: false });
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.view.tearDown(), this.unmount();
    }, o2.onFirstRender = function() {
      return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder("recent")]);
    }, o2.render = function(e3) {
      return this.view.render(e3);
    }, r2;
  }(ca), aa.VERSION = "1.5.2", sa), ma = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    ma.exports = N2;
  }(), ma = ma.exports;
  var va, ga;
  function ya(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function ba(e2, t2) {
    return (ba = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var _a = ue.Plugin, wa = Ke.Provider, Ca = Zt.ProviderViews, Sa = ma.h, ka = (ga = va = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "OneDrive", wa.initPlugin(ya(r3), n3), r3.title = r3.opts.title || "OneDrive", r3.icon = function() {
        return Sa("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, Sa("g", { fill: "none", fillRule: "evenodd" }, Sa("rect", { className: "uppy-ProviderIconBg", width: "32", height: "32", rx: "16", fill: "#0262C0" }), Sa("g", { fill: "#FFF", fillRule: "nonzero" }, Sa("path", { d: "M24.157 22s1.492-.205 1.79-1.655a2.624 2.624 0 0 0 .03-.878c-.22-1.64-1.988-2.01-1.988-2.01s.307-1.765-1.312-2.69c-1.62-.925-3.1 0-3.1 0S18.711 13 16.366 13c-3.016 0-3.519 3.448-3.519 3.448S10 16.618 10 19.14c0 2.523 2.597 2.86 2.597 2.86h11.56z" }), Sa("path", { d: "M9.421 19.246c0-2.197 1.606-3.159 2.871-3.472.44-1.477 1.654-3.439 4.135-3.439H16.445c1.721 0 2.79.823 3.368 1.476a3.99 3.99 0 0 1 1.147-.171h.01l.03.002C21.017 13.5 20.691 10 16.757 10c-2.69 0-3.639 2.345-3.639 2.345s-1.95-1.482-3.955.567c-1.028 1.052-.79 2.669-.79 2.669S6 15.824 6 18.412C6 20.757 8.452 21 8.452 21h1.372a3.77 3.77 0 0 1-.403-1.754z" }))));
      }, r3.provider = new wa(t3, { companionUrl: r3.opts.companionUrl, companionHeaders: r3.opts.companionHeaders || r3.opts.serverHeaders, companionCookiesRule: r3.opts.companionCookiesRule, provider: "onedrive", pluginId: r3.id }), r3.onFirstRender = r3.onFirstRender.bind(ya(r3)), r3.render = r3.render.bind(ya(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, ba(t2, n2);
    var o2 = r2.prototype;
    return o2.install = function() {
      this.view = new Ca(this, { provider: this.provider });
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.view.tearDown(), this.unmount();
    }, o2.onFirstRender = function() {
      return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder()]);
    }, o2.render = function(e3) {
      return this.view.render(e3);
    }, r2;
  }(_a), va.VERSION = "1.2.2", ga), xa = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    xa.exports = N2;
  }(), xa = xa.exports;
  var Pa, Ea;
  function Oa(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Aa(e2, t2) {
    return (Aa = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Ua = ue.Plugin, Na = Ke.Provider, Ta = Zt.ProviderViews, Ra = xa.h, Fa = (Ea = Pa = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "Box", Na.initPlugin(Oa(r3), n3), r3.title = r3.opts.title || "Box", r3.icon = function() {
        return Ra("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, Ra("g", { fill: "none", fillRule: "evenodd" }, Ra("rect", { className: "uppy-ProviderIconBg", fill: "#0061D5", width: "32", height: "32", rx: "16" }), Ra("g", { fill: "#fff", fillRule: "nonzero" }, Ra("path", { d: "m16.4 13.5c-1.6 0-3 0.9-3.7 2.2-0.7-1.3-2.1-2.2-3.7-2.2-1 0-1.8 0.3-2.5 0.8v-3.6c-0.1-0.3-0.5-0.7-1-0.7s-0.8 0.4-0.8 0.8v7c0 2.3 1.9 4.2 4.2 4.2 1.6 0 3-0.9 3.7-2.2 0.7 1.3 2.1 2.2 3.7 2.2 2.3 0 4.2-1.9 4.2-4.2 0.1-2.4-1.8-4.3-4.1-4.3m-7.5 6.8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5m7.5 0c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5" }), Ra("path", { d: "m27.2 20.6l-2.3-2.8 2.3-2.8c0.3-0.4 0.2-0.9-0.2-1.2s-1-0.2-1.3 0.2l-2 2.4-2-2.4c-0.3-0.4-0.9-0.4-1.3-0.2-0.4 0.3-0.5 0.8-0.2 1.2l2.3 2.8-2.3 2.8c-0.3 0.4-0.2 0.9 0.2 1.2s1 0.2 1.3-0.2l2-2.4 2 2.4c0.3 0.4 0.9 0.4 1.3 0.2 0.4-0.3 0.4-0.8 0.2-1.2" }))));
      }, r3.provider = new Na(t3, { companionUrl: r3.opts.companionUrl, companionHeaders: r3.opts.companionHeaders || r3.opts.serverHeaders, companionKeysParams: r3.opts.companionKeysParams, companionCookiesRule: r3.opts.companionCookiesRule, provider: "box", pluginId: r3.id }), r3.onFirstRender = r3.onFirstRender.bind(Oa(r3)), r3.render = r3.render.bind(Oa(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Aa(t2, n2);
    var o2 = r2.prototype;
    return o2.install = function() {
      this.view = new Ta(this, { provider: this.provider });
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.view.tearDown(), this.unmount();
    }, o2.onFirstRender = function() {
      return this.view.getFolder();
    }, o2.render = function(e3) {
      return this.view.render(e3);
    }, r2;
  }(Ua), Pa.VERSION = "0.3.12", Ea), Da = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    Da.exports = N2;
  }(), Da = Da.exports;
  var Ma, Ba;
  function Ia(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function La(e2, t2) {
    return (La = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var ja = ue.Plugin, za = Ke.Provider, Ha = Zt.ProviderViews, Wa = Da.h, Va = (Ba = Ma = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "Facebook", za.initPlugin(Ia(r3), n3), r3.title = r3.opts.title || "Facebook", r3.icon = function() {
        return Wa("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, Wa("g", { fill: "none", fillRule: "evenodd" }, Wa("rect", { className: "uppy-ProviderIconBg", width: "32", height: "32", rx: "16", fill: "#3C5A99" }), Wa("path", { d: "M17.842 26v-8.667h2.653l.398-3.377h-3.051v-2.157c0-.978.248-1.644 1.527-1.644H21V7.132A19.914 19.914 0 0 0 18.623 7c-2.352 0-3.963 1.574-3.963 4.465v2.49H12v3.378h2.66V26h3.182z", fill: "#FFF", fillRule: "nonzero" })));
      }, r3.provider = new za(t3, { companionUrl: r3.opts.companionUrl, companionHeaders: r3.opts.companionHeaders || r3.opts.serverHeaders, companionKeysParams: r3.opts.companionKeysParams, companionCookiesRule: r3.opts.companionCookiesRule, provider: "facebook", pluginId: r3.id }), r3.onFirstRender = r3.onFirstRender.bind(Ia(r3)), r3.render = r3.render.bind(Ia(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, La(t2, n2);
    var o2 = r2.prototype;
    return o2.install = function() {
      this.view = new Ha(this, { provider: this.provider });
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.view.tearDown(), this.unmount();
    }, o2.onFirstRender = function() {
      return Promise.all([this.provider.fetchPreAuthToken(), this.view.getFolder()]);
    }, o2.render = function(e3) {
      var t3 = {};
      return this.getPluginState().files.length && !this.getPluginState().folders.length && (t3.viewType = "grid", t3.showFilter = false, t3.showTitles = false), this.view.render(e3, t3);
    }, r2;
  }(ja), Ma.VERSION = "1.2.2", Ba), qa = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    qa.exports = N2;
  }(), qa = qa.exports;
  var Xa, Ga;
  function Ya() {
    return (Ya = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function $a(e2, t2) {
    return ($a = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Ka = ue.Plugin, Ja = qa.h, Qa = Ke.SearchProvider, Za = Zt.SearchProviderViews, es = (Ga = Xa = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      if ((r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "Unsplash", r3.title = r3.opts.title || "Unsplash", r3.type = "acquirer", r3.icon = function() {
        return Ja("svg", { viewBox: "0 0 32 32", height: "32", width: "32", "aria-hidden": "true" }, Ja("path", { d: "M46.575 10.883v-9h12v9zm12 5h10v18h-32v-18h10v9h12z", fill: "#fff" }), Ja("rect", { className: "uppy-ProviderIconBg", width: "32", height: "32", rx: "16" }), Ja("path", { d: "M13 12.5V8h6v4.5zm6 2.5h5v9H8v-9h5v4.5h6z", fill: "#fff" }));
      }, r3.opts = Ya({}, {}, n3), r3.hostname = r3.opts.companionUrl, !r3.hostname) throw new Error("Companion hostname is required, please consult https://uppy.io/docs/companion");
      return r3.provider = new Qa(t3, { companionUrl: r3.opts.companionUrl, companionHeaders: r3.opts.companionHeaders, companionCookiesRule: r3.opts.companionCookiesRule, provider: "unsplash", pluginId: r3.id }), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, $a(t2, n2);
    var o2 = r2.prototype;
    return o2.install = function() {
      this.view = new Za(this, { provider: this.provider });
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.onFirstRender = function() {
    }, o2.render = function(e3) {
      return this.view.render(e3);
    }, o2.uninstall = function() {
      this.unmount();
    }, r2;
  }(Ka), Xa.VERSION = "0.1.13", Ga), ts = { exports: {} };
  function ns(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function rs(e2, t2) {
    return (rs = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    ts.exports = N2;
  }();
  var os, is, as = (ts = ts.exports).h, ss = function(e2) {
    var t2, n2;
    function r2(t3) {
      var n3;
      return (n3 = e2.call(this, t3) || this).handleKeyPress = n3.handleKeyPress.bind(ns(n3)), n3.handleClick = n3.handleClick.bind(ns(n3)), n3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, rs(t2, n2);
    var o2 = r2.prototype;
    return o2.componentDidMount = function() {
      this.input.value = "";
    }, o2.handleKeyPress = function(e3) {
      13 === e3.keyCode && this.props.addFile(this.input.value);
    }, o2.handleClick = function() {
      this.props.addFile(this.input.value);
    }, o2.render = function() {
      var e3 = this;
      return as("div", { className: "uppy-Url" }, as("input", { className: "uppy-u-reset uppy-c-textInput uppy-Url-input", type: "text", "aria-label": this.props.i18n("enterUrlToImport"), placeholder: this.props.i18n("enterUrlToImport"), onKeyUp: this.handleKeyPress, ref: function(t3) {
        e3.input = t3;
      }, "data-uppy-super-focusable": true }), as("button", { className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Url-importButton", type: "button", onClick: this.handleClick }, this.props.i18n("import")));
    }, r2;
  }(ts.Component), ls = function(e2, t2, n2) {
    var r2, o2 = Co(e2.items);
    switch (t2) {
      case "paste":
        if (o2.some(function(e3) {
          return "file" === e3.kind;
        })) return;
        r2 = o2.filter(function(e3) {
          return "string" === e3.kind && "text/plain" === e3.type;
        });
        break;
      case "drop":
        r2 = o2.filter(function(e3) {
          return "string" === e3.kind && "text/uri-list" === e3.type;
        });
        break;
      default:
        throw new Error("isDropOrPaste must be either 'drop' or 'paste', but it's " + t2);
    }
    r2.forEach(function(e3) {
      e3.getAsString(function(e4) {
        return n2(e4);
      });
    });
  };
  function us() {
    return (us = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function cs(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function ps(e2, t2) {
    return (ps = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var ds = ue.Plugin, hs = ts.h, fs = Ke.RequestClient;
  function ms() {
    return hs("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, hs("g", { fill: "none", fillRule: "evenodd" }, hs("rect", { className: "uppy-ProviderIconBg", fill: "#FF753E", width: "32", height: "32", rx: "16" }), hs("path", { d: "M22.788 15.389l-2.199 2.19a3.184 3.184 0 0 1-.513.437c-.806.584-1.686.876-2.638.876a4.378 4.378 0 0 1-3.519-1.752c-.22-.292-.146-.802.147-1.021.293-.22.806-.146 1.026.146.953 1.313 2.785 1.532 4.105.583a.571.571 0 0 0 .293-.292l2.199-2.189c1.1-1.167 1.1-2.992-.073-4.086a2.976 2.976 0 0 0-4.105 0l-1.246 1.24a.71.71 0 0 1-1.026 0 .703.703 0 0 1 0-1.022l1.246-1.24a4.305 4.305 0 0 1 6.083 0c1.833 1.605 1.906 4.451.22 6.13zm-7.183 5.035l-1.246 1.24a2.976 2.976 0 0 1-4.105 0c-1.172-1.094-1.172-2.991-.073-4.086l2.2-2.19.292-.291c.66-.438 1.393-.657 2.2-.584.805.146 1.465.51 1.905 1.168.22.292.733.365 1.026.146.293-.22.367-.73.147-1.022-.733-.949-1.76-1.532-2.859-1.678-1.1-.22-2.272.073-3.225.802l-.44.438-2.199 2.19c-1.686 1.75-1.612 4.524.074 6.202.88.803 1.979 1.241 3.078 1.241 1.1 0 2.199-.438 3.079-1.24l1.246-1.241a.703.703 0 0 0 0-1.022c-.294-.292-.807-.365-1.1-.073z", fill: "#FFF", fillRule: "nonzero" })));
  }
  var vs = (is = os = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      if ((r3 = e2.call(this, t3, n3) || this).id = r3.opts.id || "Url", r3.title = r3.opts.title || "Link", r3.type = "acquirer", r3.icon = function() {
        return hs(ms, null);
      }, r3.defaultLocale = { strings: { import: "Import", enterUrlToImport: "Enter URL to import a file", failedToFetch: "Companion failed to fetch this URL, please make sure it\u2019s correct", enterCorrectUrl: "Incorrect URL: Please make sure you are entering a direct link to a file" } }, r3.opts = us({}, {}, n3), r3.i18nInit(), r3.hostname = r3.opts.companionUrl, !r3.hostname) throw new Error("Companion hostname is required, please consult https://uppy.io/docs/companion");
      return r3.getMeta = r3.getMeta.bind(cs(r3)), r3.addFile = r3.addFile.bind(cs(r3)), r3.handleRootDrop = r3.handleRootDrop.bind(cs(r3)), r3.handleRootPaste = r3.handleRootPaste.bind(cs(r3)), r3.client = new fs(t3, { companionUrl: r3.opts.companionUrl, companionHeaders: r3.opts.companionHeaders || r3.opts.serverHeaders, companionCookiesRule: r3.opts.companionCookiesRule }), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, ps(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, t3), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.i18nArray = this.translator.translateArray.bind(this.translator), this.setPluginState();
    }, o2.getFileNameFromUrl = function(e3) {
      return e3.substring(e3.lastIndexOf("/") + 1);
    }, o2.checkIfCorrectURL = function(e3) {
      if (!e3) return false;
      var t3 = e3.match(/^([a-z0-9]+):\/\//)[1];
      return "http" === t3 || "https" === t3;
    }, o2.addProtocolToURL = function(e3) {
      return /^[a-z0-9]+:\/\//.test(e3) ? e3 : "http://" + e3;
    }, o2.getMeta = function(e3) {
      var t3 = this;
      return this.client.post("url/meta", { url: e3 }).then(function(e4) {
        if (e4.error) throw t3.uppy.log("[URL] Error:"), t3.uppy.log(e4.error), new Error("Failed to fetch the file");
        return e4;
      });
    }, o2.addFile = function(e3) {
      var t3 = this;
      return e3 = this.addProtocolToURL(e3), this.checkIfCorrectURL(e3) ? this.getMeta(e3).then(function(n3) {
        return { source: t3.id, name: t3.getFileNameFromUrl(e3), type: n3.type, data: { size: n3.size }, isRemote: true, body: { url: e3 }, remote: { companionUrl: t3.opts.companionUrl, url: t3.hostname + "/url/get", body: { fileId: e3, url: e3 }, providerOptions: t3.client.opts } };
      }).then(function(e4) {
        t3.uppy.log("[Url] Adding remote file");
        try {
          return t3.uppy.addFile(e4);
        } catch (wd2) {
          return wd2.isRestriction || t3.uppy.log(wd2), wd2;
        }
      }).catch(function(e4) {
        return t3.uppy.log(e4), t3.uppy.info({ message: t3.i18n("failedToFetch"), details: e4 }, "error", 4e3), e4;
      }) : (this.uppy.log("[URL] Incorrect URL entered: " + e3), void this.uppy.info(this.i18n("enterCorrectUrl"), "error", 4e3));
    }, o2.handleRootDrop = function(e3) {
      var t3 = this;
      ls(e3.dataTransfer, "drop", function(e4) {
        t3.uppy.log("[URL] Adding file from dropped url: " + e4), t3.addFile(e4);
      });
    }, o2.handleRootPaste = function(e3) {
      var t3 = this;
      ls(e3.clipboardData, "paste", function(e4) {
        t3.uppy.log("[URL] Adding file from pasted url: " + e4), t3.addFile(e4);
      });
    }, o2.render = function(e3) {
      return hs(ss, { i18n: this.i18n, addFile: this.addFile });
    }, o2.install = function() {
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.unmount();
    }, r2;
  }(ds), os.VERSION = "1.5.23", is), gs = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    gs.exports = N2;
  }(), gs = gs.exports;
  var ys = { "audio/mp3": "mp3", "audio/mp4": "mp4", "audio/ogg": "ogg", "audio/webm": "webm", "image/gif": "gif", "image/heic": "heic", "image/heif": "heif", "image/jpeg": "jpg", "image/png": "png", "image/svg+xml": "svg", "video/mp4": "mp4", "video/ogg": "ogv", "video/quicktime": "mov", "video/webm": "webm", "video/x-matroska": "mkv", "video/x-msvideo": "avi" }, bs = function(e2) {
    return e2 = e2.replace(/;.*$/, ""), ys[e2] || null;
  }, _s = gs.h, ws = function(e2) {
    return _s("svg", { "aria-hidden": "true", focusable: "false", fill: "#0097DC", width: "66", height: "55", viewBox: "0 0 66 55" }, _s("path", { d: "M57.3 8.433c4.59 0 8.1 3.51 8.1 8.1v29.7c0 4.59-3.51 8.1-8.1 8.1H8.7c-4.59 0-8.1-3.51-8.1-8.1v-29.7c0-4.59 3.51-8.1 8.1-8.1h9.45l4.59-7.02c.54-.54 1.35-1.08 2.16-1.08h16.2c.81 0 1.62.54 2.16 1.08l4.59 7.02h9.45zM33 14.64c-8.62 0-15.393 6.773-15.393 15.393 0 8.62 6.773 15.393 15.393 15.393 8.62 0 15.393-6.773 15.393-15.393 0-8.62-6.773-15.393-15.393-15.393zM33 40c-5.648 0-9.966-4.319-9.966-9.967 0-5.647 4.318-9.966 9.966-9.966s9.966 4.319 9.966 9.966C42.966 35.681 38.648 40 33 40z", fillRule: "evenodd" }));
  }, Cs = gs.h, Ss = function(e2) {
    var t2 = e2.onSnapshot, n2 = e2.i18n;
    return Cs("button", { className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--picture", type: "button", title: n2("takePicture"), "aria-label": n2("takePicture"), onClick: t2, "data-uppy-super-focusable": true }, ws());
  }, ks = gs.h, xs = function(e2) {
    var t2 = e2.recording, n2 = e2.onStartRecording, r2 = e2.onStopRecording, o2 = e2.i18n;
    return t2 ? ks("button", { className: "uppy-u-reset uppy-c-btn uppy-Webcam-button", type: "button", title: o2("stopRecording"), "aria-label": o2("stopRecording"), onClick: r2, "data-uppy-super-focusable": true }, ks("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "100", height: "100", viewBox: "0 0 100 100" }, ks("rect", { x: "15", y: "15", width: "70", height: "70" }))) : ks("button", { className: "uppy-u-reset uppy-c-btn uppy-Webcam-button", type: "button", title: o2("startRecording"), "aria-label": o2("startRecording"), onClick: n2, "data-uppy-super-focusable": true }, ks("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "100", height: "100", viewBox: "0 0 100 100" }, ks("circle", { cx: "50", cy: "50", r: "40" })));
  }, Ps = gs.h, Es = function(e2) {
    var t2, n2 = e2.recordingLengthSeconds, r2 = e2.i18n, o2 = (t2 = n2, Math.floor(t2 / 60) + ":" + String(t2 % 60).padStart(2, 0));
    return Ps("span", { "aria-label": r2("recordingLength", { recording_length: o2 }) }, o2);
  }, Os = gs.h, As = gs.h, Us = function(e2) {
    var t2 = e2.onSubmit, n2 = e2.i18n;
    return As("button", { className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--submit", type: "button", title: n2("submitRecordedFile"), "aria-label": n2("submitRecordedFile"), onClick: t2, "data-uppy-super-focusable": true }, As("svg", { width: "12", height: "9", viewBox: "0 0 12 9", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "uppy-c-icon" }, As("path", { fill: "#fff", fillRule: "nonzero", d: "M10.66 0L12 1.31 4.136 9 0 4.956l1.34-1.31L4.136 6.38z" })));
  }, Ns = gs.h, Ts = function(e2) {
    var t2 = e2.onDiscard, n2 = e2.i18n;
    return Ns("button", { className: "uppy-u-reset uppy-c-btn uppy-Webcam-button", type: "button", title: n2("discardRecordedFile"), "aria-label": n2("discardRecordedFile"), onClick: t2, "data-uppy-super-focusable": true }, Ns("svg", { width: "13", height: "13", viewBox: "0 0 13 13", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "uppy-c-icon" }, Ns("g", { fill: "#FFF", fillRule: "evenodd" }, Ns("path", { d: "M.496 11.367L11.103.76l1.414 1.414L1.911 12.781z" }), Ns("path", { d: "M11.104 12.782L.497 2.175 1.911.76l10.607 10.606z" }))));
  };
  function Rs() {
    return (Rs = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Fs(e2, t2) {
    return (Fs = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Ds = gs.h;
  function Ms(e2, t2) {
    return -1 !== e2.indexOf(t2);
  }
  var Bs, Is, Ls = function(e2) {
    var t2, n2;
    function r2() {
      return e2.apply(this, arguments) || this;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Fs(t2, n2);
    var o2 = r2.prototype;
    return o2.componentDidMount = function() {
      (0, this.props.onFocus)();
    }, o2.componentWillUnmount = function() {
      (0, this.props.onStop)();
    }, o2.render = function() {
      var e3 = this, t3 = this.props, n3 = t3.src, r3 = t3.recordedVideo, o3 = t3.recording, i2 = t3.modes, a2 = t3.supportsRecording, s2 = t3.videoSources, l2 = t3.showVideoSourceDropdown, u2 = t3.showRecordingLength, c2 = t3.onSubmit, p2 = t3.i18n, d2 = t3.mirror, h2 = t3.onSnapshot, f2 = t3.onStartRecording, m2 = t3.onStopRecording, v2 = t3.onDiscardRecordedVideo, g2 = t3.recordingLengthSeconds, y2 = !!r3, b2 = !y2 && a2 && (Ms(i2, "video-only") || Ms(i2, "audio-only") || Ms(i2, "video-audio")), _2 = !y2 && Ms(i2, "picture"), w2 = a2 && u2, C2 = l2 && s2 && s2.length > 1, S2 = { playsinline: true };
      return r3 ? (S2.muted = false, S2.controls = true, S2.src = r3, this.videoElement && (this.videoElement.srcObject = void 0)) : (S2.muted = true, S2.autoplay = true, S2.srcObject = n3), Ds("div", { className: "uppy uppy-Webcam-container" }, Ds("div", { className: "uppy-Webcam-videoContainer" }, Ds("video", Rs({ ref: function(t4) {
        return e3.videoElement = t4;
      }, className: "uppy-Webcam-video  " + (d2 ? "uppy-Webcam-video--mirrored" : "") }, S2))), Ds("div", { className: "uppy-Webcam-footer" }, Ds("div", { className: "uppy-Webcam-videoSourceContainer" }, C2 ? function(e4) {
        var t4 = e4.currentDeviceId, n4 = e4.videoSources, r4 = e4.onChangeVideoSource;
        return Os("div", { className: "uppy-Webcam-videoSource" }, Os("select", { className: "uppy-u-reset uppy-Webcam-videoSource-select", onChange: function(e5) {
          r4(e5.target.value);
        } }, n4.map(function(e5) {
          return Os("option", { key: e5.deviceId, value: e5.deviceId, selected: e5.deviceId === t4 }, e5.label);
        })));
      }(this.props) : null), Ds("div", { className: "uppy-Webcam-buttonContainer" }, _2 && Ds(Ss, { onSnapshot: h2, i18n: p2 }), b2 && Ds(xs, { recording: o3, onStartRecording: f2, onStopRecording: m2, i18n: p2 }), y2 && Ds(Us, { onSubmit: c2, i18n: p2 }), y2 && Ds(Ts, { onDiscard: v2, i18n: p2 })), w2 && Ds("div", { className: "uppy-Webcam-recordingLength" }, Ds(Es, { recordingLengthSeconds: g2, i18n: p2 }))));
    }, r2;
  }(gs.Component), js = gs.h, zs = function(e2) {
    return js("div", { className: "uppy-Webcam-permissons" }, js("div", { className: "uppy-Webcam-permissonsIcon" }, e2.icon()), js("h1", { className: "uppy-Webcam-title" }, e2.hasCamera ? e2.i18n("allowAccessTitle") : e2.i18n("noCameraTitle")), js("p", null, e2.hasCamera ? e2.i18n("allowAccessDescription") : e2.i18n("noCameraDescription")));
  };
  function Hs() {
    return (Hs = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Ws(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Vs(e2, t2) {
    return (Vs = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var qs = gs.h;
  function Xs(e2) {
    return "." === e2[0] ? K[e2.slice(1)] : e2;
  }
  function Gs(e2) {
    return /^video\/[^*]+$/.test(e2);
  }
  function Ys(e2) {
    return /^image\/[^*]+$/.test(e2);
  }
  var $s = (Is = Bs = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      (r3 = e2.call(this, t3, n3) || this).mediaDevices = function() {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) return navigator.mediaDevices;
        var e3 = navigator.mozGetUserMedia || navigator.webkitGetUserMedia;
        return e3 ? { getUserMedia: function(t4) {
          return new Promise(function(n4, r4) {
            e3.call(navigator, t4, n4, r4);
          });
        } } : null;
      }(), r3.supportsUserMedia = !!r3.mediaDevices, r3.protocol = location.protocol.match(/https/i) ? "https" : "http", r3.id = r3.opts.id || "Webcam", r3.title = r3.opts.title || "Camera", r3.type = "acquirer", r3.capturedMediaFile = null, r3.icon = function() {
        return qs("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, qs("g", { fill: "none", fillRule: "evenodd" }, qs("rect", { className: "uppy-ProviderIconBg", fill: "#03BFEF", width: "32", height: "32", rx: "16" }), qs("path", { d: "M22 11c1.133 0 2 .867 2 2v7.333c0 1.134-.867 2-2 2H10c-1.133 0-2-.866-2-2V13c0-1.133.867-2 2-2h2.333l1.134-1.733C13.6 9.133 13.8 9 14 9h4c.2 0 .4.133.533.267L19.667 11H22zm-6 1.533a3.764 3.764 0 0 0-3.8 3.8c0 2.129 1.672 3.801 3.8 3.801s3.8-1.672 3.8-3.8c0-2.13-1.672-3.801-3.8-3.801zm0 6.261c-1.395 0-2.46-1.066-2.46-2.46 0-1.395 1.065-2.461 2.46-2.461s2.46 1.066 2.46 2.46c0 1.395-1.065 2.461-2.46 2.461z", fill: "#FFF", fillRule: "nonzero" })));
      }, r3.defaultLocale = { strings: { smile: "Smile!", takePicture: "Take a picture", startRecording: "Begin video recording", stopRecording: "Stop video recording", allowAccessTitle: "Please allow access to your camera", allowAccessDescription: "In order to take pictures or record video with your camera, please allow camera access for this site.", noCameraTitle: "Camera Not Available", noCameraDescription: "In order to take pictures or record video, please connect a camera device", recordingStoppedMaxSize: "Recording stopped because the file size is about to exceed the limit", recordingLength: "Recording length %{recording_length}", submitRecordedFile: "Submit recorded file", discardRecordedFile: "Discard recorded file" } };
      var o3 = { onBeforeSnapshot: function() {
        return Promise.resolve();
      }, countdown: false, modes: ["video-audio", "video-only", "audio-only", "picture"], mirror: true, showVideoSourceDropdown: false, facingMode: "user", preferredImageMimeType: null, preferredVideoMimeType: null, showRecordingLength: false };
      return r3.opts = Hs({}, o3, n3), r3.i18nInit(), r3.install = r3.install.bind(Ws(r3)), r3.setPluginState = r3.setPluginState.bind(Ws(r3)), r3.render = r3.render.bind(Ws(r3)), r3.start = r3.start.bind(Ws(r3)), r3.stop = r3.stop.bind(Ws(r3)), r3.takeSnapshot = r3.takeSnapshot.bind(Ws(r3)), r3.startRecording = r3.startRecording.bind(Ws(r3)), r3.stopRecording = r3.stopRecording.bind(Ws(r3)), r3.discardRecordedVideo = r3.discardRecordedVideo.bind(Ws(r3)), r3.submit = r3.submit.bind(Ws(r3)), r3.oneTwoThreeSmile = r3.oneTwoThreeSmile.bind(Ws(r3)), r3.focus = r3.focus.bind(Ws(r3)), r3.changeVideoSource = r3.changeVideoSource.bind(Ws(r3)), r3.webcamActive = false, r3.opts.countdown && (r3.opts.onBeforeSnapshot = r3.oneTwoThreeSmile), r3.setPluginState({ hasCamera: false, cameraReady: false, cameraError: null, recordingLengthSeconds: 0, videoSources: [], currentDeviceId: null }), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Vs(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, Hs({}, t3, { videoConstraints: Hs({}, this.opts.videoConstraints, null == t3 ? void 0 : t3.videoConstraints) })), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.i18nArray = this.translator.translateArray.bind(this.translator), this.setPluginState();
    }, o2.hasCameraCheck = function() {
      return this.mediaDevices ? this.mediaDevices.enumerateDevices().then(function(e3) {
        return e3.some(function(e4) {
          return "videoinput" === e4.kind;
        });
      }) : Promise.resolve(false);
    }, o2.isAudioOnly = function() {
      return 1 === this.opts.modes.length && "audio-only" === this.opts.modes[0];
    }, o2.getConstraints = function(e3) {
      var t3;
      void 0 === e3 && (e3 = null);
      var n3 = -1 !== this.opts.modes.indexOf("video-audio") || -1 !== this.opts.modes.indexOf("audio-only"), r3 = !this.isAudioOnly() && (-1 !== this.opts.modes.indexOf("video-audio") || -1 !== this.opts.modes.indexOf("video-only") || -1 !== this.opts.modes.indexOf("picture")), o3 = Hs({}, null != (t3 = this.opts.videoConstraints) ? t3 : { facingMode: this.opts.facingMode }, e3 ? { deviceId: e3, facingMode: null } : {});
      return { audio: n3, video: !!r3 && o3 };
    }, o2.start = function(e3) {
      var t3 = this;
      if (void 0 === e3 && (e3 = null), !this.supportsUserMedia) return Promise.reject(new Error("Webcam access not supported"));
      this.webcamActive = true, this.opts.mirror = true;
      var n3 = this.getConstraints(e3 && e3.deviceId ? e3.deviceId : null);
      this.hasCameraCheck().then(function(r3) {
        return t3.setPluginState({ hasCamera: r3 }), t3.mediaDevices.getUserMedia(n3).then(function(n4) {
          t3.stream = n4;
          var r4 = null, o3 = t3.isAudioOnly() ? n4.getAudioTracks() : n4.getVideoTracks();
          e3 && e3.deviceId ? o3.forEach(function(t4) {
            t4.getSettings().deviceId === e3.deviceId && (r4 = t4.getSettings().deviceId);
          }) : r4 = o3[0].getSettings().deviceId, t3.updateVideoSources(), t3.setPluginState({ currentDeviceId: r4, cameraReady: true });
        }).catch(function(e4) {
          t3.setPluginState({ cameraReady: false, cameraError: e4 }), t3.uppy.info(e4.message, "error");
        });
      });
    }, o2.getMediaRecorderOptions = function() {
      var e3 = {};
      if (MediaRecorder.isTypeSupported) {
        var t3 = this.uppy.opts.restrictions, n3 = [];
        this.opts.preferredVideoMimeType ? n3 = [this.opts.preferredVideoMimeType] : t3.allowedFileTypes && (n3 = t3.allowedFileTypes.map(Xs).filter(Gs));
        var r3 = n3.filter(function(e4) {
          return MediaRecorder.isTypeSupported(e4) && bs(e4);
        });
        r3.length > 0 && (e3.mimeType = r3[0]);
      }
      return e3;
    }, o2.startRecording = function() {
      var e3 = this;
      this.recorder = new MediaRecorder(this.stream, this.getMediaRecorderOptions()), this.recordingChunks = [];
      var t3 = false;
      this.recorder.addEventListener("dataavailable", function(n3) {
        e3.recordingChunks.push(n3.data);
        var r3 = e3.uppy.opts.restrictions;
        if (e3.recordingChunks.length > 1 && null != r3.maxFileSize && !t3) {
          var o3 = e3.recordingChunks.reduce(function(e4, t4) {
            return e4 + t4.size;
          }, 0), i2 = (o3 - e3.recordingChunks[0].size) / (e3.recordingChunks.length - 1) * 3;
          o3 > Math.max(0, r3.maxFileSize - i2) && (t3 = true, e3.uppy.info(e3.i18n("recordingStoppedMaxSize"), "warning", 4e3), e3.stopRecording());
        }
      }), this.recorder.start(500), this.opts.showRecordingLength && (this.recordingLengthTimer = setInterval(function() {
        var t4 = e3.getPluginState().recordingLengthSeconds;
        e3.setPluginState({ recordingLengthSeconds: t4 + 1 });
      }, 1e3)), this.setPluginState({ isRecording: true });
    }, o2.stopRecording = function() {
      var e3 = this;
      return new Promise(function(t3) {
        e3.recorder.addEventListener("stop", function() {
          t3();
        }), e3.recorder.stop(), e3.opts.showRecordingLength && (clearInterval(e3.recordingLengthTimer), e3.setPluginState({ recordingLengthSeconds: 0 }));
      }).then(function() {
        return e3.setPluginState({ isRecording: false }), e3.getVideo();
      }).then(function(t3) {
        try {
          e3.capturedMediaFile = t3, e3.setPluginState({ recordedVideo: URL.createObjectURL(t3.data) }), e3.opts.mirror = false;
        } catch (wd2) {
          wd2.isRestriction || e3.uppy.log(wd2);
        }
      }).then(function() {
        e3.recordingChunks = null, e3.recorder = null;
      }, function(t3) {
        throw e3.recordingChunks = null, e3.recorder = null, t3;
      });
    }, o2.discardRecordedVideo = function() {
      this.setPluginState({ recordedVideo: null }), this.opts.mirror = true, this.capturedMediaFile = null;
    }, o2.submit = function() {
      try {
        this.capturedMediaFile && this.uppy.addFile(this.capturedMediaFile);
      } catch (wd2) {
        wd2.isRestriction || this.uppy.log(wd2, "error");
      }
    }, o2.stop = function() {
      this.stream && (this.stream.getAudioTracks().forEach(function(e3) {
        e3.stop();
      }), this.stream.getVideoTracks().forEach(function(e3) {
        e3.stop();
      })), this.webcamActive = false, this.stream = null, this.setPluginState({ recordedVideo: null });
    }, o2.getVideoElement = function() {
      return this.el.querySelector(".uppy-Webcam-video");
    }, o2.oneTwoThreeSmile = function() {
      var e3 = this;
      return new Promise(function(t3, n3) {
        var r3 = e3.opts.countdown, o3 = setInterval(function() {
          if (!e3.webcamActive) return clearInterval(o3), e3.captureInProgress = false, n3(new Error("Webcam is not active"));
          r3 > 0 ? (e3.uppy.info(r3 + "...", "warning", 800), r3--) : (clearInterval(o3), e3.uppy.info(e3.i18n("smile"), "success", 1500), setTimeout(function() {
            return t3();
          }, 1500));
        }, 1e3);
      });
    }, o2.takeSnapshot = function() {
      var e3 = this;
      this.captureInProgress || (this.captureInProgress = true, this.opts.onBeforeSnapshot().catch(function(t3) {
        var n3 = "object" == typeof t3 ? t3.message : t3;
        return e3.uppy.info(n3, "error", 5e3), Promise.reject(new Error("onBeforeSnapshot: " + n3));
      }).then(function() {
        return e3.getImage();
      }).then(function(t3) {
        e3.captureInProgress = false;
        try {
          e3.uppy.addFile(t3);
        } catch (wd2) {
          wd2.isRestriction || e3.uppy.log(wd2);
        }
      }, function(t3) {
        throw e3.captureInProgress = false, t3;
      }));
    }, o2.getImage = function() {
      var e3 = this, t3 = this.getVideoElement();
      if (!t3) return Promise.reject(new Error("No video element found, likely due to the Webcam tab being closed."));
      var n3 = t3.videoWidth, r3 = t3.videoHeight, o3 = document.createElement("canvas");
      o3.width = n3, o3.height = r3, o3.getContext("2d").drawImage(t3, 0, 0);
      var i2 = this.uppy.opts.restrictions, a2 = [];
      this.opts.preferredImageMimeType ? a2 = [this.opts.preferredImageMimeType] : i2.allowedFileTypes && (a2 = i2.allowedFileTypes.map(Xs).filter(Ys));
      var s2 = a2[0] || "image/jpeg", l2 = bs(s2) || "jpg", u2 = "cam-" + Date.now() + "." + l2;
      return function(e4, t4, n4) {
        return e4.toBlob ? new Promise(function(r4) {
          e4.toBlob(r4, t4, n4);
        }) : Promise.resolve().then(function() {
          return to(e4.toDataURL(t4, n4), {});
        });
      }(o3, s2).then(function(t4) {
        return { source: e3.id, name: u2, data: new Blob([t4], { type: s2 }), type: s2 };
      });
    }, o2.getVideo = function() {
      var e3 = this.recordingChunks.find(function(e4) {
        var t4;
        return (null == (t4 = e4.type) ? void 0 : t4.length) > 0;
      }).type, t3 = bs(e3);
      if (!t3) return Promise.reject(new Error('Could not retrieve recording: Unsupported media type "' + e3 + '"'));
      var n3 = "webcam-" + Date.now() + "." + t3, r3 = new Blob(this.recordingChunks, { type: e3 }), o3 = { source: this.id, name: n3, data: new Blob([r3], { type: e3 }), type: e3 };
      return Promise.resolve(o3);
    }, o2.focus = function() {
      var e3 = this;
      this.opts.countdown && setTimeout(function() {
        e3.uppy.info(e3.i18n("smile"), "success", 1500);
      }, 1e3);
    }, o2.changeVideoSource = function(e3) {
      this.stop(), this.start({ deviceId: e3 });
    }, o2.updateVideoSources = function() {
      var e3 = this;
      this.mediaDevices.enumerateDevices().then(function(t3) {
        e3.setPluginState({ videoSources: t3.filter(function(e4) {
          return "videoinput" === e4.kind;
        }) });
      });
    }, o2.render = function() {
      this.webcamActive || this.start();
      var e3 = this.getPluginState();
      return e3.cameraReady && e3.hasCamera ? qs(Ls, Hs({}, e3, { onChangeVideoSource: this.changeVideoSource, onSnapshot: this.takeSnapshot, onStartRecording: this.startRecording, onStopRecording: this.stopRecording, onDiscardRecordedVideo: this.discardRecordedVideo, onSubmit: this.submit, onFocus: this.focus, onStop: this.stop, i18n: this.i18n, modes: this.opts.modes, showRecordingLength: this.opts.showRecordingLength, showVideoSourceDropdown: this.opts.showVideoSourceDropdown, supportsRecording: "function" == typeof MediaRecorder && !!MediaRecorder.prototype && "function" == typeof MediaRecorder.prototype.start, recording: e3.isRecording, mirror: this.opts.mirror, src: this.stream })) : qs(zs, { icon: ws, i18n: this.i18n, hasCamera: e3.hasCamera });
    }, o2.install = function() {
      var e3 = this;
      this.setPluginState({ cameraReady: false, recordingLengthSeconds: 0 });
      var t3 = this.opts.target;
      t3 && this.mount(t3, this), this.mediaDevices && (this.updateVideoSources(), this.mediaDevices.ondevicechange = function() {
        if (e3.updateVideoSources(), e3.stream) {
          var t4 = true, n3 = e3.getPluginState(), r3 = n3.videoSources, o3 = n3.currentDeviceId;
          r3.forEach(function(e4) {
            o3 === e4.deviceId && (t4 = false);
          }), t4 && (e3.stop(), e3.start());
        }
      });
    }, o2.uninstall = function() {
      this.stream && this.stop(), this.unmount();
    }, r2;
  }(ue.Plugin), Bs.VERSION = "1.8.12", Is), Ks = { exports: {} };
  !function() {
    "use strict";
    function e2() {
    }
    function t2(t3, n3) {
      var r3, o3, i3, a3, s3 = C2;
      for (a3 = arguments.length; a3-- > 2; ) w2.push(arguments[a3]);
      for (n3 && null != n3.children && (w2.length || w2.push(n3.children), delete n3.children); w2.length; ) if ((o3 = w2.pop()) && void 0 !== o3.pop) for (a3 = o3.length; a3--; ) w2.push(o3[a3]);
      else "boolean" == typeof o3 && (o3 = null), (i3 = "function" != typeof t3) && (null == o3 ? o3 = "" : "number" == typeof o3 ? o3 = String(o3) : "string" != typeof o3 && (i3 = false)), i3 && r3 ? s3[s3.length - 1] += o3 : s3 === C2 ? s3 = [o3] : s3.push(o3), r3 = i3;
      var l3 = new e2();
      return l3.nodeName = t3, l3.children = s3, l3.attributes = null == n3 ? void 0 : n3, l3.key = null == n3 ? void 0 : n3.key, void 0 !== _2.vnode && _2.vnode(l3), l3;
    }
    function n2(e3, t3) {
      for (var n3 in t3) e3[n3] = t3[n3];
      return e3;
    }
    function r2(e3) {
      !e3.__d && (e3.__d = true) && 1 == x2.push(e3) && (_2.debounceRendering || S2)(o2);
    }
    function o2() {
      var e3, t3 = x2;
      for (x2 = []; e3 = t3.pop(); ) e3.__d && g2(e3);
    }
    function i2(e3, t3) {
      return e3.__n === t3 || e3.nodeName.toLowerCase() === t3.toLowerCase();
    }
    function a2(e3) {
      var t3 = n2({}, e3.attributes);
      t3.children = e3.children;
      var r3 = e3.nodeName.defaultProps;
      if (void 0 !== r3) for (var o3 in r3) void 0 === t3[o3] && (t3[o3] = r3[o3]);
      return t3;
    }
    function s2(e3) {
      var t3 = e3.parentNode;
      t3 && t3.removeChild(e3);
    }
    function l2(e3, t3, n3, r3, o3) {
      if ("className" === t3 && (t3 = "class"), "key" === t3) ;
      else if ("ref" === t3) n3 && n3(null), r3 && r3(e3);
      else if ("class" !== t3 || o3) if ("style" === t3) {
        if (r3 && "string" != typeof r3 && "string" != typeof n3 || (e3.style.cssText = r3 || ""), r3 && "object" == typeof r3) {
          if ("string" != typeof n3) for (var i3 in n3) i3 in r3 || (e3.style[i3] = "");
          for (var i3 in r3) e3.style[i3] = "number" == typeof r3[i3] && false === k2.test(i3) ? r3[i3] + "px" : r3[i3];
        }
      } else if ("dangerouslySetInnerHTML" === t3) r3 && (e3.innerHTML = r3.__html || "");
      else if ("o" == t3[0] && "n" == t3[1]) {
        var a3 = t3 !== (t3 = t3.replace(/Capture$/, ""));
        t3 = t3.toLowerCase().substring(2), r3 ? n3 || e3.addEventListener(t3, u2, a3) : e3.removeEventListener(t3, u2, a3), (e3.__l || (e3.__l = {}))[t3] = r3;
      } else if ("list" !== t3 && "type" !== t3 && !o3 && t3 in e3) !function(e4, t4, n4) {
        try {
          e4[t4] = n4;
        } catch (r4) {
        }
      }(e3, t3, null == r3 ? "" : r3), null != r3 && false !== r3 || e3.removeAttribute(t3);
      else {
        var s3 = o3 && t3 !== (t3 = t3.replace(/^xlink:?/, ""));
        null == r3 || false === r3 ? s3 ? e3.removeAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase()) : e3.removeAttribute(t3) : "function" != typeof r3 && (s3 ? e3.setAttributeNS("http://www.w3.org/1999/xlink", t3.toLowerCase(), r3) : e3.setAttribute(t3, r3));
      }
      else e3.className = r3 || "";
    }
    function u2(e3) {
      return this.__l[e3.type](_2.event && _2.event(e3) || e3);
    }
    function c2() {
      for (var e3; e3 = P2.pop(); ) _2.afterMount && _2.afterMount(e3), e3.componentDidMount && e3.componentDidMount();
    }
    function p2(e3, t3, n3, r3, o3, u3) {
      E2++ || (O2 = null != o3 && void 0 !== o3.ownerSVGElement, A2 = null != e3 && !("__preactattr_" in e3));
      var p3 = function e4(t4, n4, r4, o4, u4) {
        var c3 = t4, p4 = O2;
        if (null != n4 && "boolean" != typeof n4 || (n4 = ""), "string" == typeof n4 || "number" == typeof n4) return t4 && void 0 !== t4.splitText && t4.parentNode && (!t4._component || u4) ? t4.nodeValue != n4 && (t4.nodeValue = n4) : (c3 = document.createTextNode(n4), t4 && (t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true))), c3.__preactattr_ = true, c3;
        var h3, m3, g3 = n4.nodeName;
        if ("function" == typeof g3) return function(e5, t5, n5, r5) {
          for (var o5 = e5 && e5._component, i3 = o5, s3 = e5, l3 = o5 && e5._componentConstructor === t5.nodeName, u5 = l3, c4 = a2(t5); o5 && !u5 && (o5 = o5.__u); ) u5 = o5.constructor === t5.nodeName;
          return o5 && u5 && (!r5 || o5._component) ? (v2(o5, c4, 3, n5, r5), e5 = o5.base) : (i3 && !l3 && (y2(i3), e5 = s3 = null), o5 = f2(t5.nodeName, c4, n5), e5 && !o5.__b && (o5.__b = e5, s3 = null), v2(o5, c4, 1, n5, r5), e5 = o5.base, s3 && e5 !== s3 && (s3._component = null, d2(s3, false))), e5;
        }(t4, n4, r4, o4);
        if (O2 = "svg" === g3 || "foreignObject" !== g3 && O2, g3 = String(g3), (!t4 || !i2(t4, g3)) && (h3 = g3, (m3 = O2 ? document.createElementNS("http://www.w3.org/2000/svg", h3) : document.createElement(h3)).__n = h3, c3 = m3, t4)) {
          for (; t4.firstChild; ) c3.appendChild(t4.firstChild);
          t4.parentNode && t4.parentNode.replaceChild(c3, t4), d2(t4, true);
        }
        var b3 = c3.firstChild, _3 = c3.__preactattr_, w3 = n4.children;
        if (null == _3) {
          _3 = c3.__preactattr_ = {};
          for (var C3 = c3.attributes, S3 = C3.length; S3--; ) _3[C3[S3].name] = C3[S3].value;
        }
        return !A2 && w3 && 1 === w3.length && "string" == typeof w3[0] && null != b3 && void 0 !== b3.splitText && null == b3.nextSibling ? b3.nodeValue != w3[0] && (b3.nodeValue = w3[0]) : (w3 && w3.length || null != b3) && function(t5, n5, r5, o5, a3) {
          var l3, u5, c4, p5, h4, f3, m4, v3, g4 = t5.childNodes, y3 = [], b4 = {}, _4 = 0, w4 = 0, C4 = g4.length, S4 = 0, k3 = n5 ? n5.length : 0;
          if (0 !== C4) for (var x3 = 0; x3 < C4; x3++) {
            var P3 = g4[x3], E3 = P3.__preactattr_;
            null != (O3 = k3 && E3 ? P3._component ? P3._component.__k : E3.key : null) ? (_4++, b4[O3] = P3) : (E3 || (void 0 !== P3.splitText ? !a3 || P3.nodeValue.trim() : a3)) && (y3[S4++] = P3);
          }
          if (0 !== k3) for (x3 = 0; x3 < k3; x3++) {
            var O3;
            if (h4 = null, null != (O3 = (p5 = n5[x3]).key)) _4 && void 0 !== b4[O3] && (h4 = b4[O3], b4[O3] = void 0, _4--);
            else if (!h4 && w4 < S4) {
              for (l3 = w4; l3 < S4; l3++) if (void 0 !== y3[l3] && (f3 = u5 = y3[l3], v3 = a3, "string" == typeof (m4 = p5) || "number" == typeof m4 ? void 0 !== f3.splitText : "string" == typeof m4.nodeName ? !f3._componentConstructor && i2(f3, m4.nodeName) : v3 || f3._componentConstructor === m4.nodeName)) {
                h4 = u5, y3[l3] = void 0, l3 === S4 - 1 && S4--, l3 === w4 && w4++;
                break;
              }
            }
            h4 = e4(h4, p5, r5, o5), c4 = g4[x3], h4 && h4 !== t5 && h4 !== c4 && (null == c4 ? t5.appendChild(h4) : h4 === c4.nextSibling ? s2(c4) : t5.insertBefore(h4, c4));
          }
          if (_4) for (var x3 in b4) void 0 !== b4[x3] && d2(b4[x3], false);
          for (; w4 <= S4; ) void 0 !== (h4 = y3[S4--]) && d2(h4, false);
        }(c3, w3, r4, o4, A2 || null != _3.dangerouslySetInnerHTML), function(e5, t5, n5) {
          var r5;
          for (r5 in n5) t5 && null != t5[r5] || null == n5[r5] || l2(e5, r5, n5[r5], n5[r5] = void 0, O2);
          for (r5 in t5) "children" === r5 || "innerHTML" === r5 || r5 in n5 && t5[r5] === ("value" === r5 || "checked" === r5 ? e5[r5] : n5[r5]) || l2(e5, r5, n5[r5], n5[r5] = t5[r5], O2);
        }(c3, n4.attributes, _3), O2 = p4, c3;
      }(e3, t3, n3, r3, u3);
      return o3 && p3.parentNode !== o3 && o3.appendChild(p3), --E2 || (A2 = false, u3 || c2()), p3;
    }
    function d2(e3, t3) {
      var n3 = e3._component;
      n3 ? y2(n3) : (null != e3.__preactattr_ && e3.__preactattr_.ref && e3.__preactattr_.ref(null), false !== t3 && null != e3.__preactattr_ || s2(e3), h2(e3));
    }
    function h2(e3) {
      for (e3 = e3.lastChild; e3; ) {
        var t3 = e3.previousSibling;
        d2(e3, true), e3 = t3;
      }
    }
    function f2(e3, t3, n3) {
      var r3, o3 = U2[e3.name];
      if (e3.prototype && e3.prototype.render ? (r3 = new e3(t3, n3), b2.call(r3, t3, n3)) : ((r3 = new b2(t3, n3)).constructor = e3, r3.render = m2), o3) {
        for (var i3 = o3.length; i3--; ) if (o3[i3].constructor === e3) {
          r3.__b = o3[i3].__b, o3.splice(i3, 1);
          break;
        }
      }
      return r3;
    }
    function m2(e3, t3, n3) {
      return this.constructor(e3, n3);
    }
    function v2(e3, t3, n3, o3, i3) {
      e3.__x || (e3.__x = true, (e3.__r = t3.ref) && delete t3.ref, (e3.__k = t3.key) && delete t3.key, !e3.base || i3 ? e3.componentWillMount && e3.componentWillMount() : e3.componentWillReceiveProps && e3.componentWillReceiveProps(t3, o3), o3 && o3 !== e3.context && (e3.__c || (e3.__c = e3.context), e3.context = o3), e3.__p || (e3.__p = e3.props), e3.props = t3, e3.__x = false, 0 !== n3 && (1 !== n3 && false === _2.syncComponentUpdates && e3.base ? r2(e3) : g2(e3, 1, i3)), e3.__r && e3.__r(e3));
    }
    function g2(e3, t3, r3, o3) {
      if (!e3.__x) {
        var i3, s3, l3, u3 = e3.props, h3 = e3.state, m3 = e3.context, b3 = e3.__p || u3, w3 = e3.__s || h3, C3 = e3.__c || m3, S3 = e3.base, k3 = e3.__b, x3 = S3 || k3, O3 = e3._component, A3 = false;
        if (S3 && (e3.props = b3, e3.state = w3, e3.context = C3, 2 !== t3 && e3.shouldComponentUpdate && false === e3.shouldComponentUpdate(u3, h3, m3) ? A3 = true : e3.componentWillUpdate && e3.componentWillUpdate(u3, h3, m3), e3.props = u3, e3.state = h3, e3.context = m3), e3.__p = e3.__s = e3.__c = e3.__b = null, e3.__d = false, !A3) {
          i3 = e3.render(u3, h3, m3), e3.getChildContext && (m3 = n2(n2({}, m3), e3.getChildContext()));
          var U3, N3, T2 = i3 && i3.nodeName;
          if ("function" == typeof T2) {
            var R2 = a2(i3);
            (s3 = O3) && s3.constructor === T2 && R2.key == s3.__k ? v2(s3, R2, 1, m3, false) : (U3 = s3, e3._component = s3 = f2(T2, R2, m3), s3.__b = s3.__b || k3, s3.__u = e3, v2(s3, R2, 0, m3, false), g2(s3, 1, r3, true)), N3 = s3.base;
          } else l3 = x3, (U3 = O3) && (l3 = e3._component = null), (x3 || 1 === t3) && (l3 && (l3._component = null), N3 = p2(l3, i3, m3, r3 || !S3, x3 && x3.parentNode, true));
          if (x3 && N3 !== x3 && s3 !== O3) {
            var F2 = x3.parentNode;
            F2 && N3 !== F2 && (F2.replaceChild(N3, x3), U3 || (x3._component = null, d2(x3, false)));
          }
          if (U3 && y2(U3), e3.base = N3, N3 && !o3) {
            for (var D2 = e3, M2 = e3; M2 = M2.__u; ) (D2 = M2).base = N3;
            N3._component = D2, N3._componentConstructor = D2.constructor;
          }
        }
        if (!S3 || r3 ? P2.unshift(e3) : A3 || (e3.componentDidUpdate && e3.componentDidUpdate(b3, w3, C3), _2.afterUpdate && _2.afterUpdate(e3)), null != e3.__h) for (; e3.__h.length; ) e3.__h.pop().call(e3);
        E2 || o3 || c2();
      }
    }
    function y2(e3) {
      _2.beforeUnmount && _2.beforeUnmount(e3);
      var t3 = e3.base;
      e3.__x = true, e3.componentWillUnmount && e3.componentWillUnmount(), e3.base = null;
      var n3 = e3._component;
      n3 ? y2(n3) : t3 && (t3.__preactattr_ && t3.__preactattr_.ref && t3.__preactattr_.ref(null), e3.__b = t3, s2(t3), function(e4) {
        var t4 = e4.constructor.name;
        (U2[t4] || (U2[t4] = [])).push(e4);
      }(e3), h2(t3)), e3.__r && e3.__r(null);
    }
    function b2(e3, t3) {
      this.__d = true, this.context = t3, this.props = e3, this.state = this.state || {};
    }
    var _2 = {}, w2 = [], C2 = [], S2 = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout, k2 = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, x2 = [], P2 = [], E2 = 0, O2 = false, A2 = false, U2 = {};
    n2(b2.prototype, { setState: function(e3, t3) {
      var o3 = this.state;
      this.__s || (this.__s = n2({}, o3)), n2(o3, "function" == typeof e3 ? e3(o3, this.props) : e3), t3 && (this.__h = this.__h || []).push(t3), r2(this);
    }, forceUpdate: function(e3) {
      e3 && (this.__h = this.__h || []).push(e3), g2(this, 2);
    }, render: function() {
    } });
    var N2 = { h: t2, createElement: t2, cloneElement: function(e3, r3) {
      return t2(e3.nodeName, n2(n2({}, e3.attributes), r3), arguments.length > 2 ? [].slice.call(arguments, 2) : e3.children);
    }, Component: b2, render: function(e3, t3, n3) {
      return p2(n3, e3, {}, false, t3, false);
    }, rerender: o2, options: _2 };
    Ks.exports = N2;
  }();
  var Js = (Ks = Ks.exports).h, Qs = function() {
    return Js("svg", { "aria-hidden": "true", focusable: "false", width: "32", height: "32", viewBox: "0 0 32 32" }, Js("g", { fill: "none", fillRule: "evenodd" }, Js("rect", { className: "uppy-ProviderIconBg", fill: "#2C3E50", width: "32", height: "32", rx: "16" }), Js("path", { d: "M24.182 9H7.818C6.81 9 6 9.742 6 10.667v10c0 .916.81 1.666 1.818 1.666h4.546V24h7.272v-1.667h4.546c1 0 1.809-.75 1.809-1.666l.009-10C26 9.742 25.182 9 24.182 9zM24 21H8V11h16v10z", fill: "#FFF", fillRule: "nonzero" }), Js("circle", { fill: "#FFF", cx: "16", cy: "16", r: "2" })));
  }, Zs = Ks.h, el = function(e2) {
    var t2 = e2.recording, n2 = e2.onStartRecording, r2 = e2.onStopRecording, o2 = e2.i18n;
    return t2 ? Zs("button", { className: "uppy-u-reset uppy-c-btn uppy-ScreenCapture-button uppy-ScreenCapture-button--video uppy-ScreenCapture-button--stop-rec", type: "button", title: o2("stopCapturing"), "aria-label": o2("stopCapturing"), onClick: r2, "data-uppy-super-focusable": true }, Zs("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "100", height: "100", viewBox: "0 0 100 100" }, Zs("rect", { x: "15", y: "15", width: "70", height: "70" }))) : Zs("button", { className: "uppy-u-reset uppy-c-btn uppy-ScreenCapture-button uppy-ScreenCapture-button--video", type: "button", title: o2("startCapturing"), "aria-label": o2("startCapturing"), onClick: n2, "data-uppy-super-focusable": true }, Zs("svg", { "aria-hidden": "true", focusable: "false", className: "uppy-c-icon", width: "100", height: "100", viewBox: "0 0 100 100" }, Zs("circle", { cx: "50", cy: "50", r: "40" })));
  }, tl = Ks.h, nl = function(e2) {
    var t2 = e2.recording, n2 = e2.recordedVideo, r2 = e2.onSubmit, o2 = e2.i18n;
    return n2 && !t2 ? tl("button", { className: "uppy-u-reset uppy-c-btn uppy-ScreenCapture-button uppy-ScreenCapture-button--submit", type: "button", title: o2("submitRecordedFile"), "aria-label": o2("submitRecordedFile"), onClick: r2, "data-uppy-super-focusable": true }, tl("svg", { width: "12", height: "9", viewBox: "0 0 12 9", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "uppy-c-icon" }, tl("path", { fill: "#fff", fillRule: "nonzero", d: "M10.66 0L12 1.31 4.136 9 0 4.956l1.34-1.31L4.136 6.38z" }))) : null;
  };
  function rl() {
    return (rl = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function ol(e2, t2) {
    return (ol = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var il = Ks.h, al = function(e2) {
    var t2, n2;
    function r2(t3) {
      var n3;
      return (n3 = e2.call(this, t3) || this).state = { elapsedTime: 0 }, n3.wrapperStyle = { width: "100%", height: "100%", display: "flex" }, n3.overlayStyle = { position: "absolute", width: "100%", height: "100%", background: "black", opacity: 0.7 }, n3.infoContainerStyle = { marginLeft: "auto", marginRight: "auto", marginTop: "auto", marginBottom: "auto", zIndex: 1, color: "white" }, n3.infotextStyle = { marginLeft: "auto", marginRight: "auto", marginBottom: "1rem", fontSize: "1.5rem" }, n3.timeStyle = { display: "block", fontWeight: "bold", marginLeft: "auto", marginRight: "auto", fontSize: "3rem", fontFamily: "Courier New" }, n3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, ol(t2, n2);
    var o2 = r2.prototype;
    return o2.startTimer = function() {
      this.timerTick(), this.timerRunning = true;
    }, o2.resetTimer = function() {
      clearTimeout(this.timer), this.setState({ elapsedTime: 0 }), this.timerRunning = false;
    }, o2.timerTick = function() {
      var e3 = this;
      this.timer = setTimeout(function() {
        e3.setState({ elapsedTime: e3.state.elapsedTime + 1 }), e3.timerTick();
      }, 1e3);
    }, o2.fmtMSS = function(e3) {
      return (e3 - (e3 %= 60)) / 60 + (e3 > 9 ? ":" : ":0") + e3;
    }, o2.render = function() {
      var e3 = rl({}, this.props), t3 = e3.recording, n3 = e3.i18n, r3 = this.fmtMSS(this.state.elapsedTime);
      return t3 && !this.timerRunning && this.startTimer(), !t3 && this.timerRunning && this.resetTimer(), t3 ? il("div", { style: this.wrapperStyle }, il("div", { style: this.overlayStyle }), il("div", { style: this.infoContainerStyle }, il("div", { style: this.infotextStyle }, n3("recording")), il("div", { style: this.timeStyle }, r3))) : null;
    }, r2;
  }(Ks.Component), sl = Ks.h, ll = function(e2) {
    var t2 = e2.streamActive, n2 = e2.i18n;
    return t2 ? sl("div", { title: n2("streamActive"), "aria-label": n2("streamActive"), className: "uppy-ScreenCapture-icon--stream uppy-ScreenCapture-icon--streamActive" }, sl("svg", { "aria-hidden": "true", focusable: "false", width: "24", height: "24", viewBox: "0 0 24 24" }, sl("path", { d: "M0 0h24v24H0z", opacity: ".1", fill: "none" }), sl("path", { d: "M0 0h24v24H0z", fill: "none" }), sl("path", { d: "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" }))) : sl("div", { title: n2("streamPassive"), "aria-label": n2("streamPassive"), className: "uppy-ScreenCapture-icon--stream" }, sl("svg", { "aria-hidden": "true", focusable: "false", width: "24", height: "24", viewBox: "0 0 24 24" }, sl("path", { d: "M0 0h24v24H0z", opacity: ".1", fill: "none" }), sl("path", { d: "M0 0h24v24H0z", fill: "none" }), sl("path", { d: "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z" })));
  };
  function ul() {
    return (ul = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function cl(e2, t2) {
    return (cl = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var pl, dl, hl = Ks.h, fl = function(e2) {
    var t2, n2;
    function r2() {
      return e2.apply(this, arguments) || this;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, cl(t2, n2);
    var o2 = r2.prototype;
    return o2.componentWillUnmount = function() {
      this.props.onStop();
    }, o2.render = function() {
      var e3 = this, t3 = this.props, n3 = t3.recording, r3 = t3.stream, o3 = t3.recordedVideo, i2 = { playsinline: true };
      return (n3 || !o3 && !n3) && (i2.muted = true, i2.autoplay = true, i2.srcObject = r3), o3 && !n3 && (i2.muted = false, i2.controls = true, i2.src = o3, this.videoElement && (this.videoElement.srcObject = void 0)), hl("div", { className: "uppy uppy-ScreenCapture-container" }, hl("div", { className: "uppy-ScreenCapture-videoContainer" }, hl(ll, this.props), hl("video", ul({ ref: function(t4) {
        return e3.videoElement = t4;
      }, className: "uppy-ScreenCapture-video" }, i2)), hl(al, this.props)), hl("div", { className: "uppy-ScreenCapture-buttonContainer" }, hl(el, this.props), hl(nl, this.props)));
    }, r2;
  }(Ks.Component);
  function ml() {
    return (ml = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function vl(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function gl(e2, t2) {
    return (gl = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var yl = Ks.h, bl = (dl = pl = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).mediaDevices = navigator && navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia && window && window.MediaRecorder ? navigator.mediaDevices : null, r3.protocol = location.protocol.match(/https/i) ? "https" : "http", r3.id = r3.opts.id || "ScreenCapture", r3.title = r3.opts.title || "Screencast", r3.type = "acquirer", r3.icon = Qs, r3.defaultLocale = { strings: { startCapturing: "Begin screen capturing", stopCapturing: "Stop screen capturing", submitRecordedFile: "Submit captured video", streamActive: "Stream active", streamPassive: "Stream passive", micDisabled: "Microphone access denied by user", recording: "Recording" } }, r3.opts = ml({}, { displayMediaConstraints: { video: { width: 1280, height: 720, frameRate: { ideal: 3, max: 5 }, cursor: "motion", displaySurface: "monitor" } }, userMediaConstraints: { audio: true }, preferredVideoMimeType: "video/webm" }, n3), r3.translator = new x([r3.defaultLocale, r3.uppy.locale, r3.opts.locale]), r3.i18n = r3.translator.translate.bind(r3.translator), r3.i18nArray = r3.translator.translateArray.bind(r3.translator), r3.install = r3.install.bind(vl(r3)), r3.setPluginState = r3.setPluginState.bind(vl(r3)), r3.render = r3.render.bind(vl(r3)), r3.start = r3.start.bind(vl(r3)), r3.stop = r3.stop.bind(vl(r3)), r3.startRecording = r3.startRecording.bind(vl(r3)), r3.stopRecording = r3.stopRecording.bind(vl(r3)), r3.submit = r3.submit.bind(vl(r3)), r3.streamInterrupted = r3.streamInactivated.bind(vl(r3)), r3.captureActive = false, r3.capturedMediaFile = null, r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, gl(t2, n2);
    var o2 = r2.prototype;
    return o2.install = function() {
      if (!this.mediaDevices) return this.uppy.log("Screen recorder access is not supported", "error"), null;
      this.setPluginState({ streamActive: false, audioStreamActive: false });
      var e3 = this.opts.target;
      e3 && this.mount(e3, this);
    }, o2.uninstall = function() {
      this.videoStream && this.stop(), this.unmount();
    }, o2.start = function() {
      var e3 = this;
      if (!this.mediaDevices) return Promise.reject(new Error("Screen recorder access not supported"));
      this.captureActive = true, this.selectAudioStreamSource(), this.selectVideoStreamSource().then(function(t3) {
        false === t3 && e3.parent && e3.parent.hideAllPanels && (e3.parent.hideAllPanels(), e3.captureActive = false);
      });
    }, o2.selectVideoStreamSource = function() {
      var e3 = this;
      return this.videoStream ? new Promise(function(t3) {
        return t3(e3.videoStream);
      }) : this.mediaDevices.getDisplayMedia(this.opts.displayMediaConstraints).then(function(t3) {
        return e3.videoStream = t3, e3.videoStream.addEventListener("inactive", function(t4) {
          e3.streamInactivated();
        }), e3.setPluginState({ streamActive: true }), t3;
      }).catch(function(t3) {
        return e3.setPluginState({ screenRecError: t3 }), e3.userDenied = true, setTimeout(function() {
          e3.userDenied = false;
        }, 1e3), false;
      });
    }, o2.selectAudioStreamSource = function() {
      var e3 = this;
      return this.audioStream ? new Promise(function(t3) {
        return t3(e3.audioStream);
      }) : this.mediaDevices.getUserMedia(this.opts.userMediaConstraints).then(function(t3) {
        return e3.audioStream = t3, e3.setPluginState({ audioStreamActive: true }), t3;
      }).catch(function(t3) {
        return "NotAllowedError" === t3.name && e3.uppy.info(e3.i18n("micDisabled"), "error", 5e3), false;
      });
    }, o2.startRecording = function() {
      var e3 = this, t3 = {};
      this.capturedMediaFile = null, this.recordingChunks = [];
      var n3 = this.opts.preferredVideoMimeType;
      this.selectVideoStreamSource().then(function(r3) {
        n3 && MediaRecorder.isTypeSupported(n3) && bs(n3) && (t3.mimeType = n3);
        var o3 = [r3.getVideoTracks()[0]];
        e3.audioStream && o3.push(e3.audioStream.getAudioTracks()[0]), e3.outputStream = new MediaStream(o3), e3.recorder = new MediaRecorder(e3.outputStream, t3), e3.recorder.addEventListener("dataavailable", function(t4) {
          e3.recordingChunks.push(t4.data);
        }), e3.recorder.start(), e3.setPluginState({ recording: true });
      }).catch(function(t4) {
        e3.uppy.log(t4, "error");
      });
    }, o2.streamInactivated = function() {
      var e3 = ml({}, this.getPluginState()), t3 = e3.recordedVideo, n3 = e3.recording;
      t3 || n3 ? n3 && (this.uppy.log("Capture stream inactive \u2014 stop recording"), this.stopRecording()) : this.parent && this.parent.hideAllPanels && this.parent.hideAllPanels(), this.videoStream = null, this.audioStream = null, this.setPluginState({ streamActive: false, audioStreamActive: false });
    }, o2.stopRecording = function() {
      var e3 = this;
      return new Promise(function(t3, n3) {
        e3.recorder.addEventListener("stop", function() {
          t3();
        }), e3.recorder.stop();
      }).then(function() {
        return e3.setPluginState({ recording: false }), e3.getVideo();
      }).then(function(t3) {
        e3.capturedMediaFile = t3, e3.setPluginState({ recordedVideo: URL.createObjectURL(t3.data) });
      }).then(function() {
        e3.recordingChunks = null, e3.recorder = null;
      }, function(t3) {
        throw e3.recordingChunks = null, e3.recorder = null, t3;
      });
    }, o2.submit = function() {
      try {
        this.capturedMediaFile && this.uppy.addFile(this.capturedMediaFile);
      } catch (wd2) {
        wd2.isRestriction || this.uppy.log(wd2, "error");
      }
    }, o2.stop = function() {
      this.videoStream && (this.videoStream.getVideoTracks().forEach(function(e3) {
        e3.stop();
      }), this.videoStream.getAudioTracks().forEach(function(e3) {
        e3.stop();
      }), this.videoStream = null), this.audioStream && (this.audioStream.getAudioTracks().forEach(function(e3) {
        e3.stop();
      }), this.audioStream.getVideoTracks().forEach(function(e3) {
        e3.stop();
      }), this.audioStream = null), this.outputStream && (this.outputStream.getAudioTracks().forEach(function(e3) {
        e3.stop();
      }), this.outputStream.getVideoTracks().forEach(function(e3) {
        e3.stop();
      }), this.outputStream = null), this.setPluginState({ recordedVideo: null }), this.captureActive = false;
    }, o2.getVideo = function() {
      var e3 = this.recordingChunks[0].type, t3 = bs(e3);
      if (!t3) return Promise.reject(new Error('Could not retrieve recording: Unsupported media type "' + e3 + '"'));
      var n3 = "screencap-" + Date.now() + "." + t3, r3 = new Blob(this.recordingChunks, { type: e3 }), o3 = { source: this.id, name: n3, data: new Blob([r3], { type: e3 }), type: e3 };
      return Promise.resolve(o3);
    }, o2.render = function(e3) {
      var t3 = this.getPluginState();
      return t3.streamActive || this.captureActive || this.userDenied || this.start(), yl(fl, ml({}, t3, { onStartRecording: this.startRecording, onStopRecording: this.stopRecording, onStop: this.stop, onSubmit: this.submit, i18n: this.i18n, stream: this.videoStream }));
    }, r2;
  }(ue.Plugin), pl.VERSION = "1.0.21", dl), _l = function() {
    function e2(e3) {
      this.limit = "number" != typeof e3 || 0 === e3 ? 1 / 0 : e3, this.activeRequests = 0, this.queuedHandlers = [];
    }
    var t2 = e2.prototype;
    return t2._call = function(e3) {
      var t3 = this;
      this.activeRequests += 1;
      var n2, r2 = false;
      try {
        n2 = e3();
      } catch (wd2) {
        throw this.activeRequests -= 1, wd2;
      }
      return { abort: function() {
        r2 || (r2 = true, t3.activeRequests -= 1, n2(), t3._queueNext());
      }, done: function() {
        r2 || (r2 = true, t3.activeRequests -= 1, t3._queueNext());
      } };
    }, t2._queueNext = function() {
      var e3 = this;
      Promise.resolve().then(function() {
        e3._next();
      });
    }, t2._next = function() {
      if (!(this.activeRequests >= this.limit) && 0 !== this.queuedHandlers.length) {
        var e3 = this.queuedHandlers.shift(), t3 = this._call(e3.fn);
        e3.abort = t3.abort, e3.done = t3.done;
      }
    }, t2._queue = function(e3, t3) {
      var n2 = this;
      void 0 === t3 && (t3 = {});
      var r2 = { fn: e3, priority: t3.priority || 0, abort: function() {
        n2._dequeue(r2);
      }, done: function() {
        throw new Error("Cannot mark a queued request as done: this indicates a bug");
      } }, o2 = ee(this.queuedHandlers, function(e4) {
        return r2.priority > e4.priority;
      });
      return -1 === o2 ? this.queuedHandlers.push(r2) : this.queuedHandlers.splice(o2, 0, r2), r2;
    }, t2._dequeue = function(e3) {
      var t3 = this.queuedHandlers.indexOf(e3);
      -1 !== t3 && this.queuedHandlers.splice(t3, 1);
    }, t2.run = function(e3, t3) {
      return this.activeRequests < this.limit ? this._call(e3) : this._queue(e3, t3);
    }, t2.wrapPromiseFunction = function(e3, t3) {
      var n2 = this;
      return function() {
        for (var r2 = arguments.length, o2 = new Array(r2), i2 = 0; i2 < r2; i2++) o2[i2] = arguments[i2];
        var a2, s2 = new Promise(function(r3, i3) {
          a2 = n2.run(function() {
            var t4, n3;
            try {
              n3 = Promise.resolve(e3.apply(void 0, o2));
            } catch (wd2) {
              n3 = Promise.reject(wd2);
            }
            return n3.then(function(e4) {
              t4 ? i3(t4) : (a2.done(), r3(e4));
            }, function(e4) {
              t4 ? i3(t4) : (a2.done(), i3(e4));
            }), function() {
              t4 = new Error("Cancelled");
            };
          }, t3);
        });
        return s2.abort = function() {
          a2.abort();
        }, s2;
      };
    }, e2;
  }(), wl = function(e2) {
    var t2 = [], n2 = [];
    function r2(e3) {
      t2.push(e3);
    }
    function o2(e3) {
      n2.push(e3);
    }
    return Promise.all(e2.map(function(e3) {
      return e3.then(r2, o2);
    })).then(function() {
      return { successful: t2, failed: n2 };
    });
  }, Cl = z(function(e2, t2, n2) {
    var r2 = t2.progress, o2 = t2.bytesUploaded, i2 = t2.bytesTotal;
    r2 && (e2.uppy.log("Upload progress: " + r2), e2.uppy.emit("upload-progress", n2, { uploader: e2, bytesUploaded: o2, bytesTotal: i2 }));
  }, 300, { leading: true, trailing: true }), Sl = function(e2) {
    var t2 = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i.exec(e2)[1];
    return (/^http:\/\//i.test(e2) ? "ws" : "wss") + "://" + t2;
  }, kl = function() {
    function e2(e3) {
      this._events = [], this._emitter = e3;
    }
    var t2 = e2.prototype;
    return t2.on = function(e3, t3) {
      return this._events.push([e3, t3]), this._emitter.on(e3, t3);
    }, t2.remove = function() {
      var e3 = this;
      this._events.forEach(function(t3) {
        var n2 = t3[0], r2 = t3[1];
        e3._emitter.off(n2, r2);
      });
    }, e2;
  }(), xl = function() {
    function e2(e3, t3) {
      this._timeout = e3, this._onTimedOut = t3, this._isDone = false, this._aliveTimer = null, this._onTimedOut = this._onTimedOut.bind(this);
    }
    var t2 = e2.prototype;
    return t2.progress = function() {
      this._isDone || this._timeout > 0 && (this._aliveTimer && clearTimeout(this._aliveTimer), this._aliveTimer = setTimeout(this._onTimedOut, this._timeout));
    }, t2.done = function() {
      this._aliveTimer && (clearTimeout(this._aliveTimer), this._aliveTimer = null), this._isDone = true;
    }, e2;
  }(), Pl = function(e2) {
    return !!e2 && (0 !== e2.readyState && 4 !== e2.readyState || 0 === e2.status);
  };
  function El() {
    return (El = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var Ol = Ke.Provider, Al = Ke.RequestClient, Ul = Ke.Socket;
  function Nl(e2, t2) {
    return t2 || (t2 = new Error("Upload error")), "string" == typeof t2 && (t2 = new Error(t2)), t2 instanceof Error || (t2 = El(new Error("Upload error"), { data: t2 })), Pl(e2) ? t2 = new Te(t2, e2) : (t2.request = e2, t2);
  }
  var Tl, Rl, Fl = function() {
    function e2(e3, t3) {
      this.uppy = e3, this.opts = El({ validateStatus: function(e4, t4, n2) {
        return e4 >= 200 && e4 < 300;
      } }, t3), this.requests = t3.__queue, this.uploaderEvents = /* @__PURE__ */ Object.create(null), this.i18n = t3.i18n;
    }
    var t2 = e2.prototype;
    return t2._getOptions = function(e3) {
      var t3 = this.uppy.getState().xhrUpload, n2 = El({}, this.opts, t3 || {}, e3.xhrUpload || {}, { headers: {} });
      return El(n2.headers, this.opts.headers), t3 && El(n2.headers, t3.headers), e3.xhrUpload && El(n2.headers, e3.xhrUpload.headers), n2;
    }, t2.uploadFile = function(e3, t3, n2) {
      var r2 = this.uppy.getFile(e3);
      if (r2.error) throw new Error(r2.error);
      return r2.isRemote ? this._uploadRemoteFile(r2, t3, n2) : this._uploadLocalFile(r2, t3, n2);
    }, t2._addMetadata = function(e3, t3, n2) {
      (Array.isArray(n2.metaFields) ? n2.metaFields : Object.keys(t3)).forEach(function(n3) {
        e3.append(n3, t3[n3]);
      });
    }, t2._createFormDataUpload = function(e3, t3) {
      var n2 = new FormData();
      this._addMetadata(n2, e3.meta, t3);
      var r2 = function(e4) {
        return e4.data.slice(0, e4.data.size, e4.meta.type);
      }(e3);
      return e3.name ? n2.append(t3.fieldName, r2, e3.meta.name) : n2.append(t3.fieldName, r2), n2;
    }, t2._createBareUpload = function(e3, t3) {
      return e3.data;
    }, t2._onFileRemoved = function(e3, t3) {
      this.uploaderEvents[e3].on("file-removed", function(n2) {
        e3 === n2.id && t3(n2.id);
      });
    }, t2._onRetry = function(e3, t3) {
      this.uploaderEvents[e3].on("upload-retry", function(n2) {
        e3 === n2 && t3();
      });
    }, t2._onRetryAll = function(e3, t3) {
      var n2 = this;
      this.uploaderEvents[e3].on("retry-all", function(r2) {
        n2.uppy.getFile(e3) && t3();
      });
    }, t2._onCancelAll = function(e3, t3) {
      var n2 = this;
      this.uploaderEvents[e3].on("cancel-all", function() {
        n2.uppy.getFile(e3) && t3();
      });
    }, t2._uploadLocalFile = function(e3, t3, n2) {
      var r2 = this, o2 = this._getOptions(e3);
      return this.uppy.log("uploading " + t3 + " of " + n2), new Promise(function(t4, n3) {
        var i2 = o2.formData ? r2._createFormDataUpload(e3, o2) : r2._createBareUpload(e3, o2), a2 = new XMLHttpRequest();
        r2.uploaderEvents[e3.id] = new kl(r2.uppy);
        var s2 = new xl(o2.timeout, function() {
          a2.abort(), u2.done();
          var t5 = new Error(r2.i18n("timedOut", { seconds: Math.ceil(o2.timeout / 1e3) }));
          r2.uppy.emit("upload-error", e3, t5), n3(t5);
        }), l2 = D();
        a2.upload.addEventListener("loadstart", function(e4) {
          r2.uppy.log("[AwsS3/XHRUpload] " + l2 + " started");
        }), a2.upload.addEventListener("progress", function(t5) {
          r2.uppy.log("[AwsS3/XHRUpload] " + l2 + " progress: " + t5.loaded + " / " + t5.total), s2.progress(), t5.lengthComputable && r2.uppy.emit("upload-progress", e3, { uploader: r2, bytesUploaded: t5.loaded, bytesTotal: t5.total });
        }), a2.addEventListener("load", function(i3) {
          if (r2.uppy.log("[AwsS3/XHRUpload] " + l2 + " finished"), s2.done(), u2.done(), r2.uploaderEvents[e3.id] && (r2.uploaderEvents[e3.id].remove(), r2.uploaderEvents[e3.id] = null), o2.validateStatus(i3.target.status, a2.responseText, a2)) {
            var c2 = o2.getResponseData(a2.responseText, a2), p2 = c2[o2.responseUrlFieldName], d2 = { status: i3.target.status, body: c2, uploadURL: p2 };
            return r2.uppy.emit("upload-success", e3, d2), p2 && r2.uppy.log("Download " + e3.name + " from " + p2), t4(e3);
          }
          var h2 = o2.getResponseData(a2.responseText, a2), f2 = Nl(a2, o2.getResponseError(a2.responseText, a2)), m2 = { status: i3.target.status, body: h2 };
          return r2.uppy.emit("upload-error", e3, f2, m2), n3(f2);
        }), a2.addEventListener("error", function(t5) {
          r2.uppy.log("[AwsS3/XHRUpload] " + l2 + " errored"), s2.done(), u2.done(), r2.uploaderEvents[e3.id] && (r2.uploaderEvents[e3.id].remove(), r2.uploaderEvents[e3.id] = null);
          var i3 = Nl(a2, o2.getResponseError(a2.responseText, a2));
          return r2.uppy.emit("upload-error", e3, i3), n3(i3);
        }), a2.open(o2.method.toUpperCase(), o2.endpoint, true), a2.withCredentials = o2.withCredentials, "" !== o2.responseType && (a2.responseType = o2.responseType), Object.keys(o2.headers).forEach(function(e4) {
          a2.setRequestHeader(e4, o2.headers[e4]);
        });
        var u2 = r2.requests.run(function() {
          return a2.send(i2), function() {
            s2.done(), a2.abort();
          };
        }, { priority: 1 });
        r2._onFileRemoved(e3.id, function() {
          u2.abort(), n3(new Error("File removed"));
        }), r2._onCancelAll(e3.id, function() {
          u2.abort(), n3(new Error("Upload cancelled"));
        });
      });
    }, t2._uploadRemoteFile = function(e3, t3, n2) {
      var r2 = this, o2 = this._getOptions(e3);
      return new Promise(function(t4, n3) {
        var i2 = {};
        (Array.isArray(o2.metaFields) ? o2.metaFields : Object.keys(e3.meta)).forEach(function(t5) {
          i2[t5] = e3.meta[t5];
        }), new (e3.remote.providerOptions.provider ? Ol : Al)(r2.uppy, e3.remote.providerOptions).post(e3.remote.url, El({}, e3.remote.body, { endpoint: o2.endpoint, size: e3.data.size, fieldname: o2.fieldName, metadata: i2, httpMethod: o2.method, useFormData: o2.formData, headers: o2.headers })).then(function(i3) {
          var a2 = i3.token, s2 = Sl(e3.remote.companionUrl), l2 = new Ul({ target: s2 + "/api/" + a2, autoOpen: false });
          r2.uploaderEvents[e3.id] = new kl(r2.uppy), r2._onFileRemoved(e3.id, function() {
            l2.send("pause", {}), u2.abort(), t4("upload " + e3.id + " was removed");
          }), r2._onCancelAll(e3.id, function() {
            l2.send("pause", {}), u2.abort(), t4("upload " + e3.id + " was canceled");
          }), r2._onRetry(e3.id, function() {
            l2.send("pause", {}), l2.send("resume", {});
          }), r2._onRetryAll(e3.id, function() {
            l2.send("pause", {}), l2.send("resume", {});
          }), l2.on("progress", function(t5) {
            return Cl(r2, t5, e3);
          }), l2.on("success", function(n4) {
            var i4 = o2.getResponseData(n4.response.responseText, n4.response), a3 = i4[o2.responseUrlFieldName], s3 = { status: n4.response.status, body: i4, uploadURL: a3 };
            return r2.uppy.emit("upload-success", e3, s3), u2.done(), r2.uploaderEvents[e3.id] && (r2.uploaderEvents[e3.id].remove(), r2.uploaderEvents[e3.id] = null), t4();
          }), l2.on("error", function(t5) {
            var i4 = t5.response, a3 = i4 ? o2.getResponseError(i4.responseText, i4) : El(new Error(t5.error.message), { cause: t5.error });
            r2.uppy.emit("upload-error", e3, a3), u2.done(), r2.uploaderEvents[e3.id] && (r2.uploaderEvents[e3.id].remove(), r2.uploaderEvents[e3.id] = null), n3(a3);
          });
          var u2 = r2.requests.run(function() {
            return l2.open(), e3.isPaused && l2.send("pause", {}), function() {
              return l2.close();
            };
          });
        }).catch(function(t5) {
          r2.uppy.emit("upload-error", e3, t5), n3(t5);
        });
      });
    }, e2;
  }(), Dl = function(e2, t2) {
    var n2, r2 = t2.headers ? t2.headers["content-type"] : t2.getResponseHeader("Content-Type");
    if ("string" == typeof r2) {
      var o2 = (n2 = r2, n2.replace(/;.*$/, "")).toLowerCase();
      if ("application/xml" === o2 || "text/xml" === o2) return true;
      if ("text/html" === o2 && /^<\?xml /.test(e2)) return true;
    }
    return false;
  };
  function Ml(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Bl(e2, t2) {
    return (Bl = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function Il() {
    return (Il = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var Ll = "function" == typeof URL ? URL : Ve, jl = Ke.RequestClient;
  function zl(e2, t2) {
    var n2 = e2.indexOf("<" + t2 + ">"), r2 = e2.indexOf("</" + t2 + ">", n2);
    return -1 !== n2 && -1 !== r2 ? e2.slice(n2 + t2.length + 2, r2) : "";
  }
  function Hl(e2) {
    if (e2 && e2.error) {
      var t2 = new Error(e2.message);
      throw Il(t2, e2.error), t2;
    }
    return e2;
  }
  var Wl = false, Vl = (Rl = Tl = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      (r3 = e2.call(this, t3, n3) || this).type = "uploader", r3.id = r3.opts.id || "AwsS3", r3.title = "AWS S3", r3.defaultLocale = { strings: { timedOut: "Upload stalled for %{seconds} seconds, aborting." } };
      var o3 = { timeout: 3e4, limit: 0, metaFields: [], getUploadParameters: r3.getUploadParameters.bind(Ml(r3)) };
      return r3.opts = Il({}, o3, n3), r3.i18nInit(), r3.client = new jl(t3, n3), r3.handleUpload = r3.handleUpload.bind(Ml(r3)), r3.requests = new _l(r3.opts.limit), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Bl(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, t3), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.setPluginState();
    }, o2.getUploadParameters = function(e3) {
      if (!this.opts.companionUrl) throw new Error("Expected a `companionUrl` option containing a Companion address.");
      var t3 = e3.meta.name, n3 = e3.meta.type, r3 = {};
      this.opts.metaFields.forEach(function(t4) {
        null != e3.meta[t4] && (r3[t4] = e3.meta[t4].toString());
      });
      var o3 = Ie({ filename: t3, type: n3, metadata: r3 });
      return this.client.get("s3/params?" + o3).then(Hl);
    }, o2.validateParameters = function(e3, t3) {
      if ("object" != typeof t3 || !t3 || "string" != typeof t3.url || "object" != typeof t3.fields && null != t3.fields) {
        var n3 = new TypeError("AwsS3: got incorrect result from 'getUploadParameters()' for file '" + e3.name + "', expected an object '{ url, method, fields, headers }' but got '" + JSON.stringify(t3) + "' instead.\nSee https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.");
        throw console.error(n3), n3;
      }
      if (null != t3.method && !/^(put|post)$/i.test(t3.method)) {
        var r3 = new TypeError("AwsS3: got incorrect method from 'getUploadParameters()' for file '" + e3.name + "', expected  'put' or 'post' but got '" + t3.method + "' instead.\nSee https://uppy.io/docs/aws-s3/#getUploadParameters-file for more on the expected format.");
        throw console.error(r3), r3;
      }
    }, o2.handleUpload = function(e3) {
      var t3 = this, n3 = /* @__PURE__ */ Object.create(null);
      function r3(e4) {
        var t4 = e4.id;
        C(n3, t4) && n3[t4].abort();
      }
      this.uppy.on("file-removed", r3), e3.forEach(function(e4) {
        var n4 = t3.uppy.getFile(e4);
        t3.uppy.emit("upload-started", n4);
      });
      var o3 = this.requests.wrapPromiseFunction(function(e4) {
        return t3.opts.getUploadParameters(e4);
      }), i2 = e3.length;
      return wl(e3.map(function(e4, r4) {
        return n3[e4] = o3(t3.uppy.getFile(e4)), n3[e4].then(function(o4) {
          delete n3[e4];
          var a2 = t3.uppy.getFile(e4);
          t3.validateParameters(a2, o4);
          var s2 = o4.method, l2 = void 0 === s2 ? "post" : s2, u2 = o4.url, c2 = o4.fields, p2 = o4.headers, d2 = { method: l2, formData: "post" === l2.toLowerCase(), endpoint: u2, metaFields: c2 ? Object.keys(c2) : [] };
          return p2 && (d2.headers = p2), t3.uppy.setFileState(a2.id, { meta: Il({}, a2.meta, c2), xhrUpload: d2 }), t3._uploader.uploadFile(a2.id, r4, i2);
        }).catch(function(r5) {
          delete n3[e4];
          var o4 = t3.uppy.getFile(e4);
          t3.uppy.emit("upload-error", o4, r5);
        });
      })).then(function(e4) {
        return t3.uppy.off("file-removed", r3), e4;
      });
    }, o2.install = function() {
      var e3 = this.uppy;
      this.uppy.addUploader(this.handleUpload);
      var t3 = { fieldName: "file", responseUrlFieldName: "location", timeout: this.opts.timeout, __queue: this.requests, responseType: "text", getResponseData: this.opts.getResponseData || function(t4, n3) {
        var r3, o3;
        return Dl(t4, n3) ? { location: (r3 = n3.responseURL, o3 = zl(t4, "Location"), r3 ? new Ll(o3, r3).toString() : new Ll(o3).toString()), bucket: zl(t4, "Bucket"), key: zl(t4, "Key"), etag: zl(t4, "ETag") } : "POST" === this.method.toUpperCase() ? (Wl || (e3.log("[AwsS3] No response data found, make sure to set the success_action_status AWS SDK option to 201. See https://uppy.io/docs/aws-s3/#POST-Uploads", "warning"), Wl = true), { location: null }) : n3.responseURL ? { location: n3.responseURL.replace(/\?.*$/, "") } : { location: null };
      }, getResponseError: function(e4, t4) {
        if (Dl(e4, t4)) {
          var n3 = zl(e4, "Message");
          return new Error(n3);
        }
      } };
      t3.i18n = this.i18n, this._uploader = new Fl(this.uppy, t3);
    }, o2.uninstall = function() {
      this.uppy.removeUploader(this.handleUpload);
    }, r2;
  }(ue.Plugin), Tl.VERSION = "1.7.12", Rl), ql = {};
  function Xl(e2, t2) {
    if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
  }
  function Gl(e2, t2) {
    for (var n2 = 0; n2 < t2.length; n2++) {
      var r2 = t2[n2];
      r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
    }
  }
  function Yl(e2, t2, n2) {
    return t2 && Gl(e2.prototype, t2), n2 && Gl(e2, n2), e2;
  }
  function $l(e2) {
    return ($l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e3) {
      return e3.__proto__ || Object.getPrototypeOf(e3);
    })(e2);
  }
  function Kl(e2, t2) {
    return (Kl = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function Jl(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Ql(e2, t2, n2) {
    return (Ql = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e3, t3, n3) {
      var r2 = function(e4, t4) {
        for (; !Object.prototype.hasOwnProperty.call(e4, t4) && null !== (e4 = $l(e4)); ) ;
        return e4;
      }(e3, t3);
      if (r2) {
        var o2 = Object.getOwnPropertyDescriptor(r2, t3);
        return o2.get ? o2.get.call(n3) : o2.value;
      }
    })(e2, t2, n2 || e2);
  }
  Object.defineProperty(ql, "__esModule", { value: true });
  var Zl = function() {
    function e2() {
      Xl(this, e2), Object.defineProperty(this, "listeners", { value: {}, writable: true, configurable: true });
    }
    return Yl(e2, [{ key: "addEventListener", value: function(e3, t2, n2) {
      e3 in this.listeners || (this.listeners[e3] = []), this.listeners[e3].push({ callback: t2, options: n2 });
    } }, { key: "removeEventListener", value: function(e3, t2) {
      if (e3 in this.listeners) {
        for (var n2 = this.listeners[e3], r2 = 0, o2 = n2.length; r2 < o2; r2++) if (n2[r2].callback === t2) return void n2.splice(r2, 1);
      }
    } }, { key: "dispatchEvent", value: function(e3) {
      if (e3.type in this.listeners) {
        for (var t2 = this.listeners[e3.type].slice(), n2 = 0, r2 = t2.length; n2 < r2; n2++) {
          var o2 = t2[n2];
          try {
            o2.callback.call(this, e3);
          } catch (i2) {
            Promise.resolve().then(function() {
              throw i2;
            });
          }
          o2.options && o2.options.once && this.removeEventListener(e3.type, o2.callback);
        }
        return !e3.defaultPrevented;
      }
    } }]), e2;
  }(), eu = function(e2) {
    !function(e3, t3) {
      if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
      e3.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e3, writable: true, configurable: true } }), t3 && Kl(e3, t3);
    }(o2, Zl);
    var t2, n2, r2 = (t2 = o2, n2 = function() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if ("function" == typeof Proxy) return true;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), true;
      } catch (e3) {
        return false;
      }
    }(), function() {
      var e3, r3, o3, i2 = $l(t2);
      if (n2) {
        var a2 = $l(this).constructor;
        e3 = Reflect.construct(i2, arguments, a2);
      } else e3 = i2.apply(this, arguments);
      return r3 = this, !(o3 = e3) || "object" != typeof o3 && "function" != typeof o3 ? Jl(r3) : o3;
    });
    function o2() {
      var e3;
      return Xl(this, o2), (e3 = r2.call(this)).listeners || Zl.call(Jl(e3)), Object.defineProperty(Jl(e3), "aborted", { value: false, writable: true, configurable: true }), Object.defineProperty(Jl(e3), "onabort", { value: null, writable: true, configurable: true }), e3;
    }
    return Yl(o2, [{ key: "toString", value: function() {
      return "[object AbortSignal]";
    } }, { key: "dispatchEvent", value: function(e3) {
      "abort" === e3.type && (this.aborted = true, "function" == typeof this.onabort && this.onabort.call(this, e3)), Ql($l(o2.prototype), "dispatchEvent", this).call(this, e3);
    } }]), o2;
  }(), tu = function() {
    function e2() {
      Xl(this, e2), Object.defineProperty(this, "signal", { value: new eu(), writable: true, configurable: true });
    }
    return Yl(e2, [{ key: "abort", value: function() {
      var e3;
      try {
        e3 = new Event("abort");
      } catch (t2) {
        "undefined" != typeof document ? document.createEvent ? (e3 = document.createEvent("Event")).initEvent("abort", false, false) : (e3 = document.createEventObject()).type = "abort" : e3 = { type: "abort", bubbles: false, cancelable: false };
      }
      this.signal.dispatchEvent(e3);
    } }, { key: "toString", value: function() {
      return "[object AbortController]";
    } }]), e2;
  }();
  "undefined" != typeof Symbol && Symbol.toStringTag && (tu.prototype[Symbol.toStringTag] = "AbortController", eu.prototype[Symbol.toStringTag] = "AbortSignal"), ql.AbortController = tu, ql.AbortSignal = eu;
  var nu = {}, ru = ql.AbortController;
  ql.AbortSignal;
  nu.AbortController = ru, nu.createAbortError = function(e2) {
    void 0 === e2 && (e2 = "Aborted");
    try {
      return new DOMException(e2, "AbortError");
    } catch (n2) {
      var t2 = new Error(e2);
      return t2.name = "AbortError", t2;
    }
  };
  var ou = nu.createAbortError;
  function iu() {
    return (iu = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var au = nu.AbortController, su = nu.createAbortError, lu = { limit: 1, retryDelays: [0, 1e3, 3e3, 5e3], getChunkSize: function(e2) {
    return Math.ceil(e2.size / 1e4);
  }, onStart: function() {
  }, onProgress: function() {
  }, onPartComplete: function() {
  }, onSuccess: function() {
  }, onError: function(e2) {
    throw e2;
  } };
  function uu(e2) {
    if ("string" == typeof e2) return parseInt(e2, 10);
    if ("number" == typeof e2) return e2;
    throw new TypeError("Expected a number");
  }
  var cu, pu, du = function() {
    function e2(e3, t3) {
      this.options = iu({}, lu, t3), this.options.getChunkSize || (this.options.getChunkSize = lu.getChunkSize), this.file = e3, this.abortController = new au(), this.key = this.options.key || null, this.uploadId = this.options.uploadId || null, this.parts = [], this.createdPromise = Promise.reject(), this.isPaused = false, this.partsInProgress = 0, this.chunks = null, this.chunkState = null, this._initChunks(), this.createdPromise.catch(function() {
      });
    }
    var t2 = e2.prototype;
    return t2._aborted = function() {
      return this.abortController.signal.aborted;
    }, t2._initChunks = function() {
      var e3 = [], t3 = this.options.getChunkSize(this.file), n2 = Math.max(5242880, Math.ceil(this.file.size / 1e4)), r2 = Math.max(t3, n2);
      if (0 === this.file.size) e3.push(this.file);
      else for (var o2 = 0; o2 < this.file.size; o2 += r2) {
        var i2 = Math.min(this.file.size, o2 + r2);
        e3.push(this.file.slice(o2, i2));
      }
      this.chunks = e3, this.chunkState = e3.map(function() {
        return { uploaded: 0, busy: false, done: false };
      });
    }, t2._createUpload = function() {
      var e3 = this;
      return this.createdPromise = Promise.resolve().then(function() {
        return e3.options.createMultipartUpload();
      }), this.createdPromise.then(function(t3) {
        if (e3._aborted()) throw su();
        if ("object" != typeof t3 || !t3 || "string" != typeof t3.uploadId || "string" != typeof t3.key) throw new TypeError("AwsS3/Multipart: Got incorrect result from `createMultipartUpload()`, expected an object `{ uploadId, key }`.");
        e3.key = t3.key, e3.uploadId = t3.uploadId, e3.options.onStart(t3), e3._uploadParts();
      }).catch(function(t3) {
        e3._onError(t3);
      });
    }, t2._resumeUpload = function() {
      var e3 = this;
      return Promise.resolve().then(function() {
        return e3.options.listParts({ uploadId: e3.uploadId, key: e3.key });
      }).then(function(t3) {
        if (e3._aborted()) throw su();
        t3.forEach(function(t4) {
          var n2 = t4.PartNumber - 1;
          e3.chunkState[n2] = { uploaded: uu(t4.Size), etag: t4.ETag, done: true }, e3.parts.some(function(e4) {
            return e4.PartNumber === t4.PartNumber;
          }) || e3.parts.push({ PartNumber: t4.PartNumber, ETag: t4.ETag });
        }), e3._uploadParts();
      }).catch(function(t3) {
        e3._onError(t3);
      });
    }, t2._uploadParts = function() {
      var e3 = this;
      if (!this.isPaused) {
        var t3 = this.options.limit - this.partsInProgress;
        if (0 !== t3) if (this.chunkState.every(function(e4) {
          return e4.done;
        })) this._completeUpload();
        else {
          for (var n2 = [], r2 = 0; r2 < this.chunkState.length; r2++) {
            var o2 = this.chunkState[r2];
            if (!o2.done && !o2.busy && (n2.push(r2), n2.length >= t3)) break;
          }
          n2.forEach(function(t4) {
            e3._uploadPartRetryable(t4).then(function() {
              e3._uploadParts();
            }, function(t5) {
              e3._onError(t5);
            });
          });
        }
      }
    }, t2._retryable = function(e3) {
      var t3 = this, n2 = e3.before, r2 = e3.attempt, o2 = e3.after, i2 = this.options.retryDelays, a2 = this.abortController.signal;
      return n2 && n2(), function e4(n3) {
        return r2().catch(function(r3) {
          if (t3._aborted()) throw su();
          if (function(e5) {
            if (e5.source && "number" == typeof e5.source.status) {
              var t4 = e5.source.status;
              return 0 === t4 || 409 === t4 || 423 === t4 || t4 >= 500 && t4 < 600;
            }
            return false;
          }(r3) && n3 < i2.length) return (o3 = i2[n3], s2 = { signal: a2 }, new Promise(function(e5, t4) {
            if (s2 && s2.signal && s2.signal.aborted) return t4(ou());
            function n4() {
              clearTimeout(r4), i3(), t4(ou());
            }
            var r4 = setTimeout(function() {
              i3(), e5();
            }, o3);
            function i3() {
              s2 && s2.signal && s2.signal.removeEventListener("abort", n4);
            }
            s2 && s2.signal && s2.signal.addEventListener("abort", n4);
          })).then(function() {
            return e4(n3 + 1);
          });
          var o3, s2;
          throw r3;
        });
      }(0).then(function(e4) {
        return o2 && o2(), e4;
      }, function(e4) {
        throw o2 && o2(), e4;
      });
    }, t2._uploadPartRetryable = function(e3) {
      var t3 = this;
      return this._retryable({ before: function() {
        t3.partsInProgress += 1;
      }, attempt: function() {
        return t3._uploadPart(e3);
      }, after: function() {
        t3.partsInProgress -= 1;
      } });
    }, t2._uploadPart = function(e3) {
      var t3 = this, n2 = this.chunks[e3];
      return this.chunkState[e3].busy = true, Promise.resolve().then(function() {
        return t3.options.prepareUploadPart({ key: t3.key, uploadId: t3.uploadId, body: n2, number: e3 + 1 });
      }).then(function(e4) {
        if ("object" != typeof e4 || !e4 || "string" != typeof e4.url) throw new TypeError("AwsS3/Multipart: Got incorrect result from `prepareUploadPart()`, expected an object `{ url }`.");
        return e4;
      }).then(function(n3) {
        var r2 = n3.url, o2 = n3.headers;
        if (t3._aborted()) throw t3.chunkState[e3].busy = false, su();
        return t3._uploadPartBytes(e3, r2, o2);
      });
    }, t2._onPartProgress = function(e3, t3, n2) {
      this.chunkState[e3].uploaded = uu(t3);
      var r2 = this.chunkState.reduce(function(e4, t4) {
        return e4 + t4.uploaded;
      }, 0);
      this.options.onProgress(r2, this.file.size);
    }, t2._onPartComplete = function(e3, t3) {
      this.chunkState[e3].etag = t3, this.chunkState[e3].done = true;
      var n2 = { PartNumber: e3 + 1, ETag: t3 };
      this.parts.push(n2), this.options.onPartComplete(n2);
    }, t2._uploadPartBytes = function(e3, t3, n2) {
      var r2, o2 = this, i2 = this.chunks[e3], a2 = this.abortController.signal, s2 = new Promise(function(e4, t4) {
        r2 = { resolve: e4, reject: t4 };
      }), l2 = new XMLHttpRequest();
      function u2() {
        a2.removeEventListener("abort", c2);
      }
      function c2() {
        l2.abort();
      }
      return l2.open("PUT", t3, true), n2 && Object.keys(n2).map(function(e4) {
        l2.setRequestHeader(e4, n2[e4]);
      }), l2.responseType = "text", a2.addEventListener("abort", c2), l2.upload.addEventListener("progress", function(t4) {
        t4.lengthComputable && o2._onPartProgress(e3, t4.loaded, t4.total);
      }), l2.addEventListener("abort", function(t4) {
        u2(), o2.chunkState[e3].busy = false, r2.reject(su());
      }), l2.addEventListener("load", function(t4) {
        if (u2(), o2.chunkState[e3].busy = false, t4.target.status < 200 || t4.target.status >= 300) {
          var n3 = new Error("Non 2xx");
          return n3.source = t4.target, void r2.reject(n3);
        }
        o2._onPartProgress(e3, i2.size, i2.size);
        var a3 = t4.target.getResponseHeader("ETag");
        null !== a3 ? (o2._onPartComplete(e3, a3), r2.resolve()) : r2.reject(new Error("AwsS3/Multipart: Could not read the ETag header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions."));
      }), l2.addEventListener("error", function(t4) {
        u2(), o2.chunkState[e3].busy = false;
        var n3 = new Error("Unknown error");
        n3.source = t4.target, r2.reject(n3);
      }), l2.send(i2), s2;
    }, t2._completeUpload = function() {
      var e3 = this;
      return this.parts.sort(function(e4, t3) {
        return e4.PartNumber - t3.PartNumber;
      }), Promise.resolve().then(function() {
        return e3.options.completeMultipartUpload({ key: e3.key, uploadId: e3.uploadId, parts: e3.parts });
      }).then(function(t3) {
        e3.options.onSuccess(t3);
      }, function(t3) {
        e3._onError(t3);
      });
    }, t2._abortUpload = function() {
      var e3 = this;
      this.abortController.abort(), this.createdPromise.then(function() {
        e3.options.abortMultipartUpload({ key: e3.key, uploadId: e3.uploadId });
      }, function() {
      });
    }, t2._onError = function(e3) {
      e3 && "AbortError" === e3.name || this.options.onError(e3);
    }, t2.start = function() {
      this.isPaused = false, this.uploadId ? this._resumeUpload() : this._createUpload();
    }, t2.pause = function() {
      this.abortController.abort(), this.abortController = new au(), this.isPaused = true;
    }, t2.abort = function(e3) {
      if (void 0 === e3 && (e3 = {}), !e3.really) return this.pause();
      this._abortUpload();
    }, e2;
  }();
  function hu(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function fu(e2, t2) {
    return (fu = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function mu() {
    return (mu = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var vu = Ke.Socket, gu = Ke.Provider, yu = Ke.RequestClient;
  function bu(e2) {
    if (e2 && e2.error) {
      var t2 = new Error(e2.message);
      throw mu(t2, e2.error), t2;
    }
    return e2;
  }
  var _u = (pu = cu = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      (r3 = e2.call(this, t3, n3) || this).type = "uploader", r3.id = r3.opts.id || "AwsS3Multipart", r3.title = "AWS S3 Multipart", r3.client = new yu(t3, n3);
      var o3 = { timeout: 3e4, limit: 0, retryDelays: [0, 1e3, 3e3, 5e3], createMultipartUpload: r3.createMultipartUpload.bind(hu(r3)), listParts: r3.listParts.bind(hu(r3)), prepareUploadPart: r3.prepareUploadPart.bind(hu(r3)), abortMultipartUpload: r3.abortMultipartUpload.bind(hu(r3)), completeMultipartUpload: r3.completeMultipartUpload.bind(hu(r3)) };
      return r3.opts = mu({}, o3, n3), r3.upload = r3.upload.bind(hu(r3)), r3.requests = new _l(r3.opts.limit), r3.uploaders = /* @__PURE__ */ Object.create(null), r3.uploaderEvents = /* @__PURE__ */ Object.create(null), r3.uploaderSockets = /* @__PURE__ */ Object.create(null), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, fu(t2, n2);
    var o2 = r2.prototype;
    return o2.resetUploaderReferences = function(e3, t3) {
      void 0 === t3 && (t3 = {}), this.uploaders[e3] && (this.uploaders[e3].abort({ really: t3.abort || false }), this.uploaders[e3] = null), this.uploaderEvents[e3] && (this.uploaderEvents[e3].remove(), this.uploaderEvents[e3] = null), this.uploaderSockets[e3] && (this.uploaderSockets[e3].close(), this.uploaderSockets[e3] = null);
    }, o2.assertHost = function(e3) {
      if (!this.opts.companionUrl) throw new Error("Expected a `companionUrl` option containing a Companion address, or if you are not using Companion, a custom `" + e3 + "` implementation.");
    }, o2.createMultipartUpload = function(e3) {
      this.assertHost("createMultipartUpload");
      var t3 = {};
      return Object.keys(e3.meta).map(function(n3) {
        null != e3.meta[n3] && (t3[n3] = e3.meta[n3].toString());
      }), this.client.post("s3/multipart", { filename: e3.name, type: e3.type, metadata: t3 }).then(bu);
    }, o2.listParts = function(e3, t3) {
      var n3 = t3.key, r3 = t3.uploadId;
      this.assertHost("listParts");
      var o3 = encodeURIComponent(n3);
      return this.client.get("s3/multipart/" + r3 + "?key=" + o3).then(bu);
    }, o2.prepareUploadPart = function(e3, t3) {
      var n3 = t3.key, r3 = t3.uploadId, o3 = t3.number;
      this.assertHost("prepareUploadPart");
      var i2 = encodeURIComponent(n3);
      return this.client.get("s3/multipart/" + r3 + "/" + o3 + "?key=" + i2).then(bu);
    }, o2.completeMultipartUpload = function(e3, t3) {
      var n3 = t3.key, r3 = t3.uploadId, o3 = t3.parts;
      this.assertHost("completeMultipartUpload");
      var i2 = encodeURIComponent(n3), a2 = encodeURIComponent(r3);
      return this.client.post("s3/multipart/" + a2 + "/complete?key=" + i2, { parts: o3 }).then(bu);
    }, o2.abortMultipartUpload = function(e3, t3) {
      var n3 = t3.key, r3 = t3.uploadId;
      this.assertHost("abortMultipartUpload");
      var o3 = encodeURIComponent(n3), i2 = encodeURIComponent(r3);
      return this.client.delete("s3/multipart/" + i2 + "?key=" + o3).then(bu);
    }, o2.uploadFile = function(e3) {
      var t3 = this;
      return new Promise(function(n3, r3) {
        var o3 = new du(e3.data, mu({ createMultipartUpload: t3.opts.createMultipartUpload.bind(t3, e3), listParts: t3.opts.listParts.bind(t3, e3), prepareUploadPart: t3.opts.prepareUploadPart.bind(t3, e3), completeMultipartUpload: t3.opts.completeMultipartUpload.bind(t3, e3), abortMultipartUpload: t3.opts.abortMultipartUpload.bind(t3, e3), getChunkSize: t3.opts.getChunkSize ? t3.opts.getChunkSize.bind(t3) : null, onStart: function(n4) {
          var r4 = t3.uppy.getFile(e3.id);
          t3.uppy.setFileState(e3.id, { s3Multipart: mu({}, r4.s3Multipart, { key: n4.key, uploadId: n4.uploadId }) });
        }, onProgress: function(n4, r4) {
          t3.uppy.emit("upload-progress", e3, { uploader: t3, bytesUploaded: n4, bytesTotal: r4 });
        }, onError: function(n4) {
          t3.uppy.log(n4), t3.uppy.emit("upload-error", e3, n4), i2.done(), t3.resetUploaderReferences(e3.id), r3(n4);
        }, onSuccess: function(r4) {
          var a2 = { body: mu({}, r4), uploadURL: r4.location };
          i2.done(), t3.resetUploaderReferences(e3.id);
          var s2 = t3.uppy.getFile(e3.id);
          t3.uppy.emit("upload-success", s2 || e3, a2), r4.location && t3.uppy.log("Download " + o3.file.name + " from " + r4.location), n3(o3);
        }, onPartComplete: function(n4) {
          var r4 = t3.uppy.getFile(e3.id);
          r4 && t3.uppy.emit("s3-multipart:part-uploaded", r4, n4);
        }, limit: t3.opts.limit || 5, retryDelays: t3.opts.retryDelays || [] }, e3.s3Multipart));
        t3.uploaders[e3.id] = o3, t3.uploaderEvents[e3.id] = new kl(t3.uppy);
        var i2 = t3.requests.run(function() {
          return e3.isPaused || o3.start(), function() {
          };
        });
        t3.onFileRemove(e3.id, function(r4) {
          i2.abort(), t3.resetUploaderReferences(e3.id, { abort: true }), n3("upload " + r4.id + " was removed");
        }), t3.onCancelAll(e3.id, function() {
          i2.abort(), t3.resetUploaderReferences(e3.id, { abort: true }), n3("upload " + e3.id + " was canceled");
        }), t3.onFilePause(e3.id, function(e4) {
          e4 ? (i2.abort(), o3.pause()) : (i2.abort(), i2 = t3.requests.run(function() {
            return o3.start(), function() {
            };
          }));
        }), t3.onPauseAll(e3.id, function() {
          i2.abort(), o3.pause();
        }), t3.onResumeAll(e3.id, function() {
          i2.abort(), e3.error && o3.abort(), i2 = t3.requests.run(function() {
            return o3.start(), function() {
            };
          });
        }), e3.progress.uploadStarted && e3.isRestored || t3.uppy.emit("upload-started", e3);
      });
    }, o2.uploadRemote = function(e3) {
      var t3 = this;
      return this.resetUploaderReferences(e3.id), e3.progress.uploadStarted && e3.isRestored || this.uppy.emit("upload-started", e3), e3.serverToken ? this.connectToServerSocket(e3) : new Promise(function(n3, r3) {
        new (e3.remote.providerOptions.provider ? gu : yu)(t3.uppy, e3.remote.providerOptions).post(e3.remote.url, mu({}, e3.remote.body, { protocol: "s3-multipart", size: e3.data.size, metadata: e3.meta })).then(function(n4) {
          return t3.uppy.setFileState(e3.id, { serverToken: n4.token }), e3 = t3.uppy.getFile(e3.id);
        }).then(function(e4) {
          return t3.connectToServerSocket(e4);
        }).then(function() {
          n3();
        }).catch(function(n4) {
          t3.uppy.emit("upload-error", e3, n4), r3(n4);
        });
      });
    }, o2.connectToServerSocket = function(e3) {
      var t3 = this;
      return new Promise(function(n3, r3) {
        var o3 = e3.serverToken, i2 = Sl(e3.remote.companionUrl), a2 = new vu({ target: i2 + "/api/" + o3, autoOpen: false });
        t3.uploaderSockets[e3.id] = a2, t3.uploaderEvents[e3.id] = new kl(t3.uppy), t3.onFileRemove(e3.id, function(r4) {
          s2.abort(), a2.send("pause", {}), t3.resetUploaderReferences(e3.id, { abort: true }), n3("upload " + e3.id + " was removed");
        }), t3.onFilePause(e3.id, function(e4) {
          e4 ? (s2.abort(), a2.send("pause", {})) : (s2.abort(), s2 = t3.requests.run(function() {
            return a2.send("resume", {}), function() {
            };
          }));
        }), t3.onPauseAll(e3.id, function() {
          s2.abort(), a2.send("pause", {});
        }), t3.onCancelAll(e3.id, function() {
          s2.abort(), a2.send("pause", {}), t3.resetUploaderReferences(e3.id), n3("upload " + e3.id + " was canceled");
        }), t3.onResumeAll(e3.id, function() {
          s2.abort(), e3.error && a2.send("pause", {}), s2 = t3.requests.run(function() {
            a2.send("resume", {});
          });
        }), t3.onRetry(e3.id, function() {
          a2.isOpen && (a2.send("pause", {}), a2.send("resume", {}));
        }), t3.onRetryAll(e3.id, function() {
          a2.isOpen && (a2.send("pause", {}), a2.send("resume", {}));
        }), a2.on("progress", function(n4) {
          return Cl(t3, n4, e3);
        }), a2.on("error", function(n4) {
          t3.uppy.emit("upload-error", e3, new Error(n4.error)), t3.resetUploaderReferences(e3.id), s2.done(), r3(new Error(n4.error));
        }), a2.on("success", function(r4) {
          var o4 = { uploadURL: r4.url };
          t3.uppy.emit("upload-success", e3, o4), t3.resetUploaderReferences(e3.id), s2.done(), n3();
        });
        var s2 = t3.requests.run(function() {
          return a2.open(), e3.isPaused && a2.send("pause", {}), function() {
          };
        });
      });
    }, o2.upload = function(e3) {
      var t3 = this;
      if (0 === e3.length) return Promise.resolve();
      var n3 = e3.map(function(e4) {
        var n4 = t3.uppy.getFile(e4);
        return n4.isRemote ? t3.uploadRemote(n4) : t3.uploadFile(n4);
      });
      return Promise.all(n3);
    }, o2.onFileRemove = function(e3, t3) {
      this.uploaderEvents[e3].on("file-removed", function(n3) {
        e3 === n3.id && t3(n3.id);
      });
    }, o2.onFilePause = function(e3, t3) {
      this.uploaderEvents[e3].on("upload-pause", function(n3, r3) {
        e3 === n3 && t3(r3);
      });
    }, o2.onRetry = function(e3, t3) {
      this.uploaderEvents[e3].on("upload-retry", function(n3) {
        e3 === n3 && t3();
      });
    }, o2.onRetryAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("retry-all", function(r3) {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.onPauseAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("pause-all", function() {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.onCancelAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("cancel-all", function() {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.onResumeAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("resume-all", function() {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.install = function() {
      var e3 = this.uppy.getState().capabilities;
      this.uppy.setState({ capabilities: mu({}, e3, { resumableUploads: true }) }), this.uppy.addUploader(this.upload);
    }, o2.uninstall = function() {
      var e3 = this.uppy.getState().capabilities;
      this.uppy.setState({ capabilities: mu({}, e3, { resumableUploads: false }) }), this.uppy.removeUploader(this.upload);
    }, r2;
  }(ue.Plugin), cu.VERSION = "1.8.18", pu), wu = {};
  function Cu(e2) {
    return (Cu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e3) {
      return typeof e3;
    } : function(e3) {
      return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
    })(e2);
  }
  function Su(e2) {
    var t2 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
    return (Su = function(e3) {
      if (null === e3 || (n2 = e3, -1 === Function.toString.call(n2).indexOf("[native code]"))) return e3;
      var n2;
      if ("function" != typeof e3) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== t2) {
        if (t2.has(e3)) return t2.get(e3);
        t2.set(e3, r2);
      }
      function r2() {
        return ku(e3, arguments, Eu(this).constructor);
      }
      return r2.prototype = Object.create(e3.prototype, { constructor: { value: r2, enumerable: false, writable: true, configurable: true } }), Pu(r2, e3);
    })(e2);
  }
  function ku(e2, t2, n2) {
    return (ku = xu() ? Reflect.construct : function(e3, t3, n3) {
      var r2 = [null];
      r2.push.apply(r2, t3);
      var o2 = new (Function.bind.apply(e3, r2))();
      return n3 && Pu(o2, n3.prototype), o2;
    }).apply(null, arguments);
  }
  function xu() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" == typeof Proxy) return true;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), true;
    } catch (e2) {
      return false;
    }
  }
  function Pu(e2, t2) {
    return (Pu = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function Eu(e2) {
    return (Eu = Object.setPrototypeOf ? Object.getPrototypeOf : function(e3) {
      return e3.__proto__ || Object.getPrototypeOf(e3);
    })(e2);
  }
  Object.defineProperty(wu, "__esModule", { value: true }), wu.default = void 0;
  var Ou = function(e2) {
    !function(e3, t3) {
      if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
      e3.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e3, writable: true, configurable: true } }), t3 && Pu(e3, t3);
    }(r2, Su(Error));
    var t2, n2 = (t2 = r2, function() {
      var e3, n3 = Eu(t2);
      if (xu()) {
        var r3 = Eu(this).constructor;
        e3 = Reflect.construct(n3, arguments, r3);
      } else e3 = n3.apply(this, arguments);
      return function(e4, t3) {
        return !t3 || "object" !== Cu(t3) && "function" != typeof t3 ? function(e5) {
          if (void 0 === e5) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e5;
        }(e4) : t3;
      }(this, e3);
    });
    function r2(e3) {
      var t3, o2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
      if (function(e4, t4) {
        if (!(e4 instanceof t4)) throw new TypeError("Cannot call a class as a function");
      }(this, r2), (t3 = n2.call(this, e3)).originalRequest = i2, t3.originalResponse = a2, t3.causingError = o2, null != o2 && (e3 += ", caused by ".concat(o2.toString())), null != i2) {
        var s2 = i2.getHeader("X-Request-ID") || "n/a", l2 = i2.getMethod(), u2 = i2.getURL(), c2 = a2 ? a2.getStatus() : "n/a", p2 = a2 ? a2.getBody() || "" : "n/a";
        e3 += ", originated from request (method: ".concat(l2, ", url: ").concat(u2, ", response code: ").concat(c2, ", response text: ").concat(p2, ", request id: ").concat(s2, ")");
      }
      return t3.message = e3, t3;
    }
    return r2;
  }();
  wu.default = Ou;
  var Au = {};
  Object.defineProperty(Au, "__esModule", { value: true }), Au.default = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e2) {
      var t2 = 16 * Math.random() | 0;
      return ("x" == e2 ? t2 : 3 & t2 | 8).toString(16);
    });
  };
  var Uu = { exports: {} };
  (function(e2) {
    (function() {
      !function(e3, t2) {
        "object" == typeof Uu.exports ? Uu.exports = t2(e3) : t2(e3);
      }("undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e2 ? e2 : this, function(e3) {
        "use strict";
        var t2, n2 = (e3 = e3 || {}).Base64, r2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", o2 = function(e4) {
          for (var t3 = {}, n3 = 0, r3 = e4.length; n3 < r3; n3++) t3[e4.charAt(n3)] = n3;
          return t3;
        }(r2), i2 = String.fromCharCode, a2 = function(e4) {
          if (e4.length < 2) return (t3 = e4.charCodeAt(0)) < 128 ? e4 : t3 < 2048 ? i2(192 | t3 >>> 6) + i2(128 | 63 & t3) : i2(224 | t3 >>> 12 & 15) + i2(128 | t3 >>> 6 & 63) + i2(128 | 63 & t3);
          var t3 = 65536 + 1024 * (e4.charCodeAt(0) - 55296) + (e4.charCodeAt(1) - 56320);
          return i2(240 | t3 >>> 18 & 7) + i2(128 | t3 >>> 12 & 63) + i2(128 | t3 >>> 6 & 63) + i2(128 | 63 & t3);
        }, s2 = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, l2 = function(e4) {
          return e4.replace(s2, a2);
        }, u2 = function(e4) {
          var t3 = [0, 2, 1][e4.length % 3], n3 = e4.charCodeAt(0) << 16 | (e4.length > 1 ? e4.charCodeAt(1) : 0) << 8 | (e4.length > 2 ? e4.charCodeAt(2) : 0);
          return [r2.charAt(n3 >>> 18), r2.charAt(n3 >>> 12 & 63), t3 >= 2 ? "=" : r2.charAt(n3 >>> 6 & 63), t3 >= 1 ? "=" : r2.charAt(63 & n3)].join("");
        }, c2 = e3.btoa && "function" == typeof e3.btoa ? function(t3) {
          return e3.btoa(t3);
        } : function(e4) {
          if (e4.match(/[^\x00-\xFF]/)) throw new RangeError("The string contains invalid characters.");
          return e4.replace(/[\s\S]{1,3}/g, u2);
        }, p2 = function(e4) {
          return c2(l2(String(e4)));
        }, d2 = function(e4) {
          return e4.replace(/[+\/]/g, function(e5) {
            return "+" == e5 ? "-" : "_";
          }).replace(/=/g, "");
        }, h2 = function(e4, t3) {
          return t3 ? d2(p2(e4)) : p2(e4);
        };
        e3.Uint8Array && (t2 = function(e4, t3) {
          for (var n3 = "", o3 = 0, i3 = e4.length; o3 < i3; o3 += 3) {
            var a3 = e4[o3], s3 = e4[o3 + 1], l3 = e4[o3 + 2], u3 = a3 << 16 | s3 << 8 | l3;
            n3 += r2.charAt(u3 >>> 18) + r2.charAt(u3 >>> 12 & 63) + (void 0 !== s3 ? r2.charAt(u3 >>> 6 & 63) : "=") + (void 0 !== l3 ? r2.charAt(63 & u3) : "=");
          }
          return t3 ? d2(n3) : n3;
        });
        var f2, m2 = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, v2 = function(e4) {
          switch (e4.length) {
            case 4:
              var t3 = ((7 & e4.charCodeAt(0)) << 18 | (63 & e4.charCodeAt(1)) << 12 | (63 & e4.charCodeAt(2)) << 6 | 63 & e4.charCodeAt(3)) - 65536;
              return i2(55296 + (t3 >>> 10)) + i2(56320 + (1023 & t3));
            case 3:
              return i2((15 & e4.charCodeAt(0)) << 12 | (63 & e4.charCodeAt(1)) << 6 | 63 & e4.charCodeAt(2));
            default:
              return i2((31 & e4.charCodeAt(0)) << 6 | 63 & e4.charCodeAt(1));
          }
        }, g2 = function(e4) {
          return e4.replace(m2, v2);
        }, y2 = function(e4) {
          var t3 = e4.length, n3 = t3 % 4, r3 = (t3 > 0 ? o2[e4.charAt(0)] << 18 : 0) | (t3 > 1 ? o2[e4.charAt(1)] << 12 : 0) | (t3 > 2 ? o2[e4.charAt(2)] << 6 : 0) | (t3 > 3 ? o2[e4.charAt(3)] : 0), a3 = [i2(r3 >>> 16), i2(r3 >>> 8 & 255), i2(255 & r3)];
          return a3.length -= [0, 0, 2, 1][n3], a3.join("");
        }, b2 = e3.atob && "function" == typeof e3.atob ? function(t3) {
          return e3.atob(t3);
        } : function(e4) {
          return e4.replace(/\S{1,4}/g, y2);
        }, _2 = function(e4) {
          return b2(String(e4).replace(/[^A-Za-z0-9\+\/]/g, ""));
        }, w2 = function(e4) {
          return String(e4).replace(/[-_]/g, function(e5) {
            return "-" == e5 ? "+" : "/";
          }).replace(/[^A-Za-z0-9\+\/]/g, "");
        }, C2 = function(e4) {
          return function(e5) {
            return g2(b2(e5));
          }(w2(e4));
        };
        if (e3.Uint8Array && (f2 = function(e4) {
          return Uint8Array.from(_2(w2(e4)), function(e5) {
            return e5.charCodeAt(0);
          });
        }), e3.Base64 = { VERSION: "2.6.4", atob: _2, btoa: c2, fromBase64: C2, toBase64: h2, utob: l2, encode: h2, encodeURI: function(e4) {
          return h2(e4, true);
        }, btou: g2, decode: C2, noConflict: function() {
          var t3 = e3.Base64;
          return e3.Base64 = n2, t3;
        }, fromUint8Array: t2, toUint8Array: f2 }, "function" == typeof Object.defineProperty) {
          var S2 = function(e4) {
            return { value: e4, enumerable: false, writable: true, configurable: true };
          };
          e3.Base64.extendString = function() {
            Object.defineProperty(String.prototype, "fromBase64", S2(function() {
              return C2(this);
            })), Object.defineProperty(String.prototype, "toBase64", S2(function(e4) {
              return h2(this, e4);
            })), Object.defineProperty(String.prototype, "toBase64URI", S2(function() {
              return h2(this, true);
            }));
          };
        }
        return e3.Meteor && (Base64 = e3.Base64), !!Uu.exports && (Uu.exports.Base64 = e3.Base64), { Base64: e3.Base64 };
      });
    }).call(this);
  }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}), Uu = Uu.exports;
  var Nu = {};
  Object.defineProperty(Nu, "__esModule", { value: true }), Nu.enableDebugLog = function() {
    Tu = true;
  }, Nu.log = function(e2) {
    Tu && console.log(e2);
  };
  var Tu = false, Ru = {};
  Object.defineProperty(Ru, "__esModule", { value: true }), Ru.default = void 0;
  var Fu = Bu(wu), Du = Bu(Au), Mu = Bu(Ve);
  function Bu(e2) {
    return e2 && e2.__esModule ? e2 : { default: e2 };
  }
  function Iu(e2, t2) {
    var n2 = Object.keys(e2);
    if (Object.getOwnPropertySymbols) {
      var r2 = Object.getOwnPropertySymbols(e2);
      t2 && (r2 = r2.filter(function(t3) {
        return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
      })), n2.push.apply(n2, r2);
    }
    return n2;
  }
  function Lu(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var n2 = null != arguments[t2] ? arguments[t2] : {};
      t2 % 2 ? Iu(Object(n2), true).forEach(function(t3) {
        ju(e2, t3, n2[t3]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(n2)) : Iu(Object(n2)).forEach(function(t3) {
        Object.defineProperty(e2, t3, Object.getOwnPropertyDescriptor(n2, t3));
      });
    }
    return e2;
  }
  function ju(e2, t2, n2) {
    return t2 in e2 ? Object.defineProperty(e2, t2, { value: n2, enumerable: true, configurable: true, writable: true }) : e2[t2] = n2, e2;
  }
  function zu(e2, t2) {
    for (var n2 = 0; n2 < t2.length; n2++) {
      var r2 = t2[n2];
      r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
    }
  }
  var Hu = function() {
    function e2(t3, n3) {
      !function(e3, t4) {
        if (!(e3 instanceof t4)) throw new TypeError("Cannot call a class as a function");
      }(this, e2), "resume" in n3 && console.log("tus: The `resume` option has been removed in tus-js-client v2. Please use the URL storage API instead."), this.options = n3, this._urlStorage = this.options.urlStorage, this.file = t3, this.url = null, this._req = null, this._fingerprint = null, this._urlStorageKey = null, this._offset = null, this._aborted = false, this._size = null, this._source = null, this._retryAttempt = 0, this._retryTimeout = null, this._offsetBeforeRetry = 0, this._parallelUploads = null, this._parallelUploadUrls = null;
    }
    var t2, n2, r2;
    return t2 = e2, r2 = [{ key: "terminate", value: function(t3) {
      var n3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r3 = arguments.length > 2 ? arguments[2] : void 0;
      if ("function" == typeof n3 || "function" == typeof r3) throw new Error("tus: the terminate function does not accept a callback since v2 anymore; please use the returned Promise instead");
      var o2 = qu("DELETE", t3, n3);
      return o2.send().then(function(e3) {
        if (204 !== e3.getStatus()) throw new Fu.default("tus: unexpected response while terminating upload", null, o2, e3);
      }).catch(function(r4) {
        if (r4 instanceof Fu.default || (r4 = new Fu.default("tus: failed to terminate upload", r4, o2, null)), !Xu(r4, 0, n3)) throw r4;
        var i2 = n3.retryDelays[0], a2 = n3.retryDelays.slice(1), s2 = Lu({}, n3, { retryDelays: a2 });
        return new Promise(function(e3) {
          return setTimeout(e3, i2);
        }).then(function() {
          return e2.terminate(t3, s2);
        });
      });
    } }], (n2 = [{ key: "findPreviousUploads", value: function() {
      var e3 = this;
      return this.options.fingerprint(this.file, this.options).then(function(t3) {
        return e3._urlStorage.findUploadsByFingerprint(t3);
      });
    } }, { key: "resumeFromPreviousUpload", value: function(e3) {
      this.url = e3.uploadUrl || null, this._parallelUploadUrls = e3.parallelUploadUrls || null, this._urlStorageKey = e3.urlStorageKey;
    } }, { key: "start", value: function() {
      var e3 = this, t3 = this.file;
      if (t3) if (this.options.endpoint || this.options.uploadUrl) {
        var n3 = this.options.retryDelays;
        null == n3 || "[object Array]" === Object.prototype.toString.call(n3) ? (this.options.parallelUploads > 1 && ["uploadUrl", "uploadSize", "uploadLengthDeferred"].forEach(function(t4) {
          e3.options[t4] && e3._emitError(new Error("tus: cannot use the ".concat(t4, " option when parallelUploads is enabled")));
        }), this.options.fingerprint(t3, this.options).then(function(n4) {
          return null == n4 ? (0, Nu.log)("No fingerprint was calculated meaning that the upload cannot be stored in the URL storage.") : (0, Nu.log)("Calculated fingerprint: ".concat(n4)), e3._fingerprint = n4, e3._source ? e3._source : e3.options.fileReader.openFile(t3, e3.options.chunkSize);
        }).then(function(t4) {
          e3._source = t4, e3.options.parallelUploads > 1 || null != e3._parallelUploadUrls ? e3._startParallelUpload() : e3._startSingleUpload();
        }).catch(function(t4) {
          e3._emitError(t4);
        })) : this._emitError(new Error("tus: the `retryDelays` option must either be an array or null"));
      } else this._emitError(new Error("tus: neither an endpoint or an upload URL is provided"));
      else this._emitError(new Error("tus: no file or stream to upload provided"));
    } }, { key: "_startParallelUpload", value: function() {
      var t3 = this, n3 = this._size = this._source.size, r3 = 0;
      this._parallelUploads = [];
      var o2 = null != this._parallelUploadUrls ? this._parallelUploadUrls.length : this.options.parallelUploads, i2 = function(e3, t4, n4) {
        for (var r4 = Math.floor(e3 / t4), o3 = [], i3 = 0; i3 < t4; i3++) o3.push({ start: r4 * i3, end: r4 * (i3 + 1) });
        return o3[t4 - 1].end = e3, n4 && o3.forEach(function(e4, t5) {
          e4.uploadUrl = n4[t5] || null;
        }), o3;
      }(this._source.size, o2, this._parallelUploadUrls);
      this._parallelUploadUrls = new Array(i2.length);
      var a2, s2 = i2.map(function(o3, a3) {
        var s3 = 0;
        return t3._source.slice(o3.start, o3.end).then(function(l2) {
          var u2 = l2.value;
          return new Promise(function(l3, c2) {
            var p2 = Lu({}, t3.options, { uploadUrl: o3.uploadUrl || null, storeFingerprintForResuming: false, removeFingerprintOnSuccess: false, parallelUploads: 1, metadata: {}, headers: Lu({}, t3.options.headers, { "Upload-Concat": "partial" }), onSuccess: l3, onError: c2, onProgress: function(e3) {
              r3 = r3 - s3 + e3, s3 = e3, t3._emitProgress(r3, n3);
            }, _onUploadUrlAvailable: function() {
              t3._parallelUploadUrls[a3] = d2.url, t3._parallelUploadUrls.filter(function(e3) {
                return !!e3;
              }).length === i2.length && t3._saveUploadInUrlStorage();
            } }), d2 = new e2(u2, p2);
            d2.start(), t3._parallelUploads.push(d2);
          });
        });
      });
      Promise.all(s2).then(function() {
        (a2 = t3._openRequest("POST", t3.options.endpoint)).setHeader("Upload-Concat", "final;".concat(t3._parallelUploadUrls.join(" ")));
        var e3 = Wu(t3.options.metadata);
        return "" !== e3 && a2.setHeader("Upload-Metadata", e3), t3._sendRequest(a2, null);
      }).then(function(e3) {
        if (Vu(e3.getStatus(), 200)) {
          var n4 = e3.getHeader("Location");
          null != n4 ? (t3.url = Gu(t3.options.endpoint, n4), (0, Nu.log)("Created upload at ".concat(t3.url)), t3._emitSuccess()) : t3._emitHttpError(a2, e3, "tus: invalid or missing Location header");
        } else t3._emitHttpError(a2, e3, "tus: unexpected response while creating upload");
      }).catch(function(e3) {
        t3._emitError(e3);
      });
    } }, { key: "_startSingleUpload", value: function() {
      if (this.options.uploadLengthDeferred) this._size = null;
      else if (null != this.options.uploadSize) {
        if (this._size = +this.options.uploadSize, isNaN(this._size)) return void this._emitError(new Error("tus: cannot convert `uploadSize` option into a number"));
      } else if (this._size = this._source.size, null == this._size) return void this._emitError(new Error("tus: cannot automatically derive upload's size from input and must be specified manually using the `uploadSize` option"));
      return this._aborted = false, null != this.url ? ((0, Nu.log)("Resuming upload from previous URL: ".concat(this.url)), void this._resumeUpload()) : null != this.options.uploadUrl ? ((0, Nu.log)("Resuming upload from provided URL: ".concat(this.options.url)), this.url = this.options.uploadUrl, void this._resumeUpload()) : ((0, Nu.log)("Creating a new upload"), void this._createUpload());
    } }, { key: "abort", value: function(t3, n3) {
      var r3 = this;
      if ("function" == typeof n3) throw new Error("tus: the abort function does not accept a callback since v2 anymore; please use the returned Promise instead");
      return null != this._parallelUploads && this._parallelUploads.forEach(function(e3) {
        e3.abort(t3);
      }), null !== this._req && (this._req.abort(), this._source.close()), this._aborted = true, null != this._retryTimeout && (clearTimeout(this._retryTimeout), this._retryTimeout = null), t3 && null != this.url ? e2.terminate(this.url, this.options).then(function() {
        return r3._removeFromUrlStorage();
      }) : Promise.resolve();
    } }, { key: "_emitHttpError", value: function(e3, t3, n3, r3) {
      this._emitError(new Fu.default(n3, r3, e3, t3));
    } }, { key: "_emitError", value: function(e3) {
      var t3 = this;
      if (!this._aborted) {
        if (null != this.options.retryDelays && (null != this._offset && this._offset > this._offsetBeforeRetry && (this._retryAttempt = 0), Xu(e3, this._retryAttempt, this.options))) {
          var n3 = this.options.retryDelays[this._retryAttempt++];
          return this._offsetBeforeRetry = this._offset, void (this._retryTimeout = setTimeout(function() {
            t3.start();
          }, n3));
        }
        if ("function" != typeof this.options.onError) throw e3;
        this.options.onError(e3);
      }
    } }, { key: "_emitSuccess", value: function() {
      this.options.removeFingerprintOnSuccess && this._removeFromUrlStorage(), "function" == typeof this.options.onSuccess && this.options.onSuccess();
    } }, { key: "_emitProgress", value: function(e3, t3) {
      "function" == typeof this.options.onProgress && this.options.onProgress(e3, t3);
    } }, { key: "_emitChunkComplete", value: function(e3, t3, n3) {
      "function" == typeof this.options.onChunkComplete && this.options.onChunkComplete(e3, t3, n3);
    } }, { key: "_createUpload", value: function() {
      var e3 = this;
      if (this.options.endpoint) {
        var t3 = this._openRequest("POST", this.options.endpoint);
        this.options.uploadLengthDeferred ? t3.setHeader("Upload-Defer-Length", 1) : t3.setHeader("Upload-Length", this._size);
        var n3, r3 = Wu(this.options.metadata);
        "" !== r3 && t3.setHeader("Upload-Metadata", r3), this.options.uploadDataDuringCreation && !this.options.uploadLengthDeferred ? (this._offset = 0, n3 = this._addChunkToRequest(t3)) : n3 = this._sendRequest(t3, null), n3.then(function(n4) {
          if (Vu(n4.getStatus(), 200)) {
            var r4 = n4.getHeader("Location");
            if (null != r4) {
              if (e3.url = Gu(e3.options.endpoint, r4), (0, Nu.log)("Created upload at ".concat(e3.url)), "function" == typeof e3.options._onUploadUrlAvailable && e3.options._onUploadUrlAvailable(), 0 === e3._size) return e3._emitSuccess(), void e3._source.close();
              e3._saveUploadInUrlStorage(), e3.options.uploadDataDuringCreation ? e3._handleUploadResponse(t3, n4) : (e3._offset = 0, e3._performUpload());
            } else e3._emitHttpError(t3, n4, "tus: invalid or missing Location header");
          } else e3._emitHttpError(t3, n4, "tus: unexpected response while creating upload");
        }).catch(function(n4) {
          e3._emitHttpError(t3, null, "tus: failed to create upload", n4);
        });
      } else this._emitError(new Error("tus: unable to create upload because no endpoint is provided"));
    } }, { key: "_resumeUpload", value: function() {
      var e3 = this, t3 = this._openRequest("HEAD", this.url);
      this._sendRequest(t3, null).then(function(n3) {
        var r3 = n3.getStatus();
        if (!Vu(r3, 200)) return Vu(r3, 400) && e3._removeFromUrlStorage(), 423 === r3 ? void e3._emitHttpError(t3, n3, "tus: upload is currently locked; retry later") : e3.options.endpoint ? (e3.url = null, void e3._createUpload()) : void e3._emitHttpError(t3, n3, "tus: unable to resume upload (new upload cannot be created without an endpoint)");
        var o2 = parseInt(n3.getHeader("Upload-Offset"), 10);
        if (isNaN(o2)) e3._emitHttpError(t3, n3, "tus: invalid or missing offset value");
        else {
          var i2 = parseInt(n3.getHeader("Upload-Length"), 10);
          if (!isNaN(i2) || e3.options.uploadLengthDeferred) {
            if ("function" == typeof e3.options._onUploadUrlAvailable && e3.options._onUploadUrlAvailable(), o2 === i2) return e3._emitProgress(i2, i2), void e3._emitSuccess();
            e3._offset = o2, e3._performUpload();
          } else e3._emitHttpError(t3, n3, "tus: invalid or missing length value");
        }
      }).catch(function(n3) {
        e3._emitHttpError(t3, null, "tus: failed to resume upload", n3);
      });
    } }, { key: "_performUpload", value: function() {
      var e3, t3 = this;
      this._aborted || (this.options.overridePatchMethod ? (e3 = this._openRequest("POST", this.url)).setHeader("X-HTTP-Method-Override", "PATCH") : e3 = this._openRequest("PATCH", this.url), e3.setHeader("Upload-Offset", this._offset), this._addChunkToRequest(e3).then(function(n3) {
        Vu(n3.getStatus(), 200) ? t3._handleUploadResponse(e3, n3) : t3._emitHttpError(e3, n3, "tus: unexpected response while uploading chunk");
      }).catch(function(n3) {
        t3._aborted || t3._emitHttpError(e3, null, "tus: failed to upload chunk at offset " + t3._offset, n3);
      }));
    } }, { key: "_addChunkToRequest", value: function(e3) {
      var t3 = this, n3 = this._offset, r3 = this._offset + this.options.chunkSize;
      return e3.setProgressHandler(function(e4) {
        t3._emitProgress(n3 + e4, t3._size);
      }), e3.setHeader("Content-Type", "application/offset+octet-stream"), (r3 === 1 / 0 || r3 > this._size) && !this.options.uploadLengthDeferred && (r3 = this._size), this._source.slice(n3, r3).then(function(n4) {
        var r4 = n4.value, o2 = n4.done;
        return t3.options.uploadLengthDeferred && o2 && (t3._size = t3._offset + (r4 && r4.size ? r4.size : 0), e3.setHeader("Upload-Length", t3._size)), null === r4 ? t3._sendRequest(e3) : (t3._emitProgress(t3._offset, t3._size), t3._sendRequest(e3, r4));
      });
    } }, { key: "_handleUploadResponse", value: function(e3, t3) {
      var n3 = parseInt(t3.getHeader("Upload-Offset"), 10);
      if (isNaN(n3)) this._emitHttpError(e3, t3, "tus: invalid or missing offset value");
      else {
        if (this._emitProgress(n3, this._size), this._emitChunkComplete(n3 - this._offset, n3, this._size), this._offset = n3, n3 == this._size) return this._emitSuccess(), void this._source.close();
        this._performUpload();
      }
    } }, { key: "_openRequest", value: function(e3, t3) {
      var n3 = qu(e3, t3, this.options);
      return this._req = n3, n3;
    } }, { key: "_removeFromUrlStorage", value: function() {
      var e3 = this;
      this._urlStorageKey && (this._urlStorage.removeUpload(this._urlStorageKey).catch(function(t3) {
        e3._emitError(t3);
      }), this._urlStorageKey = null);
    } }, { key: "_saveUploadInUrlStorage", value: function() {
      var e3 = this;
      if (this.options.storeFingerprintForResuming && this._fingerprint) {
        var t3 = { size: this._size, metadata: this.options.metadata, creationTime: (/* @__PURE__ */ new Date()).toString() };
        this._parallelUploads ? t3.parallelUploadUrls = this._parallelUploadUrls : t3.uploadUrl = this.url, this._urlStorage.addUpload(this._fingerprint, t3).then(function(t4) {
          return e3._urlStorageKey = t4;
        }).catch(function(t4) {
          e3._emitError(t4);
        });
      }
    } }, { key: "_sendRequest", value: function(e3) {
      var t3 = this, n3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      return "function" == typeof this.options.onBeforeRequest && this.options.onBeforeRequest(e3), e3.send(n3).then(function(n4) {
        return "function" == typeof t3.options.onAfterResponse && t3.options.onAfterResponse(e3, n4), n4;
      });
    } }]) && zu(t2.prototype, n2), r2 && zu(t2, r2), e2;
  }();
  function Wu(e2) {
    var t2 = [];
    for (var n2 in e2) t2.push(n2 + " " + Uu.Base64.encode(e2[n2]));
    return t2.join(",");
  }
  function Vu(e2, t2) {
    return e2 >= t2 && e2 < t2 + 100;
  }
  function qu(e2, t2, n2) {
    var r2 = n2.httpStack.createRequest(e2, t2);
    r2.setHeader("Tus-Resumable", "1.0.0");
    var o2 = n2.headers || {};
    for (var i2 in o2) r2.setHeader(i2, o2[i2]);
    if (n2.addRequestId) {
      var a2 = (0, Du.default)();
      r2.setHeader("X-Request-ID", a2);
    }
    return r2;
  }
  function Xu(e2, t2, n2) {
    var r2, o2 = e2.originalResponse ? e2.originalResponse.getStatus() : 0, i2 = !Vu(o2, 400) || 409 === o2 || 423 === o2;
    return null != n2.retryDelays && t2 < n2.retryDelays.length && null != e2.originalRequest && i2 && (r2 = true, "undefined" != typeof window && "navigator" in window && false === window.navigator.onLine && (r2 = false), r2);
  }
  function Gu(e2, t2) {
    return new Mu.default(t2, e2).toString();
  }
  Hu.defaultOptions = { endpoint: null, uploadUrl: null, metadata: {}, fingerprint: null, uploadSize: null, onProgress: null, onChunkComplete: null, onSuccess: null, onError: null, _onUploadUrlAvailable: null, overridePatchMethod: false, headers: {}, addRequestId: false, onBeforeRequest: null, onAfterResponse: null, chunkSize: 1 / 0, retryDelays: [0, 1e3, 3e3, 5e3], parallelUploads: 1, storeFingerprintForResuming: true, removeFingerprintOnSuccess: false, uploadLengthDeferred: false, uploadDataDuringCreation: false, urlStorage: null, fileReader: null, httpStack: null };
  var Yu = Hu;
  Ru.default = Yu;
  var $u = {};
  function Ku(e2, t2) {
    for (var n2 = 0; n2 < t2.length; n2++) {
      var r2 = t2[n2];
      r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
    }
  }
  Object.defineProperty($u, "__esModule", { value: true }), $u.default = void 0;
  var Ju = function() {
    function e2() {
      !function(e3, t3) {
        if (!(e3 instanceof t3)) throw new TypeError("Cannot call a class as a function");
      }(this, e2);
    }
    var t2, n2;
    return t2 = e2, (n2 = [{ key: "listAllUploads", value: function() {
      return Promise.resolve([]);
    } }, { key: "findUploadsByFingerprint", value: function(e3) {
      return Promise.resolve([]);
    } }, { key: "removeUpload", value: function(e3) {
      return Promise.resolve();
    } }, { key: "addUpload", value: function(e3, t3) {
      return Promise.resolve(null);
    } }]) && Ku(t2.prototype, n2), e2;
  }();
  $u.default = Ju;
  var Qu = {};
  function Zu(e2, t2) {
    for (var n2 = 0; n2 < t2.length; n2++) {
      var r2 = t2[n2];
      r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
    }
  }
  Object.defineProperty(Qu, "__esModule", { value: true }), Qu.WebStorageUrlStorage = Qu.canStoreURLs = void 0;
  var ec = false;
  try {
    ec = "localStorage" in window;
    var tc = "tusSupport";
    localStorage.setItem(tc, localStorage.getItem(tc));
  } catch (zf) {
    if (zf.code !== zf.SECURITY_ERR && zf.code !== zf.QUOTA_EXCEEDED_ERR) throw zf;
    ec = false;
  }
  var nc = ec;
  Qu.canStoreURLs = nc;
  var rc = function() {
    function e2() {
      !function(e3, t3) {
        if (!(e3 instanceof t3)) throw new TypeError("Cannot call a class as a function");
      }(this, e2);
    }
    var t2, n2;
    return t2 = e2, (n2 = [{ key: "findAllUploads", value: function() {
      var e3 = this._findEntries("tus::");
      return Promise.resolve(e3);
    } }, { key: "findUploadsByFingerprint", value: function(e3) {
      var t3 = this._findEntries("tus::".concat(e3, "::"));
      return Promise.resolve(t3);
    } }, { key: "removeUpload", value: function(e3) {
      return localStorage.removeItem(e3), Promise.resolve();
    } }, { key: "addUpload", value: function(e3, t3) {
      var n3 = Math.round(1e12 * Math.random()), r2 = "tus::".concat(e3, "::").concat(n3);
      return localStorage.setItem(r2, JSON.stringify(t3)), Promise.resolve(r2);
    } }, { key: "_findEntries", value: function(e3) {
      for (var t3 = [], n3 = 0; n3 < localStorage.length; n3++) {
        var r2 = localStorage.key(n3);
        if (0 === r2.indexOf(e3)) try {
          var o2 = JSON.parse(localStorage.getItem(r2));
          o2.urlStorageKey = r2, t3.push(o2);
        } catch (zf) {
        }
      }
      return t3;
    } }]) && Zu(t2.prototype, n2), e2;
  }();
  Qu.WebStorageUrlStorage = rc;
  var oc = {};
  function ic(e2, t2) {
    if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
  }
  function ac(e2, t2) {
    for (var n2 = 0; n2 < t2.length; n2++) {
      var r2 = t2[n2];
      r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
    }
  }
  function sc(e2, t2, n2) {
    return t2 && ac(e2.prototype, t2), n2 && ac(e2, n2), e2;
  }
  Object.defineProperty(oc, "__esModule", { value: true }), oc.default = void 0;
  var lc = function() {
    function e2() {
      ic(this, e2);
    }
    return sc(e2, [{ key: "createRequest", value: function(e3, t2) {
      return new uc(e3, t2);
    } }, { key: "getName", value: function() {
      return "XHRHttpStack";
    } }]), e2;
  }();
  oc.default = lc;
  var uc = function() {
    function e2(t2, n2) {
      ic(this, e2), this._xhr = new XMLHttpRequest(), this._xhr.open(t2, n2, true), this._method = t2, this._url = n2, this._headers = {};
    }
    return sc(e2, [{ key: "getMethod", value: function() {
      return this._method;
    } }, { key: "getURL", value: function() {
      return this._url;
    } }, { key: "setHeader", value: function(e3, t2) {
      this._xhr.setRequestHeader(e3, t2), this._headers[e3] = t2;
    } }, { key: "getHeader", value: function(e3) {
      return this._headers[e3];
    } }, { key: "setProgressHandler", value: function(e3) {
      "upload" in this._xhr && (this._xhr.upload.onprogress = function(t2) {
        t2.lengthComputable && e3(t2.loaded);
      });
    } }, { key: "send", value: function() {
      var e3 = this, t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
      return new Promise(function(n2, r2) {
        e3._xhr.onload = function() {
          n2(new cc(e3._xhr));
        }, e3._xhr.onerror = function(e4) {
          r2(e4);
        }, e3._xhr.send(t2);
      });
    } }, { key: "abort", value: function() {
      return this._xhr.abort(), Promise.resolve();
    } }, { key: "getUnderlyingObject", value: function() {
      return this._xhr;
    } }]), e2;
  }(), cc = function() {
    function e2(t2) {
      ic(this, e2), this._xhr = t2;
    }
    return sc(e2, [{ key: "getStatus", value: function() {
      return this._xhr.status;
    } }, { key: "getHeader", value: function(e3) {
      return this._xhr.getResponseHeader(e3);
    } }, { key: "getBody", value: function() {
      return this._xhr.responseText;
    } }, { key: "getUnderlyingObject", value: function() {
      return this._xhr;
    } }]), e2;
  }(), pc = {};
  Object.defineProperty(pc, "__esModule", { value: true }), pc.default = void 0;
  pc.default = function() {
    return "undefined" != typeof navigator && "string" == typeof navigator.product && "reactnative" === navigator.product.toLowerCase();
  };
  var dc = {};
  Object.defineProperty(dc, "__esModule", { value: true }), dc.default = function(e2) {
    return new Promise(function(t2, n2) {
      var r2 = new XMLHttpRequest();
      r2.responseType = "blob", r2.onload = function() {
        var e3 = r2.response;
        t2(e3);
      }, r2.onerror = function(e3) {
        n2(e3);
      }, r2.open("GET", e2), r2.send();
    });
  };
  var hc = {};
  Object.defineProperty(hc, "__esModule", { value: true }), hc.default = void 0;
  hc.default = function() {
    return "undefined" != typeof window && (void 0 !== window.PhoneGap || void 0 !== window.Cordova || void 0 !== window.cordova);
  };
  var fc = {};
  Object.defineProperty(fc, "__esModule", { value: true }), fc.default = function(e2) {
    return new Promise(function(t2, n2) {
      var r2 = new FileReader();
      r2.onload = function() {
        var e3 = new Uint8Array(r2.result);
        t2({ value: e3 });
      }, r2.onerror = function(e3) {
        n2(e3);
      }, r2.readAsArrayBuffer(e2);
    });
  };
  var mc = {};
  Object.defineProperty(mc, "__esModule", { value: true }), mc.default = void 0;
  var vc = _c(pc), gc = _c(dc), yc = _c(hc), bc = _c(fc);
  function _c(e2) {
    return e2 && e2.__esModule ? e2 : { default: e2 };
  }
  function wc(e2, t2) {
    if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
  }
  function Cc(e2, t2) {
    for (var n2 = 0; n2 < t2.length; n2++) {
      var r2 = t2[n2];
      r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
    }
  }
  function Sc(e2, t2, n2) {
    return t2 && Cc(e2.prototype, t2), n2 && Cc(e2, n2), e2;
  }
  var kc = function() {
    function e2(t2) {
      wc(this, e2), this._file = t2, this.size = t2.size;
    }
    return Sc(e2, [{ key: "slice", value: function(e3, t2) {
      if ((0, yc.default)()) return (0, bc.default)(this._file.slice(e3, t2));
      var n2 = this._file.slice(e3, t2);
      return Promise.resolve({ value: n2 });
    } }, { key: "close", value: function() {
    } }]), e2;
  }(), xc = function() {
    function e2(t2, n2) {
      wc(this, e2), this._chunkSize = n2, this._buffer = void 0, this._bufferOffset = 0, this._reader = t2, this._done = false;
    }
    return Sc(e2, [{ key: "slice", value: function(e3, t2) {
      return e3 < this._bufferOffset ? Promise.reject(new Error("Requested data is before the reader's current offset")) : this._readUntilEnoughDataOrDone(e3, t2);
    } }, { key: "_readUntilEnoughDataOrDone", value: function(e3, t2) {
      var n2 = this, r2 = t2 <= this._bufferOffset + Pc(this._buffer);
      if (this._done || r2) {
        var o2 = this._getDataFromBuffer(e3, t2), i2 = null == o2 && this._done;
        return Promise.resolve({ value: o2, done: i2 });
      }
      return this._reader.read().then(function(r3) {
        var o3 = r3.value;
        return r3.done ? n2._done = true : void 0 === n2._buffer ? n2._buffer = o3 : n2._buffer = function(e4, t3) {
          if (e4.concat) return e4.concat(t3);
          if (e4 instanceof Blob) return new Blob([e4, t3], { type: e4.type });
          if (e4.set) {
            var n3 = new e4.constructor(e4.length + t3.length);
            return n3.set(e4), n3.set(t3, e4.length), n3;
          }
          throw new Error("Unknown data type");
        }(n2._buffer, o3), n2._readUntilEnoughDataOrDone(e3, t2);
      });
    } }, { key: "_getDataFromBuffer", value: function(e3, t2) {
      e3 > this._bufferOffset && (this._buffer = this._buffer.slice(e3 - this._bufferOffset), this._bufferOffset = e3);
      var n2 = 0 === Pc(this._buffer);
      return this._done && n2 ? null : this._buffer.slice(0, t2 - e3);
    } }, { key: "close", value: function() {
      this._reader.cancel && this._reader.cancel();
    } }]), e2;
  }();
  function Pc(e2) {
    return void 0 === e2 ? 0 : void 0 !== e2.size ? e2.size : e2.length;
  }
  var Ec = function() {
    function e2() {
      wc(this, e2);
    }
    return Sc(e2, [{ key: "openFile", value: function(e3, t2) {
      return (0, vc.default)() && e3 && void 0 !== e3.uri ? (0, gc.default)(e3.uri).then(function(e4) {
        return new kc(e4);
      }).catch(function(e4) {
        throw new Error("tus: cannot fetch `file.uri` as Blob, make sure the uri is correct and accessible. " + e4);
      }) : "function" == typeof e3.slice && void 0 !== e3.size ? Promise.resolve(new kc(e3)) : "function" == typeof e3.read ? (t2 = +t2, isFinite(t2) ? Promise.resolve(new xc(e3, t2)) : Promise.reject(new Error("cannot create source for stream without a finite value for the `chunkSize` option"))) : Promise.reject(new Error("source object may only be an instance of File, Blob, or Reader in this environment"));
    } }]), e2;
  }();
  mc.default = Ec;
  var Oc = {};
  Object.defineProperty(Oc, "__esModule", { value: true }), Oc.default = function(e2, t2) {
    return (0, Uc.default)() ? Promise.resolve(function(e3, t3) {
      var n2 = e3.exif ? function(e4) {
        var t4 = 0;
        if (0 === e4.length) return t4;
        for (var n3 = 0; n3 < e4.length; n3++) {
          t4 = (t4 << 5) - t4 + e4.charCodeAt(n3), t4 &= t4;
        }
        return t4;
      }(JSON.stringify(e3.exif)) : "noexif";
      return ["tus-rn", e3.name || "noname", e3.size || "nosize", n2, t3.endpoint].join("/");
    }(e2, t2)) : Promise.resolve(["tus-br", e2.name, e2.type, e2.size, e2.lastModified, t2.endpoint].join("-"));
  };
  var Ac, Uc = (Ac = pc) && Ac.__esModule ? Ac : { default: Ac }, Nc = {};
  Object.defineProperty(Nc, "__esModule", { value: true }), Object.defineProperty(Nc, "enableDebugLog", { enumerable: true, get: function() {
    return Nu.enableDebugLog;
  } }), Object.defineProperty(Nc, "canStoreURLs", { enumerable: true, get: function() {
    return Qu.canStoreURLs;
  } }), Nc.defaultOptions = Nc.Upload = void 0;
  var Tc = Bc(Ru), Rc = Bc($u), Fc = Bc(oc), Dc = Bc(mc), Mc = Bc(Oc);
  function Bc(e2) {
    return e2 && e2.__esModule ? e2 : { default: e2 };
  }
  function Ic(e2) {
    return (Ic = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e3) {
      return typeof e3;
    } : function(e3) {
      return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
    })(e2);
  }
  function Lc(e2, t2) {
    for (var n2 = 0; n2 < t2.length; n2++) {
      var r2 = t2[n2];
      r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
    }
  }
  function jc(e2, t2) {
    return (jc = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function zc(e2) {
    return (zc = Object.setPrototypeOf ? Object.getPrototypeOf : function(e3) {
      return e3.__proto__ || Object.getPrototypeOf(e3);
    })(e2);
  }
  function Hc(e2, t2) {
    var n2 = Object.keys(e2);
    if (Object.getOwnPropertySymbols) {
      var r2 = Object.getOwnPropertySymbols(e2);
      t2 && (r2 = r2.filter(function(t3) {
        return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
      })), n2.push.apply(n2, r2);
    }
    return n2;
  }
  function Wc(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var n2 = null != arguments[t2] ? arguments[t2] : {};
      t2 % 2 ? Hc(Object(n2), true).forEach(function(t3) {
        Vc(e2, t3, n2[t3]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(n2)) : Hc(Object(n2)).forEach(function(t3) {
        Object.defineProperty(e2, t3, Object.getOwnPropertyDescriptor(n2, t3));
      });
    }
    return e2;
  }
  function Vc(e2, t2, n2) {
    return t2 in e2 ? Object.defineProperty(e2, t2, { value: n2, enumerable: true, configurable: true, writable: true }) : e2[t2] = n2, e2;
  }
  var qc = Wc({}, Tc.default.defaultOptions, { httpStack: new Fc.default(), fileReader: new Dc.default(), urlStorage: Qu.canStoreURLs ? new Qu.WebStorageUrlStorage() : new Rc.default(), fingerprint: Mc.default });
  Nc.defaultOptions = qc;
  var Xc = function(e2) {
    !function(e3, t3) {
      if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
      e3.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e3, writable: true, configurable: true } }), t3 && jc(e3, t3);
    }(i2, Tc.default);
    var t2, n2, r2, o2 = (r2 = i2, function() {
      var e3, t3 = zc(r2);
      if (function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if ("function" == typeof Proxy) return true;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
          })), true;
        } catch (zf) {
          return false;
        }
      }()) {
        var n3 = zc(this).constructor;
        e3 = Reflect.construct(t3, arguments, n3);
      } else e3 = t3.apply(this, arguments);
      return function(e4, t4) {
        return !t4 || "object" !== Ic(t4) && "function" != typeof t4 ? function(e5) {
          if (void 0 === e5) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e5;
        }(e4) : t4;
      }(this, e3);
    });
    function i2() {
      var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return function(e4, t4) {
        if (!(e4 instanceof t4)) throw new TypeError("Cannot call a class as a function");
      }(this, i2), t3 = Wc({}, qc, {}, t3), o2.call(this, e3, t3);
    }
    return t2 = i2, n2 = [{ key: "terminate", value: function(e3, t3, n3) {
      return t3 = Wc({}, qc, {}, t3), Tc.default.terminate(e3, t3, n3);
    } }], null, n2 && Lc(t2, n2), i2;
  }();
  Nc.Upload = Xc;
  var Gc, Yc, $c = window, Kc = $c.XMLHttpRequest, Jc = $c.Blob;
  Kc && Jc && Jc.prototype.slice;
  function Qc() {
    return (Qc = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Zc(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function ep(e2, t2) {
    return (ep = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var tp = Ke.Provider, np = Ke.RequestClient, rp = Ke.Socket, op = { endpoint: "", uploadUrl: null, metadata: {}, uploadSize: null, onProgress: null, onChunkComplete: null, onSuccess: null, onError: null, overridePatchMethod: false, headers: {}, addRequestId: false, chunkSize: 1 / 0, retryDelays: [0, 1e3, 3e3, 5e3], parallelUploads: 1, storeFingerprintForResuming: true, removeFingerprintOnSuccess: false, uploadLengthDeferred: false, uploadDataDuringCreation: false }, ip = (Yc = Gc = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).type = "uploader", r3.id = r3.opts.id || "Tus", r3.title = "Tus", r3.opts = Qc({}, { autoRetry: true, resume: true, useFastRemoteRetry: true, limit: 0, retryDelays: [0, 1e3, 3e3, 5e3], withCredentials: false }, n3), r3.requests = new _l(r3.opts.limit), r3.uploaders = /* @__PURE__ */ Object.create(null), r3.uploaderEvents = /* @__PURE__ */ Object.create(null), r3.uploaderSockets = /* @__PURE__ */ Object.create(null), r3.handleResetProgress = r3.handleResetProgress.bind(Zc(r3)), r3.handleUpload = r3.handleUpload.bind(Zc(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, ep(t2, n2);
    var o2 = r2.prototype;
    return o2.handleResetProgress = function() {
      var e3 = Qc({}, this.uppy.getState().files);
      Object.keys(e3).forEach(function(t3) {
        if (e3[t3].tus && e3[t3].tus.uploadUrl) {
          var n3 = Qc({}, e3[t3].tus);
          delete n3.uploadUrl, e3[t3] = Qc({}, e3[t3], { tus: n3 });
        }
      }), this.uppy.setState({ files: e3 });
    }, o2.resetUploaderReferences = function(e3, t3) {
      if (void 0 === t3 && (t3 = {}), this.uploaders[e3]) {
        var n3 = this.uploaders[e3];
        n3.abort(), t3.abort && setTimeout(function() {
          return n3.abort(true);
        }, 1e3), this.uploaders[e3] = null;
      }
      this.uploaderEvents[e3] && (this.uploaderEvents[e3].remove(), this.uploaderEvents[e3] = null), this.uploaderSockets[e3] && (this.uploaderSockets[e3].close(), this.uploaderSockets[e3] = null);
    }, o2.upload = function(e3, t3, n3) {
      var r3 = this;
      return this.resetUploaderReferences(e3.id), new Promise(function(t4, n4) {
        r3.uppy.emit("upload-started", e3);
        var o3, i2 = Qc({}, r3.opts, e3.tus || {}), a2 = Qc({}, op, i2);
        delete a2.resume, i2.resume && (a2.storeFingerprintForResuming = true), a2.fingerprint = (o3 = e3, function(e4, t5) {
          if ("undefined" != typeof window && (void 0 !== window.PhoneGap || void 0 !== window.Cordova || void 0 !== window.cordova) || "undefined" != typeof navigator && "string" == typeof navigator.product && "reactnative" === navigator.product.toLowerCase()) return Nc.defaultOptions.fingerprint(e4, t5);
          var n5 = ["tus", o3.id, t5.endpoint].join("-");
          return Promise.resolve(n5);
        }), a2.onBeforeRequest = function(e4) {
          e4.getUnderlyingObject().withCredentials = !!i2.withCredentials, "function" == typeof i2.onBeforeRequest && i2.onBeforeRequest(e4);
        }, a2.onError = function(t5) {
          r3.uppy.log(t5);
          var o4 = t5.originalRequest ? t5.originalRequest.getUnderlyingObject() : null;
          Pl(o4) && (t5 = new Te(t5, o4)), r3.resetUploaderReferences(e3.id), c2.done(), r3.uppy.emit("upload-error", e3, t5), n4(t5);
        }, a2.onProgress = function(t5, n5) {
          r3.onReceiveUploadUrl(e3, u2.url), r3.uppy.emit("upload-progress", e3, { uploader: r3, bytesUploaded: t5, bytesTotal: n5 });
        }, a2.onSuccess = function() {
          var n5 = { uploadURL: u2.url };
          r3.resetUploaderReferences(e3.id), c2.done(), r3.uppy.emit("upload-success", e3, n5), u2.url && r3.uppy.log("Download " + u2.file.name + " from " + u2.url), t4(u2);
        };
        var s2 = function(e4, t5, n5) {
          C(e4, t5) && !C(e4, n5) && (e4[n5] = e4[t5]);
        }, l2 = {};
        (Array.isArray(i2.metaFields) ? i2.metaFields : Object.keys(e3.meta)).forEach(function(t5) {
          l2[t5] = e3.meta[t5];
        }), s2(l2, "type", "filetype"), s2(l2, "name", "filename"), a2.metadata = l2;
        var u2 = new Nc.Upload(e3.data, a2);
        r3.uploaders[e3.id] = u2, r3.uploaderEvents[e3.id] = new kl(r3.uppy), i2.resume && u2.findPreviousUploads().then(function(t5) {
          var n5 = t5[0];
          n5 && (r3.uppy.log("[Tus] Resuming upload of " + e3.id + " started at " + n5.creationTime), u2.resumeFromPreviousUpload(n5));
        });
        var c2 = r3.requests.run(function() {
          return e3.isPaused || Promise.resolve().then(function() {
            u2.start();
          }), function() {
          };
        });
        r3.onFileRemove(e3.id, function(n5) {
          c2.abort(), r3.resetUploaderReferences(e3.id, { abort: !!u2.url }), t4("upload " + n5 + " was removed");
        }), r3.onPause(e3.id, function(e4) {
          e4 ? (c2.abort(), u2.abort()) : (c2.abort(), c2 = r3.requests.run(function() {
            return u2.start(), function() {
            };
          }));
        }), r3.onPauseAll(e3.id, function() {
          c2.abort(), u2.abort();
        }), r3.onCancelAll(e3.id, function() {
          c2.abort(), r3.resetUploaderReferences(e3.id, { abort: !!u2.url }), t4("upload " + e3.id + " was canceled");
        }), r3.onResumeAll(e3.id, function() {
          c2.abort(), e3.error && u2.abort(), c2 = r3.requests.run(function() {
            return u2.start(), function() {
            };
          });
        });
      }).catch(function(t4) {
        throw r3.uppy.emit("upload-error", e3, t4), t4;
      });
    }, o2.uploadRemote = function(e3, t3, n3) {
      var r3 = this;
      this.resetUploaderReferences(e3.id);
      var o3 = Qc({}, this.opts);
      return e3.tus && Qc(o3, e3.tus), this.uppy.emit("upload-started", e3), this.uppy.log(e3.remote.url), e3.serverToken ? this.connectToServerSocket(e3) : new Promise(function(t4, n4) {
        new (e3.remote.providerOptions.provider ? tp : np)(r3.uppy, e3.remote.providerOptions).post(e3.remote.url, Qc({}, e3.remote.body, { endpoint: o3.endpoint, uploadUrl: o3.uploadUrl, protocol: "tus", size: e3.data.size, headers: o3.headers, metadata: e3.meta })).then(function(t5) {
          return r3.uppy.setFileState(e3.id, { serverToken: t5.token }), e3 = r3.uppy.getFile(e3.id), r3.connectToServerSocket(e3);
        }).then(function() {
          t4();
        }).catch(function(t5) {
          r3.uppy.emit("upload-error", e3, t5), n4(t5);
        });
      });
    }, o2.connectToServerSocket = function(e3) {
      var t3 = this;
      return new Promise(function(n3, r3) {
        var o3 = e3.serverToken, i2 = Sl(e3.remote.companionUrl), a2 = new rp({ target: i2 + "/api/" + o3, autoOpen: false });
        t3.uploaderSockets[e3.id] = a2, t3.uploaderEvents[e3.id] = new kl(t3.uppy), t3.onFileRemove(e3.id, function() {
          s2.abort(), a2.send("pause", {}), a2.send("cancel", {}), t3.resetUploaderReferences(e3.id), n3("upload " + e3.id + " was removed");
        }), t3.onPause(e3.id, function(e4) {
          e4 ? (s2.abort(), a2.send("pause", {})) : (s2.abort(), s2 = t3.requests.run(function() {
            return a2.send("resume", {}), function() {
            };
          }));
        }), t3.onPauseAll(e3.id, function() {
          s2.abort(), a2.send("pause", {});
        }), t3.onCancelAll(e3.id, function() {
          s2.abort(), a2.send("pause", {}), a2.send("cancel", {}), t3.resetUploaderReferences(e3.id), n3("upload " + e3.id + " was canceled");
        }), t3.onResumeAll(e3.id, function() {
          s2.abort(), e3.error && a2.send("pause", {}), s2 = t3.requests.run(function() {
            return a2.send("resume", {}), function() {
            };
          });
        }), t3.onRetry(e3.id, function() {
          a2.isOpen && (a2.send("pause", {}), a2.send("resume", {}));
        }), t3.onRetryAll(e3.id, function() {
          a2.isOpen && (a2.send("pause", {}), a2.send("resume", {}));
        }), a2.on("progress", function(n4) {
          return Cl(t3, n4, e3);
        }), a2.on("error", function(n4) {
          var o4 = n4.error.message, i3 = Qc(new Error(o4), { cause: n4.error });
          t3.opts.useFastRemoteRetry ? a2.close() : (t3.resetUploaderReferences(e3.id), t3.uppy.setFileState(e3.id, { serverToken: null })), t3.uppy.emit("upload-error", e3, i3), s2.done(), r3(i3);
        }), a2.on("success", function(r4) {
          var o4 = { uploadURL: r4.url };
          t3.uppy.emit("upload-success", e3, o4), t3.resetUploaderReferences(e3.id), s2.done(), n3();
        });
        var s2 = t3.requests.run(function() {
          return a2.open(), e3.isPaused && a2.send("pause", {}), function() {
          };
        });
      });
    }, o2.onReceiveUploadUrl = function(e3, t3) {
      var n3 = this.uppy.getFile(e3.id);
      n3 && (n3.tus && n3.tus.uploadUrl === t3 || (this.uppy.log("[Tus] Storing upload url"), this.uppy.setFileState(n3.id, { tus: Qc({}, n3.tus, { uploadUrl: t3 }) })));
    }, o2.onFileRemove = function(e3, t3) {
      this.uploaderEvents[e3].on("file-removed", function(n3) {
        e3 === n3.id && t3(n3.id);
      });
    }, o2.onPause = function(e3, t3) {
      this.uploaderEvents[e3].on("upload-pause", function(n3, r3) {
        e3 === n3 && t3(r3);
      });
    }, o2.onRetry = function(e3, t3) {
      this.uploaderEvents[e3].on("upload-retry", function(n3) {
        e3 === n3 && t3();
      });
    }, o2.onRetryAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("retry-all", function(r3) {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.onPauseAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("pause-all", function() {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.onCancelAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("cancel-all", function() {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.onResumeAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("resume-all", function() {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.uploadFiles = function(e3) {
      var t3 = this, n3 = e3.map(function(n4, r3) {
        var o3 = r3 + 1, i2 = e3.length;
        return "error" in n4 && n4.error ? Promise.reject(new Error(n4.error)) : n4.isRemote ? (n4.progress.uploadStarted && n4.isRestored || t3.uppy.emit("upload-started", n4), t3.uploadRemote(n4, o3, i2)) : (n4.progress.uploadStarted && n4.isRestored || t3.uppy.emit("upload-started", n4), t3.upload(n4, o3, i2));
      });
      return wl(n3);
    }, o2.handleUpload = function(e3) {
      var t3 = this;
      if (0 === e3.length) return this.uppy.log("[Tus] No files to upload"), Promise.resolve();
      0 === this.opts.limit && this.uppy.log("[Tus] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/tus/#limit-0", "warning"), this.uppy.log("[Tus] Uploading...");
      var n3 = e3.map(function(e4) {
        return t3.uppy.getFile(e4);
      });
      return this.uploadFiles(n3).then(function() {
        return null;
      });
    }, o2.install = function() {
      this.uppy.setState({ capabilities: Qc({}, this.uppy.getState().capabilities, { resumableUploads: true }) }), this.uppy.addUploader(this.handleUpload), this.uppy.on("reset-progress", this.handleResetProgress), this.opts.autoRetry && this.uppy.on("back-online", this.uppy.retryAll);
    }, o2.uninstall = function() {
      this.uppy.setState({ capabilities: Qc({}, this.uppy.getState().capabilities, { resumableUploads: false }) }), this.uppy.removeUploader(this.handleUpload), this.opts.autoRetry && this.uppy.off("back-online", this.uppy.retryAll);
    }, r2;
  }(ue.Plugin), Gc.VERSION = "1.9.2", Yc), ap = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, sp = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"], lp = function(e2) {
    var t2 = e2, n2 = e2.indexOf("["), r2 = e2.indexOf("]");
    -1 != n2 && -1 != r2 && (e2 = e2.substring(0, n2) + e2.substring(n2, r2).replace(/:/g, ";") + e2.substring(r2, e2.length));
    for (var o2 = ap.exec(e2 || ""), i2 = {}, a2 = 14; a2--; ) i2[sp[a2]] = o2[a2] || "";
    return -1 != n2 && -1 != r2 && (i2.source = t2, i2.host = i2.host.substring(1, i2.host.length - 1).replace(/;/g, ":"), i2.authority = i2.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), i2.ipv6uri = true), i2;
  }, up = 1e3, cp = 6e4, pp = 864e5;
  function dp(e2, t2, n2) {
    if (!(e2 < t2)) return e2 < 1.5 * t2 ? Math.floor(e2 / t2) + " " + n2 : Math.ceil(e2 / t2) + " " + n2 + "s";
  }
  var hp = {};
  function fp(e2) {
    var t2;
    function n2() {
      if (n2.enabled) {
        var e3 = n2, r2 = +/* @__PURE__ */ new Date(), o2 = r2 - (t2 || r2);
        e3.diff = o2, e3.prev = t2, e3.curr = r2, t2 = r2;
        for (var i2 = new Array(arguments.length), a2 = 0; a2 < i2.length; a2++) i2[a2] = arguments[a2];
        i2[0] = hp.coerce(i2[0]), "string" != typeof i2[0] && i2.unshift("%O");
        var s2 = 0;
        i2[0] = i2[0].replace(/%([a-zA-Z%])/g, function(t3, n3) {
          if ("%%" === t3) return t3;
          s2++;
          var r3 = hp.formatters[n3];
          if ("function" == typeof r3) {
            var o3 = i2[s2];
            t3 = r3.call(e3, o3), i2.splice(s2, 1), s2--;
          }
          return t3;
        }), hp.formatArgs.call(e3, i2), (n2.log || hp.log || console.log.bind(console)).apply(e3, i2);
      }
    }
    return n2.namespace = e2, n2.enabled = hp.enabled(e2), n2.useColors = hp.useColors(), n2.color = function(e3) {
      var t3, n3 = 0;
      for (t3 in e3) n3 = (n3 << 5) - n3 + e3.charCodeAt(t3), n3 |= 0;
      return hp.colors[Math.abs(n3) % hp.colors.length];
    }(e2), n2.destroy = mp, "function" == typeof hp.init && hp.init(n2), hp.instances.push(n2), n2;
  }
  function mp() {
    var e2 = hp.instances.indexOf(this);
    return -1 !== e2 && (hp.instances.splice(e2, 1), true);
  }
  (hp = hp = fp.debug = fp.default = fp).coerce = function(e2) {
    return e2 instanceof Error ? e2.stack || e2.message : e2;
  }, hp.disable = function() {
    hp.enable("");
  }, hp.enable = function(e2) {
    var t2;
    hp.save(e2), hp.names = [], hp.skips = [];
    var n2 = ("string" == typeof e2 ? e2 : "").split(/[\s,]+/), r2 = n2.length;
    for (t2 = 0; t2 < r2; t2++) n2[t2] && ("-" === (e2 = n2[t2].replace(/\*/g, ".*?"))[0] ? hp.skips.push(new RegExp("^" + e2.substr(1) + "$")) : hp.names.push(new RegExp("^" + e2 + "$")));
    for (t2 = 0; t2 < hp.instances.length; t2++) {
      var o2 = hp.instances[t2];
      o2.enabled = hp.enabled(o2.namespace);
    }
  }, hp.enabled = function(e2) {
    if ("*" === e2[e2.length - 1]) return true;
    var t2, n2;
    for (t2 = 0, n2 = hp.skips.length; t2 < n2; t2++) if (hp.skips[t2].test(e2)) return false;
    for (t2 = 0, n2 = hp.names.length; t2 < n2; t2++) if (hp.names[t2].test(e2)) return true;
    return false;
  }, hp.humanize = function(e2, t2) {
    t2 = t2 || {};
    var n2, r2 = typeof e2;
    if ("string" === r2 && e2.length > 0) return function(e3) {
      if (!((e3 = String(e3)).length > 100)) {
        var t3 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(e3);
        if (t3) {
          var n3 = parseFloat(t3[1]);
          switch ((t3[2] || "ms").toLowerCase()) {
            case "years":
            case "year":
            case "yrs":
            case "yr":
            case "y":
              return 315576e5 * n3;
            case "days":
            case "day":
            case "d":
              return n3 * pp;
            case "hours":
            case "hour":
            case "hrs":
            case "hr":
            case "h":
              return 36e5 * n3;
            case "minutes":
            case "minute":
            case "mins":
            case "min":
            case "m":
              return n3 * cp;
            case "seconds":
            case "second":
            case "secs":
            case "sec":
            case "s":
              return n3 * up;
            case "milliseconds":
            case "millisecond":
            case "msecs":
            case "msec":
            case "ms":
              return n3;
            default:
              return;
          }
        }
      }
    }(e2);
    if ("number" === r2 && false === isNaN(e2)) return t2.long ? dp(n2 = e2, pp, "day") || dp(n2, 36e5, "hour") || dp(n2, cp, "minute") || dp(n2, up, "second") || n2 + " ms" : function(e3) {
      return e3 >= pp ? Math.round(e3 / pp) + "d" : e3 >= 36e5 ? Math.round(e3 / 36e5) + "h" : e3 >= cp ? Math.round(e3 / cp) + "m" : e3 >= up ? Math.round(e3 / up) + "s" : e3 + "ms";
    }(e2);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e2));
  }, hp.instances = [], hp.names = [], hp.skips = [], hp.formatters = {};
  var vp = {};
  (function(e2) {
    (function() {
      function t2() {
        var t3;
        try {
          t3 = vp.storage.debug;
        } catch (zf) {
        }
        return !t3 && void 0 !== e2 && "env" in e2 && (t3 = e2.env.DEBUG), t3;
      }
      (vp = vp = hp).log = function() {
        return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
      }, vp.formatArgs = function(e3) {
        var t3 = this.useColors;
        if (e3[0] = (t3 ? "%c" : "") + this.namespace + (t3 ? " %c" : " ") + e3[0] + (t3 ? "%c " : " ") + "+" + vp.humanize(this.diff), t3) {
          var n2 = "color: " + this.color;
          e3.splice(1, 0, n2, "color: inherit");
          var r2 = 0, o2 = 0;
          e3[0].replace(/%[a-zA-Z%]/g, function(e4) {
            "%%" !== e4 && (r2++, "%c" === e4 && (o2 = r2));
          }), e3.splice(o2, 0, n2);
        }
      }, vp.save = function(e3) {
        try {
          null == e3 ? vp.storage.removeItem("debug") : vp.storage.debug = e3;
        } catch (zf) {
        }
      }, vp.load = t2, vp.useColors = function() {
        return !("undefined" == typeof window || !window.process || "renderer" !== window.process.type) || ("undefined" == typeof navigator || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && ("undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
      }, vp.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : function() {
        try {
          return window.localStorage;
        } catch (zf) {
        }
      }(), vp.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], vp.formatters.j = function(e3) {
        try {
          return JSON.stringify(e3);
        } catch (wd2) {
          return "[UnexpectedJSONParseError]: " + wd2.message;
        }
      }, vp.enable(t2());
    }).call(this);
  }).call(this, e);
  var gp = vp("socket.io-client:url"), yp = function(e2, t2) {
    var n2 = e2;
    t2 = t2 || "undefined" != typeof location && location, null == e2 && (e2 = t2.protocol + "//" + t2.host), "string" == typeof e2 && ("/" === e2.charAt(0) && (e2 = "/" === e2.charAt(1) ? t2.protocol + e2 : t2.host + e2), /^(https?|wss?):\/\//.test(e2) || (gp("protocol-less url %s", e2), e2 = void 0 !== t2 ? t2.protocol + "//" + e2 : "https://" + e2), gp("parse %s", e2), n2 = lp(e2)), n2.port || (/^(http|ws)$/.test(n2.protocol) ? n2.port = "80" : /^(http|ws)s$/.test(n2.protocol) && (n2.port = "443")), n2.path = n2.path || "/";
    var r2 = -1 !== n2.host.indexOf(":") ? "[" + n2.host + "]" : n2.host;
    return n2.id = n2.protocol + "://" + r2 + ":" + n2.port, n2.href = n2.protocol + "://" + r2 + (t2 && t2.port === n2.port ? "" : ":" + n2.port), n2;
  }, bp = { exports: {} };
  function _p(e2) {
    if (e2) return function(e3) {
      for (var t2 in _p.prototype) e3[t2] = _p.prototype[t2];
      return e3;
    }(e2);
  }
  bp.exports = _p, _p.prototype.on = _p.prototype.addEventListener = function(e2, t2) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e2] = this._callbacks["$" + e2] || []).push(t2), this;
  }, _p.prototype.once = function(e2, t2) {
    function n2() {
      this.off(e2, n2), t2.apply(this, arguments);
    }
    return n2.fn = t2, this.on(e2, n2), this;
  }, _p.prototype.off = _p.prototype.removeListener = _p.prototype.removeAllListeners = _p.prototype.removeEventListener = function(e2, t2) {
    if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
    var n2, r2 = this._callbacks["$" + e2];
    if (!r2) return this;
    if (1 == arguments.length) return delete this._callbacks["$" + e2], this;
    for (var o2 = 0; o2 < r2.length; o2++) if ((n2 = r2[o2]) === t2 || n2.fn === t2) {
      r2.splice(o2, 1);
      break;
    }
    return 0 === r2.length && delete this._callbacks["$" + e2], this;
  }, _p.prototype.emit = function(e2) {
    this._callbacks = this._callbacks || {};
    for (var t2 = new Array(arguments.length - 1), n2 = this._callbacks["$" + e2], r2 = 1; r2 < arguments.length; r2++) t2[r2 - 1] = arguments[r2];
    if (n2) {
      r2 = 0;
      for (var o2 = (n2 = n2.slice(0)).length; r2 < o2; ++r2) n2[r2].apply(this, t2);
    }
    return this;
  }, _p.prototype.listeners = function(e2) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + e2] || [];
  }, _p.prototype.hasListeners = function(e2) {
    return !!this.listeners(e2).length;
  }, bp = bp.exports;
  var wp = {}.toString, Cp = Array.isArray || function(e2) {
    return "[object Array]" == wp.call(e2);
  }, Sp = {};
  (function(e2) {
    (function() {
      Sp = function(o2) {
        return t2 && e2.isBuffer(o2) || n2 && (o2 instanceof ArrayBuffer || r2(o2));
      };
      var t2 = "function" == typeof e2 && "function" == typeof e2.isBuffer, n2 = "function" == typeof ArrayBuffer, r2 = function(e3) {
        return "function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e3) : e3.buffer instanceof ArrayBuffer;
      };
    }).call(this);
  }).call(this, a({}).Buffer);
  var kp = {}, xp = Object.prototype.toString, Pp = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === xp.call(Blob), Ep = "function" == typeof File || "undefined" != typeof File && "[object FileConstructor]" === xp.call(File);
  kp.deconstructPacket = function(e2) {
    var t2 = [], n2 = e2.data, r2 = e2;
    return r2.data = function e3(t3, n3) {
      if (!t3) return t3;
      if (Sp(t3)) {
        var r3 = { _placeholder: true, num: n3.length };
        return n3.push(t3), r3;
      }
      if (Cp(t3)) {
        for (var o2 = new Array(t3.length), i2 = 0; i2 < t3.length; i2++) o2[i2] = e3(t3[i2], n3);
        return o2;
      }
      if ("object" == typeof t3 && !(t3 instanceof Date)) {
        o2 = {};
        for (var a2 in t3) o2[a2] = e3(t3[a2], n3);
        return o2;
      }
      return t3;
    }(n2, t2), r2.attachments = t2.length, { packet: r2, buffers: t2 };
  }, kp.reconstructPacket = function(e2, t2) {
    return e2.data = function e3(t3, n2) {
      if (!t3) return t3;
      if (t3 && t3._placeholder) return n2[t3.num];
      if (Cp(t3)) for (var r2 = 0; r2 < t3.length; r2++) t3[r2] = e3(t3[r2], n2);
      else if ("object" == typeof t3) for (var o2 in t3) t3[o2] = e3(t3[o2], n2);
      return t3;
    }(e2.data, t2), e2.attachments = void 0, e2;
  }, kp.removeBlobs = function(e2, t2) {
    var n2 = 0, r2 = e2;
    !function e3(o2, i2, a2) {
      if (!o2) return o2;
      if (Pp && o2 instanceof Blob || Ep && o2 instanceof File) {
        n2++;
        var s2 = new FileReader();
        s2.onload = function() {
          a2 ? a2[i2] = this.result : r2 = this.result, --n2 || t2(r2);
        }, s2.readAsArrayBuffer(o2);
      } else if (Cp(o2)) for (var l2 = 0; l2 < o2.length; l2++) e3(o2[l2], l2, o2);
      else if ("object" == typeof o2 && !Sp(o2)) for (var u2 in o2) e3(o2[u2], u2, o2);
    }(r2), n2 || t2(r2);
  };
  var Op = {}, Ap = vp("socket.io-parser");
  function Up() {
  }
  Op.protocol = 4, Op.types = ["CONNECT", "DISCONNECT", "EVENT", "ACK", "ERROR", "BINARY_EVENT", "BINARY_ACK"], Op.CONNECT = 0, Op.DISCONNECT = 1, Op.EVENT = 2, Op.ACK = 3, Op.ERROR = 4, Op.BINARY_EVENT = 5, Op.BINARY_ACK = 6, Op.Encoder = Up, Op.Decoder = Rp;
  var Np = Op.ERROR + '"encode error"';
  function Tp(e2) {
    var t2 = "" + e2.type;
    if (Op.BINARY_EVENT !== e2.type && Op.BINARY_ACK !== e2.type || (t2 += e2.attachments + "-"), e2.nsp && "/" !== e2.nsp && (t2 += e2.nsp + ","), null != e2.id && (t2 += e2.id), null != e2.data) {
      var n2 = function(e3) {
        try {
          return JSON.stringify(e3);
        } catch (zf) {
          return false;
        }
      }(e2.data);
      if (false === n2) return Np;
      t2 += n2;
    }
    return Ap("encoded %j as %s", e2, t2), t2;
  }
  function Rp() {
    this.reconstructor = null;
  }
  function Fp(e2) {
    this.reconPack = e2, this.buffers = [];
  }
  function Dp(e2) {
    return { type: Op.ERROR, data: "parser error: " + e2 };
  }
  Up.prototype.encode = function(e2, t2) {
    Ap("encoding packet %j", e2), Op.BINARY_EVENT === e2.type || Op.BINARY_ACK === e2.type ? function(e3, t3) {
      kp.removeBlobs(e3, function(e4) {
        var n2 = kp.deconstructPacket(e4), r2 = Tp(n2.packet), o2 = n2.buffers;
        o2.unshift(r2), t3(o2);
      });
    }(e2, t2) : t2([Tp(e2)]);
  }, bp(Rp.prototype), Rp.prototype.add = function(e2) {
    var t2;
    if ("string" == typeof e2) t2 = function(e3) {
      var t3 = 0, n2 = { type: Number(e3.charAt(0)) };
      if (null == Op.types[n2.type]) return Dp("unknown packet type " + n2.type);
      if (Op.BINARY_EVENT === n2.type || Op.BINARY_ACK === n2.type) {
        for (var r2 = t3 + 1; "-" !== e3.charAt(++t3) && t3 != e3.length; ) ;
        var o2 = e3.substring(r2, t3);
        if (o2 != Number(o2) || "-" !== e3.charAt(t3)) throw new Error("Illegal attachments");
        n2.attachments = Number(o2);
      }
      if ("/" === e3.charAt(t3 + 1)) {
        for (r2 = t3 + 1; ++t3; ) {
          if ("," === (a2 = e3.charAt(t3))) break;
          if (t3 === e3.length) break;
        }
        n2.nsp = e3.substring(r2, t3);
      } else n2.nsp = "/";
      var i2 = e3.charAt(t3 + 1);
      if ("" !== i2 && Number(i2) == i2) {
        for (r2 = t3 + 1; ++t3; ) {
          var a2;
          if (null == (a2 = e3.charAt(t3)) || Number(a2) != a2) {
            --t3;
            break;
          }
          if (t3 === e3.length) break;
        }
        n2.id = Number(e3.substring(r2, t3 + 1));
      }
      if (e3.charAt(++t3)) {
        var s2 = function(e4) {
          try {
            return JSON.parse(e4);
          } catch (zf) {
            return false;
          }
        }(e3.substr(t3));
        if (!(false !== s2 && (n2.type === Op.ERROR || Cp(s2)))) return Dp("invalid payload");
        n2.data = s2;
      }
      return Ap("decoded %s as %j", e3, n2), n2;
    }(e2), Op.BINARY_EVENT === t2.type || Op.BINARY_ACK === t2.type ? (this.reconstructor = new Fp(t2), 0 === this.reconstructor.reconPack.attachments && this.emit("decoded", t2)) : this.emit("decoded", t2);
    else {
      if (!Sp(e2) && !e2.base64) throw new Error("Unknown type: " + e2);
      if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
      (t2 = this.reconstructor.takeBinaryData(e2)) && (this.reconstructor = null, this.emit("decoded", t2));
    }
  }, Rp.prototype.destroy = function() {
    this.reconstructor && this.reconstructor.finishedReconstruction();
  }, Fp.prototype.takeBinaryData = function(e2) {
    if (this.buffers.push(e2), this.buffers.length === this.reconPack.attachments) {
      var t2 = kp.reconstructPacket(this.reconPack, this.buffers);
      return this.finishedReconstruction(), t2;
    }
    return null;
  }, Fp.prototype.finishedReconstruction = function() {
    this.reconPack = null, this.buffers = [];
  };
  var Mp = { exports: {} };
  function Bp(e2) {
    if (e2) return function(e3) {
      for (var t2 in Bp.prototype) e3[t2] = Bp.prototype[t2];
      return e3;
    }(e2);
  }
  Mp.exports = Bp, Bp.prototype.on = Bp.prototype.addEventListener = function(e2, t2) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e2] = this._callbacks["$" + e2] || []).push(t2), this;
  }, Bp.prototype.once = function(e2, t2) {
    function n2() {
      this.off(e2, n2), t2.apply(this, arguments);
    }
    return n2.fn = t2, this.on(e2, n2), this;
  }, Bp.prototype.off = Bp.prototype.removeListener = Bp.prototype.removeAllListeners = Bp.prototype.removeEventListener = function(e2, t2) {
    if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
    var n2, r2 = this._callbacks["$" + e2];
    if (!r2) return this;
    if (1 == arguments.length) return delete this._callbacks["$" + e2], this;
    for (var o2 = 0; o2 < r2.length; o2++) if ((n2 = r2[o2]) === t2 || n2.fn === t2) {
      r2.splice(o2, 1);
      break;
    }
    return this;
  }, Bp.prototype.emit = function(e2) {
    this._callbacks = this._callbacks || {};
    var t2 = [].slice.call(arguments, 1), n2 = this._callbacks["$" + e2];
    if (n2) for (var r2 = 0, o2 = (n2 = n2.slice(0)).length; r2 < o2; ++r2) n2[r2].apply(this, t2);
    return this;
  }, Bp.prototype.listeners = function(e2) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + e2] || [];
  }, Bp.prototype.hasListeners = function(e2) {
    return !!this.listeners(e2).length;
  }, Mp = Mp.exports;
  var Ip = [].indexOf, Lp = function(e2, t2) {
    if (Ip) return e2.indexOf(t2);
    for (var n2 = 0; n2 < e2.length; ++n2) if (e2[n2] === t2) return n2;
    return -1;
  }, jp = { encode: function(e2) {
    var t2 = "";
    for (var n2 in e2) e2.hasOwnProperty(n2) && (t2.length && (t2 += "&"), t2 += encodeURIComponent(n2) + "=" + encodeURIComponent(e2[n2]));
    return t2;
  }, decode: function(e2) {
    for (var t2 = {}, n2 = e2.split("&"), r2 = 0, o2 = n2.length; r2 < o2; r2++) {
      var i2 = n2[r2].split("=");
      t2[decodeURIComponent(i2[0])] = decodeURIComponent(i2[1]);
    }
    return t2;
  } }, zp = Object.keys || function(e2) {
    var t2 = [], n2 = Object.prototype.hasOwnProperty;
    for (var r2 in e2) n2.call(e2, r2) && t2.push(r2);
    return t2;
  }, Hp = {}.toString, Wp = Array.isArray || function(e2) {
    return "[object Array]" == Hp.call(e2);
  }, Vp = {};
  (function(e2) {
    (function() {
      var t2 = Object.prototype.toString, n2 = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === t2.call(Blob), r2 = "function" == typeof File || "undefined" != typeof File && "[object FileConstructor]" === t2.call(File);
      Vp = function t3(o2) {
        if (!o2 || "object" != typeof o2) return false;
        if (Wp(o2)) {
          for (var i2 = 0, a2 = o2.length; i2 < a2; i2++) if (t3(o2[i2])) return true;
          return false;
        }
        if ("function" == typeof e2 && e2.isBuffer && e2.isBuffer(o2) || "function" == typeof ArrayBuffer && o2 instanceof ArrayBuffer || n2 && o2 instanceof Blob || r2 && o2 instanceof File) return true;
        if (o2.toJSON && "function" == typeof o2.toJSON && 1 === arguments.length) return t3(o2.toJSON(), true);
        for (var s2 in o2) if (Object.prototype.hasOwnProperty.call(o2, s2) && t3(o2[s2])) return true;
        return false;
      };
    }).call(this);
  }).call(this, a({}).Buffer);
  var qp = function(e2, t2, n2) {
    var r2 = e2.byteLength;
    if (t2 = t2 || 0, n2 = n2 || r2, e2.slice) return e2.slice(t2, n2);
    if (t2 < 0 && (t2 += r2), n2 < 0 && (n2 += r2), n2 > r2 && (n2 = r2), t2 >= r2 || t2 >= n2 || 0 === r2) return new ArrayBuffer(0);
    for (var o2 = new Uint8Array(e2), i2 = new Uint8Array(n2 - t2), a2 = t2, s2 = 0; a2 < n2; a2++, s2++) i2[s2] = o2[a2];
    return i2.buffer;
  };
  function Xp() {
  }
  var Gp, Yp, $p, Kp = String.fromCharCode;
  function Jp(e2) {
    for (var t2, n2, r2 = [], o2 = 0, i2 = e2.length; o2 < i2; ) (t2 = e2.charCodeAt(o2++)) >= 55296 && t2 <= 56319 && o2 < i2 ? 56320 == (64512 & (n2 = e2.charCodeAt(o2++))) ? r2.push(((1023 & t2) << 10) + (1023 & n2) + 65536) : (r2.push(t2), o2--) : r2.push(t2);
    return r2;
  }
  function Qp(e2, t2) {
    if (e2 >= 55296 && e2 <= 57343) {
      if (t2) throw Error("Lone surrogate U+" + e2.toString(16).toUpperCase() + " is not a scalar value");
      return false;
    }
    return true;
  }
  function Zp(e2, t2) {
    return Kp(e2 >> t2 & 63 | 128);
  }
  function ed(e2, t2) {
    if (0 == (4294967168 & e2)) return Kp(e2);
    var n2 = "";
    return 0 == (4294965248 & e2) ? n2 = Kp(e2 >> 6 & 31 | 192) : 0 == (4294901760 & e2) ? (Qp(e2, t2) || (e2 = 65533), n2 = Kp(e2 >> 12 & 15 | 224), n2 += Zp(e2, 6)) : 0 == (4292870144 & e2) && (n2 = Kp(e2 >> 18 & 7 | 240), n2 += Zp(e2, 12), n2 += Zp(e2, 6)), n2 + Kp(63 & e2 | 128);
  }
  function td() {
    if ($p >= Yp) throw Error("Invalid byte index");
    var e2 = 255 & Gp[$p];
    if ($p++, 128 == (192 & e2)) return 63 & e2;
    throw Error("Invalid continuation byte");
  }
  function nd(e2) {
    var t2, n2;
    if ($p > Yp) throw Error("Invalid byte index");
    if ($p == Yp) return false;
    if (t2 = 255 & Gp[$p], $p++, 0 == (128 & t2)) return t2;
    if (192 == (224 & t2)) {
      if ((n2 = (31 & t2) << 6 | td()) >= 128) return n2;
      throw Error("Invalid continuation byte");
    }
    if (224 == (240 & t2)) {
      if ((n2 = (15 & t2) << 12 | td() << 6 | td()) >= 2048) return Qp(n2, e2) ? n2 : 65533;
      throw Error("Invalid continuation byte");
    }
    if (240 == (248 & t2) && (n2 = (7 & t2) << 18 | td() << 12 | td() << 6 | td()) >= 65536 && n2 <= 1114111) return n2;
    throw Error("Invalid UTF-8 detected");
  }
  var rd = function(e2, t2) {
    for (var n2 = false !== (t2 = t2 || {}).strict, r2 = Jp(e2), o2 = r2.length, i2 = -1, a2 = ""; ++i2 < o2; ) a2 += ed(r2[i2], n2);
    return a2;
  }, od = function(e2, t2) {
    var n2 = false !== (t2 = t2 || {}).strict;
    Gp = Jp(e2), Yp = Gp.length, $p = 0;
    for (var r2, o2 = []; false !== (r2 = nd(n2)); ) o2.push(r2);
    return function(e3) {
      for (var t3, n3 = e3.length, r3 = -1, o3 = ""; ++r3 < n3; ) (t3 = e3[r3]) > 65535 && (o3 += Kp((t3 -= 65536) >>> 10 & 1023 | 55296), t3 = 56320 | 1023 & t3), o3 += Kp(t3);
      return o3;
    }(o2);
  }, id = {};
  !function() {
    "use strict";
    for (var e2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t2 = new Uint8Array(256), n2 = 0; n2 < e2.length; n2++) t2[e2.charCodeAt(n2)] = n2;
    id.encode = function(t3) {
      var n3, r2 = new Uint8Array(t3), o2 = r2.length, i2 = "";
      for (n3 = 0; n3 < o2; n3 += 3) i2 += e2[r2[n3] >> 2], i2 += e2[(3 & r2[n3]) << 4 | r2[n3 + 1] >> 4], i2 += e2[(15 & r2[n3 + 1]) << 2 | r2[n3 + 2] >> 6], i2 += e2[63 & r2[n3 + 2]];
      return o2 % 3 == 2 ? i2 = i2.substring(0, i2.length - 1) + "=" : o2 % 3 == 1 && (i2 = i2.substring(0, i2.length - 2) + "=="), i2;
    }, id.decode = function(e3) {
      var n3, r2, o2, i2, a2, s2 = 0.75 * e3.length, l2 = e3.length, u2 = 0;
      "=" === e3[e3.length - 1] && (s2--, "=" === e3[e3.length - 2] && s2--);
      var c2 = new ArrayBuffer(s2), p2 = new Uint8Array(c2);
      for (n3 = 0; n3 < l2; n3 += 4) r2 = t2[e3.charCodeAt(n3)], o2 = t2[e3.charCodeAt(n3 + 1)], i2 = t2[e3.charCodeAt(n3 + 2)], a2 = t2[e3.charCodeAt(n3 + 3)], p2[u2++] = r2 << 2 | o2 >> 4, p2[u2++] = (15 & o2) << 4 | i2 >> 2, p2[u2++] = (3 & i2) << 6 | 63 & a2;
      return c2;
    };
  }();
  var ad = {}, sd = void 0 !== sd ? sd : "undefined" != typeof WebKitBlobBuilder ? WebKitBlobBuilder : "undefined" != typeof MSBlobBuilder ? MSBlobBuilder : "undefined" != typeof MozBlobBuilder && MozBlobBuilder, ld = function() {
    try {
      return 2 === new Blob(["hi"]).size;
    } catch (zf) {
      return false;
    }
  }(), ud = ld && function() {
    try {
      return 2 === new Blob([new Uint8Array([1, 2])]).size;
    } catch (zf) {
      return false;
    }
  }(), cd = sd && sd.prototype.append && sd.prototype.getBlob;
  function pd(e2) {
    return e2.map(function(e3) {
      if (e3.buffer instanceof ArrayBuffer) {
        var t2 = e3.buffer;
        if (e3.byteLength !== t2.byteLength) {
          var n2 = new Uint8Array(e3.byteLength);
          n2.set(new Uint8Array(t2, e3.byteOffset, e3.byteLength)), t2 = n2.buffer;
        }
        return t2;
      }
      return e3;
    });
  }
  function dd(e2, t2) {
    t2 = t2 || {};
    var n2 = new sd();
    return pd(e2).forEach(function(e3) {
      n2.append(e3);
    }), t2.type ? n2.getBlob(t2.type) : n2.getBlob();
  }
  function hd(e2, t2) {
    return new Blob(pd(e2), t2 || {});
  }
  "undefined" != typeof Blob && (dd.prototype = Blob.prototype, hd.prototype = Blob.prototype), ad = ld ? ud ? Blob : hd : cd ? dd : void 0;
  var fd, md = {};
  "undefined" != typeof ArrayBuffer && (fd = id);
  var vd = "undefined" != typeof navigator && /Android/i.test(navigator.userAgent), gd = "undefined" != typeof navigator && /PhantomJS/i.test(navigator.userAgent), yd = vd || gd;
  md.protocol = 3;
  var bd = md.packets = { open: 0, close: 1, ping: 2, pong: 3, message: 4, upgrade: 5, noop: 6 }, _d = zp(bd), wd = { type: "error", data: "parser error" };
  function Cd(e2, t2, n2) {
    for (var r2 = new Array(e2.length), o2 = function(e3, t3, n3) {
      var r3 = false;
      return n3 = n3 || Xp, o3.count = e3, 0 === e3 ? t3() : o3;
      function o3(e4, i3) {
        if (o3.count <= 0) throw new Error("after called too many times");
        --o3.count, e4 ? (r3 = true, t3(e4), t3 = n3) : 0 !== o3.count || r3 || t3(null, i3);
      }
    }(e2.length, n2), i2 = function(e3, n3, o3) {
      t2(n3, function(t3, n4) {
        r2[e3] = n4, o3(t3, r2);
      });
    }, a2 = 0; a2 < e2.length; a2++) i2(a2, e2[a2], o2);
  }
  md.encodePacket = function(e2, t2, n2, r2) {
    "function" == typeof t2 && (r2 = t2, t2 = false), "function" == typeof n2 && (r2 = n2, n2 = null);
    var o2 = void 0 === e2.data ? void 0 : e2.data.buffer || e2.data;
    if ("undefined" != typeof ArrayBuffer && o2 instanceof ArrayBuffer) return function(e3, t3, n3) {
      if (!t3) return md.encodeBase64Packet(e3, n3);
      var r3 = e3.data, o3 = new Uint8Array(r3), i3 = new Uint8Array(1 + r3.byteLength);
      i3[0] = bd[e3.type];
      for (var a2 = 0; a2 < o3.length; a2++) i3[a2 + 1] = o3[a2];
      return n3(i3.buffer);
    }(e2, t2, r2);
    if (void 0 !== ad && o2 instanceof ad) return function(e3, t3, n3) {
      if (!t3) return md.encodeBase64Packet(e3, n3);
      if (yd) return function(e4, t4, n4) {
        if (!t4) return md.encodeBase64Packet(e4, n4);
        var r4 = new FileReader();
        return r4.onload = function() {
          md.encodePacket({ type: e4.type, data: r4.result }, t4, true, n4);
        }, r4.readAsArrayBuffer(e4.data);
      }(e3, t3, n3);
      var r3 = new Uint8Array(1);
      return r3[0] = bd[e3.type], n3(new ad([r3.buffer, e3.data]));
    }(e2, t2, r2);
    if (o2 && o2.base64) return function(e3, t3) {
      return t3("b" + md.packets[e3.type] + e3.data.data);
    }(e2, r2);
    var i2 = bd[e2.type];
    return void 0 !== e2.data && (i2 += n2 ? rd(String(e2.data), { strict: false }) : String(e2.data)), r2("" + i2);
  }, md.encodeBase64Packet = function(e2, t2) {
    var n2, r2 = "b" + md.packets[e2.type];
    if (void 0 !== ad && e2.data instanceof ad) {
      var o2 = new FileReader();
      return o2.onload = function() {
        var e3 = o2.result.split(",")[1];
        t2(r2 + e3);
      }, o2.readAsDataURL(e2.data);
    }
    try {
      n2 = String.fromCharCode.apply(null, new Uint8Array(e2.data));
    } catch (zf) {
      for (var i2 = new Uint8Array(e2.data), a2 = new Array(i2.length), s2 = 0; s2 < i2.length; s2++) a2[s2] = i2[s2];
      n2 = String.fromCharCode.apply(null, a2);
    }
    return r2 += btoa(n2), t2(r2);
  }, md.decodePacket = function(e2, t2, n2) {
    if (void 0 === e2) return wd;
    if ("string" == typeof e2) {
      if ("b" === e2.charAt(0)) return md.decodeBase64Packet(e2.substr(1), t2);
      if (n2 && false === (e2 = function(e3) {
        try {
          e3 = od(e3, { strict: false });
        } catch (zf) {
          return false;
        }
        return e3;
      }(e2))) return wd;
      var r2 = e2.charAt(0);
      return Number(r2) == r2 && _d[r2] ? e2.length > 1 ? { type: _d[r2], data: e2.substring(1) } : { type: _d[r2] } : wd;
    }
    r2 = new Uint8Array(e2)[0];
    var o2 = qp(e2, 1);
    return ad && "blob" === t2 && (o2 = new ad([o2])), { type: _d[r2], data: o2 };
  }, md.decodeBase64Packet = function(e2, t2) {
    var n2 = _d[e2.charAt(0)];
    if (!fd) return { type: n2, data: { base64: true, data: e2.substr(1) } };
    var r2 = fd.decode(e2.substr(1));
    return "blob" === t2 && ad && (r2 = new ad([r2])), { type: n2, data: r2 };
  }, md.encodePayload = function(e2, t2, n2) {
    "function" == typeof t2 && (n2 = t2, t2 = null);
    var r2 = Vp(e2);
    return t2 && r2 ? ad && !yd ? md.encodePayloadAsBlob(e2, n2) : md.encodePayloadAsArrayBuffer(e2, n2) : e2.length ? void Cd(e2, function(e3, n3) {
      md.encodePacket(e3, !!r2 && t2, false, function(e4) {
        n3(null, function(e5) {
          return e5.length + ":" + e5;
        }(e4));
      });
    }, function(e3, t3) {
      return n2(t3.join(""));
    }) : n2("0:");
  }, md.decodePayload = function(e2, t2, n2) {
    if ("string" != typeof e2) return md.decodePayloadAsBinary(e2, t2, n2);
    var r2;
    if ("function" == typeof t2 && (n2 = t2, t2 = null), "" === e2) return n2(wd, 0, 1);
    for (var o2, i2, a2 = "", s2 = 0, l2 = e2.length; s2 < l2; s2++) {
      var u2 = e2.charAt(s2);
      if (":" === u2) {
        if ("" === a2 || a2 != (o2 = Number(a2))) return n2(wd, 0, 1);
        if (a2 != (i2 = e2.substr(s2 + 1, o2)).length) return n2(wd, 0, 1);
        if (i2.length) {
          if (r2 = md.decodePacket(i2, t2, false), wd.type === r2.type && wd.data === r2.data) return n2(wd, 0, 1);
          if (false === n2(r2, s2 + o2, l2)) return;
        }
        s2 += o2, a2 = "";
      } else a2 += u2;
    }
    return "" !== a2 ? n2(wd, 0, 1) : void 0;
  }, md.encodePayloadAsArrayBuffer = function(e2, t2) {
    if (!e2.length) return t2(new ArrayBuffer(0));
    Cd(e2, function(e3, t3) {
      md.encodePacket(e3, true, true, function(e4) {
        return t3(null, e4);
      });
    }, function(e3, n2) {
      var r2 = n2.reduce(function(e4, t3) {
        var n3;
        return e4 + (n3 = "string" == typeof t3 ? t3.length : t3.byteLength).toString().length + n3 + 2;
      }, 0), o2 = new Uint8Array(r2), i2 = 0;
      return n2.forEach(function(e4) {
        var t3 = "string" == typeof e4, n3 = e4;
        if (t3) {
          for (var r3 = new Uint8Array(e4.length), a2 = 0; a2 < e4.length; a2++) r3[a2] = e4.charCodeAt(a2);
          n3 = r3.buffer;
        }
        o2[i2++] = t3 ? 0 : 1;
        var s2 = n3.byteLength.toString();
        for (a2 = 0; a2 < s2.length; a2++) o2[i2++] = parseInt(s2[a2]);
        for (o2[i2++] = 255, r3 = new Uint8Array(n3), a2 = 0; a2 < r3.length; a2++) o2[i2++] = r3[a2];
      }), t2(o2.buffer);
    });
  }, md.encodePayloadAsBlob = function(e2, t2) {
    Cd(e2, function(e3, t3) {
      md.encodePacket(e3, true, true, function(e4) {
        var n2 = new Uint8Array(1);
        if (n2[0] = 1, "string" == typeof e4) {
          for (var r2 = new Uint8Array(e4.length), o2 = 0; o2 < e4.length; o2++) r2[o2] = e4.charCodeAt(o2);
          e4 = r2.buffer, n2[0] = 0;
        }
        var i2 = (e4 instanceof ArrayBuffer ? e4.byteLength : e4.size).toString(), a2 = new Uint8Array(i2.length + 1);
        for (o2 = 0; o2 < i2.length; o2++) a2[o2] = parseInt(i2[o2]);
        if (a2[i2.length] = 255, ad) {
          var s2 = new ad([n2.buffer, a2.buffer, e4]);
          t3(null, s2);
        }
      });
    }, function(e3, n2) {
      return t2(new ad(n2));
    });
  }, md.decodePayloadAsBinary = function(e2, t2, n2) {
    "function" == typeof t2 && (n2 = t2, t2 = null);
    for (var r2 = e2, o2 = []; r2.byteLength > 0; ) {
      for (var i2 = new Uint8Array(r2), a2 = 0 === i2[0], s2 = "", l2 = 1; 255 !== i2[l2]; l2++) {
        if (s2.length > 310) return n2(wd, 0, 1);
        s2 += i2[l2];
      }
      r2 = qp(r2, 2 + s2.length), s2 = parseInt(s2);
      var u2 = qp(r2, 0, s2);
      if (a2) try {
        u2 = String.fromCharCode.apply(null, new Uint8Array(u2));
      } catch (zf) {
        var c2 = new Uint8Array(u2);
        for (u2 = "", l2 = 0; l2 < c2.length; l2++) u2 += String.fromCharCode(c2[l2]);
      }
      o2.push(u2), r2 = qp(r2, s2);
    }
    var p2 = o2.length;
    o2.forEach(function(e3, r3) {
      n2(md.decodePacket(e3, t2, true), r3, p2);
    });
  };
  var Sd = {};
  function kd(e2) {
    this.path = e2.path, this.hostname = e2.hostname, this.port = e2.port, this.secure = e2.secure, this.query = e2.query, this.timestampParam = e2.timestampParam, this.timestampRequests = e2.timestampRequests, this.readyState = "", this.agent = e2.agent || false, this.socket = e2.socket, this.enablesXDR = e2.enablesXDR, this.pfx = e2.pfx, this.key = e2.key, this.passphrase = e2.passphrase, this.cert = e2.cert, this.ca = e2.ca, this.ciphers = e2.ciphers, this.rejectUnauthorized = e2.rejectUnauthorized, this.forceNode = e2.forceNode, this.isReactNative = e2.isReactNative, this.extraHeaders = e2.extraHeaders, this.localAddress = e2.localAddress;
  }
  Sd = kd, Mp(kd.prototype), kd.prototype.onError = function(e2, t2) {
    var n2 = new Error(e2);
    return n2.type = "TransportError", n2.description = t2, this.emit("error", n2), this;
  }, kd.prototype.open = function() {
    return "closed" !== this.readyState && "" !== this.readyState || (this.readyState = "opening", this.doOpen()), this;
  }, kd.prototype.close = function() {
    return "opening" !== this.readyState && "open" !== this.readyState || (this.doClose(), this.onClose()), this;
  }, kd.prototype.send = function(e2) {
    if ("open" !== this.readyState) throw new Error("Transport not open");
    this.write(e2);
  }, kd.prototype.onOpen = function() {
    this.readyState = "open", this.writable = true, this.emit("open");
  }, kd.prototype.onData = function(e2) {
    var t2 = md.decodePacket(e2, this.socket.binaryType);
    this.onPacket(t2);
  }, kd.prototype.onPacket = function(e2) {
    this.emit("packet", e2);
  }, kd.prototype.onClose = function() {
    this.readyState = "closed", this.emit("close");
  };
  var xd = {};
  try {
    xd = "undefined" != typeof XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
  } catch (wd2) {
    xd = false;
  }
  var Pd, Ed = function(e2) {
    var t2 = e2.xdomain, n2 = e2.xscheme, r2 = e2.enablesXDR;
    try {
      if ("undefined" != typeof XMLHttpRequest && (!t2 || xd)) return new XMLHttpRequest();
    } catch (zf) {
    }
    try {
      if ("undefined" != typeof XDomainRequest && !n2 && r2) return new XDomainRequest();
    } catch (zf) {
    }
    if (!t2) try {
      return new self[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (zf) {
    }
  }, Od = function(e2, t2) {
    var n2 = function() {
    };
    n2.prototype = t2.prototype, e2.prototype = new n2(), e2.prototype.constructor = e2;
  }, Ad = {}, Ud = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), Nd = {}, Td = 0, Rd = 0;
  function Fd(e2) {
    var t2 = "";
    do {
      t2 = Ud[e2 % 64] + t2, e2 = Math.floor(e2 / 64);
    } while (e2 > 0);
    return t2;
  }
  function Dd() {
    var e2 = Fd(+/* @__PURE__ */ new Date());
    return e2 !== Pd ? (Td = 0, Pd = e2) : e2 + "." + Fd(Td++);
  }
  for (; Rd < 64; Rd++) Nd[Ud[Rd]] = Rd;
  Dd.encode = Fd, Dd.decode = function(e2) {
    var t2 = 0;
    for (Rd = 0; Rd < e2.length; Rd++) t2 = 64 * t2 + Nd[e2.charAt(Rd)];
    return t2;
  }, Ad = Dd;
  var Md = vp("engine.io-client:polling"), Bd = Ld, Id = null != new Ed({ xdomain: false }).responseType;
  function Ld(e2) {
    var t2 = e2 && e2.forceBase64;
    Id && !t2 || (this.supportsBinary = false), Sd.call(this, e2);
  }
  Od(Ld, Sd), Ld.prototype.name = "polling", Ld.prototype.doOpen = function() {
    this.poll();
  }, Ld.prototype.pause = function(e2) {
    var t2 = this;
    function n2() {
      Md("paused"), t2.readyState = "paused", e2();
    }
    if (this.readyState = "pausing", this.polling || !this.writable) {
      var r2 = 0;
      this.polling && (Md("we are currently polling - waiting to pause"), r2++, this.once("pollComplete", function() {
        Md("pre-pause polling complete"), --r2 || n2();
      })), this.writable || (Md("we are currently writing - waiting to pause"), r2++, this.once("drain", function() {
        Md("pre-pause writing complete"), --r2 || n2();
      }));
    } else n2();
  }, Ld.prototype.poll = function() {
    Md("polling"), this.polling = true, this.doPoll(), this.emit("poll");
  }, Ld.prototype.onData = function(e2) {
    var t2 = this;
    Md("polling got data %s", e2), md.decodePayload(e2, this.socket.binaryType, function(e3, n2, r2) {
      if ("opening" === t2.readyState && t2.onOpen(), "close" === e3.type) return t2.onClose(), false;
      t2.onPacket(e3);
    }), "closed" !== this.readyState && (this.polling = false, this.emit("pollComplete"), "open" === this.readyState ? this.poll() : Md('ignoring poll - transport state "%s"', this.readyState));
  }, Ld.prototype.doClose = function() {
    var e2 = this;
    function t2() {
      Md("writing close packet"), e2.write([{ type: "close" }]);
    }
    "open" === this.readyState ? (Md("transport open - closing"), t2()) : (Md("transport not open - deferring close"), this.once("open", t2));
  }, Ld.prototype.write = function(e2) {
    var t2 = this;
    this.writable = false;
    var n2 = function() {
      t2.writable = true, t2.emit("drain");
    };
    md.encodePayload(e2, this.supportsBinary, function(e3) {
      t2.doWrite(e3, n2);
    });
  }, Ld.prototype.uri = function() {
    var e2 = this.query || {}, t2 = this.secure ? "https" : "http", n2 = "";
    return false !== this.timestampRequests && (e2[this.timestampParam] = Ad()), this.supportsBinary || e2.sid || (e2.b64 = 1), e2 = jp.encode(e2), this.port && ("https" === t2 && 443 !== Number(this.port) || "http" === t2 && 80 !== Number(this.port)) && (n2 = ":" + this.port), e2.length && (e2 = "?" + e2), t2 + "://" + (-1 !== this.hostname.indexOf(":") ? "[" + this.hostname + "]" : this.hostname) + n2 + this.path + e2;
  };
  var jd = {}, zd = vp("engine.io-client:polling-xhr");
  function Hd() {
  }
  function Wd(e2) {
    if (Bd.call(this, e2), this.requestTimeout = e2.requestTimeout, this.extraHeaders = e2.extraHeaders, "undefined" != typeof location) {
      var t2 = "https:" === location.protocol, n2 = location.port;
      n2 || (n2 = t2 ? 443 : 80), this.xd = "undefined" != typeof location && e2.hostname !== location.hostname || n2 !== e2.port, this.xs = e2.secure !== t2;
    }
  }
  function Vd(e2) {
    this.method = e2.method || "GET", this.uri = e2.uri, this.xd = !!e2.xd, this.xs = !!e2.xs, this.async = false !== e2.async, this.data = void 0 !== e2.data ? e2.data : null, this.agent = e2.agent, this.isBinary = e2.isBinary, this.supportsBinary = e2.supportsBinary, this.enablesXDR = e2.enablesXDR, this.requestTimeout = e2.requestTimeout, this.pfx = e2.pfx, this.key = e2.key, this.passphrase = e2.passphrase, this.cert = e2.cert, this.ca = e2.ca, this.ciphers = e2.ciphers, this.rejectUnauthorized = e2.rejectUnauthorized, this.extraHeaders = e2.extraHeaders, this.create();
  }
  if ((jd = Wd).Request = Vd, Od(Wd, Bd), Wd.prototype.supportsBinary = true, Wd.prototype.request = function(e2) {
    return (e2 = e2 || {}).uri = this.uri(), e2.xd = this.xd, e2.xs = this.xs, e2.agent = this.agent || false, e2.supportsBinary = this.supportsBinary, e2.enablesXDR = this.enablesXDR, e2.pfx = this.pfx, e2.key = this.key, e2.passphrase = this.passphrase, e2.cert = this.cert, e2.ca = this.ca, e2.ciphers = this.ciphers, e2.rejectUnauthorized = this.rejectUnauthorized, e2.requestTimeout = this.requestTimeout, e2.extraHeaders = this.extraHeaders, new Vd(e2);
  }, Wd.prototype.doWrite = function(e2, t2) {
    var n2 = "string" != typeof e2 && void 0 !== e2, r2 = this.request({ method: "POST", data: e2, isBinary: n2 }), o2 = this;
    r2.on("success", t2), r2.on("error", function(e3) {
      o2.onError("xhr post error", e3);
    }), this.sendXhr = r2;
  }, Wd.prototype.doPoll = function() {
    zd("xhr poll");
    var e2 = this.request(), t2 = this;
    e2.on("data", function(e3) {
      t2.onData(e3);
    }), e2.on("error", function(e3) {
      t2.onError("xhr poll error", e3);
    }), this.pollXhr = e2;
  }, Mp(Vd.prototype), Vd.prototype.create = function() {
    var e2 = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
    e2.pfx = this.pfx, e2.key = this.key, e2.passphrase = this.passphrase, e2.cert = this.cert, e2.ca = this.ca, e2.ciphers = this.ciphers, e2.rejectUnauthorized = this.rejectUnauthorized;
    var t2 = this.xhr = new Ed(e2), n2 = this;
    try {
      zd("xhr open %s: %s", this.method, this.uri), t2.open(this.method, this.uri, this.async);
      try {
        if (this.extraHeaders) for (var r2 in t2.setDisableHeaderCheck && t2.setDisableHeaderCheck(true), this.extraHeaders) this.extraHeaders.hasOwnProperty(r2) && t2.setRequestHeader(r2, this.extraHeaders[r2]);
      } catch (zf) {
      }
      if ("POST" === this.method) try {
        this.isBinary ? t2.setRequestHeader("Content-type", "application/octet-stream") : t2.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
      } catch (zf) {
      }
      try {
        t2.setRequestHeader("Accept", "*/*");
      } catch (zf) {
      }
      "withCredentials" in t2 && (t2.withCredentials = true), this.requestTimeout && (t2.timeout = this.requestTimeout), this.hasXDR() ? (t2.onload = function() {
        n2.onLoad();
      }, t2.onerror = function() {
        n2.onError(t2.responseText);
      }) : t2.onreadystatechange = function() {
        if (2 === t2.readyState) try {
          var e3 = t2.getResponseHeader("Content-Type");
          n2.supportsBinary && "application/octet-stream" === e3 && (t2.responseType = "arraybuffer");
        } catch (zf) {
        }
        4 === t2.readyState && (200 === t2.status || 1223 === t2.status ? n2.onLoad() : setTimeout(function() {
          n2.onError(t2.status);
        }, 0));
      }, zd("xhr data %s", this.data), t2.send(this.data);
    } catch (zf) {
      return void setTimeout(function() {
        n2.onError(zf);
      }, 0);
    }
    "undefined" != typeof document && (this.index = Vd.requestsCount++, Vd.requests[this.index] = this);
  }, Vd.prototype.onSuccess = function() {
    this.emit("success"), this.cleanup();
  }, Vd.prototype.onData = function(e2) {
    this.emit("data", e2), this.onSuccess();
  }, Vd.prototype.onError = function(e2) {
    this.emit("error", e2), this.cleanup(true);
  }, Vd.prototype.cleanup = function(e2) {
    if (void 0 !== this.xhr && null !== this.xhr) {
      if (this.hasXDR() ? this.xhr.onload = this.xhr.onerror = Hd : this.xhr.onreadystatechange = Hd, e2) try {
        this.xhr.abort();
      } catch (zf) {
      }
      "undefined" != typeof document && delete Vd.requests[this.index], this.xhr = null;
    }
  }, Vd.prototype.onLoad = function() {
    var e2;
    try {
      var t2;
      try {
        t2 = this.xhr.getResponseHeader("Content-Type");
      } catch (zf) {
      }
      e2 = "application/octet-stream" === t2 && this.xhr.response || this.xhr.responseText;
    } catch (zf) {
      this.onError(zf);
    }
    null != e2 && this.onData(e2);
  }, Vd.prototype.hasXDR = function() {
    return "undefined" != typeof XDomainRequest && !this.xs && this.enablesXDR;
  }, Vd.prototype.abort = function() {
    this.cleanup();
  }, Vd.requestsCount = 0, Vd.requests = {}, "undefined" != typeof document) {
    if ("function" == typeof attachEvent) attachEvent("onunload", Xd);
    else if ("function" == typeof addEventListener) {
      var qd = "onpagehide" in self ? "pagehide" : "unload";
      addEventListener(qd, Xd, false);
    }
  }
  function Xd() {
    for (var e2 in Vd.requests) Vd.requests.hasOwnProperty(e2) && Vd.requests[e2].abort();
  }
  var Gd = {};
  (function(e2) {
    (function() {
      Gd = a2;
      var t2, n2 = /\n/g, r2 = /\\n/g;
      function o2() {
      }
      function i2() {
        return "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e2 ? e2 : {};
      }
      function a2(e3) {
        if (Bd.call(this, e3), this.query = this.query || {}, !t2) {
          var n3 = i2();
          t2 = n3.___eio = n3.___eio || [];
        }
        this.index = t2.length;
        var r3 = this;
        t2.push(function(e4) {
          r3.onData(e4);
        }), this.query.j = this.index, "function" == typeof addEventListener && addEventListener("beforeunload", function() {
          r3.script && (r3.script.onerror = o2);
        }, false);
      }
      Od(a2, Bd), a2.prototype.supportsBinary = false, a2.prototype.doClose = function() {
        this.script && (this.script.parentNode.removeChild(this.script), this.script = null), this.form && (this.form.parentNode.removeChild(this.form), this.form = null, this.iframe = null), Bd.prototype.doClose.call(this);
      }, a2.prototype.doPoll = function() {
        var e3 = this, t3 = document.createElement("script");
        this.script && (this.script.parentNode.removeChild(this.script), this.script = null), t3.async = true, t3.src = this.uri(), t3.onerror = function(t4) {
          e3.onError("jsonp poll error", t4);
        };
        var n3 = document.getElementsByTagName("script")[0];
        n3 ? n3.parentNode.insertBefore(t3, n3) : (document.head || document.body).appendChild(t3), this.script = t3, "undefined" != typeof navigator && /gecko/i.test(navigator.userAgent) && setTimeout(function() {
          var e4 = document.createElement("iframe");
          document.body.appendChild(e4), document.body.removeChild(e4);
        }, 100);
      }, a2.prototype.doWrite = function(e3, t3) {
        var o3 = this;
        if (!this.form) {
          var i3, a3 = document.createElement("form"), s2 = document.createElement("textarea"), l2 = this.iframeId = "eio_iframe_" + this.index;
          a3.className = "socketio", a3.style.position = "absolute", a3.style.top = "-1000px", a3.style.left = "-1000px", a3.target = l2, a3.method = "POST", a3.setAttribute("accept-charset", "utf-8"), s2.name = "d", a3.appendChild(s2), document.body.appendChild(a3), this.form = a3, this.area = s2;
        }
        function u2() {
          c2(), t3();
        }
        function c2() {
          if (o3.iframe) try {
            o3.form.removeChild(o3.iframe);
          } catch (zf) {
            o3.onError("jsonp polling iframe removal error", zf);
          }
          try {
            var e4 = '<iframe src="javascript:0" name="' + o3.iframeId + '">';
            i3 = document.createElement(e4);
          } catch (zf) {
            (i3 = document.createElement("iframe")).name = o3.iframeId, i3.src = "javascript:0";
          }
          i3.id = o3.iframeId, o3.form.appendChild(i3), o3.iframe = i3;
        }
        this.form.action = this.uri(), c2(), e3 = e3.replace(r2, "\\\n"), this.area.value = e3.replace(n2, "\\n");
        try {
          this.form.submit();
        } catch (zf) {
        }
        this.iframe.attachEvent ? this.iframe.onreadystatechange = function() {
          "complete" === o3.iframe.readyState && u2();
        } : this.iframe.onload = u2;
      };
    }).call(this);
  }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
  var Yd = {};
  (function(e2) {
    (function() {
      var t2, n2, r2 = vp("engine.io-client:websocket");
      if ("undefined" != typeof WebSocket) t2 = WebSocket;
      else if ("undefined" != typeof self) t2 = self.WebSocket || self.MozWebSocket;
      else try {
        n2 = i({});
      } catch (zf) {
      }
      var o2 = t2 || n2;
      function a2(e3) {
        e3 && e3.forceBase64 && (this.supportsBinary = false), this.perMessageDeflate = e3.perMessageDeflate, this.usingBrowserWebSocket = t2 && !e3.forceNode, this.protocols = e3.protocols, this.usingBrowserWebSocket || (o2 = n2), Sd.call(this, e3);
      }
      Yd = a2, Od(a2, Sd), a2.prototype.name = "websocket", a2.prototype.supportsBinary = true, a2.prototype.doOpen = function() {
        if (this.check()) {
          var e3 = this.uri(), t3 = this.protocols, n3 = { agent: this.agent, perMessageDeflate: this.perMessageDeflate };
          n3.pfx = this.pfx, n3.key = this.key, n3.passphrase = this.passphrase, n3.cert = this.cert, n3.ca = this.ca, n3.ciphers = this.ciphers, n3.rejectUnauthorized = this.rejectUnauthorized, this.extraHeaders && (n3.headers = this.extraHeaders), this.localAddress && (n3.localAddress = this.localAddress);
          try {
            this.ws = this.usingBrowserWebSocket && !this.isReactNative ? t3 ? new o2(e3, t3) : new o2(e3) : new o2(e3, t3, n3);
          } catch (wd2) {
            return this.emit("error", wd2);
          }
          void 0 === this.ws.binaryType && (this.supportsBinary = false), this.ws.supports && this.ws.supports.binary ? (this.supportsBinary = true, this.ws.binaryType = "nodebuffer") : this.ws.binaryType = "arraybuffer", this.addEventListeners();
        }
      }, a2.prototype.addEventListeners = function() {
        var e3 = this;
        this.ws.onopen = function() {
          e3.onOpen();
        }, this.ws.onclose = function() {
          e3.onClose();
        }, this.ws.onmessage = function(t3) {
          e3.onData(t3.data);
        }, this.ws.onerror = function(t3) {
          e3.onError("websocket error", t3);
        };
      }, a2.prototype.write = function(t3) {
        var n3 = this;
        this.writable = false;
        for (var o3 = t3.length, i2 = 0, a3 = o3; i2 < a3; i2++) !function(t4) {
          md.encodePacket(t4, n3.supportsBinary, function(i3) {
            if (!n3.usingBrowserWebSocket) {
              var a4 = {};
              t4.options && (a4.compress = t4.options.compress), n3.perMessageDeflate && ("string" == typeof i3 ? e2.byteLength(i3) : i3.length) < n3.perMessageDeflate.threshold && (a4.compress = false);
            }
            try {
              n3.usingBrowserWebSocket ? n3.ws.send(i3) : n3.ws.send(i3, a4);
            } catch (zf) {
              r2("websocket closed before onclose event");
            }
            --o3 || (n3.emit("flush"), setTimeout(function() {
              n3.writable = true, n3.emit("drain");
            }, 0));
          });
        }(t3[i2]);
      }, a2.prototype.onClose = function() {
        Sd.prototype.onClose.call(this);
      }, a2.prototype.doClose = function() {
        void 0 !== this.ws && this.ws.close();
      }, a2.prototype.uri = function() {
        var e3 = this.query || {}, t3 = this.secure ? "wss" : "ws", n3 = "";
        return this.port && ("wss" === t3 && 443 !== Number(this.port) || "ws" === t3 && 80 !== Number(this.port)) && (n3 = ":" + this.port), this.timestampRequests && (e3[this.timestampParam] = Ad()), this.supportsBinary || (e3.b64 = 1), (e3 = jp.encode(e3)).length && (e3 = "?" + e3), t3 + "://" + (-1 !== this.hostname.indexOf(":") ? "[" + this.hostname + "]" : this.hostname) + n3 + this.path + e3;
      }, a2.prototype.check = function() {
        return !(!o2 || "__initialize" in o2 && this.name === a2.prototype.name);
      };
    }).call(this);
  }).call(this, a({}).Buffer);
  var $d = { polling: function(e2) {
    var t2 = false, n2 = false, r2 = false !== e2.jsonp;
    if ("undefined" != typeof location) {
      var o2 = "https:" === location.protocol, i2 = location.port;
      i2 || (i2 = o2 ? 443 : 80), t2 = e2.hostname !== location.hostname || i2 !== e2.port, n2 = e2.secure !== o2;
    }
    if (e2.xdomain = t2, e2.xscheme = n2, "open" in new Ed(e2) && !e2.forceJSONP) return new jd(e2);
    if (!r2) throw new Error("JSONP disabled");
    return new Gd(e2);
  } };
  $d.websocket = Yd;
  var Kd, Jd = vp("engine.io-client:socket");
  function Qd(e2, t2) {
    if (!(this instanceof Qd)) return new Qd(e2, t2);
    t2 = t2 || {}, e2 && "object" == typeof e2 && (t2 = e2, e2 = null), e2 ? (e2 = lp(e2), t2.hostname = e2.host, t2.secure = "https" === e2.protocol || "wss" === e2.protocol, t2.port = e2.port, e2.query && (t2.query = e2.query)) : t2.host && (t2.hostname = lp(t2.host).host), this.secure = null != t2.secure ? t2.secure : "undefined" != typeof location && "https:" === location.protocol, t2.hostname && !t2.port && (t2.port = this.secure ? "443" : "80"), this.agent = t2.agent || false, this.hostname = t2.hostname || ("undefined" != typeof location ? location.hostname : "localhost"), this.port = t2.port || ("undefined" != typeof location && location.port ? location.port : this.secure ? 443 : 80), this.query = t2.query || {}, "string" == typeof this.query && (this.query = jp.decode(this.query)), this.upgrade = false !== t2.upgrade, this.path = (t2.path || "/engine.io").replace(/\/$/, "") + "/", this.forceJSONP = !!t2.forceJSONP, this.jsonp = false !== t2.jsonp, this.forceBase64 = !!t2.forceBase64, this.enablesXDR = !!t2.enablesXDR, this.timestampParam = t2.timestampParam || "t", this.timestampRequests = t2.timestampRequests, this.transports = t2.transports || ["polling", "websocket"], this.transportOptions = t2.transportOptions || {}, this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.policyPort = t2.policyPort || 843, this.rememberUpgrade = t2.rememberUpgrade || false, this.binaryType = null, this.onlyBinaryUpgrades = t2.onlyBinaryUpgrades, this.perMessageDeflate = false !== t2.perMessageDeflate && (t2.perMessageDeflate || {}), true === this.perMessageDeflate && (this.perMessageDeflate = {}), this.perMessageDeflate && null == this.perMessageDeflate.threshold && (this.perMessageDeflate.threshold = 1024), this.pfx = t2.pfx || null, this.key = t2.key || null, this.passphrase = t2.passphrase || null, this.cert = t2.cert || null, this.ca = t2.ca || null, this.ciphers = t2.ciphers || null, this.rejectUnauthorized = void 0 === t2.rejectUnauthorized || t2.rejectUnauthorized, this.forceNode = !!t2.forceNode, this.isReactNative = "undefined" != typeof navigator && "string" == typeof navigator.product && "reactnative" === navigator.product.toLowerCase(), ("undefined" == typeof self || this.isReactNative) && (t2.extraHeaders && Object.keys(t2.extraHeaders).length > 0 && (this.extraHeaders = t2.extraHeaders), t2.localAddress && (this.localAddress = t2.localAddress)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingIntervalTimer = null, this.pingTimeoutTimer = null, this.open();
  }
  Kd = Qd, Qd.priorWebsocketSuccess = false, Mp(Qd.prototype), Qd.protocol = md.protocol, Qd.Socket = Qd, Qd.Transport = Sd, Qd.transports = $d, Qd.parser = md, Qd.prototype.createTransport = function(e2) {
    Jd('creating transport "%s"', e2);
    var t2 = function(e3) {
      var t3 = {};
      for (var n3 in e3) e3.hasOwnProperty(n3) && (t3[n3] = e3[n3]);
      return t3;
    }(this.query);
    t2.EIO = md.protocol, t2.transport = e2;
    var n2 = this.transportOptions[e2] || {};
    return this.id && (t2.sid = this.id), new $d[e2]({ query: t2, socket: this, agent: n2.agent || this.agent, hostname: n2.hostname || this.hostname, port: n2.port || this.port, secure: n2.secure || this.secure, path: n2.path || this.path, forceJSONP: n2.forceJSONP || this.forceJSONP, jsonp: n2.jsonp || this.jsonp, forceBase64: n2.forceBase64 || this.forceBase64, enablesXDR: n2.enablesXDR || this.enablesXDR, timestampRequests: n2.timestampRequests || this.timestampRequests, timestampParam: n2.timestampParam || this.timestampParam, policyPort: n2.policyPort || this.policyPort, pfx: n2.pfx || this.pfx, key: n2.key || this.key, passphrase: n2.passphrase || this.passphrase, cert: n2.cert || this.cert, ca: n2.ca || this.ca, ciphers: n2.ciphers || this.ciphers, rejectUnauthorized: n2.rejectUnauthorized || this.rejectUnauthorized, perMessageDeflate: n2.perMessageDeflate || this.perMessageDeflate, extraHeaders: n2.extraHeaders || this.extraHeaders, forceNode: n2.forceNode || this.forceNode, localAddress: n2.localAddress || this.localAddress, requestTimeout: n2.requestTimeout || this.requestTimeout, protocols: n2.protocols || void 0, isReactNative: this.isReactNative });
  }, Qd.prototype.open = function() {
    var e2;
    if (this.rememberUpgrade && Qd.priorWebsocketSuccess && -1 !== this.transports.indexOf("websocket")) e2 = "websocket";
    else {
      if (0 === this.transports.length) {
        var t2 = this;
        return void setTimeout(function() {
          t2.emit("error", "No transports available");
        }, 0);
      }
      e2 = this.transports[0];
    }
    this.readyState = "opening";
    try {
      e2 = this.createTransport(e2);
    } catch (zf) {
      return this.transports.shift(), void this.open();
    }
    e2.open(), this.setTransport(e2);
  }, Qd.prototype.setTransport = function(e2) {
    Jd("setting transport %s", e2.name);
    var t2 = this;
    this.transport && (Jd("clearing existing transport %s", this.transport.name), this.transport.removeAllListeners()), this.transport = e2, e2.on("drain", function() {
      t2.onDrain();
    }).on("packet", function(e3) {
      t2.onPacket(e3);
    }).on("error", function(e3) {
      t2.onError(e3);
    }).on("close", function() {
      t2.onClose("transport close");
    });
  }, Qd.prototype.probe = function(e2) {
    Jd('probing transport "%s"', e2);
    var t2 = this.createTransport(e2, { probe: 1 }), n2 = false, r2 = this;
    function o2() {
      if (r2.onlyBinaryUpgrades) {
        var o3 = !this.supportsBinary && r2.transport.supportsBinary;
        n2 = n2 || o3;
      }
      n2 || (Jd('probe transport "%s" opened', e2), t2.send([{ type: "ping", data: "probe" }]), t2.once("packet", function(o4) {
        if (!n2) if ("pong" === o4.type && "probe" === o4.data) {
          if (Jd('probe transport "%s" pong', e2), r2.upgrading = true, r2.emit("upgrading", t2), !t2) return;
          Qd.priorWebsocketSuccess = "websocket" === t2.name, Jd('pausing current transport "%s"', r2.transport.name), r2.transport.pause(function() {
            n2 || "closed" !== r2.readyState && (Jd("changing transport and sending upgrade packet"), c2(), r2.setTransport(t2), t2.send([{ type: "upgrade" }]), r2.emit("upgrade", t2), t2 = null, r2.upgrading = false, r2.flush());
          });
        } else {
          Jd('probe transport "%s" failed', e2);
          var i3 = new Error("probe error");
          i3.transport = t2.name, r2.emit("upgradeError", i3);
        }
      }));
    }
    function i2() {
      n2 || (n2 = true, c2(), t2.close(), t2 = null);
    }
    function a2(n3) {
      var o3 = new Error("probe error: " + n3);
      o3.transport = t2.name, i2(), Jd('probe transport "%s" failed because of error: %s', e2, n3), r2.emit("upgradeError", o3);
    }
    function s2() {
      a2("transport closed");
    }
    function l2() {
      a2("socket closed");
    }
    function u2(e3) {
      t2 && e3.name !== t2.name && (Jd('"%s" works - aborting "%s"', e3.name, t2.name), i2());
    }
    function c2() {
      t2.removeListener("open", o2), t2.removeListener("error", a2), t2.removeListener("close", s2), r2.removeListener("close", l2), r2.removeListener("upgrading", u2);
    }
    Qd.priorWebsocketSuccess = false, t2.once("open", o2), t2.once("error", a2), t2.once("close", s2), this.once("close", l2), this.once("upgrading", u2), t2.open();
  }, Qd.prototype.onOpen = function() {
    if (Jd("socket open"), this.readyState = "open", Qd.priorWebsocketSuccess = "websocket" === this.transport.name, this.emit("open"), this.flush(), "open" === this.readyState && this.upgrade && this.transport.pause) {
      Jd("starting upgrade probes");
      for (var e2 = 0, t2 = this.upgrades.length; e2 < t2; e2++) this.probe(this.upgrades[e2]);
    }
  }, Qd.prototype.onPacket = function(e2) {
    if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) switch (Jd('socket receive: type "%s", data "%s"', e2.type, e2.data), this.emit("packet", e2), this.emit("heartbeat"), e2.type) {
      case "open":
        this.onHandshake(JSON.parse(e2.data));
        break;
      case "pong":
        this.setPing(), this.emit("pong");
        break;
      case "error":
        var t2 = new Error("server error");
        t2.code = e2.data, this.onError(t2);
        break;
      case "message":
        this.emit("data", e2.data), this.emit("message", e2.data);
    }
    else Jd('packet received with socket readyState "%s"', this.readyState);
  }, Qd.prototype.onHandshake = function(e2) {
    this.emit("handshake", e2), this.id = e2.sid, this.transport.query.sid = e2.sid, this.upgrades = this.filterUpgrades(e2.upgrades), this.pingInterval = e2.pingInterval, this.pingTimeout = e2.pingTimeout, this.onOpen(), "closed" !== this.readyState && (this.setPing(), this.removeListener("heartbeat", this.onHeartbeat), this.on("heartbeat", this.onHeartbeat));
  }, Qd.prototype.onHeartbeat = function(e2) {
    clearTimeout(this.pingTimeoutTimer);
    var t2 = this;
    t2.pingTimeoutTimer = setTimeout(function() {
      "closed" !== t2.readyState && t2.onClose("ping timeout");
    }, e2 || t2.pingInterval + t2.pingTimeout);
  }, Qd.prototype.setPing = function() {
    var e2 = this;
    clearTimeout(e2.pingIntervalTimer), e2.pingIntervalTimer = setTimeout(function() {
      Jd("writing ping packet - expecting pong within %sms", e2.pingTimeout), e2.ping(), e2.onHeartbeat(e2.pingTimeout);
    }, e2.pingInterval);
  }, Qd.prototype.ping = function() {
    var e2 = this;
    this.sendPacket("ping", function() {
      e2.emit("ping");
    });
  }, Qd.prototype.onDrain = function() {
    this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, 0 === this.writeBuffer.length ? this.emit("drain") : this.flush();
  }, Qd.prototype.flush = function() {
    "closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length && (Jd("flushing %d packets in socket", this.writeBuffer.length), this.transport.send(this.writeBuffer), this.prevBufferLen = this.writeBuffer.length, this.emit("flush"));
  }, Qd.prototype.write = Qd.prototype.send = function(e2, t2, n2) {
    return this.sendPacket("message", e2, t2, n2), this;
  }, Qd.prototype.sendPacket = function(e2, t2, n2, r2) {
    if ("function" == typeof t2 && (r2 = t2, t2 = void 0), "function" == typeof n2 && (r2 = n2, n2 = null), "closing" !== this.readyState && "closed" !== this.readyState) {
      (n2 = n2 || {}).compress = false !== n2.compress;
      var o2 = { type: e2, data: t2, options: n2 };
      this.emit("packetCreate", o2), this.writeBuffer.push(o2), r2 && this.once("flush", r2), this.flush();
    }
  }, Qd.prototype.close = function() {
    if ("opening" === this.readyState || "open" === this.readyState) {
      this.readyState = "closing";
      var e2 = this;
      this.writeBuffer.length ? this.once("drain", function() {
        this.upgrading ? r2() : t2();
      }) : this.upgrading ? r2() : t2();
    }
    function t2() {
      e2.onClose("forced close"), Jd("socket closing - telling transport to close"), e2.transport.close();
    }
    function n2() {
      e2.removeListener("upgrade", n2), e2.removeListener("upgradeError", n2), t2();
    }
    function r2() {
      e2.once("upgrade", n2), e2.once("upgradeError", n2);
    }
    return this;
  }, Qd.prototype.onError = function(e2) {
    Jd("socket error %j", e2), Qd.priorWebsocketSuccess = false, this.emit("error", e2), this.onClose("transport error", e2);
  }, Qd.prototype.onClose = function(e2, t2) {
    "opening" !== this.readyState && "open" !== this.readyState && "closing" !== this.readyState || (Jd('socket close with reason: "%s"', e2), clearTimeout(this.pingIntervalTimer), clearTimeout(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), this.readyState = "closed", this.id = null, this.emit("close", e2, t2), this.writeBuffer = [], this.prevBufferLen = 0);
  }, Qd.prototype.filterUpgrades = function(e2) {
    for (var t2 = [], n2 = 0, r2 = e2.length; n2 < r2; n2++) ~Lp(this.transports, e2[n2]) && t2.push(e2[n2]);
    return t2;
  };
  var Zd = {};
  (Zd = Kd).parser = md;
  var eh = function(e2, t2) {
    for (var n2 = [], r2 = (t2 = t2 || 0) || 0; r2 < e2.length; r2++) n2[r2 - t2] = e2[r2];
    return n2;
  }, th = function(e2, t2, n2) {
    return e2.on(t2, n2), { destroy: function() {
      e2.removeListener(t2, n2);
    } };
  }, nh = [].slice, rh = function(e2, t2) {
    if ("string" == typeof t2 && (t2 = e2[t2]), "function" != typeof t2) throw new Error("bind() requires a function");
    var n2 = nh.call(arguments, 2);
    return function() {
      return t2.apply(e2, n2.concat(nh.call(arguments)));
    };
  }, oh = {}, ih = vp("socket.io-client:socket");
  oh = oh = lh;
  var ah = { connect: 1, connect_error: 1, connect_timeout: 1, connecting: 1, disconnect: 1, error: 1, reconnect: 1, reconnect_attempt: 1, reconnect_failed: 1, reconnect_error: 1, reconnecting: 1, ping: 1, pong: 1 }, sh = Mp.prototype.emit;
  function lh(e2, t2, n2) {
    this.io = e2, this.nsp = t2, this.json = this, this.ids = 0, this.acks = {}, this.receiveBuffer = [], this.sendBuffer = [], this.connected = false, this.disconnected = true, this.flags = {}, n2 && n2.query && (this.query = n2.query), this.io.autoConnect && this.open();
  }
  Mp(lh.prototype), lh.prototype.subEvents = function() {
    if (!this.subs) {
      var e2 = this.io;
      this.subs = [th(e2, "open", rh(this, "onopen")), th(e2, "packet", rh(this, "onpacket")), th(e2, "close", rh(this, "onclose"))];
    }
  }, lh.prototype.open = lh.prototype.connect = function() {
    return this.connected || (this.subEvents(), this.io.open(), "open" === this.io.readyState && this.onopen(), this.emit("connecting")), this;
  }, lh.prototype.send = function() {
    var e2 = eh(arguments);
    return e2.unshift("message"), this.emit.apply(this, e2), this;
  }, lh.prototype.emit = function(e2) {
    if (ah.hasOwnProperty(e2)) return sh.apply(this, arguments), this;
    var t2 = eh(arguments), n2 = { type: (void 0 !== this.flags.binary ? this.flags.binary : Vp(t2)) ? Op.BINARY_EVENT : Op.EVENT, data: t2, options: {} };
    return n2.options.compress = !this.flags || false !== this.flags.compress, "function" == typeof t2[t2.length - 1] && (ih("emitting packet with ack id %d", this.ids), this.acks[this.ids] = t2.pop(), n2.id = this.ids++), this.connected ? this.packet(n2) : this.sendBuffer.push(n2), this.flags = {}, this;
  }, lh.prototype.packet = function(e2) {
    e2.nsp = this.nsp, this.io.packet(e2);
  }, lh.prototype.onopen = function() {
    if (ih("transport is open - connecting"), "/" !== this.nsp) if (this.query) {
      var e2 = "object" == typeof this.query ? jp.encode(this.query) : this.query;
      ih("sending connect packet with query %s", e2), this.packet({ type: Op.CONNECT, query: e2 });
    } else this.packet({ type: Op.CONNECT });
  }, lh.prototype.onclose = function(e2) {
    ih("close (%s)", e2), this.connected = false, this.disconnected = true, delete this.id, this.emit("disconnect", e2);
  }, lh.prototype.onpacket = function(e2) {
    var t2 = e2.nsp === this.nsp, n2 = e2.type === Op.ERROR && "/" === e2.nsp;
    if (t2 || n2) switch (e2.type) {
      case Op.CONNECT:
        this.onconnect();
        break;
      case Op.EVENT:
      case Op.BINARY_EVENT:
        this.onevent(e2);
        break;
      case Op.ACK:
      case Op.BINARY_ACK:
        this.onack(e2);
        break;
      case Op.DISCONNECT:
        this.ondisconnect();
        break;
      case Op.ERROR:
        this.emit("error", e2.data);
    }
  }, lh.prototype.onevent = function(e2) {
    var t2 = e2.data || [];
    ih("emitting event %j", t2), null != e2.id && (ih("attaching ack callback to event"), t2.push(this.ack(e2.id))), this.connected ? sh.apply(this, t2) : this.receiveBuffer.push(t2);
  }, lh.prototype.ack = function(e2) {
    var t2 = this, n2 = false;
    return function() {
      if (!n2) {
        n2 = true;
        var r2 = eh(arguments);
        ih("sending ack %j", r2), t2.packet({ type: Vp(r2) ? Op.BINARY_ACK : Op.ACK, id: e2, data: r2 });
      }
    };
  }, lh.prototype.onack = function(e2) {
    var t2 = this.acks[e2.id];
    "function" == typeof t2 ? (ih("calling ack %s with %j", e2.id, e2.data), t2.apply(this, e2.data), delete this.acks[e2.id]) : ih("bad ack %s", e2.id);
  }, lh.prototype.onconnect = function() {
    this.connected = true, this.disconnected = false, this.emit("connect"), this.emitBuffered();
  }, lh.prototype.emitBuffered = function() {
    var e2;
    for (e2 = 0; e2 < this.receiveBuffer.length; e2++) sh.apply(this, this.receiveBuffer[e2]);
    for (this.receiveBuffer = [], e2 = 0; e2 < this.sendBuffer.length; e2++) this.packet(this.sendBuffer[e2]);
    this.sendBuffer = [];
  }, lh.prototype.ondisconnect = function() {
    ih("server disconnect (%s)", this.nsp), this.destroy(), this.onclose("io server disconnect");
  }, lh.prototype.destroy = function() {
    if (this.subs) {
      for (var e2 = 0; e2 < this.subs.length; e2++) this.subs[e2].destroy();
      this.subs = null;
    }
    this.io.destroy(this);
  }, lh.prototype.close = lh.prototype.disconnect = function() {
    return this.connected && (ih("performing disconnect (%s)", this.nsp), this.packet({ type: Op.DISCONNECT })), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }, lh.prototype.compress = function(e2) {
    return this.flags.compress = e2, this;
  }, lh.prototype.binary = function(e2) {
    return this.flags.binary = e2, this;
  };
  var uh = {};
  function ch(e2) {
    e2 = e2 || {}, this.ms = e2.min || 100, this.max = e2.max || 1e4, this.factor = e2.factor || 2, this.jitter = e2.jitter > 0 && e2.jitter <= 1 ? e2.jitter : 0, this.attempts = 0;
  }
  uh = ch, ch.prototype.duration = function() {
    var e2 = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
      var t2 = Math.random(), n2 = Math.floor(t2 * this.jitter * e2);
      e2 = 0 == (1 & Math.floor(10 * t2)) ? e2 - n2 : e2 + n2;
    }
    return 0 | Math.min(e2, this.max);
  }, ch.prototype.reset = function() {
    this.attempts = 0;
  }, ch.prototype.setMin = function(e2) {
    this.ms = e2;
  }, ch.prototype.setMax = function(e2) {
    this.max = e2;
  }, ch.prototype.setJitter = function(e2) {
    this.jitter = e2;
  };
  var ph = {}, dh = vp("socket.io-client:manager"), hh = Object.prototype.hasOwnProperty;
  function fh(e2, t2) {
    if (!(this instanceof fh)) return new fh(e2, t2);
    e2 && "object" == typeof e2 && (t2 = e2, e2 = void 0), (t2 = t2 || {}).path = t2.path || "/socket.io", this.nsps = {}, this.subs = [], this.opts = t2, this.reconnection(false !== t2.reconnection), this.reconnectionAttempts(t2.reconnectionAttempts || 1 / 0), this.reconnectionDelay(t2.reconnectionDelay || 1e3), this.reconnectionDelayMax(t2.reconnectionDelayMax || 5e3), this.randomizationFactor(t2.randomizationFactor || 0.5), this.backoff = new uh({ min: this.reconnectionDelay(), max: this.reconnectionDelayMax(), jitter: this.randomizationFactor() }), this.timeout(null == t2.timeout ? 2e4 : t2.timeout), this.readyState = "closed", this.uri = e2, this.connecting = [], this.lastPing = null, this.encoding = false, this.packetBuffer = [];
    var n2 = t2.parser || Op;
    this.encoder = new n2.Encoder(), this.decoder = new n2.Decoder(), this.autoConnect = false !== t2.autoConnect, this.autoConnect && this.open();
  }
  ph = fh, fh.prototype.emitAll = function() {
    for (var e2 in this.emit.apply(this, arguments), this.nsps) hh.call(this.nsps, e2) && this.nsps[e2].emit.apply(this.nsps[e2], arguments);
  }, fh.prototype.updateSocketIds = function() {
    for (var e2 in this.nsps) hh.call(this.nsps, e2) && (this.nsps[e2].id = this.generateId(e2));
  }, fh.prototype.generateId = function(e2) {
    return ("/" === e2 ? "" : e2 + "#") + this.engine.id;
  }, Mp(fh.prototype), fh.prototype.reconnection = function(e2) {
    return arguments.length ? (this._reconnection = !!e2, this) : this._reconnection;
  }, fh.prototype.reconnectionAttempts = function(e2) {
    return arguments.length ? (this._reconnectionAttempts = e2, this) : this._reconnectionAttempts;
  }, fh.prototype.reconnectionDelay = function(e2) {
    return arguments.length ? (this._reconnectionDelay = e2, this.backoff && this.backoff.setMin(e2), this) : this._reconnectionDelay;
  }, fh.prototype.randomizationFactor = function(e2) {
    return arguments.length ? (this._randomizationFactor = e2, this.backoff && this.backoff.setJitter(e2), this) : this._randomizationFactor;
  }, fh.prototype.reconnectionDelayMax = function(e2) {
    return arguments.length ? (this._reconnectionDelayMax = e2, this.backoff && this.backoff.setMax(e2), this) : this._reconnectionDelayMax;
  }, fh.prototype.timeout = function(e2) {
    return arguments.length ? (this._timeout = e2, this) : this._timeout;
  }, fh.prototype.maybeReconnectOnOpen = function() {
    !this.reconnecting && this._reconnection && 0 === this.backoff.attempts && this.reconnect();
  }, fh.prototype.open = fh.prototype.connect = function(e2, t2) {
    if (dh("readyState %s", this.readyState), ~this.readyState.indexOf("open")) return this;
    dh("opening %s", this.uri), this.engine = Zd(this.uri, this.opts);
    var n2 = this.engine, r2 = this;
    this.readyState = "opening", this.skipReconnect = false;
    var o2 = th(n2, "open", function() {
      r2.onopen(), e2 && e2();
    }), i2 = th(n2, "error", function(t3) {
      if (dh("connect_error"), r2.cleanup(), r2.readyState = "closed", r2.emitAll("connect_error", t3), e2) {
        var n3 = new Error("Connection error");
        n3.data = t3, e2(n3);
      } else r2.maybeReconnectOnOpen();
    });
    if (false !== this._timeout) {
      var a2 = this._timeout;
      dh("connect attempt will timeout after %d", a2);
      var s2 = setTimeout(function() {
        dh("connect attempt timed out after %d", a2), o2.destroy(), n2.close(), n2.emit("error", "timeout"), r2.emitAll("connect_timeout", a2);
      }, a2);
      this.subs.push({ destroy: function() {
        clearTimeout(s2);
      } });
    }
    return this.subs.push(o2), this.subs.push(i2), this;
  }, fh.prototype.onopen = function() {
    dh("open"), this.cleanup(), this.readyState = "open", this.emit("open");
    var e2 = this.engine;
    this.subs.push(th(e2, "data", rh(this, "ondata"))), this.subs.push(th(e2, "ping", rh(this, "onping"))), this.subs.push(th(e2, "pong", rh(this, "onpong"))), this.subs.push(th(e2, "error", rh(this, "onerror"))), this.subs.push(th(e2, "close", rh(this, "onclose"))), this.subs.push(th(this.decoder, "decoded", rh(this, "ondecoded")));
  }, fh.prototype.onping = function() {
    this.lastPing = /* @__PURE__ */ new Date(), this.emitAll("ping");
  }, fh.prototype.onpong = function() {
    this.emitAll("pong", /* @__PURE__ */ new Date() - this.lastPing);
  }, fh.prototype.ondata = function(e2) {
    this.decoder.add(e2);
  }, fh.prototype.ondecoded = function(e2) {
    this.emit("packet", e2);
  }, fh.prototype.onerror = function(e2) {
    dh("error", e2), this.emitAll("error", e2);
  }, fh.prototype.socket = function(e2, t2) {
    var n2 = this.nsps[e2];
    if (!n2) {
      n2 = new oh(this, e2, t2), this.nsps[e2] = n2;
      var r2 = this;
      n2.on("connecting", o2), n2.on("connect", function() {
        n2.id = r2.generateId(e2);
      }), this.autoConnect && o2();
    }
    function o2() {
      ~Lp(r2.connecting, n2) || r2.connecting.push(n2);
    }
    return n2;
  }, fh.prototype.destroy = function(e2) {
    var t2 = Lp(this.connecting, e2);
    ~t2 && this.connecting.splice(t2, 1), this.connecting.length || this.close();
  }, fh.prototype.packet = function(e2) {
    dh("writing packet %j", e2);
    var t2 = this;
    e2.query && 0 === e2.type && (e2.nsp += "?" + e2.query), t2.encoding ? t2.packetBuffer.push(e2) : (t2.encoding = true, this.encoder.encode(e2, function(n2) {
      for (var r2 = 0; r2 < n2.length; r2++) t2.engine.write(n2[r2], e2.options);
      t2.encoding = false, t2.processPacketQueue();
    }));
  }, fh.prototype.processPacketQueue = function() {
    if (this.packetBuffer.length > 0 && !this.encoding) {
      var e2 = this.packetBuffer.shift();
      this.packet(e2);
    }
  }, fh.prototype.cleanup = function() {
    dh("cleanup");
    for (var e2 = this.subs.length, t2 = 0; t2 < e2; t2++) this.subs.shift().destroy();
    this.packetBuffer = [], this.encoding = false, this.lastPing = null, this.decoder.destroy();
  }, fh.prototype.close = fh.prototype.disconnect = function() {
    dh("disconnect"), this.skipReconnect = true, this.reconnecting = false, "opening" === this.readyState && this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.engine && this.engine.close();
  }, fh.prototype.onclose = function(e2) {
    dh("onclose"), this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.emit("close", e2), this._reconnection && !this.skipReconnect && this.reconnect();
  }, fh.prototype.reconnect = function() {
    if (this.reconnecting || this.skipReconnect) return this;
    var e2 = this;
    if (this.backoff.attempts >= this._reconnectionAttempts) dh("reconnect failed"), this.backoff.reset(), this.emitAll("reconnect_failed"), this.reconnecting = false;
    else {
      var t2 = this.backoff.duration();
      dh("will wait %dms before reconnect attempt", t2), this.reconnecting = true;
      var n2 = setTimeout(function() {
        e2.skipReconnect || (dh("attempting reconnect"), e2.emitAll("reconnect_attempt", e2.backoff.attempts), e2.emitAll("reconnecting", e2.backoff.attempts), e2.skipReconnect || e2.open(function(t3) {
          t3 ? (dh("reconnect attempt error"), e2.reconnecting = false, e2.reconnect(), e2.emitAll("reconnect_error", t3.data)) : (dh("reconnect success"), e2.onreconnect());
        }));
      }, t2);
      this.subs.push({ destroy: function() {
        clearTimeout(n2);
      } });
    }
  }, fh.prototype.onreconnect = function() {
    var e2 = this.backoff.attempts;
    this.reconnecting = false, this.backoff.reset(), this.updateSocketIds(), this.emitAll("reconnect", e2);
  };
  function mh() {
    return (mh = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function vh(e2, t2) {
    return (vh = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var gh, yh = ["ASSEMBLY_UPLOADING", "ASSEMBLY_EXECUTING", "ASSEMBLY_COMPLETED"];
  function bh(e2, t2) {
    return yh.indexOf(e2) >= yh.indexOf(t2);
  }
  var _h = function(e2) {
    var t2, n2;
    function r2(t3) {
      var n3;
      return (n3 = e2.call(this) || this).status = t3, n3.socket = null, n3.pollInterval = null, n3.closed = false, n3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, vh(t2, n2);
    var i2 = r2.prototype;
    return i2.connect = function() {
      this._connectSocket(), this._beginPolling();
    }, i2._onFinished = function() {
      this.emit("finished"), this.close();
    }, i2._connectSocket = function() {
      var e3 = this, t3 = function(e4) {
        var t4 = /^\w+:\/\//.exec(e4), n4 = 0;
        t4 && (n4 = t4[0].length + 1);
        var r3 = e4.indexOf("/", n4);
        return -1 === r3 ? { origin: e4, pathname: "/" } : { origin: e4.slice(0, r3), pathname: e4.slice(r3) };
      }(this.status.websocket_url), n3 = (gh || (gh = o({})), gh).connect(t3.origin, { transports: ["websocket"], path: t3.pathname });
      n3.on("connect", function() {
        n3.emit("assembly_connect", { id: e3.status.assembly_id }), e3.emit("connect");
      }), n3.on("connect_failed", function() {
        e3._onError(new Te("Transloadit Socket.io connection error")), e3.socket = null;
      }), n3.on("error", function() {
        n3.disconnect(), e3.socket = null;
      }), n3.on("assembly_finished", function() {
        e3._onFinished();
      }), n3.on("assembly_upload_finished", function(t4) {
        e3.emit("upload", t4), e3.status.uploads.push(t4);
      }), n3.on("assembly_uploading_finished", function() {
        e3.emit("executing");
      }), n3.on("assembly_upload_meta_data_extracted", function() {
        e3.emit("metadata"), e3._fetchStatus({ diff: false });
      }), n3.on("assembly_result_finished", function(t4, n4) {
        e3.emit("result", t4, n4), e3.status.results[t4] || (e3.status.results[t4] = []), e3.status.results[t4].push(n4);
      }), n3.on("assembly_error", function(t4) {
        e3._onError(t4), e3._fetchStatus({ diff: false });
      }), this.socket = n3;
    }, i2._onError = function(e3) {
      this.emit("error", mh(new Error(e3.message), e3));
    }, i2._beginPolling = function() {
      var e3 = this;
      this.pollInterval = setInterval(function() {
        e3.socket && e3.socket.connected || e3._fetchStatus();
      }, 2e3);
    }, i2._fetchStatus = function(e3) {
      var t3 = this, n3 = (void 0 === e3 ? {} : e3).diff, r3 = void 0 === n3 || n3;
      return Re(this.status.assembly_ssl_url).then(function(e4) {
        return e4.json();
      }).then(function(e4) {
        t3.closed || (t3.emit("status", e4), r3 ? t3.updateStatus(e4) : t3.status = e4);
      }).catch(function(e4) {
        return t3._onError(e4);
      });
    }, i2.update = function() {
      return this._fetchStatus({ diff: true });
    }, i2.updateStatus = function(e3) {
      this._diffStatus(this.status, e3), this.status = e3;
    }, i2._diffStatus = function(e3, t3) {
      var n3 = this, r3 = e3.ok, o2 = t3.ok;
      if (t3.error && !e3.error) return this._onError(t3);
      var i3 = bh(o2, "ASSEMBLY_EXECUTING") && !bh(r3, "ASSEMBLY_EXECUTING");
      i3 && this.emit("executing"), Object.keys(t3.uploads).filter(function(t4) {
        return !C(e3.uploads, t4);
      }).map(function(e4) {
        return t3.uploads[e4];
      }).forEach(function(e4) {
        n3.emit("upload", e4);
      }), i3 && this.emit("metadata"), Object.keys(t3.results).forEach(function(r4) {
        var o3 = t3.results[r4], i4 = e3.results[r4];
        o3.filter(function(e4) {
          return !i4 || !i4.some(function(t4) {
            return t4.id === e4.id;
          });
        }).forEach(function(e4) {
          n3.emit("result", r4, e4);
        });
      }), bh(o2, "ASSEMBLY_COMPLETED") && !bh(r3, "ASSEMBLY_COMPLETED") && this.emit("finished");
    }, i2.close = function() {
      this.closed = true, this.socket && (this.socket.disconnect(), this.socket = null), clearInterval(this.pollInterval);
    }, r2;
  }(Mp), wh = function() {
    function e2(e3) {
      void 0 === e3 && (e3 = {}), this.opts = e3, this._reportError = this._reportError.bind(this), this._headers = { "Transloadit-Client": this.opts.client };
    }
    var t2 = e2.prototype;
    return t2.createAssembly = function(e3) {
      var t3 = this, n2 = e3.params, r2 = e3.fields, o2 = e3.signature, i2 = e3.expectedFiles, a2 = new FormData();
      a2.append("params", "string" == typeof n2 ? n2 : JSON.stringify(n2)), o2 && a2.append("signature", o2), Object.keys(r2).forEach(function(e4) {
        a2.append(e4, r2[e4]);
      }), a2.append("num_expected_upload_files", i2);
      var s2 = new Ve("/assemblies", "" + this.opts.service).href;
      return Re(s2, { method: "post", headers: this._headers, body: a2 }).then(function(e4) {
        return e4.json();
      }).then(function(e4) {
        if (e4.error) {
          var t4 = new Error(e4.error);
          throw t4.details = e4.message, t4.assembly = e4, e4.assembly_id && (t4.details += " Assembly ID: " + e4.assembly_id), t4;
        }
        return e4;
      }).catch(function(e4) {
        return t3._reportError(e4, { url: s2, type: "API_ERROR" });
      });
    }, t2.reserveFile = function(e3, t3) {
      var n2 = this, r2 = encodeURIComponent(t3.size), o2 = e3.assembly_ssl_url + "/reserve_file?size=" + r2;
      return Re(o2, { method: "post", headers: this._headers }).then(function(e4) {
        return e4.json();
      }).catch(function(r3) {
        return n2._reportError(r3, { assembly: e3, file: t3, url: o2, type: "API_ERROR" });
      });
    }, t2.addFile = function(e3, t3) {
      var n2 = this;
      if (!t3.uploadURL) return Promise.reject(new Error("File does not have an `uploadURL`."));
      var r2 = encodeURIComponent(t3.size), o2 = encodeURIComponent(t3.uploadURL), i2 = "size=" + r2 + "&filename=" + encodeURIComponent(t3.name) + "&fieldname=file&s3Url=" + o2, a2 = e3.assembly_ssl_url + "/add_file?" + i2;
      return Re(a2, { method: "post", headers: this._headers }).then(function(e4) {
        return e4.json();
      }).catch(function(r3) {
        return n2._reportError(r3, { assembly: e3, file: t3, url: a2, type: "API_ERROR" });
      });
    }, t2.cancelAssembly = function(e3) {
      var t3 = this, n2 = e3.assembly_ssl_url;
      return Re(n2, { method: "delete", headers: this._headers }).then(function(e4) {
        return e4.json();
      }).catch(function(e4) {
        return t3._reportError(e4, { url: n2, type: "API_ERROR" });
      });
    }, t2.getAssemblyStatus = function(e3) {
      var t3 = this;
      return Re(e3, { headers: this._headers }).then(function(e4) {
        return e4.json();
      }).catch(function(n2) {
        return t3._reportError(n2, { url: e3, type: "STATUS_ERROR" });
      });
    }, t2.submitError = function(e3, t3) {
      var n2 = t3.endpoint, r2 = t3.instance, o2 = t3.assembly, i2 = e3.details ? e3.message + " (" + e3.details + ")" : e3.message;
      return Re("https://transloaditstatus.com/client_error", { method: "post", body: JSON.stringify({ endpoint: n2, instance: r2, assembly_id: o2, agent: "undefined" != typeof navigator ? navigator.userAgent : "", client: this.opts.client, error: i2 }) }).then(function(e4) {
        return e4.json();
      });
    }, t2._reportError = function(e3, t3) {
      if (false === this.opts.errorReporting) throw e3;
      var n2 = { type: t3.type };
      throw t3.assembly && (n2.assembly = t3.assembly.assembly_id, n2.instance = t3.assembly.instance), t3.url && (n2.endpoint = t3.url), this.submitError(e3, n2).catch(function(e4) {
      }), e3;
    }, e2;
  }(), Ch = {};
  function Sh(e2) {
    if (!e2) throw new Error("Transloadit: The `params` option is required.");
    if ("string" == typeof e2) try {
      e2 = JSON.parse(e2);
    } catch (wd2) {
      throw wd2.message = "Transloadit: The `params` option is a malformed JSON string: " + wd2.message, wd2;
    }
    if (!e2.auth || !e2.auth.key) throw new Error("Transloadit: The `params.auth.key` option is required. You can find your Transloadit API key at https://transloadit.com/account/api-settings.");
  }
  var kh = function() {
    function e2(e3, t3) {
      this.files = e3, this.opts = t3;
    }
    var t2 = e2.prototype;
    return t2._normalizeAssemblyOptions = function(e3, t3) {
      if (Array.isArray(t3.fields)) {
        var n2 = t3.fields;
        t3.fields = {}, n2.forEach(function(n3) {
          t3.fields[n3] = e3.meta[n3];
        });
      }
      return t3.fields || (t3.fields = {}), t3;
    }, t2._getAssemblyOptions = function(e3) {
      var t3 = this, n2 = this.opts;
      return Promise.resolve().then(function() {
        return n2.getAssemblyOptions(e3, n2);
      }).then(function(n3) {
        return t3._normalizeAssemblyOptions(e3, n3);
      }).then(function(t4) {
        return Sh(t4.params), { fileIDs: [e3.id], options: t4 };
      });
    }, t2._dedupe = function(e3) {
      var t3 = /* @__PURE__ */ Object.create(null);
      return e3.forEach(function(e4) {
        var n2, r2 = e4.fileIDs, o2 = e4.options, i2 = JSON.stringify(o2);
        t3[i2] ? (n2 = t3[i2].fileIDs).push.apply(n2, r2) : t3[i2] = { options: o2, fileIDs: [].concat(r2) };
      }), Object.keys(t3).map(function(e4) {
        return t3[e4];
      });
    }, t2.build = function() {
      var e3 = this, t3 = this.opts;
      return this.files.length > 0 ? Promise.all(this.files.map(function(t4) {
        return e3._getAssemblyOptions(t4);
      })).then(function(t4) {
        return e3._dedupe(t4);
      }) : t3.alwaysRunAssembly ? Promise.resolve(t3.getAssemblyOptions(null, t3)).then(function(t4) {
        return Sh(t4.params), [{ fileIDs: e3.files.map(function(e4) {
          return e4.id;
        }), options: t4 }];
      }) : Promise.resolve([]);
    }, e2;
  }();
  function xh(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Ph(e2, t2) {
    return (Ph = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  (Ch = kh).validateParams = Sh;
  var Eh, Oh, Ah = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this) || this)._uppy = t3, r3._assemblyIDs = n3, r3._remaining = n3.length, r3.promise = new Promise(function(e3, t4) {
        r3._resolve = e3, r3._reject = t4;
      }), r3._onAssemblyComplete = r3._onAssemblyComplete.bind(xh(r3)), r3._onAssemblyCancel = r3._onAssemblyCancel.bind(xh(r3)), r3._onAssemblyError = r3._onAssemblyError.bind(xh(r3)), r3._onImportError = r3._onImportError.bind(xh(r3)), r3._addListeners(), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Ph(t2, n2);
    var o2 = r2.prototype;
    return o2._watching = function(e3) {
      return -1 !== this._assemblyIDs.indexOf(e3);
    }, o2._onAssemblyComplete = function(e3) {
      this._watching(e3.assembly_id) && (this._uppy.log("[Transloadit] AssemblyWatcher: Got Assembly finish " + e3.assembly_id), this.emit("assembly-complete", e3.assembly_id), this._checkAllComplete());
    }, o2._onAssemblyCancel = function(e3) {
      this._watching(e3.assembly_id) && this._checkAllComplete();
    }, o2._onAssemblyError = function(e3, t3) {
      this._watching(e3.assembly_id) && (this._uppy.log("[Transloadit] AssemblyWatcher: Got Assembly error " + e3.assembly_id), this._uppy.log(t3), this.emit("assembly-error", e3.assembly_id, t3), this._checkAllComplete());
    }, o2._onImportError = function(e3, t3, n3) {
      this._watching(e3.assembly_id) && this._onAssemblyError(e3, n3);
    }, o2._checkAllComplete = function() {
      this._remaining -= 1, 0 === this._remaining && (this._removeListeners(), this._resolve());
    }, o2._removeListeners = function() {
      this._uppy.off("transloadit:complete", this._onAssemblyComplete), this._uppy.off("transloadit:assembly-cancel", this._onAssemblyCancel), this._uppy.off("transloadit:assembly-error", this._onAssemblyError), this._uppy.off("transloadit:import-error", this._onImportError);
    }, o2._addListeners = function() {
      this._uppy.on("transloadit:complete", this._onAssemblyComplete), this._uppy.on("transloadit:assembly-cancel", this._onAssemblyCancel), this._uppy.on("transloadit:assembly-error", this._onAssemblyError), this._uppy.on("transloadit:import-error", this._onImportError);
    }, r2;
  }(Mp), Uh = {};
  function Nh() {
    return (Nh = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Th(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Rh(e2, t2) {
    return (Rh = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function Fh(e2, t2) {
    return { params: t2.params, signature: t2.signature, fields: t2.fields };
  }
  var Dh = "https://api2.transloadit.com/companion", Mh = /https?:\/\/api2(?:-\w+)?\.transloadit\.com\/companion/, Bh = /https?:\/\/api2(?:-\w+)?\.transloadit\.com\/uppy-server/;
  Oh = Eh = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      (r3 = e2.call(this, t3, n3) || this).type = "uploader", r3.id = r3.opts.id || "Transloadit", r3.title = "Transloadit", r3.defaultLocale = { strings: { creatingAssembly: "Preparing upload...", creatingAssemblyFailed: "Transloadit: Could not create Assembly", encoding: "Encoding..." } };
      var o3 = { service: "https://api2.transloadit.com", errorReporting: true, waitForEncoding: false, waitForMetadata: false, alwaysRunAssembly: false, importFromUploadURLs: false, signature: null, params: null, fields: {}, getAssemblyOptions: Fh, limit: 0 };
      r3.opts = Nh({}, o3, n3), r3.i18nInit(), r3._prepareUpload = r3._prepareUpload.bind(Th(r3)), r3._afterUpload = r3._afterUpload.bind(Th(r3)), r3._onError = r3._onError.bind(Th(r3)), r3._onTusError = r3._onTusError.bind(Th(r3)), r3._onCancelAll = r3._onCancelAll.bind(Th(r3)), r3._onFileUploadURLAvailable = r3._onFileUploadURLAvailable.bind(Th(r3)), r3._onRestored = r3._onRestored.bind(Th(r3)), r3._getPersistentData = r3._getPersistentData.bind(Th(r3));
      var i2 = r3.opts.getAssemblyOptions !== o3.getAssemblyOptions;
      return r3.opts.params ? Ch.validateParams(r3.opts.params) : i2 || Ch.validateParams(null), r3.client = new wh({ service: r3.opts.service, client: r3._getClientVersion(), errorReporting: r3.opts.errorReporting }), r3.activeAssemblies = {}, r3.assemblyWatchers = {}, r3.completedFiles = /* @__PURE__ */ Object.create(null), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Rh(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, t3), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.i18nArray = this.translator.translateArray.bind(this.translator), this.setPluginState();
    }, o2._getClientVersion = function() {
      var e3 = this, t3 = ["uppy-core:" + this.uppy.constructor.VERSION, "uppy-transloadit:" + this.constructor.VERSION, "uppy-tus:" + ip.VERSION], n3 = function(n4, r3) {
        var o3 = e3.uppy.getPlugin(n4);
        o3 && t3.push(r3 + ":" + o3.constructor.VERSION);
      };
      return this.opts.importFromUploadURLs && (n3("XHRUpload", "uppy-xhr-upload"), n3("AwsS3", "uppy-aws-s3"), n3("AwsS3Multipart", "uppy-aws-s3-multipart")), n3("Dropbox", "uppy-dropbox"), n3("Box", "uppy-box"), n3("Facebook", "uppy-facebook"), n3("GoogleDrive", "uppy-google-drive"), n3("Instagram", "uppy-instagram"), n3("OneDrive", "uppy-onedrive"), n3("Zoom", "uppy-zoom"), n3("Url", "uppy-url"), t3.join(",");
    }, o2._attachAssemblyMetadata = function(e3, t3) {
      var n3 = Nh({}, e3.meta, { assembly_url: t3.assembly_url, filename: e3.name, fieldname: "file" }), r3 = Nh({}, e3.tus, { endpoint: t3.tus_url, addRequestId: true }), o3 = e3.remote;
      if (e3.remote && Bh.test(e3.remote.companionUrl)) {
        var i2 = new Error("The https://api2.transloadit.com/uppy-server endpoint was renamed to https://api2.transloadit.com/companion, please update your `companionUrl` options accordingly.");
        throw this.uppy.log(i2), i2;
      }
      if (e3.remote && Mh.test(e3.remote.companionUrl)) {
        var a2 = t3.companion_url.replace(/\/$/, ""), s2 = e3.remote.url.replace(e3.remote.companionUrl, "").replace(/^\//, "");
        o3 = Nh({}, e3.remote, { companionUrl: a2, url: a2 + "/" + s2 });
      }
      var l2 = Nh({}, e3, { transloadit: { assembly: t3.assembly_id } });
      return this.opts.importFromUploadURLs || Nh(l2, { meta: n3, tus: r3, remote: o3 }), l2;
    }, o2._createAssembly = function(e3, t3, n3) {
      var r3 = this;
      return this.uppy.log("[Transloadit] Create Assembly"), this.client.createAssembly({ params: n3.params, fields: n3.fields, expectedFiles: e3.length, signature: n3.signature }).then(function(n4) {
        var o3, i2, a2 = new _h(n4), s2 = a2.status, l2 = s2.assembly_id, u2 = r3.getPluginState(), c2 = u2.assemblies, p2 = u2.uploadsAssemblies;
        r3.setPluginState({ assemblies: Nh({}, c2, (o3 = {}, o3[l2] = s2, o3)), uploadsAssemblies: Nh({}, p2, (i2 = {}, i2[t3] = [].concat(p2[t3], [l2]), i2)) });
        var d2 = r3.uppy.getState().files, h2 = {};
        return e3.forEach(function(e4) {
          h2[e4] = r3._attachAssemblyMetadata(r3.uppy.getFile(e4), s2);
        }), r3.uppy.setState({ files: Nh({}, d2, h2) }), r3.uppy.emit("transloadit:assembly-created", s2, e3), r3.uppy.log("[Transloadit] Created Assembly " + l2), a2;
      }).catch(function(e4) {
        throw e4.message = r3.i18n("creatingAssemblyFailed") + ": " + e4.message, e4;
      });
    }, o2._createAssemblyWatcher = function(e3, t3, n3) {
      var r3 = this, o3 = new Ah(this.uppy, e3);
      o3.on("assembly-complete", function(e4) {
        r3.getAssemblyFiles(e4).forEach(function(e5) {
          r3.completedFiles[e5.id] = true, r3.uppy.emit("postprocess-complete", e5);
        });
      }), o3.on("assembly-error", function(e4, t4) {
        r3.getAssemblyFiles(e4).forEach(function(e5) {
          r3.uppy.emit("upload-error", e5, t4), r3.uppy.emit("postprocess-complete", e5);
        });
      }), this.assemblyWatchers[n3] = o3;
    }, o2._shouldWaitAfterUpload = function() {
      return this.opts.waitForEncoding || this.opts.waitForMetadata;
    }, o2._reserveFiles = function(e3, t3) {
      var n3 = this;
      return Promise.all(t3.map(function(t4) {
        var r3 = n3.uppy.getFile(t4);
        return n3.client.reserveFile(e3.status, r3);
      }));
    }, o2._onFileUploadURLAvailable = function(e3) {
      var t3 = this, n3 = this.uppy.getFile(e3.id);
      if (n3 && n3.transloadit && n3.transloadit.assembly) {
        var r3 = this.getPluginState().assemblies[n3.transloadit.assembly];
        this.client.addFile(r3, n3).catch(function(e4) {
          t3.uppy.log(e4), t3.uppy.emit("transloadit:import-error", r3, n3.id, e4);
        });
      }
    }, o2._findFile = function(e3) {
      for (var t3 = this.uppy.getFiles(), n3 = 0; n3 < t3.length; n3++) {
        var r3 = t3[n3];
        if (r3.uploadURL === e3.tus_upload_url) return r3;
        if (r3.tus && r3.tus.uploadUrl === e3.tus_upload_url) return r3;
        if (!e3.is_tus_file && r3.name === e3.name && r3.size === e3.size) return r3;
      }
    }, o2._onFileUploadComplete = function(e3, t3) {
      var n3, r3 = this.getPluginState(), o3 = this._findFile(t3);
      o3 ? (this.setPluginState({ files: Nh({}, r3.files, (n3 = {}, n3[t3.id] = { assembly: e3, id: o3.id, uploadedFile: t3 }, n3)) }), this.uppy.emit("transloadit:upload", t3, this.getAssembly(e3))) : this.uppy.log("[Transloadit] Couldn\u2019t file the file, it was likely removed in the process");
    }, o2._onResult = function(e3, t3, n3) {
      var r3 = this.getPluginState(), o3 = r3.files[n3.original_id];
      n3.localId = o3 ? o3.id : null;
      var i2 = { result: n3, stepName: t3, id: n3.id, assembly: e3 };
      this.setPluginState({ results: [].concat(r3.results, [i2]) }), this.uppy.emit("transloadit:result", t3, n3, this.getAssembly(e3));
    }, o2._onAssemblyFinished = function(e3) {
      var t3 = this, n3 = e3.assembly_ssl_url;
      this.client.getAssemblyStatus(n3).then(function(e4) {
        var n4, r3 = e4.assembly_id, o3 = t3.getPluginState();
        t3.setPluginState({ assemblies: Nh({}, o3.assemblies, (n4 = {}, n4[r3] = e4, n4)) }), t3.uppy.emit("transloadit:complete", e4);
      });
    }, o2._cancelAssembly = function(e3) {
      var t3 = this;
      return this.client.cancelAssembly(e3).then(function() {
        t3.uppy.emit("transloadit:assembly-cancelled", e3);
      });
    }, o2._onCancelAll = function() {
      var e3 = this, t3 = this.getPluginState().uploadsAssemblies, n3 = Object.keys(t3).reduce(function(e4, n4) {
        return e4.push.apply(e4, t3[n4]), e4;
      }, []).map(function(t4) {
        var n4 = e3.getAssembly(t4);
        return e3._cancelAssembly(n4);
      });
      Promise.all(n3).catch(function(t4) {
        e3.uppy.log(t4);
      });
    }, o2._getPersistentData = function(e3) {
      var t3, n3 = this.getPluginState(), r3 = n3.assemblies, o3 = n3.uploadsAssemblies;
      e3(((t3 = {})[this.id] = { assemblies: r3, uploadsAssemblies: o3 }, t3));
    }, o2._onRestored = function(e3) {
      var t3 = this, n3 = e3 && e3[this.id] ? e3[this.id] : {}, r3 = n3.assemblies || {}, o3 = n3.uploadsAssemblies || {};
      0 !== Object.keys(o3).length && (this.restored = Promise.resolve().then(function() {
        var e4, n4, i2;
        return e4 = r3, n4 = {}, i2 = [], Object.keys(e4).forEach(function(r4) {
          var o4 = e4[r4];
          o4.uploads.forEach(function(e5) {
            var o5 = t3._findFile(e5);
            n4[e5.id] = { id: o5.id, assembly: r4, uploadedFile: e5 };
          });
          var a2 = t3.getPluginState();
          Object.keys(o4.results).forEach(function(e5) {
            o4.results[e5].forEach(function(t4) {
              var n5 = a2.files[t4.original_id];
              t4.localId = n5 ? n5.id : null, i2.push({ id: t4.id, result: t4, stepName: e5, assembly: r4 });
            });
          });
        }), t3.setPluginState({ assemblies: e4, files: n4, results: i2, uploadsAssemblies: o3 }), function() {
          var e5 = t3.getPluginState(), n5 = e5.assemblies, r4 = e5.uploadsAssemblies;
          Object.keys(r4).forEach(function(e6) {
            var n6 = r4[e6], o4 = n6.reduce(function(e7, n7) {
              var r5 = t3.getAssemblyFiles(n7).map(function(e8) {
                return e8.id;
              });
              return e7.push.apply(e7, r5), e7;
            }, []);
            t3._createAssemblyWatcher(n6, o4, e6);
          }), Object.keys(n5).forEach(function(e6) {
            var r5 = new _h(n5[e6]);
            t3._connectAssembly(r5);
          });
        }(), function() {
          var e5 = t3.getPluginState().assemblies;
          return Promise.all(Object.keys(e5).map(function(e6) {
            return t3.activeAssemblies[e6].update();
          }));
        }();
      }), this.restored.then(function() {
        t3.restored = null;
      }));
    }, o2._connectAssembly = function(e3) {
      var t3 = this, n3 = e3.status.assembly_id;
      return this.activeAssemblies[n3] = e3, e3.on("status", function(e4) {
        var r3, o3 = t3.getPluginState().assemblies;
        t3.setPluginState({ assemblies: Nh({}, o3, (r3 = {}, r3[n3] = e4, r3)) });
      }), e3.on("upload", function(e4) {
        t3._onFileUploadComplete(n3, e4);
      }), e3.on("error", function(n4) {
        n4.assembly = e3.status, t3.uppy.emit("transloadit:assembly-error", e3.status, n4);
      }), e3.on("executing", function() {
        t3.uppy.emit("transloadit:assembly-executing", e3.status);
      }), this.opts.waitForEncoding && e3.on("result", function(e4, r3) {
        t3._onResult(n3, e4, r3);
      }), this.opts.waitForEncoding ? e3.on("finished", function() {
        t3._onAssemblyFinished(e3.status);
      }) : this.opts.waitForMetadata && e3.on("metadata", function() {
        t3._onAssemblyFinished(e3.status);
      }), "ASSEMBLY_COMPLETE" === e3.ok || (new Promise(function(t4, n4) {
        e3.once("connect", t4), e3.once("status", t4), e3.once("error", n4);
      }).then(function() {
        t3.uppy.log("[Transloadit] Socket is ready");
      }), e3.connect()), e3;
    }, o2._prepareUpload = function(e3, t3) {
      var n3, r3 = this;
      (e3 = e3.filter(function(e4) {
        return !e4.error;
      })).forEach(function(e4) {
        var t4 = r3.uppy.getFile(e4);
        r3.uppy.emit("preprocess-progress", t4, { mode: "indeterminate", message: r3.i18n("creatingAssembly") });
      });
      var o3 = function(e4) {
        var n4, o4 = e4.fileIDs, i3 = e4.options;
        return r3._createAssembly(o4, t3, i3).then(function(e5) {
          if (n4 = e5, r3.opts.importFromUploadURLs) return r3._reserveFiles(e5, o4);
        }).then(function() {
          return o4.forEach(function(e5) {
            var t4 = r3.uppy.getFile(e5);
            r3.uppy.emit("preprocess-complete", t4);
          }), n4;
        }).catch(function(e5) {
          throw o4.forEach(function(t4) {
            var n5 = r3.uppy.getFile(t4);
            r3.uppy.emit("preprocess-complete", n5), r3.uppy.emit("upload-error", n5, e5);
          }), e5;
        });
      }, i2 = this.getPluginState().uploadsAssemblies;
      this.setPluginState({ uploadsAssemblies: Nh({}, i2, (n3 = {}, n3[t3] = [], n3)) });
      var a2 = e3.map(function(e4) {
        return r3.uppy.getFile(e4);
      });
      return new Ch(a2, this.opts).build().then(function(n4) {
        return Promise.all(n4.map(o3)).then(function(n5) {
          var o4 = n5.map(function(e4) {
            return e4.status.assembly_id;
          });
          r3._createAssemblyWatcher(o4, e3, t3), n5.map(function(e4) {
            return r3._connectAssembly(e4);
          });
        });
      }, function(t4) {
        throw e3.forEach(function(e4) {
          var n4 = r3.uppy.getFile(e4);
          r3.uppy.emit("preprocess-complete", n4), r3.uppy.emit("upload-error", n4, t4);
        }), t4;
      });
    }, o2._afterUpload = function(e3, t3) {
      var n3 = this, r3 = e3.map(function(e4) {
        return n3.uppy.getFile(e4);
      });
      e3 = r3.filter(function(e4) {
        return !e4.error;
      }).map(function(e4) {
        return e4.id;
      });
      var o3 = this.getPluginState();
      if (this.restored) return this.restored.then(function() {
        return n3._afterUpload(e3, t3);
      });
      var i2 = o3.uploadsAssemblies[t3], a2 = function() {
        i2.forEach(function(e4) {
          n3.activeAssemblies[e4].close(), delete n3.activeAssemblies[e4];
        });
      };
      if (!this._shouldWaitAfterUpload()) {
        a2();
        var s2 = i2.map(function(e4) {
          return n3.getAssembly(e4);
        });
        return this.uppy.addResultData(t3, { transloadit: s2 }), Promise.resolve();
      }
      return 0 === i2.length ? (this.uppy.addResultData(t3, { transloadit: [] }), Promise.resolve()) : (r3.filter(function(e4) {
        return !C(n3.completedFiles, e4.id);
      }).forEach(function(e4) {
        n3.uppy.emit("postprocess-progress", e4, { mode: "indeterminate", message: n3.i18n("encoding") });
      }), this.assemblyWatchers[t3].promise.then(function() {
        a2();
        var e4 = i2.map(function(e5) {
          return n3.getAssembly(e5);
        }), r4 = Nh({}, n3.getPluginState().uploadsAssemblies);
        delete r4[t3], n3.setPluginState({ uploadsAssemblies: r4 }), n3.uppy.addResultData(t3, { transloadit: e4 });
      }));
    }, o2._onError = function(e3, t3) {
      var n3 = this;
      void 0 === e3 && (e3 = null), this.getPluginState().uploadsAssemblies[t3].forEach(function(e4) {
        n3.activeAssemblies[e4] && n3.activeAssemblies[e4].close();
      });
    }, o2._onTusError = function(e3) {
      if (e3 && /^tus: /.test(e3.message)) {
        var t3 = e3.originalRequest ? e3.originalRequest.getUnderlyingObject() : null, n3 = t3 && t3.responseURL ? t3.responseURL : null;
        this.client.submitError(e3, { url: n3, type: "TUS_ERROR" }).then(function(e4) {
        });
      }
    }, o2.install = function() {
      this.uppy.addPreProcessor(this._prepareUpload), this.uppy.addPostProcessor(this._afterUpload), this.uppy.on("error", this._onError), this.uppy.on("cancel-all", this._onCancelAll), this.uppy.on("upload-error", this._onTusError), this.opts.importFromUploadURLs ? this.uppy.on("upload-success", this._onFileUploadURLAvailable) : this.uppy.use(ip, { storeFingerprintForResuming: false, resume: false, useFastRemoteRetry: false, metaFields: ["assembly_url", "filename", "fieldname"], limit: this.opts.limit }), this.uppy.on("restore:get-data", this._getPersistentData), this.uppy.on("restored", this._onRestored), this.setPluginState({ assemblies: {}, uploadsAssemblies: {}, files: {}, results: [] });
      var e3 = this.uppy.getState().capabilities;
      this.uppy.setState({ capabilities: Nh({}, e3, { individualCancellation: false }) });
    }, o2.uninstall = function() {
      this.uppy.removePreProcessor(this._prepareUpload), this.uppy.removePostProcessor(this._afterUpload), this.uppy.off("error", this._onError), this.opts.importFromUploadURLs && this.uppy.off("upload-success", this._onFileUploadURLAvailable);
      var e3 = this.uppy.getState().capabilities;
      this.uppy.setState({ capabilities: Nh({}, e3, { individualCancellation: true }) });
    }, o2.getAssembly = function(e3) {
      return this.getPluginState().assemblies[e3];
    }, o2.getAssemblyFiles = function(e3) {
      return this.uppy.getFiles().filter(function(t3) {
        return t3 && t3.transloadit && t3.transloadit.assembly === e3;
      });
    }, r2;
  }(ue.Plugin), Eh.VERSION = "1.6.26", (Uh = Oh).COMPANION = Dh, Uh.UPPY_SERVER = Dh, Uh.COMPANION_PATTERN = /\.transloadit\.com$/;
  var Ih, Lh;
  function jh(e2, t2) {
    return (jh = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  function zh() {
    return (zh = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var Hh = Ke.Provider, Wh = Ke.RequestClient, Vh = Ke.Socket;
  function qh(e2, t2) {
    return t2 || (t2 = new Error("Upload error")), "string" == typeof t2 && (t2 = new Error(t2)), t2 instanceof Error || (t2 = zh(new Error("Upload error"), { data: t2 })), Pl(e2) ? t2 = new Te(t2, e2) : (t2.request = e2, t2);
  }
  function Xh(e2) {
    return e2.data.slice(0, e2.data.size, e2.meta.type);
  }
  var Gh = (Lh = Ih = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      (r3 = e2.call(this, t3, n3) || this).type = "uploader", r3.id = r3.opts.id || "XHRUpload", r3.title = "XHRUpload", r3.defaultLocale = { strings: { timedOut: "Upload stalled for %{seconds} seconds, aborting." } };
      var o3 = { formData: true, fieldName: "files[]", method: "post", metaFields: null, responseUrlFieldName: "url", bundle: false, headers: {}, timeout: 3e4, limit: 0, withCredentials: false, responseType: "", getResponseData: function(e3, t4) {
        var n4 = {};
        try {
          n4 = JSON.parse(e3);
        } catch (wd2) {
          console.log(wd2);
        }
        return n4;
      }, getResponseError: function(e3, t4) {
        var n4 = new Error("Upload error");
        return Pl(t4) && (n4 = new Te(n4, t4)), n4;
      }, validateStatus: function(e3, t4, n4) {
        return e3 >= 200 && e3 < 300;
      } };
      if (r3.opts = zh({}, o3, n3), r3.i18nInit(), r3.handleUpload = r3.handleUpload.bind(function(e3) {
        if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e3;
      }(r3)), r3.opts.__queue instanceof _l ? r3.requests = r3.opts.__queue : r3.requests = new _l(r3.opts.limit), r3.opts.bundle && !r3.opts.formData) throw new Error("`opts.formData` must be true when `opts.bundle` is enabled.");
      return r3.uploaderEvents = /* @__PURE__ */ Object.create(null), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, jh(t2, n2);
    var o2 = r2.prototype;
    return o2.setOptions = function(t3) {
      e2.prototype.setOptions.call(this, t3), this.i18nInit();
    }, o2.i18nInit = function() {
      this.translator = new x([this.defaultLocale, this.uppy.locale, this.opts.locale]), this.i18n = this.translator.translate.bind(this.translator), this.setPluginState();
    }, o2.getOptions = function(e3) {
      var t3 = this.uppy.getState().xhrUpload, n3 = this.opts.headers, r3 = zh({}, this.opts, t3 || {}, e3.xhrUpload || {}, { headers: {} });
      return "function" == typeof n3 ? r3.headers = n3(e3) : zh(r3.headers, this.opts.headers), t3 && zh(r3.headers, t3.headers), e3.xhrUpload && zh(r3.headers, e3.xhrUpload.headers), r3;
    }, o2.addMetadata = function(e3, t3, n3) {
      (Array.isArray(n3.metaFields) ? n3.metaFields : Object.keys(t3)).forEach(function(n4) {
        e3.append(n4, t3[n4]);
      });
    }, o2.createFormDataUpload = function(e3, t3) {
      var n3 = new FormData();
      this.addMetadata(n3, e3.meta, t3);
      var r3 = Xh(e3);
      return e3.name ? n3.append(t3.fieldName, r3, e3.meta.name) : n3.append(t3.fieldName, r3), n3;
    }, o2.createBundledUpload = function(e3, t3) {
      var n3 = this, r3 = new FormData(), o3 = this.uppy.getState().meta;
      return this.addMetadata(r3, o3, t3), e3.forEach(function(e4) {
        var t4 = n3.getOptions(e4), o4 = Xh(e4);
        e4.name ? r3.append(t4.fieldName, o4, e4.name) : r3.append(t4.fieldName, o4);
      }), r3;
    }, o2.createBareUpload = function(e3, t3) {
      return e3.data;
    }, o2.upload = function(e3, t3, n3) {
      var r3 = this, o3 = this.getOptions(e3);
      return this.uppy.log("uploading " + t3 + " of " + n3), new Promise(function(t4, n4) {
        r3.uppy.emit("upload-started", e3);
        var i2 = o3.formData ? r3.createFormDataUpload(e3, o3) : r3.createBareUpload(e3, o3), a2 = new XMLHttpRequest();
        r3.uploaderEvents[e3.id] = new kl(r3.uppy);
        var s2 = new xl(o3.timeout, function() {
          a2.abort(), u2.done();
          var t5 = new Error(r3.i18n("timedOut", { seconds: Math.ceil(o3.timeout / 1e3) }));
          r3.uppy.emit("upload-error", e3, t5), n4(t5);
        }), l2 = D();
        a2.upload.addEventListener("loadstart", function(e4) {
          r3.uppy.log("[XHRUpload] " + l2 + " started");
        }), a2.upload.addEventListener("progress", function(t5) {
          r3.uppy.log("[XHRUpload] " + l2 + " progress: " + t5.loaded + " / " + t5.total), s2.progress(), t5.lengthComputable && r3.uppy.emit("upload-progress", e3, { uploader: r3, bytesUploaded: t5.loaded, bytesTotal: t5.total });
        }), a2.addEventListener("load", function(i3) {
          if (r3.uppy.log("[XHRUpload] " + l2 + " finished"), s2.done(), u2.done(), r3.uploaderEvents[e3.id] && (r3.uploaderEvents[e3.id].remove(), r3.uploaderEvents[e3.id] = null), o3.validateStatus(i3.target.status, a2.responseText, a2)) {
            var c2 = o3.getResponseData(a2.responseText, a2), p2 = c2[o3.responseUrlFieldName], d2 = { status: i3.target.status, body: c2, uploadURL: p2 };
            return r3.uppy.emit("upload-success", e3, d2), p2 && r3.uppy.log("Download " + e3.name + " from " + p2), t4(e3);
          }
          var h2 = o3.getResponseData(a2.responseText, a2), f2 = qh(a2, o3.getResponseError(a2.responseText, a2)), m2 = { status: i3.target.status, body: h2 };
          return r3.uppy.emit("upload-error", e3, f2, m2), n4(f2);
        }), a2.addEventListener("error", function(t5) {
          r3.uppy.log("[XHRUpload] " + l2 + " errored"), s2.done(), u2.done(), r3.uploaderEvents[e3.id] && (r3.uploaderEvents[e3.id].remove(), r3.uploaderEvents[e3.id] = null);
          var i3 = qh(a2, o3.getResponseError(a2.responseText, a2));
          return r3.uppy.emit("upload-error", e3, i3), n4(i3);
        }), a2.open(o3.method.toUpperCase(), o3.endpoint, true), a2.withCredentials = o3.withCredentials, "" !== o3.responseType && (a2.responseType = o3.responseType);
        var u2 = r3.requests.run(function() {
          var t5 = r3.getOptions(e3);
          return Object.keys(t5.headers).forEach(function(e4) {
            a2.setRequestHeader(e4, t5.headers[e4]);
          }), a2.send(i2), function() {
            s2.done(), a2.abort();
          };
        });
        r3.onFileRemove(e3.id, function() {
          u2.abort(), n4(new Error("File removed"));
        }), r3.onCancelAll(e3.id, function() {
          u2.abort(), n4(new Error("Upload cancelled"));
        });
      });
    }, o2.uploadRemote = function(e3, t3, n3) {
      var r3 = this, o3 = this.getOptions(e3);
      return new Promise(function(t4, n4) {
        r3.uppy.emit("upload-started", e3);
        var i2 = {};
        (Array.isArray(o3.metaFields) ? o3.metaFields : Object.keys(e3.meta)).forEach(function(t5) {
          i2[t5] = e3.meta[t5];
        }), new (e3.remote.providerOptions.provider ? Hh : Wh)(r3.uppy, e3.remote.providerOptions).post(e3.remote.url, zh({}, e3.remote.body, { endpoint: o3.endpoint, size: e3.data.size, fieldname: o3.fieldName, metadata: i2, httpMethod: o3.method, useFormData: o3.formData, headers: o3.headers })).then(function(i3) {
          var a2 = i3.token, s2 = Sl(e3.remote.companionUrl), l2 = new Vh({ target: s2 + "/api/" + a2, autoOpen: false });
          r3.uploaderEvents[e3.id] = new kl(r3.uppy), r3.onFileRemove(e3.id, function() {
            l2.send("pause", {}), u2.abort(), t4("upload " + e3.id + " was removed");
          }), r3.onCancelAll(e3.id, function() {
            l2.send("pause", {}), u2.abort(), t4("upload " + e3.id + " was canceled");
          }), r3.onRetry(e3.id, function() {
            l2.send("pause", {}), l2.send("resume", {});
          }), r3.onRetryAll(e3.id, function() {
            l2.send("pause", {}), l2.send("resume", {});
          }), l2.on("progress", function(t5) {
            return Cl(r3, t5, e3);
          }), l2.on("success", function(n5) {
            var i4 = o3.getResponseData(n5.response.responseText, n5.response), a3 = i4[o3.responseUrlFieldName], s3 = { status: n5.response.status, body: i4, uploadURL: a3 };
            return r3.uppy.emit("upload-success", e3, s3), u2.done(), r3.uploaderEvents[e3.id] && (r3.uploaderEvents[e3.id].remove(), r3.uploaderEvents[e3.id] = null), t4();
          }), l2.on("error", function(t5) {
            var i4 = t5.response, a3 = i4 ? o3.getResponseError(i4.responseText, i4) : zh(new Error(t5.error.message), { cause: t5.error });
            r3.uppy.emit("upload-error", e3, a3), u2.done(), r3.uploaderEvents[e3.id] && (r3.uploaderEvents[e3.id].remove(), r3.uploaderEvents[e3.id] = null), n4(a3);
          });
          var u2 = r3.requests.run(function() {
            return l2.open(), e3.isPaused && l2.send("pause", {}), function() {
              return l2.close();
            };
          });
        }).catch(function(t5) {
          r3.uppy.emit("upload-error", e3, t5), n4(t5);
        });
      });
    }, o2.uploadBundle = function(e3) {
      var t3 = this;
      return new Promise(function(n3, r3) {
        var o3 = t3.opts.endpoint, i2 = t3.opts.method, a2 = t3.uppy.getState().xhrUpload, s2 = t3.createBundledUpload(e3, zh({}, t3.opts, a2 || {})), l2 = new XMLHttpRequest(), u2 = new xl(t3.opts.timeout, function() {
          l2.abort();
          var e4 = new Error(t3.i18n("timedOut", { seconds: Math.ceil(t3.opts.timeout / 1e3) }));
          c2(e4), r3(e4);
        }), c2 = function(n4) {
          e3.forEach(function(e4) {
            t3.uppy.emit("upload-error", e4, n4);
          });
        };
        l2.upload.addEventListener("loadstart", function(e4) {
          t3.uppy.log("[XHRUpload] started uploading bundle"), u2.progress();
        }), l2.upload.addEventListener("progress", function(n4) {
          u2.progress(), n4.lengthComputable && e3.forEach(function(e4) {
            t3.uppy.emit("upload-progress", e4, { uploader: t3, bytesUploaded: n4.loaded / n4.total * e4.size, bytesTotal: e4.size });
          });
        }), l2.addEventListener("load", function(o4) {
          if (u2.done(), t3.opts.validateStatus(o4.target.status, l2.responseText, l2)) {
            var i3 = t3.opts.getResponseData(l2.responseText, l2), a3 = { status: o4.target.status, body: i3 };
            return e3.forEach(function(e4) {
              t3.uppy.emit("upload-success", e4, a3);
            }), n3();
          }
          var s3 = t3.opts.getResponseError(l2.responseText, l2) || new Error("Upload error");
          return s3.request = l2, c2(s3), r3(s3);
        }), l2.addEventListener("error", function(e4) {
          u2.done();
          var n4 = t3.opts.getResponseError(l2.responseText, l2) || new Error("Upload error");
          return c2(n4), r3(n4);
        }), t3.uppy.on("cancel-all", function() {
          u2.done(), l2.abort();
        }), l2.open(i2.toUpperCase(), o3, true), l2.withCredentials = t3.opts.withCredentials, "" !== t3.opts.responseType && (l2.responseType = t3.opts.responseType), Object.keys(t3.opts.headers).forEach(function(e4) {
          l2.setRequestHeader(e4, t3.opts.headers[e4]);
        }), l2.send(s2), e3.forEach(function(e4) {
          t3.uppy.emit("upload-started", e4);
        });
      });
    }, o2.uploadFiles = function(e3) {
      var t3 = this, n3 = e3.map(function(n4, r3) {
        var o3 = parseInt(r3, 10) + 1, i2 = e3.length;
        return n4.error ? Promise.reject(new Error(n4.error)) : n4.isRemote ? t3.uploadRemote(n4, o3, i2) : t3.upload(n4, o3, i2);
      });
      return wl(n3);
    }, o2.onFileRemove = function(e3, t3) {
      this.uploaderEvents[e3].on("file-removed", function(n3) {
        e3 === n3.id && t3(n3.id);
      });
    }, o2.onRetry = function(e3, t3) {
      this.uploaderEvents[e3].on("upload-retry", function(n3) {
        e3 === n3 && t3();
      });
    }, o2.onRetryAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("retry-all", function(r3) {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.onCancelAll = function(e3, t3) {
      var n3 = this;
      this.uploaderEvents[e3].on("cancel-all", function() {
        n3.uppy.getFile(e3) && t3();
      });
    }, o2.handleUpload = function(e3) {
      var t3 = this;
      if (0 === e3.length) return this.uppy.log("[XHRUpload] No files to upload!"), Promise.resolve();
      0 !== this.opts.limit || this.opts.__queue || this.uppy.log("[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0", "warning"), this.uppy.log("[XHRUpload] Uploading...");
      var n3 = e3.map(function(e4) {
        return t3.uppy.getFile(e4);
      });
      if (this.opts.bundle) {
        if (n3.some(function(e4) {
          return e4.isRemote;
        })) throw new Error("Can\u2019t upload remote files when the `bundle: true` option is set");
        if ("function" == typeof this.opts.headers) throw new TypeError("`headers` may not be a function when the `bundle: true` option is set");
        return this.uploadBundle(n3);
      }
      return this.uploadFiles(n3).then(function() {
        return null;
      });
    }, o2.install = function() {
      if (this.opts.bundle) {
        var e3 = this.uppy.getState().capabilities;
        this.uppy.setState({ capabilities: zh({}, e3, { individualCancellation: false }) });
      }
      this.uppy.addUploader(this.handleUpload);
    }, o2.uninstall = function() {
      if (this.opts.bundle) {
        var e3 = this.uppy.getState().capabilities;
        this.uppy.setState({ capabilities: zh({}, e3, { individualCancellation: true }) });
      }
      this.uppy.removeUploader(this.handleUpload);
    }, r2;
  }(ue.Plugin), Ih.VERSION = "1.7.5", Lh), Yh = { __esModule: true };
  Yh.default = tf, Yh.getFieldData = nf;
  var $h = { "[object HTMLCollection]": true, "[object NodeList]": true, "[object RadioNodeList]": true }, Kh = { button: true, fieldset: true, reset: true, submit: true }, Jh = { checkbox: true, radio: true }, Qh = /^\s+|\s+$/g, Zh = Array.prototype.slice, ef = Object.prototype.toString;
  function tf(e2) {
    var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { trim: false };
    if (!e2) throw new Error("A form is required by getFormData, was given form=" + e2);
    for (var n2 = {}, r2 = void 0, o2 = [], i2 = {}, a2 = 0, s2 = e2.elements.length; a2 < s2; a2++) {
      var l2 = e2.elements[a2];
      Kh[l2.type] || l2.disabled || (r2 = l2.name || l2.id) && !i2[r2] && (o2.push(r2), i2[r2] = true);
    }
    for (var u2 = 0, c2 = o2.length; u2 < c2; u2++) {
      var p2 = nf(e2, r2 = o2[u2], t2);
      null != p2 && (n2[r2] = p2);
    }
    return n2;
  }
  function nf(e2, t2) {
    var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { trim: false };
    if (!e2) throw new Error("A form is required by getFieldData, was given form=" + e2);
    if (!t2 && "[object String]" !== ef.call(t2)) throw new Error("A field name is required by getFieldData, was given fieldName=" + t2);
    var r2 = e2.elements[t2];
    if (!r2 || r2.disabled) return null;
    if (!$h[ef.call(r2)]) return rf(r2, n2.trim);
    for (var o2 = [], i2 = true, a2 = 0, s2 = r2.length; a2 < s2; a2++) if (!r2[a2].disabled) {
      i2 && "radio" !== r2[a2].type && (i2 = false);
      var l2 = rf(r2[a2], n2.trim);
      null != l2 && (o2 = o2.concat(l2));
    }
    return i2 && 1 === o2.length ? o2[0] : o2.length > 0 ? o2 : null;
  }
  function rf(e2, t2) {
    var n2 = null, r2 = e2.type;
    if ("select-one" === r2) return e2.options.length && (n2 = e2.options[e2.selectedIndex].value), n2;
    if ("select-multiple" === r2) {
      n2 = [];
      for (var o2 = 0, i2 = e2.options.length; o2 < i2; o2++) e2.options[o2].selected && n2.push(e2.options[o2].value);
      return 0 === n2.length && (n2 = null), n2;
    }
    return "file" === r2 && "files" in e2 ? (e2.multiple ? 0 === (n2 = Zh.call(e2.files)).length && (n2 = null) : n2 = e2.files[0], n2) : (Jh[r2] ? e2.checked && (n2 = e2.value) : n2 = t2 ? e2.value.replace(Qh, "") : e2.value, n2);
  }
  tf.getFieldData = nf;
  var of, af;
  function sf() {
    return (sf = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function lf(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function uf(e2, t2) {
    return (uf = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var cf = ue.Plugin, pf = Yh.default || Yh, df = (af = of = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).type = "acquirer", r3.id = r3.opts.id || "Form", r3.title = "Form", r3.opts = sf({}, { target: null, resultName: "uppyResult", getMetaFromForm: true, addResultToForm: true, multipleResults: false, submitOnSuccess: false, triggerUploadOnSubmit: false }, n3), r3.handleFormSubmit = r3.handleFormSubmit.bind(lf(r3)), r3.handleUploadStart = r3.handleUploadStart.bind(lf(r3)), r3.handleSuccess = r3.handleSuccess.bind(lf(r3)), r3.addResultToForm = r3.addResultToForm.bind(lf(r3)), r3.getMetaFromForm = r3.getMetaFromForm.bind(lf(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, uf(t2, n2);
    var o2 = r2.prototype;
    return o2.handleUploadStart = function() {
      this.opts.getMetaFromForm && this.getMetaFromForm();
    }, o2.handleSuccess = function(e3) {
      this.opts.addResultToForm && this.addResultToForm(e3), this.opts.submitOnSuccess && this.form.submit();
    }, o2.handleFormSubmit = function(e3) {
      var t3 = this;
      if (this.opts.triggerUploadOnSubmit) {
        e3.preventDefault();
        var n3 = Co(e3.target.elements), r3 = [];
        n3.forEach(function(e4) {
          ("BUTTON" === e4.tagName || "INPUT" === e4.tagName && "submit" === e4.type) && !e4.disabled && (e4.disabled = true, r3.push(e4));
        }), this.uppy.upload().then(function() {
          r3.forEach(function(e4) {
            e4.disabled = false;
          });
        }, function(e4) {
          return r3.forEach(function(e5) {
            e5.disabled = false;
          }), Promise.reject(e4);
        }).catch(function(e4) {
          t3.uppy.log(e4.stack || e4.message || e4);
        });
      }
    }, o2.addResultToForm = function(e3) {
      this.uppy.log("[Form] Adding result to the original form:"), this.uppy.log(e3);
      var t3 = this.form.querySelector('[name="' + this.opts.resultName + '"]');
      if (t3) if (this.opts.multipleResults) {
        var n3;
        try {
          n3 = JSON.parse(t3.value);
        } catch (wd2) {
        }
        Array.isArray(n3) || (n3 = []), n3.push(e3), t3.value = JSON.stringify(n3);
      } else t3.value = JSON.stringify(e3);
      else (t3 = document.createElement("input")).name = this.opts.resultName, t3.type = "hidden", this.opts.multipleResults ? t3.value = JSON.stringify([e3]) : t3.value = JSON.stringify(e3), this.form.appendChild(t3);
    }, o2.getMetaFromForm = function() {
      var e3 = pf(this.form);
      delete e3[this.opts.resultName], this.uppy.setMeta(e3);
    }, o2.install = function() {
      this.form = se(this.opts.target), this.form && "FORM" === this.form.nodeName ? (this.form.addEventListener("submit", this.handleFormSubmit), this.uppy.on("upload", this.handleUploadStart), this.uppy.on("complete", this.handleSuccess)) : this.uppy.log("Form plugin requires a <form> target element passed in options to operate, none was found", "error");
    }, o2.uninstall = function() {
      this.form.removeEventListener("submit", this.handleFormSubmit), this.uppy.off("upload", this.handleUploadStart), this.uppy.off("complete", this.handleSuccess);
    }, r2;
  }(cf), of.VERSION = "1.3.31", af), hf = {}, ff = "undefined" != typeof navigator && "serviceWorker" in navigator, mf = function() {
    function e2(e3) {
      this.ready = new Promise(function(e4, t3) {
        ff ? navigator.serviceWorker.controller ? e4() : navigator.serviceWorker.addEventListener("controllerchange", function() {
          e4();
        }) : t3(new Error("Unsupported"));
      }), this.name = e3.storeName;
    }
    var t2 = e2.prototype;
    return t2.list = function() {
      var e3 = this, t3 = {}, n2 = new Promise(function(e4, n3) {
        t3.resolve = e4, t3.reject = n3;
      });
      console.log("Loading stored blobs from Service Worker");
      var r2 = function n3(r3) {
        if (r3.data.store === e3.name) switch (r3.data.type) {
          case "uppy/ALL_FILES":
            t3.resolve(r3.data.files), navigator.serviceWorker.removeEventListener("message", n3);
        }
      };
      return this.ready.then(function() {
        navigator.serviceWorker.addEventListener("message", r2), navigator.serviceWorker.controller.postMessage({ type: "uppy/GET_FILES", store: e3.name });
      }), n2;
    }, t2.put = function(e3) {
      var t3 = this;
      return this.ready.then(function() {
        navigator.serviceWorker.controller.postMessage({ type: "uppy/ADD_FILE", store: t3.name, file: e3 });
      });
    }, t2.delete = function(e3) {
      var t3 = this;
      return this.ready.then(function() {
        navigator.serviceWorker.controller.postMessage({ type: "uppy/REMOVE_FILE", store: t3.name, fileID: e3 });
      });
    }, e2;
  }();
  mf.isSupported = ff, hf = mf;
  var vf = {};
  function gf() {
    return (gf = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  var yf = "undefined" != typeof window && (window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.OIndexedDB || window.msIndexedDB), bf = !!yf;
  function _f(e2) {
    var t2 = yf.open(e2, 3);
    return new Promise(function(e3, n2) {
      t2.onupgradeneeded = function(t3) {
        var n3 = t3.target.result, r2 = t3.currentTarget.transaction;
        if (t3.oldVersion < 2 && n3.createObjectStore("files", { keyPath: "id" }).createIndex("store", "store", { unique: false }), t3.oldVersion < 3) {
          var o2 = r2.objectStore("files");
          o2.createIndex("expires", "expires", { unique: false }), o2.openCursor().onsuccess = function(e4) {
            var t4 = e4.target.result;
            if (t4) {
              var n4 = t4.value;
              n4.expires = Date.now() + 864e5, t4.update(n4);
            }
          };
        }
        r2.oncomplete = function() {
          e3(n3);
        };
      }, t2.onsuccess = function(t3) {
        e3(t3.target.result);
      }, t2.onerror = n2;
    });
  }
  function wf(e2) {
    return new Promise(function(t2, n2) {
      e2.onsuccess = function(e3) {
        t2(e3.target.result);
      }, e2.onerror = n2;
    });
  }
  var Cf = false, Sf = function() {
    function e2(t3) {
      var n2 = this;
      this.opts = gf({ dbName: "uppy-blobs", storeName: "default", expires: 864e5, maxFileSize: 10485760, maxTotalSize: 314572800 }, t3), this.name = this.opts.storeName;
      var r2 = function() {
        return _f(n2.opts.dbName);
      };
      Cf ? this.ready = r2() : (Cf = true, this.ready = e2.cleanup().then(r2, r2));
    }
    var t2 = e2.prototype;
    return t2.key = function(e3) {
      return this.name + "!" + e3;
    }, t2.list = function() {
      var e3 = this;
      return this.ready.then(function(t3) {
        return wf(t3.transaction(["files"], "readonly").objectStore("files").index("store").getAll(IDBKeyRange.only(e3.name)));
      }).then(function(e4) {
        var t3 = {};
        return e4.forEach(function(e5) {
          t3[e5.fileID] = e5.data;
        }), t3;
      });
    }, t2.get = function(e3) {
      var t3 = this;
      return this.ready.then(function(n2) {
        return wf(n2.transaction(["files"], "readonly").objectStore("files").get(t3.key(e3)));
      }).then(function(e4) {
        return { id: e4.data.fileID, data: e4.data.data };
      });
    }, t2.getSize = function() {
      var e3 = this;
      return this.ready.then(function(t3) {
        var n2 = t3.transaction(["files"], "readonly").objectStore("files").index("store").openCursor(IDBKeyRange.only(e3.name));
        return new Promise(function(e4, t4) {
          var r2 = 0;
          n2.onsuccess = function(t5) {
            var n3 = t5.target.result;
            n3 ? (r2 += n3.value.data.size, n3.continue()) : e4(r2);
          }, n2.onerror = function() {
            t4(new Error("Could not retrieve stored blobs size"));
          };
        });
      });
    }, t2.put = function(e3) {
      var t3 = this;
      return e3.data.size > this.opts.maxFileSize ? Promise.reject(new Error("File is too big to store.")) : this.getSize().then(function(e4) {
        return e4 > t3.opts.maxTotalSize ? Promise.reject(new Error("No space left")) : t3.ready;
      }).then(function(n2) {
        return wf(n2.transaction(["files"], "readwrite").objectStore("files").add({ id: t3.key(e3.id), fileID: e3.id, store: t3.name, expires: Date.now() + t3.opts.expires, data: e3.data }));
      });
    }, t2.delete = function(e3) {
      var t3 = this;
      return this.ready.then(function(n2) {
        return wf(n2.transaction(["files"], "readwrite").objectStore("files").delete(t3.key(e3)));
      });
    }, e2.cleanup = function() {
      return _f("uppy-blobs").then(function(e3) {
        var t3 = e3.transaction(["files"], "readwrite").objectStore("files").index("expires").openCursor(IDBKeyRange.upperBound(Date.now()));
        return new Promise(function(n2, r2) {
          t3.onsuccess = function(t4) {
            var r3 = t4.target.result;
            if (r3) {
              var o2 = r3.value;
              console.log("[IndexedDBStore] Deleting record", o2.fileID, "of size", W(o2.data.size), "- expired on", new Date(o2.expires)), r3.delete(), r3.continue();
            } else n2(e3);
          }, t3.onerror = r2;
        });
      }).then(function(e3) {
        e3.close();
      });
    }, e2;
  }();
  function kf() {
    return (kf = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function xf(e2) {
    try {
      return JSON.parse(e2);
    } catch (wd2) {
      return null;
    }
  }
  Sf.isSupported = bf, vf = Sf;
  var Pf, Ef, Of = false, Af = function() {
    function e2(t3) {
      this.opts = kf({ expires: 864e5 }, t3), this.name = "uppyState:" + t3.storeName, Of || (Of = true, e2.cleanup());
    }
    var t2 = e2.prototype;
    return t2.load = function() {
      var e3 = localStorage.getItem(this.name);
      if (!e3) return null;
      var t3 = xf(e3);
      return t3 ? t3.metadata ? t3.metadata : (this.save(t3), t3) : null;
    }, t2.save = function(e3) {
      var t3 = Date.now() + this.opts.expires, n2 = JSON.stringify({ metadata: e3, expires: t3 });
      localStorage.setItem(this.name, n2);
    }, e2.cleanup = function(e3) {
      if (e3) localStorage.removeItem("uppyState:" + e3);
      else {
        var t3 = function() {
          for (var e4 = [], t4 = 0; t4 < localStorage.length; t4++) {
            var n3 = localStorage.key(t4);
            /^uppyState:/.test(n3) && e4.push(n3.slice("uppyState:".length));
          }
          return e4;
        }(), n2 = Date.now();
        t3.forEach(function(e4) {
          var t4 = localStorage.getItem("uppyState:" + e4);
          if (!t4) return null;
          var r2 = xf(t4);
          if (!r2) return null;
          r2.expires && r2.expires < n2 && localStorage.removeItem("uppyState:" + e4);
        });
      }
    }, e2;
  }();
  function Uf() {
    return (Uf = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Nf(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Tf(e2, t2) {
    return (Tf = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Rf, Ff, Df = (Ef = Pf = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).addBlobToStores = function(e3) {
        e3.isRemote || (r3.ServiceWorkerStore && r3.ServiceWorkerStore.put(e3).catch(function(e4) {
          r3.uppy.log("[GoldenRetriever] Could not store file", "warning"), r3.uppy.log(e4);
        }), r3.IndexedDBStore.put(e3).catch(function(e4) {
          r3.uppy.log("[GoldenRetriever] Could not store file", "warning"), r3.uppy.log(e4);
        }));
      }, r3.removeBlobFromStores = function(e3) {
        r3.ServiceWorkerStore && r3.ServiceWorkerStore.delete(e3.id).catch(function(e4) {
          r3.uppy.log("[GoldenRetriever] Failed to remove file", "warning"), r3.uppy.log(e4);
        }), r3.IndexedDBStore.delete(e3.id).catch(function(e4) {
          r3.uppy.log("[GoldenRetriever] Failed to remove file", "warning"), r3.uppy.log(e4);
        });
      }, r3.replaceBlobInStores = function(e3) {
        r3.removeBlobFromStores(e3), r3.addBlobToStores(e3);
      }, r3.handleRestoreConfirmed = function() {
        r3.uppy.log("[GoldenRetriever] Restore confirmed, proceeding...");
        var e3 = r3.uppy.getState().currentUploads;
        e3 && (Object.keys(e3).forEach(function(t4) {
          r3.uppy.restore(t4, e3[t4]);
        }), r3.uppy.resumeAll()), r3.uppy.upload(), r3.uppy.setState({ recoveredState: null });
      }, r3.abortRestore = function() {
        r3.uppy.log("[GoldenRetriever] Aborting restore...");
        var e3 = Object.keys(r3.uppy.getState().files);
        r3.deleteBlobs(e3).then(function() {
          r3.uppy.log("[GoldenRetriever] Removed " + e3.length + " files");
        }).catch(function(t4) {
          r3.uppy.log("[GoldenRetriever] Could not remove " + e3.length + " files", "warning"), r3.uppy.log(t4);
        }), r3.uppy.cancelAll(), r3.uppy.setState({ recoveredState: null }), Af.cleanup(r3.uppy.opts.id);
      }, r3.handleComplete = function(e3) {
        var t4 = e3.successful, n4 = t4.map(function(e4) {
          return e4.id;
        });
        r3.deleteBlobs(n4).then(function() {
          r3.uppy.log("[GoldenRetriever] Removed " + t4.length + " files that finished uploading");
        }).catch(function(e4) {
          r3.uppy.log("[GoldenRetriever] Could not remove " + t4.length + " files that finished uploading", "warning"), r3.uppy.log(e4);
        }), r3.uppy.setState({ recoveredState: null }), Af.cleanup(r3.uppy.opts.id);
      }, r3.restoreBlobs = function() {
        r3.uppy.getFiles().length > 0 ? Promise.all([r3.loadFileBlobsFromServiceWorker(), r3.loadFileBlobsFromIndexedDB()]).then(function(e3) {
          var t4 = Uf({}, e3[0], e3[1]);
          r3.onBlobsLoaded(t4);
        }) : (r3.uppy.log("[GoldenRetriever] No files need to be loaded, only restoring processing state..."), r3.onBlobsLoaded([]));
      }, r3.type = "debugger", r3.id = r3.opts.id || "GoldenRetriever", r3.title = "Golden Retriever", r3.opts = Uf({}, { expires: 864e5, serviceWorker: false }, n3), r3.MetaDataStore = new Af({ expires: r3.opts.expires, storeName: t3.getID() }), r3.ServiceWorkerStore = null, r3.opts.serviceWorker && (r3.ServiceWorkerStore = new hf({ storeName: t3.getID() })), r3.IndexedDBStore = new vf(Uf({ expires: r3.opts.expires }, r3.opts.indexedDB || {}, { storeName: t3.getID() })), r3.saveFilesStateToLocalStorage = z(r3.saveFilesStateToLocalStorage.bind(Nf(r3)), 500, { leading: true, trailing: true }), r3.restoreState = r3.restoreState.bind(Nf(r3)), r3.loadFileBlobsFromServiceWorker = r3.loadFileBlobsFromServiceWorker.bind(Nf(r3)), r3.loadFileBlobsFromIndexedDB = r3.loadFileBlobsFromIndexedDB.bind(Nf(r3)), r3.onBlobsLoaded = r3.onBlobsLoaded.bind(Nf(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, Tf(t2, n2);
    var o2 = r2.prototype;
    return o2.restoreState = function() {
      var e3 = this.MetaDataStore.load();
      e3 && (this.uppy.log("[GoldenRetriever] Recovered some state from Local Storage"), this.uppy.setState({ currentUploads: e3.currentUploads || {}, files: e3.files || {}, recoveredState: e3 }), this.savedPluginData = e3.pluginData);
    }, o2.getWaitingFiles = function() {
      var e3 = {};
      return this.uppy.getFiles().forEach(function(t3) {
        t3.progress && t3.progress.uploadStarted || (e3[t3.id] = t3);
      }), e3;
    }, o2.getUploadingFiles = function() {
      var e3 = this, t3 = {}, n3 = this.uppy.getState().currentUploads;
      return n3 && Object.keys(n3).forEach(function(r3) {
        n3[r3].fileIDs.forEach(function(n4) {
          t3[n4] = e3.uppy.getFile(n4);
        });
      }), t3;
    }, o2.saveFilesStateToLocalStorage = function() {
      var e3 = Uf({}, this.getWaitingFiles(), this.getUploadingFiles());
      if (0 === Object.keys(e3).length) return this.uppy.setState({ recoveredState: null }), void Af.cleanup(this.uppy.opts.id);
      var t3 = {};
      Object.keys(e3).forEach(function(n4) {
        e3[n4].isRemote ? t3[n4] = Uf({}, e3[n4], { isRestored: true }) : t3[n4] = Uf({}, e3[n4], { isRestored: true, data: null, preview: null });
      });
      var n3 = {};
      this.uppy.emit("restore:get-data", function(e4) {
        Uf(n3, e4);
      });
      var r3 = this.uppy.getState().currentUploads;
      this.MetaDataStore.save({ currentUploads: r3, files: t3, pluginData: n3 });
    }, o2.loadFileBlobsFromServiceWorker = function() {
      var e3 = this;
      return this.ServiceWorkerStore ? this.ServiceWorkerStore.list().then(function(t3) {
        var n3 = e3.uppy.getFiles().filter(function(e4) {
          return !e4.isRemote;
        }), r3 = Object.keys(t3).length;
        return r3 === n3.length ? (e3.uppy.log("[GoldenRetriever] Successfully recovered " + r3 + " blobs from Service Worker!"), t3) : (e3.uppy.log("[GoldenRetriever] No blobs found in Service Worker, trying IndexedDB now..."), {});
      }).catch(function(t3) {
        return e3.uppy.log("[GoldenRetriever] Failed to recover blobs from Service Worker", "warning"), e3.uppy.log(t3), {};
      }) : Promise.resolve({});
    }, o2.loadFileBlobsFromIndexedDB = function() {
      var e3 = this;
      return this.IndexedDBStore.list().then(function(t3) {
        var n3 = Object.keys(t3).length;
        return n3 > 0 ? (e3.uppy.log("[GoldenRetriever] Successfully recovered " + n3 + " blobs from IndexedDB!"), t3) : (e3.uppy.log("[GoldenRetriever] No blobs found in IndexedDB"), {});
      }).catch(function(t3) {
        return e3.uppy.log("[GoldenRetriever] Failed to recover blobs from IndexedDB", "warning"), e3.uppy.log(t3), {};
      });
    }, o2.onBlobsLoaded = function(e3) {
      var t3 = this, n3 = [], r3 = Uf({}, this.uppy.getState().files);
      Object.keys(e3).forEach(function(o3) {
        var i2 = t3.uppy.getFile(o3);
        if (i2) {
          var a2 = { data: e3[o3], isRestored: true, isGhost: false };
          r3[o3] = Uf({}, i2, a2);
        } else n3.push(o3);
      }), Object.keys(r3).forEach(function(e4) {
        null === r3[e4].data && (r3[e4] = Uf({}, r3[e4], { isGhost: true }));
      }), this.uppy.setState({ files: r3 }), this.uppy.emit("restored", this.savedPluginData), n3.length && this.deleteBlobs(n3).then(function() {
        t3.uppy.log("[GoldenRetriever] Cleaned up " + n3.length + " old files");
      }).catch(function(e4) {
        t3.uppy.log("[GoldenRetriever] Could not clean up " + n3.length + " old files", "warning"), t3.uppy.log(e4);
      });
    }, o2.deleteBlobs = function(e3) {
      var t3 = this, n3 = [];
      return e3.forEach(function(e4) {
        t3.ServiceWorkerStore && n3.push(t3.ServiceWorkerStore.delete(e4)), t3.IndexedDBStore && n3.push(t3.IndexedDBStore.delete(e4));
      }), Promise.all(n3);
    }, o2.install = function() {
      this.restoreState(), this.restoreBlobs(), this.uppy.on("file-added", this.addBlobToStores), this.uppy.on("file-editor:complete", this.replaceBlobInStores), this.uppy.on("file-removed", this.removeBlobFromStores), this.uppy.on("state-update", this.saveFilesStateToLocalStorage), this.uppy.on("restore-confirmed", this.handleRestoreConfirmed), this.uppy.on("restore-canceled", this.abortRestore), this.uppy.on("complete", this.handleComplete);
    }, o2.uninstall = function() {
      this.uppy.off("file-added", this.addBlobToStores), this.uppy.off("file-editor:complete", this.replaceBlobInStores), this.uppy.off("file-removed", this.removeBlobFromStores), this.uppy.off("state-update", this.saveFilesStateToLocalStorage), this.uppy.off("restore-confirmed", this.handleRestoreConfirmed), this.uppy.off("restore-canceled", this.abortRestore), this.uppy.off("complete", this.handleComplete);
    }, r2;
  }(ue.Plugin), Pf.VERSION = "1.4.2", Ef);
  function Mf() {
    return (Mf = Object.assign || function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }).apply(this, arguments);
  }
  function Bf(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function If(e2, t2) {
    return (If = Object.setPrototypeOf || function(e3, t3) {
      return e3.__proto__ = t3, e3;
    })(e2, t2);
  }
  var Lf = (Ff = Rf = function(e2) {
    var t2, n2;
    function r2(t3, n3) {
      var r3;
      return (r3 = e2.call(this, t3, n3) || this).type = "debugger", r3.id = r3.opts.id || "ReduxDevTools", r3.title = "Redux DevTools", r3.opts = Mf({}, {}, n3), r3.handleStateChange = r3.handleStateChange.bind(Bf(r3)), r3.initDevTools = r3.initDevTools.bind(Bf(r3)), r3;
    }
    n2 = e2, (t2 = r2).prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, If(t2, n2);
    var o2 = r2.prototype;
    return o2.handleStateChange = function(e3, t3, n3) {
      this.devTools.send("UPPY_STATE_UPDATE", t3);
    }, o2.initDevTools = function() {
      var e3 = this;
      this.devTools = window.devToolsExtension.connect(), this.devToolsUnsubscribe = this.devTools.subscribe(function(t3) {
        if ("DISPATCH" === t3.type) switch (t3.payload.type) {
          case "RESET":
            return void e3.uppy.reset();
          case "IMPORT_STATE":
            var n3 = t3.payload.nextLiftedState.computedStates;
            return e3.uppy.store.state = Mf({}, e3.uppy.getState(), n3[n3.length - 1].state), void e3.uppy.updateAll(e3.uppy.getState());
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            e3.uppy.store.state = Mf({}, e3.uppy.getState(), JSON.parse(t3.state)), e3.uppy.updateAll(e3.uppy.getState());
        }
      });
    }, o2.install = function() {
      this.withDevTools = "undefined" != typeof window && window.__REDUX_DEVTOOLS_EXTENSION__, this.withDevTools && (this.initDevTools(), this.uppy.on("state-update", this.handleStateChange));
    }, o2.uninstall = function() {
      this.withDevTools && (this.devToolsUnsubscribe(), this.uppy.off("state-update", this.handleStateUpdate));
    }, r2;
  }(ue.Plugin), Rf.VERSION = "1.3.9", Ff), jf = {};
  jf.Core = ue, jf.debugLogger = jf.Core.debugLogger, jf.server = Ke, jf.views = { ProviderView: Zt }, jf.DefaultStore = q, jf.ReduxStore = Jt, jf.Dashboard = Xo, jf.DragDrop = ri, jf.DropTarget = ai, jf.FileInput = mi, jf.Informer = eo, jf.ProgressBar = xi, jf.StatusBar = Xr, jf.ImageEditor = Bi, jf.Dropbox = Gi, jf.GoogleDrive = oa, jf.Instagram = fa, jf.OneDrive = ka, jf.Box = Fa, jf.Facebook = Va, jf.Unsplash = es, jf.Url = vs, jf.Webcam = $s, jf.ScreenCapture = bl, jf.AwsS3 = Vl, jf.AwsS3Multipart = _u, jf.Transloadit = Uh, jf.Tus = ip, jf.XHRUpload = Gh, jf.Form = df, jf.GoldenRetriever = Df, jf.ReduxDevTools = Lf, jf.ThumbnailGenerator = _o, jf.locales = {};
  return jf;
});
